const combinedShotData = [
  {
    "3-Pointer Number": 1,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -76,
    "LOC_Y": 250,
    "GAME_DATE": 20091030,
    "Season": "2009-2010",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "https://www.youtube.com/embed/-TBdGQzvTHM?start=1752&end=1762",
    "nftUrl": "https://ftx.us/nfts/token/389547173092305707",
    "name": "The 2974 Collection #0001",
    "imageUrl": "https://arweave.net/_mlgnIYB5CwuL-1i5TekWKPXsWV5ArUChB4HO1ZkJBw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2009,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 2,
    "Special Moment": "1st Three Pointer",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 1,
    "LOC_Y": 247,
    "GAME_DATE": 20091030,
    "Season": "2009-2010",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "https://www.youtube.com/embed/oa9LfU0AdGI?start=5&end=8",
    "nftUrl": "https://ftx.us/nfts/token/540360570731873921",
    "name": "The 2974 Collection #0002",
    "imageUrl": "https://arweave.net/ThJBzIIMSErm84XRZKk0nBTwFaV1SJBwW-shk6AmLRA?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2009,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 3,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 127,
    "LOC_Y": 216,
    "GAME_DATE": 20091104,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "https://www.youtube.com/embed/oa9LfU0AdGI?start=9&end=12",
    "nftUrl": "https://ftx.us/nfts/token/532190280791862126",
    "name": "The 2974 Collection #0003",
    "imageUrl": "https://arweave.net/OIi293m1ItgjBMkJEMjj_jrZkBSnAKhXo9qApOhtxuQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2009,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 4,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -59,
    "LOC_Y": 242,
    "GAME_DATE": 20091108,
    "Season": "2009-2010",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355111004673495136",
    "name": "The 2974 Collection #0004",
    "imageUrl": "https://arweave.net/C_CvjfmTnqPv93hrZJTobm5fW9qDoXY_a2o5rHK6KRc?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2009,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 5,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 187,
    "LOC_Y": 225,
    "GAME_DATE": 20091109,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/509125166103175686",
    "name": "The 2974 Collection #0005",
    "imageUrl": "https://arweave.net/MYevJHdknRaxNrcNmyampmFqH-4sIF8o-A9Sag35ofU?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2009,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 6,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": -2,
    "GAME_DATE": 20091114,
    "Season": "2009-2010",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404553510859324236",
    "name": "The 2974 Collection #0006",
    "imageUrl": "https://arweave.net/5rPFH68fXkbHQgC1UrJIEpMy7s-Lge3rq5NCmfYKeJk?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2009,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 7,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -142,
    "LOC_Y": 257,
    "GAME_DATE": 20091114,
    "Season": "2009-2010",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498680966815555131",
    "name": "The 2974 Collection #0007",
    "imageUrl": "https://arweave.net/zo4mI6ZVdxOOiLB3nJjEfzrDMwoKnqIEW6kHQ7FqmJ4?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2009,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 8,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 239,
    "LOC_Y": 7,
    "GAME_DATE": 20091117,
    "Season": "2009-2010",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349539233376036617",
    "name": "The 2974 Collection #0008",
    "imageUrl": "https://arweave.net/15DAQkM3OgjU_O8GbGMin5alicf82DYli1SrOOgRLAU?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2009,
    "Month": 11,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 9,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -242,
    "LOC_Y": 78,
    "GAME_DATE": 20091117,
    "Season": "2009-2010",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519296734601362971",
    "name": "The 2974 Collection #0009",
    "imageUrl": "https://arweave.net/IZ65ES4W04S7UZYxsCeBlHA8h4nkgOXXiDLBpI87h9o?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2009,
    "Month": 11,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 10,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -234,
    "LOC_Y": 99,
    "GAME_DATE": 20091118,
    "Season": "2009-2010",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344924501152840038",
    "name": "The 2974 Collection #0010",
    "imageUrl": "https://arweave.net/ryKtH2D1lfKdQwXqBdAIQxVUJS15h9RNg5ZkFX1JnXk?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2009,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 11,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -155,
    "LOC_Y": 220,
    "GAME_DATE": 20091120,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382642588743752991",
    "name": "The 2974 Collection #0011",
    "imageUrl": "https://arweave.net/MhJLvq6juGjr5GbELB501xF2Kc03SgHb14qOz-cT-K8?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2009,
    "Month": 11,
    "Day": 20,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 12,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -134,
    "LOC_Y": 235,
    "GAME_DATE": 20091120,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397533695403270720",
    "name": "The 2974 Collection #0012",
    "imageUrl": "https://arweave.net/kNMOhSM56o4Rfzg0-q05KYZMVhfLn1GT-dBWtOYm6nA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2009,
    "Month": 11,
    "Day": 20,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 13,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 196,
    "LOC_Y": 162,
    "GAME_DATE": 20091124,
    "Season": "2009-2010",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/424508337415209959",
    "name": "The 2974 Collection #0013",
    "imageUrl": "https://arweave.net/ry-V2Qzo4bPTq-4PYFPDUmIdhU4Lx8RY5i3vaXyaCgI?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2009,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 14,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -182,
    "LOC_Y": 159,
    "GAME_DATE": 20091124,
    "Season": "2009-2010",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/528880842476454553",
    "name": "The 2974 Collection #0014",
    "imageUrl": "https://arweave.net/n4fKgEO56YJUussWwuMxbGhIuSR33nyoz_SpKwrc3nY?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2009,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 15,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 176,
    "LOC_Y": 178,
    "GAME_DATE": 20091125,
    "Season": "2009-2010",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378580449188237685",
    "name": "The 2974 Collection #0015",
    "imageUrl": "https://arweave.net/RrYv4RpceRqj9mFL19tdDA_2ORj80gwHuUcwBaTwBKc?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2009,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 16,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -68,
    "LOC_Y": 261,
    "GAME_DATE": 20091128,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/469028632725620499",
    "name": "The 2974 Collection #0016",
    "imageUrl": "https://arweave.net/13GBJo2Cbth4QIyOygfa2qRE0qCcvagyC57Sqz7rv0g?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2009,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 17,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 61,
    "LOC_Y": 263,
    "GAME_DATE": 20091130,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567078130702714489",
    "name": "The 2974 Collection #0017",
    "imageUrl": "https://arweave.net/s_YdsHKmhMEb5tXMZeyWyFQ4ULoHZuDlshDjZCZdSoo?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2009,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 18,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -40,
    "LOC_Y": 248,
    "GAME_DATE": 20091201,
    "Season": "2009-2010",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326214761707287142",
    "name": "The 2974 Collection #0018",
    "imageUrl": "https://arweave.net/i7M17y4asZk_mhgbIkLV2C7RuptiQi4AY7uvWTauAaI?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2009,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 19,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -154,
    "LOC_Y": 185,
    "GAME_DATE": 20091201,
    "Season": "2009-2010",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566034540705184501",
    "name": "The 2974 Collection #0019",
    "imageUrl": "https://arweave.net/ixBT6Ke7iPF_H8ZRa2ndFk4R6U4f_9oapLW90rqbC58?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2009,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 20,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 1,
    "GAME_DATE": 20091203,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388373475609503214",
    "name": "The 2974 Collection #0020",
    "imageUrl": "https://arweave.net/wfHorhhHLTG9SBpIT6_7G7MfzaU1xDSp8K7Ra2YzyLk?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2009,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 21,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 119,
    "LOC_Y": 214,
    "GAME_DATE": 20091207,
    "Season": "2009-2010",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374850159189071307",
    "name": "The 2974 Collection #0021",
    "imageUrl": "https://arweave.net/xvFkD0LrxLam8XWY0Xu6K9l3Mx-MMLtedO7ubORHa6o?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2009,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 22,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 132,
    "LOC_Y": 201,
    "GAME_DATE": 20091207,
    "Season": "2009-2010",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/487945815146345980",
    "name": "The 2974 Collection #0022",
    "imageUrl": "https://arweave.net/FsrxhHoBW4Z6FmkNZT1n9lSCZq4T126Hplm8SGwNY2k?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2009,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 23,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 147,
    "LOC_Y": 187,
    "GAME_DATE": 20091209,
    "Season": "2009-2010",
    "HTM": "NJN",
    "VTM": "GSW",
    "Opposing Team": "NJN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/370427800647898903",
    "name": "The 2974 Collection #0023",
    "imageUrl": "https://arweave.net/0D-PJYBDZvmnc7nD-daYxUFkR_XWFlAp_qg8qVoi-fQ?ext=png",
    "Opposing Team City": "New Jersey",
    "Year": 2009,
    "Month": 12,
    "Day": 9,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 24,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 47,
    "GAME_DATE": 20091212,
    "Season": "2009-2010",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551968961385819219",
    "name": "The 2974 Collection #0024",
    "imageUrl": "https://arweave.net/47RTAeMN2FIFh6Qa3MxWvjbfhJ1MC2ityuZQgRYPJb0?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2009,
    "Month": 12,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 25,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 32,
    "LOC_Y": 257,
    "GAME_DATE": 20091212,
    "Season": "2009-2010",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/401699418330450144",
    "name": "The 2974 Collection #0025",
    "imageUrl": "https://arweave.net/gRoTcLtBeowGBXp5IK9h2vGOY34sLVASrIBTJmQQkRQ?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2009,
    "Month": 12,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 26,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -239,
    "LOC_Y": 33,
    "GAME_DATE": 20091212,
    "Season": "2009-2010",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296376665012812228",
    "name": "The 2974 Collection #0026",
    "imageUrl": "https://arweave.net/oSC3nn3Nx63dEmAwtfDv6dBtyKZgEOCP1dy0n1xD1zc?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2009,
    "Month": 12,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 27,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": -22,
    "GAME_DATE": 20091214,
    "Season": "2009-2010",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354337923797061155",
    "name": "The 2974 Collection #0027",
    "imageUrl": "https://arweave.net/aAu9Y92Nk6cREW194faL_vR8BqH2qBukcMh4unmAnOg?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2009,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 28,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 239,
    "LOC_Y": 0,
    "GAME_DATE": 20091218,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443477997123805504",
    "name": "The 2974 Collection #0028",
    "imageUrl": "https://arweave.net/X5Q9Dhx0_tgOPe5B2qqyCvmMvRPl6ef4RiKVSS0qJA4?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2009,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 29,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -204,
    "LOC_Y": 145,
    "GAME_DATE": 20091218,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/372776198231097207",
    "name": "The 2974 Collection #0029",
    "imageUrl": "https://arweave.net/O0gf5K0Aw3B8Hr12ixEQT3OCpOV24BiW3pTQ0cWe2I0?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2009,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 30,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -52,
    "LOC_Y": 254,
    "GAME_DATE": 20091218,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519129575272387879",
    "name": "The 2974 Collection #0030",
    "imageUrl": "https://arweave.net/lZe7597SdYtz1ZwPZ3_So4NZ81fwj4gZypsaBS2Brz8?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2009,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Jersey Number",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 31,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 7,
    "LOC_Y": 279,
    "GAME_DATE": 20091218,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480018985027938563",
    "name": "The 2974 Collection #0031",
    "imageUrl": "https://arweave.net/JUsVfpcECPkJuWamh0MZtp-qlnwFOn8JZWJBfZoUyyg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2009,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 32,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 9,
    "LOC_Y": 269,
    "GAME_DATE": 20091218,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550457324847152411",
    "name": "The 2974 Collection #0032",
    "imageUrl": "https://arweave.net/n-Y-jaM83QOUrytkcwpIa0Vph-b1_mfLs5y_8atJxKE?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2009,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 33,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -122,
    "LOC_Y": 219,
    "GAME_DATE": 20091222,
    "Season": "2009-2010",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/337543125023340982",
    "name": "The 2974 Collection #0033",
    "imageUrl": "https://arweave.net/-V6BdBTTzOWFKBm-q-JYwQVGCjLVCXLrw9UcqC-wbUI?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2009,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 34,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -150,
    "LOC_Y": 189,
    "GAME_DATE": 20091222,
    "Season": "2009-2010",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/291007217449220182",
    "name": "The 2974 Collection #0034",
    "imageUrl": "https://arweave.net/eNb3AFzPaMNP9CmvFdbXYTNtOiH-5gcwi16Zl8xcGCg?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2009,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 35,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 154,
    "LOC_Y": 203,
    "GAME_DATE": 20091223,
    "Season": "2009-2010",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536455639884313481",
    "name": "The 2974 Collection #0035",
    "imageUrl": "https://arweave.net/sVQr2tVzKxRfFHehE0MYGnt-YEOJDvnkv3rDp3F_f5Y?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2009,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 36,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -92,
    "LOC_Y": 249,
    "GAME_DATE": 20091223,
    "Season": "2009-2010",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515838486046144774",
    "name": "The 2974 Collection #0036",
    "imageUrl": "https://arweave.net/Bt2cib0EfYYF-YoaUECSw5Gd3UWYW2ONeAU8FaWdSz0?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2009,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 37,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 25,
    "GAME_DATE": 20091223,
    "Season": "2009-2010",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356871523834207489",
    "name": "The 2974 Collection #0037",
    "imageUrl": "https://arweave.net/4hEWBQUiOlI6OzkuDtW9dXnTh_ZMrx2qnIwOa-ziLZ0?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2009,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 38,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -202,
    "LOC_Y": 148,
    "GAME_DATE": 20091226,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446934009228560765",
    "name": "The 2974 Collection #0038",
    "imageUrl": "https://arweave.net/uSes7vSOg4h7N15SCv9peC-68sWWeaVLv38bodlZGsI?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2009,
    "Month": 12,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 39,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -202,
    "LOC_Y": 151,
    "GAME_DATE": 20091226,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551009969361131902",
    "name": "The 2974 Collection #0039",
    "imageUrl": "https://arweave.net/80ZhcyNd5wV54TUbi9QHcgFnOtiDWiq7hcaR6vdUdlw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2009,
    "Month": 12,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 40,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 122,
    "LOC_Y": 235,
    "GAME_DATE": 20091226,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/383997040224237778",
    "name": "The 2974 Collection #0040",
    "imageUrl": "https://arweave.net/mV9mdnFJEheqZRi7ylGhBpEmPNJCT6qbPqxXLLC83F8?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2009,
    "Month": 12,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 41,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 209,
    "LOC_Y": 126,
    "GAME_DATE": 20100102,
    "Season": "2009-2010",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367488876741738541",
    "name": "The 2974 Collection #0041",
    "imageUrl": "https://arweave.net/V0QoTLoK_BmXK0GzTal021PKI1tl7WtxGBe3GQnby1c?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2010,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 42,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 146,
    "LOC_Y": 206,
    "GAME_DATE": 20100105,
    "Season": "2009-2010",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417195447979302573",
    "name": "The 2974 Collection #0042",
    "imageUrl": "https://arweave.net/1OwIt4Dd6x0iYFYBkHbZ4Q03nu-_4c5_U2v2FVuM0FE?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 43,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 174,
    "LOC_Y": 180,
    "GAME_DATE": 20100105,
    "Season": "2009-2010",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458144619667616650",
    "name": "The 2974 Collection #0043",
    "imageUrl": "https://arweave.net/T9iQPndY_ZOvczgozvvOxxQ5WjpGRYIT1Z-ij95DOUo?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 44,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 22,
    "GAME_DATE": 20100105,
    "Season": "2009-2010",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479392898800839030",
    "name": "The 2974 Collection #0044",
    "imageUrl": "https://arweave.net/HnlKO36SE7XRHXIrW3YcjvJzQFOIyl3XpzBoJDruuW8?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 45,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 232,
    "LOC_Y": 70,
    "GAME_DATE": 20100105,
    "Season": "2009-2010",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/430286588638164722",
    "name": "The 2974 Collection #0045",
    "imageUrl": "https://arweave.net/S8xtSSm43ELQUUx4hOMaHmzD5RyFy-pXI_YqDxQ3LlY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 46,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -162,
    "LOC_Y": 187,
    "GAME_DATE": 20100105,
    "Season": "2009-2010",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341301955853287601",
    "name": "The 2974 Collection #0046",
    "imageUrl": "https://arweave.net/lA53GKdq5JxNmVgCCMP3ST_DcjBodFkyFhp5u701HCY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 47,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -177,
    "LOC_Y": 185,
    "GAME_DATE": 20100105,
    "Season": "2009-2010",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503853411975724884",
    "name": "The 2974 Collection #0047",
    "imageUrl": "https://arweave.net/qAsMmefykMbufuiAI4z0d6OBm6ag6NIXHpeeS6I73-U?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 48,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -27,
    "LOC_Y": 258,
    "GAME_DATE": 20100108,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373909383020112736",
    "name": "The 2974 Collection #0048",
    "imageUrl": "https://arweave.net/zNPK6ZVPh0RxxT_BHZ3dz1w7N5pJ5osyWI_NJ7p31Yo?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2010,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 49,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 7,
    "LOC_Y": 268,
    "GAME_DATE": 20100111,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464014192880858496",
    "name": "The 2974 Collection #0049",
    "imageUrl": "https://arweave.net/Beg9zsW2oZxqvZBkNxSVL1Gs1FjA3gJSZBq5w8ESy44?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2010,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 50,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -185,
    "LOC_Y": 178,
    "GAME_DATE": 20100113,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510901263452943798",
    "name": "The 2974 Collection #0050",
    "imageUrl": "https://arweave.net/BFbqj-tp_DanOi3BOWhFO5jxF8SezUMPqL9GUU-SymI?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2010,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 51,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 0,
    "GAME_DATE": 20100113,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386899973928873871",
    "name": "The 2974 Collection #0051",
    "imageUrl": "https://arweave.net/Z5IW-f053UQ0bmnKJYJbMIe-9ky9WSSZSE_jymCjSZg?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2010,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 52,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -125,
    "LOC_Y": 230,
    "GAME_DATE": 20100113,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566788093360885520",
    "name": "The 2974 Collection #0052",
    "imageUrl": "https://arweave.net/pEyw7CLxkqIHsO1ug_4CnDqclgR8wRqLZ48jgWj07Tc?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2010,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 53,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 204,
    "LOC_Y": 143,
    "GAME_DATE": 20100115,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565111593902036086",
    "name": "The 2974 Collection #0053",
    "imageUrl": "https://arweave.net/LSiGGBvK0Ai_NF4CtubY6sl8eikpCB2biS1XRQZN7e0?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2010,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 54,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 155,
    "LOC_Y": 217,
    "GAME_DATE": 20100118,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480704991897707352",
    "name": "The 2974 Collection #0054",
    "imageUrl": "https://arweave.net/I3vBhAn7eM4KbKeNZ4IqZ4BEtM3-a1D1TOkBj2pebx0?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2010,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 55,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -109,
    "LOC_Y": 242,
    "GAME_DATE": 20100118,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/340543255942174250",
    "name": "The 2974 Collection #0055",
    "imageUrl": "https://arweave.net/ZBkPFN9rj3bvXBnA_PsYyI6gnYNO6tPpiv6_3o3iDhs?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2010,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 56,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 226,
    "LOC_Y": 6,
    "GAME_DATE": 20100118,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319566005847974213",
    "name": "The 2974 Collection #0056",
    "imageUrl": "https://arweave.net/8v_0y93_hCet6wipQ6XsJP7LBNlla-wTFjMM6KNCIAM?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2010,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 57,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 198,
    "LOC_Y": 184,
    "GAME_DATE": 20100118,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524265957500340733",
    "name": "The 2974 Collection #0057",
    "imageUrl": "https://arweave.net/jMNWRT6W9Qj39ERfimgU20DRS57p3yyq-IOjRP_60Pg?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2010,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 58,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -76,
    "LOC_Y": 255,
    "GAME_DATE": 20100118,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461159022442301242",
    "name": "The 2974 Collection #0058",
    "imageUrl": "https://arweave.net/6-TNFhXCpKjC20h27liX3vnCCJ6U7c57CjGqzlj67Ac?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2010,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 59,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": -6,
    "GAME_DATE": 20100120,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544654139374066913",
    "name": "The 2974 Collection #0059",
    "imageUrl": "https://arweave.net/PG7V5_Sf6enPu3MaUxp1_yIInXxZQcbJc2AARfk0-7Q?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 60,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 42,
    "GAME_DATE": 20100120,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/350670456909742153",
    "name": "The 2974 Collection #0060",
    "imageUrl": "https://arweave.net/gp_Ad9jNO0rJrB_Cecd01AIuzw--ECCJd1ILvqC13OY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 61,
    "PERIOD": 5,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -82,
    "LOC_Y": 257,
    "GAME_DATE": 20100120,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312050076091685674",
    "name": "The 2974 Collection #0061",
    "imageUrl": "https://arweave.net/MTUYcoO8m2I2aAdtvAdf8ld5OR8GpU0KzunDXI7ouhk?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 62,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 64,
    "LOC_Y": 238,
    "GAME_DATE": 20100122,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "NJN",
    "Opposing Team": "NJN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482610246972461564",
    "name": "The 2974 Collection #0062",
    "imageUrl": "https://arweave.net/5m-kZFEPbQDi5fwexR3yXpTYlqhqrhh-u9GxadO5P58?ext=png",
    "Opposing Team City": "New Jersey",
    "Year": 2010,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 63,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 176,
    "LOC_Y": 211,
    "GAME_DATE": 20100122,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "NJN",
    "Opposing Team": "NJN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373809392977951783",
    "name": "The 2974 Collection #0063",
    "imageUrl": "https://arweave.net/WXcE_Kia8u_acqyV-YaDUedIYhAKMFaNONgG869O_Q4?ext=png",
    "Opposing Team City": "New Jersey",
    "Year": 2010,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 64,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -188,
    "LOC_Y": 192,
    "GAME_DATE": 20100122,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "NJN",
    "Opposing Team": "NJN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/494993386640924329",
    "name": "The 2974 Collection #0064",
    "imageUrl": "https://arweave.net/8rYpKWrLI54w370Pz8zYqkZD4ztUwvIE_tk64vMhK8A?ext=png",
    "Opposing Team City": "New Jersey",
    "Year": 2010,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 65,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 80,
    "LOC_Y": 250,
    "GAME_DATE": 20100123,
    "Season": "2009-2010",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/447247033794932293",
    "name": "The 2974 Collection #0065",
    "imageUrl": "https://arweave.net/4QIPa8vLEi3Ya0Sm2uco0C6C-CUytoI7wkZjxKdOVHg?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2010,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 66,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 173,
    "LOC_Y": 187,
    "GAME_DATE": 20100123,
    "Season": "2009-2010",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/538202921778076627",
    "name": "The 2974 Collection #0066",
    "imageUrl": "https://arweave.net/emUcDIfEqj-ht-ktIO034UekSqYNKyQyLYv3p4TZCww?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2010,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 67,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 24,
    "LOC_Y": 250,
    "GAME_DATE": 20100123,
    "Season": "2009-2010",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443753448397669903",
    "name": "The 2974 Collection #0067",
    "imageUrl": "https://arweave.net/A8u3G_wSZqsv1E2Po-83ZzSvZ7HjgACPLtoUz8TfA40?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2010,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 68,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 160,
    "LOC_Y": 194,
    "GAME_DATE": 20100123,
    "Season": "2009-2010",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464758853094101971",
    "name": "The 2974 Collection #0068",
    "imageUrl": "https://arweave.net/i8LOl93KIxc90Kw0IrnnlTfA7dNzrZTdgmNoGAfUdUI?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2010,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 69,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 12,
    "LOC_Y": 252,
    "GAME_DATE": 20100126,
    "Season": "2009-2010",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567894717931970566",
    "name": "The 2974 Collection #0069",
    "imageUrl": "https://arweave.net/xY4Gf1rG2bXQ8vGwqeVOhtIDQ8eCf3JVTHED87ictSc?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2010,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 70,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -87,
    "LOC_Y": 231,
    "GAME_DATE": 20100126,
    "Season": "2009-2010",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520155749385169104",
    "name": "The 2974 Collection #0070",
    "imageUrl": "https://arweave.net/lIfh_qQRRPGjP9JWyXf8LNJH_eWhODq403_yoyJbbFE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2010,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 71,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": 39,
    "GAME_DATE": 20100126,
    "Season": "2009-2010",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489978698377809175",
    "name": "The 2974 Collection #0071",
    "imageUrl": "https://arweave.net/DnFhHuFuOvsuV6ATZ68STJjEllzW_YzI75TeFAnmQaw?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2010,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 72,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": -2,
    "GAME_DATE": 20100127,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444020664661124931",
    "name": "The 2974 Collection #0072",
    "imageUrl": "https://arweave.net/ZtTIuAQebKVqyaZHqb_V1syKb9rdTGrzkwe1tXRIdA8?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2010,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 73,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 170,
    "LOC_Y": 213,
    "GAME_DATE": 20100129,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500779895079912369",
    "name": "The 2974 Collection #0073",
    "imageUrl": "https://arweave.net/zRBqby0eb8mCrfng0eMURol4kc03U5h2WCLy4Nv-yp4?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 1,
    "Day": 29,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 74,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -147,
    "LOC_Y": 224,
    "GAME_DATE": 20100129,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/486741336117846108",
    "name": "The 2974 Collection #0074",
    "imageUrl": "https://arweave.net/jcUDuzR6wwBohjO44_Jm1_mOKbM-srw-6V0_L8JUDOk?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 1,
    "Day": 29,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 75,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -5,
    "LOC_Y": 242,
    "GAME_DATE": 20100131,
    "Season": "2009-2010",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349684603066297146",
    "name": "The 2974 Collection #0075",
    "imageUrl": "https://arweave.net/ugZqmmUmGVPDwLXz8YvhOC5OrdHXxCDXrXJt7gfqiqY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 76,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 0,
    "LOC_Y": 242,
    "GAME_DATE": 20100131,
    "Season": "2009-2010",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297743020007160992",
    "name": "The 2974 Collection #0076",
    "imageUrl": "https://arweave.net/S1JRnt5PHH2QExgWjBhy_XRrezxr83ZkO0aHf5HUQJ0?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 77,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -210,
    "LOC_Y": 116,
    "GAME_DATE": 20100202,
    "Season": "2009-2010",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390380943442620310",
    "name": "The 2974 Collection #0077",
    "imageUrl": "https://arweave.net/ZpAF9Q_gpDL_68fRBZFDmW3Q9Of5H0_fcZ-XG9DdIGs?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2010,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 78,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -97,
    "LOC_Y": 233,
    "GAME_DATE": 20100202,
    "Season": "2009-2010",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/554230225247085042",
    "name": "The 2974 Collection #0078",
    "imageUrl": "https://arweave.net/3PKL0WOST2TrhwLK2eMc2sS8orT-l6kACH1mvjwxcHc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2010,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 79,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 26,
    "GAME_DATE": 20100206,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347878429094934898",
    "name": "The 2974 Collection #0079",
    "imageUrl": "https://arweave.net/8vgZcc0LG6N-dqaUnL0_29DDfLU4K9TCjSKWDcdWkfg?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 80,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -168,
    "LOC_Y": 211,
    "GAME_DATE": 20100206,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338189486615152439",
    "name": "The 2974 Collection #0080",
    "imageUrl": "https://arweave.net/GH0sD8-koiE6SF6CJUjr26IkUpbHvXKAuzR_awpr5xU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 81,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -131,
    "LOC_Y": 269,
    "GAME_DATE": 20100206,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/325999435271855620",
    "name": "The 2974 Collection #0081",
    "imageUrl": "https://arweave.net/WlovL4GOBh-9DL0RpvAz6R_eh_plrZWiADXQDkLyeRs?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 82,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -161,
    "LOC_Y": 238,
    "GAME_DATE": 20100208,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378922987624665319",
    "name": "The 2974 Collection #0082",
    "imageUrl": "https://arweave.net/2M7eoxxO9aCiVUqneH-07z1-bJx-l4qYR4RlPCImBIU?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2010,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 83,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 48,
    "GAME_DATE": 20100210,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330926018187037422",
    "name": "The 2974 Collection #0083",
    "imageUrl": "https://arweave.net/hA89tiY9pFrPREugju9IfjGwoA04kydSwzPaMnezj10?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Triple-Double",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 84,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 62,
    "LOC_Y": 258,
    "GAME_DATE": 20100210,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/294677993209527410",
    "name": "The 2974 Collection #0084",
    "imageUrl": "https://arweave.net/fwZFH9wzAVLl3eo6Ll5Qp97C0clCNDJ3t1_zgmf9NNQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Triple-Double",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 85,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -213,
    "LOC_Y": 157,
    "GAME_DATE": 20100210,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/496454572412253084",
    "name": "The 2974 Collection #0085",
    "imageUrl": "https://arweave.net/fBBrtv88aDpXdLP5ukvvWLCelJiadF7NGZ-NZXk9-DQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 86,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 42,
    "GAME_DATE": 20100210,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480791258635486642",
    "name": "The 2974 Collection #0086",
    "imageUrl": "https://arweave.net/2DwHeu39dQbtSldD0v577hsCrcBd14-vR6xCaFdmOgw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Triple-Double",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 87,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 136,
    "LOC_Y": 242,
    "GAME_DATE": 20100210,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/530268688946554026",
    "name": "The 2974 Collection #0087",
    "imageUrl": "https://arweave.net/6BK68KQttjzZ2L2-SR4aos3GALMXbAHXR2CFJYSvoaw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Triple-Double",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 88,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 62,
    "LOC_Y": 258,
    "GAME_DATE": 20100210,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547897554154670020",
    "name": "The 2974 Collection #0088",
    "imageUrl": "https://arweave.net/bYh6jpnnz_nduVO4xisfjEA8RLDHyNBhL2-Iq-lqcJ8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Triple-Double",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 89,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 7,
    "LOC_Y": 266,
    "GAME_DATE": 20100210,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/560034263024968411",
    "name": "The 2974 Collection #0089",
    "imageUrl": "https://arweave.net/7YS7jCLuL8waFS6jbwBNWvs5zKMEeU1MXkVDhN8Qdjo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 90,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 62,
    "LOC_Y": 266,
    "GAME_DATE": 20100216,
    "Season": "2009-2010",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/304110017239321319",
    "name": "The 2974 Collection #0090",
    "imageUrl": "https://arweave.net/ERxS5AHtRy1MMqQYwqNBLcxOLdvMqoNXqt3pOdQ9GQA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 2,
    "Day": 16,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 91,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 1,
    "GAME_DATE": 20100217,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391199585144304041",
    "name": "The 2974 Collection #0091",
    "imageUrl": "https://arweave.net/yDj5rw4ksxNumZVSyeVvyZ0nqTBri-BNtWBYfu9jvks?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2010,
    "Month": 2,
    "Day": 17,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 92,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 231,
    "LOC_Y": 3,
    "GAME_DATE": 20100219,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544881055720917149",
    "name": "The 2974 Collection #0092",
    "imageUrl": "https://arweave.net/a9bSAcA1cjurCcSkM8f8JBvIXX3QOQbSY9lHQD1AwHI?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2010,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 93,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -212,
    "LOC_Y": 140,
    "GAME_DATE": 20100219,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468283527772168569",
    "name": "The 2974 Collection #0093",
    "imageUrl": "https://arweave.net/UaKjaKszQdzXjYf8KSaHLSaxS251K6x_a3dWGCs_dqs?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2010,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 94,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": -2,
    "GAME_DATE": 20100219,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/425454026652502308",
    "name": "The 2974 Collection #0094",
    "imageUrl": "https://arweave.net/ORunBo2XOE9QDqd5KRnXNqR7z3b4T_kvTcbWAaHl67A?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2010,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 95,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 12,
    "LOC_Y": 257,
    "GAME_DATE": 20100221,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/306060809965871449",
    "name": "The 2974 Collection #0095",
    "imageUrl": "https://arweave.net/7cXl7AutEd_mJanShkH14qFeEI3csbEU8dAcE6btGFc?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2010,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 96,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 44,
    "GAME_DATE": 20100223,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558321339806364980",
    "name": "The 2974 Collection #0096",
    "imageUrl": "https://arweave.net/IIJkQTapnKlVIrmCqkedDuOVIJ33N4dsXWbE0qhL__c?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2010,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 97,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -161,
    "LOC_Y": 228,
    "GAME_DATE": 20100225,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/365157236163834294",
    "name": "The 2974 Collection #0097",
    "imageUrl": "https://arweave.net/dq0CwAbe6Wvqqy7PXgBGybcJcHHK6cWbAVzx29z1IA4?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 98,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -146,
    "LOC_Y": 225,
    "GAME_DATE": 20100225,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512166235553137781",
    "name": "The 2974 Collection #0098",
    "imageUrl": "https://arweave.net/I8gDmzMXxndFt_mHD3rwjbjUulCzbMO1ZWdPfXrhk8E?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 99,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -141,
    "LOC_Y": 222,
    "GAME_DATE": 20100227,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/553760267735048159",
    "name": "The 2974 Collection #0099",
    "imageUrl": "https://arweave.net/H4tZjtqBOv-t-0YXfrmHOt3b99TiTpPJvM475X7Qr3Y?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2010,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 100,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -52,
    "LOC_Y": 246,
    "GAME_DATE": 20100227,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/313557615675687077",
    "name": "The 2974 Collection #0100",
    "imageUrl": "https://arweave.net/11SFtnlMLPrtBjmgcdIFWp0WQqRYZg2P9h1hxIBALI0?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2010,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 101,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 9,
    "LOC_Y": 257,
    "GAME_DATE": 20100227,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352119956034710730",
    "name": "The 2974 Collection #0101",
    "imageUrl": "https://arweave.net/kauTKjY4xG6VIZp9NuluGWWFqwmzAqbtU9Ktdp5uP64?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2010,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 102,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 163,
    "LOC_Y": 192,
    "GAME_DATE": 20100302,
    "Season": "2009-2010",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523231131126817931",
    "name": "The 2974 Collection #0102",
    "imageUrl": "https://arweave.net/ff40tvpe3FY3VvymBpiIG4MF1FOHoGTa6jJjmoKGkPI?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2010,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 103,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 152,
    "LOC_Y": 213,
    "GAME_DATE": 20100302,
    "Season": "2009-2010",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459467514150894992",
    "name": "The 2974 Collection #0103",
    "imageUrl": "https://arweave.net/KRaBYMrceRN5zrccn8gIgWXrz72ftdJG4bgRajovp3s?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2010,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 104,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 214,
    "LOC_Y": 113,
    "GAME_DATE": 20100302,
    "Season": "2009-2010",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491562594850353564",
    "name": "The 2974 Collection #0104",
    "imageUrl": "https://arweave.net/U0zUEqMKJNSGXqEYAWWyNAodziAK-4es0JCaZkJjTVQ?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2010,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 105,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 225,
    "LOC_Y": 72,
    "GAME_DATE": 20100303,
    "Season": "2009-2010",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502564317273621058",
    "name": "The 2974 Collection #0105",
    "imageUrl": "https://arweave.net/wqzAHa89imytcISGiMUT9x-LNtFzAesqEMTAScz5Axc?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2010,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 106,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -130,
    "LOC_Y": 220,
    "GAME_DATE": 20100305,
    "Season": "2009-2010",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434409818013096944",
    "name": "The 2974 Collection #0106",
    "imageUrl": "https://arweave.net/ansGNtti3odiAXTf1qZYjB4TADaabjbJOL_01KnReqI?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2010,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 107,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 111,
    "LOC_Y": 242,
    "GAME_DATE": 20100305,
    "Season": "2009-2010",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341715349456577394",
    "name": "The 2974 Collection #0107",
    "imageUrl": "https://arweave.net/iOR16rX4wp18nT37G77RwYnnfM3ojd6ez55_Nxt_7U4?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2010,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 108,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -127,
    "LOC_Y": 216,
    "GAME_DATE": 20100305,
    "Season": "2009-2010",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/426333712337641879",
    "name": "The 2974 Collection #0108",
    "imageUrl": "https://arweave.net/xh3c_NzsAyBot0u5O0kqcN0Mp2X3Kl6Cii7mVpv_Jv0?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2010,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 109,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -163,
    "LOC_Y": 206,
    "GAME_DATE": 20100305,
    "Season": "2009-2010",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/471566991257535027",
    "name": "The 2974 Collection #0109",
    "imageUrl": "https://arweave.net/JlMRdkxZ2hBSPh7Wa8it1O8ib3GWXxtHMkmvrCs1S54?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2010,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 110,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -163,
    "LOC_Y": 203,
    "GAME_DATE": 20100305,
    "Season": "2009-2010",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439204660555041647",
    "name": "The 2974 Collection #0110",
    "imageUrl": "https://arweave.net/icd678H8gpxVcv7Kj9PvYHVVlbahAtugQan-9NzqVvo?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2010,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 111,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 239,
    "LOC_Y": 14,
    "GAME_DATE": 20100306,
    "Season": "2009-2010",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/292791805741361058",
    "name": "The 2974 Collection #0111",
    "imageUrl": "https://arweave.net/BdQrZcKstt_rKNec0J4k9ra7LWlp7YzUTirIUhU6-ug?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 112,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 209,
    "LOC_Y": 135,
    "GAME_DATE": 20100306,
    "Season": "2009-2010",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/288893970616339160",
    "name": "The 2974 Collection #0112",
    "imageUrl": "https://arweave.net/r8hiOaV3jE2kDFHIYQb5HiGZISUCp2GfikBXyZwM-xA?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 113,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 130,
    "LOC_Y": 222,
    "GAME_DATE": 20100306,
    "Season": "2009-2010",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541795495163038170",
    "name": "The 2974 Collection #0113",
    "imageUrl": "https://arweave.net/32Tmou3WMPEF8EiDapDpPYm7QpCE5qq1vpmxlhQfok0?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 114,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -5,
    "GAME_DATE": 20100306,
    "Season": "2009-2010",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491083924203241029",
    "name": "The 2974 Collection #0114",
    "imageUrl": "https://arweave.net/NE8YQKvLttKCFvU0m7QMoVi1peYnK5WecKIHYBPrs1A?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 115,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -23,
    "LOC_Y": 258,
    "GAME_DATE": 20100308,
    "Season": "2009-2010",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/488014536688586845",
    "name": "The 2974 Collection #0115",
    "imageUrl": "https://arweave.net/7Mk9SxlJBWOPkIbM_AKTykkS4WOGjegXAMOv3lQi7BM?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2010,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 116,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -171,
    "LOC_Y": 203,
    "GAME_DATE": 20100308,
    "Season": "2009-2010",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461227760067840957",
    "name": "The 2974 Collection #0116",
    "imageUrl": "https://arweave.net/HO3JVuAKRXSPAXlEzNnxMvsJ1i8nypTYkpZQvW0MDcY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2010,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 117,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 157,
    "LOC_Y": 227,
    "GAME_DATE": 20100311,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444347988845786433",
    "name": "The 2974 Collection #0117",
    "imageUrl": "https://arweave.net/YEkTj0RR8SYvSzME7YlOCPdeL_9lMtqcqnLIlbAWIlE?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2010,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 118,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 2,
    "LOC_Y": 269,
    "GAME_DATE": 20100311,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/405989464003179923",
    "name": "The 2974 Collection #0118",
    "imageUrl": "https://arweave.net/IWbVFnQQiuxNx3xFMylseOGN4FRHBL_p-64KLf1u6jQ?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2010,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 119,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 23,
    "GAME_DATE": 20100313,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/329199612892144647",
    "name": "The 2974 Collection #0119",
    "imageUrl": "https://arweave.net/6TmXrE_AY_3HIH5vdlf4gbXvVCol9laZOwQzAvBch0E?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 120,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 20,
    "GAME_DATE": 20100313,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/432598388080474692",
    "name": "The 2974 Collection #0120",
    "imageUrl": "https://arweave.net/PhzyBULAx-qK2v5j3sn5zf4c-hfQQ3PhSwjhNY4ysXU?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 121,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": 28,
    "GAME_DATE": 20100313,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312793695502944852",
    "name": "The 2974 Collection #0121",
    "imageUrl": "https://arweave.net/Gv8BpmN1sy9MhDbz0xAQGB5fdX8kZQxDNfObTz8K5oQ?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 122,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -117,
    "LOC_Y": 225,
    "GAME_DATE": 20100313,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/342737148978879026",
    "name": "The 2974 Collection #0122",
    "imageUrl": "https://arweave.net/8FxHj4IefWm-OvEtYmvDrvnyZjm0tHaF-JJMGzZzoXk?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 123,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 129,
    "LOC_Y": 290,
    "GAME_DATE": 20100313,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539222322533990041",
    "name": "The 2974 Collection #0123",
    "imageUrl": "https://arweave.net/aii6OBSIC8zw4QSEZhxEqFTXXBywrNBynfqxjYixZYc?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 124,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 241,
    "LOC_Y": -10,
    "GAME_DATE": 20100315,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363188038857527874",
    "name": "The 2974 Collection #0124",
    "imageUrl": "https://arweave.net/RqKH5uFkqnT_vhtbzVrsKrljt18gTczy0xUjeg-0yT0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 3,
    "Day": 15,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 125,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 67,
    "LOC_Y": 252,
    "GAME_DATE": 20100315,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300698463180728752",
    "name": "The 2974 Collection #0125",
    "imageUrl": "https://arweave.net/-XEQdiRRYMOrJK5KbK4NZE7oRWyYRVyYMmHSWnivNL0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 3,
    "Day": 15,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 126,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -190,
    "LOC_Y": 195,
    "GAME_DATE": 20100315,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331034120302556137",
    "name": "The 2974 Collection #0126",
    "imageUrl": "https://arweave.net/wLZknVcluBP9_fZW690ijydHBAO6wHrI3eRu005kvfU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 3,
    "Day": 15,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 127,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 54,
    "LOC_Y": 265,
    "GAME_DATE": 20100315,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368550399048753887",
    "name": "The 2974 Collection #0127",
    "imageUrl": "https://arweave.net/J9PClUOF7wH19tDbifeV3EY3RRiTP5NDN9Qg75KHJ-I?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 3,
    "Day": 15,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 128,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 171,
    "LOC_Y": 205,
    "GAME_DATE": 20100315,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392218948865242324",
    "name": "The 2974 Collection #0128",
    "imageUrl": "https://arweave.net/oaOGT2ANb_Jma38dKg8Xg2L6AWwHaCDdNdPsdeOQlpI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 3,
    "Day": 15,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 129,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -122,
    "LOC_Y": 220,
    "GAME_DATE": 20100320,
    "Season": "2009-2010",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468920621081151862",
    "name": "The 2974 Collection #0129",
    "imageUrl": "https://arweave.net/EMWoT1pKxb1Hjeb7ogbt-hA4tZ_q3cwVdYKIgxOBBNo?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2010,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 130,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -13,
    "LOC_Y": 244,
    "GAME_DATE": 20100322,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289242678432715235",
    "name": "The 2974 Collection #0130",
    "imageUrl": "https://arweave.net/scyra_jGZrhEkANlb4ztTYg2YeVBA-GgCxvHZSJuJLw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2010,
    "Month": 3,
    "Day": 22,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 131,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 25,
    "GAME_DATE": 20100322,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/460606811759810397",
    "name": "The 2974 Collection #0131",
    "imageUrl": "https://arweave.net/EKBQal0IfYkD1HAsjhe0PcoUk37x7y9-TbUpa9nJ80I?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2010,
    "Month": 3,
    "Day": 22,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 132,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 143,
    "LOC_Y": 222,
    "GAME_DATE": 20100324,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/401070801258897053",
    "name": "The 2974 Collection #0132",
    "imageUrl": "https://arweave.net/1I9hXn3fPrsqIkeM7QUL-B6eywjyOZs6thuBwOZ7uiw?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2010,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 133,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 0,
    "GAME_DATE": 20100324,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344925682320946981",
    "name": "The 2974 Collection #0133",
    "imageUrl": "https://arweave.net/Z-jYVFa8MRGrmp-NL-YVQwdmhLFqg4EzblfzXOPcTp4?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2010,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 134,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -98,
    "LOC_Y": 247,
    "GAME_DATE": 20100324,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348697999095777974",
    "name": "The 2974 Collection #0134",
    "imageUrl": "https://arweave.net/UzdwcsVHfxEaNPX1jzlA5b2xP3AzGufszNmDm9dMN-s?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2010,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 135,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -11,
    "LOC_Y": 260,
    "GAME_DATE": 20100324,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490802080109562673",
    "name": "The 2974 Collection #0135",
    "imageUrl": "https://arweave.net/bxXWroVrClbWyBidN0lbiwwsq2mXbDPZNz2iT9dSiRs?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2010,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 136,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 28,
    "GAME_DATE": 20100327,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402583149991707443",
    "name": "The 2974 Collection #0136",
    "imageUrl": "https://arweave.net/0L3fn66tRVBAc6EOl8m3SbdL46uh33f86G61IetXncc?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2010,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 137,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -75,
    "LOC_Y": 250,
    "GAME_DATE": 20100327,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317537605096270174",
    "name": "The 2974 Collection #0137",
    "imageUrl": "https://arweave.net/DRy4HkhjMPN0YiGvAkE3kE0jFaVG1vO88Z_aktMKNdo?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2010,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 138,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 254,
    "GAME_DATE": 20100327,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290133358740745475",
    "name": "The 2974 Collection #0138",
    "imageUrl": "https://arweave.net/JRAR5mO4-0TxnwkCsXPIt2iBthVVpmhe3YlajxTJ0ho?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2010,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 139,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -16,
    "LOC_Y": 258,
    "GAME_DATE": 20100328,
    "Season": "2009-2010",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558409578468374554",
    "name": "The 2974 Collection #0139",
    "imageUrl": "https://arweave.net/bVr-RMbPDnCmz1vrRomYfonfQiPqac-Fulz0xlr88Dg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 140,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": 17,
    "GAME_DATE": 20100328,
    "Season": "2009-2010",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363640314627142330",
    "name": "The 2974 Collection #0140",
    "imageUrl": "https://arweave.net/f05ZuYs2umEca7KQo4SSI7sZ_28-nH7h7P1dYAAQSS8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 141,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -106,
    "LOC_Y": 217,
    "GAME_DATE": 20100331,
    "Season": "2009-2010",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/445248310435108643",
    "name": "The 2974 Collection #0141",
    "imageUrl": "https://arweave.net/s586h9SeMIGulIlBu0ugw1lVwJF7-06u7zIUa7MWOXs?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2010,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 142,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 146,
    "LOC_Y": 219,
    "GAME_DATE": 20100402,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520661388939639082",
    "name": "The 2974 Collection #0142",
    "imageUrl": "https://arweave.net/W7u1KubHDx0MgsfLVJkDHEBLsBzZBGWzaHTIOegh2zc?ext=png",
    "Opposing Team City": "New York",
    "Year": 2010,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 143,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 2,
    "LOC_Y": 249,
    "GAME_DATE": 20100404,
    "Season": "2009-2010",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309626661270517725",
    "name": "The 2974 Collection #0143",
    "imageUrl": "https://arweave.net/pSG_Z2-VNh2-_fJRn_q82wFphTFUc1DDDa4k2xleNQE?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 144,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -117,
    "LOC_Y": 224,
    "GAME_DATE": 20100404,
    "Season": "2009-2010",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/469756953745396641",
    "name": "The 2974 Collection #0144",
    "imageUrl": "https://arweave.net/rKB9azL_UcKVehMS_xQJk4h2pMvlOz_zoMdja4Rm6Lo?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 145,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 59,
    "LOC_Y": 239,
    "GAME_DATE": 20100404,
    "Season": "2009-2010",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/453181395475977217",
    "name": "The 2974 Collection #0145",
    "imageUrl": "https://arweave.net/-Chl2IlAq_RcvcA9bxM0YTH2O9W-uyGdh1TjhNrVri4?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 146,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 72,
    "LOC_Y": 238,
    "GAME_DATE": 20100404,
    "Season": "2009-2010",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/466659774621859163",
    "name": "The 2974 Collection #0146",
    "imageUrl": "https://arweave.net/jnSBv_SXEzPLg-W1tv5J2PcQk6rb7_s2w0u1-Ll0BxY?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 147,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 3,
    "GAME_DATE": 20100404,
    "Season": "2009-2010",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495878608329159616",
    "name": "The 2974 Collection #0147",
    "imageUrl": "https://arweave.net/CyFYxsrHYdrOidXLTePpEzTQOMb7JPe9YKE3Fg-_N5k?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 148,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -188,
    "LOC_Y": 176,
    "GAME_DATE": 20100406,
    "Season": "2009-2010",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404705183864516298",
    "name": "The 2974 Collection #0148",
    "imageUrl": "https://arweave.net/3z2HnBVlu9Onvt5-7yp0wegrDSyxNjZ3k1Vai4avAzc?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2010,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 149,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 159,
    "LOC_Y": 198,
    "GAME_DATE": 20100406,
    "Season": "2009-2010",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/292000565760626126",
    "name": "The 2974 Collection #0149",
    "imageUrl": "https://arweave.net/63C0hM377Nib0znZwPosBBYjY0BG3Q-1sTIutGgnsIQ?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2010,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 150,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -229,
    "LOC_Y": 124,
    "GAME_DATE": 20100406,
    "Season": "2009-2010",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/451814024186293203",
    "name": "The 2974 Collection #0150",
    "imageUrl": "https://arweave.net/hTmUkRVNT_Mi0bA3EOPUForUZh-G0HtFKQ_FvjsEz44?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2010,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 151,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -23,
    "LOC_Y": 252,
    "GAME_DATE": 20100407,
    "Season": "2009-2010",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480823704985499338",
    "name": "The 2974 Collection #0151",
    "imageUrl": "https://arweave.net/EKc0ryO3r4-cqnJjcutvjcXgJGN0tMSK3Fmorb9xutQ?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2010,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 152,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 209,
    "LOC_Y": 159,
    "GAME_DATE": 20100407,
    "Season": "2009-2010",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508786160605319917",
    "name": "The 2974 Collection #0152",
    "imageUrl": "https://arweave.net/9C4ldOUPFIMMtf0SezOsPXBzD439LAbbSHGIgzwrVw0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2010,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 153,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 231,
    "LOC_Y": 30,
    "GAME_DATE": 20100407,
    "Season": "2009-2010",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388675396073933754",
    "name": "The 2974 Collection #0153",
    "imageUrl": "https://arweave.net/5bnv6LXcDGD0eJ2GgZjnIsxKIyrxr5X35A5g3wCxDfo?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2010,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 154,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -224,
    "LOC_Y": 15,
    "GAME_DATE": 20100410,
    "Season": "2009-2010",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490244247275719406",
    "name": "The 2974 Collection #0154",
    "imageUrl": "https://arweave.net/4_63qUFOfwBxND73j8N3zjFUeNEg9WO5E6uE6bcIRdU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 155,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 193,
    "LOC_Y": 172,
    "GAME_DATE": 20100410,
    "Season": "2009-2010",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536801248207443098",
    "name": "The 2974 Collection #0155",
    "imageUrl": "https://arweave.net/O0Rg9WzvDKceoh2czjq6RmR3vz8YD-6SAbW8a1ihLuc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 156,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 4,
    "GAME_DATE": 20100410,
    "Season": "2009-2010",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/389562620822308304",
    "name": "The 2974 Collection #0156",
    "imageUrl": "https://arweave.net/92kqtVktoyacwfe3WZUyhpREboE481Httgho5po6W9U?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 157,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 223,
    "LOC_Y": 110,
    "GAME_DATE": 20100410,
    "Season": "2009-2010",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/414353822399408377",
    "name": "The 2974 Collection #0157",
    "imageUrl": "https://arweave.net/BwRP8iZL0zrd706etBaVJ4tAFfYU1xDel4EF8kgRz7k?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 158,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": -2,
    "GAME_DATE": 20100410,
    "Season": "2009-2010",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552761690782713167",
    "name": "The 2974 Collection #0158",
    "imageUrl": "https://arweave.net/gPQRURNx443imjAgJp0uZcfu2a_KH95fNuAIv2TW4Rs?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 159,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -106,
    "LOC_Y": 260,
    "GAME_DATE": 20100411,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548231448539717654",
    "name": "The 2974 Collection #0159",
    "imageUrl": "https://arweave.net/Eyy67czdD3cspm2LFmRxYFGEi1PqeZJgvu65VKDfffQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 160,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -139,
    "LOC_Y": 224,
    "GAME_DATE": 20100411,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551299344948255272",
    "name": "The 2974 Collection #0160",
    "imageUrl": "https://arweave.net/K7e1Va8e6nw5humViNpLnWUuUjv3pM69T8QB7DUsP8A?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 161,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 201,
    "LOC_Y": 160,
    "GAME_DATE": 20100411,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/377475750665471841",
    "name": "The 2974 Collection #0161",
    "imageUrl": "https://arweave.net/kafYm_8xWVeWkvsrcZIUtSKCZUG-v0cFNTE2PuKSyZ8?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 162,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 192,
    "LOC_Y": 203,
    "GAME_DATE": 20100413,
    "Season": "2009-2010",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503275810220682933",
    "name": "The 2974 Collection #0162",
    "imageUrl": "https://arweave.net/vxLVAXN6DhbDJJ1tS2nqbB2w9iwdojUDxoWOm2fSwf8?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2010,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 163,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 163,
    "LOC_Y": 201,
    "GAME_DATE": 20100414,
    "Season": "2009-2010",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/383889327688021935",
    "name": "The 2974 Collection #0163",
    "imageUrl": "https://arweave.net/Jg6_G0uBmgOAlTkl35lFg52H2m3lZ6EfDvJ-qBdoS6s?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2010,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 164,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 187,
    "LOC_Y": 170,
    "GAME_DATE": 20100414,
    "Season": "2009-2010",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362187777006185497",
    "name": "The 2974 Collection #0164",
    "imageUrl": "https://arweave.net/cyEIarMGnKPzcvXq9T5TsRCi7Ce0MKw5ASaHFwUOh4A?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2010,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 165,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -127,
    "LOC_Y": 216,
    "GAME_DATE": 20100414,
    "Season": "2009-2010",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/545410041627780066",
    "name": "The 2974 Collection #0165",
    "imageUrl": "https://arweave.net/L50jlSUw9hvymoF81cojTYy5j7apsp3KFaz0GMbnh-E?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2010,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 166,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -49,
    "LOC_Y": 242,
    "GAME_DATE": 20100414,
    "Season": "2009-2010",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/460151706943887561",
    "name": "The 2974 Collection #0166",
    "imageUrl": "https://arweave.net/PZ6KG4NG-hW1683oLguMLB93UD8hRfcEX7w5NQfokGg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2010,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 167,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -215,
    "LOC_Y": 143,
    "GAME_DATE": 20101027,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411239183438814717",
    "name": "The 2974 Collection #0167",
    "imageUrl": "https://arweave.net/_e5MvCxtMDBuKbWDsJtjDeInc6kgdoUFUFi2uiccNnE?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2010,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 168,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 166,
    "LOC_Y": 217,
    "GAME_DATE": 20101027,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/376637143618956868",
    "name": "The 2974 Collection #0168",
    "imageUrl": "https://arweave.net/hAnKyenpeOlMIBh4nrDO3a-RUWBJsqxgxAmHDTrPuyY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2010,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 169,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 201,
    "LOC_Y": 194,
    "GAME_DATE": 20101027,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/570263211853348227",
    "name": "The 2974 Collection #0169",
    "imageUrl": "https://arweave.net/wdsU5zYSwRf9ToHE_rTChTDtrBBbEIuhm5yy0slnYaA?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2010,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 170,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -142,
    "LOC_Y": 231,
    "GAME_DATE": 20101029,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335471827151040574",
    "name": "The 2974 Collection #0170",
    "imageUrl": "https://arweave.net/vacTcVNfOaLMh0LDkXNEDUnWfPidhmEhJLmjUfLxsHs?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 10,
    "Day": 29,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 171,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 42,
    "LOC_Y": 255,
    "GAME_DATE": 20101105,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/372238807508775106",
    "name": "The 2974 Collection #0171",
    "imageUrl": "https://arweave.net/nGQfX0NS1yIjOgopto01-tOxWCkx7CTMQtFtnYJinlc?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2010,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 172,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -213,
    "LOC_Y": 113,
    "GAME_DATE": 20101108,
    "Season": "2010-2011",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327616317284770647",
    "name": "The 2974 Collection #0172",
    "imageUrl": "https://arweave.net/4TLOx1PZ5K7kTneW41I_LzvSYc1r9WWkPBHcOwLFwrc?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 173,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 1,
    "GAME_DATE": 20101108,
    "Season": "2010-2011",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474705050744883046",
    "name": "The 2974 Collection #0173",
    "imageUrl": "https://arweave.net/FwGc8vcpebhnURD2A91L5qafx4Akqgsmx1fN1q1nFsY?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2010,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 174,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 108,
    "LOC_Y": 225,
    "GAME_DATE": 20101110,
    "Season": "2010-2011",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/409181772350765571",
    "name": "The 2974 Collection #0174",
    "imageUrl": "https://arweave.net/jSoyKVzIy3o-SSc_gOxdDZnRzDIRSmfhDPn3I6yY95Y?ext=png",
    "Opposing Team City": "New York",
    "Year": 2010,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 175,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 0,
    "GAME_DATE": 20101111,
    "Season": "2010-2011",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418339008266694911",
    "name": "The 2974 Collection #0175",
    "imageUrl": "https://arweave.net/tSlTFD3W3k_ozeURv0vCCSMShWLo-3cPODOh2i6gWeI?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2010,
    "Month": 11,
    "Day": 11,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 176,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 1,
    "LOC_Y": 265,
    "GAME_DATE": 20101111,
    "Season": "2010-2011",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/453145715669210544",
    "name": "The 2974 Collection #0176",
    "imageUrl": "https://arweave.net/l0Xs2FuwlK-vynBtcuDkvN4ZgEayMGvWaUwFM8oZq_8?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2010,
    "Month": 11,
    "Day": 11,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 177,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -229,
    "LOC_Y": 15,
    "GAME_DATE": 20101115,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411979186266215951",
    "name": "The 2974 Collection #0177",
    "imageUrl": "https://arweave.net/FyScUUJ8zRd_w-xZChsVPfV-MY1p8Xf5O57bUnj5D28?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2010,
    "Month": 11,
    "Day": 15,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 178,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -220,
    "LOC_Y": 118,
    "GAME_DATE": 20101115,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/507614894265381538",
    "name": "The 2974 Collection #0178",
    "imageUrl": "https://arweave.net/U96H8EP5uGR5ja4_NjcgcsrveLKxuKIHM9TJgWqz9oE?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2010,
    "Month": 11,
    "Day": 15,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 179,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -117,
    "LOC_Y": 247,
    "GAME_DATE": 20101119,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361399747127475368",
    "name": "The 2974 Collection #0179",
    "imageUrl": "https://arweave.net/h23-oTpq0X_s1MK9dBxRDhoX7vlcgDSBuQXORR5pvog?ext=png",
    "Opposing Team City": "New York",
    "Year": 2010,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 180,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 6,
    "LOC_Y": 258,
    "GAME_DATE": 20101119,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548825028212801868",
    "name": "The 2974 Collection #0180",
    "imageUrl": "https://arweave.net/dyH5eYE4Z_nwmS4fyS7RaM3cMhf4bWQ02z7ThCSwGMo?ext=png",
    "Opposing Team City": "New York",
    "Year": 2010,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 181,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 173,
    "LOC_Y": 195,
    "GAME_DATE": 20101119,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422700014206822727",
    "name": "The 2974 Collection #0181",
    "imageUrl": "https://arweave.net/TQgxdUPccFqeSnkt6DAdKZXrLemeC83GqdwwZxD3y7I?ext=png",
    "Opposing Team City": "New York",
    "Year": 2010,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 182,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -60,
    "LOC_Y": 249,
    "GAME_DATE": 20101121,
    "Season": "2010-2011",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379532030343668809",
    "name": "The 2974 Collection #0182",
    "imageUrl": "https://arweave.net/QytejO_hCCFgC9tDvYC3f_j-_5_lxkaY-Nq8qMWvzvo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2010,
    "Month": 11,
    "Day": 21,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 183,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -229,
    "LOC_Y": 1,
    "GAME_DATE": 20101122,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518546291197634182",
    "name": "The 2974 Collection #0183",
    "imageUrl": "https://arweave.net/ugoEKIVHZQCZD_Le7GNfBLSrw0Ra0Jpb0qpBhQgb01M?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2010,
    "Month": 11,
    "Day": 22,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 184,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 0,
    "GAME_DATE": 20101126,
    "Season": "2010-2011",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360601716715660332",
    "name": "The 2974 Collection #0184",
    "imageUrl": "https://arweave.net/XZBDXfkYfdSO5DJvdQMErjlDQHyW7l1N8mHh56zLgEI?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2010,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 185,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 58,
    "LOC_Y": 238,
    "GAME_DATE": 20101126,
    "Season": "2010-2011",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/529952689558079434",
    "name": "The 2974 Collection #0185",
    "imageUrl": "https://arweave.net/wCxK-_hAS8fuabjHI1jisXY044JHDE77EuklU4RoZEY?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2010,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 186,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 209,
    "LOC_Y": 132,
    "GAME_DATE": 20101126,
    "Season": "2010-2011",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446574094287850269",
    "name": "The 2974 Collection #0186",
    "imageUrl": "https://arweave.net/i1Jmj_Z-JHxgkDV7Ftwg3KJHErNWXpsDQygfep2yzmQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2010,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 187,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -171,
    "LOC_Y": 190,
    "GAME_DATE": 20101126,
    "Season": "2010-2011",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503571058066956597",
    "name": "The 2974 Collection #0187",
    "imageUrl": "https://arweave.net/nHFCA6ZkFB6IPG8l-CfWgt7go4zYNSwcuOu1dtYTiy4?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2010,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 188,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 181,
    "LOC_Y": 170,
    "GAME_DATE": 20101127,
    "Season": "2010-2011",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/574843772066048072",
    "name": "The 2974 Collection #0188",
    "imageUrl": "https://arweave.net/poa2k5sbltUUnMeVJqVFUl9MXs0aYEvRX1575IyNyGg?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2010,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 189,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -78,
    "LOC_Y": 238,
    "GAME_DATE": 20101127,
    "Season": "2010-2011",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418653714785604524",
    "name": "The 2974 Collection #0189",
    "imageUrl": "https://arweave.net/Lh1m2DwTgpyBhCjLdT3I7nZn-tKV57JCQXGPrAdWi9E?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2010,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 190,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 0,
    "LOC_Y": 263,
    "GAME_DATE": 20101130,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400150083876303898",
    "name": "The 2974 Collection #0190",
    "imageUrl": "https://arweave.net/bw-ehFD0mu6obRXT_0YcMkI8sLJp5vdDK2xJOTWlEb0?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2010,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 191,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -182,
    "LOC_Y": 228,
    "GAME_DATE": 20101130,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321539165460909984",
    "name": "The 2974 Collection #0191",
    "imageUrl": "https://arweave.net/FHab1U8pNNBccfCXiXcuS8ZwcEgBbBg5Mhr_pNHchFI?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2010,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 192,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -147,
    "LOC_Y": 206,
    "GAME_DATE": 20101130,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522923933614578430",
    "name": "The 2974 Collection #0192",
    "imageUrl": "https://arweave.net/mJGM3vBX9kt4ijUzBtxt4QwKmsiLue77rUmWMB8Gjbw?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2010,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 193,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 92,
    "LOC_Y": 241,
    "GAME_DATE": 20101202,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411050410992708133",
    "name": "The 2974 Collection #0193",
    "imageUrl": "https://arweave.net/jyJBbM-A0eGbSfZMOwIRC5XceJ7m1aj9t_eggZOsGeA?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2010,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 194,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -225,
    "LOC_Y": 12,
    "GAME_DATE": 20101205,
    "Season": "2010-2011",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/530744242329436894",
    "name": "The 2974 Collection #0194",
    "imageUrl": "https://arweave.net/pf53gi7f8U5ZpQV5HcApztfx7W5a0HmFWLf8Pa-GTJ0?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 195,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 168,
    "LOC_Y": 186,
    "GAME_DATE": 20101205,
    "Season": "2010-2011",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/569897434181577471",
    "name": "The 2974 Collection #0195",
    "imageUrl": "https://arweave.net/FZpYHp1ytCw2WuaE5-rexHiFhIJS6Rah9eZOyRZv4j8?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 196,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 226,
    "LOC_Y": 47,
    "GAME_DATE": 20101205,
    "Season": "2010-2011",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/413646223534351736",
    "name": "The 2974 Collection #0196",
    "imageUrl": "https://arweave.net/DfPys4oGe5yKO9rZQ7QMWVCUpTxJ__wGfkFWSGrHTZo?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 197,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -179,
    "LOC_Y": 167,
    "GAME_DATE": 20101205,
    "Season": "2010-2011",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/488352752993616785",
    "name": "The 2974 Collection #0197",
    "imageUrl": "https://arweave.net/gdg2_A2h1WK2t-wc7_H6YSJtOWJtIwpAOBaiahV7L-U?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2010,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 198,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 151,
    "LOC_Y": 200,
    "GAME_DATE": 20101207,
    "Season": "2010-2011",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391429519011413257",
    "name": "The 2974 Collection #0198",
    "imageUrl": "https://arweave.net/jexKodgFkaXdgzzqrXVCNCs5qOf8f7YKLHdCnscC5bU?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2010,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 199,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -221,
    "LOC_Y": 115,
    "GAME_DATE": 20101207,
    "Season": "2010-2011",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346560495285218540",
    "name": "The 2974 Collection #0199",
    "imageUrl": "https://arweave.net/fh5srbUSlrDWLiBebKjrcct2o09RBeCTNck6MxZuGO4?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2010,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 200,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 130,
    "LOC_Y": 206,
    "GAME_DATE": 20101207,
    "Season": "2010-2011",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/494652156141006819",
    "name": "The 2974 Collection #0200",
    "imageUrl": "https://arweave.net/sgOgQPsX9oDsy8UAWQkyDYaH8x80HXzqRP1HvErQVAQ?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2010,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 201,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -78,
    "LOC_Y": 247,
    "GAME_DATE": 20101227,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/314583054512355886",
    "name": "The 2974 Collection #0201",
    "imageUrl": "https://arweave.net/NEiwsXrjCn0rg2RVljy6USExIhoikJCVpuP9oxbJtt4?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2010,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 202,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 241,
    "LOC_Y": -2,
    "GAME_DATE": 20101227,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326020321544463772",
    "name": "The 2974 Collection #0202",
    "imageUrl": "https://arweave.net/sXFt9YWF8B_CTmT5kplQ-zHycJS-oAX-oukdFEN4U80?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2010,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 203,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -2,
    "LOC_Y": 252,
    "GAME_DATE": 20101227,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556347295703266602",
    "name": "The 2974 Collection #0203",
    "imageUrl": "https://arweave.net/eIpvMBtxXOuG-nbVdYm5ah_KwvhOWtmUfWC2ZBTSRxQ?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2010,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 204,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 239,
    "LOC_Y": 4,
    "GAME_DATE": 20101227,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/340420255536859648",
    "name": "The 2974 Collection #0204",
    "imageUrl": "https://arweave.net/E40ggQuGVC4SX_WvH-MIC6lRC98te4NrSEbUged9SNo?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2010,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 205,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 171,
    "LOC_Y": 190,
    "GAME_DATE": 20101231,
    "Season": "2010-2011",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/528800410502378299",
    "name": "The 2974 Collection #0205",
    "imageUrl": "https://arweave.net/6V8RW_Nyra7wDYERNBmcqOuc3l4hazwtbpD2POwzM5o?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "New Year's Eve",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 206,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -92,
    "LOC_Y": 238,
    "GAME_DATE": 20101231,
    "Season": "2010-2011",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/298219091990729849",
    "name": "The 2974 Collection #0206",
    "imageUrl": "https://arweave.net/WMHksWUs2mHxMRGHX9Qey32tEuuaHy9A6_tx32y3vcg?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "New Year's Eve",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 207,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -90,
    "LOC_Y": 246,
    "GAME_DATE": 20101231,
    "Season": "2010-2011",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/298251000499978984",
    "name": "The 2974 Collection #0207",
    "imageUrl": "https://arweave.net/8jgGKXGpJ6nJWShN4AQSsjR8GaZCF3iygYROO0Oo0KE?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "New Year's Eve",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 208,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 220,
    "LOC_Y": 116,
    "GAME_DATE": 20101231,
    "Season": "2010-2011",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302632192097636666",
    "name": "The 2974 Collection #0208",
    "imageUrl": "https://arweave.net/TPon4SnX_o9FeKGTyRCSVR7uwKGpX4mvi-B0gU0TBbA?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2010,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "New Year's Eve",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 209,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 36,
    "GAME_DATE": 20110101,
    "Season": "2010-2011",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565314194692635259",
    "name": "The 2974 Collection #0209",
    "imageUrl": "https://arweave.net/Z2VRKslNhKcsWT325TXDOQNtrvPqNtPgB8TT-e3fhU4?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2011,
    "Month": 1,
    "Day": 1,
    "3-Pointers made in the game": 1,
    "Special Moment": "New Year's Day",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 210,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -196,
    "LOC_Y": 168,
    "GAME_DATE": 20110103,
    "Season": "2010-2011",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522287863070746767",
    "name": "The 2974 Collection #0210",
    "imageUrl": "https://arweave.net/t3EQdCPmehqsIX8cavKN8EZk244NgVj3RbVX8eO4qfs?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2011,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 211,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 23,
    "GAME_DATE": 20110103,
    "Season": "2010-2011",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572442787201518633",
    "name": "The 2974 Collection #0211",
    "imageUrl": "https://arweave.net/HpIbo1Pmuu9PDpnq1WZCNA75UkJkB_9ZGrYItxHoUIQ?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2011,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 212,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 0,
    "GAME_DATE": 20110103,
    "Season": "2010-2011",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/557378270968036519",
    "name": "The 2974 Collection #0212",
    "imageUrl": "https://arweave.net/m_jEoXolpNyNt1Sr7hZxjJKKHWF4csO7k1kQC5cdipk?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2011,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 213,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -243,
    "LOC_Y": 4,
    "GAME_DATE": 20110105,
    "Season": "2010-2011",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/534034349447599376",
    "name": "The 2974 Collection #0213",
    "imageUrl": "https://arweave.net/IudHIqM_bOeDNiJPPCGv81xwozEBiX8802pb2p1-npo?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2011,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 214,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -109,
    "LOC_Y": 235,
    "GAME_DATE": 20110107,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/332675331284085171",
    "name": "The 2974 Collection #0214",
    "imageUrl": "https://arweave.net/wum3_vuBNjulWs6_gdY_JscOdXdwM-iMEQB1BuhZ6xA?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2011,
    "Month": 1,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 215,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -84,
    "LOC_Y": 246,
    "GAME_DATE": 20110107,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/414750652178026387",
    "name": "The 2974 Collection #0215",
    "imageUrl": "https://arweave.net/II1W2SWQO271kHfQTMMbG_RCGhIzhsf2IZXh8RXqJVY?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2011,
    "Month": 1,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 216,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 239,
    "LOC_Y": 28,
    "GAME_DATE": 20110107,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/408281086906828164",
    "name": "The 2974 Collection #0216",
    "imageUrl": "https://arweave.net/G4M72mgpwONW_6kwO6T3CpLQQN8MpuUOBe7XrZbsWtE?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2011,
    "Month": 1,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 217,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -123,
    "LOC_Y": 217,
    "GAME_DATE": 20110112,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353756363902482507",
    "name": "The 2974 Collection #0217",
    "imageUrl": "https://arweave.net/zxc_rpA22hIQTG-x4KoBbVHgJsiN2G3eXJKaniAnN70?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 1,
    "Day": 12,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 218,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 244,
    "LOC_Y": 12,
    "GAME_DATE": 20110114,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301197126171275046",
    "name": "The 2974 Collection #0218",
    "imageUrl": "https://arweave.net/9HymNbZprew9vZvHgop6Ee-qAh_X6GorR7R56rstITc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 219,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -27,
    "LOC_Y": 254,
    "GAME_DATE": 20110114,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/487938422806779936",
    "name": "The 2974 Collection #0219",
    "imageUrl": "https://arweave.net/RP_ZWzJJiRHY4ncUiWCPi6Dn1s7wQqxdRX8ERj6R9yo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 220,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -171,
    "LOC_Y": 187,
    "GAME_DATE": 20110114,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328311815067355687",
    "name": "The 2974 Collection #0220",
    "imageUrl": "https://arweave.net/XJomKu64YdxXpB5Zi8togjpReRxsnWggfObRHFhC3I8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 221,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 241,
    "LOC_Y": 3,
    "GAME_DATE": 20110114,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/288401382604372415",
    "name": "The 2974 Collection #0221",
    "imageUrl": "https://arweave.net/EY2-wrud3Nkfdqoi1W5VuW385clcPIbLFK7vUOxKMag?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 222,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -131,
    "LOC_Y": 214,
    "GAME_DATE": 20110114,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/488038692141344525",
    "name": "The 2974 Collection #0222",
    "imageUrl": "https://arweave.net/2YXXDAt35-mXHpX5GNSoSsYqZfeabZ5cKD6A3oz3zCc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 223,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 18,
    "LOC_Y": 261,
    "GAME_DATE": 20110117,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "NJN",
    "Opposing Team": "NJN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369866452622450564",
    "name": "The 2974 Collection #0223",
    "imageUrl": "https://arweave.net/ccFoUZAU4C4KwaJ_MKMjgM5CoLqo2F7jKuIKeUDwvHo?ext=png",
    "Opposing Team City": "New Jersey",
    "Year": 2011,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 224,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 174,
    "LOC_Y": 179,
    "GAME_DATE": 20110117,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "NJN",
    "Opposing Team": "NJN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/408682993062262085",
    "name": "The 2974 Collection #0224",
    "imageUrl": "https://arweave.net/h4UVAtOONPPh-NZSOnuxKRM9vbshReGkVp1g6SooE-0?ext=png",
    "Opposing Team City": "New Jersey",
    "Year": 2011,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 225,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -149,
    "LOC_Y": 201,
    "GAME_DATE": 20110121,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296944473304295784",
    "name": "The 2974 Collection #0225",
    "imageUrl": "https://arweave.net/QYq15UiCpXTAvu0oX3nCOpmFVMap1csA92HZW_pOaTE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 226,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": 42,
    "GAME_DATE": 20110121,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508207408866572254",
    "name": "The 2974 Collection #0226",
    "imageUrl": "https://arweave.net/pDdXIM13lpH5A1vOSeQo7jAMfqXL5Z86_KQQlBhufcE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 227,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 73,
    "LOC_Y": 252,
    "GAME_DATE": 20110121,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421637432858334953",
    "name": "The 2974 Collection #0227",
    "imageUrl": "https://arweave.net/mVBIsw9H3oApZH8HIGbBannrd0rXEsDey3RnSg2E6VE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 228,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -180,
    "LOC_Y": 187,
    "GAME_DATE": 20110122,
    "Season": "2010-2011",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550549487761879952",
    "name": "The 2974 Collection #0228",
    "imageUrl": "https://arweave.net/5qm7C-uEXNHdVACYUsZCjszVWnePhEhgIsqLeqVgG8o?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 229,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -146,
    "LOC_Y": 227,
    "GAME_DATE": 20110122,
    "Season": "2010-2011",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/311969148443617109",
    "name": "The 2974 Collection #0229",
    "imageUrl": "https://arweave.net/dPbWWA6FHtW7aFHJBPe5LIdleLyn_jRSQt_qGeALtto?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 230,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 78,
    "LOC_Y": 247,
    "GAME_DATE": 20110122,
    "Season": "2010-2011",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335636784203084872",
    "name": "The 2974 Collection #0230",
    "imageUrl": "https://arweave.net/WmIk-THmd-asK8nC8dGKdLu9ftjf_hLylExUHjZUA28?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 231,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 12,
    "LOC_Y": 260,
    "GAME_DATE": 20110124,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368787910951213843",
    "name": "The 2974 Collection #0231",
    "imageUrl": "https://arweave.net/ai_CsbDCMcGKP4bwgko0hxqTlt2kN8i-sIwnRiecB04?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2011,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 232,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -228,
    "LOC_Y": 31,
    "GAME_DATE": 20110124,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428401335251941945",
    "name": "The 2974 Collection #0232",
    "imageUrl": "https://arweave.net/WdZOP8zE8a8yIJmaUX0JQcTFfCf-bxLAcRDhAVuNhq0?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2011,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 233,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -166,
    "LOC_Y": 183,
    "GAME_DATE": 20110126,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412391434963743817",
    "name": "The 2974 Collection #0233",
    "imageUrl": "https://arweave.net/ZLQXiRhrRNtLJqlfjAaxm50dyWZ5aVgh7O3nw7cciqc?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2011,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 234,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 94,
    "LOC_Y": 242,
    "GAME_DATE": 20110128,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/288562210105973421",
    "name": "The 2974 Collection #0234",
    "imageUrl": "https://arweave.net/QnuBfvcER1q8_EY65tFv_kAMGtQ2GIAWzu2rhwAMVA4?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2011,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 235,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 6,
    "GAME_DATE": 20110128,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/414143304143986358",
    "name": "The 2974 Collection #0235",
    "imageUrl": "https://arweave.net/TfmRKyUFrUR-c68zXtaPCTlcLYqXY0mRDJr2P258Vqk?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2011,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 236,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 177,
    "LOC_Y": 214,
    "GAME_DATE": 20110128,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499084629825652854",
    "name": "The 2974 Collection #0236",
    "imageUrl": "https://arweave.net/f5dE2kizqM00q0ER_tUfxHw3IcbeqDy0_dfS38hMvow?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2011,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 237,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -105,
    "LOC_Y": 241,
    "GAME_DATE": 20110128,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390890692407998862",
    "name": "The 2974 Collection #0237",
    "imageUrl": "https://arweave.net/wU4WdMtG8SmqnWRr3et7sFkE24nBJvn0OqHxkkEvYDU?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2011,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 238,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 23,
    "LOC_Y": 263,
    "GAME_DATE": 20110130,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/370146119852345421",
    "name": "The 2974 Collection #0238",
    "imageUrl": "https://arweave.net/21g5YXqjuPqsbrA4tQWusj_ucHJpmawro2fg1yKvV4A?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2011,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 239,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 116,
    "LOC_Y": 227,
    "GAME_DATE": 20110130,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/569834774188126120",
    "name": "The 2974 Collection #0239",
    "imageUrl": "https://arweave.net/Yox0ZLKs4_UehlpYbChmVFmO_7LxFC-EDwv6y10onvk?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2011,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 240,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 78,
    "LOC_Y": 246,
    "GAME_DATE": 20110130,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428488181299332333",
    "name": "The 2974 Collection #0240",
    "imageUrl": "https://arweave.net/RX6g4xPmjCx6-wCs03O1ygYh9Oyq-Mz0ucSapzvOPd0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2011,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 241,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -122,
    "LOC_Y": 228,
    "GAME_DATE": 20110203,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328831030351895566",
    "name": "The 2974 Collection #0241",
    "imageUrl": "https://arweave.net/wR9b-iSqERD0d0jkQv6FNiRo5YqlDVS7qTAqLUu6lhU?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2011,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 242,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -97,
    "LOC_Y": 239,
    "GAME_DATE": 20110203,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510651738288888331",
    "name": "The 2974 Collection #0242",
    "imageUrl": "https://arweave.net/fL93QGaDiBW-bRtKZbHSA_b5QMwN-u9pOjeCWIvaFJk?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2011,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 243,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 17,
    "GAME_DATE": 20110205,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357759382540862437",
    "name": "The 2974 Collection #0243",
    "imageUrl": "https://arweave.net/rkCtBMU_U1fyZEneYQ16H5a2-kVJYG5dkljTKXkPu4Q?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2011,
    "Month": 2,
    "Day": 5,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 244,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -175,
    "LOC_Y": 173,
    "GAME_DATE": 20110205,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/560140492094886165",
    "name": "The 2974 Collection #0244",
    "imageUrl": "https://arweave.net/Uv6ZrVt9d9Pq06QD03J2VDGM7_KiIK5q4M4g1h265ts?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2011,
    "Month": 2,
    "Day": 5,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 245,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 160,
    "LOC_Y": 201,
    "GAME_DATE": 20110209,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364136060989248256",
    "name": "The 2974 Collection #0245",
    "imageUrl": "https://arweave.net/tmiKePXMGkhtLItOsthsl-D_Gnb_hm79t2qTTjxM39s?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2011,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 246,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 168,
    "LOC_Y": 190,
    "GAME_DATE": 20110210,
    "Season": "2010-2011",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561950604244024554",
    "name": "The 2974 Collection #0246",
    "imageUrl": "https://arweave.net/86Xxc1xYE1BACu3C4YWy8yx97cP-lGsJede5HsN4nnw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2011,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 247,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 160,
    "LOC_Y": 186,
    "GAME_DATE": 20110210,
    "Season": "2010-2011",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502582091173525679",
    "name": "The 2974 Collection #0247",
    "imageUrl": "https://arweave.net/8OlgRwKyWMny0bKl5mkYTiq-2DoF-8zoSTu3rllA-wU?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2011,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 248,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 7,
    "GAME_DATE": 20110213,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/345571691704803336",
    "name": "The 2974 Collection #0248",
    "imageUrl": "https://arweave.net/1xr82rK-Qi41fY1NsxGcxxSQ3KcAEczwsSWcrsQa7TA?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2011,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 249,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 20,
    "LOC_Y": 269,
    "GAME_DATE": 20110213,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/532922722627062917",
    "name": "The 2974 Collection #0249",
    "imageUrl": "https://arweave.net/D5vLBU0E_ywZQSoYwYZ1AS8OqpZyTyIveGW1Sg9fPqM?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2011,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 250,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -201,
    "LOC_Y": 153,
    "GAME_DATE": 20110215,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456535849042208104",
    "name": "The 2974 Collection #0250",
    "imageUrl": "https://arweave.net/6BB6sP9pJTKXf26O1-XL2LA9N1x33PBFPGGdKR98U-s?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2011,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 251,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 233,
    "LOC_Y": 113,
    "GAME_DATE": 20110215,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468522286968896144",
    "name": "The 2974 Collection #0251",
    "imageUrl": "https://arweave.net/G-taj3-t90_XmornunqK5wttPcH8_VMNTRjgSYjcuHo?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2011,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 252,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 237,
    "LOC_Y": 12,
    "GAME_DATE": 20110215,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/413849797225407846",
    "name": "The 2974 Collection #0252",
    "imageUrl": "https://arweave.net/CasCDkGPVRoUteAMYbZCdTtUkJ39ElKRICOMBGY7i2Y?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2011,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 253,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 237,
    "LOC_Y": 47,
    "GAME_DATE": 20110222,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392869243325718050",
    "name": "The 2974 Collection #0253",
    "imageUrl": "https://arweave.net/Yy0Wzr8Iw2_k-4VctFVc_prMUaqiVYjMOeUkWnpn5DM?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2011,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 254,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 110,
    "LOC_Y": 231,
    "GAME_DATE": 20110227,
    "Season": "2010-2011",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/394155962600351229",
    "name": "The 2974 Collection #0254",
    "imageUrl": "https://arweave.net/vdwbjEJNUZNp32Op5KKRk8jJWVDI3K4SUBYCakYcmnk?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2011,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 255,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -239,
    "LOC_Y": 25,
    "GAME_DATE": 20110227,
    "Season": "2010-2011",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456718075168458789",
    "name": "The 2974 Collection #0255",
    "imageUrl": "https://arweave.net/2Pv2SSXSjhjxFtPQcRqRndTEe_F6Beet0W5UZz0RqNM?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2011,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 256,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -119,
    "LOC_Y": 209,
    "GAME_DATE": 20110227,
    "Season": "2010-2011",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385352441402058987",
    "name": "The 2974 Collection #0256",
    "imageUrl": "https://arweave.net/JhW3Poejsu5n2Elznrp_YME25L8x2Dr1T-F8R0i5xmo?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2011,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 257,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -119,
    "LOC_Y": 213,
    "GAME_DATE": 20110227,
    "Season": "2010-2011",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566841649470952520",
    "name": "The 2974 Collection #0257",
    "imageUrl": "https://arweave.net/HXwJf_0ph-4jcvtECGl4evj2L1FDC2zlXOKO25mdjfQ?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2011,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 258,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -120,
    "LOC_Y": 219,
    "GAME_DATE": 20110227,
    "Season": "2010-2011",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482357895360657821",
    "name": "The 2974 Collection #0258",
    "imageUrl": "https://arweave.net/kSmcGlKLuhqseVW0czfBhNzta69JrXOSDV7mqLNo0Xc?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2011,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 259,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 114,
    "LOC_Y": 241,
    "GAME_DATE": 20110301,
    "Season": "2010-2011",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349179805498748787",
    "name": "The 2974 Collection #0259",
    "imageUrl": "https://arweave.net/WGF_VYHrVKQPGnvnpIef4pNR4YL4i2FnSnwRsMZZjbc?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2011,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 260,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 228,
    "LOC_Y": 131,
    "GAME_DATE": 20110301,
    "Season": "2010-2011",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565103616860033203",
    "name": "The 2974 Collection #0260",
    "imageUrl": "https://arweave.net/4fwQoRPzWhaNYnYUF7Zin_-MX8p_CBd5GW13m5512ZE?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2011,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 261,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 124,
    "LOC_Y": 225,
    "GAME_DATE": 20110301,
    "Season": "2010-2011",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/454298014066841653",
    "name": "The 2974 Collection #0261",
    "imageUrl": "https://arweave.net/MDxzvWdxzVJ6xzDLg9LZrYJ-Sp37NVGfVnoZx08J2Po?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2011,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 262,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 245,
    "LOC_Y": 1,
    "GAME_DATE": 20110301,
    "Season": "2010-2011",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403520604146485702",
    "name": "The 2974 Collection #0262",
    "imageUrl": "https://arweave.net/azrzOCGHRESVlakMxESsxpId2Tv5k0uH7dOWKbvIYhU?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2011,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 263,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -224,
    "LOC_Y": 55,
    "GAME_DATE": 20110302,
    "Season": "2010-2011",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322430982516793668",
    "name": "The 2974 Collection #0263",
    "imageUrl": "https://arweave.net/nHpgIjEyq7TkVxaZ9Qg_yqKZWTjAB4w6G_zLInoXQnE?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2011,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 264,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 108,
    "LOC_Y": 242,
    "GAME_DATE": 20110302,
    "Season": "2010-2011",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356300305234146535",
    "name": "The 2974 Collection #0264",
    "imageUrl": "https://arweave.net/-qD_1HSZfH04QL-eBg0RzXNKUdjttMi9y6BAj1HjsiE?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2011,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 265,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 168,
    "LOC_Y": 194,
    "GAME_DATE": 20110302,
    "Season": "2010-2011",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450356986755320104",
    "name": "The 2974 Collection #0265",
    "imageUrl": "https://arweave.net/IJzHC5TtOULVMaDJwShasTIlbs1kLIP2D6cl2YaCoZk?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2011,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 266,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 4,
    "LOC_Y": 244,
    "GAME_DATE": 20110304,
    "Season": "2010-2011",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356964599213979774",
    "name": "The 2974 Collection #0266",
    "imageUrl": "https://arweave.net/73GcgbHdKuQDg2LQ7edstLvWuOmd0gBKRYHN4gExgdE?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2011,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 267,
    "PERIOD": 5,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 198,
    "LOC_Y": 154,
    "GAME_DATE": 20110306,
    "Season": "2010-2011",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503602574067715784",
    "name": "The 2974 Collection #0267",
    "imageUrl": "https://arweave.net/qMBTn8nsYOV1NJmXJEBTHgnZxO-esYx_rTExaxcTBzc?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2011,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 268,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -235,
    "LOC_Y": 69,
    "GAME_DATE": 20110308,
    "Season": "2010-2011",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/306695888424897140",
    "name": "The 2974 Collection #0268",
    "imageUrl": "https://arweave.net/u2WhuXeOd088IpDuI11wfRGUsNBgeSnt6cyPi4qx_1c?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2011,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 269,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -243,
    "LOC_Y": 60,
    "GAME_DATE": 20110308,
    "Season": "2010-2011",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347742169305431102",
    "name": "The 2974 Collection #0269",
    "imageUrl": "https://arweave.net/AOXjBHtk8OGheyE5kv1Ba-3dmgu3DAZ51F25kJ8VYh4?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2011,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 270,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 20,
    "LOC_Y": 266,
    "GAME_DATE": 20110309,
    "Season": "2010-2011",
    "HTM": "NJN",
    "VTM": "GSW",
    "Opposing Team": "NJN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/425025168296334253",
    "name": "The 2974 Collection #0270",
    "imageUrl": "https://arweave.net/wf_Wbwc0L-GH8gMBl9Du-lhLZaejRfItIbges3Se8Z8?ext=png",
    "Opposing Team City": "New Jersey",
    "Year": 2011,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 271,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -224,
    "LOC_Y": -6,
    "GAME_DATE": 20110309,
    "Season": "2010-2011",
    "HTM": "NJN",
    "VTM": "GSW",
    "Opposing Team": "NJN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465733561029710070",
    "name": "The 2974 Collection #0271",
    "imageUrl": "https://arweave.net/236mmp_LCMXq0YB5timHfOhmQz6abQdCZH7H86xjkJI?ext=png",
    "Opposing Team City": "New Jersey",
    "Year": 2011,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 272,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 34,
    "GAME_DATE": 20110311,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349540648378727048",
    "name": "The 2974 Collection #0272",
    "imageUrl": "https://arweave.net/N_eW3al_myQ2dZgq7HJRuhTQj9hH72JIs0E2xzhxA_4?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2011,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 273,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 122,
    "LOC_Y": 241,
    "GAME_DATE": 20110311,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/451785524698846170",
    "name": "The 2974 Collection #0273",
    "imageUrl": "https://arweave.net/ypSkC0SGfi3KbrvmhvmpnnYzx9wDqfKKnu03nSGCtmY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2011,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 274,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 215,
    "LOC_Y": 145,
    "GAME_DATE": 20110311,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/405649892963536445",
    "name": "The 2974 Collection #0274",
    "imageUrl": "https://arweave.net/JfrhQOCE-L45dXzyqucIrjLmS0ydU9vn-GPsEH230LM?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2011,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 275,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -163,
    "LOC_Y": 203,
    "GAME_DATE": 20110311,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362423833851312659",
    "name": "The 2974 Collection #0275",
    "imageUrl": "https://arweave.net/cNeXYC60YnID59zv-aTMYhh3zCy38M2ka5gprS5lGdA?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2011,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 276,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -163,
    "LOC_Y": 198,
    "GAME_DATE": 20110313,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515278245426959685",
    "name": "The 2974 Collection #0276",
    "imageUrl": "https://arweave.net/e7zZ93KPzexDaY1doL7YdxPR6BRg9418hXiZ-qyyhxE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2011,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 277,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -23,
    "LOC_Y": 242,
    "GAME_DATE": 20110313,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384161257062277570",
    "name": "The 2974 Collection #0277",
    "imageUrl": "https://arweave.net/kbO0De3Ki7V_SgVr2bi8M91cB0o2IIqkj6KZE9txuY8?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2011,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 278,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 181,
    "LOC_Y": 184,
    "GAME_DATE": 20110313,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441333251923128405",
    "name": "The 2974 Collection #0278",
    "imageUrl": "https://arweave.net/uuxmzPh8s__4cFDVtooFOPrDPxVOIbSuEqRraKAu8Fg?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2011,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 279,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 9,
    "LOC_Y": 261,
    "GAME_DATE": 20110313,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/298266124337640292",
    "name": "The 2974 Collection #0279",
    "imageUrl": "https://arweave.net/PNUsQDIZJsrywSypUkJGg46akbwUtjDGvIN2O8FAIU4?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2011,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 280,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 22,
    "GAME_DATE": 20110314,
    "Season": "2010-2011",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/486115119693795721",
    "name": "The 2974 Collection #0280",
    "imageUrl": "https://arweave.net/7WPjl_p5QAiaijVa9h6YtwSwO3c-3vGzu8dbI14Yo8E?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 281,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -221,
    "LOC_Y": 107,
    "GAME_DATE": 20110314,
    "Season": "2010-2011",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391760738773585471",
    "name": "The 2974 Collection #0281",
    "imageUrl": "https://arweave.net/OS50Jya2-iSpqwdRzIlTrhFcetWEHBsf8GJPDJtHl3k?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 282,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -240,
    "LOC_Y": 28,
    "GAME_DATE": 20110314,
    "Season": "2010-2011",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/569825730152927289",
    "name": "The 2974 Collection #0282",
    "imageUrl": "https://arweave.net/XPgei3F0cTR_iqF-zxOo4UX8rzRz8rhc0P_tPOHhXGM?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 283,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 225,
    "LOC_Y": 48,
    "GAME_DATE": 20110314,
    "Season": "2010-2011",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458671043185328081",
    "name": "The 2974 Collection #0283",
    "imageUrl": "https://arweave.net/oJHaPjXYxrygtIGDQbZpS6D10JbzkdhxYVhFs6LkOUM?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 284,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -71,
    "LOC_Y": 250,
    "GAME_DATE": 20110314,
    "Season": "2010-2011",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421969899056416989",
    "name": "The 2974 Collection #0284",
    "imageUrl": "https://arweave.net/biWjbvzMlliJ7skuOT1DLe8TgU-51kUaSsdeqzLQRgQ?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 285,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -224,
    "LOC_Y": 22,
    "GAME_DATE": 20110316,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330801483120494565",
    "name": "The 2974 Collection #0285",
    "imageUrl": "https://arweave.net/k5ciIuP2WcrrhSJ_j_WPCShHuIPiGaaWZqsPgaJ7H5A?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2011,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 286,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -34,
    "LOC_Y": 254,
    "GAME_DATE": 20110316,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491321708593298402",
    "name": "The 2974 Collection #0286",
    "imageUrl": "https://arweave.net/uvF8p0QfJ53z4MGa4rsGJDIjuqH8bi9QK51ZwJKnx-E?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2011,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 287,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 125,
    "LOC_Y": 214,
    "GAME_DATE": 20110318,
    "Season": "2010-2011",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567466615469579326",
    "name": "The 2974 Collection #0287",
    "imageUrl": "https://arweave.net/yxMNiZd6jQ3ZlV-ohckDPY-FsxYZgdYarTekkalFTkQ?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2011,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 288,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 97,
    "LOC_Y": 228,
    "GAME_DATE": 20110318,
    "Season": "2010-2011",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/559089416446912125",
    "name": "The 2974 Collection #0288",
    "imageUrl": "https://arweave.net/-0RCfuvCJNMW3_mSr5OAky5ZHW7LOMvtr_QMJuKcZlo?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2011,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 289,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -224,
    "LOC_Y": 99,
    "GAME_DATE": 20110320,
    "Season": "2010-2011",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515716750444957967",
    "name": "The 2974 Collection #0289",
    "imageUrl": "https://arweave.net/vW_9Cd9AFELdOGy2xjhwdBdgYeyDbejIzYzBaaKtMeU?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2011,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 290,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -152,
    "LOC_Y": 201,
    "GAME_DATE": 20110321,
    "Season": "2010-2011",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319375695178739887",
    "name": "The 2974 Collection #0290",
    "imageUrl": "https://arweave.net/2T-tHQDamxYpiRr9yeKVVkKolondtLPH2Ux0H0fRJKA?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2011,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 291,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -16,
    "LOC_Y": 250,
    "GAME_DATE": 20110323,
    "Season": "2010-2011",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381860974379668531",
    "name": "The 2974 Collection #0291",
    "imageUrl": "https://arweave.net/pnu8u84LYCseQjNnj0xvQsxKNP13pYTRM6x8lwjEOIs?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2011,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 292,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -229,
    "LOC_Y": 108,
    "GAME_DATE": 20110323,
    "Season": "2010-2011",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520750447624531871",
    "name": "The 2974 Collection #0292",
    "imageUrl": "https://arweave.net/u_0TDVoxj_mUfAXPbmI7KJEzheffPeTCxINVzHhp9ic?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2011,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 293,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 6,
    "GAME_DATE": 20110325,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423466592560021269",
    "name": "The 2974 Collection #0293",
    "imageUrl": "https://arweave.net/uUD3uu_dnLeFwTOhPhXL8SYL299hmWM77ct6yZkzGKU?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2011,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 294,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -171,
    "LOC_Y": 197,
    "GAME_DATE": 20110325,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/483347052511604503",
    "name": "The 2974 Collection #0294",
    "imageUrl": "https://arweave.net/2Fy4cmeW05l8v-tj0GnScB4KCdPN4LRHBjBzE2RR1Fs?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2011,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 295,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": -10,
    "GAME_DATE": 20110325,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513815721485799316",
    "name": "The 2974 Collection #0295",
    "imageUrl": "https://arweave.net/wJSq5OkY2tpdbQYE_KIpEzGfHdUrhS0JBakp2GGNr6o?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2011,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 296,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 244,
    "LOC_Y": 0,
    "GAME_DATE": 20110325,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/340109723068913851",
    "name": "The 2974 Collection #0296",
    "imageUrl": "https://arweave.net/IQts7I77Dd1Fv6sJN0YATwNR8s2ofYQrjezSiNGouzw?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2011,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 297,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": 6,
    "GAME_DATE": 20110327,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443308879875812549",
    "name": "The 2974 Collection #0297",
    "imageUrl": "https://arweave.net/GrtQce3hLjwVoXKMW3RGotjV2BNTfMFkWLn_1cDw1o0?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2011,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 298,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -228,
    "LOC_Y": 45,
    "GAME_DATE": 20110329,
    "Season": "2010-2011",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368307051815395641",
    "name": "The 2974 Collection #0298",
    "imageUrl": "https://arweave.net/HJxUjRfn1CYWPiwU87uZmzmutU9JUqRwEGDFHpx0Lsk?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2011,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 299,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": 23,
    "GAME_DATE": 20110329,
    "Season": "2010-2011",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324062471516801162",
    "name": "The 2974 Collection #0299",
    "imageUrl": "https://arweave.net/ykA-3tZWTlgFhI8gLpS1NvLbHy-gxg493XJa14qVk0M?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2011,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 300,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 159,
    "LOC_Y": 184,
    "GAME_DATE": 20110329,
    "Season": "2010-2011",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423869808500534912",
    "name": "The 2974 Collection #0300",
    "imageUrl": "https://arweave.net/kbuTwKa0w0eZTJz0ZG2Uwov5mwqVZrQ8TV9ED1vAwNI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2011,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 301,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -224,
    "LOC_Y": 6,
    "GAME_DATE": 20110329,
    "Season": "2010-2011",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369194059758786568",
    "name": "The 2974 Collection #0301",
    "imageUrl": "https://arweave.net/LEO_hAPp8DwXzRJMq-vcOeiiZKWSi31e4nJow9FIUFY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2011,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 302,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -223,
    "LOC_Y": 22,
    "GAME_DATE": 20110329,
    "Season": "2010-2011",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/473911486957845442",
    "name": "The 2974 Collection #0302",
    "imageUrl": "https://arweave.net/uTqbqohuYUHhHGDudZEvPTDmqBNV-zFFDeiO1u_ErHw?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2011,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 303,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 170,
    "LOC_Y": 190,
    "GAME_DATE": 20110330,
    "Season": "2010-2011",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369179806313445528",
    "name": "The 2974 Collection #0303",
    "imageUrl": "https://arweave.net/Oyx4UIlFu7Ffh1PiJzpQNtnFk5eCZEV-Vt3Fi1LRH5k?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2011,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 304,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -111,
    "LOC_Y": 236,
    "GAME_DATE": 20110402,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/424824023411499615",
    "name": "The 2974 Collection #0304",
    "imageUrl": "https://arweave.net/YGxpWmlneOYccQNJYT9ZMZdFeRVWWRsUcTuGm_D0DYU?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2011,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 305,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 33,
    "GAME_DATE": 20110405,
    "Season": "2010-2011",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/467740276438994223",
    "name": "The 2974 Collection #0305",
    "imageUrl": "https://arweave.net/OZmhyF1yJwZgKX2roZKmln-JF-qUtBg3ugZhud2iFIg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2011,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 306,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 111,
    "LOC_Y": 222,
    "GAME_DATE": 20110405,
    "Season": "2010-2011",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/526491109990949712",
    "name": "The 2974 Collection #0306",
    "imageUrl": "https://arweave.net/m8RB4DdeFT-QNCHvEk7nGZcngFvxgI4KyRdHbCCeGuc?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2011,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 307,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 129,
    "LOC_Y": 206,
    "GAME_DATE": 20110405,
    "Season": "2010-2011",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497300436149430982",
    "name": "The 2974 Collection #0307",
    "imageUrl": "https://arweave.net/USgwBYbtb8drOxm6qfewYwNJKKTW7U3mQ_XvZwQtnZM?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2011,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 308,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 231,
    "LOC_Y": 138,
    "GAME_DATE": 20110406,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510176897997976305",
    "name": "The 2974 Collection #0308",
    "imageUrl": "https://arweave.net/FaEMusW9OkHIqtkChYuL39clzOTJv204J5o-Y82gLYs?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 309,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 102,
    "LOC_Y": 254,
    "GAME_DATE": 20110406,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485275267291789183",
    "name": "The 2974 Collection #0309",
    "imageUrl": "https://arweave.net/Le80NVIeikIDl1IY2crqylNir5PFY0axxCjNkhlqnU8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2011,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 310,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 231,
    "LOC_Y": 19,
    "GAME_DATE": 20110410,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500279760243641457",
    "name": "The 2974 Collection #0310",
    "imageUrl": "https://arweave.net/VC053Katmg6DKgsnsoifDxqvY9iJRD-q9eLANLMtm7Y?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 311,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 146,
    "LOC_Y": 208,
    "GAME_DATE": 20110410,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523881868684807053",
    "name": "The 2974 Collection #0311",
    "imageUrl": "https://arweave.net/JYPBc4ao4FeG4ELpgncfZ7W2cW_BNygBRSScIhm4s2s?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 312,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 200,
    "LOC_Y": 216,
    "GAME_DATE": 20110410,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/570543586281671951",
    "name": "The 2974 Collection #0312",
    "imageUrl": "https://arweave.net/LEr7c2Idonkk2_EVb9-MAJj1Ko_lB5g_RnQPXAvt_Ig?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2011,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 313,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -133,
    "LOC_Y": 208,
    "GAME_DATE": 20110411,
    "Season": "2010-2011",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523277271585216908",
    "name": "The 2974 Collection #0313",
    "imageUrl": "https://arweave.net/C67fKDFhubuMjRZ-6CkO-cxMuV170EkuCkuvqTFYu6M?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2011,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 314,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": -3,
    "GAME_DATE": 20110411,
    "Season": "2010-2011",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498042777348677901",
    "name": "The 2974 Collection #0314",
    "imageUrl": "https://arweave.net/Uj4uBv0ncxZ2oi7NLGPU6WbeMB8Pku3xR_qFTELN5To?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2011,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 315,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 160,
    "LOC_Y": 205,
    "GAME_DATE": 20110411,
    "Season": "2010-2011",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322971454439107167",
    "name": "The 2974 Collection #0315",
    "imageUrl": "https://arweave.net/Ov02iUCW7wSVfIfQW1Ku8eyPt8fxSG9DcuB-LoAZqmw?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2011,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 316,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 114,
    "LOC_Y": 238,
    "GAME_DATE": 20110413,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368475162718229626",
    "name": "The 2974 Collection #0316",
    "imageUrl": "https://arweave.net/GIi-0QEGWagnlCefXV-etr5jg1--0r_2xAfFaz4LNh8?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2011,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 317,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -171,
    "LOC_Y": 208,
    "GAME_DATE": 20110413,
    "Season": "2010-2011",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347393693170476708",
    "name": "The 2974 Collection #0317",
    "imageUrl": "https://arweave.net/RNTOOTDnjSvqVrn1JQs5457wxq9PbhgoDCbfRQuxp5o?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2011,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 318,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": -10,
    "GAME_DATE": 20111226,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327267648388498181",
    "name": "The 2974 Collection #0318",
    "imageUrl": "https://arweave.net/JC7AC4Ai7POU7b5m0KU9tg3PwrKKcWdwJqdQ6eS9AEU?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2011,
    "Month": 12,
    "Day": 26,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 319,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -226,
    "LOC_Y": 124,
    "GAME_DATE": 20111231,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371354270685303817",
    "name": "The 2974 Collection #0319",
    "imageUrl": "https://arweave.net/Y_yPnjYnwdK5z83Ovt3pjcXb2x_Nw4c8yBWPYQxHa94?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2011,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 3,
    "Special Moment": "New Year's Eve",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 320,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 103,
    "LOC_Y": 249,
    "GAME_DATE": 20111231,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293091693491849220",
    "name": "The 2974 Collection #0320",
    "imageUrl": "https://arweave.net/RDAiqf7B6BFh1gcGqhlsKrrLCHQgre2RZkwag95FRYQ?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2011,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 3,
    "Special Moment": "New Year's Eve",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 321,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -177,
    "LOC_Y": 203,
    "GAME_DATE": 20111231,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392758612287480299",
    "name": "The 2974 Collection #0321",
    "imageUrl": "https://arweave.net/hnRXWW-ycQ1mWGAGqb_hOBWLjzUy-naZhYGgeL7l7Ww?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2011,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 3,
    "Special Moment": "New Year's Eve",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 322,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 4,
    "LOC_Y": 252,
    "GAME_DATE": 20120102,
    "Season": "2011-2012",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/427452576364692448",
    "name": "The 2974 Collection #0322",
    "imageUrl": "https://arweave.net/OkOPcu1BLFxIOIklg_B-XXMmjJ3PdDeFMhvEJRB8H50?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2012,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 323,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 33,
    "GAME_DATE": 20120102,
    "Season": "2011-2012",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438422341709108298",
    "name": "The 2974 Collection #0323",
    "imageUrl": "https://arweave.net/tqtN0H_qC00VHa1_No9QwT0Ik6FQ7NRB3NHfIbncx9s?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2012,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 324,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -209,
    "LOC_Y": 154,
    "GAME_DATE": 20120104,
    "Season": "2011-2012",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319127454738784168",
    "name": "The 2974 Collection #0324",
    "imageUrl": "https://arweave.net/2m_waHX0fRup_RaRv_yKG-kdrqc748tj4FA2DJzEwkw?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2012,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 325,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -237,
    "LOC_Y": 55,
    "GAME_DATE": 20120104,
    "Season": "2011-2012",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/291394616189826026",
    "name": "The 2974 Collection #0325",
    "imageUrl": "https://arweave.net/XLo9Xb9cB21emRddAjSZ8LhzjmtVXE7HPixDcMdIqpo?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2012,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 326,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": -5,
    "GAME_DATE": 20120104,
    "Season": "2011-2012",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524569194610971811",
    "name": "The 2974 Collection #0326",
    "imageUrl": "https://arweave.net/u5Nz0OhuR2UEQjd5jbY-jAU3prlQGng_rJFfmw4lf50?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2012,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 327,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 78,
    "LOC_Y": 250,
    "GAME_DATE": 20120120,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531259030765308711",
    "name": "The 2974 Collection #0327",
    "imageUrl": "https://arweave.net/Lv0lJxvOWqf3O9XyV3gAkzSeVSrV2neHDF7AzY3sfwg?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2012,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 328,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 106,
    "LOC_Y": 231,
    "GAME_DATE": 20120120,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421353831773523664",
    "name": "The 2974 Collection #0328",
    "imageUrl": "https://arweave.net/96faCVbowox8e51gC5JTJ76vXkqxOuz1rI9FIRNfmOY?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2012,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 329,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 9,
    "LOC_Y": 260,
    "GAME_DATE": 20120123,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551682983196615131",
    "name": "The 2974 Collection #0329",
    "imageUrl": "https://arweave.net/GzduieYfPYutbUtX-4p79-F7kjwTxE_W9AjIuypW6Fo?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 330,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 119,
    "LOC_Y": 235,
    "GAME_DATE": 20120123,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/372790809129399214",
    "name": "The 2974 Collection #0330",
    "imageUrl": "https://arweave.net/ocEfQNq6yQbSrw68jG7JdpzCCYozkWikwWz9waFRFss?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 331,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 217,
    "LOC_Y": 119,
    "GAME_DATE": 20120125,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450442139210532913",
    "name": "The 2974 Collection #0331",
    "imageUrl": "https://arweave.net/8Yjv2esWkHo-SKgDmOzdU_p_ZVFAhITISI9YnSHMJ5Q?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2012,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 332,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 1,
    "GAME_DATE": 20120125,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359242934465543857",
    "name": "The 2974 Collection #0332",
    "imageUrl": "https://arweave.net/-hXhXFWKCs9xB5nJr0zX_71VLYENriSnu5h68UComAU?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2012,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 333,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": 28,
    "GAME_DATE": 20120125,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484773184447416225",
    "name": "The 2974 Collection #0333",
    "imageUrl": "https://arweave.net/5Gxm5oH24ov7JdZG-1IPkgxl3Eoe-DylgsRiLM6Fm7Y?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2012,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 334,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 207,
    "LOC_Y": 143,
    "GAME_DATE": 20120125,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/530940738380355556",
    "name": "The 2974 Collection #0334",
    "imageUrl": "https://arweave.net/ru4ioPAOHn9xnVfzwJvEuJNGKxAPaNjRQf7Roy3LH5Y?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2012,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 335,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 168,
    "LOC_Y": 184,
    "GAME_DATE": 20120125,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502863852382419842",
    "name": "The 2974 Collection #0335",
    "imageUrl": "https://arweave.net/kJh4tE8hIb7jUfrmP99TXXWn1c4cIBtZbZxFy3X6SVA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2012,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 336,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 37,
    "LOC_Y": 265,
    "GAME_DATE": 20120125,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547303473723813014",
    "name": "The 2974 Collection #0336",
    "imageUrl": "https://arweave.net/e3YNlaEuRAvLXw4V1NrYWpGu2WdTnPOpkDv9clxzcRk?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2012,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 337,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -240,
    "LOC_Y": 7,
    "GAME_DATE": 20120127,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493087018052340350",
    "name": "The 2974 Collection #0337",
    "imageUrl": "https://arweave.net/k-FiBuHW5dh4yLspJylkTfP0_uez7gLCG_H898mbdmA?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 338,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 225,
    "LOC_Y": 119,
    "GAME_DATE": 20120127,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/350686301881590222",
    "name": "The 2974 Collection #0338",
    "imageUrl": "https://arweave.net/AJSdhCwSUEDhifSQtmxorzF9acvJgoXUmzkEDHlx4Eg?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 339,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 239,
    "LOC_Y": 7,
    "GAME_DATE": 20120202,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309739102662216140",
    "name": "The 2974 Collection #0339",
    "imageUrl": "https://arweave.net/KvwprLiv5X267fx2wGPD9m27KBPZweDlJJBG-YCpCFw?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2012,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 340,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -23,
    "LOC_Y": 255,
    "GAME_DATE": 20120202,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357116373046266525",
    "name": "The 2974 Collection #0340",
    "imageUrl": "https://arweave.net/Ehu2QRrT5oFt2DxQjp6XEeVs1u6DFzlqARhIQWI2JcQ?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2012,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 341,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -73,
    "LOC_Y": 235,
    "GAME_DATE": 20120204,
    "Season": "2011-2012",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295570974858167126",
    "name": "The 2974 Collection #0341",
    "imageUrl": "https://arweave.net/FWRlIsQVQ0yihqmvL-dhp2hW0xFpLL1Cp4UzZAJfGzw?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 342,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 138,
    "LOC_Y": 225,
    "GAME_DATE": 20120204,
    "Season": "2011-2012",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429619773037299710",
    "name": "The 2974 Collection #0342",
    "imageUrl": "https://arweave.net/C7qlucFDzaM-c_bGMM08q8lTcvM6X7MHNcfpNS0q2Ac?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 343,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 241,
    "LOC_Y": 41,
    "GAME_DATE": 20120204,
    "Season": "2011-2012",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533846729454470203",
    "name": "The 2974 Collection #0343",
    "imageUrl": "https://arweave.net/qJk_UIQEqsuFtzSvRXsy7xvnDv2b5sioEWobHccf6nE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 344,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -171,
    "LOC_Y": 211,
    "GAME_DATE": 20120207,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367364201148004378",
    "name": "The 2974 Collection #0344",
    "imageUrl": "https://arweave.net/kzdDxPK25aiwVqLtbGVDw8NXP7Hg2vimPrp15HbSfUY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 2,
    "Day": 7,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 345,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 237,
    "LOC_Y": 42,
    "GAME_DATE": 20120209,
    "Season": "2011-2012",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/466597813079145188",
    "name": "The 2974 Collection #0345",
    "imageUrl": "https://arweave.net/Ii7AJAq6WYoJ5vrdTwGfDH3IU62urwzIbFNijH-G66k?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 346,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 212,
    "LOC_Y": 134,
    "GAME_DATE": 20120209,
    "Season": "2011-2012",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429130594049138285",
    "name": "The 2974 Collection #0346",
    "imageUrl": "https://arweave.net/fsaRsPaoTrW3ccz6dcDX68eaiIY_qCEy6iufklU5V2A?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 347,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -160,
    "LOC_Y": 195,
    "GAME_DATE": 20120209,
    "Season": "2011-2012",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322447617269005460",
    "name": "The 2974 Collection #0347",
    "imageUrl": "https://arweave.net/8hJsfMxfOSQhJAMDPCb0uOG1jqQ1FPI_G5AyCbCoQs8?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 348,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 45,
    "LOC_Y": 244,
    "GAME_DATE": 20120209,
    "Season": "2011-2012",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371875503218842949",
    "name": "The 2974 Collection #0348",
    "imageUrl": "https://arweave.net/YXVnSa_bXSA4hAWtF_WYijxP8K3n7rDqCf6R7PcIs1Q?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 349,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 189,
    "LOC_Y": 156,
    "GAME_DATE": 20120209,
    "Season": "2011-2012",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305587902162497807",
    "name": "The 2974 Collection #0349",
    "imageUrl": "https://arweave.net/4lADx56DhBB9xOsxLwUbGwETBBr_8p-7AThpEdBDjDk?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 350,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 177,
    "LOC_Y": 176,
    "GAME_DATE": 20120209,
    "Season": "2011-2012",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/394811207444198244",
    "name": "The 2974 Collection #0350",
    "imageUrl": "https://arweave.net/tANkTFX0YMUXGLi4mro2t4oyptZkvijKPR-3L92bXQw?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 351,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -239,
    "LOC_Y": 23,
    "GAME_DATE": 20120212,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417031111998103906",
    "name": "The 2974 Collection #0351",
    "imageUrl": "https://arweave.net/cqqCMAe3yNAbuFpxvN8DlOZ-u9Y_bX0PUDTandmlk2U?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2012,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 352,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 67,
    "LOC_Y": 260,
    "GAME_DATE": 20120212,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439719973207807766",
    "name": "The 2974 Collection #0352",
    "imageUrl": "https://arweave.net/9q4TpN-cT_LL4a7kKyYuZ8iVy8CV4rKgjwTi_qEPuUA?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2012,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 353,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -217,
    "LOC_Y": 145,
    "GAME_DATE": 20120212,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312620844550657041",
    "name": "The 2974 Collection #0353",
    "imageUrl": "https://arweave.net/pzgVqN0PjZ7M2TLhlNZSeQERzW3TQiTphPhLjLSTZjk?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2012,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 354,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 189,
    "LOC_Y": 206,
    "GAME_DATE": 20120213,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567562289531348772",
    "name": "The 2974 Collection #0354",
    "imageUrl": "https://arweave.net/dp7KGaPlBgdvzFJk8TvLe8QmxVN1TockLE-f5bKcTIo?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2012,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 355,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 196,
    "LOC_Y": 148,
    "GAME_DATE": 20120217,
    "Season": "2011-2012",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/442411395717769272",
    "name": "The 2974 Collection #0355",
    "imageUrl": "https://arweave.net/F5YDzY6V54-9eOGOZEWc4nnPIhAdmGshfR0bMYdLoAY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 2,
    "Day": 17,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 356,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 32,
    "LOC_Y": 239,
    "GAME_DATE": 20120217,
    "Season": "2011-2012",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438191508672558378",
    "name": "The 2974 Collection #0356",
    "imageUrl": "https://arweave.net/kxRUxaNZXK4GPbED4kJH0gApIKVHmYlHbgeEiDSi3C8?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 2,
    "Day": 17,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 357,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 39,
    "LOC_Y": 239,
    "GAME_DATE": 20120217,
    "Season": "2011-2012",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/463567277916993904",
    "name": "The 2974 Collection #0357",
    "imageUrl": "https://arweave.net/KY5Aj6Kl5RM-u38idpx0GwBfYDaAIJyEvAKfb6zVW_I?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 2,
    "Day": 17,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 358,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 225,
    "LOC_Y": 66,
    "GAME_DATE": 20120218,
    "Season": "2011-2012",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360317838368028584",
    "name": "The 2974 Collection #0358",
    "imageUrl": "https://arweave.net/qpNVxmXdAYtDFWzWl7KF5UVKDduWy0ATO6LmQhxirpo?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 2,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 359,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 198,
    "LOC_Y": 148,
    "GAME_DATE": 20120218,
    "Season": "2011-2012",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423606002946364513",
    "name": "The 2974 Collection #0359",
    "imageUrl": "https://arweave.net/yjlaGpAaleXNRZQrK1MkdNW_KnSK4DemfeX4NXGPdrU?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 2,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 360,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -111,
    "LOC_Y": 222,
    "GAME_DATE": 20120218,
    "Season": "2011-2012",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381113022665754828",
    "name": "The 2974 Collection #0360",
    "imageUrl": "https://arweave.net/jgZGsOWGRfl-6hDbkTQ1Io83-mBC4InEePgtjwYfdVQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 2,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 361,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 43,
    "LOC_Y": 242,
    "GAME_DATE": 20120218,
    "Season": "2011-2012",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490824529591295398",
    "name": "The 2974 Collection #0361",
    "imageUrl": "https://arweave.net/Dza6yI5XO7s-RsbEItb3rShst5tEPPSrVv5u8HrcP98?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 2,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 362,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -194,
    "LOC_Y": 184,
    "GAME_DATE": 20120218,
    "Season": "2011-2012",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/571836065059364349",
    "name": "The 2974 Collection #0362",
    "imageUrl": "https://arweave.net/NCJrKrdHQtBDNr8_yNBHbPQ2NDCAPcVg0aHTVnI5FXE?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 2,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 363,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -3,
    "GAME_DATE": 20120218,
    "Season": "2011-2012",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/398155896524008424",
    "name": "The 2974 Collection #0363",
    "imageUrl": "https://arweave.net/kp9Vd-Q0t4_OMbj_j84uTqTN_kwYlHac8yNTxxlKRkc?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 2,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 364,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 228,
    "LOC_Y": 74,
    "GAME_DATE": 20120220,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/376021000756536355",
    "name": "The 2974 Collection #0364",
    "imageUrl": "https://arweave.net/h2SYjskHX38EVl6cH3CckILxEPXvwTQUJBFK39eNfv0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 365,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -100,
    "LOC_Y": 258,
    "GAME_DATE": 20120220,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346672112711424077",
    "name": "The 2974 Collection #0365",
    "imageUrl": "https://arweave.net/iABFX_XESaxjmsjLCBwiLNI0LcyXqRmiIu1jsTJGdCQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 366,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -120,
    "LOC_Y": 247,
    "GAME_DATE": 20120220,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439818610252057771",
    "name": "The 2974 Collection #0366",
    "imageUrl": "https://arweave.net/mzap4I4SrGHSFiYnx4XN7HmnwXrnxKiz2XK_Kv6kc_c?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 367,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": -11,
    "GAME_DATE": 20120222,
    "Season": "2011-2012",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300143798340265746",
    "name": "The 2974 Collection #0367",
    "imageUrl": "https://arweave.net/1P-ANS2O9JPIR4QPTE5mmN1N2f5yIsLzmKr_ZZENiA0?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2012,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 368,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 12,
    "LOC_Y": 261,
    "GAME_DATE": 20120305,
    "Season": "2011-2012",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/303651633631646955",
    "name": "The 2974 Collection #0368",
    "imageUrl": "https://arweave.net/_8a-IqxAgCmPRFKVZFPmod25LGonUpEA4Mi0WBRkpXk?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2012,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 369,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -87,
    "LOC_Y": 258,
    "GAME_DATE": 20120305,
    "Season": "2011-2012",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/337592422859609076",
    "name": "The 2974 Collection #0369",
    "imageUrl": "https://arweave.net/43IPqIiJ2WPx6xJyGx72Ib16taIKvlCFxPiRdtyQdxo?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2012,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 370,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -43,
    "LOC_Y": 255,
    "GAME_DATE": 20120307,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/339276479339550516",
    "name": "The 2974 Collection #0370",
    "imageUrl": "https://arweave.net/P1cwoKFBy-wl-noZZQUIIGyBqzlo3Ag5ovo4vC-ornk?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 3,
    "Day": 7,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 371,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 84,
    "LOC_Y": 258,
    "GAME_DATE": 20120310,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/496288785390719461",
    "name": "The 2974 Collection #0371",
    "imageUrl": "https://arweave.net/p91tjPzCmQc4rQNVmly6P1S5CLwu4DyS-fmIQAB1TLw?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2012,
    "Month": 3,
    "Day": 10,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 372,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -177,
    "LOC_Y": 178,
    "GAME_DATE": 20120310,
    "Season": "2011-2012",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552474926449106064",
    "name": "The 2974 Collection #0372",
    "imageUrl": "https://arweave.net/pBJCj-SM-ceTGEmUlEgk41beC7kQNuqW7jzm9xYONro?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2012,
    "Month": 3,
    "Day": 10,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 373,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": -3,
    "GAME_DATE": 20121102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/537933901284155108",
    "name": "The 2974 Collection #0373",
    "imageUrl": "https://arweave.net/qYRD_CE0TA32JM3j2aUGjuscfBulBR4SHzTWJOwXUxY?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 374,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -228,
    "LOC_Y": 48,
    "GAME_DATE": 20121102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/505598898747834826",
    "name": "The 2974 Collection #0374",
    "imageUrl": "https://arweave.net/TNBm3U-pIyqGvNlKJ9Pul9Z6zr0z3Sa8e89b_sSrASU?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 375,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -209,
    "LOC_Y": 142,
    "GAME_DATE": 20121102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421155716955915038",
    "name": "The 2974 Collection #0375",
    "imageUrl": "https://arweave.net/5qIoVulDuYv-z0Lz7hRZaPIFrOsTSN2dNdms79SMhdc?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 376,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 110,
    "LOC_Y": 239,
    "GAME_DATE": 20121102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521175445051103125",
    "name": "The 2974 Collection #0376",
    "imageUrl": "https://arweave.net/nRS3rvPBlOyDZ2xJikBq35S3W1bxC6-8P49ZlGQ38mk?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 377,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 154,
    "LOC_Y": 222,
    "GAME_DATE": 20121102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/314454901658072389",
    "name": "The 2974 Collection #0377",
    "imageUrl": "https://arweave.net/ZQ4wl-8mqQr76Hp3qNoUYFz_L_L_6AVC2Jq4EtR8W7k?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 378,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 138,
    "LOC_Y": 238,
    "GAME_DATE": 20121102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317232823618791103",
    "name": "The 2974 Collection #0378",
    "imageUrl": "https://arweave.net/pn-4WT9pkqOsbXrdjsZCldCoa_Ctzj1t9wbg5hUmiIE?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2012,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 379,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -168,
    "LOC_Y": 213,
    "GAME_DATE": 20121103,
    "Season": "2012-2013",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533785334079333495",
    "name": "The 2974 Collection #0379",
    "imageUrl": "https://arweave.net/zT8I1U_XlSIJk4neSpGtW_z255xz2UV_GS_6Hrg_Cjc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 11,
    "Day": 3,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 380,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -142,
    "LOC_Y": 241,
    "GAME_DATE": 20121103,
    "Season": "2012-2013",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/394693188781319605",
    "name": "The 2974 Collection #0380",
    "imageUrl": "https://arweave.net/3ol_w6Jm44X4T5kUH1CFr32MJ-m8_ALfuoF9Dxp-_qM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 11,
    "Day": 3,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 381,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 143,
    "LOC_Y": 211,
    "GAME_DATE": 20121105,
    "Season": "2012-2013",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/475087919001301495",
    "name": "The 2974 Collection #0381",
    "imageUrl": "https://arweave.net/ox_C3CtecL4iqzue98-9aUpwxEDTqufIxZi2kx1Ru7Y?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 382,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 9,
    "LOC_Y": 246,
    "GAME_DATE": 20121105,
    "Season": "2012-2013",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/494601646361436750",
    "name": "The 2974 Collection #0382",
    "imageUrl": "https://arweave.net/id7arLHxD9Z8EHcVg_5OLrOOYX1Z-BF4f9AFxZJDIOA?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 383,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 124,
    "LOC_Y": 242,
    "GAME_DATE": 20121107,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566588936253906767",
    "name": "The 2974 Collection #0383",
    "imageUrl": "https://arweave.net/schkZzYONBSKft_Sn3ak_JQ_CvFR80BUIw5Xf6hT7d4?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2012,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 384,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -201,
    "LOC_Y": 143,
    "GAME_DATE": 20121107,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/549385399293397764",
    "name": "The 2974 Collection #0384",
    "imageUrl": "https://arweave.net/ZYJMomt3-pQEpu3mnD6BbsVGVqNtPQGkVwoFkxHiZcU?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2012,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 385,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": 9,
    "GAME_DATE": 20121109,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368765434960341242",
    "name": "The 2974 Collection #0385",
    "imageUrl": "https://arweave.net/PheaNm_I9ANPSzyxJKvLAWwFtN2utveS8CNT1wbJU5I?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 386,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -131,
    "LOC_Y": 217,
    "GAME_DATE": 20121109,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386626617555672073",
    "name": "The 2974 Collection #0386",
    "imageUrl": "https://arweave.net/923x6jlfoeEyFnECHWOJ6PHpPVtAGlKGMPYJEz7tTtI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 387,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 114,
    "LOC_Y": 239,
    "GAME_DATE": 20121110,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/427638233190047170",
    "name": "The 2974 Collection #0387",
    "imageUrl": "https://arweave.net/RjcB2fbq0wYvWQ8m0hIL5USGdhVbgpHiE__tGh6CgL4?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 388,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 127,
    "LOC_Y": 247,
    "GAME_DATE": 20121110,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504391155613465352",
    "name": "The 2974 Collection #0388",
    "imageUrl": "https://arweave.net/Hl9IvxxsaJ09SffkrZOsC_0K0Ss_eJv-XT067nAx8Zo?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 389,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 7,
    "GAME_DATE": 20121110,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/555136268045774145",
    "name": "The 2974 Collection #0389",
    "imageUrl": "https://arweave.net/ecFE0fhfzNftweZCuy4D8yMpPvKpFan90DZfe4GHItk?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 390,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 106,
    "LOC_Y": 220,
    "GAME_DATE": 20121118,
    "Season": "2012-2013",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423805297062610636",
    "name": "The 2974 Collection #0390",
    "imageUrl": "https://arweave.net/BDtXsXIy9nVBdvptCj11VGXrYh7TQ7Xoe2nwL-xwfHU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 391,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -207,
    "LOC_Y": 138,
    "GAME_DATE": 20121118,
    "Season": "2012-2013",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295411239370663218",
    "name": "The 2974 Collection #0391",
    "imageUrl": "https://arweave.net/xWSh8gfJw-s1RPa1yN1NfCnJ75pE6hO_ogOux4x_w4k?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 392,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -46,
    "LOC_Y": 238,
    "GAME_DATE": 20121118,
    "Season": "2012-2013",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317214785514473723",
    "name": "The 2974 Collection #0392",
    "imageUrl": "https://arweave.net/NSUs_tYJgCj4XPBrYWai4CTytCyZogUh-6Q2q9OT3Lc?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 393,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -37,
    "LOC_Y": 241,
    "GAME_DATE": 20121118,
    "Season": "2012-2013",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512255491702135372",
    "name": "The 2974 Collection #0393",
    "imageUrl": "https://arweave.net/5ltCnroq0e244gBCT219MZZFJvVsFx9jGZv4DxRb_Ng?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2012,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 394,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 83,
    "LOC_Y": 233,
    "GAME_DATE": 20121119,
    "Season": "2012-2013",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/399824116523237329",
    "name": "The 2974 Collection #0394",
    "imageUrl": "https://arweave.net/Q02R4iUCV_1X2Sy7Sxxg-cccNhXM6yrdI9WD16-fbQI?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2012,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 395,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -89,
    "LOC_Y": 242,
    "GAME_DATE": 20121119,
    "Season": "2012-2013",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433360117934777600",
    "name": "The 2974 Collection #0395",
    "imageUrl": "https://arweave.net/RLGijhOD2vz99fE6ba-V6Eatiq__91QYgXt8wCnfmxs?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2012,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 396,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 174,
    "LOC_Y": 209,
    "GAME_DATE": 20121119,
    "Season": "2012-2013",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/472645063961497813",
    "name": "The 2974 Collection #0396",
    "imageUrl": "https://arweave.net/aWCBkR_cox70zNoGkM7qkcrmUnKS2QczK-OOy310pkU?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2012,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 397,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 170,
    "LOC_Y": 225,
    "GAME_DATE": 20121121,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461353865691376204",
    "name": "The 2974 Collection #0397",
    "imageUrl": "https://arweave.net/7OOgXOSHsfVFq9IMVIh6jSbdWkD-lzpBaRv5vgNFXzc?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2012,
    "Month": 11,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 398,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -5,
    "LOC_Y": 274,
    "GAME_DATE": 20121121,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434105309312680174",
    "name": "The 2974 Collection #0398",
    "imageUrl": "https://arweave.net/GqktdO9QBTTIymRlBB_QTwuQ8Jw38O1IqVWuBhWcxrY?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2012,
    "Month": 11,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 399,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -213,
    "LOC_Y": 142,
    "GAME_DATE": 20121123,
    "Season": "2012-2013",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361323900955756029",
    "name": "The 2974 Collection #0399",
    "imageUrl": "https://arweave.net/n8zBqf2rnVJ1xRxbZvBLQSsfjIjfQ30dgovnGnkT3Ns?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 400,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 162,
    "LOC_Y": 200,
    "GAME_DATE": 20121123,
    "Season": "2012-2013",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331631526710968023",
    "name": "The 2974 Collection #0400",
    "imageUrl": "https://arweave.net/atl2K8bMkoJ8i0QYgKb6zoRuzeikqUDgGfWze_ik1Xs?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 401,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -24,
    "LOC_Y": 274,
    "GAME_DATE": 20121124,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299764466047694028",
    "name": "The 2974 Collection #0401",
    "imageUrl": "https://arweave.net/k9LoUD3Ga9gftEF8cqDG6UrP1hhrYK6UWsnkqIiSwOY?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2012,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 402,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -142,
    "LOC_Y": 233,
    "GAME_DATE": 20121124,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/358089305277603950",
    "name": "The 2974 Collection #0402",
    "imageUrl": "https://arweave.net/swaLtQM8t0cwPtU4vZ7nb2J9Z-mT6S26c4bhWU_TpXc?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2012,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 403,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -2,
    "LOC_Y": 271,
    "GAME_DATE": 20121124,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543149512116099957",
    "name": "The 2974 Collection #0403",
    "imageUrl": "https://arweave.net/NsAImK5lbH8-2l_H0bT11gRojLLPOf9R7Asz0FN8mO4?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2012,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 404,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -150,
    "LOC_Y": 228,
    "GAME_DATE": 20121124,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/399192124753274516",
    "name": "The 2974 Collection #0404",
    "imageUrl": "https://arweave.net/ZXEC4U43n558aoRmHwUvvb-wUCiK-v1fQqS_t5kh-_0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2012,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 405,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -119,
    "LOC_Y": 228,
    "GAME_DATE": 20121124,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481791222242481819",
    "name": "The 2974 Collection #0405",
    "imageUrl": "https://arweave.net/Afo8GjHvohN3fsWJRSuidzUB6FmZtftqlfJwNA-cRak?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2012,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 406,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": 0,
    "GAME_DATE": 20121129,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/453007728339503284",
    "name": "The 2974 Collection #0406",
    "imageUrl": "https://arweave.net/qLie1PsufDtYdKz41A2y9wqbsltIpNo-ly9eGoFpBeg?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 407,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -122,
    "LOC_Y": 227,
    "GAME_DATE": 20121129,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562045099761623803",
    "name": "The 2974 Collection #0407",
    "imageUrl": "https://arweave.net/WCNfoJsUlMSxX1pG8cdDBfmtZBQVhi_Iu0QaV19n5zU?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 408,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 6,
    "LOC_Y": 268,
    "GAME_DATE": 20121129,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/311911179588253988",
    "name": "The 2974 Collection #0408",
    "imageUrl": "https://arweave.net/n9TCXGxdDLq-PLaLU3rkTlZiQiWgVrjXQZfKcsAGlTU?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 409,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -105,
    "LOC_Y": 254,
    "GAME_DATE": 20121129,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415827082153743969",
    "name": "The 2974 Collection #0409",
    "imageUrl": "https://arweave.net/_WK9xXCwh4sCThLbjPV4wrQJWnN7TCpeHiublpf0iZI?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2012,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 410,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -198,
    "LOC_Y": 153,
    "GAME_DATE": 20121201,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403442685377232345",
    "name": "The 2974 Collection #0410",
    "imageUrl": "https://arweave.net/1IiyKE9tlZh4dTYa4Hkjt5aYG3dd3r_G3EmcBia627w?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2012,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 411,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 152,
    "LOC_Y": 227,
    "GAME_DATE": 20121201,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/528475780708199506",
    "name": "The 2974 Collection #0411",
    "imageUrl": "https://arweave.net/V-xAsqTV9KDOG0kpmj1Qqfw8n9wJ1XUVYAcrCNfNbto?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2012,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 412,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -71,
    "LOC_Y": 261,
    "GAME_DATE": 20121201,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321654984179442796",
    "name": "The 2974 Collection #0412",
    "imageUrl": "https://arweave.net/LrUPoVhV3ezvo4rMrHIy_hQG7qdDui_JSVKxv0_IXyQ?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2012,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 413,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -185,
    "LOC_Y": 187,
    "GAME_DATE": 20121203,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385970166955088200",
    "name": "The 2974 Collection #0413",
    "imageUrl": "https://arweave.net/6U9w0ccFv7-_XdNAYKAsUDdjCuHm9NybccGIB5S7Wn4?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2012,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 414,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -24,
    "LOC_Y": 261,
    "GAME_DATE": 20121203,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515864120547996301",
    "name": "The 2974 Collection #0414",
    "imageUrl": "https://arweave.net/VhacZVB5gA9yJfg94woxr7yT46gMSgkzONEhQZMRAlc?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2012,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 415,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 88,
    "LOC_Y": 238,
    "GAME_DATE": 20121203,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330037676831939711",
    "name": "The 2974 Collection #0415",
    "imageUrl": "https://arweave.net/LhL8XTBjmDGpUS05s2hJ8ERcOZGy4wP9EO1G1wJ2s2U?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2012,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 416,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -217,
    "LOC_Y": 134,
    "GAME_DATE": 20121205,
    "Season": "2012-2013",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513650580512996823",
    "name": "The 2974 Collection #0416",
    "imageUrl": "https://arweave.net/YpiyI7D7k06rQxDY1iaqGl9pCuDstNXrG5OEBw3L2sg?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2012,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 417,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -158,
    "LOC_Y": 217,
    "GAME_DATE": 20121205,
    "Season": "2012-2013",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525939841571485322",
    "name": "The 2974 Collection #0417",
    "imageUrl": "https://arweave.net/PS5-ffvK3yTiRXQWbTWbg4JVAqWledk384re9Agayts?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2012,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 418,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -67,
    "LOC_Y": 254,
    "GAME_DATE": 20121205,
    "Season": "2012-2013",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439632479040027363",
    "name": "The 2974 Collection #0418",
    "imageUrl": "https://arweave.net/PW5fDZhIhz0tJlqud8s2xHOt_AFEkEXzlql6elJHivY?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2012,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 419,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 226,
    "LOC_Y": 119,
    "GAME_DATE": 20121205,
    "Season": "2012-2013",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520101973816271856",
    "name": "The 2974 Collection #0419",
    "imageUrl": "https://arweave.net/frgwnU4w6CmBaE4m_OF7ziUVONchdGmhY7cvdJTG_Co?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2012,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 420,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 185,
    "LOC_Y": 187,
    "GAME_DATE": 20121207,
    "Season": "2012-2013",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297693997941354237",
    "name": "The 2974 Collection #0420",
    "imageUrl": "https://arweave.net/oL7bUzai-hZjrSUTOba7Z0Vxm_r8_wjn1OWKKugXo94?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2012,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 421,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 257,
    "GAME_DATE": 20121207,
    "Season": "2012-2013",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369441458117990782",
    "name": "The 2974 Collection #0421",
    "imageUrl": "https://arweave.net/fFdR9l0yJYVYR1qLorLp3pD98AnU2u8wc9lGBjTVIIo?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2012,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 422,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -239,
    "LOC_Y": 19,
    "GAME_DATE": 20121207,
    "Season": "2012-2013",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415029271488374121",
    "name": "The 2974 Collection #0422",
    "imageUrl": "https://arweave.net/nN6hWLgMmvXD3VVR6js7j-QCBtOS4rLsHUQp59ktRmk?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2012,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 423,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 95,
    "LOC_Y": 244,
    "GAME_DATE": 20121207,
    "Season": "2012-2013",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446577795100382948",
    "name": "The 2974 Collection #0423",
    "imageUrl": "https://arweave.net/pVpnQ7g2u_cxc1Zc7m5nJ62yfq2yvFcZnPB2rFd1Q14?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2012,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 424,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -128,
    "LOC_Y": 224,
    "GAME_DATE": 20121207,
    "Season": "2012-2013",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/449138288340582088",
    "name": "The 2974 Collection #0424",
    "imageUrl": "https://arweave.net/FeljbjhauXdESvMimOxTkS8N55No-d6Mia-mK02plRQ?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2012,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 425,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 231,
    "LOC_Y": 115,
    "GAME_DATE": 20121208,
    "Season": "2012-2013",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362813559851427679",
    "name": "The 2974 Collection #0425",
    "imageUrl": "https://arweave.net/lw6-Is4q6nVRTBJyoTyhmOF_tdfh3AvuOzHrS5_WQPg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2012,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 426,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -218,
    "LOC_Y": 119,
    "GAME_DATE": 20121208,
    "Season": "2012-2013",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403434202129710456",
    "name": "The 2974 Collection #0426",
    "imageUrl": "https://arweave.net/lTenVTz6OgxEsAP_lHaxCUWZ_xpd9A-KIytqPyJK__s?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2012,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 427,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -168,
    "LOC_Y": 197,
    "GAME_DATE": 20121210,
    "Season": "2012-2013",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/410970249066691026",
    "name": "The 2974 Collection #0427",
    "imageUrl": "https://arweave.net/mENgd6V79axcOWbLud3upVs7_6WkiuIvhnEtFXuX2lw?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 428,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -86,
    "LOC_Y": 291,
    "GAME_DATE": 20121210,
    "Season": "2012-2013",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/462592897489459088",
    "name": "The 2974 Collection #0428",
    "imageUrl": "https://arweave.net/g2ijeILVrQ8uL62ouABIjKr-iYx-O5nN5U4Iq9f-rKI?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 429,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -242,
    "LOC_Y": 3,
    "GAME_DATE": 20121210,
    "Season": "2012-2013",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308652594846646868",
    "name": "The 2974 Collection #0429",
    "imageUrl": "https://arweave.net/NVJy25kCD18hVZM_sKBK389iI1r2N7zv5A_4kXiqB4M?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 430,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -166,
    "LOC_Y": 227,
    "GAME_DATE": 20121210,
    "Season": "2012-2013",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356711425723837212",
    "name": "The 2974 Collection #0430",
    "imageUrl": "https://arweave.net/V3eCq_SfH-vTQKchUz-sy9pYdB0DxnFN1T7ZjBrfvvs?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 431,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -172,
    "LOC_Y": 178,
    "GAME_DATE": 20121212,
    "Season": "2012-2013",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338668328944750724",
    "name": "The 2974 Collection #0431",
    "imageUrl": "https://arweave.net/CsUfEPtIxMiA4_Iwm7oIMV4mubYlFPvIq4zTMV9wqSI?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2012,
    "Month": 12,
    "Day": 12,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 432,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -142,
    "LOC_Y": 222,
    "GAME_DATE": 20121214,
    "Season": "2012-2013",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504055054168420201",
    "name": "The 2974 Collection #0432",
    "imageUrl": "https://arweave.net/YtzAa4pb8XYsBJMP5EjGox6oQL-EYmgRwrq0mzpzPeU?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2012,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 433,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 177,
    "LOC_Y": 181,
    "GAME_DATE": 20121214,
    "Season": "2012-2013",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493018974042481434",
    "name": "The 2974 Collection #0433",
    "imageUrl": "https://arweave.net/3jvkIc9CMQagSPOC-hf_Fh9zZrPh3cEswKZ3dxNkd9E?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2012,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 434,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -86,
    "LOC_Y": 238,
    "GAME_DATE": 20121215,
    "Season": "2012-2013",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/303021221746688684",
    "name": "The 2974 Collection #0434",
    "imageUrl": "https://arweave.net/MpggUlHiHM0yE3HxHu0C4Uw3YzOP1Lo-o31AsODLHoc?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2012,
    "Month": 12,
    "Day": 15,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 435,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 94,
    "LOC_Y": 242,
    "GAME_DATE": 20121215,
    "Season": "2012-2013",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364832037333252433",
    "name": "The 2974 Collection #0435",
    "imageUrl": "https://arweave.net/ntp748bVZ8Ovc8rfhTavqZ9307VdOxmp20yhKVjfU8Y?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2012,
    "Month": 12,
    "Day": 15,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 436,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 78,
    "LOC_Y": 239,
    "GAME_DATE": 20121215,
    "Season": "2012-2013",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498001728955283268",
    "name": "The 2974 Collection #0436",
    "imageUrl": "https://arweave.net/SflapLPGK8CclMSTIlb2fY6AirVixpeEpv4sC406gnM?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2012,
    "Month": 12,
    "Day": 15,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 437,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -5,
    "GAME_DATE": 20121218,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566426373954125678",
    "name": "The 2974 Collection #0437",
    "imageUrl": "https://arweave.net/dKZYoF1mmnapiOfAsDB7W1sFxj2RJdR-ZH2aV9MAV8g?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2012,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 438,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -5,
    "LOC_Y": 250,
    "GAME_DATE": 20121219,
    "Season": "2012-2013",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513917897372868654",
    "name": "The 2974 Collection #0438",
    "imageUrl": "https://arweave.net/43M6D0B2Zk4mQT3c185_tTqsMOOITn0RLmHACl3JLGk?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 439,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 95,
    "LOC_Y": 238,
    "GAME_DATE": 20121219,
    "Season": "2012-2013",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/553283100731862358",
    "name": "The 2974 Collection #0439",
    "imageUrl": "https://arweave.net/Fcynf7ERqe6V6tIT8ItrEo337q1x5bFDq93b3vDjIIg?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 440,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 20,
    "GAME_DATE": 20121219,
    "Season": "2012-2013",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546420763151315530",
    "name": "The 2974 Collection #0440",
    "imageUrl": "https://arweave.net/5NGKKCoS03phXihzHYnOVEeaphoXC84DC18f91ynPI0?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 441,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 206,
    "LOC_Y": 142,
    "GAME_DATE": 20121219,
    "Season": "2012-2013",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348399665270881869",
    "name": "The 2974 Collection #0441",
    "imageUrl": "https://arweave.net/QAmHs0VyZXyr3Al312VRPgJyzS2nitERbnzV9lffD6U?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 442,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -57,
    "LOC_Y": 247,
    "GAME_DATE": 20121219,
    "Season": "2012-2013",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341004953999610778",
    "name": "The 2974 Collection #0442",
    "imageUrl": "https://arweave.net/CbMRGhKBCIOfqHjNtyuE44kBk3TaKHYSeCJpOslCCH8?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 443,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -49,
    "LOC_Y": 244,
    "GAME_DATE": 20121219,
    "Season": "2012-2013",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478590110180840185",
    "name": "The 2974 Collection #0443",
    "imageUrl": "https://arweave.net/skZxl4B-3PEgyHY4XEh02PG7Roy1-qiqZ7j2iK-VkjY?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 444,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -79,
    "LOC_Y": 233,
    "GAME_DATE": 20121219,
    "Season": "2012-2013",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511272336798760747",
    "name": "The 2974 Collection #0444",
    "imageUrl": "https://arweave.net/324tkyG7UWU3lh7djiGx79NTuuEYm4dKhEmmC8u-KaQ?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2012,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 445,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 6,
    "GAME_DATE": 20121221,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/462339100791620022",
    "name": "The 2974 Collection #0445",
    "imageUrl": "https://arweave.net/nomF2b0rTp4YbAvReQv-ucZKB2kbsUiYbbFNFBIWb_0?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 446,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 177,
    "LOC_Y": 216,
    "GAME_DATE": 20121221,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551952408062695223",
    "name": "The 2974 Collection #0446",
    "imageUrl": "https://arweave.net/utyy-xspb1Nru0F-0xrP3uky8UFPCJnJf1V94n3CO60?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 447,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 32,
    "LOC_Y": 276,
    "GAME_DATE": 20121221,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373451280594007842",
    "name": "The 2974 Collection #0447",
    "imageUrl": "https://arweave.net/3e4oXV0PuOPEYKgIN-jZdUDwLksC68Ju7PmeGZtTmQw?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 448,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -161,
    "LOC_Y": 233,
    "GAME_DATE": 20121221,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/358974706122801038",
    "name": "The 2974 Collection #0448",
    "imageUrl": "https://arweave.net/1zSKjr0iU1O9TSCHg3PCeTrkhIU1FhA-VL2VQnL_aMs?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 449,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 250,
    "GAME_DATE": 20121221,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540585160577526819",
    "name": "The 2974 Collection #0449",
    "imageUrl": "https://arweave.net/aaHThexuFvrkBq4D-ApFoqH9T-iqJWo-Z0adnQnwxwU?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 450,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -199,
    "LOC_Y": 214,
    "GAME_DATE": 20121221,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/442979130101987251",
    "name": "The 2974 Collection #0450",
    "imageUrl": "https://arweave.net/SWuMC3Da8sfNrq14C2q2onRd7UwTIBAYvly08vmdyzM?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 451,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 163,
    "LOC_Y": 201,
    "GAME_DATE": 20121221,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/574512734179274558",
    "name": "The 2974 Collection #0451",
    "imageUrl": "https://arweave.net/5NWzxNba0iscHyP_oWfp41qGkeT0bc2OiM-UMjrVmdw?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 452,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 138,
    "LOC_Y": 225,
    "GAME_DATE": 20121221,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/340960934170360264",
    "name": "The 2974 Collection #0452",
    "imageUrl": "https://arweave.net/BT1kJaRm8lFmVtMkOaov5yRPfUvSv1ZVsJjwhvrR4Fw?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2012,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 453,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 31,
    "GAME_DATE": 20121222,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411095884680586566",
    "name": "The 2974 Collection #0453",
    "imageUrl": "https://arweave.net/3J6BKX1uumr8tSh_ymcrPCrPuW7-KoSQZZ_dut6mcHg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 454,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 34,
    "GAME_DATE": 20121222,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552928948006671923",
    "name": "The 2974 Collection #0454",
    "imageUrl": "https://arweave.net/mBDa-RqZSKJvopP0wF8E70DnXmEDPKey55pqZKyOEBY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 455,
    "PERIOD": 5,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 95,
    "LOC_Y": 238,
    "GAME_DATE": 20121222,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302615669799519935",
    "name": "The 2974 Collection #0455",
    "imageUrl": "https://arweave.net/IZE76rytVJTkaC_IA1RJSENkNVz_XCdZK0Nivo3OFxc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2012,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 456,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -100,
    "LOC_Y": 225,
    "GAME_DATE": 20121226,
    "Season": "2012-2013",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312464433263430194",
    "name": "The 2974 Collection #0456",
    "imageUrl": "https://arweave.net/1R9GdhthXygl56BGjyi5eY_nu19L8L9vCfC-95j0cYk?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2012,
    "Month": 12,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 457,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 105,
    "LOC_Y": 227,
    "GAME_DATE": 20121226,
    "Season": "2012-2013",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/437030921140068269",
    "name": "The 2974 Collection #0457",
    "imageUrl": "https://arweave.net/SeY2OB3iJBfeMj8iE0BoMJWbnkL-W_vygMhN0vqHfoU?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2012,
    "Month": 12,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 458,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 157,
    "LOC_Y": 190,
    "GAME_DATE": 20121226,
    "Season": "2012-2013",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/313632708718732133",
    "name": "The 2974 Collection #0458",
    "imageUrl": "https://arweave.net/_XuUqvzpQ2t2dqYD86WN1Cexm2M7V5Q5TzxDr5q27TY?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2012,
    "Month": 12,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 459,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -199,
    "LOC_Y": 134,
    "GAME_DATE": 20121226,
    "Season": "2012-2013",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/445642011264463320",
    "name": "The 2974 Collection #0459",
    "imageUrl": "https://arweave.net/x0PtJ4Ro-V_P695HUcT5in4EZwbj2mvikui5vmFidLc?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2012,
    "Month": 12,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 460,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -2,
    "LOC_Y": 254,
    "GAME_DATE": 20121228,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533917973515458175",
    "name": "The 2974 Collection #0460",
    "imageUrl": "https://arweave.net/m7PN1E-Yo6diMgCJLE3a0tbm4d9mNxRRDjZv7OQvW4c?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2012,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 461,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -201,
    "LOC_Y": 189,
    "GAME_DATE": 20121229,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502864723684823945",
    "name": "The 2974 Collection #0461",
    "imageUrl": "https://arweave.net/-Qj20GkABsXBeJzSYj1p-Diahc7qWj7CV-3t9cMV7hw?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2012,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 462,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -117,
    "LOC_Y": 255,
    "GAME_DATE": 20121229,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346007555875917218",
    "name": "The 2974 Collection #0462",
    "imageUrl": "https://arweave.net/nWt_OAulaJoB6gkFpISwWH7fgBD-JNdkoc5OFWluENw?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2012,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 463,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 144,
    "LOC_Y": 216,
    "GAME_DATE": 20121229,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348175127272636966",
    "name": "The 2974 Collection #0463",
    "imageUrl": "https://arweave.net/pquBmMcxM-tqU3algixb3uhEldmh8i3wG3J4PeFMarU?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2012,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 464,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 185,
    "LOC_Y": 190,
    "GAME_DATE": 20121229,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374360785443499338",
    "name": "The 2974 Collection #0464",
    "imageUrl": "https://arweave.net/elBBFeqCooZXsWqYpZtvXrlrQyhdTKZDd4VHKTPnSCg?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2012,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 465,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 60,
    "GAME_DATE": 20130102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544884509536855768",
    "name": "The 2974 Collection #0465",
    "imageUrl": "https://arweave.net/lGcEI2JTpmvXIzSQgX8uDCAKhE19yc-99Be1XWg-SxQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 466,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -213,
    "LOC_Y": 153,
    "GAME_DATE": 20130102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547341766487155169",
    "name": "The 2974 Collection #0466",
    "imageUrl": "https://arweave.net/MBNlM8kCnJ6BVu3VqO10cV8o6vs6tyceyKqL3oen3yw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 467,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 7,
    "LOC_Y": 261,
    "GAME_DATE": 20130102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515705183015086159",
    "name": "The 2974 Collection #0467",
    "imageUrl": "https://arweave.net/Obje_VUSkV9XdRRyet4ZBTiXNDqGLOCd7V-19FvaaTs?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 468,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -82,
    "LOC_Y": 257,
    "GAME_DATE": 20130102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422797112398638440",
    "name": "The 2974 Collection #0468",
    "imageUrl": "https://arweave.net/ieE5ycY3ksJywcTCya5GK_p6D2k1w_sMwnD-V8norU4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 469,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 237,
    "LOC_Y": 45,
    "GAME_DATE": 20130102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373231758791734953",
    "name": "The 2974 Collection #0469",
    "imageUrl": "https://arweave.net/UAQN2yd1HHTR62VcAivbmthc8-rGSNP6PZ4Wj1mT6SU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 470,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 45,
    "GAME_DATE": 20130102,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361575305523292320",
    "name": "The 2974 Collection #0470",
    "imageUrl": "https://arweave.net/uDdeVaUhWju5cERc-xEWw464CbWp7O1NTn9RId5_MoU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 471,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 234,
    "LOC_Y": 63,
    "GAME_DATE": 20130105,
    "Season": "2012-2013",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495538015268377458",
    "name": "The 2974 Collection #0471",
    "imageUrl": "https://arweave.net/SprJh0uxdD1qbgY2BpwoMEmZ4SsgvRAGocN52j0MdAY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 472,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 15,
    "GAME_DATE": 20130109,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558644114898250760",
    "name": "The 2974 Collection #0472",
    "imageUrl": "https://arweave.net/YlQUS_VMXThPMiXQ0uNVeOagozy4vHSgp8lqYWrWToA?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 473,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 146,
    "LOC_Y": 216,
    "GAME_DATE": 20130109,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402722987265695311",
    "name": "The 2974 Collection #0473",
    "imageUrl": "https://arweave.net/YFBh7cEp4qqdgmm92U87sKPaOQxnYM4ke3zty0euwDE?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 474,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 217,
    "LOC_Y": 138,
    "GAME_DATE": 20130109,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521301558172172426",
    "name": "The 2974 Collection #0474",
    "imageUrl": "https://arweave.net/KTktx07dYX8pxvdDz_UgQYdpyNjhGX24k3nMJ1L-560?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 475,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 154,
    "LOC_Y": 222,
    "GAME_DATE": 20130109,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465734143332537301",
    "name": "The 2974 Collection #0475",
    "imageUrl": "https://arweave.net/DZWzlNZmynFIWD6wAUxdnNcv8qo6XBVGJ3haGsQP6Rs?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 476,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 0,
    "LOC_Y": 274,
    "GAME_DATE": 20130111,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/339825344245723712",
    "name": "The 2974 Collection #0476",
    "imageUrl": "https://arweave.net/0UVDHeCC8Nnl1YvbG_sipaPAUjlg_CUNGtDs10RVE9s?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 477,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -224,
    "LOC_Y": 47,
    "GAME_DATE": 20130111,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/350230390011901244",
    "name": "The 2974 Collection #0477",
    "imageUrl": "https://arweave.net/_q7NVO1H-j71Pm6ayAPDalEWnEusy1jEXsia6xd_1iY?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 478,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 147,
    "LOC_Y": 206,
    "GAME_DATE": 20130111,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/291885634590598704",
    "name": "The 2974 Collection #0478",
    "imageUrl": "https://arweave.net/qWbMkvFQOlggjJI4mmYHA7VhpW1sKWpkl7F9pBkEtpg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 479,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 237,
    "LOC_Y": 25,
    "GAME_DATE": 20130113,
    "Season": "2012-2013",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561740137475643700",
    "name": "The 2974 Collection #0479",
    "imageUrl": "https://arweave.net/Io8FqiYwqkmaHpmnREk7wJqXIz-ZNg7ER_mE1UrjueU?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2013,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 480,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 174,
    "LOC_Y": 179,
    "GAME_DATE": 20130113,
    "Season": "2012-2013",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/419185606991841828",
    "name": "The 2974 Collection #0480",
    "imageUrl": "https://arweave.net/eWpDzL0xdgCUyWdl19BNVIumAMqmCUbz_TgbMB3Kefo?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2013,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 481,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -242,
    "LOC_Y": -13,
    "GAME_DATE": 20130113,
    "Season": "2012-2013",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519785562238711626",
    "name": "The 2974 Collection #0481",
    "imageUrl": "https://arweave.net/e__0YnGsa1X4JmOlVE_ytmCzetDBeG4yPLrQimo827U?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2013,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 482,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 220,
    "LOC_Y": 126,
    "GAME_DATE": 20130113,
    "Season": "2012-2013",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497918159029290836",
    "name": "The 2974 Collection #0482",
    "imageUrl": "https://arweave.net/8SLeMXFtBsk5Wj1IInuu73MIsHAZ5ePZtZLh5CItwFU?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2013,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 483,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 91,
    "LOC_Y": 250,
    "GAME_DATE": 20130113,
    "Season": "2012-2013",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/333961348722367339",
    "name": "The 2974 Collection #0483",
    "imageUrl": "https://arweave.net/aQTy37yOWwvRFlB7SQFKYPfq_OP-ch-_9WqB-9caNxg?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2013,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 484,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 237,
    "LOC_Y": -5,
    "GAME_DATE": 20130113,
    "Season": "2012-2013",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/564274874294463425",
    "name": "The 2974 Collection #0484",
    "imageUrl": "https://arweave.net/KbFqqqRDZRb4a3-6WlyUHGjW9WihiM4hySrmVb1vYYY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2013,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 485,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 159,
    "LOC_Y": 200,
    "GAME_DATE": 20130113,
    "Season": "2012-2013",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/571261311487346633",
    "name": "The 2974 Collection #0485",
    "imageUrl": "https://arweave.net/qrzJuk2oAvJZy38e2JjtkgXBZtb4cozOL_w0kMYtUjo?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2013,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 486,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -101,
    "LOC_Y": 230,
    "GAME_DATE": 20130119,
    "Season": "2012-2013",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489038053188784219",
    "name": "The 2974 Collection #0486",
    "imageUrl": "https://arweave.net/70iOLKmYuadymDQ1a0cmg3NVF6AOILesLCn-R8ngL94?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 1,
    "Day": 19,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 487,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -128,
    "LOC_Y": 219,
    "GAME_DATE": 20130119,
    "Season": "2012-2013",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/452002365241935405",
    "name": "The 2974 Collection #0487",
    "imageUrl": "https://arweave.net/spw3eJJaEI--nL8bWuXQM2bzmrMQi0aBtb7dw7BaCz0?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 1,
    "Day": 19,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 488,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 130,
    "LOC_Y": 238,
    "GAME_DATE": 20130121,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352170451502398594",
    "name": "The 2974 Collection #0488",
    "imageUrl": "https://arweave.net/Qw7YrtLe-WHmvqQHeAVRoxa95FCxfN4wT1_oIKq-Pmg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 489,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 121,
    "LOC_Y": 239,
    "GAME_DATE": 20130121,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/316024194802844028",
    "name": "The 2974 Collection #0489",
    "imageUrl": "https://arweave.net/y4R8eF3XcbNrFT3j0fp7Dwvwo3g1dZNaBZpLGrKGfOw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 490,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 203,
    "LOC_Y": 198,
    "GAME_DATE": 20130121,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/571597384651236422",
    "name": "The 2974 Collection #0490",
    "imageUrl": "https://arweave.net/BokANMDsGHl5_DmXPnWVLduSzESiHYMbr8z3a45hA6U?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 491,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 230,
    "LOC_Y": 74,
    "GAME_DATE": 20130121,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/457391638948780791",
    "name": "The 2974 Collection #0491",
    "imageUrl": "https://arweave.net/XuZO5VYLfrCt8bJqAgy6ETmQqJPTT5z0918uH2l0a-g?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 492,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 182,
    "LOC_Y": 213,
    "GAME_DATE": 20130121,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513554456496666546",
    "name": "The 2974 Collection #0492",
    "imageUrl": "https://arweave.net/cLGASPm4hblC7w2by3zt-kbdEVpPgb1A4qBqXuybuvA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 493,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 190,
    "LOC_Y": 190,
    "GAME_DATE": 20130121,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/445841297046365477",
    "name": "The 2974 Collection #0493",
    "imageUrl": "https://arweave.net/JhXI83N44Cb_F6FSLjV3vrnk81O7NrVcEoMypAW6Th0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 494,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -201,
    "LOC_Y": 160,
    "GAME_DATE": 20130123,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/431926201987381709",
    "name": "The 2974 Collection #0494",
    "imageUrl": "https://arweave.net/OMABayW3Tf-Y8c0mKrxF2qes2LXgqGkb3UKWiHSywT4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 495,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 239,
    "LOC_Y": 23,
    "GAME_DATE": 20130123,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490381134196516945",
    "name": "The 2974 Collection #0495",
    "imageUrl": "https://arweave.net/kp79ttW4mUpqTKLw-6gRj3IqGyL4Su8PIlaq9G02Oxg?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 496,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -139,
    "LOC_Y": 216,
    "GAME_DATE": 20130123,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412913989023169213",
    "name": "The 2974 Collection #0496",
    "imageUrl": "https://arweave.net/ibnRvv2c2EOSHb4yFSp10sM5htYujaAqeDMCN2KeVZY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 497,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": -16,
    "GAME_DATE": 20130125,
    "Season": "2012-2013",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412110561167012717",
    "name": "The 2974 Collection #0497",
    "imageUrl": "https://arweave.net/ldBMtgX6r7nF0hDp9csJ4fYKiSAWnT-HGrcJ2MsJOGM?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2013,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 498,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 170,
    "LOC_Y": 192,
    "GAME_DATE": 20130125,
    "Season": "2012-2013",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562149375286429670",
    "name": "The 2974 Collection #0498",
    "imageUrl": "https://arweave.net/hAwkelMB_30BCQS1Y5EsPnfyiwflJz7Bvm7xRa-vNy4?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2013,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 499,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 176,
    "LOC_Y": 172,
    "GAME_DATE": 20130125,
    "Season": "2012-2013",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476749488804314663",
    "name": "The 2974 Collection #0499",
    "imageUrl": "https://arweave.net/unudtoMCIwPIK_NimGKoTtDhm6arrrsuw7c1KiElIxM?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2013,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 500,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 236,
    "LOC_Y": 63,
    "GAME_DATE": 20130126,
    "Season": "2012-2013",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480852596341250776",
    "name": "The 2974 Collection #0500",
    "imageUrl": "https://arweave.net/v8gBRxcX0RD7rNEEdO0a-2edkjTlvpn5NzwQRiPFTmU?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2013,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 501,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 193,
    "LOC_Y": 172,
    "GAME_DATE": 20130126,
    "Season": "2012-2013",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456032107592014082",
    "name": "The 2974 Collection #0501",
    "imageUrl": "https://arweave.net/KywOObPM8JNkBB58DLuaiJS0AztlNB1aWmY3CPmYjyM?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2013,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 502,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 9,
    "GAME_DATE": 20130126,
    "Season": "2012-2013",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417306988475080068",
    "name": "The 2974 Collection #0502",
    "imageUrl": "https://arweave.net/e06LfOHRT1xKkxwAOJw8pzpcVIQWTC_jIidwM7agKto?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2013,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 503,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -217,
    "LOC_Y": 140,
    "GAME_DATE": 20130126,
    "Season": "2012-2013",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422064430858517775",
    "name": "The 2974 Collection #0503",
    "imageUrl": "https://arweave.net/oLt9dxrvZWrgfqMlSa8wBS2mdbKc4ApibUw78ZVuSAQ?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2013,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 504,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -223,
    "LOC_Y": 50,
    "GAME_DATE": 20130126,
    "Season": "2012-2013",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/534713309138070773",
    "name": "The 2974 Collection #0504",
    "imageUrl": "https://arweave.net/2xNcMSt5GDwJEMnDPHn9TW7CG24fhGylOodPKD_AsOI?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2013,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 505,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 1,
    "LOC_Y": 285,
    "GAME_DATE": 20130128,
    "Season": "2012-2013",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317927688367884373",
    "name": "The 2974 Collection #0505",
    "imageUrl": "https://arweave.net/J7jpWbuDM9YcgBMr6vI5IolFQlBlofO9WFh96nRC_o8?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2013,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 506,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -153,
    "LOC_Y": 217,
    "GAME_DATE": 20130202,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321208664875708508",
    "name": "The 2974 Collection #0506",
    "imageUrl": "https://arweave.net/szrCOTc8C1CVAKHBHTtgI0Zx2Dz-u0cup3OvN_kHhKg?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 507,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -103,
    "LOC_Y": 242,
    "GAME_DATE": 20130202,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/545498750750239175",
    "name": "The 2974 Collection #0507",
    "imageUrl": "https://arweave.net/efAl3y9t6zkcMH4gsJy7-S6q7j0eC7jDNsfqmVngoaw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 508,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -19,
    "LOC_Y": 265,
    "GAME_DATE": 20130202,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/560345217406893515",
    "name": "The 2974 Collection #0508",
    "imageUrl": "https://arweave.net/sHRuNUPIUe7yNHLKrKPw2hgvozzl5c6mLpqbCu0r2AA?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 509,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -7,
    "LOC_Y": 268,
    "GAME_DATE": 20130202,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295654148504933741",
    "name": "The 2974 Collection #0509",
    "imageUrl": "https://arweave.net/-Wr-Rg-ApCDJEFh28It7tLCs19oc6mcudoNmDKIXJJM?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 510,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -240,
    "LOC_Y": 19,
    "GAME_DATE": 20130202,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/316919322245325612",
    "name": "The 2974 Collection #0510",
    "imageUrl": "https://arweave.net/rKfmC2omYQjSH4AGZqUZeOKQrz0D-x85afpt2ZcUxno?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 511,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 154,
    "LOC_Y": 225,
    "GAME_DATE": 20130202,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395897262614635428",
    "name": "The 2974 Collection #0511",
    "imageUrl": "https://arweave.net/wnWct5rak6JtvU_2GdlDcUUe5i5U6azftf_3_5mE_uU?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 512,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 43,
    "LOC_X": 192,
    "LOC_Y": 389,
    "GAME_DATE": 20130205,
    "Season": "2012-2013",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/488517260051088520",
    "name": "The 2974 Collection #0512",
    "imageUrl": "https://arweave.net/4LUz1lCGZdl-YH34cTYuJcydzAjFC-Ycpr9zeFb17hY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 2,
    "Day": 5,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 513,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 36,
    "LOC_Y": 238,
    "GAME_DATE": 20130206,
    "Season": "2012-2013",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429996266442376524",
    "name": "The 2974 Collection #0513",
    "imageUrl": "https://arweave.net/nNuZHO9V4Oavgx0RMBg6fveJMP0zmKSwKkHYeRgs8Q4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 514,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -229,
    "LOC_Y": 0,
    "GAME_DATE": 20130206,
    "Season": "2012-2013",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290570299377649106",
    "name": "The 2974 Collection #0514",
    "imageUrl": "https://arweave.net/HDfc5_LL702GGROBNvnJ4vFDXzf7NJg2iTMAW0hHIzI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 515,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 26,
    "LOC_Y": 247,
    "GAME_DATE": 20130208,
    "Season": "2012-2013",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/329531880313321219",
    "name": "The 2974 Collection #0515",
    "imageUrl": "https://arweave.net/aMoglI2gODwSMdMEV5niYIaGqbpSn0ORgEoQMGMWCk4?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 516,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -139,
    "LOC_Y": 201,
    "GAME_DATE": 20130208,
    "Season": "2012-2013",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552216158269612886",
    "name": "The 2974 Collection #0516",
    "imageUrl": "https://arweave.net/xTcZeqSQLiGrFiBNNOD9Z_JQwfBrRswMydtNFoDVb2o?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 517,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 189,
    "LOC_Y": 173,
    "GAME_DATE": 20130208,
    "Season": "2012-2013",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353985701197522385",
    "name": "The 2974 Collection #0517",
    "imageUrl": "https://arweave.net/6zRzV30oF78wijWxh9vgeGRH591aIheZdzqpLXUBXIc?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 518,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 162,
    "LOC_Y": 178,
    "GAME_DATE": 20130208,
    "Season": "2012-2013",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397594507668303124",
    "name": "The 2974 Collection #0518",
    "imageUrl": "https://arweave.net/x9O1Gy1tufJVfJeVLXxT7pI8t2G2AVMU069D8ZAA4-Q?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 519,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 159,
    "LOC_Y": 224,
    "GAME_DATE": 20130209,
    "Season": "2012-2013",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479382528630524847",
    "name": "The 2974 Collection #0519",
    "imageUrl": "https://arweave.net/vZ1151pM2g_fefaQQVG31Ul2EF1cV8XYYKQucrSpl_c?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 520,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -183,
    "LOC_Y": 173,
    "GAME_DATE": 20130212,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481734436442522779",
    "name": "The 2974 Collection #0520",
    "imageUrl": "https://arweave.net/V0K5_pMnjF_63CMjo9_l-acSbZGDquQkV8_GylxO-6Y?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 521,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 192,
    "LOC_Y": 200,
    "GAME_DATE": 20130212,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/507000684695918685",
    "name": "The 2974 Collection #0521",
    "imageUrl": "https://arweave.net/KwFD8tI3XsgUSIfM8Lti2gngFkEDiAvawj1MgD2lcmk?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 522,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -89,
    "LOC_Y": 225,
    "GAME_DATE": 20130219,
    "Season": "2012-2013",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439053669493828982",
    "name": "The 2974 Collection #0522",
    "imageUrl": "https://arweave.net/xntjsL00Q6JR4ZoUC7D5gs7GpFJgBRsPr4KeuosSQpI?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 523,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 58,
    "LOC_Y": 244,
    "GAME_DATE": 20130219,
    "Season": "2012-2013",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440653884413112060",
    "name": "The 2974 Collection #0523",
    "imageUrl": "https://arweave.net/qaYY6zLB4EXEXb8mE-5WtbmD9vT5p5sZvR-mMwlJZOc?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 524,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 154,
    "LOC_Y": 195,
    "GAME_DATE": 20130219,
    "Season": "2012-2013",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450942045713973647",
    "name": "The 2974 Collection #0524",
    "imageUrl": "https://arweave.net/VY6Dw1TVNRCl71fFtOTg3Dnbtn28aBkCGI2kZ6BKEsY?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 525,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 135,
    "LOC_Y": 205,
    "GAME_DATE": 20130219,
    "Season": "2012-2013",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/306329618089591993",
    "name": "The 2974 Collection #0525",
    "imageUrl": "https://arweave.net/rS1t7DrMs7G3YS944xMUpH2fX7ezAxya53U0l_auFXU?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 526,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 84,
    "LOC_Y": 254,
    "GAME_DATE": 20130220,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/304101608893469104",
    "name": "The 2974 Collection #0526",
    "imageUrl": "https://arweave.net/SnvzylnNUTwRYoMHwxHSbV-bseEyRybNnJF7cXaOMnA?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 527,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -79,
    "LOC_Y": 247,
    "GAME_DATE": 20130220,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/377501043503564631",
    "name": "The 2974 Collection #0527",
    "imageUrl": "https://arweave.net/EClpShHlODOg7JBrhkXWH3fQatDbYO3I8ojVg73Wcuw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 528,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 223,
    "LOC_Y": 145,
    "GAME_DATE": 20130222,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302622996655827591",
    "name": "The 2974 Collection #0528",
    "imageUrl": "https://arweave.net/EWIHMsw2wfCPr50uPWjUuU3JF1pKPanUbETZ9NyE84w?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 529,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 83,
    "LOC_Y": 255,
    "GAME_DATE": 20130222,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/325492126928750091",
    "name": "The 2974 Collection #0529",
    "imageUrl": "https://arweave.net/TIH35rYRXPUjqy_sBnpN-S-mNMpRb8I9lQ_8LqNKSTk?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 530,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -209,
    "LOC_Y": 200,
    "GAME_DATE": 20130222,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434416763300425125",
    "name": "The 2974 Collection #0530",
    "imageUrl": "https://arweave.net/MdQO_XJPSLCzvFjumHEax5iiJF8eN7ndfa51FhdAF5Q?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 531,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 138,
    "LOC_Y": 198,
    "GAME_DATE": 20130224,
    "Season": "2012-2013",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397643679811961454",
    "name": "The 2974 Collection #0531",
    "imageUrl": "https://arweave.net/2me-i4-tZZndEM3d3zBjTvzu_FeRfuncCQ4sXKtUBcE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2013,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 532,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 190,
    "LOC_Y": 181,
    "GAME_DATE": 20130226,
    "Season": "2012-2013",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355916517241913074",
    "name": "The 2974 Collection #0532",
    "imageUrl": "https://arweave.net/Nb7ezHpyLjgeh34tMf6G-UU0zBls2OY0bKrAB1pnryc?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2013,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 533,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 138,
    "LOC_Y": 220,
    "GAME_DATE": 20130226,
    "Season": "2012-2013",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540202871959226359",
    "name": "The 2974 Collection #0533",
    "imageUrl": "https://arweave.net/SuuOgC46IqbTWdPq67il1IE-sMukYSbgr0m-U0W5HE8?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2013,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 534,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 2,
    "LOC_Y": 260,
    "GAME_DATE": 20130226,
    "Season": "2012-2013",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520443969981589040",
    "name": "The 2974 Collection #0534",
    "imageUrl": "https://arweave.net/AKYPlI1roUNWSGDlUzwgPYI3iEcM-QJy7rEk2s9r8y0?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2013,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 535,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 185,
    "LOC_Y": 172,
    "GAME_DATE": 20130226,
    "Season": "2012-2013",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/506959956659271942",
    "name": "The 2974 Collection #0535",
    "imageUrl": "https://arweave.net/5a0MirlZnHTvzVvJEN72XglQMfRORY3dt6iR4_e6AR0?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2013,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 536,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 141,
    "LOC_Y": 213,
    "GAME_DATE": 20130226,
    "Season": "2012-2013",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438179561799686367",
    "name": "The 2974 Collection #0536",
    "imageUrl": "https://arweave.net/SPTxY7hXRbNX2o3IHvWJhj4f8v1wZJPxik6mUlJ9GLo?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2013,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 537,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 6,
    "LOC_Y": 247,
    "GAME_DATE": 20130226,
    "Season": "2012-2013",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468486138853155018",
    "name": "The 2974 Collection #0537",
    "imageUrl": "https://arweave.net/-yo6hadCsns6ywKZ5O7oOyDFboBq0_sOgPW3vCkzw7c?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2013,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 538,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 118,
    "LOC_Y": 236,
    "GAME_DATE": 20130226,
    "Season": "2012-2013",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547270156519922076",
    "name": "The 2974 Collection #0538",
    "imageUrl": "https://arweave.net/ePtZiI61zHx8xm0ATdUwVDuPsgiRgzNck5_1-jSncj4?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2013,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 539,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": -41,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/380285400318349439",
    "name": "The 2974 Collection #0539",
    "imageUrl": "https://arweave.net/Wt1cUWE28B-Fv0OHiuTQseMGmWPcHevFQtn9hpiizL0?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 540,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 201,
    "LOC_Y": 197,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344209714875721432",
    "name": "The 2974 Collection #0540",
    "imageUrl": "https://arweave.net/Gsr-0RaZMYHSWuKE4LHSPm0ypYQ6Pay3GHQawLXCs_0?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 541,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 234,
    "LOC_Y": 78,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299231370304575390",
    "name": "The 2974 Collection #0541",
    "imageUrl": "https://arweave.net/kwxQf-EaiOur8Cl0NPJa7A2pi7_DWgnbpidKtoUlwkU?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 542,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 110,
    "LOC_Y": 225,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/506749302495563958",
    "name": "The 2974 Collection #0542",
    "imageUrl": "https://arweave.net/WWqaKSXQUbEv_ggloEaAxIkYPsFIa4kWB2_b_zB7lkE?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 543,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -229,
    "LOC_Y": -8,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/425550143647906113",
    "name": "The 2974 Collection #0543",
    "imageUrl": "https://arweave.net/dxLNbSiE8bk_78kjf5ivEEkjHvXV3H-NFB_GGHiDnVE?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 544,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 177,
    "LOC_Y": 175,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/345676335569312938",
    "name": "The 2974 Collection #0544",
    "imageUrl": "https://arweave.net/plAn1yVlPH-O7MBUIV6RMUNvM7Sd1k0hN-Uz9_iPegY?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 545,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 132,
    "LOC_Y": 238,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515542403753803427",
    "name": "The 2974 Collection #0545",
    "imageUrl": "https://arweave.net/xpbPUDdO1gl9xk14dK4vKS4oAgUkSQR7ljFTAd6DRD0?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 546,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 196,
    "LOC_Y": 162,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428654334100746748",
    "name": "The 2974 Collection #0546",
    "imageUrl": "https://arweave.net/pe9S038_bqd4gL6xoD0aj_rY7O0rIKWOrcbaG5xIVk8?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 547,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 212,
    "LOC_Y": 119,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382469660719432134",
    "name": "The 2974 Collection #0547",
    "imageUrl": "https://arweave.net/4ewQ_aVq6qfZnvaJCsaKhN9t6geUnHVSBhPFs986vJI?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 548,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 185,
    "LOC_Y": 173,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297612528904729426",
    "name": "The 2974 Collection #0548",
    "imageUrl": "https://arweave.net/5CSemLNjCtx_Qacl5vfPm6gceajXeedZ_CCJDllFanU?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 549,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 207,
    "LOC_Y": 140,
    "GAME_DATE": 20130227,
    "Season": "2012-2013",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568907580357475281",
    "name": "The 2974 Collection #0549",
    "imageUrl": "https://arweave.net/VTe5AFgnBiLbmm3zLRCBOF1P-veJ2yDsAh60mujJnYY?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 550,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 168,
    "LOC_Y": 192,
    "GAME_DATE": 20130301,
    "Season": "2012-2013",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/466468846007879618",
    "name": "The 2974 Collection #0550",
    "imageUrl": "https://arweave.net/NruEPKStZUVG6jcgvw3OsOzK7BBeOxSHOfhtpI0bzwY?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2013,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 551,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 230,
    "LOC_Y": 102,
    "GAME_DATE": 20130301,
    "Season": "2012-2013",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379780696734794782",
    "name": "The 2974 Collection #0551",
    "imageUrl": "https://arweave.net/wu14GIwC1EoZ1KN-Hd5fiksiut34OXyADHeaHoRrTOw?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2013,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 552,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -70,
    "LOC_Y": 246,
    "GAME_DATE": 20130301,
    "Season": "2012-2013",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539931976753017974",
    "name": "The 2974 Collection #0552",
    "imageUrl": "https://arweave.net/bA8Q3yLpIKEqC9Cw3cEz0dK5vUPZm-1dXaSB7at4RUc?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2013,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 553,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -166,
    "LOC_Y": 178,
    "GAME_DATE": 20130302,
    "Season": "2012-2013",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355991736519149462",
    "name": "The 2974 Collection #0553",
    "imageUrl": "https://arweave.net/agDcKC2-D8rtP0m0Wexe39LuJTRkXHidHivyXp6slbA?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2013,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 554,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 40,
    "LOC_Y": 239,
    "GAME_DATE": 20130302,
    "Season": "2012-2013",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353695450850519322",
    "name": "The 2974 Collection #0554",
    "imageUrl": "https://arweave.net/Spjum-DYj7cYhLWlT4IvpI-NFd7ZOXIovSHjUTOtZX8?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2013,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 555,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 110,
    "LOC_Y": 222,
    "GAME_DATE": 20130302,
    "Season": "2012-2013",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533666052108001015",
    "name": "The 2974 Collection #0555",
    "imageUrl": "https://arweave.net/odlWBhUAs55F5ZJ2clDZ_UPQnqNpuI0VxfaBuWPJ5GQ?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2013,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 556,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 30,
    "GAME_DATE": 20130304,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/345007987860980819",
    "name": "The 2974 Collection #0556",
    "imageUrl": "https://arweave.net/v4uT8nXa9by-Mui2OHfXiaImOQgQL3VCn6hx5YZy8X0?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2013,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 557,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 189,
    "LOC_Y": 187,
    "GAME_DATE": 20130304,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531400451150913084",
    "name": "The 2974 Collection #0557",
    "imageUrl": "https://arweave.net/QHjyTjCIcx80VGGdBdUSOFPte4S70Wn6qW_2isF61MM?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2013,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 558,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -105,
    "LOC_Y": 254,
    "GAME_DATE": 20130306,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/453736592864087161",
    "name": "The 2974 Collection #0558",
    "imageUrl": "https://arweave.net/daxiNj3k6sjQUkpQVF093nbNx7uQaBiU3R0iacU07nE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 559,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 48,
    "LOC_Y": 266,
    "GAME_DATE": 20130306,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344493296877054763",
    "name": "The 2974 Collection #0559",
    "imageUrl": "https://arweave.net/n9j4HlEhZpEkcZXWTY-N_KVgH1KKrytwEUQbiUlsl6U?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 560,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -193,
    "LOC_Y": 186,
    "GAME_DATE": 20130308,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484581126829986563",
    "name": "The 2974 Collection #0560",
    "imageUrl": "https://arweave.net/JgkS4aPH5he4uGdcnYQYzCavv0RBKlLgwfDwPoqPYXY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 561,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 190,
    "LOC_Y": 201,
    "GAME_DATE": 20130308,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439818983113644554",
    "name": "The 2974 Collection #0561",
    "imageUrl": "https://arweave.net/WtbTGyWaIUhEMTdqj0tEqR93BARP02nNq5G_eW-pwII?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 562,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -98,
    "LOC_Y": 241,
    "GAME_DATE": 20130308,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417485459388721255",
    "name": "The 2974 Collection #0562",
    "imageUrl": "https://arweave.net/Uqr81IQJ1EMsTOz0RnQioDAEyF4FiApg9xSxCUketDU?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 563,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 177,
    "LOC_Y": 213,
    "GAME_DATE": 20130309,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349091946994145858",
    "name": "The 2974 Collection #0563",
    "imageUrl": "https://arweave.net/lnSGOC_hsHAwOuOhNGqwGWMMcI1END-oUy2Jjk7sNn4?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2013,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 564,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 72,
    "LOC_Y": 266,
    "GAME_DATE": 20130309,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/380057842251927866",
    "name": "The 2974 Collection #0564",
    "imageUrl": "https://arweave.net/KIUKbbzdcBPTffIdq1EwZnqu4Xbi5vJfWNgAtLR8IlQ?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2013,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 565,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -105,
    "LOC_Y": 239,
    "GAME_DATE": 20130311,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/483672192770356834",
    "name": "The 2974 Collection #0565",
    "imageUrl": "https://arweave.net/o3zJxlBkMmFDr8jRyKtngGadllnFDlJjZsALPsp7L94?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 566,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -229,
    "LOC_Y": 6,
    "GAME_DATE": 20130311,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296699862957926532",
    "name": "The 2974 Collection #0566",
    "imageUrl": "https://arweave.net/VR1Pdg2KO5BLWwyxtnSridPqV9_V6U6JytQ9IP9TAEg?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 567,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -43,
    "LOC_Y": 255,
    "GAME_DATE": 20130311,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/416412263028899730",
    "name": "The 2974 Collection #0567",
    "imageUrl": "https://arweave.net/7jO-cNGay7WWY2AWcNFJ6uDd1C3I22YUF11UsNeAu_k?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 568,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 220,
    "LOC_Y": 129,
    "GAME_DATE": 20130311,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566768673380296969",
    "name": "The 2974 Collection #0568",
    "imageUrl": "https://arweave.net/QoM6PUjvEPB9TWrihrSpqxWbjrw0imEoYzvjbtV2VRA?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 569,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -116,
    "LOC_Y": 247,
    "GAME_DATE": 20130311,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364508083558794962",
    "name": "The 2974 Collection #0569",
    "imageUrl": "https://arweave.net/VsfF45yM2kRjli10py2I5ogdAY27xK9_8OyVnyUALEo?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 570,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": -14,
    "GAME_DATE": 20130311,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520718243937252327",
    "name": "The 2974 Collection #0570",
    "imageUrl": "https://arweave.net/RHTekdlXZd9TrkM5OAHk0NjS_4WWAAttFuDVC5yRu-g?ext=png",
    "Opposing Team City": "New York",
    "Year": 2013,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 571,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 7,
    "GAME_DATE": 20130313,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441382148754421944",
    "name": "The 2974 Collection #0571",
    "imageUrl": "https://arweave.net/UY17QRVUbNKkcKxsEjn4Y9naQsAsuqUCBdGmV3I8UiM?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2013,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 572,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 122,
    "LOC_Y": 249,
    "GAME_DATE": 20130313,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301849473369218365",
    "name": "The 2974 Collection #0572",
    "imageUrl": "https://arweave.net/uQ_YXpUgW-HAflYek-dP3HxvOMwjPqa_UHh1xneCoX0?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2013,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 573,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -199,
    "LOC_Y": 181,
    "GAME_DATE": 20130313,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/405229570961761566",
    "name": "The 2974 Collection #0573",
    "imageUrl": "https://arweave.net/CQB2O9SCZi8Gg9Bhbo-wMdycrxvKHVuOgnYS7w9eg2s?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2013,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 574,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -150,
    "LOC_Y": 217,
    "GAME_DATE": 20130313,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357184701242274279",
    "name": "The 2974 Collection #0574",
    "imageUrl": "https://arweave.net/pELngkPBBgHKFAKOumAwGqbcbfRdv1FZPZxLilvrA74?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2013,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 575,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 42,
    "LOC_Y": 269,
    "GAME_DATE": 20130313,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/471373030298241501",
    "name": "The 2974 Collection #0575",
    "imageUrl": "https://arweave.net/GdmD-iPnOEIs7buQM2NSBaftAvM3fYjrQ8Djr9f3X-E?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2013,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 576,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 187,
    "LOC_Y": 170,
    "GAME_DATE": 20130317,
    "Season": "2012-2013",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327708762546763676",
    "name": "The 2974 Collection #0576",
    "imageUrl": "https://arweave.net/qyIwH03BNvZMZ58fY4ApjiFbczdhCUG6DP-PGDJNlKE?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 3,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 577,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 6,
    "GAME_DATE": 20130317,
    "Season": "2012-2013",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/506754465133451292",
    "name": "The 2974 Collection #0577",
    "imageUrl": "https://arweave.net/Tlq2GlMBIsS6qmoTzM_nNR--ySmkHLdGTrrtslrZ_Sg?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 3,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 578,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 9,
    "GAME_DATE": 20130317,
    "Season": "2012-2013",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479590333588475530",
    "name": "The 2974 Collection #0578",
    "imageUrl": "https://arweave.net/9t32yPj6TVs0wneyYQK0gpsYbgdKboBrwKwIFNcpdiY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 3,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 579,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -158,
    "LOC_Y": 198,
    "GAME_DATE": 20130317,
    "Season": "2012-2013",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508535106340183471",
    "name": "The 2974 Collection #0579",
    "imageUrl": "https://arweave.net/C3VbpnFAD0nywX7sKRvbW5U5VcX37UoEdvewNxlrHko?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 3,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 580,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 151,
    "LOC_Y": 197,
    "GAME_DATE": 20130317,
    "Season": "2012-2013",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355118607497398956",
    "name": "The 2974 Collection #0580",
    "imageUrl": "https://arweave.net/jnbY1CwFd2uHtfgtDjF2ajDNK5pVm_GBTZ0N5FuaUi4?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 3,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 581,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 155,
    "LOC_Y": 201,
    "GAME_DATE": 20130318,
    "Season": "2012-2013",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446903701547991440",
    "name": "The 2974 Collection #0581",
    "imageUrl": "https://arweave.net/7Y9PeszQDvSB7hjJb_hl270Zzh-rnbYBfGhtRSETiCY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 582,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 154,
    "LOC_Y": 219,
    "GAME_DATE": 20130318,
    "Season": "2012-2013",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406171947081416470",
    "name": "The 2974 Collection #0582",
    "imageUrl": "https://arweave.net/dfd0pabZ8G3bit2puu0w2Z532-ACl2nZ9Mafq5SYiwM?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 583,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -48,
    "LOC_Y": 258,
    "GAME_DATE": 20130318,
    "Season": "2012-2013",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297109096276323937",
    "name": "The 2974 Collection #0583",
    "imageUrl": "https://arweave.net/4ATZ8c8hyaq_sAsIOk8YfMjshMN-i71ngpcTJ_lt27A?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 584,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -168,
    "LOC_Y": 187,
    "GAME_DATE": 20130318,
    "Season": "2012-2013",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/466085281104402959",
    "name": "The 2974 Collection #0584",
    "imageUrl": "https://arweave.net/q6p1fadwZ3ehgU2BLCmhbjDQjIosSGCy_H6Tg8N_S7g?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 585,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -100,
    "LOC_Y": 277,
    "GAME_DATE": 20130318,
    "Season": "2012-2013",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385508248975944601",
    "name": "The 2974 Collection #0585",
    "imageUrl": "https://arweave.net/c9k-W8tHdJv3ey0BKdA67DvdYs2-KSJ99K2WM87W7ts?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 586,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 223,
    "LOC_Y": 11,
    "GAME_DATE": 20130318,
    "Season": "2012-2013",
    "HTM": "NOH",
    "VTM": "GSW",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312136388524975035",
    "name": "The 2974 Collection #0586",
    "imageUrl": "https://arweave.net/bZNOZIr6Q1KjwGdp1ZJV1YbNMk9erWPgKIRDV-uHrnM?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 587,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -183,
    "LOC_Y": 168,
    "GAME_DATE": 20130320,
    "Season": "2012-2013",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/542331259493754316",
    "name": "The 2974 Collection #0587",
    "imageUrl": "https://arweave.net/VFyVpilISglZhnq-VYAjPYTLU9k55IH9z4uaKewuGjo?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 588,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": 45,
    "GAME_DATE": 20130320,
    "Season": "2012-2013",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479684344508066202",
    "name": "The 2974 Collection #0588",
    "imageUrl": "https://arweave.net/Vd3zDy8akAj_jgjbZYl0veiTwLV_gis0yny2OGKGzBA?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 589,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 174,
    "LOC_Y": 189,
    "GAME_DATE": 20130320,
    "Season": "2012-2013",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407870607701182968",
    "name": "The 2974 Collection #0589",
    "imageUrl": "https://arweave.net/jACACkkR4fMteszF6vdz175GgMquF8GjnIPJ6DY7yUw?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 590,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": 7,
    "GAME_DATE": 20130320,
    "Season": "2012-2013",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309621759354906757",
    "name": "The 2974 Collection #0590",
    "imageUrl": "https://arweave.net/5-3P35cXk3vTK1EtowivEkCOSBchHiZMVfTc-8iC0Mo?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 591,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -11,
    "LOC_Y": 276,
    "GAME_DATE": 20130323,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/442506497888467908",
    "name": "The 2974 Collection #0591",
    "imageUrl": "https://arweave.net/nljiZK1BZ6YOD1-_i00lU66ryl34GZKGCajcjr2zKwQ?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2013,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 592,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 168,
    "LOC_Y": 208,
    "GAME_DATE": 20130323,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323705070645852875",
    "name": "The 2974 Collection #0592",
    "imageUrl": "https://arweave.net/Gt7-9-enZZlh23ErHPq9De1xvLhNULSJB6BVFx0Dpjc?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2013,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 593,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 122,
    "LOC_Y": 246,
    "GAME_DATE": 20130323,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478811597487438639",
    "name": "The 2974 Collection #0593",
    "imageUrl": "https://arweave.net/CNUp2TzVJwqwXKlzpaL1-arfe0SOXtwUBq9aPLsGYu4?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2013,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 594,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 54,
    "LOC_Y": 260,
    "GAME_DATE": 20130323,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373783298701256959",
    "name": "The 2974 Collection #0594",
    "imageUrl": "https://arweave.net/a10aKBoRRoKAcQQmYT7m-Dgbf6dPPBr8KR3z3Qb_4Gg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2013,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 595,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -101,
    "LOC_Y": 242,
    "GAME_DATE": 20130323,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299084343526495437",
    "name": "The 2974 Collection #0595",
    "imageUrl": "https://arweave.net/ep7dYrNhvooM8o3eua9AMKGlOmzAxg6dF9IvDQJ14UY?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2013,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 596,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 119,
    "LOC_Y": 241,
    "GAME_DATE": 20130323,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546197065332868139",
    "name": "The 2974 Collection #0596",
    "imageUrl": "https://arweave.net/cIfEB7Ux0SZ8l02x4zEu45mehO638-N27LVgsrPqZcE?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2013,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 597,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 4,
    "GAME_DATE": 20130325,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373904183047310651",
    "name": "The 2974 Collection #0597",
    "imageUrl": "https://arweave.net/gB0UHaPSzSaLxg-BYWKCCeWrEOj6dJuCSh2VP10J1Vo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 598,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 209,
    "LOC_Y": 153,
    "GAME_DATE": 20130325,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562848454288583297",
    "name": "The 2974 Collection #0598",
    "imageUrl": "https://arweave.net/PF4meRFuVvPRAAzUvwcxUceZUTniPfG9CjgkoO4zHvE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 599,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 179,
    "LOC_Y": 181,
    "GAME_DATE": 20130325,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/399991708831799639",
    "name": "The 2974 Collection #0599",
    "imageUrl": "https://arweave.net/vqeUr42Og04bwHAncIDN-zcLSxWpXH4pChO5vWpCGKo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 600,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -166,
    "LOC_Y": 201,
    "GAME_DATE": 20130327,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407721727250956378",
    "name": "The 2974 Collection #0600",
    "imageUrl": "https://arweave.net/OtyfH9G-yUoHjSDZqNSNhzsnH5a9PFLCc0Hc3X3Pd3g?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 601,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 237,
    "LOC_Y": 0,
    "GAME_DATE": 20130327,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/517780204924905150",
    "name": "The 2974 Collection #0601",
    "imageUrl": "https://arweave.net/NwqbuVAEIRhpYwu6ZbYAXFN1MsbwsPTxVar7c5ytpZE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 602,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -30,
    "LOC_Y": 263,
    "GAME_DATE": 20130330,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400022998384556673",
    "name": "The 2974 Collection #0602",
    "imageUrl": "https://arweave.net/0gployFn4jn5CHBcv7twPoLHq3AnPUpLPrHQCWLP1NU?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 603,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -196,
    "LOC_Y": 160,
    "GAME_DATE": 20130330,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548413984374258373",
    "name": "The 2974 Collection #0603",
    "imageUrl": "https://arweave.net/fVlQaNrfVxorDo3KZ5537qaaPB201oSonHv3ppyNPRk?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 604,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -218,
    "LOC_Y": 113,
    "GAME_DATE": 20130330,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366171847565408329",
    "name": "The 2974 Collection #0604",
    "imageUrl": "https://arweave.net/IOUY2oods719Ht6ppYKQDbIWBeysEZP8M-d0ovmKJWo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 605,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -158,
    "LOC_Y": 190,
    "GAME_DATE": 20130330,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/437658099259347180",
    "name": "The 2974 Collection #0605",
    "imageUrl": "https://arweave.net/Kfty0WbMCorB6GIBnSuyiNTWyVSxuWrjGjLIi4yVXGQ?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 606,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 81,
    "LOC_Y": 261,
    "GAME_DATE": 20130330,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363568334617882072",
    "name": "The 2974 Collection #0606",
    "imageUrl": "https://arweave.net/p005YPFMy4DoBBhvfkE9Eq9CJoMY40tfdDOC9TWh040?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 607,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 62,
    "LOC_Y": 250,
    "GAME_DATE": 20130330,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/554748961676136831",
    "name": "The 2974 Collection #0607",
    "imageUrl": "https://arweave.net/E2qaZwXl96XlbTuC0vm7EYryNKvfpy6UGQtbsGRZrsU?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 608,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 140,
    "LOC_Y": 238,
    "GAME_DATE": 20130330,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341798045059144013",
    "name": "The 2974 Collection #0608",
    "imageUrl": "https://arweave.net/hTSdwcMT3BIC3G09UdG79gU_-5ZipBprLFeAR_7qrkg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 609,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -7,
    "LOC_Y": 255,
    "GAME_DATE": 20130403,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/396192597266626995",
    "name": "The 2974 Collection #0609",
    "imageUrl": "https://arweave.net/c1F_tAGQjSwPS4KUHjvXkW7FaTNtKykGEnK0tWAEhac?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 610,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 149,
    "LOC_Y": 220,
    "GAME_DATE": 20130403,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295627165035803855",
    "name": "The 2974 Collection #0610",
    "imageUrl": "https://arweave.net/rSU5cnzzeGk_IZzmzAa8LAmwLMHGqoIUiLEM_JhFMF0?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 611,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -168,
    "LOC_Y": 189,
    "GAME_DATE": 20130403,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308270914671395224",
    "name": "The 2974 Collection #0611",
    "imageUrl": "https://arweave.net/rx6YahxEapRkipoZLyow7CLwEJhAc9VN0T6vkVX1dgY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 612,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -65,
    "LOC_Y": 260,
    "GAME_DATE": 20130403,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "NOH",
    "Opposing Team": "NOH",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522354245945649629",
    "name": "The 2974 Collection #0612",
    "imageUrl": "https://arweave.net/NU4BXzzXs2Xtx7LP7SZlFpQlBt9S41_32FQCXG8av6k?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 613,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 179,
    "LOC_Y": 190,
    "GAME_DATE": 20130405,
    "Season": "2012-2013",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354497023650961897",
    "name": "The 2974 Collection #0613",
    "imageUrl": "https://arweave.net/be_Khn8qJf8Vq60QGdxGYmT8EqUZondroPZV-3Ss6Mw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 614,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 174,
    "LOC_Y": 183,
    "GAME_DATE": 20130405,
    "Season": "2012-2013",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562542131176623318",
    "name": "The 2974 Collection #0614",
    "imageUrl": "https://arweave.net/opmFDE3xgwbS8cMJvFv-V2Ti1eXKiZyYPNOVIRaUzUU?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 615,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 228,
    "LOC_Y": 45,
    "GAME_DATE": 20130405,
    "Season": "2012-2013",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566430208419969451",
    "name": "The 2974 Collection #0615",
    "imageUrl": "https://arweave.net/_L27NRQBiWN2FZQK3_s2kCkAcMdq70dMFPQDAPZKm4U?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 616,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -100,
    "LOC_Y": 231,
    "GAME_DATE": 20130407,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402780192731230501",
    "name": "The 2974 Collection #0616",
    "imageUrl": "https://arweave.net/BS-6EAmiPLEnNcR7aT471eu3Z8NW3nWp12WoAh8GsbE?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 617,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 222,
    "LOC_Y": 113,
    "GAME_DATE": 20130407,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407392941378821082",
    "name": "The 2974 Collection #0617",
    "imageUrl": "https://arweave.net/BqhSIWxUpqxNeF3fR4DE10EErtnbK2K5PLY6wlGm-_g?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 618,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -174,
    "LOC_Y": 203,
    "GAME_DATE": 20130407,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336780011022009076",
    "name": "The 2974 Collection #0618",
    "imageUrl": "https://arweave.net/GcGeDGyagQ7k80as6t9yKVdIKQvJTNmHmtIJ0UyQ_X0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 619,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 13,
    "LOC_Y": 249,
    "GAME_DATE": 20130407,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566954371893625409",
    "name": "The 2974 Collection #0619",
    "imageUrl": "https://arweave.net/qXjUc2K-z7-4XQEIitPMaU-3mhoKSwFP1nMz5gEUXe8?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 620,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 24,
    "LOC_Y": 276,
    "GAME_DATE": 20130409,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400812121328516170",
    "name": "The 2974 Collection #0620",
    "imageUrl": "https://arweave.net/tycgwLicOJF6OsuECFPTYFE-u4eh1SJ5YuyfbN53Gys?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2013,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 621,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -97,
    "LOC_Y": 241,
    "GAME_DATE": 20130409,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366262850830927635",
    "name": "The 2974 Collection #0621",
    "imageUrl": "https://arweave.net/t7jEeKhPmmHhwGEvIdw4Wmv1pMxZv4pzYw95XS-Ob0Y?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2013,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 622,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -183,
    "LOC_Y": 168,
    "GAME_DATE": 20130411,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556696966850278257",
    "name": "The 2974 Collection #0622",
    "imageUrl": "https://arweave.net/AiIawQSlue9empV-ih_u9PO3nYS3CfW4XcuDHdORbrQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 623,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -210,
    "LOC_Y": 146,
    "GAME_DATE": 20130411,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362418689787464393",
    "name": "The 2974 Collection #0623",
    "imageUrl": "https://arweave.net/aORPNHbwg10ibUOqkkZ4Jidx58QwqTchwjHDG9eQQcM?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 624,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -127,
    "LOC_Y": 242,
    "GAME_DATE": 20130411,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550131636790140078",
    "name": "The 2974 Collection #0624",
    "imageUrl": "https://arweave.net/X77Gdvf4saKnlujJyMkWaY59kQ5uqWtg0uR5HCfrj5w?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 625,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 31,
    "LOC_Y": 255,
    "GAME_DATE": 20130412,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/358210620728832244",
    "name": "The 2974 Collection #0625",
    "imageUrl": "https://arweave.net/B95J102JuYQA46HJ9XOV9tiPmCptWNNqV7FP094w3Lw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 626,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 89,
    "LOC_Y": 236,
    "GAME_DATE": 20130412,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326141636444994399",
    "name": "The 2974 Collection #0626",
    "imageUrl": "https://arweave.net/7yujOpDBZ8ESJJADP6Kr8IMx_VIomTVsANACoD_lqiM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 627,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 176,
    "LOC_Y": 181,
    "GAME_DATE": 20130412,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540768456639676137",
    "name": "The 2974 Collection #0627",
    "imageUrl": "https://arweave.net/iHnbiox4RH42UWC5OKOkRp-ZZ19xtni867Jo2vccwjA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 628,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -212,
    "LOC_Y": 137,
    "GAME_DATE": 20130412,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511727631290602292",
    "name": "The 2974 Collection #0628",
    "imageUrl": "https://arweave.net/RUDhryFPaR0HdAcgme_Wm6fVhm0BdnHRQnD-qgnZmvQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 629,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 37,
    "LOC_Y": 249,
    "GAME_DATE": 20130412,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/537416218740870070",
    "name": "The 2974 Collection #0629",
    "imageUrl": "https://arweave.net/ukwW2qTJDhNkHvXEIhcuIXnkvEX-2hng3UG5lphRfdQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 630,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 143,
    "LOC_Y": 200,
    "GAME_DATE": 20130412,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495090564210792538",
    "name": "The 2974 Collection #0630",
    "imageUrl": "https://arweave.net/N3Vpm7023IoEomcfWaE44O2l5F3FkxJ6zYkjtKXZW44?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 631,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 119,
    "LOC_Y": 219,
    "GAME_DATE": 20130412,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296769680265176310",
    "name": "The 2974 Collection #0631",
    "imageUrl": "https://arweave.net/lMp73fjAGQmU_eqj0HNqSij32XZvHFQ9o-1gjKnXpJI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 632,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 155,
    "LOC_Y": 190,
    "GAME_DATE": 20130412,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402385142404191771",
    "name": "The 2974 Collection #0632",
    "imageUrl": "https://arweave.net/KqIaDtLtfKzpWmjhQmUgTW8hH2o75xh92bB-XFL82kc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 633,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -164,
    "LOC_Y": 187,
    "GAME_DATE": 20130412,
    "Season": "2012-2013",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/545461722182731856",
    "name": "The 2974 Collection #0633",
    "imageUrl": "https://arweave.net/MEDs8UdzSIzPQQBCSyeuYTFJ_gqT9XTZe_DOBqUfHZw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 634,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 195,
    "LOC_Y": 195,
    "GAME_DATE": 20130415,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493691772656107168",
    "name": "The 2974 Collection #0634",
    "imageUrl": "https://arweave.net/FFQXDBEwe3sd6sQh8QIt-feGHzD68fVtgbirnohGCpk?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 635,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -67,
    "LOC_Y": 249,
    "GAME_DATE": 20130415,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/448897929117444526",
    "name": "The 2974 Collection #0635",
    "imageUrl": "https://arweave.net/0BjT65jKhgO4pmFI8BEoTex3EWUdb4zRxUuH5Aqh4R0?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 636,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 9,
    "GAME_DATE": 20130415,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568947685490076322",
    "name": "The 2974 Collection #0636",
    "imageUrl": "https://arweave.net/nAVdXzR0HW04szr9hiNOcb28x3XBtAu-lhv4LVzldlI?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 637,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -204,
    "LOC_Y": 176,
    "GAME_DATE": 20130415,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355145395644541359",
    "name": "The 2974 Collection #0637",
    "imageUrl": "https://arweave.net/C3CCsylpPlSf_XK24Zyvlx-DcFSZ8HmV9vYKEyC-9Ac?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 638,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": -3,
    "GAME_DATE": 20130415,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548092647080935444",
    "name": "The 2974 Collection #0638",
    "imageUrl": "https://arweave.net/QF7GpemeI32_kB2g0eQ8bdjR1JYhoBOsm9k_DrosSDo?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 639,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -136,
    "LOC_Y": 233,
    "GAME_DATE": 20130415,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415525304261595803",
    "name": "The 2974 Collection #0639",
    "imageUrl": "https://arweave.net/UExfkqkR4tpQua_mSHGStvhtp5emNKYl-0XG4CoJ7Io?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 640,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -90,
    "LOC_Y": 263,
    "GAME_DATE": 20130415,
    "Season": "2012-2013",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418036692762732898",
    "name": "The 2974 Collection #0640",
    "imageUrl": "https://arweave.net/xegMX_0q26BcDJGH0q3cetA07ojEYZW0RC_MSMasDms?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 641,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 50,
    "LOC_Y": 254,
    "GAME_DATE": 20130417,
    "Season": "2012-2013",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/467312864401707322",
    "name": "The 2974 Collection #0641",
    "imageUrl": "https://arweave.net/YOI3skgAtdjoHsNDZ9mp6RkG8mCgJ_D3denRvz8LTPw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 642,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 209,
    "LOC_Y": 154,
    "GAME_DATE": 20130417,
    "Season": "2012-2013",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521679253800845546",
    "name": "The 2974 Collection #0642",
    "imageUrl": "https://arweave.net/N2iyv1Q4B-ZQQYLHVKhqPO-h-lgRJuLAcXjBpcIUSaw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 643,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -75,
    "LOC_Y": 244,
    "GAME_DATE": 20130417,
    "Season": "2012-2013",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289236354146929097",
    "name": "The 2974 Collection #0643",
    "imageUrl": "https://arweave.net/9n3G7rY-KuOocxwcXpJ4YNK9b2Igm_hZa30A0iRb2EA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 644,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 30,
    "GAME_DATE": 20130417,
    "Season": "2012-2013",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349339926886356284",
    "name": "The 2974 Collection #0644",
    "imageUrl": "https://arweave.net/1X4YGU-NkZFocM1DmlOVxSnqUMSGQCFO2AkLmzBkPsE?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 645,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -86,
    "LOC_Y": 244,
    "GAME_DATE": 20131030,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/401390266929445399",
    "name": "The 2974 Collection #0645",
    "imageUrl": "https://arweave.net/IdO7ICiKfzytVA9sl8gbOl5xRnT7dzZ1dMl7wAF4gog?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 646,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -67,
    "LOC_Y": 247,
    "GAME_DATE": 20131030,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/467949601208037513",
    "name": "The 2974 Collection #0646",
    "imageUrl": "https://arweave.net/-8-x708ivZGNj-cnQ1OObX-zBOS5bUu4bDp8KchhC_8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 647,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 147,
    "LOC_Y": 194,
    "GAME_DATE": 20131031,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308653428665615811",
    "name": "The 2974 Collection #0647",
    "imageUrl": "https://arweave.net/I_Cm4VEW6udRui5MeJAiTNPzyO5mOSFJFTDZldCpbvU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 648,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -150,
    "LOC_Y": 190,
    "GAME_DATE": 20131031,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523289159707945564",
    "name": "The 2974 Collection #0648",
    "imageUrl": "https://arweave.net/IqcpqhXryU_3SMn_60evL4KP62T9FdkM1Kg_DinUMrY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 649,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 103,
    "LOC_Y": 241,
    "GAME_DATE": 20131031,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429699879526933187",
    "name": "The 2974 Collection #0649",
    "imageUrl": "https://arweave.net/GVM3C3zRlkQlQDzLQk5NhqQpWQApTBGnv74pbu4u5Dg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 650,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 151,
    "LOC_Y": 198,
    "GAME_DATE": 20131031,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502434419820478858",
    "name": "The 2974 Collection #0650",
    "imageUrl": "https://arweave.net/7dmQwE_xfB_zd0-qMP3lMA5crdf7Tl-Ga79a4V3j_H0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 651,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 198,
    "LOC_Y": 197,
    "GAME_DATE": 20131031,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474455607704040964",
    "name": "The 2974 Collection #0651",
    "imageUrl": "https://arweave.net/hnTVZLOFLlydWT14J9ZMOdDX-RXiSCTZpHgKKdtbfzM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 652,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 1,
    "GAME_DATE": 20131031,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/304879159850128339",
    "name": "The 2974 Collection #0652",
    "imageUrl": "https://arweave.net/g-Q4NTaI0GSLDoLMw8c68B7nSbXHSX7WPkuSCKzK4Rk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 653,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -169,
    "LOC_Y": 178,
    "GAME_DATE": 20131031,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/527257249152892670",
    "name": "The 2974 Collection #0653",
    "imageUrl": "https://arweave.net/qzi53uUd0YmWqf4tAwbYBXwKdnsgN7MuxQmN6R2d0zo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 654,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 155,
    "LOC_Y": 192,
    "GAME_DATE": 20131031,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461426477366252638",
    "name": "The 2974 Collection #0654",
    "imageUrl": "https://arweave.net/e9ntmmhrAYaIBYiKjPvSRreAddM_PhT0GIBuJUjb8zY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 655,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 193,
    "LOC_Y": 156,
    "GAME_DATE": 20131031,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/449229961193467114",
    "name": "The 2974 Collection #0655",
    "imageUrl": "https://arweave.net/7RbzWuOSz_3epRvJq53_NBgkVl6kkYgl1dugtQ53pb4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 656,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 12,
    "GAME_DATE": 20131102,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441172239838315975",
    "name": "The 2974 Collection #0656",
    "imageUrl": "https://arweave.net/ee_Rrw_DDwB27fJzkt0927zZbniOPHWtkaRFFiApRCY?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 657,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 187,
    "LOC_Y": 165,
    "GAME_DATE": 20131102,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482485548585780257",
    "name": "The 2974 Collection #0657",
    "imageUrl": "https://arweave.net/y9Y4ps-CR6zlFllWSioEf2Q1-eXjb5c79UpF3saJDuc?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 658,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -168,
    "LOC_Y": 203,
    "GAME_DATE": 20131102,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567777482666491372",
    "name": "The 2974 Collection #0658",
    "imageUrl": "https://arweave.net/QnkUQjq82HBvVq4vlvg9nQgpUHl2Be97u4wrzPRw2MY?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 659,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -174,
    "LOC_Y": 224,
    "GAME_DATE": 20131102,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415272339489315242",
    "name": "The 2974 Collection #0659",
    "imageUrl": "https://arweave.net/-Rz2D4YI3KhL1CX-1PWidOIfkIJ-OdYeEHFhUM8TypI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 660,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 193,
    "LOC_Y": 181,
    "GAME_DATE": 20131102,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548489658287335913",
    "name": "The 2974 Collection #0660",
    "imageUrl": "https://arweave.net/Q_xvyTLuWithTs6BtlWh0SGBB3xCUtX1nzBt2hgMaP4?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 661,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 7,
    "LOC_Y": 249,
    "GAME_DATE": 20131104,
    "Season": "2013-2014",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384534521912511387",
    "name": "The 2974 Collection #0661",
    "imageUrl": "https://arweave.net/jSpNxys9UqprxwsUM_bp2nhfUxZtSuE-11yipCE6VpU?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2013,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 2,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 662,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 23,
    "LOC_Y": 257,
    "GAME_DATE": 20131104,
    "Season": "2013-2014",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/339995449880523038",
    "name": "The 2974 Collection #0662",
    "imageUrl": "https://arweave.net/GDbq6-oDK2k0PxkGjE2XA93GED_54x6tim4Cub8tOas?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2013,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 2,
    "Special Moment": "Triple-Double",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 663,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -4,
    "LOC_Y": 257,
    "GAME_DATE": 20131109,
    "Season": "2013-2014",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459754201022952066",
    "name": "The 2974 Collection #0663",
    "imageUrl": "https://arweave.net/Wp5Bgkg50KEHWNukX_UFbBQjR1YISgjuK6LGeRI-RUc?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 664,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 231,
    "LOC_Y": -13,
    "GAME_DATE": 20131109,
    "Season": "2013-2014",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520045885790781989",
    "name": "The 2974 Collection #0664",
    "imageUrl": "https://arweave.net/5_11m4XEXPn4dYN_mtJRmjgl0ShkJurg2hpTRsP4gRg?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 665,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -18,
    "LOC_Y": 246,
    "GAME_DATE": 20131109,
    "Season": "2013-2014",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334547761406449933",
    "name": "The 2974 Collection #0665",
    "imageUrl": "https://arweave.net/AO4QP1YO-i9tzCo-afS3mrBlIH0mVYo5hMZo9DZa1uw?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 666,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -196,
    "LOC_Y": 154,
    "GAME_DATE": 20131109,
    "Season": "2013-2014",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/506983447640708276",
    "name": "The 2974 Collection #0666",
    "imageUrl": "https://arweave.net/a5twghc8XYhDB6fUoXY39kF6phwUWIsGgILmOoif1AY?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 667,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 53,
    "GAME_DATE": 20131112,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/291927777648713027",
    "name": "The 2974 Collection #0667",
    "imageUrl": "https://arweave.net/AXQ3fghL2cJuRLjv4fBkUtxf-mBupQGJe2-A_ns2j7o?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2013,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 668,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 209,
    "LOC_Y": 162,
    "GAME_DATE": 20131112,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/467607236443837599",
    "name": "The 2974 Collection #0668",
    "imageUrl": "https://arweave.net/_UxvPM4VTVQPXXUMPx2NOdQG1WDNm0EIpFpiSYr_7Og?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2013,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 669,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -180,
    "LOC_Y": 205,
    "GAME_DATE": 20131114,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/345111093174920526",
    "name": "The 2974 Collection #0669",
    "imageUrl": "https://arweave.net/jprNCOZphidzXLJqHVzhV0QHatV8OqBe57hai1Hu3LU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 670,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 65,
    "LOC_Y": 236,
    "GAME_DATE": 20131114,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/517476036201499257",
    "name": "The 2974 Collection #0670",
    "imageUrl": "https://arweave.net/35xeTVoap3abbvCdWo6m15eugf7ERkmTQKnTFDHljPg?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 671,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 24,
    "LOC_Y": 268,
    "GAME_DATE": 20131114,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498964577368552649",
    "name": "The 2974 Collection #0671",
    "imageUrl": "https://arweave.net/TeOYkffkoZmNqnthE4Jqt-NTEsfoHmNeuQ9U1q9JYP8?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 672,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -196,
    "LOC_Y": 179,
    "GAME_DATE": 20131114,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/483959094507439447",
    "name": "The 2974 Collection #0672",
    "imageUrl": "https://arweave.net/7SbXYvBtngs4pEJAzW5UDcWTSeLyTKFriELeTbIT_pg?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 673,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 176,
    "LOC_Y": 173,
    "GAME_DATE": 20131118,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450873127690206383",
    "name": "The 2974 Collection #0673",
    "imageUrl": "https://arweave.net/9zPpFE0bFTpf7ySBMRJpAHZA2vLrB-7bJmuhDkN9uCM?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 674,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 18,
    "LOC_Y": 249,
    "GAME_DATE": 20131118,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484460627936255399",
    "name": "The 2974 Collection #0674",
    "imageUrl": "https://arweave.net/e1UdMnNWe5ufftYuFrapiv5dFojA4b4zPjtFmEEadis?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 675,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -205,
    "LOC_Y": 127,
    "GAME_DATE": 20131118,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301707539216069632",
    "name": "The 2974 Collection #0675",
    "imageUrl": "https://arweave.net/FA1FSRBEV2BGljhvkMipnDRskRyFohU4hedFwSnGDg4?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 676,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 73,
    "LOC_Y": 241,
    "GAME_DATE": 20131118,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335676121347480491",
    "name": "The 2974 Collection #0676",
    "imageUrl": "https://arweave.net/fDE9FWFpiJjziTL0gepNSrVYr1KpFQR_JgAkN16SYd0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2013,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 677,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -111,
    "LOC_Y": 228,
    "GAME_DATE": 20131123,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/435981265021773205",
    "name": "The 2974 Collection #0677",
    "imageUrl": "https://arweave.net/Dld7BgaeuWuLiNhqRWJ6hRCktWB_VD0f9HqD-vETQnI?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 678,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 151,
    "LOC_Y": 225,
    "GAME_DATE": 20131123,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541617599380173590",
    "name": "The 2974 Collection #0678",
    "imageUrl": "https://arweave.net/tlCYSC-sz2kXyx3qQFKjWdzkjjxA7K8rVmUOukFYkG8?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2013,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 679,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": 14,
    "GAME_DATE": 20131126,
    "Season": "2013-2014",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/463498548831292524",
    "name": "The 2974 Collection #0679",
    "imageUrl": "https://arweave.net/1uiLEHhmVdYZfSuxeNVWYjdWDiBEJA5njmeTT0BKTwY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 680,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 77,
    "LOC_Y": 242,
    "GAME_DATE": 20131126,
    "Season": "2013-2014",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357934980698954165",
    "name": "The 2974 Collection #0680",
    "imageUrl": "https://arweave.net/2-qKHqwnhpIlVssKeih9c78L0kOzsMTo2ryZkzB3jSg?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 681,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 36,
    "LOC_Y": 241,
    "GAME_DATE": 20131127,
    "Season": "2013-2014",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397477277317175254",
    "name": "The 2974 Collection #0681",
    "imageUrl": "https://arweave.net/T__DPvf-g1UVnoAEo1YtZ8NMQCf5ei1oZBe3jzUwZ50?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 682,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -26,
    "LOC_Y": 244,
    "GAME_DATE": 20131127,
    "Season": "2013-2014",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/339954616657171652",
    "name": "The 2974 Collection #0682",
    "imageUrl": "https://arweave.net/TIJQe8wjNBlaQgONdUzuwdb6aFUhSlnuIRT3C0KEnig?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 683,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 26,
    "LOC_Y": 250,
    "GAME_DATE": 20131127,
    "Season": "2013-2014",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/314231011420023806",
    "name": "The 2974 Collection #0683",
    "imageUrl": "https://arweave.net/jN6Pvr_9_IrfnDCT_1x_TWXgUUXVJFFTGn0QkQCYzpk?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 684,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -179,
    "LOC_Y": 168,
    "GAME_DATE": 20131127,
    "Season": "2013-2014",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/559334378461318221",
    "name": "The 2974 Collection #0684",
    "imageUrl": "https://arweave.net/EBfJ6dqPQ3A7DNtowDKmtRdtJAot2cofXVN-pGX3SAQ?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 685,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 106,
    "LOC_Y": 219,
    "GAME_DATE": 20131127,
    "Season": "2013-2014",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349023449148996769",
    "name": "The 2974 Collection #0685",
    "imageUrl": "https://arweave.net/d5-SNL0YBLoFQuVWemzm5F2H9EIOreQxaGYfZ0PP488?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 686,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 190,
    "LOC_Y": 146,
    "GAME_DATE": 20131127,
    "Season": "2013-2014",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491862895573207669",
    "name": "The 2974 Collection #0686",
    "imageUrl": "https://arweave.net/ezQj4Bv5MRPldHMTyuwF-0ZjCOQuzU01lbClBZSLb2M?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 687,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -5,
    "LOC_Y": 241,
    "GAME_DATE": 20131129,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349277980098581853",
    "name": "The 2974 Collection #0687",
    "imageUrl": "https://arweave.net/wLcOneXqdpZUJNoaC6CvIyv5VGbTXIAE6WcxtPCk98o?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 688,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -86,
    "LOC_Y": 246,
    "GAME_DATE": 20131129,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434826140406029038",
    "name": "The 2974 Collection #0688",
    "imageUrl": "https://arweave.net/t5Ny0rk-WCA0bdrtLvEMMNkw6y12XEv6xDP_1S4EXng?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 689,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 136,
    "LOC_Y": 205,
    "GAME_DATE": 20131129,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348269275538961935",
    "name": "The 2974 Collection #0689",
    "imageUrl": "https://arweave.net/s_ESsyuOdFWGFGw_o5ub6q7WaTCZQEcVkcsV6j0mxsQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 690,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 12,
    "LOC_Y": 249,
    "GAME_DATE": 20131129,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/526838501628753964",
    "name": "The 2974 Collection #0690",
    "imageUrl": "https://arweave.net/7wn6SudODggbJiCWssbucwuel8FZKJa4VFUdYgDX8WU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2013,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 691,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 59,
    "LOC_Y": 241,
    "GAME_DATE": 20131201,
    "Season": "2013-2014",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539422975987672519",
    "name": "The 2974 Collection #0691",
    "imageUrl": "https://arweave.net/PCYQUx4me7TaqHHW4cQr9r-UlIrKfdYrqO1M3DZCVZU?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 692,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -161,
    "LOC_Y": 179,
    "GAME_DATE": 20131201,
    "Season": "2013-2014",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322146276739094258",
    "name": "The 2974 Collection #0692",
    "imageUrl": "https://arweave.net/jaCf7RgGGVJdaLWKCYcYrcFgRef3Cv_ml_-naQRrSm0?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 693,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -51,
    "LOC_Y": 241,
    "GAME_DATE": 20131201,
    "Season": "2013-2014",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440992329527347641",
    "name": "The 2974 Collection #0693",
    "imageUrl": "https://arweave.net/p9p9dEqu4PTozKfO79Dgw4OkqUigprnTAKofgcmO5lY?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 694,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -68,
    "LOC_Y": 249,
    "GAME_DATE": 20131201,
    "Season": "2013-2014",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/452806107148008385",
    "name": "The 2974 Collection #0694",
    "imageUrl": "https://arweave.net/p3jqHGMfUZm8FaPozAhZkAm_NZEyfqMulrsksY_WqK0?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 695,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -21,
    "LOC_Y": 252,
    "GAME_DATE": 20131201,
    "Season": "2013-2014",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531527407518023333",
    "name": "The 2974 Collection #0695",
    "imageUrl": "https://arweave.net/qOELxKax6kqDBFntRWHcRJOagqKLQqUGQQO2d3SnSGg?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2013,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 696,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -234,
    "LOC_Y": 63,
    "GAME_DATE": 20131203,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/437618767371990214",
    "name": "The 2974 Collection #0696",
    "imageUrl": "https://arweave.net/jayC83NuwUPlXJtAL-V7u5ahtKmgRt9rhkiL3Z-P7jE?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2013,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 697,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -125,
    "LOC_Y": 222,
    "GAME_DATE": 20131203,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330360846697045371",
    "name": "The 2974 Collection #0697",
    "imageUrl": "https://arweave.net/OWRBz2jk-ICFV_xqeqxre8hexgaOLJNPcuRaiylop2Y?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2013,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 698,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -169,
    "LOC_Y": 206,
    "GAME_DATE": 20131203,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551278494985262909",
    "name": "The 2974 Collection #0698",
    "imageUrl": "https://arweave.net/dEJ9cbW3ehAJ_ZQVn6FyRFS2cE6X2hhVeK6OQQws0FI?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2013,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 699,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 192,
    "LOC_Y": 146,
    "GAME_DATE": 20131206,
    "Season": "2013-2014",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301414954831511231",
    "name": "The 2974 Collection #0699",
    "imageUrl": "https://arweave.net/Q_p5crLzMv89qxJI6naMJVl78Zr-WvCoMS7GPLAvQfY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 700,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 166,
    "LOC_Y": 198,
    "GAME_DATE": 20131207,
    "Season": "2013-2014",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/564215745858711537",
    "name": "The 2974 Collection #0700",
    "imageUrl": "https://arweave.net/HLQBI-r9IdEOcVeb_VS1_kLi5E9mkkXG1RVA97AMrjI?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 701,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 159,
    "LOC_Y": 209,
    "GAME_DATE": 20131207,
    "Season": "2013-2014",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317906043026668793",
    "name": "The 2974 Collection #0701",
    "imageUrl": "https://arweave.net/Ckk6TM-nANlb8IWcdAizNON2shKtCPW78y-8TPTlYq4?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2013,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 702,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 9,
    "GAME_DATE": 20131209,
    "Season": "2013-2014",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321530156491433726",
    "name": "The 2974 Collection #0702",
    "imageUrl": "https://arweave.net/mm76-710BwqEYpLJ4wA-YY0zoJ17G2jb3MPExepsw2c?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2013,
    "Month": 12,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 703,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -7,
    "LOC_Y": 254,
    "GAME_DATE": 20131209,
    "Season": "2013-2014",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344599200030243955",
    "name": "The 2974 Collection #0703",
    "imageUrl": "https://arweave.net/5zZmF_f-GfbNySgizfPwHClbJ31KEjQjZ8tdcT-Pehw?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2013,
    "Month": 12,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 704,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 108,
    "LOC_Y": 227,
    "GAME_DATE": 20131209,
    "Season": "2013-2014",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/549583705769355096",
    "name": "The 2974 Collection #0704",
    "imageUrl": "https://arweave.net/e2wYsUXbQ_1rk5QGpHS1-1J3ltcU6eFGw9-pYkmbruc?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2013,
    "Month": 12,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 705,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -218,
    "LOC_Y": 138,
    "GAME_DATE": 20131209,
    "Season": "2013-2014",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/494689258990486112",
    "name": "The 2974 Collection #0705",
    "imageUrl": "https://arweave.net/sV2JTh8LrkHOv8wy55-I0UvWvCj38MYkwKNwcTYvPGU?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2013,
    "Month": 12,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 706,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -84,
    "LOC_Y": 268,
    "GAME_DATE": 20131209,
    "Season": "2013-2014",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415066805669420551",
    "name": "The 2974 Collection #0706",
    "imageUrl": "https://arweave.net/SRmIrgLjJBP6gYOdRt-YLkWaK3LLJBypaOjzZIbBDsM?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2013,
    "Month": 12,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 707,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 39,
    "GAME_DATE": 20131211,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336153310441487382",
    "name": "The 2974 Collection #0707",
    "imageUrl": "https://arweave.net/zVJt1YtXaWHLZlDT3SBjJFkKS6z9Lz69jkTMEa0aS-U?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 708,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -59,
    "LOC_Y": 252,
    "GAME_DATE": 20131211,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458529945988550236",
    "name": "The 2974 Collection #0708",
    "imageUrl": "https://arweave.net/Pk0uwCUUyE76khRefpG5Am3J8ETG_eY0mgU74zS_YcY?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 709,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 45,
    "LOC_Y": 250,
    "GAME_DATE": 20131211,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/427390273945291116",
    "name": "The 2974 Collection #0709",
    "imageUrl": "https://arweave.net/Rp95mJV2dGXfTZU_evclViOwx1ZFj9xU0bXOKYgyVlw?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 710,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 26,
    "GAME_DATE": 20131211,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352998375877027706",
    "name": "The 2974 Collection #0710",
    "imageUrl": "https://arweave.net/MgCcs6VKFBfzcuZQGOtkrJJETRO0S3Xo7Wk35KLcma8?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 711,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -71,
    "LOC_Y": 257,
    "GAME_DATE": 20131211,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/570858754449222245",
    "name": "The 2974 Collection #0711",
    "imageUrl": "https://arweave.net/XRx9tb209esP8S96A13kkQCz3PA7EJRV0tEXbld6aW8?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 712,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -15,
    "LOC_Y": 244,
    "GAME_DATE": 20131211,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290582563557646389",
    "name": "The 2974 Collection #0712",
    "imageUrl": "https://arweave.net/WbRqkEO8Q0tt4lqpdw6hD_fBrqiRgrLp7iq8K1sJiD4?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2013,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 713,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 80,
    "LOC_Y": 254,
    "GAME_DATE": 20131213,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364368039925386754",
    "name": "The 2974 Collection #0713",
    "imageUrl": "https://arweave.net/31KfZMJ5T7fd1eUeZ0R2ZhrRAR9W4_knC4IXzxwVVbg?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2013,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 714,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 211,
    "LOC_Y": 148,
    "GAME_DATE": 20131215,
    "Season": "2013-2014",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319718376974438129",
    "name": "The 2974 Collection #0714",
    "imageUrl": "https://arweave.net/Ekws92pBi-c3X-SdMmkeAg3d6bs6MrLXdUIo5mHY7G4?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 12,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 715,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -223,
    "LOC_Y": 113,
    "GAME_DATE": 20131215,
    "Season": "2013-2014",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289950813408837678",
    "name": "The 2974 Collection #0715",
    "imageUrl": "https://arweave.net/SeDUqujBcTNA4dAX1BN-5vrtSiZgqZWrc16TrWnaMy8?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 12,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 716,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -239,
    "LOC_Y": 96,
    "GAME_DATE": 20131215,
    "Season": "2013-2014",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384687860679162923",
    "name": "The 2974 Collection #0716",
    "imageUrl": "https://arweave.net/upz4ZR3HVpCP9q26XuZjE58VVzzjmD8nfRdhYzCro90?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 12,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 717,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 114,
    "LOC_Y": 220,
    "GAME_DATE": 20131215,
    "Season": "2013-2014",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/516840293569487164",
    "name": "The 2974 Collection #0717",
    "imageUrl": "https://arweave.net/YBlmKon8Dj3xX7xIufnM8FR-ojvQX0U2K0hqFm8525A?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 12,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 718,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 182,
    "LOC_Y": 203,
    "GAME_DATE": 20131217,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364103387103643502",
    "name": "The 2974 Collection #0718",
    "imageUrl": "https://arweave.net/RgEPFwfklGaq4DOrBxuVOeCvddb8X6eujkCk-NPhLEY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 719,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 124,
    "LOC_Y": 224,
    "GAME_DATE": 20131217,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331297339378210772",
    "name": "The 2974 Collection #0719",
    "imageUrl": "https://arweave.net/SCXV4F6IRkwPq3J9PxBIgvV1p2jDSlwutXYdLQw-rJk?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2013,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 720,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 125,
    "LOC_Y": 249,
    "GAME_DATE": 20131219,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406199278200413104",
    "name": "The 2974 Collection #0720",
    "imageUrl": "https://arweave.net/O_gcT2QLqLhx6mdB5q0hTfIrhhYSmiDi2_p9_xca-7M?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 721,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 32,
    "LOC_Y": 260,
    "GAME_DATE": 20131219,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390147626646369044",
    "name": "The 2974 Collection #0721",
    "imageUrl": "https://arweave.net/3B2qqeftVIEXzC40MjTyaI0lAUe4u8YfzTA512UMVDs?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 722,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -45,
    "LOC_Y": 266,
    "GAME_DATE": 20131219,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539872193950817291",
    "name": "The 2974 Collection #0722",
    "imageUrl": "https://arweave.net/PkviT2mJVv5dslvGm6kchQ7KJtEPxksOy5ZuXqMYw7E?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 723,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -100,
    "LOC_Y": 244,
    "GAME_DATE": 20131219,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297566709385729636",
    "name": "The 2974 Collection #0723",
    "imageUrl": "https://arweave.net/9BsmYfcmbAS745gY1bIAEEZQCN1prRQd-EtuwQIIumM?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 724,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 81,
    "LOC_Y": 257,
    "GAME_DATE": 20131219,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344155006655601301",
    "name": "The 2974 Collection #0724",
    "imageUrl": "https://arweave.net/UEgM5_rB_6NOrh8EeszP5b8drUi3j8f3kUzoOiQm4K0?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 725,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -101,
    "LOC_Y": 250,
    "GAME_DATE": 20131219,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484631335416851097",
    "name": "The 2974 Collection #0725",
    "imageUrl": "https://arweave.net/bA8NQ6RKqow2gJ5YJSgMPp0t9zXpP9ci4hOxQMgs2PM?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2013,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 726,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 64,
    "LOC_Y": 252,
    "GAME_DATE": 20131221,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/532232727076421202",
    "name": "The 2974 Collection #0726",
    "imageUrl": "https://arweave.net/0fbf-NUmtKgG2N-Xxr6cDWObsvvicshQLLeqts49owo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 727,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -138,
    "LOC_Y": 236,
    "GAME_DATE": 20131221,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361667060154516645",
    "name": "The 2974 Collection #0727",
    "imageUrl": "https://arweave.net/W-tJH_GI4Pt7pPNJgYYfS0qddkw26QfxyELlcSgV0ng?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 728,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 129,
    "LOC_Y": 239,
    "GAME_DATE": 20131221,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302197394496255660",
    "name": "The 2974 Collection #0728",
    "imageUrl": "https://arweave.net/wGtTPjvJ0nj8QE9l_YTTR4lllZIvUA3vvJcj1Bn-_aA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 729,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -240,
    "LOC_Y": 15,
    "GAME_DATE": 20131221,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479199229118044763",
    "name": "The 2974 Collection #0729",
    "imageUrl": "https://arweave.net/SKFakQxFQMusV_NfcfYxq1-3GPRtTPy_UTT2kannHKk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 12,
    "Day": 21,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 730,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 215,
    "LOC_Y": 134,
    "GAME_DATE": 20131223,
    "Season": "2013-2014",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289448329027581258",
    "name": "The 2974 Collection #0730",
    "imageUrl": "https://arweave.net/dpZBm6UqEHnqySiayDrTLGT9pF0fASSHTN1NSt3uQ78?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2013,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 731,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 217,
    "LOC_Y": 132,
    "GAME_DATE": 20131223,
    "Season": "2013-2014",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344370754742103707",
    "name": "The 2974 Collection #0731",
    "imageUrl": "https://arweave.net/AcUeeTVITuTQXn2Jz0EqmktC1wtl1iLj3VH5AfAr0vw?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2013,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 732,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -16,
    "LOC_Y": 260,
    "GAME_DATE": 20131225,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429023683285504237",
    "name": "The 2974 Collection #0732",
    "imageUrl": "https://arweave.net/tEFWxW_a8d7_Pp1xDOuDDCBBAlwTHyjneRm-TiqTFkE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "Christmas",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 733,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -51,
    "LOC_Y": 252,
    "GAME_DATE": 20131225,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382544589096126997",
    "name": "The 2974 Collection #0733",
    "imageUrl": "https://arweave.net/81gd04kzQHr1d2V6JUOLnIlBXNp5my4bCru9I-hivyA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2013,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "Christmas",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 734,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -191,
    "LOC_Y": 220,
    "GAME_DATE": 20131227,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/528667009525696301",
    "name": "The 2974 Collection #0734",
    "imageUrl": "https://arweave.net/ct4jhM2OqgsYeFIz9Lrqu_1L_9OPxP9YNU-WHHaUe1U?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2013,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 1,
    "Special Moment": "16 Assists",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 735,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 176,
    "LOC_Y": 181,
    "GAME_DATE": 20131229,
    "Season": "2013-2014",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459661220734024898",
    "name": "The 2974 Collection #0735",
    "imageUrl": "https://arweave.net/3OJLxJu33LgD8XPEH7-r2v7qoridKolSlkIn-_zW74A?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2013,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 736,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -134,
    "LOC_Y": 211,
    "GAME_DATE": 20131229,
    "Season": "2013-2014",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440843793209359945",
    "name": "The 2974 Collection #0736",
    "imageUrl": "https://arweave.net/X0bPn3mtrmu1OD-wGU_bxaHvPnDnod-wDcje6cWAVaQ?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2013,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 737,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -144,
    "LOC_Y": 238,
    "GAME_DATE": 20131229,
    "Season": "2013-2014",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293912852923648530",
    "name": "The 2974 Collection #0737",
    "imageUrl": "https://arweave.net/a5hnwLGysRLuPQt48wzlXy2U08ZfuUl_VQ_Ffb6bVI4?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2013,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 738,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 23,
    "LOC_Y": 261,
    "GAME_DATE": 20131229,
    "Season": "2013-2014",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367294923490586786",
    "name": "The 2974 Collection #0738",
    "imageUrl": "https://arweave.net/dMNqdJIwXON_w5qlzjUTaOpC1Cpa-nDDLMJ3eiwcl7w?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2013,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 739,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 91,
    "LOC_Y": 236,
    "GAME_DATE": 20131229,
    "Season": "2013-2014",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369070453499952207",
    "name": "The 2974 Collection #0739",
    "imageUrl": "https://arweave.net/CRGRGGvJWZRqQMYbAUTdczYiNjrm6SSDQuzClbk3f4s?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2013,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 740,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -163,
    "LOC_Y": 205,
    "GAME_DATE": 20131231,
    "Season": "2013-2014",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296290058265084861",
    "name": "The 2974 Collection #0740",
    "imageUrl": "https://arweave.net/3zyAjNCQ7Gg_kvjx3BC1_CZJJ7xhfpcSv0iClDwO-v8?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2013,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 1,
    "Special Moment": "New Year's Eve",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 741,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 133,
    "LOC_Y": 211,
    "GAME_DATE": 20140102,
    "Season": "2013-2014",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/574660494164129226",
    "name": "The 2974 Collection #0741",
    "imageUrl": "https://arweave.net/nJXZTVH2UFh-0JuJSafbohnW9_ecRRMdGe7AM2MBcQc?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 742,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 181,
    "LOC_Y": 183,
    "GAME_DATE": 20140102,
    "Season": "2013-2014",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/370777489691274508",
    "name": "The 2974 Collection #0742",
    "imageUrl": "https://arweave.net/5NqTugC4hcgrIMmGiO8dJ3DzZcOux1w5CZH0JOl5Usc?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 743,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -201,
    "LOC_Y": 135,
    "GAME_DATE": 20140102,
    "Season": "2013-2014",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/393810342706742403",
    "name": "The 2974 Collection #0743",
    "imageUrl": "https://arweave.net/P4zwtB95ocPhWT-iYgZgNTZ4QhYbG482g-7uBtkJang?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 744,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -155,
    "LOC_Y": 192,
    "GAME_DATE": 20140102,
    "Season": "2013-2014",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/313915879080559954",
    "name": "The 2974 Collection #0744",
    "imageUrl": "https://arweave.net/IRDLsyDgxW5rSI-tHRwgOVYJotHTAV_tbmwy_j0aE_k?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 745,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 193,
    "LOC_Y": 164,
    "GAME_DATE": 20140102,
    "Season": "2013-2014",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/339865914799219133",
    "name": "The 2974 Collection #0745",
    "imageUrl": "https://arweave.net/ZqDvAZ3roWupIDr7UR_1hqEDLrxggPKyJalsGtn5PzM?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 746,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 204,
    "LOC_Y": 159,
    "GAME_DATE": 20140102,
    "Season": "2013-2014",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501867860012651367",
    "name": "The 2974 Collection #0746",
    "imageUrl": "https://arweave.net/3Vg2V8Js8Uw0zkEjnN68v40_9D44nbPBAT7aa3X4tws?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 747,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 236,
    "LOC_Y": 52,
    "GAME_DATE": 20140102,
    "Season": "2013-2014",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/365631526152889185",
    "name": "The 2974 Collection #0747",
    "imageUrl": "https://arweave.net/jykHaR17MbdKZ7uuG-JhRdW1ZpQeZmbhkLHIhXrb00Y?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 748,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -207,
    "LOC_Y": 127,
    "GAME_DATE": 20140102,
    "Season": "2013-2014",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296796894901962028",
    "name": "The 2974 Collection #0748",
    "imageUrl": "https://arweave.net/KmdrRTog63Bs4kGk9BrNw6a6A3RE4_7Yz8rH21V7nek?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 749,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 122,
    "LOC_Y": 219,
    "GAME_DATE": 20140103,
    "Season": "2013-2014",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/560572489253259848",
    "name": "The 2974 Collection #0749",
    "imageUrl": "https://arweave.net/efdeM-sjca3qNXEBdtT2FwshGsTPHhcjZt6ZTEXZc8s?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2014,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 750,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -150,
    "LOC_Y": 220,
    "GAME_DATE": 20140105,
    "Season": "2013-2014",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320496438167395182",
    "name": "The 2974 Collection #0750",
    "imageUrl": "https://arweave.net/TsWXPZNIScJKQz0eaoXtPKzPO7nPSOxcaQHu3cQKvwk?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2014,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 751,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -134,
    "LOC_Y": 220,
    "GAME_DATE": 20140107,
    "Season": "2013-2014",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441026196403997070",
    "name": "The 2974 Collection #0751",
    "imageUrl": "https://arweave.net/NAJFbpFIJg4Acfj95n2uaKyoLYvXMgSI7OMAUYNfOgg?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2014,
    "Month": 1,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 752,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -250,
    "LOC_Y": 28,
    "GAME_DATE": 20140107,
    "Season": "2013-2014",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352255919385982377",
    "name": "The 2974 Collection #0752",
    "imageUrl": "https://arweave.net/OVldUhi3rrU5rV5PljRPY6rmP5MeGoTRLzvT6tETsj4?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2014,
    "Month": 1,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 753,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -67,
    "LOC_Y": 265,
    "GAME_DATE": 20140108,
    "Season": "2013-2014",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/534230486404801364",
    "name": "The 2974 Collection #0753",
    "imageUrl": "https://arweave.net/buhiYXMAFNM3qDe9hhZHkmucabTpKo0ailmbtsF7MVw?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2014,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 754,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -224,
    "LOC_Y": 42,
    "GAME_DATE": 20140108,
    "Season": "2013-2014",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415803655756099296",
    "name": "The 2974 Collection #0754",
    "imageUrl": "https://arweave.net/KXRikCcnb5diPGoSZQJJ7k6NqpLLhMs50WInhqi5IZE?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2014,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 755,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 24,
    "LOC_Y": 282,
    "GAME_DATE": 20140110,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385196738132543019",
    "name": "The 2974 Collection #0755",
    "imageUrl": "https://arweave.net/ksnk-Zrw1aq6qs64SjrXirWtyIVE7nc8GrjvKqxr2CQ?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2014,
    "Month": 1,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 756,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 4,
    "GAME_DATE": 20140110,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479908541651426414",
    "name": "The 2974 Collection #0756",
    "imageUrl": "https://arweave.net/HmgF9C0s7O_0lE7auhkZdRDkyDT14D_6AuRCFUpHu_E?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2014,
    "Month": 1,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 757,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 62,
    "LOC_Y": 272,
    "GAME_DATE": 20140110,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/492548580686793398",
    "name": "The 2974 Collection #0757",
    "imageUrl": "https://arweave.net/cXu1pR5E8BPIAEKETrVR6xBB_EWpSaUsMuAMndmfciA?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2014,
    "Month": 1,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 758,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 48,
    "LOC_Y": 241,
    "GAME_DATE": 20140115,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354309220176824992",
    "name": "The 2974 Collection #0758",
    "imageUrl": "https://arweave.net/kzpUM5TizlYIuLk3Q0IZvTYtQgjbZMHnlmMlCqAHTSY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2014,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 759,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 28,
    "LOC_Y": 261,
    "GAME_DATE": 20140115,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/457061352823520818",
    "name": "The 2974 Collection #0759",
    "imageUrl": "https://arweave.net/sZ2B0Gwbk3bmRQ_vJrljvpRZvDPCFRIz7WuLVuBUFAk?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2014,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 760,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -43,
    "LOC_Y": 247,
    "GAME_DATE": 20140115,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/537487711779741140",
    "name": "The 2974 Collection #0760",
    "imageUrl": "https://arweave.net/3fo_kTzVSc2A7ZJiSJgzVa0mK8yMnStVkJLX7S695co?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2014,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 761,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -60,
    "LOC_Y": 266,
    "GAME_DATE": 20140115,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418138419425097505",
    "name": "The 2974 Collection #0761",
    "imageUrl": "https://arweave.net/54v41cGQ7gBdy5W8p_WSjxDNsmKAXpF9wALFoYMhWiE?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2014,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 762,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 215,
    "LOC_Y": 126,
    "GAME_DATE": 20140117,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/455716487181369728",
    "name": "The 2974 Collection #0762",
    "imageUrl": "https://arweave.net/G6lQNSuMftCCslZrX5I1029FxpWCmZD08tN7qrP0ZWs?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 763,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 59,
    "LOC_Y": 241,
    "GAME_DATE": 20140117,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/507963484517659926",
    "name": "The 2974 Collection #0763",
    "imageUrl": "https://arweave.net/eZRNPgo5B9Wr_b4HCes5UjouWVdfgiVCehpJKUj9ZNQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 764,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 15,
    "LOC_Y": 246,
    "GAME_DATE": 20140117,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/431399909793747843",
    "name": "The 2974 Collection #0764",
    "imageUrl": "https://arweave.net/E2419tSWU-P5hZJcLJGSKHsF8rndjGonoiFPVmX0rxU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 765,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -229,
    "LOC_Y": 7,
    "GAME_DATE": 20140117,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/389432792635975016",
    "name": "The 2974 Collection #0765",
    "imageUrl": "https://arweave.net/B4Pr7EoPjus4vtEU4d38qNZ8XzOGC_79pM3-thHAE50?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 766,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -65,
    "LOC_Y": 235,
    "GAME_DATE": 20140117,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/370643769315021808",
    "name": "The 2974 Collection #0766",
    "imageUrl": "https://arweave.net/FIOLEKmqvUYBoKKFnpK7UAtViaiZ2xW3b6UpFy0SA6k?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 767,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 190,
    "LOC_Y": 167,
    "GAME_DATE": 20140117,
    "Season": "2013-2014",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556175722537911478",
    "name": "The 2974 Collection #0767",
    "imageUrl": "https://arweave.net/7f8SMVS5-yXDKRZiJA4YdIgI3r6ucklZtwGVjlij4xc?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 768,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 108,
    "LOC_Y": 238,
    "GAME_DATE": 20140118,
    "Season": "2013-2014",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386970130613942903",
    "name": "The 2974 Collection #0768",
    "imageUrl": "https://arweave.net/p8WBn-WM3RsKCfGXm8GS_j52jdSidF41AHO-52YjvLs?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 769,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -54,
    "LOC_Y": 257,
    "GAME_DATE": 20140118,
    "Season": "2013-2014",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357692980453954631",
    "name": "The 2974 Collection #0769",
    "imageUrl": "https://arweave.net/C20MqMNCcKvt68BPrsQmc2O_6neaSJj91bSRvBGIyWM?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 770,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 14,
    "GAME_DATE": 20140120,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/432097446378858257",
    "name": "The 2974 Collection #0770",
    "imageUrl": "https://arweave.net/7vD9uvC0hZ7O-r8xEr-vNcO9LRfIlSI_VY_ONBH1YDo?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2014,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 771,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 39,
    "LOC_Y": 255,
    "GAME_DATE": 20140120,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336579781206604401",
    "name": "The 2974 Collection #0771",
    "imageUrl": "https://arweave.net/KtZQcQ5yvun1T-CrmCMoLfyaAemsdT4CTJwuo_4Kuv4?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2014,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 772,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 7,
    "GAME_DATE": 20140120,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441919824185835585",
    "name": "The 2974 Collection #0772",
    "imageUrl": "https://arweave.net/XVQIHfTYXcqvd4YTjfjAn8vrrFD8e84ni-7ZxWZ0jc0?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2014,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 773,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 116,
    "LOC_Y": 238,
    "GAME_DATE": 20140124,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/442633381356598905",
    "name": "The 2974 Collection #0773",
    "imageUrl": "https://arweave.net/B4OkcUduEQiHq5OLQsesob1lFVrUoUG-DhsZeMyyWrQ?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 774,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -144,
    "LOC_Y": 269,
    "GAME_DATE": 20140124,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/448908423783793797",
    "name": "The 2974 Collection #0774",
    "imageUrl": "https://arweave.net/imLXkXVjeL53V0OeCnhy_88JO4y3TmeePh9T0D8NmHI?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 775,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 121,
    "LOC_Y": 225,
    "GAME_DATE": 20140124,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/370385470347132732",
    "name": "The 2974 Collection #0775",
    "imageUrl": "https://arweave.net/lIG8F0KTNigAXbqIgkHKinVM7sshgNfWVR1-2eRWs7Q?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 776,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -29,
    "LOC_Y": 258,
    "GAME_DATE": 20140124,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381238051573605172",
    "name": "The 2974 Collection #0776",
    "imageUrl": "https://arweave.net/Vm1DOOXo0PxjmNNmiKiTFhOPBLFOSo3q53UQ0PKoL0g?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 777,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 133,
    "LOC_Y": 252,
    "GAME_DATE": 20140124,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361598139825053286",
    "name": "The 2974 Collection #0777",
    "imageUrl": "https://arweave.net/NCdlaetC-6Iw5-j72A7PQnimCx80ZePWIrfAq1W1zCQ?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 778,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -114,
    "LOC_Y": 241,
    "GAME_DATE": 20140124,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293640367261302143",
    "name": "The 2974 Collection #0778",
    "imageUrl": "https://arweave.net/qmgIQFffhyyPRDlyJJzZ5vZF2KzrUH4d_OVwCTx9rC4?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 779,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 130,
    "LOC_Y": 238,
    "GAME_DATE": 20140126,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/537347980844517536",
    "name": "The 2974 Collection #0779",
    "imageUrl": "https://arweave.net/QDfCEe1qeQFG9oLFHhalaHcQlBArejlLUzrR58XJNpA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 780,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -161,
    "LOC_Y": 206,
    "GAME_DATE": 20140126,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/318056024571097387",
    "name": "The 2974 Collection #0780",
    "imageUrl": "https://arweave.net/-cBqiyGN9Z42wqXkwftYlBSrqoM9wppJAylOHDCkwJw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 781,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -161,
    "LOC_Y": 224,
    "GAME_DATE": 20140126,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/496063261086299868",
    "name": "The 2974 Collection #0781",
    "imageUrl": "https://arweave.net/zFDFnQZ75UeUGzTLJa8DS8mViWPxFRQOMzXSS7OMJ1s?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 782,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 67,
    "LOC_Y": 263,
    "GAME_DATE": 20140126,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420730833992104444",
    "name": "The 2974 Collection #0782",
    "imageUrl": "https://arweave.net/kXHDf4T_c8KXb4lO911Gk8mznfWpjTq4wiEgdgMr3X4?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 783,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 228,
    "LOC_Y": 41,
    "GAME_DATE": 20140126,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422326124474009667",
    "name": "The 2974 Collection #0783",
    "imageUrl": "https://arweave.net/jFgxUkgCFfByTxDtsm0LGDujQvWoGf1sBu5ktycxXFc?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 784,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -196,
    "LOC_Y": 197,
    "GAME_DATE": 20140128,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355117327282345278",
    "name": "The 2974 Collection #0784",
    "imageUrl": "https://arweave.net/pUwQy-q3ogxda-JmWekXWwmyoP3G3y8Pt9CPCLaieDg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2014,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 785,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -149,
    "LOC_Y": 209,
    "GAME_DATE": 20140128,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546197694674679456",
    "name": "The 2974 Collection #0785",
    "imageUrl": "https://arweave.net/1D9PaaWdOQt4sBwRpTPaNWkFPPpSMjwWcv4mOrQTOMU?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2014,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 786,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -183,
    "LOC_Y": 190,
    "GAME_DATE": 20140130,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/318272257402092175",
    "name": "The 2974 Collection #0786",
    "imageUrl": "https://arweave.net/bb4SMKajTQ0qpmf4Jo2My1lE7lsjxDQnlADKQqHig2E?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 787,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -64,
    "LOC_Y": 242,
    "GAME_DATE": 20140130,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/358608072948262383",
    "name": "The 2974 Collection #0787",
    "imageUrl": "https://arweave.net/JpqK-c-3pi-m4SVTeQPWAH-Yva7EJHSBY2-sJbdl6SQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 788,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 33,
    "GAME_DATE": 20140130,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382022910469908907",
    "name": "The 2974 Collection #0788",
    "imageUrl": "https://arweave.net/BBki2pR-vTZTE_pPRY2hkbUeoEps7p_7zp6oiEk-OTM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 789,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 165,
    "LOC_Y": 198,
    "GAME_DATE": 20140130,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539409584042641255",
    "name": "The 2974 Collection #0789",
    "imageUrl": "https://arweave.net/vFBnM8pTNmA0T40FY1Ev0WtN82_Co7Mb2sHD4ijYHEI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 790,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 91,
    "LOC_Y": 254,
    "GAME_DATE": 20140131,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334817165836479771",
    "name": "The 2974 Collection #0790",
    "imageUrl": "https://arweave.net/S7ESStAWWBUXsHzsFuQVQPL_t9b4bs6ULGG4Qo2OJUI?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 791,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -40,
    "LOC_Y": 247,
    "GAME_DATE": 20140131,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493275595515126562",
    "name": "The 2974 Collection #0791",
    "imageUrl": "https://arweave.net/3p3BMz0A8U2Tm46NdJEUgWc0vp7xdyyYNeEqSw47ots?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 792,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 222,
    "LOC_Y": 116,
    "GAME_DATE": 20140131,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/413833887445262604",
    "name": "The 2974 Collection #0792",
    "imageUrl": "https://arweave.net/tI9lMhlyjba7IWEEFOoZMmIUs4LGr_gP_OrlC9Oc4W0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 793,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 6,
    "LOC_Y": 249,
    "GAME_DATE": 20140131,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556654392945225580",
    "name": "The 2974 Collection #0793",
    "imageUrl": "https://arweave.net/vozZNPVblcHo3otskrbdEOYBI0PuWyM18P4Dk2m7QhA?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 794,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 89,
    "LOC_Y": 231,
    "GAME_DATE": 20140131,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519339483909431247",
    "name": "The 2974 Collection #0794",
    "imageUrl": "https://arweave.net/2wzX5hTh9JVjpefxZxB-j1-hOsp0CIpw5bkGyURgXtY?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 795,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 143,
    "LOC_Y": 198,
    "GAME_DATE": 20140131,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322286194721088391",
    "name": "The 2974 Collection #0795",
    "imageUrl": "https://arweave.net/5iopa6C4vA2kuhtxDpk-a_ZVVopmheCv3i7pNOYCiYk?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 796,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -131,
    "LOC_Y": 208,
    "GAME_DATE": 20140131,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491809398672469679",
    "name": "The 2974 Collection #0796",
    "imageUrl": "https://arweave.net/TDpzwCy3pyh3GRIcursrAGTO4Z-tqeRh8nFM1DjARHU?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 797,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -122,
    "LOC_Y": 227,
    "GAME_DATE": 20140131,
    "Season": "2013-2014",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556277051307149727",
    "name": "The 2974 Collection #0797",
    "imageUrl": "https://arweave.net/5gUVthkDgRSMQizMc6QbX8PruCKOpi3XlkqnfkO7GzY?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 798,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": -2,
    "GAME_DATE": 20140204,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485081981179932824",
    "name": "The 2974 Collection #0798",
    "imageUrl": "https://arweave.net/bT7QETi1-WLgR1Q06t8sckjjeKbQu9rXkhmnUN-tpUM?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2014,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 799,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 37,
    "LOC_Y": 261,
    "GAME_DATE": 20140206,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/340720261784981191",
    "name": "The 2974 Collection #0799",
    "imageUrl": "https://arweave.net/ShJ-JtSkjpKHX_-klqzkFM5_-ZtKijaWpmPoq45mO70?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2014,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 800,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 114,
    "LOC_Y": 268,
    "GAME_DATE": 20140206,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/332884535322821524",
    "name": "The 2974 Collection #0800",
    "imageUrl": "https://arweave.net/ZsR26sMLewDdYT5fZyc9Ya7sbn2zcKYtm6lt-cJHMgs?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2014,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 801,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 173,
    "LOC_Y": 198,
    "GAME_DATE": 20140206,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/486275586024690499",
    "name": "The 2974 Collection #0801",
    "imageUrl": "https://arweave.net/z0JEnAjLzGuTs6MGTJSoQC9Ha-a6BSWtfwqx3yz_yaE?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2014,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 802,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 143,
    "LOC_Y": 211,
    "GAME_DATE": 20140206,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403383924269725699",
    "name": "The 2974 Collection #0802",
    "imageUrl": "https://arweave.net/AqnJI_ytxbGp3Zqw68sS-mcjIdBUeaWJu4jSftdrees?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2014,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 803,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 135,
    "LOC_Y": 213,
    "GAME_DATE": 20140208,
    "Season": "2013-2014",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/426197533642572971",
    "name": "The 2974 Collection #0803",
    "imageUrl": "https://arweave.net/ZvhgqhX3RRrCYopGO8sayH16k70MA3mn4VGxWZJ18Aw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2014,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 804,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 99,
    "LOC_Y": 225,
    "GAME_DATE": 20140208,
    "Season": "2013-2014",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/538126446361055203",
    "name": "The 2974 Collection #0804",
    "imageUrl": "https://arweave.net/BbRLY16SqtBHu2CeNdpbACIQCMdQEz5YkzlI4hDDU_Q?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2014,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 805,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 11,
    "GAME_DATE": 20140208,
    "Season": "2013-2014",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308666574985944274",
    "name": "The 2974 Collection #0805",
    "imageUrl": "https://arweave.net/Yn7bf5ffiR9XikYp67wbjbMHB59Yf0IWjjk0VQGk1Zk?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2014,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 806,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 157,
    "LOC_Y": 205,
    "GAME_DATE": 20140210,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476406645893339160",
    "name": "The 2974 Collection #0806",
    "imageUrl": "https://arweave.net/qfzCCBQQSgHhBoyRObG6vXQfm4KwLfE2DKHUtwfkjxU?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2014,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 807,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -78,
    "LOC_Y": 258,
    "GAME_DATE": 20140210,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362928319360659574",
    "name": "The 2974 Collection #0807",
    "imageUrl": "https://arweave.net/RWZAB0h-j68UnesvozDES-zaDJWociNICw3ZNq6Z9kI?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2014,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 808,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 44,
    "GAME_DATE": 20140210,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347141470210300016",
    "name": "The 2974 Collection #0808",
    "imageUrl": "https://arweave.net/552g_JzaEeHLIzzqneW9z9_FcBEk5uUR7zOD6-gkRks?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2014,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 809,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -29,
    "LOC_Y": 265,
    "GAME_DATE": 20140210,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355922045376670146",
    "name": "The 2974 Collection #0809",
    "imageUrl": "https://arweave.net/zgHr9vvh9gZRZzTE-FKeBQsv6sLVQF7lCwPhZmyp_7k?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2014,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 810,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 193,
    "LOC_Y": 159,
    "GAME_DATE": 20140210,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/573110775347987559",
    "name": "The 2974 Collection #0810",
    "imageUrl": "https://arweave.net/WmhcoNAQM1qHTi5JRUEOe8FwCXOswClqYZ7-uDNvkhs?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2014,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 811,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -237,
    "LOC_Y": 47,
    "GAME_DATE": 20140210,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/516837972972431284",
    "name": "The 2974 Collection #0811",
    "imageUrl": "https://arweave.net/ov4LbcQ02mwW0bi9Wld-KBy0ER8fsrk-0sIrhRimrhQ?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2014,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 812,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -168,
    "LOC_Y": 233,
    "GAME_DATE": 20140212,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/430947706894639573",
    "name": "The 2974 Collection #0812",
    "imageUrl": "https://arweave.net/I-NoSp8ocF3ywuXGXd9HBlm5yRULmO0a9ew3R-GB5jA?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 813,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -201,
    "LOC_Y": 173,
    "GAME_DATE": 20140212,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368682287144890940",
    "name": "The 2974 Collection #0813",
    "imageUrl": "https://arweave.net/lMkzuG_mD3q55kmMgi03Mf9v4n6d3Ry30bX4aBdW79Y?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 814,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 254,
    "GAME_DATE": 20140212,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371882638720443793",
    "name": "The 2974 Collection #0814",
    "imageUrl": "https://arweave.net/Wmf70a6LlTGOpsNAt-GY9XDcdQb0vI0UXoeZLoLLxYg?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 815,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -7,
    "LOC_Y": 260,
    "GAME_DATE": 20140212,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320754411089682554",
    "name": "The 2974 Collection #0815",
    "imageUrl": "https://arweave.net/uO0ziqiLq1_YJ71PI2071xKMDXJQag2EZSDtsDQw8e0?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 816,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 174,
    "LOC_Y": 181,
    "GAME_DATE": 20140219,
    "Season": "2013-2014",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297161047500332897",
    "name": "The 2974 Collection #0816",
    "imageUrl": "https://arweave.net/3qxEmrSz8htkO_3_-CRKJHAOur3am5TSHFlYInzDHq8?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2014,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 817,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -60,
    "LOC_Y": 250,
    "GAME_DATE": 20140220,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297648636611575031",
    "name": "The 2974 Collection #0817",
    "imageUrl": "https://arweave.net/zibT426CskXO0yLr6-yRAFQXEY7RKS2GIijPQK_l9Vg?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 818,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -114,
    "LOC_Y": 241,
    "GAME_DATE": 20140220,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299218433881621705",
    "name": "The 2974 Collection #0818",
    "imageUrl": "https://arweave.net/j-lGoFgV1o6zzAiGl5C-cw4fPGxtgaJL0Xl1oQKbTuY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 819,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 193,
    "LOC_Y": 170,
    "GAME_DATE": 20140220,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512525396347838766",
    "name": "The 2974 Collection #0819",
    "imageUrl": "https://arweave.net/Xt9aPMSKB6U_u1FhOZU3Z95XheL3SuIRRxMq4aP7WI8?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 820,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 6,
    "LOC_Y": 266,
    "GAME_DATE": 20140220,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465937682686331236",
    "name": "The 2974 Collection #0820",
    "imageUrl": "https://arweave.net/Nt36miNYSREMwTcZabdGr3Cm3gvOF7fF_W0VrQlosS8?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 821,
    "PERIOD": 5,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 179,
    "LOC_Y": 195,
    "GAME_DATE": 20140220,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550688377433760179",
    "name": "The 2974 Collection #0821",
    "imageUrl": "https://arweave.net/HvNGcHk6ksw3zSbkViyZ0fegVBc212zkpdDUwjtvq9s?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 822,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 141,
    "LOC_Y": 224,
    "GAME_DATE": 20140222,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381683820566359062",
    "name": "The 2974 Collection #0822",
    "imageUrl": "https://arweave.net/iW0r15wGeQGgHHAm36J-EkJi78rnNvZKYIdB_YLOmPc?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2014,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 823,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -172,
    "LOC_Y": 186,
    "GAME_DATE": 20140222,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328803881794529696",
    "name": "The 2974 Collection #0823",
    "imageUrl": "https://arweave.net/IXIP6neo6UFLMCKaoxZQ6L5cwANFFBO6Xw9648Faa2M?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2014,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 824,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -161,
    "LOC_Y": 214,
    "GAME_DATE": 20140222,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/516305074156006354",
    "name": "The 2974 Collection #0824",
    "imageUrl": "https://arweave.net/7664tsO49qoRce9PBnZeIpU1AbOfTyPolP2b53d_GaE?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2014,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 825,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 31,
    "LOC_Y": 263,
    "GAME_DATE": 20140224,
    "Season": "2013-2014",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346338938005028761",
    "name": "The 2974 Collection #0825",
    "imageUrl": "https://arweave.net/m15sL-bJChRC8eN62OW-wqWNCRs2N7UcqXvcpSAZAfY?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2014,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 826,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -166,
    "LOC_Y": 205,
    "GAME_DATE": 20140224,
    "Season": "2013-2014",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/483248625075589618",
    "name": "The 2974 Collection #0826",
    "imageUrl": "https://arweave.net/dAWZCALdtnJvocWR4bA-Pkg14EjyX11UtWx2gqQIRCM?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2014,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 827,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 192,
    "LOC_Y": 178,
    "GAME_DATE": 20140224,
    "Season": "2013-2014",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468007447216163916",
    "name": "The 2974 Collection #0827",
    "imageUrl": "https://arweave.net/uRSHf3mmc0lPkrZql3oijxjIcxG_LN2UsRxaw63-ztc?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2014,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 828,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 88,
    "LOC_Y": 235,
    "GAME_DATE": 20140226,
    "Season": "2013-2014",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354403895584486489",
    "name": "The 2974 Collection #0828",
    "imageUrl": "https://arweave.net/rYU1YGoDjandTe02aKVwBiJbu6CV9WSR5TAJTF_Kgkc?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2014,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 829,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 209,
    "LOC_Y": 143,
    "GAME_DATE": 20140228,
    "Season": "2013-2014",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/376554991675493088",
    "name": "The 2974 Collection #0829",
    "imageUrl": "https://arweave.net/0ulv0nsOOfVfsG_Sas5tKj3EwsmaY027cwryr8dkctA?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 830,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 22,
    "GAME_DATE": 20140228,
    "Season": "2013-2014",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489872824183969048",
    "name": "The 2974 Collection #0830",
    "imageUrl": "https://arweave.net/hYywXhtMEjoEhA5LCWAhHLGgO9pJ91rBPTmxamXN6l4?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Triple-Double",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 831,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -103,
    "LOC_Y": 236,
    "GAME_DATE": 20140228,
    "Season": "2013-2014",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367805488432434294",
    "name": "The 2974 Collection #0831",
    "imageUrl": "https://arweave.net/2uIqJyiT2FCfg8rmpucZ5EvslPtGbpEXpaDrKRxN66A?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Triple-Double",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 832,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 80,
    "LOC_Y": 244,
    "GAME_DATE": 20140228,
    "Season": "2013-2014",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392689541181492225",
    "name": "The 2974 Collection #0832",
    "imageUrl": "https://arweave.net/ZQmy1ASyl47jqQOVtKYOxPJ0hxH5y8kERjhn1VUAcD8?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Triple-Double",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 833,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -180,
    "LOC_Y": 159,
    "GAME_DATE": 20140228,
    "Season": "2013-2014",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/387260913967480919",
    "name": "The 2974 Collection #0833",
    "imageUrl": "https://arweave.net/wT-Tjot-7O6oLxioF9Q6Tlh79RSPCFv7xypmxZF1Qlk?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 834,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -117,
    "LOC_Y": 217,
    "GAME_DATE": 20140302,
    "Season": "2013-2014",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296349899162021427",
    "name": "The 2974 Collection #0834",
    "imageUrl": "https://arweave.net/0llQKn0vjVmCxlNnWRUrR3SaqAgC5SpqjvmpcN1QOxo?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2014,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 835,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 138,
    "LOC_Y": 208,
    "GAME_DATE": 20140302,
    "Season": "2013-2014",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338857427491527849",
    "name": "The 2974 Collection #0835",
    "imageUrl": "https://arweave.net/wKOspChSs1RYc9NdTVx_d1lIAD_LdfuzRNxAyqUfyEo?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2014,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 836,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 144,
    "LOC_Y": 203,
    "GAME_DATE": 20140302,
    "Season": "2013-2014",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360743441912184240",
    "name": "The 2974 Collection #0836",
    "imageUrl": "https://arweave.net/NInb1M9I1_gkhcvtvDVr9m8-PsTja0WsYpX6hSaBeUk?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2014,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 837,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 6,
    "LOC_Y": 246,
    "GAME_DATE": 20140302,
    "Season": "2013-2014",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474969263706844674",
    "name": "The 2974 Collection #0837",
    "imageUrl": "https://arweave.net/x01VmZDyMqnpsA_OusBAaK1GJTG9AQzs3QDalkVM3zw?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2014,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 838,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -100,
    "LOC_Y": 228,
    "GAME_DATE": 20140304,
    "Season": "2013-2014",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/339893460183935493",
    "name": "The 2974 Collection #0838",
    "imageUrl": "https://arweave.net/SeABbp5aqpHNsjdwAtZwxRCo2V853MJ8ascEea_iHXg?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2014,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 839,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 152,
    "LOC_Y": 201,
    "GAME_DATE": 20140304,
    "Season": "2013-2014",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518482101416173126",
    "name": "The 2974 Collection #0839",
    "imageUrl": "https://arweave.net/xdB3QNxZM31-pifaeOK4ZvNfO_eR9R9jpHrpjr8OViE?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2014,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 840,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -207,
    "LOC_Y": 145,
    "GAME_DATE": 20140305,
    "Season": "2013-2014",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344121195954573344",
    "name": "The 2974 Collection #0840",
    "imageUrl": "https://arweave.net/LyJmmp-5fiIREfWKyoP_q6ilvn2OZPy72p3bM784Luw?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2014,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 841,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 125,
    "LOC_Y": 224,
    "GAME_DATE": 20140307,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/542301659171929564",
    "name": "The 2974 Collection #0841",
    "imageUrl": "https://arweave.net/bS5MPs36Mdo3Jff2tGqWHSaiiKwqc4eiyGmZ3bbkgmE?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2014,
    "Month": 3,
    "Day": 7,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 842,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 129,
    "LOC_Y": 246,
    "GAME_DATE": 20140309,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328649271260420932",
    "name": "The 2974 Collection #0842",
    "imageUrl": "https://arweave.net/IU_3e7c8IUmA1gQ1PBDgkJcsCsfQshXwSfutKTM8Lsc?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2014,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 843,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 159,
    "LOC_Y": 219,
    "GAME_DATE": 20140311,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/291888677100771961",
    "name": "The 2974 Collection #0843",
    "imageUrl": "https://arweave.net/3_-u1I8t_pISVxnTJfUKGuW0odavFBlMTaqexu9ym5c?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2014,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 844,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 130,
    "LOC_Y": 216,
    "GAME_DATE": 20140312,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533140409076515067",
    "name": "The 2974 Collection #0844",
    "imageUrl": "https://arweave.net/viOBU9IaDK0A_aLAILb_Pe203IZQVaq6G-AOhagwSpU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 3,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 845,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -138,
    "LOC_Y": 208,
    "GAME_DATE": 20140312,
    "Season": "2013-2014",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429521104631745057",
    "name": "The 2974 Collection #0845",
    "imageUrl": "https://arweave.net/htrsuQxyfCrzsjphSIH345OX2A8Ak5_ld-Er35haVeQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 3,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 846,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 84,
    "LOC_Y": 236,
    "GAME_DATE": 20140314,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490922528980220941",
    "name": "The 2974 Collection #0846",
    "imageUrl": "https://arweave.net/lDniKbXlusjeLio77pN041CKNH4l6SgSK_GB9igCiU0?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2014,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 847,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 129,
    "LOC_Y": 224,
    "GAME_DATE": 20140314,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/291301913990680997",
    "name": "The 2974 Collection #0847",
    "imageUrl": "https://arweave.net/NvzpbkG3oBlJmul6NrvPk2vbSwNOZwnnkRV-joYp39s?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2014,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 848,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 122,
    "LOC_Y": 236,
    "GAME_DATE": 20140314,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307379684298033722",
    "name": "The 2974 Collection #0848",
    "imageUrl": "https://arweave.net/CtcWglmCExjaHbimSdLzrqrFx8q-XrIsBThH7WtMW4U?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2014,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 849,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 231,
    "LOC_Y": 12,
    "GAME_DATE": 20140314,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520796476135860278",
    "name": "The 2974 Collection #0849",
    "imageUrl": "https://arweave.net/fFdhEhx26kXmSP_vy7cKOZEPD4UBAjQfi8KD_Q2kzyo?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2014,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 850,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 75,
    "LOC_Y": 255,
    "GAME_DATE": 20140314,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355596210839408862",
    "name": "The 2974 Collection #0850",
    "imageUrl": "https://arweave.net/wGy_HZs4wD8T_J0Dp1NUm1WWZ7lOIfiESDE9J-jy2Qc?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2014,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 851,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 149,
    "LOC_Y": 198,
    "GAME_DATE": 20140316,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386410561216749022",
    "name": "The 2974 Collection #0851",
    "imageUrl": "https://arweave.net/6T2Vp3R3YUnLU6F-eRAPcHz-Ed0NvxQq4ULHPShY1W8?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 852,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -231,
    "LOC_Y": 82,
    "GAME_DATE": 20140316,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307314742500076652",
    "name": "The 2974 Collection #0852",
    "imageUrl": "https://arweave.net/fNkhJWvcGXsilw16xGKEkeLI_2Gd07URLjNq7hcXAHo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 853,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 56,
    "LOC_Y": 241,
    "GAME_DATE": 20140316,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406061238568237426",
    "name": "The 2974 Collection #0853",
    "imageUrl": "https://arweave.net/iNmnCDF43lYSBssVMV_5ROD3vGSWxS1fwfnRtrv1m0U?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 854,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -5,
    "LOC_Y": 242,
    "GAME_DATE": 20140316,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/345277409880699400",
    "name": "The 2974 Collection #0854",
    "imageUrl": "https://arweave.net/4Um8BMwOMTORZ3txWJNPRwOg17xgwO7DQUn4x_UmZEY?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 855,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -171,
    "LOC_Y": 205,
    "GAME_DATE": 20140316,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481752289834301368",
    "name": "The 2974 Collection #0855",
    "imageUrl": "https://arweave.net/oPrrGqv7buNpyXXoNmC17W6Ci4DKgIRGuBGFsIQ5R0I?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 856,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -226,
    "LOC_Y": 83,
    "GAME_DATE": 20140316,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346895131122409753",
    "name": "The 2974 Collection #0856",
    "imageUrl": "https://arweave.net/11V3z9wV-UxaukI2-YMSM8xcuBnfIhC1EGNy-dVANXE?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 857,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 61,
    "LOC_Y": 247,
    "GAME_DATE": 20140318,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/343347291933256490",
    "name": "The 2974 Collection #0857",
    "imageUrl": "https://arweave.net/Vn3PGOOr8MBUCuv9KbW5N0rBQ7NUNGu2fo2dCNXo91I?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 858,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 25,
    "GAME_DATE": 20140318,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508302550360006955",
    "name": "The 2974 Collection #0858",
    "imageUrl": "https://arweave.net/BVVTR_4Loki9a91ABr1ChR2lvSYv0RbRcpK-kSWLH5s?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 859,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 3,
    "GAME_DATE": 20140318,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391935525639174666",
    "name": "The 2974 Collection #0859",
    "imageUrl": "https://arweave.net/c13RZ26GxOflNadvK4BhTD7d_14t2xL5w68Kr_2P5Uc?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 860,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -191,
    "LOC_Y": 153,
    "GAME_DATE": 20140320,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436179070870181542",
    "name": "The 2974 Collection #0860",
    "imageUrl": "https://arweave.net/0qSa-q_dr7OhP0U8hIBinCLzv-Gyu4EDXJNf6wku8rE?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2014,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 861,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -196,
    "LOC_Y": 175,
    "GAME_DATE": 20140320,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305421933385132205",
    "name": "The 2974 Collection #0861",
    "imageUrl": "https://arweave.net/GqgiLZxKC5eajROSy1LjUK7kRSqpvj6boiFkoNRdHo4?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2014,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 862,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -120,
    "LOC_Y": 225,
    "GAME_DATE": 20140320,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440935254118586662",
    "name": "The 2974 Collection #0862",
    "imageUrl": "https://arweave.net/1oF8oRhU9ObqIWFHpXzlLvBjxYFX2Bw6xGZgDzCOv9s?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2014,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 863,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -229,
    "LOC_Y": 4,
    "GAME_DATE": 20140322,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503608482933415906",
    "name": "The 2974 Collection #0863",
    "imageUrl": "https://arweave.net/p3GNevSX0ioZKyItDJqQ1GBR1MUnTI29pzCcQDl5n7U?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2014,
    "Month": 3,
    "Day": 22,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 864,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 111,
    "LOC_Y": 231,
    "GAME_DATE": 20140328,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575075849956028505",
    "name": "The 2974 Collection #0864",
    "imageUrl": "https://arweave.net/pIR7roKHMWzZ9nq8uqrV3VKZxohX0DZzkU2bODCnz_s?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2014,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 865,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 127,
    "LOC_Y": 246,
    "GAME_DATE": 20140328,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295838206229742174",
    "name": "The 2974 Collection #0865",
    "imageUrl": "https://arweave.net/KeHnfE6HZMKhFMCE4iGiY7LmpmQR7qp_7366QmXU7JA?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2014,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 866,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -160,
    "LOC_Y": 206,
    "GAME_DATE": 20140328,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367440820842082243",
    "name": "The 2974 Collection #0866",
    "imageUrl": "https://arweave.net/z0ttuRUQ6jM6zL3iAPg0cbTfkPRF3kFIOCJPSSs_Bbw?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2014,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 867,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 2,
    "LOC_Y": 255,
    "GAME_DATE": 20140328,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328231378508721531",
    "name": "The 2974 Collection #0867",
    "imageUrl": "https://arweave.net/WINuKdoUK7-rZsC3aRvx-AI2hCEyi9RNBJ50YhpqgrU?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2014,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 868,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 80,
    "LOC_Y": 252,
    "GAME_DATE": 20140328,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/435346774215269956",
    "name": "The 2974 Collection #0868",
    "imageUrl": "https://arweave.net/SAbyzdbLy7-CgohHB7l6ijctX-1N3jIyFR0blYSC544?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2014,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 869,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -43,
    "LOC_Y": 260,
    "GAME_DATE": 20140330,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511938763069123139",
    "name": "The 2974 Collection #0869",
    "imageUrl": "https://arweave.net/BOt-crvGPd7AxlONSp5KSKD-MnpCunrlZ7vGtrRVvOI?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 870,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 1,
    "LOC_Y": 255,
    "GAME_DATE": 20140330,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450101687170035187",
    "name": "The 2974 Collection #0870",
    "imageUrl": "https://arweave.net/xanO7MQnAaXoZjdgDdz_f_KFUzLxwgiBchZTklxACDM?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 871,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 61,
    "LOC_Y": 255,
    "GAME_DATE": 20140330,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362002216489914793",
    "name": "The 2974 Collection #0871",
    "imageUrl": "https://arweave.net/NMU51bXNzHU56Lbeg2M7-4pvmGdNbNaQ_eVjjjYnjKM?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 872,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 144,
    "LOC_Y": 206,
    "GAME_DATE": 20140330,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/538538426771701669",
    "name": "The 2974 Collection #0872",
    "imageUrl": "https://arweave.net/wp91BTSZ6WAS0rF2AoAYy4JCwiJAUw1xiDJe5_hj7OM?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 873,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 201,
    "LOC_Y": 159,
    "GAME_DATE": 20140330,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300678641678485901",
    "name": "The 2974 Collection #0873",
    "imageUrl": "https://arweave.net/f0H_aOQ3MbH4SbeRSBN1RGo3U5tv3MwxrUckcCBrVXk?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 874,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 231,
    "LOC_Y": 1,
    "GAME_DATE": 20140330,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522533456585410809",
    "name": "The 2974 Collection #0874",
    "imageUrl": "https://arweave.net/jlZ-AqrO2vduKBzq4h0an1l3ZBwssw2smwL_tKC6wXc?ext=png",
    "Opposing Team City": "New York",
    "Year": 2014,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 875,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 53,
    "GAME_DATE": 20140401,
    "Season": "2013-2014",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544380529307944816",
    "name": "The 2974 Collection #0875",
    "imageUrl": "https://arweave.net/128ZwyFWqrl3JjFHkDpAfKeDMpQG_kktw6-xeNIn69g?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2014,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 876,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -213,
    "LOC_Y": 110,
    "GAME_DATE": 20140401,
    "Season": "2013-2014",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300572426792450130",
    "name": "The 2974 Collection #0876",
    "imageUrl": "https://arweave.net/q14RjzVwjHkfvuQQ6PBCgSh21kooFsKfqHygqVLyAoc?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2014,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 877,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -164,
    "LOC_Y": 179,
    "GAME_DATE": 20140401,
    "Season": "2013-2014",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/462594573911147097",
    "name": "The 2974 Collection #0877",
    "imageUrl": "https://arweave.net/6Ll9LCWKJYGUaJYu78kgQ9OG0dTtD-xyNsv37EJVmuQ?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2014,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 878,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 97,
    "LOC_Y": 239,
    "GAME_DATE": 20140402,
    "Season": "2013-2014",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461146537386077857",
    "name": "The 2974 Collection #0878",
    "imageUrl": "https://arweave.net/y_Ld64EXi38WcGZptTQlOoC-2077BYM06zF5AKV46dc?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2014,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 879,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 48,
    "GAME_DATE": 20140404,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407055198495752297",
    "name": "The 2974 Collection #0879",
    "imageUrl": "https://arweave.net/S-aD1_XEyQBw0kGu0KyxlJ9IDAnP26TFrsBdLnH61ZU?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2014,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 880,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -199,
    "LOC_Y": 164,
    "GAME_DATE": 20140404,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/304437283984381301",
    "name": "The 2974 Collection #0880",
    "imageUrl": "https://arweave.net/FNYWFBwYMWcTfkO4EZ7h-97Llm7OvQumxbAt5hHjxtQ?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2014,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 881,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -125,
    "LOC_Y": 242,
    "GAME_DATE": 20140406,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404884936178987433",
    "name": "The 2974 Collection #0881",
    "imageUrl": "https://arweave.net/wqnFn5LIU63Bb8hmaaUSfwTs_Qxl5KlqDt9aIvLSZp8?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "16 Assists",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 882,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 149,
    "LOC_Y": 228,
    "GAME_DATE": 20140406,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/401862142547274991",
    "name": "The 2974 Collection #0882",
    "imageUrl": "https://arweave.net/38hMhdu3rBK3FptgyV7fR3f3xbweccCxfmu8U5RzRu4?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "16 Assists",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 883,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -202,
    "LOC_Y": 173,
    "GAME_DATE": 20140406,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533607394787024598",
    "name": "The 2974 Collection #0883",
    "imageUrl": "https://arweave.net/KMPQNC1X5EL2gsXOsQ0jdZpFLgKRpyAHnscYCZfD2XM?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "16 Assists",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 884,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -45,
    "LOC_Y": 246,
    "GAME_DATE": 20140406,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/313621518797247541",
    "name": "The 2974 Collection #0884",
    "imageUrl": "https://arweave.net/CtZZ6D_ALSQF5h3ql6UJym70NxeWz5kVcBlPe6kRFxc?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "16 Assists",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 885,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -175,
    "LOC_Y": 260,
    "GAME_DATE": 20140406,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300442097032121410",
    "name": "The 2974 Collection #0885",
    "imageUrl": "https://arweave.net/tuMttyJ8v9Jkgy2TRSAvXWPOnv6FWSr6is_RHIcvBwo?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "16 Assists",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 886,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -191,
    "LOC_Y": 179,
    "GAME_DATE": 20140410,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523337131628376559",
    "name": "The 2974 Collection #0886",
    "imageUrl": "https://arweave.net/dUlDJYD2bSxq-iksBZjRE4UbO_XiyUSG_-Ur11Yw8m4?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2014,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 887,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 114,
    "LOC_Y": 244,
    "GAME_DATE": 20140410,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503119960079421797",
    "name": "The 2974 Collection #0887",
    "imageUrl": "https://arweave.net/BjSZ8zEAmoeIVx9Ad7lKrWTeU8TyqX9PPjXYl6rHDyE?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2014,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 888,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -250,
    "LOC_Y": 50,
    "GAME_DATE": 20140411,
    "Season": "2013-2014",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443155971949240737",
    "name": "The 2974 Collection #0888",
    "imageUrl": "https://arweave.net/arZDcU9KFa_deCT681YLM1naxecYKylDhQDExdye_rI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "Triple-Double",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 889,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -127,
    "LOC_Y": 231,
    "GAME_DATE": 20140411,
    "Season": "2013-2014",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/306919525478165025",
    "name": "The 2974 Collection #0889",
    "imageUrl": "https://arweave.net/LO-PX7dIBVjbt5_ZaTFy9jaRqDtlmf1vpMRLDCtM8uo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 890,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -108,
    "LOC_Y": 244,
    "GAME_DATE": 20140411,
    "Season": "2013-2014",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478205556784124424",
    "name": "The 2974 Collection #0890",
    "imageUrl": "https://arweave.net/rKqVn8at51y_9rlgGxYfAInRKWDH4a1_JqZFXoJDtqw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "Triple-Double",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 891,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 125,
    "LOC_Y": 236,
    "GAME_DATE": 20140411,
    "Season": "2013-2014",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572590726429010183",
    "name": "The 2974 Collection #0891",
    "imageUrl": "https://arweave.net/f0SH-n763UpShOeDmH7aOClIKIS3fx0fD-L_UpOz5nY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "Triple-Double",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 892,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -67,
    "LOC_Y": 236,
    "GAME_DATE": 20140413,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/430453080800386615",
    "name": "The 2974 Collection #0892",
    "imageUrl": "https://arweave.net/RedAZ0SCyCiCsz030coGHWF3Irtee9zByjpjSGEB51w?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 893,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 144,
    "LOC_Y": 203,
    "GAME_DATE": 20140413,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461540023115252775",
    "name": "The 2974 Collection #0893",
    "imageUrl": "https://arweave.net/82wfHebPmcWxCqeg--CgGYLQTVHf0lXGboOU1ouuXCc?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 894,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 26,
    "GAME_DATE": 20140413,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450895499909647242",
    "name": "The 2974 Collection #0894",
    "imageUrl": "https://arweave.net/5RJbIcO28BpJ2ecCZmK_qsj9Pg7225AMWhkaEMAgWyY?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 895,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -4,
    "LOC_Y": 249,
    "GAME_DATE": 20140413,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502564495593310374",
    "name": "The 2974 Collection #0895",
    "imageUrl": "https://arweave.net/AICsDDcjmv0A80ExcLJ8ESVDUsSAauThbQoS_Mi-lGs?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 896,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 58,
    "LOC_Y": 236,
    "GAME_DATE": 20140413,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297605630287595802",
    "name": "The 2974 Collection #0896",
    "imageUrl": "https://arweave.net/Y5GMeXTGCF3gNmCF3PcWnV68c1dtoueguZlrXrVgpF0?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 897,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 86,
    "LOC_Y": 228,
    "GAME_DATE": 20140413,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533327652208675119",
    "name": "The 2974 Collection #0897",
    "imageUrl": "https://arweave.net/vRPHQoRgfuAG1MIUrqydVn2SYi5aIHZedzfg6S4XK04?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 898,
    "PERIOD": 5,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 141,
    "LOC_Y": 194,
    "GAME_DATE": 20140413,
    "Season": "2013-2014",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482440578344512794",
    "name": "The 2974 Collection #0898",
    "imageUrl": "https://arweave.net/8-peLSSIGW_6N_hIDtkmbvRXr4r8kQdDSVCbg3gLm6c?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 899,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 36,
    "LOC_Y": 254,
    "GAME_DATE": 20140414,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312551371131200274",
    "name": "The 2974 Collection #0899",
    "imageUrl": "https://arweave.net/4UnuDT-IjFlxLb_H88v66K8un_DNE9jjQPfNem-zCfQ?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 900,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -123,
    "LOC_Y": 236,
    "GAME_DATE": 20140414,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480309755607307212",
    "name": "The 2974 Collection #0900",
    "imageUrl": "https://arweave.net/6IeBr3o31QbQV4-GwOOixfcKh-V8Nz97j8UEaVPD6dY?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 901,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 138,
    "LOC_Y": 233,
    "GAME_DATE": 20140414,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/573902105347328238",
    "name": "The 2974 Collection #0901",
    "imageUrl": "https://arweave.net/1ZpvDrU4pwMrvvvh_dWr1sHuKMoeY-wgG79vK3_753g?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 902,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -155,
    "LOC_Y": 213,
    "GAME_DATE": 20140414,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/449147264568307704",
    "name": "The 2974 Collection #0902",
    "imageUrl": "https://arweave.net/8le_GvUq4p1jYW3hK115COioGUV1rli5NXZJitY88hQ?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 903,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 176,
    "LOC_Y": 194,
    "GAME_DATE": 20140414,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/409883929034233325",
    "name": "The 2974 Collection #0903",
    "imageUrl": "https://arweave.net/M4RgwAq2TdEZ2WJIQGZnWpYXn3jxWeiLQNyvGRbiIB0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 904,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -155,
    "LOC_Y": 244,
    "GAME_DATE": 20140414,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327321478502016920",
    "name": "The 2974 Collection #0904",
    "imageUrl": "https://arweave.net/Zwhdohra5vIchNJXINY1PdCD6ngtA3Qwo56vl_Pn6uA?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 905,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 179,
    "LOC_Y": 189,
    "GAME_DATE": 20140414,
    "Season": "2013-2014",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544456298631962423",
    "name": "The 2974 Collection #0905",
    "imageUrl": "https://arweave.net/IPmrjYCXArUM7ENfYCfpnxF4qOna_tuIY3beFm2Ymgo?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 906,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -18,
    "LOC_Y": 246,
    "GAME_DATE": 20141029,
    "Season": "2014-2015",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/10/29/0021400014/431/44e6a5dc-245c-1cfc-0637-51cfabe9c68b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572869667421833888",
    "name": "The 2974 Collection #0906",
    "imageUrl": "https://arweave.net/dB3QST3ovLIdCGWetFMIZneL0c6X45y5YXJGYOMBjuo?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2014,
    "Month": 10,
    "Day": 29,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 907,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 225,
    "LOC_Y": 99,
    "GAME_DATE": 20141029,
    "Season": "2014-2015",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/10/29/0021400014/605/25b01b8f-4669-b80e-b71f-f76215c123d4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544177182513964699",
    "name": "The 2974 Collection #0907",
    "imageUrl": "https://arweave.net/iLOcsex76BpZWbbz0Jq2H3x_zhcF5Srlormyzq8uOUc?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2014,
    "Month": 10,
    "Day": 29,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 908,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -123,
    "LOC_Y": 230,
    "GAME_DATE": 20141101,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/01/0021400038/62/9dd1bafa-d2ae-6dec-af51-51b5a73ea32f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/333032655603395065",
    "name": "The 2974 Collection #0908",
    "imageUrl": "https://arweave.net/KRdmoYk4cTXy_etDqlBKcFBxtk_VfopQgYYNjI96CvI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 909,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -123,
    "LOC_Y": 230,
    "GAME_DATE": 20141101,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/01/0021400038/88/b7ac1e04-ec5a-7629-c0a1-9354022435bb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/470753234965568818",
    "name": "The 2974 Collection #0909",
    "imageUrl": "https://arweave.net/ieQp3IxztB4HAul60rij55FwSO94W04ZYtzAVW_apgQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 910,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 159,
    "LOC_Y": 224,
    "GAME_DATE": 20141101,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/01/0021400038/341/2f65caff-98b2-a0bf-e739-8c2e6156395c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/527451742557623705",
    "name": "The 2974 Collection #0910",
    "imageUrl": "https://arweave.net/5Ba61aBEvkM176OtIGldugRj1CY3jjiBsOpYphHNFn0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 911,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -51,
    "LOC_Y": 242,
    "GAME_DATE": 20141102,
    "Season": "2014-2015",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/02/0021400042/38/b83243bb-c68d-510f-8d52-b35f2d975e4d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420312944251049353",
    "name": "The 2974 Collection #0911",
    "imageUrl": "https://arweave.net/n0kcQTC59cbkKFnjSwsoAvxSg-TOSSVyvPBryzv333k?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2014,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 912,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -199,
    "LOC_Y": 148,
    "GAME_DATE": 20141105,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/05/0021400068/51/54ec46f7-cf19-c1b1-c3a6-291a19fbd4cd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/488073187650683706",
    "name": "The 2974 Collection #0912",
    "imageUrl": "https://arweave.net/SgtI7gcFhEM2CAQa5MLVNIhrKI_0rGjP0KEG0juNhLU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 913,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 166,
    "LOC_Y": 203,
    "GAME_DATE": 20141105,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/05/0021400068/180/fbbe7883-b717-b6ec-1775-d9a684f8d800_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319123397089323392",
    "name": "The 2974 Collection #0913",
    "imageUrl": "https://arweave.net/hjfF7Te--qZcKGE00bfKkOxryftWmd64JrRMf4XR7_k?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 914,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -231,
    "LOC_Y": 74,
    "GAME_DATE": 20141105,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/05/0021400068/203/b37448f0-bbcf-b283-08a2-167a603c526a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421605818296683090",
    "name": "The 2974 Collection #0914",
    "imageUrl": "https://arweave.net/GrPXjwX_MkuQ9MOEGNgpO7P9mBsaMhG6xR_BPuDLKVI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 915,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 165,
    "LOC_Y": 220,
    "GAME_DATE": 20141105,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/05/0021400068/441/f61bce25-f601-861b-3e15-77a2b57db9f4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543904175323766253",
    "name": "The 2974 Collection #0915",
    "imageUrl": "https://arweave.net/TWjPfpSCUfg-e1RpX2gkKP2y6JP8_7SELU7XYVxpDy0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 916,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -8,
    "LOC_Y": 255,
    "GAME_DATE": 20141108,
    "Season": "2014-2015",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/08/0021400087/46/0460ab28-3d9e-e985-6dad-5c4698320594_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395811246465325414",
    "name": "The 2974 Collection #0916",
    "imageUrl": "https://arweave.net/CnE6H-CCF5__TtIs033JSA5iV21Cz5jEcklP8oVj-zQ?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 917,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -155,
    "LOC_Y": 189,
    "GAME_DATE": 20141108,
    "Season": "2014-2015",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/08/0021400087/328/63fc727b-bbe6-7c90-57f6-9cd3c66e1a4e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420213148688745959",
    "name": "The 2974 Collection #0917",
    "imageUrl": "https://arweave.net/oa_5HzK-5U0LO58BxEL6O3gRvyVAtqsJp-oL4kZXpFA?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 918,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 226,
    "LOC_Y": 42,
    "GAME_DATE": 20141108,
    "Season": "2014-2015",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/08/0021400087/361/b95f8545-1efc-1fbc-998e-b31892ce9128_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525136745810500478",
    "name": "The 2974 Collection #0918",
    "imageUrl": "https://arweave.net/Prn7Zkq1DbZIaKrEY7Kz0mvJQjaWjStmBSikeOvDAE8?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 919,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 122,
    "LOC_Y": 211,
    "GAME_DATE": 20141108,
    "Season": "2014-2015",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/08/0021400087/369/d7c54183-b256-df92-37ae-9c5257e3f83f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513180846466975128",
    "name": "The 2974 Collection #0919",
    "imageUrl": "https://arweave.net/aVJUcgOTf8Cwv3DdW1aA4b3YwZr2apUIJdVZT-Jo8cQ?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 920,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 236,
    "LOC_Y": 91,
    "GAME_DATE": 20141108,
    "Season": "2014-2015",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/08/0021400087/563/a789c3d2-f7fd-c32b-f65a-09af18d51cf9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366976526612657308",
    "name": "The 2974 Collection #0920",
    "imageUrl": "https://arweave.net/Ag3zw3IR1-PIAFOX2Q-fswZWb99fbHVlEtosvSngRRo?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 921,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 252,
    "GAME_DATE": 20141108,
    "Season": "2014-2015",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/08/0021400087/573/d9922988-2612-3299-8d50-b9f09d06c91e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/573607712590467169",
    "name": "The 2974 Collection #0921",
    "imageUrl": "https://arweave.net/LLuqULwaqVeuiIX-rSZTTAdLbQR37K7TXulGBkYeJRc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 922,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 21,
    "LOC_Y": 272,
    "GAME_DATE": 20141109,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/09/0021400095/22/f811c20e-46ff-c748-1f91-c7984d25ad43_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456024871739245955",
    "name": "The 2974 Collection #0922",
    "imageUrl": "https://arweave.net/4g869CJknNm_66j54ns_4RTpzq8mNLH6-Dv1ztZIdHM?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2014,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 923,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": -10,
    "GAME_DATE": 20141109,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/09/0021400095/53/9b3d8c1e-02b7-7369-3a67-13b69d3368b2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459040004142101242",
    "name": "The 2974 Collection #0923",
    "imageUrl": "https://arweave.net/AGzEezVA_xrzpKExMY9TBFsOixa22nKk-xQdecMFnQ8?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2014,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 924,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 22,
    "GAME_DATE": 20141109,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/09/0021400095/184/877dfc09-8605-1388-080f-346bd0bb22d8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/304605849141954300",
    "name": "The 2974 Collection #0924",
    "imageUrl": "https://arweave.net/gZjR5spcKZulu4AjcLudDd---Lg9H59HfDF5Abe2m4Q?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2014,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 925,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -84,
    "LOC_Y": 230,
    "GAME_DATE": 20141109,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/09/0021400095/218/48629845-78de-06cb-c70b-1988262c7106_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558713168944284105",
    "name": "The 2974 Collection #0925",
    "imageUrl": "https://arweave.net/G-vgSWaW8I9geNiuX61XesWtuGdtQWC3nIQBTfC4UVI?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2014,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 926,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 222,
    "LOC_Y": 108,
    "GAME_DATE": 20141113,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547763071826710969",
    "name": "The 2974 Collection #0926",
    "imageUrl": "https://arweave.net/trLqfNf9bMomChlbvlRwFD1WmIiGaFmBBNVwqOZkDes?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2014,
    "Month": 11,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 927,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 237,
    "LOC_Y": 15,
    "GAME_DATE": 20141113,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440175646233994081",
    "name": "The 2974 Collection #0927",
    "imageUrl": "https://arweave.net/C6fuFIHFz1_98tLFeq--LRGBjw-RkMpNyKiTUJQtaUo?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2014,
    "Month": 11,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 928,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 163,
    "LOC_Y": 217,
    "GAME_DATE": 20141113,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384278410091960657",
    "name": "The 2974 Collection #0928",
    "imageUrl": "https://arweave.net/Z2Qo7a7pasLGW6378z0oTFiktaDC4lK6sajFeiDWDkI?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2014,
    "Month": 11,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 929,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -224,
    "LOC_Y": 129,
    "GAME_DATE": 20141115,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/15/0021400140/216/3d071bdb-77f4-f6c7-7496-96cf6e95a3f2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/574090707653457762",
    "name": "The 2974 Collection #0929",
    "imageUrl": "https://arweave.net/SUtOCD4DAw07JTAr7-c1tDiVmyusZJvnc6dYWTjVPY8?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2014,
    "Month": 11,
    "Day": 15,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 930,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -166,
    "LOC_Y": 230,
    "GAME_DATE": 20141115,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/15/0021400140/225/03fb8d0a-3902-64b4-4ff3-b914c44aa574_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364114641170270331",
    "name": "The 2974 Collection #0930",
    "imageUrl": "https://arweave.net/kJL6PUOmgNYvjXX1AtW37pGvWfQztfLqZh0c9N1nXlg?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2014,
    "Month": 11,
    "Day": 15,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 931,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -32,
    "LOC_Y": 266,
    "GAME_DATE": 20141115,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/15/0021400140/390/4721b553-5af5-9d2b-f043-3f04d3300868_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335328827925907402",
    "name": "The 2974 Collection #0931",
    "imageUrl": "https://arweave.net/pDJenqaKGtKsKgH59HVH4_u7eRnEO6L1BCg1RzrcCb0?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2014,
    "Month": 11,
    "Day": 15,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 932,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 15,
    "LOC_Y": 260,
    "GAME_DATE": 20141116,
    "Season": "2014-2015",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/16/0021400145/73/bf741db2-5f70-3e69-8405-9c619f938255_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321274143383588419",
    "name": "The 2974 Collection #0932",
    "imageUrl": "https://arweave.net/SXEBqqIRUTUJf1G-x6jFtoRnizIFicTNhDhLINps1w4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 933,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 138,
    "LOC_Y": 211,
    "GAME_DATE": 20141116,
    "Season": "2014-2015",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/16/0021400145/248/7e3e3f85-76a5-52a0-7c54-fd7f987c3e36_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575819572772373407",
    "name": "The 2974 Collection #0933",
    "imageUrl": "https://arweave.net/DEjS1vVN4l2VGb-OtgJvgT6kSKTPKBxesu11nhI8nyI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 934,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -188,
    "LOC_Y": 214,
    "GAME_DATE": 20141116,
    "Season": "2014-2015",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/16/0021400145/267/c51ca29d-8787-cfed-1731-90698d464c26_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300801249394208961",
    "name": "The 2974 Collection #0934",
    "imageUrl": "https://arweave.net/i4Ykv1cz3JGRXWapSXcOOkgKenVfl4cxRxJLS_pH3jA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 935,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -171,
    "LOC_Y": 224,
    "GAME_DATE": 20141116,
    "Season": "2014-2015",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/16/0021400145/324/c0665314-b7c9-6c70-4ea2-34cd47f8a6c9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433955455880338772",
    "name": "The 2974 Collection #0935",
    "imageUrl": "https://arweave.net/RoExQ_1Qx4VnP5y4Nehj4xFOuFBir2F13eGKphIvnd0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 936,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 125,
    "LOC_Y": 220,
    "GAME_DATE": 20141116,
    "Season": "2014-2015",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/16/0021400145/369/1065be05-d80b-a969-eea4-77e85a711e87_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/442610165527372749",
    "name": "The 2974 Collection #0936",
    "imageUrl": "https://arweave.net/xhUnbiZATwJA6VfD-yiMC9OJVyOXHni03S95LwmzCD8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 937,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 121,
    "LOC_Y": 258,
    "GAME_DATE": 20141121,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/21/0021400182/13/afa77835-91db-9b13-47e1-929cbc516896_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300330038576768751",
    "name": "The 2974 Collection #0937",
    "imageUrl": "https://arweave.net/bwN2Gd5coyY2IfjUfHwoTej6fO5aahSzUsATPBzExbw?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 11,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 938,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -109,
    "LOC_Y": 228,
    "GAME_DATE": 20141121,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/21/0021400182/91/a269075c-691c-8e0f-b120-2f3e01f5c52e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348082881365682779",
    "name": "The 2974 Collection #0938",
    "imageUrl": "https://arweave.net/J79oJDsxQ0crCeG6Y9vawS9eNDtJHsbctlRClaMELvs?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2014,
    "Month": 11,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 939,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 4,
    "LOC_Y": 244,
    "GAME_DATE": 20141123,
    "Season": "2014-2015",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/23/0021400196/5/04ccb4df-6220-ce15-c1a5-7555301bfeba_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388215293609083245",
    "name": "The 2974 Collection #0939",
    "imageUrl": "https://arweave.net/qYuP-PD7rFVEa2yX16RY2khce3jOL3QnPjCv-vH3cRM?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 940,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -158,
    "LOC_Y": 187,
    "GAME_DATE": 20141123,
    "Season": "2014-2015",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/23/0021400196/73/a5767984-fbb1-65d2-3336-5385a07060f1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417451982309504182",
    "name": "The 2974 Collection #0940",
    "imageUrl": "https://arweave.net/dEEpjPm_0Rmyu8ISr0ePqwkhn65l5jjbMTg8vlZ0Bjk?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 941,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -136,
    "LOC_Y": 203,
    "GAME_DATE": 20141125,
    "Season": "2014-2015",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/25/0021400206/7/28da73b9-bd2a-539a-c973-2a47d4b4070b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/559587662565374599",
    "name": "The 2974 Collection #0941",
    "imageUrl": "https://arweave.net/2gobmLLmf8plL93xxtdqjjpSHUXqdE8i6LCgqjdYnl8?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 942,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -59,
    "LOC_Y": 241,
    "GAME_DATE": 20141125,
    "Season": "2014-2015",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/25/0021400206/42/2b774b52-b44a-d78f-a8e1-a566e079e209_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/427600632583256677",
    "name": "The 2974 Collection #0942",
    "imageUrl": "https://arweave.net/47G9NryVYLhxYgUyzt4fwGd2B7mD-qZWmvm9fj3r1vA?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 943,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -201,
    "LOC_Y": 138,
    "GAME_DATE": 20141125,
    "Season": "2014-2015",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/25/0021400206/205/3fa31283-bb51-1ed4-23f8-32d36f627012_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458873609026565216",
    "name": "The 2974 Collection #0943",
    "imageUrl": "https://arweave.net/1vQ38FQIRN4uI-p17yiIFfQDpH-GSwDmpA8eI-OqR98?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 944,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -15,
    "LOC_Y": 246,
    "GAME_DATE": 20141125,
    "Season": "2014-2015",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/25/0021400206/244/ba3e5c8a-cf22-2682-78c1-b5ffe230ec3b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546770600634566635",
    "name": "The 2974 Collection #0944",
    "imageUrl": "https://arweave.net/A7F1OeFaQ_LBQQ4r3C5RSjXJUrOAwTZNDAzcRqzNNFU?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 945,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 160,
    "LOC_Y": 194,
    "GAME_DATE": 20141125,
    "Season": "2014-2015",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/25/0021400206/292/66381957-5796-f332-9333-94daff89b820_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308046379297340356",
    "name": "The 2974 Collection #0945",
    "imageUrl": "https://arweave.net/7z7ymBLStkxN3EDjwRASYRvZ3FIJsZlettXP3DK50zg?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 946,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 242,
    "LOC_Y": 31,
    "GAME_DATE": 20141125,
    "Season": "2014-2015",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/25/0021400206/300/c5a15a23-b6bc-84bc-aec3-40397a157ba0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/554873391993561906",
    "name": "The 2974 Collection #0946",
    "imageUrl": "https://arweave.net/JfIAS_FWkZEup9abGGpE0QwCWKCtvlHUUYEhAhTTxio?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 947,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 51,
    "LOC_Y": 247,
    "GAME_DATE": 20141125,
    "Season": "2014-2015",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/25/0021400206/345/8e143e39-f865-6733-78c7-23a661daa4b4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541394749803531166",
    "name": "The 2974 Collection #0947",
    "imageUrl": "https://arweave.net/dmEWRbg25Ia0niqBMtmnIYBvZzR_jsmEbWtjqYSvBjU?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 948,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -174,
    "LOC_Y": 172,
    "GAME_DATE": 20141125,
    "Season": "2014-2015",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/25/0021400206/485/53db0ef1-5438-29f4-b355-c160e7db41f4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575478955407757147",
    "name": "The 2974 Collection #0948",
    "imageUrl": "https://arweave.net/VwQueWaV4bul6X4FtwZlLz3KEU5ZKi-OBFAd9iTSiu8?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2014,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 949,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -71,
    "LOC_Y": 272,
    "GAME_DATE": 20141126,
    "Season": "2014-2015",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/26/0021400212/41/6451f1fe-7079-de73-75ee-dc57fac117dd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/396656766142557969",
    "name": "The 2974 Collection #0949",
    "imageUrl": "https://arweave.net/FcVw4gSoTNY6GGID45HiZwS_zn892cdI2vCZ07Z1VGU?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 950,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -175,
    "LOC_Y": 176,
    "GAME_DATE": 20141126,
    "Season": "2014-2015",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/26/0021400212/67/970cc0bc-7d61-bfb5-1fe4-2a7791448363_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/350692340581664819",
    "name": "The 2974 Collection #0950",
    "imageUrl": "https://arweave.net/uSyV8AhanaiIGFOO5iGDo5GIHr8ATq6RbzQGSxNSd5M?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 951,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 47,
    "GAME_DATE": 20141126,
    "Season": "2014-2015",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/26/0021400212/84/7259feec-65dc-6279-0ae4-e09bac84771e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489945546779982081",
    "name": "The 2974 Collection #0951",
    "imageUrl": "https://arweave.net/E37X8fouvKPYocN_JAE6Qe-i5EclVRzcxuvIky9l0gc?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 952,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 72,
    "LOC_Y": 258,
    "GAME_DATE": 20141126,
    "Season": "2014-2015",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/26/0021400212/95/60ed813c-dae9-d9e6-a4eb-7d410a7268b1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302012841110103789",
    "name": "The 2974 Collection #0952",
    "imageUrl": "https://arweave.net/Wy5elVo0FdENb2JiYabd3x3BPwgbIazz9dCTPxltITM?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 953,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -30,
    "LOC_Y": 290,
    "GAME_DATE": 20141126,
    "Season": "2014-2015",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/26/0021400212/210/1c58995b-8932-dd87-be87-042343866dcd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440930285608057630",
    "name": "The 2974 Collection #0953",
    "imageUrl": "https://arweave.net/NYgI6yqJqqq6-Y29oYloo4mly8j2R1u4UPVLYPmVM9U?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 954,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 18,
    "LOC_Y": 277,
    "GAME_DATE": 20141126,
    "Season": "2014-2015",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/26/0021400212/320/7b1aa9c2-e5f0-ccc6-1286-0a81949aeba6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439113791104421300",
    "name": "The 2974 Collection #0954",
    "imageUrl": "https://arweave.net/sIlb8hROXiwlCy66YwR_jqoZ4VDelAScI7Xb23uM08Q?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 955,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 206,
    "LOC_Y": 165,
    "GAME_DATE": 20141128,
    "Season": "2014-2015",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/28/0021400224/6/17b75309-5b07-49f7-af38-8e4e613509c0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/315834007390219644",
    "name": "The 2974 Collection #0955",
    "imageUrl": "https://arweave.net/IrF9lpkMwDRlOImk3zneifKW02_pvYUfyJkcAVBe1wM?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2014,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 956,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -19,
    "LOC_Y": 268,
    "GAME_DATE": 20141130,
    "Season": "2014-2015",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/11/30/0021400243/251/87f6bb15-aac4-9a5d-35bd-db107abbe0dd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/410689448552667665",
    "name": "The 2974 Collection #0956",
    "imageUrl": "https://arweave.net/Ac5jnAIGTWG-DEOVYwOUVhc9dXFet8gLqqNLbu3hlqc?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2014,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 957,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -95,
    "LOC_Y": 280,
    "GAME_DATE": 20141202,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/02/0021400262/225/6706a284-096f-3362-1238-181b445908ea_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346879060246776577",
    "name": "The 2974 Collection #0957",
    "imageUrl": "https://arweave.net/iwS2QwvVUjF6v2TM2n9yKfZAf5HDmDkJ7SgnxkxeXLc?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 958,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -171,
    "LOC_Y": 220,
    "GAME_DATE": 20141202,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/02/0021400262/437/65f08f76-afd7-e35a-c4f9-f3fd1988d05f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338895642632956481",
    "name": "The 2974 Collection #0958",
    "imageUrl": "https://arweave.net/qcSUcUiPIfFA_gsDJLp008svUh3Xb_W-TotWtnRNeGc?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 959,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 174,
    "LOC_Y": 209,
    "GAME_DATE": 20141202,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/02/0021400262/474/88df965a-ac52-4efe-2b7f-31b8432a5fd2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/472941379251689814",
    "name": "The 2974 Collection #0959",
    "imageUrl": "https://arweave.net/RjFqiZ78Mr76wCnvrvPFPQTD7pcHAGbmm_uFaoEiPDE?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2014,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 960,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -38,
    "LOC_Y": 266,
    "GAME_DATE": 20141204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/04/0021400275/16/996f9642-d51f-c280-deb5-8280af5ffddc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352046929868761957",
    "name": "The 2974 Collection #0960",
    "imageUrl": "https://arweave.net/r8KKJHDirafGlBO5n48wWTpDf-0vMeqU9U2rG2SCcew?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 961,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 187,
    "LOC_Y": 206,
    "GAME_DATE": 20141204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/04/0021400275/221/5defa698-dc2a-efac-90dd-0ceb1074a59f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403951204300963398",
    "name": "The 2974 Collection #0961",
    "imageUrl": "https://arweave.net/ZO0QfQmChm_zx82gnLcpXmUBF9p5yhwBXfyqt015w_4?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 962,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 50,
    "GAME_DATE": 20141204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/04/0021400275/435/72c46e9b-a479-3d87-7e3f-7b23aca0db6e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441697870992003431",
    "name": "The 2974 Collection #0962",
    "imageUrl": "https://arweave.net/uC9DEuApZrPjM0fT8IiMG1q4JpCS0AHwjRIbBE1cY08?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 963,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -87,
    "LOC_Y": 239,
    "GAME_DATE": 20141206,
    "Season": "2014-2015",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/06/0021400289/351/64f6975e-ab05-1e49-443f-f754bf5c7830_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326177688884539880",
    "name": "The 2974 Collection #0963",
    "imageUrl": "https://arweave.net/mqXyyeQkMC3hIULsqupFT5fICqS-IKHcifwmPbHxo4c?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2014,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 964,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -157,
    "LOC_Y": 195,
    "GAME_DATE": 20141208,
    "Season": "2014-2015",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/08/0021400305/351/36a1b12a-c9a9-ee46-4b90-71461d863bb6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360603963267974669",
    "name": "The 2974 Collection #0964",
    "imageUrl": "https://arweave.net/hu86AFnUBwHe34EphakUgudYQ-WZ5tIPedr8HAnN9vs?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 965,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 19,
    "GAME_DATE": 20141210,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/10/0021400324/231/fb0962b7-70a4-61d8-2512-a870284c062b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/350612053908688007",
    "name": "The 2974 Collection #0965",
    "imageUrl": "https://arweave.net/66-gjYT4UY0LKnjWERM9kZ6qrBHdok8vkzmKQ7pJXzY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 966,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -40,
    "LOC_Y": 279,
    "GAME_DATE": 20141210,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/10/0021400324/244/d084d750-5aed-b368-4fe3-c1a22989215d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508199236236144780",
    "name": "The 2974 Collection #0966",
    "imageUrl": "https://arweave.net/gKERclO1prSSBwaKuEODAf4q7C1AlmPLx_6K-NGTCLY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 967,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -52,
    "LOC_Y": 268,
    "GAME_DATE": 20141210,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/10/0021400324/475/8a9215cd-71fa-bd21-b0ef-e6a38285585f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543139290443175513",
    "name": "The 2974 Collection #0967",
    "imageUrl": "https://arweave.net/uANa88888tPPjwLLzaeOIX-HFabl3GgllUN2Z8YgZP0?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2014,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 968,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 204,
    "LOC_Y": 137,
    "GAME_DATE": 20141213,
    "Season": "2014-2015",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/13/0021400340/18/2ede9e53-c6f5-d0ef-8195-f9bd255cb89b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502327588074429355",
    "name": "The 2974 Collection #0968",
    "imageUrl": "https://arweave.net/CkRhg5O5uavke8MdfSI943e7m8-auft3EIkSygYSJFU?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2014,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 969,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 203,
    "LOC_Y": 209,
    "GAME_DATE": 20141213,
    "Season": "2014-2015",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/13/0021400340/72/aab17923-2d45-faf0-8f15-91ef3d2fb62c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508931826954139935",
    "name": "The 2974 Collection #0969",
    "imageUrl": "https://arweave.net/aVyzqrob0myL2nX1c_dPsmxUoSWDWE2TN_PwkwSHCWA?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2014,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 970,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 226,
    "LOC_Y": 23,
    "GAME_DATE": 20141213,
    "Season": "2014-2015",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/13/0021400340/121/80ea176b-147d-fef6-03af-bf1c31ba2dbd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/527527574028168505",
    "name": "The 2974 Collection #0970",
    "imageUrl": "https://arweave.net/RhKDDikIxb8TIjxlBDIe3DBOXHx7bxjmUURrmkKS12k?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2014,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 971,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -155,
    "LOC_Y": 198,
    "GAME_DATE": 20141214,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/14/0021400348/21/e27b6d38-0a05-4a86-9569-e6a0ae42ed4f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386774427327197985",
    "name": "The 2974 Collection #0971",
    "imageUrl": "https://arweave.net/_RYYPnXfLLveP5bE9BiQVLMN94M1cUqygt1RihCXW_Q?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 972,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 146,
    "LOC_Y": 200,
    "GAME_DATE": 20141214,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/14/0021400348/40/579f2251-95ba-37b5-0cd7-8c36f1edc52f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525185780529028577",
    "name": "The 2974 Collection #0972",
    "imageUrl": "https://arweave.net/j2pexUZIk1R-rBTaCkQaHsgTtXck1jDpGuY_fnh5_e8?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 973,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 32,
    "LOC_Y": 257,
    "GAME_DATE": 20141214,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/14/0021400348/46/6e723b4e-6794-6b99-c298-f7e9c87ad54c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502215019698875590",
    "name": "The 2974 Collection #0973",
    "imageUrl": "https://arweave.net/aQyKUJpqgDJutirV45Ulgu_2RLEOLL33nUQzm6s5E_8?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 974,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -84,
    "LOC_Y": 241,
    "GAME_DATE": 20141214,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/14/0021400348/296/86090745-5d7e-e4ad-4d32-0b44b0f30a81_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/509804908971194494",
    "name": "The 2974 Collection #0974",
    "imageUrl": "https://arweave.net/1naueZlFyFtS6bS2aXNKL2p2M6GFEipnBjLehFUHaQo?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 975,
    "PERIOD": 5,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 88,
    "LOC_Y": 242,
    "GAME_DATE": 20141214,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/14/0021400348/570/5e3d80f8-1d26-a892-46ae-53503e8b0d84_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572939912699106618",
    "name": "The 2974 Collection #0975",
    "imageUrl": "https://arweave.net/tajFosUjHcXQk9hmtJS33RNqkbCdGKy00q7P3EaiYZY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 976,
    "PERIOD": 5,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -163,
    "LOC_Y": 206,
    "GAME_DATE": 20141214,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/14/0021400348/591/af26e35a-c713-7679-f3a2-6bbca9ea3c46_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/365231003103054113",
    "name": "The 2974 Collection #0976",
    "imageUrl": "https://arweave.net/KCW6zLEb5b8Bo3NoI-r6nESatFYrUc2gkEAccO0ZJ3U?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2014,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 977,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -89,
    "LOC_Y": 242,
    "GAME_DATE": 20141216,
    "Season": "2014-2015",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/16/0021400365/345/6811aad8-dc6a-58db-4b33-7c0d328ad2e0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/365600669434678169",
    "name": "The 2974 Collection #0977",
    "imageUrl": "https://arweave.net/5x3a4WIq2aAg6ppDwC1_9SJofejUrZl4qDbtR3XVsFQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2014,
    "Month": 12,
    "Day": 16,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 978,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 64,
    "LOC_Y": 238,
    "GAME_DATE": 20141218,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/18/0021400382/26/102dfa4c-26a5-0d52-9427-d15384b2ded1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/292131609150699495",
    "name": "The 2974 Collection #0978",
    "imageUrl": "https://arweave.net/SdxK_Xmm7eqnXyEfTr5fHtL27pI0VXWFXTCDdRxACIg?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 979,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -172,
    "LOC_Y": 213,
    "GAME_DATE": 20141218,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/18/0021400382/79/709f8a0c-2eb8-6658-3be8-bcb098ec6c06_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/563296255564769960",
    "name": "The 2974 Collection #0979",
    "imageUrl": "https://arweave.net/1CLn9Yia0d0pZTfpKDi_1LqEkl0EquExLzxGOldtsks?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 980,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 204,
    "LOC_Y": 181,
    "GAME_DATE": 20141218,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/18/0021400382/157/96e85b7a-a920-502a-31de-de7c49cecce0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524182595458904809",
    "name": "The 2974 Collection #0980",
    "imageUrl": "https://arweave.net/zUaBym9muVKkEnVWChoI403l-rGGCAJffbW3FGEqyog?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 981,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -205,
    "LOC_Y": 189,
    "GAME_DATE": 20141218,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/18/0021400382/197/1f170727-75cc-5cfa-a2de-1378c5abab43_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461867632459358373",
    "name": "The 2974 Collection #0981",
    "imageUrl": "https://arweave.net/8p8JQCq9iflE761KNzkKZRbXsFDEnkdGQ6ZNEjbGcCY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 982,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 163,
    "LOC_Y": 197,
    "GAME_DATE": 20141218,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/18/0021400382/426/ceb856af-75d1-d327-2f94-6c3bd80c74ad_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562778647249501301",
    "name": "The 2974 Collection #0982",
    "imageUrl": "https://arweave.net/unZhs3km_lSm2yrzUbB39fY-OD5QmwXBXJAWf3nGaso?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2014,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 983,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -127,
    "LOC_Y": 255,
    "GAME_DATE": 20141222,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/22/0021400415/106/ee767c61-a81e-a737-eec6-b10f8249ce5b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354103927819010844",
    "name": "The 2974 Collection #0983",
    "imageUrl": "https://arweave.net/iSKhn8PWl4ksTAtr8HwF8dIxRN7FdPbJJQcadBsWKBQ?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2014,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 984,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -117,
    "LOC_Y": 224,
    "GAME_DATE": 20141223,
    "Season": "2014-2015",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/23/0021400426/55/84a86eba-4bea-ba41-b572-777ab3e97c8b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322392951646914705",
    "name": "The 2974 Collection #0984",
    "imageUrl": "https://arweave.net/df8O0FcmZi-h1dwuP_Feev5mfVt0WJ2qFpb04BvN-Yc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 985,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -4,
    "LOC_Y": 257,
    "GAME_DATE": 20141223,
    "Season": "2014-2015",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/23/0021400426/283/ef6f4e60-e8b9-542f-0daf-d26b6422ca42_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307365806445126075",
    "name": "The 2974 Collection #0985",
    "imageUrl": "https://arweave.net/Zd7FEynNinFahsDRYAuBA1oiBuVvU1jd9mQ6L5vdQq4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 986,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 152,
    "LOC_Y": 222,
    "GAME_DATE": 20141225,
    "Season": "2014-2015",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/25/0021400431/11/b4c8e93c-1430-dab3-bd35-8e2388906cff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300278253344007011",
    "name": "The 2974 Collection #0986",
    "imageUrl": "https://arweave.net/BHLV0lQSUK11jQfaAVyqG7ryrrUL69wZ30MGH71yXG4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2014,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 1,
    "Special Moment": "Christmas",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 987,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 218,
    "LOC_Y": 129,
    "GAME_DATE": 20141227,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/27/0021400452/35/4cd8ea34-ee2e-773d-1100-51fdbc1853d8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458833213717019675",
    "name": "The 2974 Collection #0987",
    "imageUrl": "https://arweave.net/3ZBjH-foGPoJ4jFPtES20CdgS3D3ABc1EWyMGHkw224?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 988,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -191,
    "LOC_Y": 184,
    "GAME_DATE": 20141227,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/27/0021400452/120/a52c6cc3-84c3-fa15-91e6-ff730b3cb4ba_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/472226037466786892",
    "name": "The 2974 Collection #0988",
    "imageUrl": "https://arweave.net/J8FkJO5jLvoZhxvEPv-1xz4_tGJiv25zgL2CVDgwv2U?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 989,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": -14,
    "GAME_DATE": 20141227,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/27/0021400452/304/a161f4cb-305e-39f2-d6de-0df9b2db8383_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378060011149654147",
    "name": "The 2974 Collection #0989",
    "imageUrl": "https://arweave.net/EkQVBjB_4ir4eh0GM-Clw1TdboBhnikX4bQLr8VtgxU?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 990,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 236,
    "LOC_Y": 53,
    "GAME_DATE": 20141227,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/27/0021400452/364/e04597aa-4890-5d6b-faf4-fb4939d04374_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/514207194356521717",
    "name": "The 2974 Collection #0990",
    "imageUrl": "https://arweave.net/EcQqEuVwbPgo3NlrnzS3ybn22gFhXbyflcMY6kub714?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2014,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 991,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -157,
    "LOC_Y": 216,
    "GAME_DATE": 20141230,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/30/0021400474/58/4da376a1-5ff3-965e-c0bc-b7d34cd09bc7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541069988562715528",
    "name": "The 2974 Collection #0991",
    "imageUrl": "https://arweave.net/_fbi-9OtPg33txSjMPurlyXXfZNlJgrBqLPamsSYCa8?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2014,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 992,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -201,
    "LOC_Y": 190,
    "GAME_DATE": 20141230,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/30/0021400474/80/13864862-2eb0-1284-6915-40550f3233fe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301714755856284276",
    "name": "The 2974 Collection #0992",
    "imageUrl": "https://arweave.net/jBjogaYvvW6IXKFDnneqNuxn8KjhfCutS_cPiK9cYXs?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2014,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 993,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -86,
    "LOC_Y": 247,
    "GAME_DATE": 20141230,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2014/12/30/0021400474/333/84906e6b-92f9-3217-8fe9-f8ae38c3c2bf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390282819257399153",
    "name": "The 2974 Collection #0993",
    "imageUrl": "https://arweave.net/KLLSEPSly9FRzzqKA8MBynnYPockgDSrWNtXR-gEk24?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2014,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 994,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -175,
    "LOC_Y": 209,
    "GAME_DATE": 20150102,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/02/0021400493/4/f112a794-5968-ffc6-924a-a40f45cd99ec_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500922718376340611",
    "name": "The 2974 Collection #0994",
    "imageUrl": "https://arweave.net/njTM6rlWSQ1VnKQbrUXvmZuQ9oRUqMDPUElsjG-4qIM?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 995,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 168,
    "LOC_Y": 200,
    "GAME_DATE": 20150102,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/02/0021400493/250/28127a0f-4045-64c3-5848-f245da9c029e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/507633941470054931",
    "name": "The 2974 Collection #0995",
    "imageUrl": "https://arweave.net/i_WXI8gGMPj3W_BoV8GemIXEv414PqcyBGvcLudFvHc?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 996,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 181,
    "LOC_Y": 225,
    "GAME_DATE": 20150102,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/02/0021400493/416/8972def5-18d7-e210-e030-d063d8761839_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550414581512543959",
    "name": "The 2974 Collection #0996",
    "imageUrl": "https://arweave.net/iDZoQGHNMohaS1Hm7jh4ZUooG0QtakuEZVmnJ3nm_58?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 997,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 37,
    "GAME_DATE": 20150102,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/02/0021400493/468/edfa5ec0-bdc4-802f-4ae4-6ef828dcd40e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386744369281550610",
    "name": "The 2974 Collection #0997",
    "imageUrl": "https://arweave.net/VwhverC12NznJTB_OsX_vkAezxg9MZ0EVt0KrOSqIoc?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 998,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 176,
    "LOC_Y": 211,
    "GAME_DATE": 20150102,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/02/0021400493/471/e56d1f96-5e1e-e68b-6fec-40fa16f09a54_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374325729903514581",
    "name": "The 2974 Collection #0998",
    "imageUrl": "https://arweave.net/Cd4uoHB-yf46XN9KEXi_baXhcQn4aBG-hNfpPJtvyTY?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 999,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -146,
    "LOC_Y": 277,
    "GAME_DATE": 20150105,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/05/0021400518/508/4f9996c3-a527-56bb-403e-6e29edbde782_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/457222321776853160",
    "name": "The 2974 Collection #0999",
    "imageUrl": "https://arweave.net/1rU47oXmTSv63XatTBrkkwtZ_8vnmMMu4apJ4z-M0Ac?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2015,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1000,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -169,
    "LOC_Y": 205,
    "GAME_DATE": 20150107,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/07/0021400533/42/90b936c7-103d-c759-4ed8-2731ea74f159_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485925757465007759",
    "name": "The 2974 Collection #1000",
    "imageUrl": "https://arweave.net/97MKJpLfUALQTgUZA9oDJvo45e_4IY5lnAAzO6cXnwg?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2015,
    "Month": 1,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1001,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 174,
    "LOC_Y": 257,
    "GAME_DATE": 20150107,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/07/0021400533/191/651a511f-5987-79b2-69b4-bc8c3a4c646a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/559851399948136515",
    "name": "The 2974 Collection #1001",
    "imageUrl": "https://arweave.net/16H8TEmXF4nIWYpZuxPFGrHnR_se5F8PFqDlggeKtJs?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2015,
    "Month": 1,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1002,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 108,
    "LOC_Y": 260,
    "GAME_DATE": 20150107,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/07/0021400533/232/9c59a72b-85b3-4ebf-4c57-ecaadf185ef2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/410577804014947321",
    "name": "The 2974 Collection #1002",
    "imageUrl": "https://arweave.net/KTde89VDmzQYNwawoVKXhvOWNyXYOlVA4T-JtdMyaz4?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2015,
    "Month": 1,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1003,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -177,
    "LOC_Y": 172,
    "GAME_DATE": 20150107,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/07/0021400533/451/9202285b-9eea-b3cb-228b-00cfebd2be96_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296319965544998273",
    "name": "The 2974 Collection #1003",
    "imageUrl": "https://arweave.net/Y6jLJZO2-FsxJwL8JRLuX9LLZ4EAIxOlzJJUxhHLrqo?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2015,
    "Month": 1,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1004,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -209,
    "LOC_Y": 156,
    "GAME_DATE": 20150109,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/09/0021400547/91/ae80f9b8-cd12-ed47-513e-23aaf55b5421_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361119516366681855",
    "name": "The 2974 Collection #1004",
    "imageUrl": "https://arweave.net/8cQeJXgOz2vvMohen6cjcfi6ZF1DP2wA134XCTFWWA4?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2015,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1005,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 130,
    "LOC_Y": 235,
    "GAME_DATE": 20150109,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/09/0021400547/237/9dac7bd7-83d2-0d48-54c4-520e8aa4469d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346310628604675903",
    "name": "The 2974 Collection #1005",
    "imageUrl": "https://arweave.net/qPUUDm8BPSjrfZjFOn8Sv6h_STxnlSPePwGeNhNbyls?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2015,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1006,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 110,
    "LOC_Y": 230,
    "GAME_DATE": 20150109,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/09/0021400547/331/993e78f3-7f91-b4f2-ea45-252eb2a9c032_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561076526066283467",
    "name": "The 2974 Collection #1006",
    "imageUrl": "https://arweave.net/rgoxyNZEalsdpC_LRNIImhyyodKZ3WQ6DITly6yQ9N4?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2015,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1007,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 121,
    "LOC_Y": 224,
    "GAME_DATE": 20150113,
    "Season": "2014-2015",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/13/0021400571/31/aa8a71fa-6335-54f0-a908-31f8368d8179_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533647079223441094",
    "name": "The 2974 Collection #1007",
    "imageUrl": "https://arweave.net/hJ3Os8CeIFW7fbbMnwMQw-XSmpnG_RDS9UjjT_YZtjc?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1008,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 257,
    "GAME_DATE": 20150113,
    "Season": "2014-2015",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/13/0021400571/197/b50836f4-abb4-5e63-8715-c4cd8a83e553_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402193606042264239",
    "name": "The 2974 Collection #1008",
    "imageUrl": "https://arweave.net/66F4OCMHESIYhldX7l6Ns1uoribYlrEkdJsRWKl-XyE?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1009,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 108,
    "LOC_Y": 217,
    "GAME_DATE": 20150113,
    "Season": "2014-2015",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/13/0021400571/235/9815db35-285e-21fa-f724-92c97ab57ae0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/303543550422187826",
    "name": "The 2974 Collection #1009",
    "imageUrl": "https://arweave.net/TkYb3xjcBJAApNsliugU83utmFxdbLPjtELO73wAfpA?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1010,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 234,
    "LOC_Y": 85,
    "GAME_DATE": 20150113,
    "Season": "2014-2015",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/13/0021400571/243/b530b604-0867-9ad6-aaf1-9a7012596640_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519127046884846712",
    "name": "The 2974 Collection #1010",
    "imageUrl": "https://arweave.net/4ugM3l-Y_962yhrOrA6WXeXfPSeJXWrGMrFoCeGv628?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1011,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 48,
    "GAME_DATE": 20150114,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/14/0021400582/25/8eac357b-3029-205d-1d37-4299ee7521a4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/318335147202799539",
    "name": "The 2974 Collection #1011",
    "imageUrl": "https://arweave.net/U82qh9yZgWCjqzj5OszZsmHf1NT6DiN5S-_PhuO82oM?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2015,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1012,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -134,
    "LOC_Y": 285,
    "GAME_DATE": 20150114,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/14/0021400582/28/0950c8a3-e08c-109f-a218-0cb225c6f3c3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391592561324378881",
    "name": "The 2974 Collection #1012",
    "imageUrl": "https://arweave.net/4XSSURE_u-BzUzQiozql-JkfJDY18IzyGQGlolqvZHY?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2015,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1013,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -120,
    "LOC_Y": 250,
    "GAME_DATE": 20150114,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/14/0021400582/185/a8235207-3dec-d1fb-65a0-869b47214fef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/545867030990128530",
    "name": "The 2974 Collection #1013",
    "imageUrl": "https://arweave.net/8A0eoeSy1tqgfepP7ePVW5dXM8Xybi3o9RG3MyZZszY?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2015,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1014,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 133,
    "LOC_Y": 247,
    "GAME_DATE": 20150114,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/14/0021400582/192/b73470d4-73b8-12ab-5091-6ee113cd66a9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441600762788814319",
    "name": "The 2974 Collection #1014",
    "imageUrl": "https://arweave.net/AR_4Nw_96L-hT99eWzIxn9-V_PoNIfh9LmmK8fwaA_E?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2015,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1015,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -101,
    "LOC_Y": 238,
    "GAME_DATE": 20150114,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/14/0021400582/312/eb866762-517f-3c19-8775-8237ca584e27_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296696231002204105",
    "name": "The 2974 Collection #1015",
    "imageUrl": "https://arweave.net/RwbaNGHuNKXe6v8on4KBh_aMHRYy1oGXiL0sWkC4Kkw?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2015,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1016,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -240,
    "LOC_Y": -5,
    "GAME_DATE": 20150114,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/14/0021400582/322/db6233d5-864c-9317-7b5b-118e68bfd65c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381178685458677135",
    "name": "The 2974 Collection #1016",
    "imageUrl": "https://arweave.net/-3vI7TzZ3eJcU5xVp2L1sQ1DI40lpOkBd6FIgHfb0yM?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2015,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1017,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -239,
    "LOC_Y": 15,
    "GAME_DATE": 20150114,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/14/0021400582/491/5eaf579d-82c4-44e8-dd81-30cad5f1aa77_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415734983073374645",
    "name": "The 2974 Collection #1017",
    "imageUrl": "https://arweave.net/bBU8ZmS9ad3w0qMKrgDplpuxI9e3o4e6tTu9SfuFs20?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2015,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1018,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -166,
    "LOC_Y": 178,
    "GAME_DATE": 20150116,
    "Season": "2014-2015",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/16/0021400593/296/b292c60a-0257-436d-5293-6a356e99486f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524013560241203454",
    "name": "The 2974 Collection #1018",
    "imageUrl": "https://arweave.net/YU5bxFIrWKf4INlZGGCqsIv1JlT9bsqy2xuO6MEIm2o?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2015,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1019,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 37,
    "GAME_DATE": 20150116,
    "Season": "2014-2015",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/16/0021400593/322/7cae48e2-83a7-6450-21b9-c81830159830_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312880153616066073",
    "name": "The 2974 Collection #1019",
    "imageUrl": "https://arweave.net/bsw1sY-rOztM8f_X1m7KSiqbQlka7fizBRy6D4Yxtc4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2015,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1020,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -133,
    "LOC_Y": 228,
    "GAME_DATE": 20150117,
    "Season": "2014-2015",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/17/0021400603/306/2b5a71f5-b1b3-bf7f-5876-573339fc1066_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495519249022852692",
    "name": "The 2974 Collection #1020",
    "imageUrl": "https://arweave.net/eKgjwVpQu3y-8dhiBNhSMO54kmE08Jv_mn782FJzD7Q?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2015,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1021,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -166,
    "LOC_Y": 179,
    "GAME_DATE": 20150117,
    "Season": "2014-2015",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/17/0021400603/570/e5c2bd07-ba0e-4313-6776-c46f6d3f3097_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411869503381420676",
    "name": "The 2974 Collection #1021",
    "imageUrl": "https://arweave.net/yzX9eAfrpyqGZaKLTrgSg42XeqpBPaLFpQAGgY2W7Hc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2015,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1022,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -209,
    "LOC_Y": 189,
    "GAME_DATE": 20150119,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/19/0021400615/28/93e733a3-473d-99a5-a640-ac630ff16702_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/332985097084466310",
    "name": "The 2974 Collection #1022",
    "imageUrl": "https://arweave.net/iyWg2Z3-mUuSHFMGylrvZeSmi3ca9HMjXttT55_ripQ?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 1,
    "Day": 19,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1023,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 176,
    "LOC_Y": 216,
    "GAME_DATE": 20150119,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/19/0021400615/249/eae2d7e5-9f84-3a9b-8779-1ddd2a127aee_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/442782884509777487",
    "name": "The 2974 Collection #1023",
    "imageUrl": "https://arweave.net/ilVydvsLoPtPbeumXR3DTSqF8x85iW1rwrhJPayc7f4?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 1,
    "Day": 19,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1024,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 34,
    "GAME_DATE": 20150121,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/21/0021400636/40/d9a81b74-7721-985b-4c2b-498a89f9b13e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331258185912570166",
    "name": "The 2974 Collection #1024",
    "imageUrl": "https://arweave.net/ritDR3xmyZ-TJfPra04Si1xsqq8hJEVB6r9m42mmoGI?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2015,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1025,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 13,
    "LOC_Y": 260,
    "GAME_DATE": 20150121,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/21/0021400636/413/d65ee2fd-e942-f948-1e19-13660c7f4fda_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417962593279451284",
    "name": "The 2974 Collection #1025",
    "imageUrl": "https://arweave.net/p60jwAfeqhRD4WCW87RNw7_ggg5N0NB8VhhFonFZq3s?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2015,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1026,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 113,
    "LOC_Y": 247,
    "GAME_DATE": 20150121,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/21/0021400636/433/9a68bb28-885c-c700-e293-e4ce6ba123e7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354549949309100822",
    "name": "The 2974 Collection #1026",
    "imageUrl": "https://arweave.net/B5T5Iosnk9Osv_9x4-PBzqm02-r7VRzo1YCqEo_vkp0?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2015,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1027,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -114,
    "LOC_Y": 247,
    "GAME_DATE": 20150123,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/23/0021400651/110/60fd634f-d498-f8b7-c7d2-a8de541a4dd8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508577825935619344",
    "name": "The 2974 Collection #1027",
    "imageUrl": "https://arweave.net/q-iU-J6oouvXXeANBC-NGW_YbsXXJyMIXMxdz6x8PQI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1028,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -29,
    "LOC_Y": 263,
    "GAME_DATE": 20150123,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/23/0021400651/230/1eecdba7-a61c-9639-a949-91c21bea152f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395691724964769469",
    "name": "The 2974 Collection #1028",
    "imageUrl": "https://arweave.net/eLjloqpYc3UDsnERwBIHBPFfJ_Dpxyw_4L-JrDe0Xoo?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1029,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -52,
    "LOC_Y": 263,
    "GAME_DATE": 20150125,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/25/0021400665/301/a657b0ff-a80b-904d-6dad-24452d8216e2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353093896357518263",
    "name": "The 2974 Collection #1029",
    "imageUrl": "https://arweave.net/RiUoUB_Y2nSFF_U_SFSPF2gvPF0zNJXxfwVL50rVGJI?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1030,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -147,
    "LOC_Y": 236,
    "GAME_DATE": 20150127,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/27/0021400679/13/49525c2e-c729-b4ec-7cc8-0cb41c7309d0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511455314218028931",
    "name": "The 2974 Collection #1030",
    "imageUrl": "https://arweave.net/g7-C0Djfq9b_M3oA-u9046Skkssm3kPBbztBXCo6vEs?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2015,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1031,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 75,
    "LOC_Y": 257,
    "GAME_DATE": 20150127,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/27/0021400679/102/fe105a48-5658-05a3-9552-114b2ca3f0bd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378409540828702527",
    "name": "The 2974 Collection #1031",
    "imageUrl": "https://arweave.net/zzeNTDgFkHmsKVqtcR0pDv2qITqzDByhagimxv07XDA?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2015,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1032,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 209,
    "LOC_Y": 138,
    "GAME_DATE": 20150130,
    "Season": "2014-2015",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/30/0021400703/229/fc482c9f-173e-156a-6d6b-2ad793466776_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309454971230375753",
    "name": "The 2974 Collection #1032",
    "imageUrl": "https://arweave.net/wltnmcwYdIMEbq3v2Yfw6IGEJmJlAq1LEiGfYeWcXP4?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1033,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 114,
    "LOC_Y": 235,
    "GAME_DATE": 20150130,
    "Season": "2014-2015",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/30/0021400703/232/ee4911a1-d7a2-cc37-901f-8506d0e8e778_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/389097345801663449",
    "name": "The 2974 Collection #1033",
    "imageUrl": "https://arweave.net/0TFAXfAg3_zUEj9u1gDtO1nGf_dT6m49IYkr8Rdi8jY?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1034,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 89,
    "LOC_Y": 238,
    "GAME_DATE": 20150130,
    "Season": "2014-2015",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523047444164355659",
    "name": "The 2974 Collection #1034",
    "imageUrl": "https://arweave.net/jf9qnjmySEvU3s0OSCKUVu66J9fqaRK8vCONw9C2uoM?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1035,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 61,
    "LOC_Y": 238,
    "GAME_DATE": 20150130,
    "Season": "2014-2015",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/30/0021400703/333/1c9088fc-96f0-4dde-4a92-f8796f90dfd4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446181645050893539",
    "name": "The 2974 Collection #1035",
    "imageUrl": "https://arweave.net/XXPhmytP6zFvDJOPDpOHHWvhpzqipWFIhrZXhEz0dL8?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1036,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 132,
    "LOC_Y": 201,
    "GAME_DATE": 20150130,
    "Season": "2014-2015",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/30/0021400703/386/a74ca16d-9cd9-af9f-4700-c4f007865810_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539686315613837705",
    "name": "The 2974 Collection #1036",
    "imageUrl": "https://arweave.net/fFDRZfb4xPN0c3R4iuLOVveH4nuQcGpgoQGUhFlVWB0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1037,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 200,
    "LOC_Y": 157,
    "GAME_DATE": 20150131,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/31/0021400715/120/141dec0c-c9ed-c53b-dd5c-9e8c1e9c1b35_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334821982328109035",
    "name": "The 2974 Collection #1037",
    "imageUrl": "https://arweave.net/-8U0IUhG46VmJTti2Rj7duJeLEu3wMqBhh6hQd2QIPE?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1038,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -68,
    "LOC_Y": 255,
    "GAME_DATE": 20150131,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/31/0021400715/194/49718721-cf38-599c-0e0d-394bf61a3a04_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411291058542207006",
    "name": "The 2974 Collection #1038",
    "imageUrl": "https://arweave.net/ZkgwbbxFbEN2kCEUnTL7nMvK1vMRhIv7IJi0jn9pydc?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1039,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -224,
    "LOC_Y": 52,
    "GAME_DATE": 20150131,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/31/0021400715/197/cd8b5de5-4624-919c-6f11-ee1ceb1e69ef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/432635341798048420",
    "name": "The 2974 Collection #1039",
    "imageUrl": "https://arweave.net/CfuG8d4qsd45r2zQy-PBFm77gJqom6JO54o74gPRNm0?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1040,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -196,
    "LOC_Y": 156,
    "GAME_DATE": 20150131,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/01/31/0021400715/213/e1486d60-d18b-0f25-4297-bfe6c0447abc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319198053401875128",
    "name": "The 2974 Collection #1040",
    "imageUrl": "https://arweave.net/j0gxe5NOoyeAl4gxkWqL0OTfUzfoAAc_AE4MWSY1rbM?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1041,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 23,
    "LOC_Y": 255,
    "GAME_DATE": 20150203,
    "Season": "2014-2015",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/03/0021400730/66/428ccf14-81bf-b8ea-90d2-ee2c84740a8b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458169316045332847",
    "name": "The 2974 Collection #1041",
    "imageUrl": "https://arweave.net/yKC9OPDHgeOs0v4dkmV3i8AcxygUDhG3lhfkVpCDvCg?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1042,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 13,
    "LOC_Y": 280,
    "GAME_DATE": 20150203,
    "Season": "2014-2015",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/03/0021400730/382/9ee357bc-5d88-cb6a-285f-c040e5de27eb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428910219914435653",
    "name": "The 2974 Collection #1042",
    "imageUrl": "https://arweave.net/hk8ygcsIdfOxFMGgNvqo57onOzGDjCSCOWTUgkt8kBg?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1043,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -116,
    "LOC_Y": 236,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/71/34e6e5e4-cfad-ffa8-7498-102a48db01fe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407341677537569878",
    "name": "The 2974 Collection #1043",
    "imageUrl": "https://arweave.net/ChaOs18N_hau_4NyhoumC7t7u45wpbCQieLa2-1XsdU?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1044,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -198,
    "LOC_Y": 164,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/82/2add7c42-9f2c-d676-2fd7-0894b3eb8d0f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397949993527275845",
    "name": "The 2974 Collection #1044",
    "imageUrl": "https://arweave.net/oHT6ngqrtmPeCMd9QuGN288pfZPSzsuuppS40_Z1ZZg?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1045,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 151,
    "LOC_Y": 209,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/86/db189cc8-9b97-0c77-5f45-45dd9c8c2b43_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/394193402800496340",
    "name": "The 2974 Collection #1045",
    "imageUrl": "https://arweave.net/pPfnrDP873_m8GuID9r606l_WAz1ijc1eDMyKjU8v54?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1046,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 97,
    "LOC_Y": 246,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/249/ef1f8f1b-6160-f2ec-46cd-081bb169f043_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491419609124763107",
    "name": "The 2974 Collection #1046",
    "imageUrl": "https://arweave.net/A86VnKnySUxQuECD8BwCQHGS6S0tcv_vj8y31_h9Ba0?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1047,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -81,
    "LOC_Y": 249,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/267/c383096e-686b-0abf-1f50-92769953dc65_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290216452345702755",
    "name": "The 2974 Collection #1047",
    "imageUrl": "https://arweave.net/RE1mS1AdFdI8n1-HH-qpSCIYDSPv_XZ8OGO6WniAa9w?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1048,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -92,
    "LOC_Y": 236,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/273/808f41b4-215a-d88f-42e8-5434e9401f24_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523335901104350868",
    "name": "The 2974 Collection #1048",
    "imageUrl": "https://arweave.net/fgrKkw2y28XTH6-AwhWc5wGoM-I0CqRwojK5dS2cA_s?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1049,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 146,
    "LOC_Y": 227,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/297/9fce9993-de60-6183-f2a7-17671c0ad981_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/555071414323047954",
    "name": "The 2974 Collection #1049",
    "imageUrl": "https://arweave.net/iPAe2bcFWMr-b7nqLvzc1EIAXUMX8341n7ICB3k9aeQ?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1050,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -32,
    "LOC_Y": 261,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/326/89daa401-f16c-28a6-4dc1-804eb9897feb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384102035804943472",
    "name": "The 2974 Collection #1050",
    "imageUrl": "https://arweave.net/OemlUrUqxPxTQNzW-Sk3AQPTSiniYwdbpAzEBqhfutI?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1051,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 124,
    "LOC_Y": 252,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/383/961f9478-fae4-6aaa-143c-13e6111a2604_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/454035891063817066",
    "name": "The 2974 Collection #1051",
    "imageUrl": "https://arweave.net/knpCJqV7sbi6h5YEtnwkxLfLnZXsRolCe13yWPf4BoM?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1052,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -71,
    "LOC_Y": 269,
    "GAME_DATE": 20150204,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/04/0021400741/541/928e03b6-79ec-6ae8-7de0-ccb9e6fd7e69_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464493543470519849",
    "name": "The 2974 Collection #1052",
    "imageUrl": "https://arweave.net/9hMyqyXmyXPvXT0dWnbS95rR71vxNvCBYBTsOl93qd8?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1053,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 211,
    "LOC_Y": 172,
    "GAME_DATE": 20150206,
    "Season": "2014-2015",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/06/0021400749/69/e2119406-8f70-c88f-589d-f98ecf2ec66d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/394219030749321824",
    "name": "The 2974 Collection #1053",
    "imageUrl": "https://arweave.net/PZ_o4ddFvgQ7S1Ozl38ZzucIOiVUmAqR_MvsizL7d2k?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2015,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1054,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -19,
    "LOC_Y": 246,
    "GAME_DATE": 20150206,
    "Season": "2014-2015",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/06/0021400749/338/87c5fced-7c31-e06f-e00d-892f2db61abc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354368960947039166",
    "name": "The 2974 Collection #1054",
    "imageUrl": "https://arweave.net/yiDamK8u-T3IAksKRxFSfA7KnfkiK7hn3Ivta3DvV8o?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2015,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1055,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Bank shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 20,
    "LOC_Y": 266,
    "GAME_DATE": 20150206,
    "Season": "2014-2015",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/06/0021400749/370/f21f2a6f-26bc-8539-4468-c0ad04dbf226_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/315127313952263895",
    "name": "The 2974 Collection #1055",
    "imageUrl": "https://arweave.net/PISOQYg9vho9PulXRsHfQQLL4e8IoDQfglEGnEe4ffo?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2015,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1056,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 121,
    "LOC_Y": 236,
    "GAME_DATE": 20150206,
    "Season": "2014-2015",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/06/0021400749/373/2ebe0755-08d6-d72a-cbc9-871522317688_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308215216934790881",
    "name": "The 2974 Collection #1056",
    "imageUrl": "https://arweave.net/ggraYB0ah0n7eQ6y36yTGiU_j8cb1bitQ5ki74OP1_4?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2015,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1057,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -127,
    "LOC_Y": 236,
    "GAME_DATE": 20150207,
    "Season": "2014-2015",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/07/0021400760/22/782e4452-4ec5-1a83-7b26-f5ee33794843_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338924118608151593",
    "name": "The 2974 Collection #1057",
    "imageUrl": "https://arweave.net/SfMyUoVxvBLilJ5W0yNIdyv9beWI-qFUR8y-ia8zHlA?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 2,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1058,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -52,
    "LOC_Y": 255,
    "GAME_DATE": 20150207,
    "Season": "2014-2015",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/07/0021400760/266/c1437c5a-39c0-b96e-4935-acb0516418c2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544759277058084497",
    "name": "The 2974 Collection #1058",
    "imageUrl": "https://arweave.net/NGneX0Zm9BMJ4cRnBVaaz88dFlMkIwehDL0hkdMZp6M?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 2,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1059,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 17,
    "LOC_Y": 260,
    "GAME_DATE": 20150207,
    "Season": "2014-2015",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/07/0021400760/303/9c39dccb-ab6b-ee3e-a859-29a5b7628685_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/451706582106384187",
    "name": "The 2974 Collection #1059",
    "imageUrl": "https://arweave.net/xEDdPGyVBbkuiGHqwtFgCovj7idvF6zbi_0vfPRIWpU?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 2,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1060,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -199,
    "LOC_Y": 145,
    "GAME_DATE": 20150207,
    "Season": "2014-2015",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/07/0021400760/497/9917a223-e17f-8f30-1d7a-50ce06dd00e3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334604777839918079",
    "name": "The 2974 Collection #1060",
    "imageUrl": "https://arweave.net/i9C7svIfuxazXpZtqzQCgePNxEF-nnvy-bGKzdfD96c?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 2,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1061,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -100,
    "LOC_Y": 233,
    "GAME_DATE": 20150207,
    "Season": "2014-2015",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/07/0021400760/504/2ac41b39-6e6d-ec2b-d335-79f2b5cd585f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379559704857853922",
    "name": "The 2974 Collection #1061",
    "imageUrl": "https://arweave.net/dLvhk_RmT69JjWLC2cMwl93KsM6Rh5sVxwvF3r8OQ5Q?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 2,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1062,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 15,
    "LOC_Y": 249,
    "GAME_DATE": 20150209,
    "Season": "2014-2015",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/09/0021400775/239/d9f5408d-865f-b8c4-8d96-1158d9fe2450_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/553564626774570492",
    "name": "The 2974 Collection #1062",
    "imageUrl": "https://arweave.net/HUkIhw4vpiyEetubuhESS3-KkVDfMqxRWSA7miNQxKo?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2015,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1063,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 1,
    "GAME_DATE": 20150209,
    "Season": "2014-2015",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/09/0021400775/292/8166fbbd-6417-ea5c-3b81-8fa66f13f4cb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456270548190525326",
    "name": "The 2974 Collection #1063",
    "imageUrl": "https://arweave.net/RDfjfCSLALMag8dMT6smBPBqbPLYtKB-H0Ws2eK-fW0?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2015,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1064,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -4,
    "LOC_Y": 250,
    "GAME_DATE": 20150209,
    "Season": "2014-2015",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/09/0021400775/330/9cf1d2fc-184f-8587-e47e-c76546375417_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324774259857377182",
    "name": "The 2974 Collection #1064",
    "imageUrl": "https://arweave.net/GFn_MPZS_ruItwXfybk3r8O0WpKS8R_-mvUTM-btPCA?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2015,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1065,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 26,
    "GAME_DATE": 20150211,
    "Season": "2014-2015",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/11/0021400793/221/cc0ce47a-9778-99a0-2667-2353f8a4298d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/554317613888076119",
    "name": "The 2974 Collection #1065",
    "imageUrl": "https://arweave.net/o1-DZSBCtmrPUg9-dzrxYdkIUWoz4LlmcRd4cZszvbY?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1066,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 15,
    "LOC_Y": 239,
    "GAME_DATE": 20150211,
    "Season": "2014-2015",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/11/0021400793/321/d8c08f41-e1b4-2d59-0921-e47ae0839d68_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556087420468748640",
    "name": "The 2974 Collection #1066",
    "imageUrl": "https://arweave.net/QVkGwyJ-WKgwikBin8UciEwbU_GFL3-nLbKHPVDMQcA?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1067,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -16,
    "LOC_Y": 257,
    "GAME_DATE": 20150220,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/20/0021400814/106/927e04ce-4261-9f7d-732f-99c7ffd4269a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/532440136584206685",
    "name": "The 2974 Collection #1067",
    "imageUrl": "https://arweave.net/4fEftmxdUWCfHRm0_l_RWnTGDuZvW9IkEZcm9it7HkY?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2015,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1068,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -193,
    "LOC_Y": 183,
    "GAME_DATE": 20150220,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/20/0021400814/177/535f7a30-dd43-fee5-3b88-494684884ef0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415540638568786478",
    "name": "The 2974 Collection #1068",
    "imageUrl": "https://arweave.net/ez6DoOSekF6MlqiFwQHJmIni3mQjp109Ve6RNvMmCeg?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2015,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1069,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 163,
    "LOC_Y": 224,
    "GAME_DATE": 20150220,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/20/0021400814/201/0c630ffb-23f8-c198-8d3e-1fd3a500342d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522445788876237352",
    "name": "The 2974 Collection #1069",
    "imageUrl": "https://arweave.net/SDtycucT9g8G3VHqzOL2JtrAA3zdhQTxFIZ-eP0-aiU?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2015,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1070,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 236,
    "LOC_Y": 72,
    "GAME_DATE": 20150220,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/20/0021400814/366/0ebbab82-1854-a704-1738-c23a22795d70_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/469184372249100482",
    "name": "The 2974 Collection #1070",
    "imageUrl": "https://arweave.net/VlPNAHuYsBfv2m5npHIcHKUPeW0M4UbXxg7nOWjuSew?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2015,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1071,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -71,
    "LOC_Y": 263,
    "GAME_DATE": 20150224,
    "Season": "2014-2015",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/24/0021400838/32/6832a53c-a682-f23d-05fc-2108effcd35a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420765534143407402",
    "name": "The 2974 Collection #1071",
    "imageUrl": "https://arweave.net/cUN0FDz1m44Soe_PXHozRhz0JpRVyN8_hdvK444eGHs?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1072,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 32,
    "LOC_Y": 261,
    "GAME_DATE": 20150224,
    "Season": "2014-2015",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/24/0021400838/99/ad37a3ba-64ec-3eae-13cf-104bea968edd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/509541652878025660",
    "name": "The 2974 Collection #1072",
    "imageUrl": "https://arweave.net/H_cCC5sGKhYlT7-kPz1uMwHWuUMoQApYZ-RBNevEY54?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1073,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 54,
    "LOC_Y": 268,
    "GAME_DATE": 20150224,
    "Season": "2014-2015",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/24/0021400838/113/dedbf902-906b-12b4-6e88-df107b1cf334_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400469686998491213",
    "name": "The 2974 Collection #1073",
    "imageUrl": "https://arweave.net/iAg_2lWI8Xg6Ms4C7PaWmnRVVeuc2FCKmRkdWRAx4mM?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1074,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -231,
    "LOC_Y": 86,
    "GAME_DATE": 20150224,
    "Season": "2014-2015",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/24/0021400838/259/dcfa91e4-2e22-5b90-57a6-2a10a9da5030_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356302094601345812",
    "name": "The 2974 Collection #1074",
    "imageUrl": "https://arweave.net/itSsXbwzclci2q2QC36gl7MRHQqM0HXsTWUwLUi9A_U?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1075,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -15,
    "LOC_Y": 260,
    "GAME_DATE": 20150224,
    "Season": "2014-2015",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/24/0021400838/365/7db13173-507e-03c6-98c4-1646a52aa0b8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336697201896314180",
    "name": "The 2974 Collection #1075",
    "imageUrl": "https://arweave.net/C81wRTkOcG8dGcWqjSNq1Af3w3xEkf9TYTVN7ouIcHU?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1076,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 193,
    "LOC_Y": 156,
    "GAME_DATE": 20150226,
    "Season": "2014-2015",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/26/0021400854/22/b4cc5a0e-3320-7e5a-9a3a-5fa577706aa2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/298621904560560713",
    "name": "The 2974 Collection #1076",
    "imageUrl": "https://arweave.net/cz4PjkOoHgFENBH-kK8rjs1wXzugiqOd80koD4ceWEc?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2015,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1077,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 0,
    "GAME_DATE": 20150226,
    "Season": "2014-2015",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/26/0021400854/57/efc00da6-8e8a-2b09-65e2-7b4f40848db2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/467597231380216499",
    "name": "The 2974 Collection #1077",
    "imageUrl": "https://arweave.net/D9RaJ1EIz1i9XA6-wnXkiMoLP7ZyiTTrYhqu7V5XtD8?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2015,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1078,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 10,
    "LOC_Y": 252,
    "GAME_DATE": 20150226,
    "Season": "2014-2015",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/26/0021400854/76/668994b7-c6f7-80f8-6853-4a4497d4355d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/472975404526913297",
    "name": "The 2974 Collection #1078",
    "imageUrl": "https://arweave.net/4g005NfOpIKD59uNB13BJqGO9Mp856BUGRZ1bmRFDGU?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2015,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1079,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 54,
    "LOC_Y": 247,
    "GAME_DATE": 20150227,
    "Season": "2014-2015",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/27/0021400861/140/7bb46f03-00b2-7cb3-51b0-404cabeea206_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/396021876237714040",
    "name": "The 2974 Collection #1079",
    "imageUrl": "https://arweave.net/46rxhdHthnOxPDvn4cWYb4jvqCi9d4q3zquxBC1y2j4?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1080,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 105,
    "LOC_Y": 233,
    "GAME_DATE": 20150227,
    "Season": "2014-2015",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/27/0021400861/366/aa168ad8-81fb-27c9-570c-2fa89929c3ae_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/298896949708988309",
    "name": "The 2974 Collection #1080",
    "imageUrl": "https://arweave.net/10tSaKDf3741iBCA3KsEjqC1vQl5uMBiktJvL05F3BQ?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1081,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -202,
    "LOC_Y": 167,
    "GAME_DATE": 20150227,
    "Season": "2014-2015",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/02/27/0021400861/376/2083c1fa-a4b3-4c15-c865-07b1b280a8d8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/570561641624451375",
    "name": "The 2974 Collection #1081",
    "imageUrl": "https://arweave.net/Dm8ZOBylt7_0adApnthVk894tXwpH4Nh7PAQ0Yp3XH0?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1082,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 7,
    "LOC_Y": 258,
    "GAME_DATE": 20150301,
    "Season": "2014-2015",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/01/0021400880/38/6ae4ba0e-9e16-0a8a-2bf7-f40a33fcbc29_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/426578154586867196",
    "name": "The 2974 Collection #1082",
    "imageUrl": "https://arweave.net/4bcWB0TZeTAcgF551I9gNxXc7A0Mz8VQV6-CLcZj6DQ?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1083,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 86,
    "LOC_Y": 236,
    "GAME_DATE": 20150301,
    "Season": "2014-2015",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/01/0021400880/104/22b48f88-a44d-5806-6fec-84ed4add8110_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349744630145039492",
    "name": "The 2974 Collection #1083",
    "imageUrl": "https://arweave.net/lhyN46ZEkO1OD9W7EG0WCphSNTe5ed6h-31R_tx3IdI?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1084,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -125,
    "LOC_Y": 228,
    "GAME_DATE": 20150301,
    "Season": "2014-2015",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/01/0021400880/258/e63a1278-1882-ffa5-6024-bc0dc64a5850_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/470291712623401279",
    "name": "The 2974 Collection #1084",
    "imageUrl": "https://arweave.net/_rBQZyL6CSczYZmQ_Sn-NXHKmbV5071inaGHRrp-rCQ?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1085,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -23,
    "LOC_Y": 252,
    "GAME_DATE": 20150301,
    "Season": "2014-2015",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/01/0021400880/304/854338f2-eba3-d251-0c4c-fbac3eb187d5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382355388148925926",
    "name": "The 2974 Collection #1085",
    "imageUrl": "https://arweave.net/z3rdhcrRJlmjr_L0kSRDFz6o4NgDzipUYtMkLyBKphQ?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1086,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 135,
    "LOC_Y": 220,
    "GAME_DATE": 20150301,
    "Season": "2014-2015",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/01/0021400880/431/ba815566-f223-9691-d5ae-8febb879df79_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565575809316945343",
    "name": "The 2974 Collection #1086",
    "imageUrl": "https://arweave.net/5VNabt3KDd_IGd4vHv4L8sZ5bWEYkNu4DiB0IduTTJ4?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 3,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1087,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 226,
    "LOC_Y": -3,
    "GAME_DATE": 20150302,
    "Season": "2014-2015",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/02/0021400886/50/99068a44-a0c5-b3d3-972c-82dff86471e3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508641332944902372",
    "name": "The 2974 Collection #1087",
    "imageUrl": "https://arweave.net/kERrbl64OToV6a5XOicURbEl8sjDmLsOcPdwo_ptY0c?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1088,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 116,
    "LOC_Y": 224,
    "GAME_DATE": 20150302,
    "Season": "2014-2015",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/02/0021400886/365/44beeeda-c2f6-220b-2d90-e408a0c477b6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511176586925763700",
    "name": "The 2974 Collection #1088",
    "imageUrl": "https://arweave.net/KiirZyC7RGPsvClnrVWnVn12oOdk_ZerQzJCrlyKZyI?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1089,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 92,
    "LOC_Y": 228,
    "GAME_DATE": 20150302,
    "Season": "2014-2015",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/02/0021400886/399/a2ef2989-46cd-a9f1-29e8-eacd3c587916_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521499889570730116",
    "name": "The 2974 Collection #1089",
    "imageUrl": "https://arweave.net/nqkLzZUQZVDrKVBx-1tIxqlCA5_9dYT2_KmgF_6Fi3k?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1090,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 12,
    "GAME_DATE": 20150302,
    "Season": "2014-2015",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/02/0021400886/449/869e443d-11e7-66de-bd5c-ca980d6786a1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/549293731740444385",
    "name": "The 2974 Collection #1090",
    "imageUrl": "https://arweave.net/aIiFFKHypXEYxlR6rMv3jnF-Tu1w0rS1zTP-cBT1Wn8?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1091,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -11,
    "LOC_Y": 241,
    "GAME_DATE": 20150302,
    "Season": "2014-2015",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/02/0021400886/451/32d36b68-1365-6f3c-f732-c5de74c3c800_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/507212301928330096",
    "name": "The 2974 Collection #1091",
    "imageUrl": "https://arweave.net/Kaen0HG2W9W00NK-34EwccHv5mBlOIIOj9tW233rnBA?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1092,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -201,
    "LOC_Y": 131,
    "GAME_DATE": 20150302,
    "Season": "2014-2015",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/02/0021400886/458/77ce61a2-998b-3cf2-45ad-df54be193d7e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379342109858568396",
    "name": "The 2974 Collection #1092",
    "imageUrl": "https://arweave.net/QuGoqfeGFoxojyeiG71NR_isg6PGA8gb9D0JZ-Otv6o?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1093,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -212,
    "LOC_Y": 118,
    "GAME_DATE": 20150304,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/04/0021400907/53/1db31cd9-b647-5b40-5800-42f6d4fe1b45_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420519444267688893",
    "name": "The 2974 Collection #1093",
    "imageUrl": "https://arweave.net/irkO8ribdqy-OP_0dztl2BUWfAj1hXEaSbq_Mv7fLtY?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1094,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -82,
    "LOC_Y": 272,
    "GAME_DATE": 20150304,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/04/0021400907/58/3055713b-feca-26e5-3812-73e46fdf101a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/318458156458566789",
    "name": "The 2974 Collection #1094",
    "imageUrl": "https://arweave.net/18AZ3zAZrxHwdj3fd9Fca643VHCMnKHtxbMJuy_iiMM?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1095,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -183,
    "LOC_Y": 172,
    "GAME_DATE": 20150304,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/04/0021400907/419/cdfd5237-0488-90d2-e836-6b06bc08914c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/401434237787709370",
    "name": "The 2974 Collection #1095",
    "imageUrl": "https://arweave.net/s-WFJP5EKVnzaeweTCFsRY8bSLfiDZDg33oBh6SER7w?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1096,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -130,
    "LOC_Y": 228,
    "GAME_DATE": 20150304,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/04/0021400907/421/9a027a19-965a-6c87-0b8f-dce5386e46df_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/350896143917002149",
    "name": "The 2974 Collection #1096",
    "imageUrl": "https://arweave.net/V0Nf6YzsbRH5efvYOPChC2JTyMXBblzv_0RDqOan1AU?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1097,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -142,
    "LOC_Y": 228,
    "GAME_DATE": 20150304,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/04/0021400907/424/25d707d0-963c-5a5e-0c3d-1671c09077a6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423352451544479675",
    "name": "The 2974 Collection #1097",
    "imageUrl": "https://arweave.net/ckFgSR9Znj9JN4gXjIuYrMwx5PFuWQFFRfSKusnmcTE?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1098,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -177,
    "LOC_Y": 187,
    "GAME_DATE": 20150304,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/04/0021400907/491/2611630f-b47e-8228-1c80-44202b048f65_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326742740471016316",
    "name": "The 2974 Collection #1098",
    "imageUrl": "https://arweave.net/a6EmNv2KyEgjOLDYPLICoPK4qdtMZVn-_QgRFEKrsLc?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 4,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1099,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -127,
    "LOC_Y": 228,
    "GAME_DATE": 20150306,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/06/0021400922/16/ee77dae5-b84d-0ab2-95e5-68bfde23a838_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568783755239999839",
    "name": "The 2974 Collection #1099",
    "imageUrl": "https://arweave.net/bW8eS8x3nyVwNI2C69sofTp2ZuTgXRYeli9tHX0o2F4?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1100,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 36,
    "GAME_DATE": 20150306,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/06/0021400922/26/d89c79d3-daa1-5d3a-8958-d416d928b67e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353351244688545322",
    "name": "The 2974 Collection #1100",
    "imageUrl": "https://arweave.net/iCVVh3OCZoG3oEJ_1i5TfIWgwj_NqPUM-YADuFOQJAo?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1101,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 86,
    "LOC_Y": 244,
    "GAME_DATE": 20150306,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/06/0021400922/57/7cd3d4fd-833c-c255-6d9f-0347a115d3f3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550797440953602693",
    "name": "The 2974 Collection #1101",
    "imageUrl": "https://arweave.net/Q5bHkg2WeZqYZ5CNdU7Zb7ulL7vPVh-kXKpK9r7QVRE?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1102,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 209,
    "LOC_Y": 138,
    "GAME_DATE": 20150306,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/06/0021400922/203/d32bff63-64e4-0417-793b-d1816e2fa9e6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/477681797362677345",
    "name": "The 2974 Collection #1102",
    "imageUrl": "https://arweave.net/3QTPp7F4IMMaFJbVhWiAtaTuSAcdMjhpfm-153EkCdU?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1103,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 154,
    "LOC_Y": 227,
    "GAME_DATE": 20150306,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/06/0021400922/412/a3eebae0-dc8d-e01f-22dd-ce7b0bf0727d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522870703625773203",
    "name": "The 2974 Collection #1103",
    "imageUrl": "https://arweave.net/QMA7c1l2qxrj9AwBY-X6lXP-2RjEQwlJaL6USyzOJcI?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1104,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 196,
    "LOC_Y": 187,
    "GAME_DATE": 20150308,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/08/0021400932/253/8b543f18-d2c2-f868-7b37-4c68339e72cc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543630230351987443",
    "name": "The 2974 Collection #1104",
    "imageUrl": "https://arweave.net/dBT-XqnNlEP0YkOdwEI1ClmSHEZ7E0E75kxFv1Nb5I4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1105,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 255,
    "GAME_DATE": 20150308,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/08/0021400932/261/b2bffce9-c910-85f1-d3c3-c010f5d54bf4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474429151291760132",
    "name": "The 2974 Collection #1105",
    "imageUrl": "https://arweave.net/ntrL11edvDWQuvATaFdoPVuYVmc9fZ90TNhlnVsYfMw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1106,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 214,
    "LOC_Y": 137,
    "GAME_DATE": 20150309,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/09/0021400944/58/bcbc2d4d-39da-c707-528e-4e225eff57df_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508926559298608926",
    "name": "The 2974 Collection #1106",
    "imageUrl": "https://arweave.net/0T-tuaMF2tH6EbsNF_Wp9U0vWGiNECX0HBlV4k2C9TI?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1107,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -18,
    "LOC_Y": 247,
    "GAME_DATE": 20150309,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/09/0021400944/293/b37a3e50-a6c7-2b82-4a1b-6a2b184d781f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417449381225920443",
    "name": "The 2974 Collection #1107",
    "imageUrl": "https://arweave.net/cTv01XLHXer-q_HjjCIbAOFlZ7do3kE6Y7k5NJVS-Z4?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1108,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -218,
    "LOC_Y": 113,
    "GAME_DATE": 20150309,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/09/0021400944/356/278983da-9283-4db2-c827-3e94476188d8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465986316548700718",
    "name": "The 2974 Collection #1108",
    "imageUrl": "https://arweave.net/N2V4TlpvTn21Gd5ErFDcwrFxMMStZZM93NvwIDIeYDo?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1109,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 135,
    "LOC_Y": 213,
    "GAME_DATE": 20150309,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/09/0021400944/443/c23c1484-d982-8ef6-2576-36b1a5a39c12_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308290324064146568",
    "name": "The 2974 Collection #1109",
    "imageUrl": "https://arweave.net/fb4DWgIfAXgtkETe9ERaZ0LHWaOyC8STmMFcq0eGHKc?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1110,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 24,
    "LOC_Y": 246,
    "GAME_DATE": 20150309,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/09/0021400944/457/c04aa6f7-4b9c-6e2c-2918-42d2c39c3b82_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371817748578529271",
    "name": "The 2974 Collection #1110",
    "imageUrl": "https://arweave.net/UqjAvoUPIFTmPUJVCmtepbyvuVxF3dxmilRhVhlgYXI?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1111,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 34,
    "LOC_Y": 263,
    "GAME_DATE": 20150309,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/09/0021400944/487/dce026b4-72ad-b164-46db-b1fc35423334_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/545526760209507364",
    "name": "The 2974 Collection #1111",
    "imageUrl": "https://arweave.net/zGbozIQT4-ZPxcO8FnJRZjCt8Ylp5-vjChTjrCxoEio?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1112,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": -10,
    "GAME_DATE": 20150309,
    "Season": "2014-2015",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/09/0021400944/489/879daf58-92b9-c1ce-27b8-0afe1d580414_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/339773842595450808",
    "name": "The 2974 Collection #1112",
    "imageUrl": "https://arweave.net/HB66vBCi2WIFfxLUxBbWjJrXLYAd-oI7SXk_AZRJdls?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1113,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 133,
    "LOC_Y": 224,
    "GAME_DATE": 20150311,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/11/0021400960/38/c5146b21-b40c-745c-62fb-4b68cd172e39_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308044101308217861",
    "name": "The 2974 Collection #1113",
    "imageUrl": "https://arweave.net/6HZme1wsomD25BMCdzVmWLpiFh2V6RHgKHxj1oFhHJM?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2015,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1114,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -207,
    "LOC_Y": 149,
    "GAME_DATE": 20150314,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/14/0021400981/29/814c65dd-abb4-c479-96f5-503a3b71ec45_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295509762831591228",
    "name": "The 2974 Collection #1114",
    "imageUrl": "https://arweave.net/XWMiCSEh6cJadoIFV34735GZsEyvH65hjWvT61Jt1t0?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1115,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -193,
    "LOC_Y": 148,
    "GAME_DATE": 20150314,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/14/0021400981/31/cd6a4881-d065-9d92-8175-46a77ec44081_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489563344467595343",
    "name": "The 2974 Collection #1115",
    "imageUrl": "https://arweave.net/C-YZoTEE3E0CtRgWPIBdpKpZI17uCxY94tX_2lVUOUM?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1116,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 122,
    "LOC_Y": 233,
    "GAME_DATE": 20150314,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/14/0021400981/224/45ae95ca-81d1-0d63-01a3-4a7ea79b8a7d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464496977809356557",
    "name": "The 2974 Collection #1116",
    "imageUrl": "https://arweave.net/95_nqdPCXrMBviSzBV4azwn0m0_II92Berlp9_Lokyw?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1117,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 6,
    "GAME_DATE": 20150314,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/14/0021400981/226/b061dc45-75ba-21d9-b178-6d511afb1e79_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491275639132374762",
    "name": "The 2974 Collection #1117",
    "imageUrl": "https://arweave.net/Kwv2M5XyNsfC_wjsZlnxFUL0yFUTnboQwSf-aQa73tg?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1118,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -190,
    "LOC_Y": 200,
    "GAME_DATE": 20150314,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/14/0021400981/239/d33ffb4f-2da3-6263-a608-ecc8f11bba78_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388733484373034403",
    "name": "The 2974 Collection #1118",
    "imageUrl": "https://arweave.net/hyC6zKXWrFqINoI37Hn8gJcRl4Az0XSbhV1eJiR13O0?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1119,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 113,
    "LOC_Y": 224,
    "GAME_DATE": 20150314,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/14/0021400981/316/24ee5be4-9237-4251-44b7-40847072d107_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/380228281249803767",
    "name": "The 2974 Collection #1119",
    "imageUrl": "https://arweave.net/Rbzew3nfQM0jnLMQWt3throZUjH7mcbq2HTQg--ynTQ?ext=png",
    "Opposing Team City": "New York",
    "Year": 2015,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1120,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 149,
    "LOC_Y": 211,
    "GAME_DATE": 20150316,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/16/0021400999/335/1365a1a7-dfd6-ff6f-d2d0-a4ec2495e196_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482950784074959436",
    "name": "The 2974 Collection #1120",
    "imageUrl": "https://arweave.net/x5eqLntZkA0lxvUZ3cWldiMkwhQqXBnKyNCbkXivRUU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1121,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -149,
    "LOC_Y": 222,
    "GAME_DATE": 20150316,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/16/0021400999/338/8885375f-54e7-e7da-160e-be3df355239d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/342680197898367867",
    "name": "The 2974 Collection #1121",
    "imageUrl": "https://arweave.net/aD95yVWX1ATL8eFRBYzdmYTUlD2y3BnDi9_NCvZyukM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1122,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 197,
    "LOC_Y": 144,
    "GAME_DATE": 20150318,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/18/0021401014/39/71b0e486-10ae-6f78-44b0-baaa08012d5f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536790655141121499",
    "name": "The 2974 Collection #1122",
    "imageUrl": "https://arweave.net/CRbJOKTUOvyJhsxIw4rhyKBEY5lMqD3tEJAifymvWUE?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2015,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1123,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -100,
    "LOC_Y": 244,
    "GAME_DATE": 20150318,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/18/0021401014/206/bd308b8a-fa48-c75b-ce02-a4c9ea314be4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406636994862696955",
    "name": "The 2974 Collection #1123",
    "imageUrl": "https://arweave.net/WBzySA1MfunrR3OMbGFJpx3Kd-muKMELtKZP9Vcv3vA?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2015,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1124,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 97,
    "LOC_Y": 261,
    "GAME_DATE": 20150320,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/20/0021401030/350/775c9746-3610-b315-b4de-ace3508afc28_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/337591775773439937",
    "name": "The 2974 Collection #1124",
    "imageUrl": "https://arweave.net/ooRf4OMuQAlzLGuaVexArGs4iaCq9EtgoSaAV0dj0Fg?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1125,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -210,
    "LOC_Y": 190,
    "GAME_DATE": 20150320,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/20/0021401030/374/2922d868-e839-aa18-9ac3-1dce8376c37c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/557007504249332160",
    "name": "The 2974 Collection #1125",
    "imageUrl": "https://arweave.net/q2cnfWOYamc-K01Cu978APhXJETdJHOsGC4aKNz3LvM?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1126,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 36,
    "LOC_Y": 247,
    "GAME_DATE": 20150321,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/21/0021401036/168/73394917-2b21-ec72-861a-3f6a632f679e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456235240325946377",
    "name": "The 2974 Collection #1126",
    "imageUrl": "https://arweave.net/gS5nenYnwSnM6MjDqbAGDCwd24X8RN961YGXPsUyEyI?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1127,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -157,
    "LOC_Y": 203,
    "GAME_DATE": 20150321,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/21/0021401036/185/bb2b7086-f8bc-cd3a-60ef-0db597893376_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328332418098934241",
    "name": "The 2974 Collection #1127",
    "imageUrl": "https://arweave.net/5X43XQZFCrD41kca_Lwh4TngEHxbpgcrZcR2VqwxFwQ?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1128,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 9,
    "GAME_DATE": 20150321,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/21/0021401036/221/1767f9cc-fd97-28d1-8ef5-632ccf2f73b7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481430008538859263",
    "name": "The 2974 Collection #1128",
    "imageUrl": "https://arweave.net/Tp-tO1WnfthC5jDTlDKT0J8SNrN1TbZMeKINW9UZlo4?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1129,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 69,
    "LOC_Y": 257,
    "GAME_DATE": 20150323,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/23/0021401053/52/afeb2459-a8f9-0617-9907-49186e30fd3e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300725886464087311",
    "name": "The 2974 Collection #1129",
    "imageUrl": "https://arweave.net/PX1PPdimATxpndBYaFa0cod_MoNRE-okm2ilhNvcBCg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1130,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 108,
    "LOC_Y": 242,
    "GAME_DATE": 20150323,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/23/0021401053/57/2d62ba85-f9c9-bacb-5f2b-57461baab82b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397188116844168227",
    "name": "The 2974 Collection #1130",
    "imageUrl": "https://arweave.net/vHWRS2a0dNj4hrwEflfEvkwVsSxwEZJRplM_KObBMkY?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1131,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 254,
    "GAME_DATE": 20150323,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/23/0021401053/330/ce76fc80-d009-2227-5b9e-dad8296fb7ac_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493401402901562066",
    "name": "The 2974 Collection #1131",
    "imageUrl": "https://arweave.net/N-9uLL-DyltpKyu7IyKE37i_-Wo9qa7Fo0qwKxlxqNE?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1132,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 143,
    "LOC_Y": 231,
    "GAME_DATE": 20150323,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/23/0021401053/341/d8be04da-24ed-51a1-0f16-515d57afd192_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446438776770033781",
    "name": "The 2974 Collection #1132",
    "imageUrl": "https://arweave.net/Y7IsSIF66wYniWzsJTh9bYutReVq_eb2J8fRFGovqYg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1133,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 218,
    "LOC_Y": 190,
    "GAME_DATE": 20150323,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/23/0021401053/347/bb3872c3-0078-361c-e8d2-170c375dcc08_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495636663687143393",
    "name": "The 2974 Collection #1133",
    "imageUrl": "https://arweave.net/dJmjeodShas4xTOENiM6Yl4R4NkJCWbsIV0a0QYo5qo?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2015,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1134,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": -3,
    "GAME_DATE": 20150324,
    "Season": "2014-2015",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/24/0021401059/203/ee48ecc8-db9f-31fc-6c75-f7aec514ed4e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/408080071516654853",
    "name": "The 2974 Collection #1134",
    "imageUrl": "https://arweave.net/tN3k7vn4mZnPXqJ8kjebKZVP7iYEqAOWcZ7006u0O-c?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1135,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 2,
    "LOC_Y": 266,
    "GAME_DATE": 20150324,
    "Season": "2014-2015",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/24/0021401059/205/8a5500c6-c8de-88ed-ebb0-53e5c0c30cd3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/318952619357218458",
    "name": "The 2974 Collection #1135",
    "imageUrl": "https://arweave.net/84K4VMVBKjPxN-k-JFGx_Ne5IMuhPtJ4IRi5HWLksOQ?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1136,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": -17,
    "GAME_DATE": 20150324,
    "Season": "2014-2015",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/24/0021401059/287/d69a6092-4c7f-8aef-0f30-95a53912ea49_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/294216438221400993",
    "name": "The 2974 Collection #1136",
    "imageUrl": "https://arweave.net/kWB1KGQLdTcfz_z5CCHhPz9ABXbUsJ3ejGtfy88d40c?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1137,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -239,
    "LOC_Y": 42,
    "GAME_DATE": 20150324,
    "Season": "2014-2015",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/24/0021401059/321/fcb64dc6-c6f0-0095-4742-8b3f9f4e9460_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531762840028727152",
    "name": "The 2974 Collection #1137",
    "imageUrl": "https://arweave.net/eDbWXf0dmtf-hJzYmdCLE5flsEsuT3W7Ggj-XnEP-do?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1138,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 177,
    "LOC_Y": 173,
    "GAME_DATE": 20150324,
    "Season": "2014-2015",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/24/0021401059/353/ff4f021c-3c44-513c-e853-d02fafb48c91_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321902653980778990",
    "name": "The 2974 Collection #1138",
    "imageUrl": "https://arweave.net/96FMwvSXmJSZm7P3KYvv0I5DmFT32d6BGOtuZygkAKw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1139,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 14,
    "GAME_DATE": 20150327,
    "Season": "2014-2015",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/27/0021401082/90/8d079d63-4e99-1f87-3bab-56cfad4b6eef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/454845212293367551",
    "name": "The 2974 Collection #1139",
    "imageUrl": "https://arweave.net/U6t6v9GBcHMny7CdsfbAa75jHg9lS0ETNx0zdCXsf60?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1140,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 149,
    "LOC_Y": 214,
    "GAME_DATE": 20150327,
    "Season": "2014-2015",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/27/0021401082/97/622babda-1255-83e3-60e9-1a2c582bff8d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/554421858293716346",
    "name": "The 2974 Collection #1140",
    "imageUrl": "https://arweave.net/Oyw_Mcma3Eu9IdgP6x6hM1265Me0J2gs0iVsgWSMFt4?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1141,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": 20,
    "GAME_DATE": 20150327,
    "Season": "2014-2015",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/27/0021401082/219/f197bac8-5434-41ec-ecf7-a5f3714865bd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493951204556244632",
    "name": "The 2974 Collection #1141",
    "imageUrl": "https://arweave.net/bBJTROlxfWWG2Ec4dVg_Sj29BEQDN7ppOMpUYO1Pw7M?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1142,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -223,
    "LOC_Y": 34,
    "GAME_DATE": 20150327,
    "Season": "2014-2015",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/27/0021401082/265/9806ac75-5ec6-fe99-d52f-0d2bed8e056c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324836836773371512",
    "name": "The 2974 Collection #1142",
    "imageUrl": "https://arweave.net/YrcbjmHuQyiEo00sWejk4CRMLuwcID8XWQac55D6NRg?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1143,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 163,
    "LOC_Y": 228,
    "GAME_DATE": 20150327,
    "Season": "2014-2015",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/27/0021401082/294/cc8d8b93-f039-5990-9f82-bb0c69a91906_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364815967710941978",
    "name": "The 2974 Collection #1143",
    "imageUrl": "https://arweave.net/goAA6YLDg6cVu4P_XIxmVG38Mj5r-oFzMopqCuJ65sg?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1144,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -21,
    "LOC_Y": 260,
    "GAME_DATE": 20150327,
    "Season": "2014-2015",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/27/0021401082/318/13e517b5-87d1-038d-0212-630ea573357b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510852825004472051",
    "name": "The 2974 Collection #1144",
    "imageUrl": "https://arweave.net/glifG3M-OsE0i3nyBha5se_LGTTZmkHvwyHnVHRa_sQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1145,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": 33,
    "GAME_DATE": 20150327,
    "Season": "2014-2015",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/27/0021401082/322/11327c08-7e92-e170-ff2d-b3cd32ead31e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/372219320139588301",
    "name": "The 2974 Collection #1145",
    "imageUrl": "https://arweave.net/OhZKdp6hkRBDrReqQZxNlACE6yyvjvevePg9t4E9Kv8?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1146,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 103,
    "LOC_Y": 239,
    "GAME_DATE": 20150327,
    "Season": "2014-2015",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/27/0021401082/437/760a2989-7965-bf4e-042a-962a38c10580_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299109988122753487",
    "name": "The 2974 Collection #1146",
    "imageUrl": "https://arweave.net/j11-duQDLhSP1ufafR-2wgJ_T5819busfMt06ThHNs8?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1147,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 214,
    "LOC_Y": 137,
    "GAME_DATE": 20150328,
    "Season": "2014-2015",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/28/0021401089/33/4742cac5-cb9d-ff1f-d417-63aed346c8f8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438760588447983679",
    "name": "The 2974 Collection #1147",
    "imageUrl": "https://arweave.net/DkCCycKc2Ix56zwDsMaQ6L4H_zAQG5g5nV0m85MxbFI?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1148,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 143,
    "LOC_Y": 219,
    "GAME_DATE": 20150328,
    "Season": "2014-2015",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/28/0021401089/265/80fdcc92-1d90-2922-9ab7-5fab4d838967_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/573497698886875990",
    "name": "The 2974 Collection #1148",
    "imageUrl": "https://arweave.net/pIqdgG0_ohBSUycBDJIm4EBYuTiE2S7YXkawkXTw-04?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1149,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 116,
    "LOC_Y": 217,
    "GAME_DATE": 20150328,
    "Season": "2014-2015",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/28/0021401089/306/b2836554-45e0-f626-8af5-a0afad21b18b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322555211281384913",
    "name": "The 2974 Collection #1149",
    "imageUrl": "https://arweave.net/A-MzorEtjX-nFI09t47VYS0ol5D-sdxtUP9dhY76I5M?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1150,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -229,
    "LOC_Y": 89,
    "GAME_DATE": 20150328,
    "Season": "2014-2015",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/28/0021401089/450/ae84a5a3-6547-8837-a161-61c8fd35546f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/467550078223270489",
    "name": "The 2974 Collection #1150",
    "imageUrl": "https://arweave.net/NhzB3IiHqVaPVdOFm7krZvXDMBbuwzrSw0kxF5G2O98?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1151,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 22,
    "GAME_DATE": 20150328,
    "Season": "2014-2015",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/28/0021401089/461/fba171ac-a57f-2d7e-88e1-fa6781f49750_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/325772235280049036",
    "name": "The 2974 Collection #1151",
    "imageUrl": "https://arweave.net/92AKR48KF1qWsa1FoPCeNDI74y3gdS_25B_17MyCiLo?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1152,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -217,
    "LOC_Y": 134,
    "GAME_DATE": 20150328,
    "Season": "2014-2015",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/28/0021401089/491/6e81d026-e619-119d-d034-658e479756d4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/375624291586711102",
    "name": "The 2974 Collection #1152",
    "imageUrl": "https://arweave.net/FHaNOlrxnPm5wE2r95HsytDeJxBig5CXgB_0rPSlZKE?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1153,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 6,
    "GAME_DATE": 20150331,
    "Season": "2014-2015",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/31/0021401111/30/a1e6812e-4b3d-69c8-ab30-4eb67bb67285_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308743611733973134",
    "name": "The 2974 Collection #1153",
    "imageUrl": "https://arweave.net/hcFtto7SRcIgzPTrW01Rsmv3AJpGDpgkjRzHTG8zSRQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1154,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 72,
    "LOC_Y": 242,
    "GAME_DATE": 20150331,
    "Season": "2014-2015",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/31/0021401111/204/7f15bdad-15b0-e184-c2cf-fb6f2523d7a7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508993762618787685",
    "name": "The 2974 Collection #1154",
    "imageUrl": "https://arweave.net/hAxhULLNcFI_9ZstXklVoStTPDr0KCYuOKuT9uzKyuc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1155,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 226,
    "LOC_Y": 71,
    "GAME_DATE": 20150331,
    "Season": "2014-2015",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/31/0021401111/242/b06aa1c2-5b7c-ae8a-b2eb-1ca96dfdc506_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/559216152829877580",
    "name": "The 2974 Collection #1155",
    "imageUrl": "https://arweave.net/MQHR2_0l9RMPonLAkyLC5LEielm0YJInu3gklq43NDk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1156,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 214,
    "LOC_Y": 153,
    "GAME_DATE": 20150331,
    "Season": "2014-2015",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/03/31/0021401111/374/2af5e6f6-bf8b-a1b4-1534-c890444ff7a9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/473886131545431264",
    "name": "The 2974 Collection #1156",
    "imageUrl": "https://arweave.net/MhUGFV_XTrgVuwUxKuyyapJvd2EOFMca314EiFda7Hw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1157,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 136,
    "LOC_Y": 235,
    "GAME_DATE": 20150402,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/02/0021401126/84/38d30458-3829-bfec-dc43-caf46a69b694_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/473627461987110626",
    "name": "The 2974 Collection #1157",
    "imageUrl": "https://arweave.net/Z4SwBiXYJZ8uS78O_Pk72uZz7pk95AO3BBCK9-Gelq0?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1158,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 4,
    "GAME_DATE": 20150402,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/02/0021401126/247/82c0b8a0-0261-fc2b-4ffd-af1882bc844c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423714470495370615",
    "name": "The 2974 Collection #1158",
    "imageUrl": "https://arweave.net/WVOMxHmutW9jeycS7h5IbJU1PsfFwy3_H870LZzxq7o?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1159,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 233,
    "LOC_Y": 82,
    "GAME_DATE": 20150402,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/02/0021401126/277/7fe73d4f-cf4e-c42e-e852-6ff8cc018b79_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349093143648806169",
    "name": "The 2974 Collection #1159",
    "imageUrl": "https://arweave.net/E4pYiPTEAEzIb7C9v4sCss6_Qqzx4iFN9qMEPYdrJaU?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1160,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 64,
    "LOC_Y": 254,
    "GAME_DATE": 20150402,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/02/0021401126/452/145c3e0b-f40a-f986-1f08-0963e1bd0751_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371496857913226295",
    "name": "The 2974 Collection #1160",
    "imageUrl": "https://arweave.net/-UQAk3h4hLd6a2KpiBc4vLpR0AG41XIUwdSK_8PmKd0?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1161,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 121,
    "LOC_Y": 225,
    "GAME_DATE": 20150402,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/02/0021401126/489/2dea0215-6cc9-f066-9c1f-0828670dcbe1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521578099582018669",
    "name": "The 2974 Collection #1161",
    "imageUrl": "https://arweave.net/9Cb0_9RZ0h5OYVsfpvO74IXWjFq9V2SFsLCBOXmbsoc?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1162,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 228,
    "LOC_Y": 110,
    "GAME_DATE": 20150402,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/02/0021401126/517/bd7c4135-5b16-0bea-ae12-b9390fbe4f7e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322721227956202524",
    "name": "The 2974 Collection #1162",
    "imageUrl": "https://arweave.net/_06ahGr_06p4RVjBzFD4_rfv8R2EulK7YCx7BvRPOvY?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1163,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 226,
    "LOC_Y": 6,
    "GAME_DATE": 20150404,
    "Season": "2014-2015",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/04/0021401142/47/16da3025-3c70-9721-b47b-3b945c9250c8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/426206689702865752",
    "name": "The 2974 Collection #1163",
    "imageUrl": "https://arweave.net/S4onNdi2qeQQgrCV_iKqJhdrSsT_n9m8vtTonh8nbu8?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2015,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1164,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 92,
    "LOC_Y": 233,
    "GAME_DATE": 20150405,
    "Season": "2014-2015",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/05/0021401150/107/b021b6b8-2a0b-80e7-4125-d3c51a0319a7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456626436392328496",
    "name": "The 2974 Collection #1164",
    "imageUrl": "https://arweave.net/CJCcXERagMJCi0br1eijQqJSr6MV0VrTAi539GWJXN0?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2015,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1165,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 21,
    "LOC_Y": 246,
    "GAME_DATE": 20150405,
    "Season": "2014-2015",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/05/0021401150/181/2f778c18-069b-cb0e-1c5d-d0b0eb330dcb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491305458617247274",
    "name": "The 2974 Collection #1165",
    "imageUrl": "https://arweave.net/iU3PWJ_BbXo1wHqKNTkjgOWWnSEKmWa-QPWY0DZbbZs?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2015,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1166,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -242,
    "LOC_Y": -8,
    "GAME_DATE": 20150405,
    "Season": "2014-2015",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/05/0021401150/257/c08a0c0e-44d5-eaa9-3af5-56724b17bafa_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309200032179818081",
    "name": "The 2974 Collection #1166",
    "imageUrl": "https://arweave.net/psaDEHhIUukBkbZgmrS1djfmsWnIDrm74xMk6JSnbSA?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2015,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1167,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 84,
    "LOC_Y": 231,
    "GAME_DATE": 20150405,
    "Season": "2014-2015",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/05/0021401150/261/113308e8-8562-f736-2421-f065eea850af_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363789568001881206",
    "name": "The 2974 Collection #1167",
    "imageUrl": "https://arweave.net/28MajL70PjzGvVOhH-Wf803hlUN5-LUdidFl94Fut3M?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2015,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1168,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 26,
    "LOC_Y": 252,
    "GAME_DATE": 20150405,
    "Season": "2014-2015",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/05/0021401150/266/136527dc-6a17-4180-7242-4fd87caeb231_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/337787196276229689",
    "name": "The 2974 Collection #1168",
    "imageUrl": "https://arweave.net/aQjghzx2zuTgIRw9MU1Ecq9D_jl7GbXintEQyAC540M?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2015,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1169,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 144,
    "LOC_Y": 213,
    "GAME_DATE": 20150407,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/07/0021401156/126/5baa9874-0605-6c86-8cff-1653f40109e4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523667374988741243",
    "name": "The 2974 Collection #1169",
    "imageUrl": "https://arweave.net/eqZGOiFqSEO2Tjl1WDtNOGFgWCFly4Ml6mbJZcPvpbo?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1170,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 21,
    "LOC_Y": 255,
    "GAME_DATE": 20150407,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/07/0021401156/222/89d2ade9-edb0-95b5-70a6-6d4c6f0b3a71_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/325579039570063547",
    "name": "The 2974 Collection #1170",
    "imageUrl": "https://arweave.net/T33Kvmfec2BRHiygwTP_275teV3MsGZ2I_amoqCAxP4?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1171,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 91,
    "LOC_Y": 247,
    "GAME_DATE": 20150407,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/07/0021401156/227/2a672d7f-7201-b10f-53bb-658f68ac2ca7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499668626196308352",
    "name": "The 2974 Collection #1171",
    "imageUrl": "https://arweave.net/7S1Ak12DsKJy3owmRiSdA2CbrNYFCPILLyI0NsDF8-Y?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1172,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 147,
    "LOC_Y": 209,
    "GAME_DATE": 20150407,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/07/0021401156/242/67273fff-2ded-5bf2-3634-21588858d084_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/351323075311743146",
    "name": "The 2974 Collection #1172",
    "imageUrl": "https://arweave.net/gxj0lYe_HTOn3pu6JsW7_g4iYpAgcwoOb22ib6dSbrA?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1173,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -125,
    "LOC_Y": 255,
    "GAME_DATE": 20150407,
    "Season": "2014-2015",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/07/0021401156/496/05ae4d0c-541f-b5c4-a440-9285ec3d4b43_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439372076660691029",
    "name": "The 2974 Collection #1173",
    "imageUrl": "https://arweave.net/hyBQkpqCZZIHX46_H0dc_HPAN1m5MfLfkNFobWvEfFI?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1174,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -109,
    "LOC_Y": 246,
    "GAME_DATE": 20150409,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/09/0021401174/12/376d5362-76e2-1b63-1b9a-b6ec2f512ddd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381224019515347685",
    "name": "The 2974 Collection #1174",
    "imageUrl": "https://arweave.net/Am0tqAt3Gjg7ifLjdDEbP01RHVXNeg494pChRpNZx9E?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1175,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -193,
    "LOC_Y": 206,
    "GAME_DATE": 20150409,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/09/0021401174/15/08ad8fc1-57b9-556a-1ad8-e450c54e3f6f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/560055215238554966",
    "name": "The 2974 Collection #1175",
    "imageUrl": "https://arweave.net/W50Gf6Wbs9bfiKVdvOFz-KOHC6YwE1MCMYN4xcXXavQ?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1176,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 125,
    "LOC_Y": 233,
    "GAME_DATE": 20150409,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/09/0021401174/40/ae1c4018-9fa3-ab0c-f340-31c9b4257db8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540509012275715359",
    "name": "The 2974 Collection #1176",
    "imageUrl": "https://arweave.net/w69KpUtCmfaSTUkMMxaTo4ga0MtH75_7dhn3v2ZaTIM?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1177,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -15,
    "LOC_Y": 254,
    "GAME_DATE": 20150409,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/09/0021401174/107/d4ae765b-7b12-fe65-9c40-f11bb9602130_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485540527027532258",
    "name": "The 2974 Collection #1177",
    "imageUrl": "https://arweave.net/YpeVH1H2d9Foflftpz4acWd-P9TyNRwOwkcfaWKnQm0?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1178,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -127,
    "LOC_Y": 246,
    "GAME_DATE": 20150409,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/09/0021401174/198/a2010c3b-0ee6-c14b-0adf-0dd4fb1be102_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353750241217154672",
    "name": "The 2974 Collection #1178",
    "imageUrl": "https://arweave.net/9pzeWf-FBK73pWM765EC5Hbs4dLBtfE7trGJpVBHB0A?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1179,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -194,
    "LOC_Y": 164,
    "GAME_DATE": 20150409,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/09/0021401174/205/dcb4f80d-f1d4-5d32-e1ae-56821766b83d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/528023531868616504",
    "name": "The 2974 Collection #1179",
    "imageUrl": "https://arweave.net/yXXr4bY38T59FzkUxU6EdyK5Cu1PkhefTJmkOAzdrow?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1180,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 138,
    "LOC_Y": 227,
    "GAME_DATE": 20150409,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/09/0021401174/401/470df2a0-1ee0-e078-d56f-4f77ed7ce882_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378050816760536056",
    "name": "The 2974 Collection #1180",
    "imageUrl": "https://arweave.net/7ykFL-Ffn-TVmORlkgKk7v8ZJEk-yL8QjsvhF70AiU4?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1181,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 132,
    "LOC_Y": 249,
    "GAME_DATE": 20150409,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/09/0021401174/442/037508ae-944e-336f-53d7-3c8596760a11_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558679673051936599",
    "name": "The 2974 Collection #1181",
    "imageUrl": "https://arweave.net/W8s47ip9CFfvp87Xe_saH2ClS9AOVZE4gkeLmhJekZc?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2015,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1182,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 77,
    "LOC_Y": 242,
    "GAME_DATE": 20150411,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/11/0021401192/5/a8422212-bcc9-de85-7662-b2dd15c85ada_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461814716590602913",
    "name": "The 2974 Collection #1182",
    "imageUrl": "https://arweave.net/Bc7xtuzuQT7RYvm1C7ryN05n3Yz_gDgd3uiyIfqta9E?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1183,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 26,
    "GAME_DATE": 20150411,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/11/0021401192/54/29a6f1a3-0029-7bb9-3c15-42aaf7bc2cd4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436708038353461109",
    "name": "The 2974 Collection #1183",
    "imageUrl": "https://arweave.net/wohOuiP-8MUwtipb3Y5wDXArBIxXJeqVJhl7r06GcGM?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1184,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -202,
    "LOC_Y": 145,
    "GAME_DATE": 20150411,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/11/0021401192/100/eabce783-ebd7-bc55-d1e1-f5a745a41223_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346750382275248222",
    "name": "The 2974 Collection #1184",
    "imageUrl": "https://arweave.net/xQDuOsKSMh3YuzZW26mGeknMKjV0pxdB0FXd_V9FtVg?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1185,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 237,
    "LOC_Y": 4,
    "GAME_DATE": 20150411,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/11/0021401192/225/676d9846-1a04-e5d9-31da-4470b1ca887e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359585583899162951",
    "name": "The 2974 Collection #1185",
    "imageUrl": "https://arweave.net/yK6TUVYgqL_mhu7zpuBaLJ7P06eMWFVikUZjhherEOY?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1186,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 99,
    "LOC_Y": 250,
    "GAME_DATE": 20150411,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/11/0021401192/389/a8ca1099-e079-edbe-e354-d77138a422be_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415379850861929999",
    "name": "The 2974 Collection #1186",
    "imageUrl": "https://arweave.net/r67__UjP3U70O6a5jqIDIFxz2TsvYG2vu4jvuesOnV0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 4,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1187,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 179,
    "LOC_Y": 192,
    "GAME_DATE": 20150413,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/13/0021401212/39/2cd914e2-9cc3-0092-c608-9861de093323_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/507590486979827159",
    "name": "The 2974 Collection #1187",
    "imageUrl": "https://arweave.net/XvDwI4e4goj0jzmcP8YWhE7OZOg7lLRC6bASieJE7-U?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1188,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 114,
    "LOC_Y": 258,
    "GAME_DATE": 20150413,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/13/0021401212/248/4822dd20-a699-1d27-1bc6-a1c99bbf29f4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429827782052176383",
    "name": "The 2974 Collection #1188",
    "imageUrl": "https://arweave.net/CXGKbJ7F-5BSEx00jOnQu-eu1hBdwyzdSJdYOcu0ovI?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1189,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 225,
    "LOC_Y": 123,
    "GAME_DATE": 20150413,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/13/0021401212/348/837cb87d-2049-1079-e6a1-b2549f9e9e14_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305389740058790044",
    "name": "The 2974 Collection #1189",
    "imageUrl": "https://arweave.net/905-g6Lqqtgt5o_YURncY95-bLsYH_HKNQla6jOaNsM?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1190,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -93,
    "LOC_Y": 260,
    "GAME_DATE": 20150415,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/15/0021401229/87/1ad9c87e-52b7-9eeb-d31a-81cc7e0486a7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423015022759366695",
    "name": "The 2974 Collection #1190",
    "imageUrl": "https://arweave.net/CVWE6O_6CrJ3OMzzmJ9FVynUcw4_Sx7kLXNB_-CB0s4?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1191,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 129,
    "LOC_Y": 225,
    "GAME_DATE": 20150415,
    "Season": "2014-2015",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/04/15/0021401229/283/fc22c04d-1b30-8cc8-b1ae-0ffe3b85fb1e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301389295961936934",
    "name": "The 2974 Collection #1191",
    "imageUrl": "https://arweave.net/oNYwKqoeVnucvYYjXsRiHnA6jjNrte4IFUBGEiW5IAs?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1192,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -197,
    "LOC_Y": 193,
    "GAME_DATE": 20151027,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/27/0021500003/19/d0f29f80-087d-39d5-29be-96c79df9414c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297117529423162824",
    "name": "The 2974 Collection #1192",
    "imageUrl": "https://arweave.net/zwW8krnrlKzbtsxIEjwqCGZc64XhDs-WP3RhZ2zVOek?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1193,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -11,
    "LOC_Y": 259,
    "GAME_DATE": 20151027,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/27/0021500003/38/6e201b6a-30f6-e46b-13ea-870f2dc3d05d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485707242256835168",
    "name": "The 2974 Collection #1193",
    "imageUrl": "https://arweave.net/NuAAS9KTZ_xrFUzDaRKL1rEtXtE6EnFKEOfsGk46Ae8?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1194,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -179,
    "LOC_Y": 228,
    "GAME_DATE": 20151027,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/27/0021500003/55/66e009f5-c859-d273-a321-18c97bb21062_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356318664684673538",
    "name": "The 2974 Collection #1194",
    "imageUrl": "https://arweave.net/yExP01qLi9bqvufZeZ0nZPj0Bfg1w4gWMbbw7CwAdzE?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1195,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 89,
    "LOC_Y": 239,
    "GAME_DATE": 20151027,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/27/0021500003/68/5a6a364e-78cc-8327-7d74-bdad7b2c48c3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/393657199636238960",
    "name": "The 2974 Collection #1195",
    "imageUrl": "https://arweave.net/ubF_yquK1QXIQ72xs5tNN78Oi0aiSVCuN7iqPgjXug8?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1196,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 184,
    "LOC_Y": 170,
    "GAME_DATE": 20151027,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/27/0021500003/395/645be64d-fa29-ad18-9d84-27be64ac03b7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359988186005590866",
    "name": "The 2974 Collection #1196",
    "imageUrl": "https://arweave.net/EQ2oI7O2aTR7Vnnka7ljGKETk-DojRt29FTWtS_mMt8?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1197,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 209,
    "LOC_Y": 124,
    "GAME_DATE": 20151030,
    "Season": "2015-2016",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/30/0021500030/35/94076586-3505-fd4d-c038-8e255f96b2d1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/466087569075354081",
    "name": "The 2974 Collection #1197",
    "imageUrl": "https://arweave.net/JvEUFoGoaCNkN9cx4d-StfwUu4KR5vLTrZrIEj9gxsc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2015,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1198,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 228,
    "LOC_Y": 87,
    "GAME_DATE": 20151030,
    "Season": "2015-2016",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/30/0021500030/39/57c524fb-fe76-a324-2ebf-3d24de4a5401_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/505707721862526580",
    "name": "The 2974 Collection #1198",
    "imageUrl": "https://arweave.net/QwoL5QozJgj9ZYADmYCOsFMpVBpxpjl_TFtOPgZ1rc0?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2015,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1199,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -52,
    "LOC_Y": 288,
    "GAME_DATE": 20151030,
    "Season": "2015-2016",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/30/0021500030/44/67fc004b-664c-db20-42b1-2b2d72b21499_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/377903605045588796",
    "name": "The 2974 Collection #1199",
    "imageUrl": "https://arweave.net/yA7WElv0BAPCw1ZXiPUh410NJL_UsekGE7F2MtqR66w?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2015,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1200,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -240,
    "LOC_Y": 100,
    "GAME_DATE": 20151030,
    "Season": "2015-2016",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/30/0021500030/251/37b9d088-2c69-11cc-ead2-fdae21e56398_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/557109955518471401",
    "name": "The 2974 Collection #1200",
    "imageUrl": "https://arweave.net/C4jR5YeFCrF9QpZB1gpcKMchKCskzmNQ29t7DAVbOBo?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2015,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1201,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 197,
    "LOC_Y": 244,
    "GAME_DATE": 20151031,
    "Season": "2015-2016",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/31/0021500035/45/75a4534e-f499-5708-1af5-a924c7523003_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562554469135300931",
    "name": "The 2974 Collection #1201",
    "imageUrl": "https://arweave.net/028Y_f6B_5qlQ-FTH2M9zT9Ya2a4HbI0BBpLj-MMzVg?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (53 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1202,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 181,
    "LOC_Y": 232,
    "GAME_DATE": 20151031,
    "Season": "2015-2016",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/31/0021500035/101/a922bada-8e36-ca1a-7389-4fd5e9873cca_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391571061642917001",
    "name": "The 2974 Collection #1202",
    "imageUrl": "https://arweave.net/m7kI8szeUSD3QvjlGLeUZDzQdFw_yV1ihaBi_1kMc04?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (53 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1203,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -142,
    "LOC_Y": 247,
    "GAME_DATE": 20151031,
    "Season": "2015-2016",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/31/0021500035/351/e0495cef-b3c0-85f8-edf3-814b290650ed_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323408625898467809",
    "name": "The 2974 Collection #1203",
    "imageUrl": "https://arweave.net/iJ5DMyAc8_83CsmagF9tGZ1eOKpS0ZbM8mXLjdp9sOM?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (53 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1204,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -225,
    "LOC_Y": 120,
    "GAME_DATE": 20151031,
    "Season": "2015-2016",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/31/0021500035/361/04c51738-e1cc-82a1-9609-68dfe3d4b816_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326100764997254228",
    "name": "The 2974 Collection #1204",
    "imageUrl": "https://arweave.net/-AxyodF6b0ZknvQFoDYu4AynzIbt_tD1JyhtTH35D4Q?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (53 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1205,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -181,
    "LOC_Y": 188,
    "GAME_DATE": 20151031,
    "Season": "2015-2016",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/31/0021500035/363/78fa716d-5abb-835c-0842-895f2b7ea9a4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/314882784196954599",
    "name": "The 2974 Collection #1205",
    "imageUrl": "https://arweave.net/Pm7YG6idnkAqSwQqxq6Q7hTTp9WqFm49EQBFqzLEbNc?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (53 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1206,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 187,
    "LOC_Y": 170,
    "GAME_DATE": 20151031,
    "Season": "2015-2016",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/31/0021500035/396/9242556c-4401-55a3-0805-3febdc8833a4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501050456711820146",
    "name": "The 2974 Collection #1206",
    "imageUrl": "https://arweave.net/qfWVK2GirWzXKxTLlVe0f96FCgCoYIiAJfAhwEg1znU?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (53 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1207,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 194,
    "LOC_Y": 185,
    "GAME_DATE": 20151031,
    "Season": "2015-2016",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/31/0021500035/421/f0d3016a-fd9f-1eb0-7a65-75d2318de251_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335559231755542759",
    "name": "The 2974 Collection #1207",
    "imageUrl": "https://arweave.net/zYTdMJ-0zw6JcGMZNUlDZrMfuR1DEQuwTxPA8oZI8co?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (53 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1208,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -145,
    "LOC_Y": 259,
    "GAME_DATE": 20151031,
    "Season": "2015-2016",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/10/31/0021500035/556/94e60599-14d6-8349-c111-f7bc9fa520ee_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500473287988040263",
    "name": "The 2974 Collection #1208",
    "imageUrl": "https://arweave.net/Yw5xT7blZPC5NnlyHXO4lSHLIt7ydVJHj6Hd9MrwYDE?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2015,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (53 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1209,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -210,
    "LOC_Y": 188,
    "GAME_DATE": 20151102,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/02/0021500051/11/7dcef8cb-4fa8-91dc-1fb9-5e60a883f754_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456726330353104636",
    "name": "The 2974 Collection #1209",
    "imageUrl": "https://arweave.net/qrwhy0Ur-n23R4whH7HIEb6YH7EaIiTLs_Il5qBatmM?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1210,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -143,
    "LOC_Y": 210,
    "GAME_DATE": 20151102,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/02/0021500051/297/85e6d2cc-8642-dcc2-d204-e813ee751349_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/454385078467654379",
    "name": "The 2974 Collection #1210",
    "imageUrl": "https://arweave.net/e7JFMPUUhLkq_yP_TC8A1xV6t9gOqWKoF5hrfQEfECU?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1211,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 232,
    "LOC_Y": 95,
    "GAME_DATE": 20151102,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/02/0021500051/339/ceeb0924-8b30-7655-75ac-cd18d4d26db8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/452152422264647493",
    "name": "The 2974 Collection #1211",
    "imageUrl": "https://arweave.net/4MeMNc27SqxN5r1y4HkGuUGNy7ffb4lVTlHU5c9VF3E?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1212,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": -5,
    "GAME_DATE": 20151102,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/02/0021500051/344/5e85890a-b10e-2346-213f-917f4777cfa8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444395185098986649",
    "name": "The 2974 Collection #1212",
    "imageUrl": "https://arweave.net/7-nMPICQAjk5oJUpIbKMegVu417lBWE9YDUBDiVc__w?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1213,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -43,
    "LOC_Y": 247,
    "GAME_DATE": 20151104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/04/0021500069/5/74d388da-e560-0425-c27a-fc6cdeb511c6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/452064744974850683",
    "name": "The 2974 Collection #1213",
    "imageUrl": "https://arweave.net/9mB7TRW59Cn39NotQYv2j8ygRVpdG4BSITwh0WthSrY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1214,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -151,
    "LOC_Y": 223,
    "GAME_DATE": 20151104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/04/0021500069/164/1f633ec1-2bfd-d1fa-43be-5381990948e4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400322090376428356",
    "name": "The 2974 Collection #1214",
    "imageUrl": "https://arweave.net/AbQ6KpX6-Z1thOoB6ffwiZmdjTXOiHKIYTx772ebRp0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1215,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -122,
    "LOC_Y": 264,
    "GAME_DATE": 20151104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/04/0021500069/195/bec7b1ad-2eb4-0507-ed16-771708b7af36_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356685337422440518",
    "name": "The 2974 Collection #1215",
    "imageUrl": "https://arweave.net/yaLW2FANxgSQ6oMo2PRkghxpCS4wmU4vbnrODj7z7W0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1216,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 43,
    "LOC_Y": 247,
    "GAME_DATE": 20151104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/04/0021500069/248/fb447f28-7871-5ffe-8a2d-78157533418f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/291565544647365919",
    "name": "The 2974 Collection #1216",
    "imageUrl": "https://arweave.net/WRiZDziBdmTqG-rLk-dPW4GVMHPWh89guPu_tA46jTg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1217,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -91,
    "LOC_Y": 228,
    "GAME_DATE": 20151104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/04/0021500069/472/07ac3321-6d0b-63af-20eb-71ccd4594b61_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504515054003774821",
    "name": "The 2974 Collection #1217",
    "imageUrl": "https://arweave.net/DeMxDmWw3wdrQnJx8GYPaKax8LNQ9Pn8eVsellNYWAc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1218,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 101,
    "LOC_Y": 249,
    "GAME_DATE": 20151104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/04/0021500069/478/209eba55-2e3b-8c99-a125-0f09bfbd9664_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359555916587449224",
    "name": "The 2974 Collection #1218",
    "imageUrl": "https://arweave.net/9-aJ4EqS-A7CnwW0QWO7IMyUmgO4b7dbH16RuueaSs0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1219,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -74,
    "LOC_Y": 257,
    "GAME_DATE": 20151104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/04/0021500069/523/570d7d0d-85b0-b32f-6739-4c364693edf8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384916506894411364",
    "name": "The 2974 Collection #1219",
    "imageUrl": "https://arweave.net/LnBSinODY_DPqh7rxWxeO0U_FT3xz3k6iTmGLqwD7fk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1220,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 212,
    "LOC_Y": 139,
    "GAME_DATE": 20151106,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/06/0021500083/58/8c3135f3-7bf0-eef3-9b4c-5d7e905e45e4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480443751943075623",
    "name": "The 2974 Collection #1220",
    "imageUrl": "https://arweave.net/WhOuWE_1a6DTeRG11eKH6yHlSshQITXZNZFdZE7Vs78?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1221,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -196,
    "LOC_Y": 183,
    "GAME_DATE": 20151106,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/06/0021500083/73/320997d2-e731-81c9-2fdf-ee5beb1b392a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/509340181517825980",
    "name": "The 2974 Collection #1221",
    "imageUrl": "https://arweave.net/n9oJ9Ts-q3CYbHZvwQB0U2CEly41a0jMvpKiJKgppsY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1222,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -81,
    "LOC_Y": 252,
    "GAME_DATE": 20151106,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/06/0021500083/93/9c6fd676-1ad0-f28f-7c68-42991e6fa9e0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522126024244948180",
    "name": "The 2974 Collection #1222",
    "imageUrl": "https://arweave.net/9gRY-mGlUsxFPnDd9jt16mqxpudgGGsFHdJkTLYlYRA?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1223,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 138,
    "LOC_Y": 228,
    "GAME_DATE": 20151106,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/06/0021500083/132/abf0da7b-0b84-91a2-93d4-fa9ad9ea200d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324501615278212465",
    "name": "The 2974 Collection #1223",
    "imageUrl": "https://arweave.net/x_KY3pd9Xg-0wILjJw3zde6iSa8NBvlgmTUFNw_JCYU?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1224,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 159,
    "LOC_Y": 200,
    "GAME_DATE": 20151106,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/06/0021500083/275/d6fa0c91-1558-d01b-2f1d-4f7cf1b1b9bb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300323023284142029",
    "name": "The 2974 Collection #1224",
    "imageUrl": "https://arweave.net/R_PDzUwulWLpzpuibFw8sSQf-yEF6qxrBQz3FB9uoB0?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1225,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -212,
    "LOC_Y": 134,
    "GAME_DATE": 20151106,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/06/0021500083/280/f8195f6f-b53c-fc78-d14a-238ed3c112a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/526973155903438419",
    "name": "The 2974 Collection #1225",
    "imageUrl": "https://arweave.net/oe2QmMP3yhuH2mHxMH2UJVeF8yGmopAMLfVICLftx04?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1226,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 227,
    "LOC_Y": 11,
    "GAME_DATE": 20151106,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/06/0021500083/344/00c014fa-f689-b9f1-af9d-f883f40b2ea8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/453794613825585684",
    "name": "The 2974 Collection #1226",
    "imageUrl": "https://arweave.net/BYUTMeBCjPMqBn_h-St4DFB30QCZtWdgWs-e5_WZVyM?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1227,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 227,
    "LOC_Y": 106,
    "GAME_DATE": 20151106,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/06/0021500083/367/6768ec42-62c9-91a3-e132-8b9e17c90856_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556070564566132853",
    "name": "The 2974 Collection #1227",
    "imageUrl": "https://arweave.net/fv9cjrwx6kjtB-QYYLOINmoaGZw1d2SD2MOVTr0Mffg?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1228,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 71,
    "LOC_Y": 264,
    "GAME_DATE": 20151107,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/07/0021500092/474/7dcc91e6-9eb8-f221-3462-11d1a5d6a438_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361846719588841414",
    "name": "The 2974 Collection #1228",
    "imageUrl": "https://arweave.net/OZG8Vw-easR52wAvfYvRxVeW1VYUcBpbJdw9Pz4F9FU?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1229,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 21,
    "GAME_DATE": 20151107,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/07/0021500092/529/76f1862f-cbe9-0c19-b10b-3dd6f0e3ba9b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422337106528847621",
    "name": "The 2974 Collection #1229",
    "imageUrl": "https://arweave.net/ejxMSrDMFMy_GfUde605CaIq2PgF32024wWL4xmk3c4?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1230,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -214,
    "LOC_Y": 134,
    "GAME_DATE": 20151109,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/09/0021500104/159/cfdb93d1-846b-9588-5d40-7a18122e7a49_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519185574233731206",
    "name": "The 2974 Collection #1230",
    "imageUrl": "https://arweave.net/M0PUFLkNGHPWZ0AmYHxbCdzRSwD5qoV9ieHVkndRsZg?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2015,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1231,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 150,
    "LOC_Y": 213,
    "GAME_DATE": 20151109,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/09/0021500104/273/259b9edb-a320-8f9c-028a-91af48c6e34a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320164843970483281",
    "name": "The 2974 Collection #1231",
    "imageUrl": "https://arweave.net/MaUpCUpLykg7msZKvb_b0yfSFvrS5fR1_DyOfYCrxGY?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2015,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1232,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -6,
    "LOC_Y": 259,
    "GAME_DATE": 20151109,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/09/0021500104/444/a53d04ef-6087-6ae7-5fd8-865ce644b236_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498563379050980298",
    "name": "The 2974 Collection #1232",
    "imageUrl": "https://arweave.net/ZJsZ66PbzKLd3k4zWXRmM_pjjBbflWy4NPa09Rve_Sk?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2015,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1233,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 33,
    "GAME_DATE": 20151111,
    "Season": "2015-2016",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/11/0021500120/30/d5be3b0c-b670-5845-b982-3a2423b61e39_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/333692419053205471",
    "name": "The 2974 Collection #1233",
    "imageUrl": "https://arweave.net/1fQLGc9HouXEbif15vyefaXNQ9mzipbaZedHLdFvxIA?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 11,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1234,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Driving Bank shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -89,
    "LOC_Y": 272,
    "GAME_DATE": 20151111,
    "Season": "2015-2016",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/11/0021500120/408/903bd4f6-1354-ec0f-c4a1-e762af66297f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305440657574110016",
    "name": "The 2974 Collection #1234",
    "imageUrl": "https://arweave.net/-9G5gl2COsnx_3TdJkVvL6Ho4xG-AXHX16af8Who6sQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 11,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1235,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 39,
    "LOC_X": -199,
    "LOC_Y": 342,
    "GAME_DATE": 20151111,
    "Season": "2015-2016",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/11/0021500120/444/08b8199e-db22-758d-5d1a-b88321e4b87e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/526034550047338719",
    "name": "The 2974 Collection #1235",
    "imageUrl": "https://arweave.net/ynDUpVfnAAcpQKhxYJyuEAS8ESvABSNay_TM4Abd408?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2015,
    "Month": 11,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1236,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -145,
    "LOC_Y": 234,
    "GAME_DATE": 20151112,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/12/0021500125/7/09dc3c8c-9d46-2137-9fe8-4eac3a294778_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323293255393813534",
    "name": "The 2974 Collection #1236",
    "imageUrl": "https://arweave.net/N1kwpRwC7iT3kZXeYLApkcyO4LUJ_fk-tQyqz8rJlm8?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1237,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -235,
    "LOC_Y": 75,
    "GAME_DATE": 20151112,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/12/0021500125/19/079fa5e5-7e7e-b2c3-0a1f-50c3a8f5c7c5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438406802398621962",
    "name": "The 2974 Collection #1237",
    "imageUrl": "https://arweave.net/qQbpW6f_RUGXFlJQIoLveKPuPVfz6k-I7mB6LqVMLYE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1238,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -240,
    "LOC_Y": 16,
    "GAME_DATE": 20151112,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/12/0021500125/47/1eb44d04-faa4-ee67-a9ae-e1a5437195f8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/370098770126953075",
    "name": "The 2974 Collection #1238",
    "imageUrl": "https://arweave.net/MbwjEa4LegKW0F8gAyLSSsrN4Y4rSaH0pLJDOkf1Yzg?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1239,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 91,
    "LOC_Y": 224,
    "GAME_DATE": 20151112,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/12/0021500125/114/6f31094b-583d-9bde-6442-cac4aafebb1d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322238555413269328",
    "name": "The 2974 Collection #1239",
    "imageUrl": "https://arweave.net/km6xXH_5bR6hZO59wtEiWTxyaktzOorlf8IFiDFOwOk?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1240,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 112,
    "LOC_Y": 232,
    "GAME_DATE": 20151112,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/12/0021500125/365/cba19b69-4067-023a-a2e7-ffdeeb1c29bd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299912162835423169",
    "name": "The 2974 Collection #1240",
    "imageUrl": "https://arweave.net/FD0DTz3-Lz7wIxFT46V-0tpppGTYABgIaMR9HjzmykI?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1241,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 192,
    "LOC_Y": 159,
    "GAME_DATE": 20151112,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/12/0021500125/367/f6503fb5-2dbb-26a4-13fa-7e49748ad626_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326522245082836595",
    "name": "The 2974 Collection #1241",
    "imageUrl": "https://arweave.net/wlIg5ZhAOOqV7XRC1Ann9sDjxiTAXDbe7KY4kukWfrE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1242,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 76,
    "LOC_Y": 252,
    "GAME_DATE": 20151112,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/12/0021500125/454/823aee8a-cdb9-dd44-b727-48a3f579fdb0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361252315839607759",
    "name": "The 2974 Collection #1242",
    "imageUrl": "https://arweave.net/OYaihMOq-VudfqPC9Bukgi9ZcVPiNZ1ZC5-6PSi473U?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1243,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 51,
    "LOC_Y": 257,
    "GAME_DATE": 20151112,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/12/0021500125/527/65a2be02-82c6-44c5-3e43-74c017b0d07d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323296240608723756",
    "name": "The 2974 Collection #1243",
    "imageUrl": "https://arweave.net/IPJnuT00TRzq8LuFo1Q3ixN9pJ4uSNExP1Yb74sVJWE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2015,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1244,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -179,
    "LOC_Y": 190,
    "GAME_DATE": 20151114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/14/0021500144/60/b354c184-3b5b-7801-0659-e97640b1b0b1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546106938367657498",
    "name": "The 2974 Collection #1244",
    "imageUrl": "https://arweave.net/Z0dezOzOmV-_FffxJCo_fk4_RdjXSYcbRCgWNAPmtZE?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1245,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -68,
    "LOC_Y": 242,
    "GAME_DATE": 20151114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/14/0021500144/196/82ac74e7-8100-8f65-6886-6700dcb14424_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359281056624947186",
    "name": "The 2974 Collection #1245",
    "imageUrl": "https://arweave.net/Sver4bgiWtvjcyhJGxPrWCW7pU_sP3FwPu6fv4QH7S0?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1246,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -194,
    "LOC_Y": 170,
    "GAME_DATE": 20151114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/14/0021500144/304/0b55ac2f-4648-a507-f747-01764cdf5fc0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/530067218563685860",
    "name": "The 2974 Collection #1246",
    "imageUrl": "https://arweave.net/pvpwjuaYXbngFtNa4Rh18nxouOX9WDJd_W29K5ahr64?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1247,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -209,
    "LOC_Y": 141,
    "GAME_DATE": 20151114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/14/0021500144/374/356b9769-fdcf-c296-5d40-70530e4fccdd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367061661758527869",
    "name": "The 2974 Collection #1247",
    "imageUrl": "https://arweave.net/XBkGMUrafgaJ7GaZfee_RO-DZEU1wq80yFhjNTsgGuA?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1248,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 47,
    "GAME_DATE": 20151114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/14/0021500144/397/8b6d47ef-1da7-8d23-4ed1-cc1df013ba65_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422452387651438891",
    "name": "The 2974 Collection #1248",
    "imageUrl": "https://arweave.net/RJ0-gZdhN9AP2cKqOtWNzeoC4CN1TfW_mhkcUURUrlg?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1249,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 64,
    "LOC_Y": 252,
    "GAME_DATE": 20151117,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/17/0021500164/96/15bb7093-512f-fb55-c205-dd3ce2dd5c33_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367518571114928590",
    "name": "The 2974 Collection #1249",
    "imageUrl": "https://arweave.net/pHHPMPzchiAZRR4NKbnwg2ghE9eh_K5nTAlJptekAlg?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 11,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1250,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 109,
    "LOC_Y": 232,
    "GAME_DATE": 20151117,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/17/0021500164/121/c330366c-b446-0d78-1eb0-92cc7775b38b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/365784473636942285",
    "name": "The 2974 Collection #1250",
    "imageUrl": "https://arweave.net/tPmOktae4SZ_1grWG5fStc13niqDtP7RJ7rCLWX1YP4?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 11,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1251,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -30,
    "LOC_Y": 252,
    "GAME_DATE": 20151117,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/17/0021500164/218/0e8870cb-d11a-6b32-67d7-1c8d71fa3718_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434079088210894309",
    "name": "The 2974 Collection #1251",
    "imageUrl": "https://arweave.net/pV6VaUxOf6JLJQk03JXvRyYYmSmNUi0jtIEIb8EvpW4?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 11,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1252,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -147,
    "LOC_Y": 205,
    "GAME_DATE": 20151117,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/17/0021500164/313/93470158-fbfe-bd3b-f503-d94e94e718dd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525380083297886303",
    "name": "The 2974 Collection #1252",
    "imageUrl": "https://arweave.net/J6jX0e0G3o5CCoo8IxlV9NHZiWTzDg4vN5yw5fY65_Y?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 11,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1253,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -4,
    "LOC_Y": 257,
    "GAME_DATE": 20151117,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/17/0021500164/463/95a161a5-2b37-0923-d05c-99deb3790329_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384735024928566831",
    "name": "The 2974 Collection #1253",
    "imageUrl": "https://arweave.net/-D9CyQb4xG6MMvs3s7dLf01RQJEILdStdM7OOPk0h28?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 11,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1254,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -202,
    "LOC_Y": 178,
    "GAME_DATE": 20151119,
    "Season": "2015-2016",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/19/0021500177/8/ab8fe47b-5f68-0b16-2712-1c98e092deb6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321923087118741578",
    "name": "The 2974 Collection #1254",
    "imageUrl": "https://arweave.net/FutKQKnKV0A9HRiRGUH4u2IMD6u_b0lgjW1RBDlXp0k?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1255,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 21,
    "GAME_DATE": 20151119,
    "Season": "2015-2016",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/19/0021500177/159/2646f906-1166-2550-42c6-bdeaeeed5cba_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504210746960868284",
    "name": "The 2974 Collection #1255",
    "imageUrl": "https://arweave.net/wVAb9Pkh8_KMK0Hyp2lg4dbOSrm0LwQwExYG7soy1XY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1256,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -148,
    "LOC_Y": 232,
    "GAME_DATE": 20151119,
    "Season": "2015-2016",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/19/0021500177/281/3cd8d6ef-cabb-c4e1-83aa-4bc790ff0a13_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/527275326176612627",
    "name": "The 2974 Collection #1256",
    "imageUrl": "https://arweave.net/Crv4rRc11BYi2PGPl5ACfIzeC20B2Yk2HonKSRwxZ9o?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1257,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -125,
    "LOC_Y": 218,
    "GAME_DATE": 20151119,
    "Season": "2015-2016",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/19/0021500177/485/fc513fd3-4570-5822-dfbc-8450da0e85fb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321124209806728845",
    "name": "The 2974 Collection #1257",
    "imageUrl": "https://arweave.net/O7xj1aZUdI36VM-F0MiMFd7UaW1dNFmWrRAwNkPDX4s?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1258,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 176,
    "LOC_Y": 178,
    "GAME_DATE": 20151119,
    "Season": "2015-2016",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/19/0021500177/496/af209809-397a-e043-09a0-026ec8d95732_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429005134260443024",
    "name": "The 2974 Collection #1258",
    "imageUrl": "https://arweave.net/u7Ofxk1esbd6ffc2HQsrnQKd4_vZXFmgxfhBvo5uBf8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1259,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -47,
    "LOC_Y": 242,
    "GAME_DATE": 20151119,
    "Season": "2015-2016",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/19/0021500177/525/de00d943-3149-1d84-89a3-a8c342a4c75b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404275470318201364",
    "name": "The 2974 Collection #1259",
    "imageUrl": "https://arweave.net/1tHgJdlP9Ux11o64YriBhZYWPySq3P7l_KrdDLaVVv0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1260,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -127,
    "LOC_Y": 213,
    "GAME_DATE": 20151120,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/20/0021500187/14/23f72cdc-a6ca-fecd-e249-52d0f048e1ee_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510020686450249685",
    "name": "The 2974 Collection #1260",
    "imageUrl": "https://arweave.net/KZPFR21vA2BiqYkPTZTuGj5kYZSCMb89WLt3Ff7vh3k?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2015,
    "Month": 11,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1261,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 79,
    "LOC_Y": 249,
    "GAME_DATE": 20151120,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/20/0021500187/76/7fce1458-4c97-3c19-c88a-1dc08a497005_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297903957159645064",
    "name": "The 2974 Collection #1261",
    "imageUrl": "https://arweave.net/X7XZlRFpBnPFIpUTIcKQKiFPkFLw5jUjf5Cc4ZTWCZI?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2015,
    "Month": 11,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1262,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -29,
    "LOC_Y": 252,
    "GAME_DATE": 20151120,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/20/0021500187/465/d7b90df6-30e4-fb22-f0c4-bbfa9819b3b6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371829616704557832",
    "name": "The 2974 Collection #1262",
    "imageUrl": "https://arweave.net/i6zUhoFQY14m5PTeYKl7Vix7K4dwtc5PMxtyHIYgWrY?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2015,
    "Month": 11,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1263,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 240,
    "LOC_Y": -5,
    "GAME_DATE": 20151122,
    "Season": "2015-2016",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/22/0021500200/74/56989004-1684-f362-aae5-ca1ba1576f75_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299177712909268362",
    "name": "The 2974 Collection #1263",
    "imageUrl": "https://arweave.net/uJ05BP04crI5fPvD8AikOjI1AgxWT3QN1CCIJGHZTKI?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1264,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 30,
    "LOC_Y": 254,
    "GAME_DATE": 20151122,
    "Season": "2015-2016",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/22/0021500200/293/1a0163ec-cdec-f22c-ff7a-497e738dd49c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/517752580720992356",
    "name": "The 2974 Collection #1264",
    "imageUrl": "https://arweave.net/i0JRrAXXB5CmL1TNhxsdRb8QQzD241p56g-cCqytxSg?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1265,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 225,
    "LOC_Y": 90,
    "GAME_DATE": 20151122,
    "Season": "2015-2016",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/22/0021500200/383/3a959284-211d-8a2d-8e62-230781be901f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501206916239266416",
    "name": "The 2974 Collection #1265",
    "imageUrl": "https://arweave.net/yjN1nR-8qjoSpdD9Q-qqTti7MmYKPDLU_AJ4UdiR0wg?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2015,
    "Month": 11,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1266,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 47,
    "GAME_DATE": 20151124,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/24/0021500214/33/4944dd8e-9f61-af59-1158-e342660234b1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493050849686276170",
    "name": "The 2974 Collection #1266",
    "imageUrl": "https://arweave.net/8240CO8Eu3ZG1R3THtomfr2jHT-2MbSLP3g4SEa_b8g?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1267,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 99,
    "LOC_Y": 239,
    "GAME_DATE": 20151124,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/24/0021500214/106/79006a50-9d8a-8b2d-b6d4-c5514461ea52_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/460708023242490839",
    "name": "The 2974 Collection #1267",
    "imageUrl": "https://arweave.net/sK-U7lN97xp_YfHPzkc8dkOrnc98qCOlzDlqsjP4xlE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1268,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 23,
    "GAME_DATE": 20151124,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/24/0021500214/279/8cc47add-af28-fcdf-d797-a40a08abc408_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297541053419140747",
    "name": "The 2974 Collection #1268",
    "imageUrl": "https://arweave.net/FTUnzeuaSjb2Hx37ENnChghSFVgJ3gejsW0fMITDlF0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1269,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 143,
    "LOC_Y": 237,
    "GAME_DATE": 20151124,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/24/0021500214/352/3deb04c4-babd-1c6b-0374-9130103efe7c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/325721859720632599",
    "name": "The 2974 Collection #1269",
    "imageUrl": "https://arweave.net/C5cOJN_xYU99R-mOiCpgUuBkp27VbVkGk_lmZvZMLgM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2015,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1270,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 7,
    "GAME_DATE": 20151127,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/27/0021500236/14/77187498-fe87-d7ba-f2e3-2fc2f5510c3f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/351534419782930908",
    "name": "The 2974 Collection #1270",
    "imageUrl": "https://arweave.net/mDafas6YPh-LJKJdnM4GXA1TeUQ5Edg6nYbFi-Ea8L4?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1271,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -117,
    "LOC_Y": 223,
    "GAME_DATE": 20151127,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/27/0021500236/52/66b432db-edad-24d4-c0f0-8e1882af45d0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482503939840847155",
    "name": "The 2974 Collection #1271",
    "imageUrl": "https://arweave.net/u-_r69itDo0qh_WFBCzEsJv5wbN2SmW22QkrbulJaII?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1272,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 204,
    "LOC_Y": 149,
    "GAME_DATE": 20151127,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/27/0021500236/80/71969a8a-f3db-5878-cc2a-a21e6f421a39_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456918572250680342",
    "name": "The 2974 Collection #1272",
    "imageUrl": "https://arweave.net/2wtEpxsnNVmiGRIf0Jx70VIB9Kt4qsbmMjTPK9vvwvo?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1273,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 174,
    "LOC_Y": 175,
    "GAME_DATE": 20151127,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/27/0021500236/110/e46420b4-3ee5-2850-f261-b3a262080499_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556650492946033678",
    "name": "The 2974 Collection #1273",
    "imageUrl": "https://arweave.net/mZx2TCU8RlzSVpmWU0jq3Y7rByjHnFM3bI2nL3zuuWM?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1274,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 182,
    "LOC_Y": 170,
    "GAME_DATE": 20151127,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/27/0021500236/119/ab3e163b-cfdf-54f1-8aa7-96078f146bd8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/304197842402038704",
    "name": "The 2974 Collection #1274",
    "imageUrl": "https://arweave.net/fDaNK76wfsnEFY-gEr4Rpj9wI4KUNdXnqHOIfC_3hck?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1275,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -138,
    "LOC_Y": 213,
    "GAME_DATE": 20151127,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/27/0021500236/195/911d311d-ed9d-a14d-0b09-4c1fecd4bc23_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/574904115775732525",
    "name": "The 2974 Collection #1275",
    "imageUrl": "https://arweave.net/8MfO3xRipBVf9pAhpk4PJCuRAkgeznGDufp4OxzqhEE?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1276,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -142,
    "LOC_Y": 229,
    "GAME_DATE": 20151127,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/27/0021500236/259/52ad4738-f506-d96a-a51e-f97330af49a6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/332017339150845104",
    "name": "The 2974 Collection #1276",
    "imageUrl": "https://arweave.net/vQsWXpPz_dlZNIDjEy5aoDkHPzrZiHqOL-l8QjgQw24?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1277,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 217,
    "LOC_Y": 110,
    "GAME_DATE": 20151127,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/27/0021500236/344/00065d8c-393c-5a70-9ca0-375ac1e626bf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/529097726622148875",
    "name": "The 2974 Collection #1277",
    "imageUrl": "https://arweave.net/k-PmJ3azyGUqk1JKgGRK1f1OqWf4Sf_K-dhbVfONX-o?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1278,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -197,
    "LOC_Y": 160,
    "GAME_DATE": 20151127,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/27/0021500236/372/093e02d0-183b-97fb-6b53-6b6a55862acb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338283153477050857",
    "name": "The 2974 Collection #1278",
    "imageUrl": "https://arweave.net/hf__m2kUvvfgAqZ46HUd1lPQ2ZrQD5ge4qFawVBA-nQ?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 11,
    "Day": 27,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1279,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -202,
    "LOC_Y": 149,
    "GAME_DATE": 20151128,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/28/0021500245/63/0c80cf81-c797-b692-1fcf-88817c0992f0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344554563141680854",
    "name": "The 2974 Collection #1279",
    "imageUrl": "https://arweave.net/7zew-BP045LqCCvxci8yU9j5h1ag8GaqBIOuqUCDmAI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1280,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 158,
    "LOC_Y": 193,
    "GAME_DATE": 20151128,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/28/0021500245/84/9e6bbe13-64f0-66aa-b6e7-e78328045fff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/447132803792656623",
    "name": "The 2974 Collection #1280",
    "imageUrl": "https://arweave.net/qJlQx-BSBJW0AQKzjlWAetvlp6bVd_ZF9b-jqC6tKSg?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1281,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 82,
    "LOC_Y": 242,
    "GAME_DATE": 20151128,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/28/0021500245/112/370c0364-3ced-28f0-5fea-4906f15e5f69_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433715485220056948",
    "name": "The 2974 Collection #1281",
    "imageUrl": "https://arweave.net/icIo2-JNrEehJnBAf5lPH5jphyvSMze52NA25MQwskk?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1282,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 212,
    "LOC_Y": 149,
    "GAME_DATE": 20151130,
    "Season": "2015-2016",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/30/0021500259/6/051b7de3-470e-d2f7-ba2b-8a623f2886aa_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459799473478045134",
    "name": "The 2974 Collection #1282",
    "imageUrl": "https://arweave.net/gIOtPWCMGOcs1DnZFeKByD7GOmNL3ldF1DGuEicjkSo?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1283,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -173,
    "LOC_Y": 178,
    "GAME_DATE": 20151130,
    "Season": "2015-2016",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/30/0021500259/356/d26cbee5-8e96-49e3-8432-fe38a27d5a6e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406185640385659858",
    "name": "The 2974 Collection #1283",
    "imageUrl": "https://arweave.net/N1SQPXKPbuEWe3i9fVxfOmahj2EYqIdUWIIO_r-_Ghc?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1284,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 119,
    "LOC_Y": 208,
    "GAME_DATE": 20151130,
    "Season": "2015-2016",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/30/0021500259/434/4137fce1-8cef-e04f-2415-f74b6ed343b6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444525350061408229",
    "name": "The 2974 Collection #1284",
    "imageUrl": "https://arweave.net/AK8T2HpmpjwIFOYYyVai4AOaeoRhlc0iGG2NBCpaID0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1285,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -205,
    "LOC_Y": 165,
    "GAME_DATE": 20151130,
    "Season": "2015-2016",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/11/30/0021500259/483/33bfcd0b-7a0d-b702-eb00-883621c0a640_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323742832730218475",
    "name": "The 2974 Collection #1285",
    "imageUrl": "https://arweave.net/7sShU0X7RZRS_ZoB2le1q5XS9aPNkgyowlEOqcyuEME?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1286,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 218,
    "LOC_Y": 116,
    "GAME_DATE": 20151202,
    "Season": "2015-2016",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/02/0021500268/61/60955629-5b43-c8c7-9751-4c56694d22a1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/398664933495907102",
    "name": "The 2974 Collection #1286",
    "imageUrl": "https://arweave.net/I6h7l6Q85iGXwNkOev1N8trpesQy6_46J1xX2ZMCjXE?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2015,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1287,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 19,
    "LOC_Y": 301,
    "GAME_DATE": 20151202,
    "Season": "2015-2016",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/02/0021500268/63/ca5e4870-26a4-586c-9036-55bca8565b7a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/532774533457348774",
    "name": "The 2974 Collection #1287",
    "imageUrl": "https://arweave.net/b1jEhTcnCYepza-dj0xkeD8f5prrEdCrpg9ACNHOm4w?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2015,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1288,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 18,
    "GAME_DATE": 20151202,
    "Season": "2015-2016",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/02/0021500268/236/9725bb03-6239-c7c8-c47f-c026a198f0c2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/454619779133660092",
    "name": "The 2974 Collection #1288",
    "imageUrl": "https://arweave.net/NzgjQRuXbd0bak6B4QLjtXB1iMVJzx9VYrkzfiST4WU?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2015,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1289,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 16,
    "GAME_DATE": 20151202,
    "Season": "2015-2016",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/02/0021500268/329/6f171f8f-11d8-19ae-e426-b30b37afca2c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/492144268193600515",
    "name": "The 2974 Collection #1289",
    "imageUrl": "https://arweave.net/Jf8GnCuFI_XzounJh48tYQEH-MSha7zhOZnRG9JFSwk?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2015,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1290,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -63,
    "LOC_Y": 242,
    "GAME_DATE": 20151202,
    "Season": "2015-2016",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/02/0021500268/358/24312de0-8c6e-1487-d684-25044b1e8609_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465060980921568735",
    "name": "The 2974 Collection #1290",
    "imageUrl": "https://arweave.net/jrHHHQCFU6d20l-nBL12CRCNAvnRVbzKlR-mDJoFFQw?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2015,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1291,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 143,
    "LOC_Y": 262,
    "GAME_DATE": 20151202,
    "Season": "2015-2016",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/02/0021500268/360/ca959554-b5d5-162c-c7ca-ba58875a3448_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/517201917516505906",
    "name": "The 2974 Collection #1291",
    "imageUrl": "https://arweave.net/XKojYjyAMWcci5XhEQo7AHmVCZlSGNVWNq7mGIiVXbc?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2015,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1292,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -101,
    "LOC_Y": 267,
    "GAME_DATE": 20151202,
    "Season": "2015-2016",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/02/0021500268/364/c363568d-a27b-1dad-4a5a-057b7ef5f190_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546127365233148507",
    "name": "The 2974 Collection #1292",
    "imageUrl": "https://arweave.net/PF6yoLE8Mb1m49jiP47R4Q-CxFi3EzzUXev14HV1FDI?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2015,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1293,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 158,
    "LOC_Y": 257,
    "GAME_DATE": 20151202,
    "Season": "2015-2016",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/02/0021500268/368/401e664f-2fc9-0fc4-a710-b7046966eb90_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510445012160472804",
    "name": "The 2974 Collection #1293",
    "imageUrl": "https://arweave.net/iU--v-PsyPnL_dId_1voRp-Dmsf0KLddOqgdtx2EIAg?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2015,
    "Month": 12,
    "Day": 2,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1294,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 153,
    "LOC_Y": 190,
    "GAME_DATE": 20151205,
    "Season": "2015-2016",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/05/0021500290/14/1c62486c-1085-d576-0f8d-adfdc5a963b0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392857347713311023",
    "name": "The 2974 Collection #1294",
    "imageUrl": "https://arweave.net/7XFk7kosuMb83ufWUcopj2A9R_zfeQb3IjnDbrazESc?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1295,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 4,
    "LOC_Y": 242,
    "GAME_DATE": 20151205,
    "Season": "2015-2016",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/05/0021500290/25/fc7e755e-03f6-6aea-80d1-db3ca38a9de7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429802187039557031",
    "name": "The 2974 Collection #1295",
    "imageUrl": "https://arweave.net/HXkh242JyX9ehqTwTHNgUiwtU7or9asuhZW7-kcY8oc?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1296,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": 26,
    "GAME_DATE": 20151205,
    "Season": "2015-2016",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/05/0021500290/28/1d201708-e170-d8a2-ae58-0a205b2863b3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541008615754396670",
    "name": "The 2974 Collection #1296",
    "imageUrl": "https://arweave.net/ihdxoZNeVSu11g7dXT7RolJNyLAZWEiPydvLoSHGCYE?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1297,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 50,
    "LOC_Y": 242,
    "GAME_DATE": 20151205,
    "Season": "2015-2016",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/05/0021500290/43/2ea55e07-ff05-8a4b-29ff-a31d0f5ae905_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513829321088447004",
    "name": "The 2974 Collection #1297",
    "imageUrl": "https://arweave.net/24M_HHkmVrSOYBt4enMr1vdJzP3omPXrz8WTBQjpUow?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1298,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -215,
    "LOC_Y": 115,
    "GAME_DATE": 20151205,
    "Season": "2015-2016",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/05/0021500290/230/a03f587f-d152-ed32-8904-a3eaa108838a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/389731729867655771",
    "name": "The 2974 Collection #1298",
    "imageUrl": "https://arweave.net/NhROMlLrZBK7M-tCRhOay0KHODQuOmh6SmidUghSf6M?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1299,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -238,
    "LOC_Y": 8,
    "GAME_DATE": 20151205,
    "Season": "2015-2016",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/05/0021500290/387/8a66ac66-d710-db1e-bf07-cddb4ce0b3c7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468799227288822729",
    "name": "The 2974 Collection #1299",
    "imageUrl": "https://arweave.net/RFgMhkzNIOI_O6u9gJU8re1ct3RmmxanX2em3O7Uz_U?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1300,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 176,
    "LOC_Y": 180,
    "GAME_DATE": 20151205,
    "Season": "2015-2016",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/05/0021500290/452/d7ec5192-da43-06d3-2578-73fa8a47b858_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382912507582843176",
    "name": "The 2974 Collection #1300",
    "imageUrl": "https://arweave.net/iBWwVD_pJz0dg71BOvmQVPzuBm6DH3C16RKfCnzLdRI?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1301,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 4,
    "LOC_Y": 252,
    "GAME_DATE": 20151205,
    "Season": "2015-2016",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/05/0021500290/499/a3964b19-7365-2ec2-459f-7dd546355bee_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/532217626129906765",
    "name": "The 2974 Collection #1301",
    "imageUrl": "https://arweave.net/WW2fRw6edgWAW0ihL9Tzna-FCfb5MRdNr9e2U2TWyY0?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1302,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 2,
    "LOC_Y": 249,
    "GAME_DATE": 20151205,
    "Season": "2015-2016",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/05/0021500290/511/b85dc204-9a0d-fa2f-9d29-3bac7f59bd24_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/471928891771733649",
    "name": "The 2974 Collection #1302",
    "imageUrl": "https://arweave.net/tIsXs4HaTG3hYH-JzBqME-g-JroXYAegXzyoD5TyP-c?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2015,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1303,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -232,
    "LOC_Y": 95,
    "GAME_DATE": 20151206,
    "Season": "2015-2016",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/06/0021500300/41/39eb622b-e0ad-77c0-3da0-b8f8cbe5ea29_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/560040732195847327",
    "name": "The 2974 Collection #1303",
    "imageUrl": "https://arweave.net/8C2zOyltIDAu4lkAXwC2y78PI5JuizwpInmXOQthYOI?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1304,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -106,
    "LOC_Y": 269,
    "GAME_DATE": 20151206,
    "Season": "2015-2016",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/06/0021500300/255/7d851f7a-b5cc-588a-1204-6e99c746e846_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/315784869755048275",
    "name": "The 2974 Collection #1304",
    "imageUrl": "https://arweave.net/P7CVnf_HtLZMlF3Q3hxJWpK4N-g2H5cLmy24G3SMesg?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1305,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": 31,
    "GAME_DATE": 20151206,
    "Season": "2015-2016",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/06/0021500300/366/a73fc9b6-d240-6e9c-9fc9-13cb33841aab_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/394592358836304779",
    "name": "The 2974 Collection #1305",
    "imageUrl": "https://arweave.net/gX2yj1cIypCDVK4rtTixKLm9SuzYOBmUexWqYLhLpJc?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1306,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 173,
    "LOC_Y": 213,
    "GAME_DATE": 20151206,
    "Season": "2015-2016",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/06/0021500300/392/e05bc508-613b-bbef-a173-9fc5139c87d7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522669340646535954",
    "name": "The 2974 Collection #1306",
    "imageUrl": "https://arweave.net/NsMNeYPMqqAZTAQoRzHLKHAs0jzRLISR3WI_ovd-tQU?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1307,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -207,
    "LOC_Y": 129,
    "GAME_DATE": 20151206,
    "Season": "2015-2016",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/06/0021500300/413/d62e90a8-8cc8-4070-84df-2bfbde0e24ee_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395074631192589333",
    "name": "The 2974 Collection #1307",
    "imageUrl": "https://arweave.net/YigVrLjjVvqhuFJrGy7piRDdHnE1MtxX4rai-RZsqEM?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2015,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1308,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 187,
    "LOC_Y": 188,
    "GAME_DATE": 20151208,
    "Season": "2015-2016",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/08/0021500314/100/f3a53914-6ac7-6482-06f4-386b853424f5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565309507630924168",
    "name": "The 2974 Collection #1308",
    "imageUrl": "https://arweave.net/8zrqWkntUHgzJIrPmUJ25SmVxi6I7AAhxEQH569AX78?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2015,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1309,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -187,
    "LOC_Y": 193,
    "GAME_DATE": 20151208,
    "Season": "2015-2016",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/08/0021500314/112/f74b32af-5440-7302-0d29-4cde90968b7c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/471841940903217260",
    "name": "The 2974 Collection #1309",
    "imageUrl": "https://arweave.net/XgqXACI8F8Rb2dhqvIiSKqqJu__rz8QpQchtSZEx_QA?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2015,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1310,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 218,
    "LOC_Y": 120,
    "GAME_DATE": 20151208,
    "Season": "2015-2016",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/08/0021500314/238/001c6e24-edb5-7e77-9457-8ddc783155b2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465181989560576104",
    "name": "The 2974 Collection #1310",
    "imageUrl": "https://arweave.net/hGzXw9iaL7oXXgWTOqKcOdTKWqdxH3aUWk6MRUTsKag?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2015,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1311,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 140,
    "LOC_Y": 223,
    "GAME_DATE": 20151211,
    "Season": "2015-2016",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/11/0021500336/23/5a5de21c-a92f-d5f5-d967-64b2638afa54_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440717025594913961",
    "name": "The 2974 Collection #1311",
    "imageUrl": "https://arweave.net/d5CrZ6dfRhN5Dccz-1SbM5SVQVcZIg_U2eyeT3r6zm4?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game (24-0 Team Record)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1312,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -196,
    "LOC_Y": 149,
    "GAME_DATE": 20151211,
    "Season": "2015-2016",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/11/0021500336/201/8e5e7c59-48bd-2c9e-b953-5ba8431c2215_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/534042576042300910",
    "name": "The 2974 Collection #1312",
    "imageUrl": "https://arweave.net/tS5Z3K0dBnDNw3GsTDN3fzxykVwzX_h3y60tK2tLEqM?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game (24-0 Team Record)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1313,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 182,
    "LOC_Y": 228,
    "GAME_DATE": 20151211,
    "Season": "2015-2016",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/11/0021500336/207/fac9e4dd-a24b-0dc8-9e6c-de887650be92_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508291230502936255",
    "name": "The 2974 Collection #1313",
    "imageUrl": "https://arweave.net/GfMzvUl6_ZGdxGz0I4B3WZ7jfPTXv8-BgcovF_86Uxo?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game (24-0 Team Record)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1314,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 20,
    "LOC_Y": 247,
    "GAME_DATE": 20151211,
    "Season": "2015-2016",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/11/0021500336/292/4ef7401f-26a5-056f-02fa-a2a46b78a24e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450727717228207442",
    "name": "The 2974 Collection #1314",
    "imageUrl": "https://arweave.net/Rf85FEIvkYD_by1J6xxClRTqDMWdBw36jfWK-BPkhOw?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game (24-0 Team Record)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1315,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 42,
    "LOC_Y": 247,
    "GAME_DATE": 20151211,
    "Season": "2015-2016",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/11/0021500336/499/55503074-10e1-55bd-edc8-827461d9fc3f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551853347523674909",
    "name": "The 2974 Collection #1315",
    "imageUrl": "https://arweave.net/Por7xnIIWit28Repg38a_5m08nlG-Sg0pv0k-ut5xmc?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game (24-0 Team Record)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1316,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -24,
    "LOC_Y": 288,
    "GAME_DATE": 20151211,
    "Season": "2015-2016",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/11/0021500336/560/615dfd9c-9053-d5d4-2bf0-6fdc3a7d507d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/311398946021133293",
    "name": "The 2974 Collection #1316",
    "imageUrl": "https://arweave.net/AtEEKQ1QOO0TZ8elHZJfNWa3eQ69BXMLQY-7EYUNZkE?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2015,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game (24-0 Team Record)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1317,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 222,
    "LOC_Y": -11,
    "GAME_DATE": 20151212,
    "Season": "2015-2016",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/12/0021500351/64/81d0770e-90e1-3dc6-630f-2432a9ccc70f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480219989068676359",
    "name": "The 2974 Collection #1317",
    "imageUrl": "https://arweave.net/PRQJsK9JYDadKpbTlBx2lKGN8mycyU0WR9fC0duy9Vs?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 12,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1318,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 153,
    "LOC_Y": 214,
    "GAME_DATE": 20151212,
    "Season": "2015-2016",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/12/0021500351/506/50136b8c-1d9c-886e-fde0-fac296b74876_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515159358100509290",
    "name": "The 2974 Collection #1318",
    "imageUrl": "https://arweave.net/7lwDVBgIBkK5naedYJU-2FxlAChKBnvt5DznbCrIOXM?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 12,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1319,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -92,
    "LOC_Y": 237,
    "GAME_DATE": 20151216,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/16/0021500381/209/9c335c94-59bb-2dfa-b66a-49a6513f59b1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438947079589665839",
    "name": "The 2974 Collection #1319",
    "imageUrl": "https://arweave.net/eDyIaX6Tn7DILhuPh0CDuahMsabsofppbb0H3Ep7FRA?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 12,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1320,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 153,
    "LOC_Y": 208,
    "GAME_DATE": 20151216,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/16/0021500381/217/c0dbca51-dd64-f320-845c-1bbbccf3c308_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536192513203038520",
    "name": "The 2974 Collection #1320",
    "imageUrl": "https://arweave.net/gtje7hLFPDz3PvJV1CtpX-KWHfVn7VGL2UT1gE5q0rQ?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2015,
    "Month": 12,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1321,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 148,
    "LOC_Y": 190,
    "GAME_DATE": 20151218,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/18/0021500397/6/4cdeabe1-f859-ea3c-c23d-17c21022427b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550556853118489889",
    "name": "The 2974 Collection #1321",
    "imageUrl": "https://arweave.net/oqN5oOIO5GxHd9MnVQzInO0h46lXwC1MYUdqf7F4o94?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1322,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -194,
    "LOC_Y": 175,
    "GAME_DATE": 20151218,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/18/0021500397/76/f33a72c8-b9de-6750-9930-6ab402fbee33_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465118823039137492",
    "name": "The 2974 Collection #1322",
    "imageUrl": "https://arweave.net/jjcCuSs6LIkrRSd2YKvWbef7iNecce1cF_j2s18AzIE?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2015,
    "Month": 12,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1323,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 46,
    "LOC_Y": 244,
    "GAME_DATE": 20151223,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/23/0021500434/8/4114a9dd-7882-ad7c-1bcc-bb4f9fc6c6a8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348060746878860053",
    "name": "The 2974 Collection #1323",
    "imageUrl": "https://arweave.net/am0T6_lVSG49YkH9bmU7bYi-Cy6IN7lV60uoiVtiGmU?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1324,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -238,
    "LOC_Y": 43,
    "GAME_DATE": 20151223,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/23/0021500434/402/4ce83f2e-2e28-3de7-d830-d4c8679a85dc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299059078014687219",
    "name": "The 2974 Collection #1324",
    "imageUrl": "https://arweave.net/Wq8K5HPJiHtumuduyYVbTYs5fF84JWWS3vQNbP9YCKY?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2015,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1325,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -204,
    "LOC_Y": 213,
    "GAME_DATE": 20151225,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/25/0021500438/102/54745719-c5f4-f51c-fda1-fa54e22f8597_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510083692261512322",
    "name": "The 2974 Collection #1325",
    "imageUrl": "https://arweave.net/_RCxSuYSq-WRX3HPAh-L9OCmUEaC3_d5R7iowsOUXlE?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2015,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 1,
    "Special Moment": "Christmas",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1326,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -197,
    "LOC_Y": 169,
    "GAME_DATE": 20151228,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/28/0021500468/264/56ddd31e-e894-f8ad-edfb-9963a3b6346f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485014707741740708",
    "name": "The 2974 Collection #1326",
    "imageUrl": "https://arweave.net/tnDlqGkQC8yGLlLZNn6HOQk0FI1vynFKDxqRAk7bYEA?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Triple-Double",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1327,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -225,
    "LOC_Y": -1,
    "GAME_DATE": 20151228,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/28/0021500468/271/82662d35-26b5-7ed5-4440-1a90f2a45c9f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/560756903574877465",
    "name": "The 2974 Collection #1327",
    "imageUrl": "https://arweave.net/6UIgD4e3EbbYS8-75athnKYyeOpy_nrEGrR-WtbBNg8?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Triple-Double",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1328,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -55,
    "LOC_Y": 262,
    "GAME_DATE": 20151228,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/28/0021500468/282/3c400350-5a8a-b917-1180-0bfd60ec55c9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360317763894478827",
    "name": "The 2974 Collection #1328",
    "imageUrl": "https://arweave.net/iM7Jy0Irv7FKOuCqH0D95mm9147ulV9VSAfGmTI4FOo?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Triple-Double",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1329,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -22,
    "LOC_Y": 277,
    "GAME_DATE": 20151228,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/28/0021500468/284/9c3fcdfd-cafe-1380-0fe9-0eede6b2a829_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428241328693956883",
    "name": "The 2974 Collection #1329",
    "imageUrl": "https://arweave.net/gumJyl4QWKJKDumvpupyQUTVDN_3TNknbDdpTperw30?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1330,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -117,
    "LOC_Y": 257,
    "GAME_DATE": 20151228,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/28/0021500468/292/28399a95-8446-7c9a-ba2c-42147ae7099d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390104702289390090",
    "name": "The 2974 Collection #1330",
    "imageUrl": "https://arweave.net/6RWYenHJJwmqhUFSBG1K8aRQga5E_L87yE0Va19_AYs?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Triple-Double",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1331,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -142,
    "LOC_Y": 223,
    "GAME_DATE": 20151228,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2015/12/28/0021500468/432/2b66ea11-cd45-4ef9-e203-d55026fc9167_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482137877574013697",
    "name": "The 2974 Collection #1331",
    "imageUrl": "https://arweave.net/YsY5c90zsmYnAPuHt3psxJb599pHn1oyD7hBqaQT0Z4?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2015,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Triple-Double",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1332,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -176,
    "LOC_Y": 213,
    "GAME_DATE": 20160102,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/02/0021500504/208/facbdc3b-cd84-8e90-268d-157d0e3db418_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468496053402533482",
    "name": "The 2974 Collection #1332",
    "imageUrl": "https://arweave.net/a6e70Qdbx1tR_mRtw0KVhPWRE3byHim8GHTws9YArKU?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1333,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -186,
    "LOC_Y": 180,
    "GAME_DATE": 20160104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/04/0021500520/4/cb00627a-80a6-302e-ae43-9787bc7b8c59_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547650856287418998",
    "name": "The 2974 Collection #1333",
    "imageUrl": "https://arweave.net/R3FXYXIlNSAHiid9US-LmGGZuZqzl-Vt40bVVxiYURc?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2016,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1334,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 19,
    "LOC_Y": 272,
    "GAME_DATE": 20160104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/04/0021500520/157/97f4b3ac-209a-df8f-396c-a5f6facfaece_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/454556599304321742",
    "name": "The 2974 Collection #1334",
    "imageUrl": "https://arweave.net/RIywP6i3sjN_-qUlakO6p3vKgUtURNFVcnGoLz5eDKw?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2016,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1335,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 158,
    "LOC_Y": 213,
    "GAME_DATE": 20160104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/04/0021500520/268/5b429cc7-f661-ce9a-16df-7c8ab918ffeb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/405169409454131230",
    "name": "The 2974 Collection #1335",
    "imageUrl": "https://arweave.net/intoTAvql_dVJJ5hU4KmKewD-7R7I0hP-VQUiTWihuE?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2016,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1336,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 204,
    "LOC_Y": 139,
    "GAME_DATE": 20160104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/04/0021500520/281/43982348-2d91-de6a-1a7d-672e175c6675_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498289131585124655",
    "name": "The 2974 Collection #1336",
    "imageUrl": "https://arweave.net/aGrAUXLkMKZ6xT38Rn_MkyCDqPVqgNBSQ8CtOQ69mU4?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2016,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1337,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 12,
    "LOC_Y": 257,
    "GAME_DATE": 20160104,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/04/0021500520/393/8dbdd201-0407-669c-1d70-0e38715b1ad1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575014651235975401",
    "name": "The 2974 Collection #1337",
    "imageUrl": "https://arweave.net/4yQJWiHbddxEbtgAI2kGqarQMeh7ux4SQOeh5VNDobQ?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2016,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1338,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -230,
    "LOC_Y": 38,
    "GAME_DATE": 20160105,
    "Season": "2015-2016",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/05/0021500524/92/e58a062a-fb9f-3332-376a-fc5dbfc70d09_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/530599713256388963",
    "name": "The 2974 Collection #1338",
    "imageUrl": "https://arweave.net/0ypVg-brbDj3b0AYz5490Qp4qWH-Gd_A67D7l3Gta9o?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1339,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -194,
    "LOC_Y": 178,
    "GAME_DATE": 20160105,
    "Season": "2015-2016",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/05/0021500524/190/393e3f2c-97e2-ff4a-35e8-1cc707b6c456_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321154807443469733",
    "name": "The 2974 Collection #1339",
    "imageUrl": "https://arweave.net/TRoK_U5gpzQeUQtVeyHEkifUkYHq2PycdxyVR8hqraI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1340,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 141,
    "LOC_Y": 214,
    "GAME_DATE": 20160105,
    "Season": "2015-2016",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/05/0021500524/263/567bd24b-48f3-6c59-1313-dd77d553b509_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540495488182285373",
    "name": "The 2974 Collection #1340",
    "imageUrl": "https://arweave.net/1L6UtA0i1v_1OZL9Tjh0y9KuNZeYVhDY0v24dqYQeHA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1341,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": -21,
    "GAME_DATE": 20160105,
    "Season": "2015-2016",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/05/0021500524/348/8b44f7a6-a14b-f64c-a3b7-890d653668d2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458406854940272897",
    "name": "The 2974 Collection #1341",
    "imageUrl": "https://arweave.net/qC7EUHXxzoeOkazVWN2lmYd0RJzDV_X-5TuBBwTlGV0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1342,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 227,
    "LOC_Y": 8,
    "GAME_DATE": 20160108,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/08/0021500548/9/cc05d003-d224-53e9-8ccb-c561b955070b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/507908400780956843",
    "name": "The 2974 Collection #1342",
    "imageUrl": "https://arweave.net/mUnACiWUuKD-QgbL4Xohg3lxFiMqAJ4hCqvRcfI-azs?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1343,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 12,
    "LOC_Y": 242,
    "GAME_DATE": 20160108,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/08/0021500548/383/f373d849-c34c-0b01-d15d-b203bec56b2c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465063326671046015",
    "name": "The 2974 Collection #1343",
    "imageUrl": "https://arweave.net/LAxtamvvCSoztGetCAC4kfAG2tpgZZM0lPKZ1NtZ-NQ?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1344,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 120,
    "LOC_Y": 213,
    "GAME_DATE": 20160108,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/08/0021500548/393/ba327b0f-94ba-88b8-64b0-388485d90a29_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/342966937678952831",
    "name": "The 2974 Collection #1344",
    "imageUrl": "https://arweave.net/OV90B7ZD3hlMQLpcEXeBsX6kKGA46TWNx9TjYsH8wTc?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1345,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -187,
    "LOC_Y": 214,
    "GAME_DATE": 20160108,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/08/0021500548/414/fe40b689-ddc6-0e0f-1eea-948ffa587f33_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346624546928619882",
    "name": "The 2974 Collection #1345",
    "imageUrl": "https://arweave.net/W0_h7bY7OuA5vZV-guQKVuNS_A4Pc1yvJAWgysuisw4?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1346,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": 16,
    "GAME_DATE": 20160109,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/09/0021500556/27/a2e5292e-9386-5625-dd63-1c0a37f7e723_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381158598023129373",
    "name": "The 2974 Collection #1346",
    "imageUrl": "https://arweave.net/8FCd2neg3HVvcHzgyBoX4eiX9YPHYOausNDjo85K_vo?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2016,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1347,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -176,
    "LOC_Y": 169,
    "GAME_DATE": 20160109,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/09/0021500556/185/c299c311-716d-007d-7137-c3a01295ff21_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497042847496437301",
    "name": "The 2974 Collection #1347",
    "imageUrl": "https://arweave.net/AtGLRAFBy0vnjRLk0EdYlxLKRjAneWkN81wD5HFgbes?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2016,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1348,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 46,
    "LOC_Y": 278,
    "GAME_DATE": 20160109,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/09/0021500556/254/22dd50dc-808e-9bea-43ff-8dc91071bf3a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385355348586313146",
    "name": "The 2974 Collection #1348",
    "imageUrl": "https://arweave.net/v8qk2CeAedWfqz_9uLXSUuUWE19GzgAnPZ7WixuXaOk?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2016,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1349,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -148,
    "LOC_Y": 228,
    "GAME_DATE": 20160109,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/09/0021500556/259/b4af7fff-660c-c3e9-6138-7b28c9ae6e0d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/396292888330680366",
    "name": "The 2974 Collection #1349",
    "imageUrl": "https://arweave.net/rP4AJWP-injpKU2S6DVojRhK250lXoZacmrUZiSRvTs?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2016,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1350,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -225,
    "LOC_Y": 120,
    "GAME_DATE": 20160109,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/09/0021500556/388/7674b4c9-a18b-fcf9-9f16-ea80d4d38e8e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300703002171733408",
    "name": "The 2974 Collection #1350",
    "imageUrl": "https://arweave.net/BMxxxaH_7K031TJ5hgBvFWHjtz_K7VLhDT-OfOV6qj8?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2016,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1351,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 189,
    "LOC_Y": 174,
    "GAME_DATE": 20160109,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/09/0021500556/492/142c9033-7ff7-0c00-932c-7e8a807f7558_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464018502208608212",
    "name": "The 2974 Collection #1351",
    "imageUrl": "https://arweave.net/zJil-fUc22yAUFYtLMVairu3cUET7S_9UD9sUSNtgSk?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2016,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1352,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 16,
    "GAME_DATE": 20160109,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/09/0021500556/509/e5483b30-bcc9-4350-b86d-154d5869c1fa_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558081159788478871",
    "name": "The 2974 Collection #1352",
    "imageUrl": "https://arweave.net/gbbWxEndCX0QjcN3nSatm6wQrnAoS3Kei2Qf6NXuZS4?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2016,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1353,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -205,
    "LOC_Y": 169,
    "GAME_DATE": 20160109,
    "Season": "2015-2016",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/09/0021500556/550/a391faf3-0f0a-64e3-a59b-0b5f84ac1778_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363425134256034686",
    "name": "The 2974 Collection #1353",
    "imageUrl": "https://arweave.net/OLnoM6YjR35J1kzYYyiFrR1WX8gvFkpNS9DsWkG9UZA?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2016,
    "Month": 1,
    "Day": 9,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1354,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 11,
    "GAME_DATE": 20160111,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/11/0021500568/20/f1b5fee6-8c87-6b71-72be-16f76e7303f5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362431600752902158",
    "name": "The 2974 Collection #1354",
    "imageUrl": "https://arweave.net/YUj81fAOprxYHauoC11S6SUU2O6-WGCR9wGVmqY36HA?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1355,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -202,
    "LOC_Y": 188,
    "GAME_DATE": 20160111,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/11/0021500568/249/25191a05-1275-677c-e5ae-545a1ae7cc92_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536845035077686349",
    "name": "The 2974 Collection #1355",
    "imageUrl": "https://arweave.net/GhYtuUrAAaIXu05EcugADiquVjLx1XGh92TLRLmfe6Y?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1356,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -140,
    "LOC_Y": 218,
    "GAME_DATE": 20160111,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/11/0021500568/463/da527b1e-ce25-5d13-0586-e0d653949a5f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/345920790923491218",
    "name": "The 2974 Collection #1356",
    "imageUrl": "https://arweave.net/k1O_iyHMY2hhys7zMrt6X4d5_md20VBpcU7B7jLtRhU?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1357,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -117,
    "LOC_Y": 232,
    "GAME_DATE": 20160111,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/11/0021500568/506/0c38e5f9-f8dd-9a0f-5d19-39c6c0a119ab_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420033496202422730",
    "name": "The 2974 Collection #1357",
    "imageUrl": "https://arweave.net/dYY94T-_oZrepB7ze3VjIcEmtzURgNs9wnc6lzgmW1M?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1358,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 143,
    "LOC_Y": 208,
    "GAME_DATE": 20160113,
    "Season": "2015-2016",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/13/0021500583/42/77c7b5aa-a434-6154-617d-f09df4bbdf8f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308598486224983715",
    "name": "The 2974 Collection #1358",
    "imageUrl": "https://arweave.net/tS0M7fQJPxBDTs1bsSRVKbp-EC3eb3xij3GFtFo-yRQ?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1359,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 164,
    "LOC_Y": 210,
    "GAME_DATE": 20160113,
    "Season": "2015-2016",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/13/0021500583/278/abbb2d26-afb7-9f50-7582-375106f3d793_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/342027712234807143",
    "name": "The 2974 Collection #1359",
    "imageUrl": "https://arweave.net/9DN4fhFAsDhCUqIyZUJ24-UDWG6EeJYfxoDQ9zTm-tY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1360,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -196,
    "LOC_Y": 198,
    "GAME_DATE": 20160113,
    "Season": "2015-2016",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/13/0021500583/512/d9d9a31d-baa2-970f-ffd4-16cf77d0ae91_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531610165258495450",
    "name": "The 2974 Collection #1360",
    "imageUrl": "https://arweave.net/3ndAITul4Ur-NvZTHurcXybZ4tSAo-nn3TQYT2u4-G4?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1361,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 150,
    "LOC_Y": 190,
    "GAME_DATE": 20160113,
    "Season": "2015-2016",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/13/0021500583/545/423f5cd5-62fb-c718-1929-84178dd84c09_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412650234644795599",
    "name": "The 2974 Collection #1361",
    "imageUrl": "https://arweave.net/p_NliNN3LxyoQIOhQ_1DKWQyHUhDklAUWPkvq9LyuBU?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1362,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": -138,
    "LOC_Y": 303,
    "GAME_DATE": 20160113,
    "Season": "2015-2016",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/13/0021500583/556/0e7c09f1-fc96-6b8b-81b4-562b09711fde_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521679280261231167",
    "name": "The 2974 Collection #1362",
    "imageUrl": "https://arweave.net/oSyrGS4ENUZ2sKckt4BDst6o_Cdcb6ZAblTi1vU3L2I?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1363,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -7,
    "LOC_Y": 259,
    "GAME_DATE": 20160114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/14/0021500592/35/b887f6f6-be33-141b-2726-8382e5faaa94_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/329917403546127425",
    "name": "The 2974 Collection #1363",
    "imageUrl": "https://arweave.net/bhcAzr0QIM1cRbzQ7JikbWgPgnsu18FsGfMkk320iIY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1364,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 43,
    "LOC_Y": 267,
    "GAME_DATE": 20160114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/14/0021500592/51/1a2c4c3e-742b-96c1-cbe9-5db30759b682_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508677065677316229",
    "name": "The 2974 Collection #1364",
    "imageUrl": "https://arweave.net/HqpT69i85PZMycA3n5c-nZrpDezCHrkX4jxXSQ31sm4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1365,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -187,
    "LOC_Y": 190,
    "GAME_DATE": 20160114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/14/0021500592/65/ad30aa5e-fad8-3954-a1e9-d5c96cd9feac_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/325479996865638492",
    "name": "The 2974 Collection #1365",
    "imageUrl": "https://arweave.net/D5-YpIWmJyos3dJ69tHxGun-tLRvBAsgNLjtVABGwiM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1366,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -215,
    "LOC_Y": 159,
    "GAME_DATE": 20160114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/14/0021500592/221/48d648fa-840b-6668-0851-a0e72e27a874_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572417588776255498",
    "name": "The 2974 Collection #1366",
    "imageUrl": "https://arweave.net/girH9q8FJ0rM8gQN0k0FtiX0mfWbKvP_9lpglROth-A?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1367,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -99,
    "LOC_Y": 242,
    "GAME_DATE": 20160114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/14/0021500592/265/89da8471-0234-35a5-9075-85b66d125dcf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547840693227516661",
    "name": "The 2974 Collection #1367",
    "imageUrl": "https://arweave.net/uickO-KfSXwPVr6yoySc7FGfwI-YSuOkYQG0HOCBK_U?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1368,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 197,
    "LOC_Y": 144,
    "GAME_DATE": 20160114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361448410273094649",
    "name": "The 2974 Collection #1368",
    "imageUrl": "https://arweave.net/t1uFvs9XIE86U6-Z7n38Qnn1-B2SSkdZlEOZXhGTioc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1369,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 145,
    "LOC_Y": 223,
    "GAME_DATE": 20160114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/14/0021500592/345/67c913d0-2f23-3e84-7a1e-08e204ac4f6e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/509430561728122553",
    "name": "The 2974 Collection #1369",
    "imageUrl": "https://arweave.net/fGjYS4XyFiPdjktyRyNNGBqXUlW-R3EXA1RUmHcdCQw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1370,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -238,
    "LOC_Y": 56,
    "GAME_DATE": 20160114,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/14/0021500592/354/fff72152-75ad-a31e-fac2-d38fbfb73c6a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338843592411213048",
    "name": "The 2974 Collection #1370",
    "imageUrl": "https://arweave.net/mmNH9cNSoYMvWMTdB-LSByS0h7d_0xNUboZQ_XXIqLs?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1371,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -97,
    "LOC_Y": 282,
    "GAME_DATE": 20160116,
    "Season": "2015-2016",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/16/0021500605/81/98bd225e-7d39-0e4c-88a8-1af26018d796_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/505450636571372199",
    "name": "The 2974 Collection #1371",
    "imageUrl": "https://arweave.net/_yVXNFAM1HhdKE4oxQOrECV8n7yhwW1dXqU02dpDMiM?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1372,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -163,
    "LOC_Y": 213,
    "GAME_DATE": 20160116,
    "Season": "2015-2016",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/16/0021500605/105/86b79f32-b8d5-c04f-5054-4320b300e6bc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374181642993578107",
    "name": "The 2974 Collection #1372",
    "imageUrl": "https://arweave.net/XF1DzmMz5SBtao7NoBPHViGesg3VOBxcdvzbUkSq_RY?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1373,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 213,
    "LOC_Y": 141,
    "GAME_DATE": 20160116,
    "Season": "2015-2016",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/16/0021500605/318/3803630b-a0a9-3792-22ce-bb6f51427fda_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450089823954156923",
    "name": "The 2974 Collection #1373",
    "imageUrl": "https://arweave.net/-2PTX9QM3WxFeg60L87U2W3a3G5SdSqdvih_tCOmaF0?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1374,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -151,
    "LOC_Y": 213,
    "GAME_DATE": 20160116,
    "Season": "2015-2016",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/16/0021500605/334/c5780a96-3c94-4a73-889f-d11a7d09b40a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307984108395734644",
    "name": "The 2974 Collection #1374",
    "imageUrl": "https://arweave.net/_uOi_fkaWUMUmBVtmJZmuZbgh6INpQA19QtUdP44Z0o?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1375,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -114,
    "LOC_Y": 234,
    "GAME_DATE": 20160116,
    "Season": "2015-2016",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/16/0021500605/361/d22fc8a2-c062-646c-ab1e-9eb8e9549009_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428848907276222453",
    "name": "The 2974 Collection #1375",
    "imageUrl": "https://arweave.net/zLoww6URCH0-bN9cLz7wD80EHx_Z0ZTgjrp487RDXkI?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1376,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 125,
    "LOC_Y": 234,
    "GAME_DATE": 20160116,
    "Season": "2015-2016",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/16/0021500605/389/6bebbe3c-c9bd-7071-5034-e6341ad70b2c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/463272815601398278",
    "name": "The 2974 Collection #1376",
    "imageUrl": "https://arweave.net/bStw4m0f83hEiOPGeEWoMUFxpnU31e43JEt1MQY46mY?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1377,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 94,
    "LOC_Y": 252,
    "GAME_DATE": 20160116,
    "Season": "2015-2016",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/16/0021500605/483/39d862a8-a56d-35e5-6490-aa7f7ff17aa6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575046084954746202",
    "name": "The 2974 Collection #1377",
    "imageUrl": "https://arweave.net/A9ZBen0RDSJPNM5cdj1gTf03gBgGs_LM5jEbRBwrWj0?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1378,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -125,
    "LOC_Y": 254,
    "GAME_DATE": 20160118,
    "Season": "2015-2016",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/18/0021500622/4/11bdda53-dab8-b1c0-f6d3-b1b539c1b363_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360976812301245864",
    "name": "The 2974 Collection #1378",
    "imageUrl": "https://arweave.net/Edn8TOptZEVtdaNiNZ4y7BtqaXKw2Om_bPbHLRRQjt4?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2016,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1379,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 210,
    "LOC_Y": 115,
    "GAME_DATE": 20160118,
    "Season": "2015-2016",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/18/0021500622/55/20d1844e-34ef-108d-deb3-9262be2f3d22_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421119435255441494",
    "name": "The 2974 Collection #1379",
    "imageUrl": "https://arweave.net/auYl0M1vdh-8Zayh-be29aztenl8fYNlA09nUMn_5zw?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2016,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1380,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -50,
    "LOC_Y": 267,
    "GAME_DATE": 20160118,
    "Season": "2015-2016",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/18/0021500622/91/49d47038-e790-6919-ebf5-3df7ebc557a0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/405897631240944910",
    "name": "The 2974 Collection #1380",
    "imageUrl": "https://arweave.net/4KTCGmODJDcxWLCBuO6VAZ5ZQR13diOaIr7LzJt5NLI?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2016,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1381,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 213,
    "LOC_Y": 115,
    "GAME_DATE": 20160118,
    "Season": "2015-2016",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/18/0021500622/95/cc6d9406-9d8a-4fa7-dc9d-6ba24a21cef6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423258949557073194",
    "name": "The 2974 Collection #1381",
    "imageUrl": "https://arweave.net/6LB-as2cO9eSUSOPhlay9tb1Gn5QrJrCEPzpl16oIWc?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2016,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1382,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 133,
    "LOC_Y": 203,
    "GAME_DATE": 20160118,
    "Season": "2015-2016",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/18/0021500622/276/9b2e92b5-95c4-5e9e-4ced-c741a3335e58_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550067380183249353",
    "name": "The 2974 Collection #1382",
    "imageUrl": "https://arweave.net/HFY_70QtGdcPXOjrZPECYg5OIhm9Tqe4WZ26q3_JWPA?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2016,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1383,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -245,
    "LOC_Y": 13,
    "GAME_DATE": 20160118,
    "Season": "2015-2016",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/18/0021500622/344/45d24d33-73d2-21b0-088c-ad1136c4395c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/311059127905423599",
    "name": "The 2974 Collection #1383",
    "imageUrl": "https://arweave.net/Tj9emSt32r-q2MuoEqg0J4_Wp49b2yuJKjV-COfju5M?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2016,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1384,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 63,
    "LOC_Y": 249,
    "GAME_DATE": 20160118,
    "Season": "2015-2016",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/18/0021500622/396/9da85c17-d0ec-dce7-db85-bcf134730975_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443971494356136171",
    "name": "The 2974 Collection #1384",
    "imageUrl": "https://arweave.net/vXnjovCgDL1hyZk7svCYYqHAIVpTJ5izmcz3qUEgOBo?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2016,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1385,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 43,
    "LOC_Y": 237,
    "GAME_DATE": 20160120,
    "Season": "2015-2016",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/20/0021500634/25/1e112b5e-e8a7-5340-1bf8-40a819fb90d7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459562763443750142",
    "name": "The 2974 Collection #1385",
    "imageUrl": "https://arweave.net/Zdg6ZjnNuMx-dGFSx8i2paqVNzqJVnhqEvEN6LWZwJg?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2016,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1386,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 137,
    "LOC_Y": 203,
    "GAME_DATE": 20160120,
    "Season": "2015-2016",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/20/0021500634/372/97ab13e2-37d6-3c91-bc4f-affc0bfb915c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/448928681053125216",
    "name": "The 2974 Collection #1386",
    "imageUrl": "https://arweave.net/p_i_xLq4Gw-PTVM9cqv35yG0UrGtO59BqMKwKof-tHE?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2016,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1387,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 40,
    "LOC_Y": 252,
    "GAME_DATE": 20160120,
    "Season": "2015-2016",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/20/0021500634/501/6eec6b88-456d-a6ce-ea38-9d475540b527_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474284720019477688",
    "name": "The 2974 Collection #1387",
    "imageUrl": "https://arweave.net/UgnsL7CNeJpv7D7WRvS548NJE53xYzLFdbVNMH4SncY?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2016,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1388,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 114,
    "LOC_Y": 213,
    "GAME_DATE": 20160122,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/22/0021500652/9/e37433e2-6e2b-a663-1865-d04d544f33d6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/311576900617079993",
    "name": "The 2974 Collection #1388",
    "imageUrl": "https://arweave.net/J70nP1wY3IGW_3kqJqpGE79GIY9vK5SQa_tDBovoabo?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Triple-Double",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1389,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -16,
    "LOC_Y": 259,
    "GAME_DATE": 20160122,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/22/0021500652/46/4c923d2b-d0d6-f712-5bbb-0558d48b8ef0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/535512345491320008",
    "name": "The 2974 Collection #1389",
    "imageUrl": "https://arweave.net/4tJ3EEFHFk4NiYEwWsg943Z5C4OoXhi1cHZV-RG0oBo?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1390,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 99,
    "LOC_Y": 269,
    "GAME_DATE": 20160122,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/22/0021500652/267/288c070c-b875-97c0-99e7-ffc108e15674_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320879484057685693",
    "name": "The 2974 Collection #1390",
    "imageUrl": "https://arweave.net/E0hfY_wHTuksOrppSKALQ0sLeV6D_GYYIUKigQSHbUs?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Triple-Double",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1391,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Backcourt",
    "SHOT_DISTANCE": 48,
    "LOC_X": 117,
    "LOC_Y": 467,
    "GAME_DATE": 20160122,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/22/0021500652/270/a0ad1979-1491-2722-d61c-e0bb4e89290b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362404309670840194",
    "name": "The 2974 Collection #1391",
    "imageUrl": "https://arweave.net/G3-nz7RAt6ApoXWQ05N0YyDEoAwOFvKx3YIRN_9LUyQ?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Triple-Double",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1392,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 105,
    "LOC_Y": 228,
    "GAME_DATE": 20160122,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/22/0021500652/319/3aa225b1-35a7-e10b-f973-91273ad37f19_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531180769855183680",
    "name": "The 2974 Collection #1392",
    "imageUrl": "https://arweave.net/29nE8nWveWLIpueKYhJEiVYQyR2FbJ4smK4YsrM8XmI?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Triple-Double",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1393,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 18,
    "GAME_DATE": 20160122,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/22/0021500652/336/18b141de-861a-8f2e-4fc7-d3ffe8aa2aab_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550442177251667354",
    "name": "The 2974 Collection #1393",
    "imageUrl": "https://arweave.net/Jfb8UWA_i3ND8PxQaoJBjWM0C0rhEg3jLaDcojsekig?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1394,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 114,
    "LOC_Y": 228,
    "GAME_DATE": 20160122,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/22/0021500652/503/050e822f-1422-8706-8b15-1d77e5603fc6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/416531450467656387",
    "name": "The 2974 Collection #1394",
    "imageUrl": "https://arweave.net/gfl-7s2I5NQ1cwlNM5jw8jwF3aLhFrrY-5-MyhSfQdg?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Triple-Double",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1395,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 18,
    "GAME_DATE": 20160122,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/22/0021500652/518/4ff6d50a-6237-ab7a-33cb-c71fc0e92b5c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/310866362533061788",
    "name": "The 2974 Collection #1395",
    "imageUrl": "https://arweave.net/8JhgzT3DctMkOF2Gw9NVAxY0ftcVypas6T6JcS5WYsk?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Triple-Double",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1396,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 40,
    "LOC_Y": 277,
    "GAME_DATE": 20160125,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/25/0021500675/24/b72dfa5d-6df7-1fd3-bbc8-302a8d791db4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/315885480476548710",
    "name": "The 2974 Collection #1396",
    "imageUrl": "https://arweave.net/EdaPM4XjB1qm9K-jubX5RRb-uon8nfY3qwK6PoUgE1k?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1397,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -169,
    "LOC_Y": 205,
    "GAME_DATE": 20160125,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/25/0021500675/40/23ad779d-cbb7-a981-cb96-63abc484b5da_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524054488164437560",
    "name": "The 2974 Collection #1397",
    "imageUrl": "https://arweave.net/xD9Al22YSFAo5UnuA5HnsVg3MgcrwfrtU3plLUroxjY?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1398,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 227,
    "LOC_Y": 33,
    "GAME_DATE": 20160125,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/25/0021500675/100/53014a91-0dc7-4c2f-c82e-d0f75f30f9e9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/380714555555363994",
    "name": "The 2974 Collection #1398",
    "imageUrl": "https://arweave.net/KlXHlglY4wLoV8zCgdZTCB8yV57MoOhgVLHZyQooCJg?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1399,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 14,
    "LOC_Y": 257,
    "GAME_DATE": 20160125,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/25/0021500675/292/8c3dcd6c-db24-4db6-1fa4-4a63c61d8567_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290804818122161644",
    "name": "The 2974 Collection #1399",
    "imageUrl": "https://arweave.net/HcG4R3Bsy7__zFaMTJSb18T-W1hpThygdOU-pL_U7GY?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1400,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -40,
    "LOC_Y": 273,
    "GAME_DATE": 20160125,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/25/0021500675/299/a4618297-3e5e-d0e3-59ef-5763f546288a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450618484830524867",
    "name": "The 2974 Collection #1400",
    "imageUrl": "https://arweave.net/F6mCiXwhuBIOiuhOz-b7T8TMrnalnh2tWEAi1_1kxOU?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1401,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": -1,
    "GAME_DATE": 20160125,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/25/0021500675/389/23d9b24f-4b03-b274-44d2-2a76c71d2fa1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/358415528989984921",
    "name": "The 2974 Collection #1401",
    "imageUrl": "https://arweave.net/NC-g2P2qZRZsqStbGum26GMU0NUx8BjZfeimBIqMviY?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1402,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 186,
    "LOC_Y": 169,
    "GAME_DATE": 20160127,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/27/0021500691/242/7ddb84df-9806-619b-cfac-2bdd6907530d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/449110841239113560",
    "name": "The 2974 Collection #1402",
    "imageUrl": "https://arweave.net/iZlj24MJQ7SK2dCOHSo1GMvBeMU_38iBksU-Sv1vABo?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1403,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 22,
    "LOC_Y": 262,
    "GAME_DATE": 20160127,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/27/0021500691/266/9858c96a-de85-4633-7183-5da2d2028402_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347838516234591345",
    "name": "The 2974 Collection #1403",
    "imageUrl": "https://arweave.net/dMH1Ns8IvYjSzIfACBl3Q0-UEVh86s-gwXUEa4Sfnms?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1404,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 153,
    "LOC_Y": 242,
    "GAME_DATE": 20160127,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/27/0021500691/269/992b7da9-5794-b2f2-80f0-a38b34f79fd2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525689655681164042",
    "name": "The 2974 Collection #1404",
    "imageUrl": "https://arweave.net/a0McXa1dWKk4uHbxd98Uk-OTRm-l2japLX439j7qp3M?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1405,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -178,
    "LOC_Y": 174,
    "GAME_DATE": 20160130,
    "Season": "2015-2016",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/30/0021500707/53/822d737b-4e07-0ec4-14bd-75359a58cf39_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328392799999022101",
    "name": "The 2974 Collection #1405",
    "imageUrl": "https://arweave.net/D7Aj6SD4TZx7dkr935upI7JPnT7Vg1SxiOpb9HVza7A?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2016,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1406,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 31,
    "GAME_DATE": 20160130,
    "Season": "2015-2016",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/30/0021500707/100/372cc201-20ec-e07e-27ea-66123663b435_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520090259220220526",
    "name": "The 2974 Collection #1406",
    "imageUrl": "https://arweave.net/DGbXP99U-Y_0eETkpgh3WMKmlE6k_tMvFVvaLUzTb7I?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2016,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1407,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -84,
    "LOC_Y": 239,
    "GAME_DATE": 20160130,
    "Season": "2015-2016",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/30/0021500707/233/e971172b-abcd-eab3-7c32-d1c04741eab8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541864676537737066",
    "name": "The 2974 Collection #1407",
    "imageUrl": "https://arweave.net/GK8pPnnRZ_UUEgLqZVhdQMWOwF41Hk6AxQ7gdCBhtdo?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2016,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1408,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -16,
    "LOC_Y": 257,
    "GAME_DATE": 20160130,
    "Season": "2015-2016",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/30/0021500707/414/ca4c2384-3bff-5589-2994-b79550a46054_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/559654267917307475",
    "name": "The 2974 Collection #1408",
    "imageUrl": "https://arweave.net/hyxIH7FonLtnNDLk3U-j_xsRK00Tn_OGL9YfobC2lEY?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2016,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1409,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -73,
    "LOC_Y": 242,
    "GAME_DATE": 20160130,
    "Season": "2015-2016",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/30/0021500707/464/a8e0d430-f6b6-2b80-2581-d5f1d7180f41_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/534455707248630645",
    "name": "The 2974 Collection #1409",
    "imageUrl": "https://arweave.net/nH_sbizsXZpBkRJngosWWXsNnqrmjEBh1dH0wO2NbD4?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2016,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1410,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -106,
    "LOC_Y": 214,
    "GAME_DATE": 20160131,
    "Season": "2015-2016",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/31/0021500718/94/76a343f8-c413-4052-717c-9fa410b33815_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/311686303603112037",
    "name": "The 2974 Collection #1410",
    "imageUrl": "https://arweave.net/b9EF1DN6od7xHl-tpqR1m0DMAohO2-YbmKepBGJYAMg?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1411,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 91,
    "LOC_Y": 247,
    "GAME_DATE": 20160131,
    "Season": "2015-2016",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/31/0021500718/117/16097573-ab86-151f-1a1c-c6182df1b88d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385919938751434396",
    "name": "The 2974 Collection #1411",
    "imageUrl": "https://arweave.net/j9D04k4JspjRpVnRyMkCEUbaxS5DfNcJaf43JXgr1VI?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1412,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -168,
    "LOC_Y": 218,
    "GAME_DATE": 20160131,
    "Season": "2015-2016",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/01/31/0021500718/423/1a9199c9-7ea2-311d-9696-1a64187e776d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369477525853840411",
    "name": "The 2974 Collection #1412",
    "imageUrl": "https://arweave.net/DbPQ6k2edmWBiw5bhzHxAx5TgMXcRZ8TtoBsJUVI0EA?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1413,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 151,
    "LOC_Y": 218,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/22/9dbce750-e578-8f44-4749-da83a1ac5e87_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364334254292663105",
    "name": "The 2974 Collection #1413",
    "imageUrl": "https://arweave.net/9Eqfce1VLbhvprejkGUgOateMXcPmPAGG4B1Rwn62oc?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1414,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -219,
    "LOC_Y": 124,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/32/b1ecb7f1-27f2-6cc4-f8fc-48c989949293_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367727299046444762",
    "name": "The 2974 Collection #1414",
    "imageUrl": "https://arweave.net/4HQzbAjLNde5_xYlZd3rqFqc6uZKQ5DYo4H6A08IQRY?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1415,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 195,
    "LOC_Y": 198,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/35/ed0bc0b7-d2ed-da8d-c14b-4d934a717ad5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/475025680031940753",
    "name": "The 2974 Collection #1415",
    "imageUrl": "https://arweave.net/KIG-PrkmOLTdw-3sqWEv3MFVffML32gSm1mFQZZE33Y?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1416,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -122,
    "LOC_Y": 228,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/54/fed27103-5800-7f8e-d30d-b29f72b5a8f3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491722166717836619",
    "name": "The 2974 Collection #1416",
    "imageUrl": "https://arweave.net/BrNYIiQxH8G34Nb8Wd9dKijd6xOhKAZjMZbU-xeCsDo?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1417,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -48,
    "LOC_Y": 239,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/62/15e270ba-9401-4775-5a1a-a9e52e4c34a9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420643327698243049",
    "name": "The 2974 Collection #1417",
    "imageUrl": "https://arweave.net/BqLNChHtheVuHNsdh0xqOYsftOGk_prUlCSWvpnqUd0?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1418,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -148,
    "LOC_Y": 205,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/90/d75e3dc3-bea1-5550-dad9-11e77cb0327d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305396613167225815",
    "name": "The 2974 Collection #1418",
    "imageUrl": "https://arweave.net/IVHhDj8jkm6zTbsVdP08xlpJwXM0PSFxajWNdynG6-4?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1419,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -16,
    "LOC_Y": 252,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/96/828542d6-c213-eee8-4b83-f905a2883897_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322441757592875261",
    "name": "The 2974 Collection #1419",
    "imageUrl": "https://arweave.net/dDSddtN2yK4Mm7jGxfPwEN27j823wLmxvm0972FQnZ4?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1420,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 151,
    "LOC_Y": 218,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/271/1fb54f9f-fcaf-ce35-e3c8-0531ca4fd8a3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/340071066473836253",
    "name": "The 2974 Collection #1420",
    "imageUrl": "https://arweave.net/vcSSkzlnFoVi9rl0WwUQ60Y9MKT03phlKShU7Xdiexo?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1421,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -209,
    "LOC_Y": 169,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/431/3d0e9a0b-998b-80b6-dd02-164bec2c803b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/311555408810102832",
    "name": "The 2974 Collection #1421",
    "imageUrl": "https://arweave.net/8xp_S-SH4kvf9edDNVaIVbPZrtQz4-KvgQlkIKY-3UA?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1422,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 207,
    "LOC_Y": 203,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/446/19fe202a-562d-2456-ed47-e80535cdc299_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501934108014067374",
    "name": "The 2974 Collection #1422",
    "imageUrl": "https://arweave.net/SEE5Y2sJi8DjIFXxu_D3K9EI80wsdkPfQ-_RwPVaWc0?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1423,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -212,
    "LOC_Y": 188,
    "GAME_DATE": 20160203,
    "Season": "2015-2016",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/03/0021500739/560/30fa8009-f282-1dd8-f4d7-64998bd7f925_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548500777687976449",
    "name": "The 2974 Collection #1423",
    "imageUrl": "https://arweave.net/ktf5YzsHWAmT-B1y-zQGfl029zVL4Ee32R6dKIRajVw?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1424,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 32,
    "LOC_Y": 257,
    "GAME_DATE": 20160206,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/06/0021500769/60/af3f2403-d245-14be-5d33-ab69124c8ebe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/376907695255071855",
    "name": "The 2974 Collection #1424",
    "imageUrl": "https://arweave.net/hbqmWRYlLU5MkHSJrbmF9cULAmlgzX1v1FLS7lRoHxs?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1425,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -156,
    "LOC_Y": 259,
    "GAME_DATE": 20160209,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/09/0021500788/10/81e0b1a1-3638-0765-5077-01572f34e9af_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562323343744527843",
    "name": "The 2974 Collection #1425",
    "imageUrl": "https://arweave.net/L1zmSd8xeOhQtQZz9Khtf5TFcetD6M8psOMinJfr2uA?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1426,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -184,
    "LOC_Y": 174,
    "GAME_DATE": 20160209,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/09/0021500788/77/4a661843-4630-81d5-f254-4af1ad1fb937_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503065106050890427",
    "name": "The 2974 Collection #1426",
    "imageUrl": "https://arweave.net/2mYlLy9yLiETEFcEHpOcIRrI6Qw6W3k9Jdi6ptqbVbU?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1427,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -70,
    "LOC_Y": 242,
    "GAME_DATE": 20160209,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/09/0021500788/79/4e7be7f3-6ee5-d59b-e040-c5cf9eeca57b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/573517960358280804",
    "name": "The 2974 Collection #1427",
    "imageUrl": "https://arweave.net/GXJ6i9uwuXG0-iA2IPjO41W-pWPRHMaL4Nqu6i4nwKg?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1428,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 2,
    "GAME_DATE": 20160209,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/09/0021500788/82/136f48e5-1d8c-a194-f95e-d2591989a1ed_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330743603027571742",
    "name": "The 2974 Collection #1428",
    "imageUrl": "https://arweave.net/er1kmhnLo0nkzpKfFMTe3U2jIaFF3_fXYtII_ENR0rQ?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1429,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -209,
    "LOC_Y": 170,
    "GAME_DATE": 20160209,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/09/0021500788/100/ebdc30b0-1daf-cd0b-dc03-7c12fc282bd9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429815523003300542",
    "name": "The 2974 Collection #1429",
    "imageUrl": "https://arweave.net/07a6nNHWfIaAFPpbOHSCT-WzRLpuAvXhF-JN6dwOHJA?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1430,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -24,
    "LOC_Y": 311,
    "GAME_DATE": 20160209,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/09/0021500788/252/c93f12e8-113b-e0f1-73a4-b2ae7dfd1016_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/383438628663493726",
    "name": "The 2974 Collection #1430",
    "imageUrl": "https://arweave.net/q2K7t-Huv6iRgjj6hUu-UWxllJDYpuM2096mYZV7cmQ?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1431,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -45,
    "LOC_Y": 262,
    "GAME_DATE": 20160209,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/09/0021500788/412/34479110-8f8a-8a91-2f53-21ef717aed6f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407157130194419170",
    "name": "The 2974 Collection #1431",
    "imageUrl": "https://arweave.net/sIr7wztKRWByTa0PgjgslhbbwLT57lseESboZd1Nr8o?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1432,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 238,
    "LOC_Y": 26,
    "GAME_DATE": 20160210,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/10/0021500799/10/97f045da-0011-b53f-6798-d6465685c8f6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384282220039976676",
    "name": "The 2974 Collection #1432",
    "imageUrl": "https://arweave.net/-3QjKYomw93L7yhJOMGQsCFt777kCXfCxucrxW644VE?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1433,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -238,
    "LOC_Y": 33,
    "GAME_DATE": 20160210,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/10/0021500799/54/5174d198-f5f7-49f1-d09e-03f6a69e9d28_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327358264194113725",
    "name": "The 2974 Collection #1433",
    "imageUrl": "https://arweave.net/ooGfwuI79UqCClsDcRihD84y9tQ7TNpdW-yNPiHWJiM?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1434,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 119,
    "LOC_Y": 264,
    "GAME_DATE": 20160210,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/10/0021500799/212/f6304d99-8cac-097f-5933-60d7865a65c4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518820817912385862",
    "name": "The 2974 Collection #1434",
    "imageUrl": "https://arweave.net/qcGw2ql9pDhUC3AK4_v7HI1_hy0-eJM-yzOllxemSPM?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1435,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 174,
    "LOC_Y": 234,
    "GAME_DATE": 20160210,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/10/0021500799/222/d7ff4a39-b8a4-46b3-0254-f50d1a848682_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344886733889670560",
    "name": "The 2974 Collection #1435",
    "imageUrl": "https://arweave.net/yhgyV1GH0PBbwN08CgWrNz7tcoCJm8tc-tQ1OPlBt8w?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1436,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 217,
    "LOC_Y": 105,
    "GAME_DATE": 20160210,
    "Season": "2015-2016",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/10/0021500799/291/1db5a7dc-ca75-947a-49ed-a36fa96aa9b7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/310039680369974433",
    "name": "The 2974 Collection #1436",
    "imageUrl": "https://arweave.net/kLAUIwRskZtfgpUHN6bP9NvFspxuduBdH1_Je0zZbOQ?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1437,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -96,
    "LOC_Y": 223,
    "GAME_DATE": 20160219,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/19/0021500815/15/f16912df-d1b5-0cfe-71cd-b5710ab9160f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361434672201593811",
    "name": "The 2974 Collection #1437",
    "imageUrl": "https://arweave.net/n6bKAYPhtaslLA5uX9fsFP6kIzTlH7CKdC3oKLxJKO4?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1438,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -110,
    "LOC_Y": 218,
    "GAME_DATE": 20160219,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/19/0021500815/28/963cedef-4ac0-fb5c-71a8-d03507e78fb5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/528624547255716434",
    "name": "The 2974 Collection #1438",
    "imageUrl": "https://arweave.net/Mp-Gm3GSPKgY2Nt_1Hu5Tvq-0olIiPt-l92F3hqWiGM?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1439,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -227,
    "LOC_Y": 7,
    "GAME_DATE": 20160219,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/19/0021500815/37/5321c3c1-33ff-075a-b66d-61aa47d0c0dd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344467466690257922",
    "name": "The 2974 Collection #1439",
    "imageUrl": "https://arweave.net/kRQKMGQWXCmPDJF_FI2bflrHLUN9uNG2NI9-0Mq-jqk?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1440,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -155,
    "LOC_Y": 185,
    "GAME_DATE": 20160219,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/19/0021500815/97/8351dfbf-da35-cd3b-58dc-f1c67944ddbd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369214214381027630",
    "name": "The 2974 Collection #1440",
    "imageUrl": "https://arweave.net/XcyE82OcIDmqLF-zztvIVAxbeI99I2dQsNxWefjdkQo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1441,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 153,
    "LOC_Y": 193,
    "GAME_DATE": 20160219,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/19/0021500815/218/cfd5d16b-ed45-7e16-a3a1-bf73377dc4f4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317777322131700526",
    "name": "The 2974 Collection #1441",
    "imageUrl": "https://arweave.net/BPS06OPUC0vWZ8Jaa1dCnBAe6pN5qI7u72e1RM4H8lI?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1442,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 135,
    "LOC_Y": 228,
    "GAME_DATE": 20160219,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/19/0021500815/250/ff690a27-bb5f-e4e6-1644-651ab3088830_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543733026399622517",
    "name": "The 2974 Collection #1442",
    "imageUrl": "https://arweave.net/yPMq_vnPH2mYKMBdpLYJ-SalduTbSDzHqvjDTMhHxsA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1443,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -127,
    "LOC_Y": 210,
    "GAME_DATE": 20160219,
    "Season": "2015-2016",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/19/0021500815/291/741959b2-891e-57e6-f3f8-c038a3b4086c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567554286298572792",
    "name": "The 2974 Collection #1443",
    "imageUrl": "https://arweave.net/KDNjdvzRV2lmi4PGRro41r-wDEMtWEEENY2u19JZkH0?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1444,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 74,
    "LOC_Y": 252,
    "GAME_DATE": 20160220,
    "Season": "2015-2016",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/20/0021500822/21/3999e904-1078-0daa-21a7-5d83fd643fad_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444862745666737244",
    "name": "The 2974 Collection #1444",
    "imageUrl": "https://arweave.net/adNlp4JSziVj44lTWcMI9z2Pg1eNkXvtZOkZ7KD9df8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1445,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -120,
    "LOC_Y": 237,
    "GAME_DATE": 20160220,
    "Season": "2015-2016",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/20/0021500822/373/207c65f3-0d64-6042-4cce-a0baaaabc975_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371636664502510827",
    "name": "The 2974 Collection #1445",
    "imageUrl": "https://arweave.net/-6iOaPE_7m8WyHLV4ny61UdTijLznHlqie-lOUDciEk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1446,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 177,
    "LOC_Y": 188,
    "GAME_DATE": 20160220,
    "Season": "2015-2016",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/20/0021500822/477/96066dd3-79e1-b7bc-2c13-5566d3a2f73e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450364763214444808",
    "name": "The 2974 Collection #1446",
    "imageUrl": "https://arweave.net/xOXjtHmxZn0rf6Kf48iEq_4va44s7vJX5DlkeLML3V0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 2,
    "Day": 20,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1447,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -202,
    "LOC_Y": 144,
    "GAME_DATE": 20160222,
    "Season": "2015-2016",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/22/0021500836/14/8311206f-e16c-5de8-1572-4689bafe762c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500934725401431489",
    "name": "The 2974 Collection #1447",
    "imageUrl": "https://arweave.net/RtQEGtCALUx5pdQMl_M0lN8jceRhXXla9QcqSR4Mi1s?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2016,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1448,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 38,
    "LOC_Y": 242,
    "GAME_DATE": 20160222,
    "Season": "2015-2016",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/22/0021500836/44/4819cc53-fdd0-0161-9c30-c284d773d481_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297937823129045402",
    "name": "The 2974 Collection #1448",
    "imageUrl": "https://arweave.net/-bLRkcyJogf73zmj63mDX07rGs-KqfdxSFfZ8ZXmV9M?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2016,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1449,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 228,
    "LOC_Y": 85,
    "GAME_DATE": 20160222,
    "Season": "2015-2016",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/22/0021500836/217/e8813141-7578-c55d-6846-22ec23047396_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/408107827518038505",
    "name": "The 2974 Collection #1449",
    "imageUrl": "https://arweave.net/d-E69vUrnDr_8nnBirJxCXdmPNrDu56YsfslzLUhs5w?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2016,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1450,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 73,
    "LOC_Y": 229,
    "GAME_DATE": 20160222,
    "Season": "2015-2016",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/22/0021500836/226/1571a0c1-ec25-9618-6d4a-b61ba9e9ea83_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/563178791101095907",
    "name": "The 2974 Collection #1450",
    "imageUrl": "https://arweave.net/H1EWQkSf_h0AqFEbaKHcbAom1h5fDB_OvqffnzrUc6w?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2016,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1451,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 31,
    "GAME_DATE": 20160222,
    "Season": "2015-2016",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/22/0021500836/465/61634e63-9c73-e721-31ff-578c3f42aba4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328240244823346714",
    "name": "The 2974 Collection #1451",
    "imageUrl": "https://arweave.net/zVT-rT59zMs0S7zuGDHXDV06Be29NB9z1HuZhOyw88k?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2016,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1452,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -205,
    "LOC_Y": 174,
    "GAME_DATE": 20160224,
    "Season": "2015-2016",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/24/0021500848/11/74d31739-5d02-7951-c65d-176a0c1f64d3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305469526781127668",
    "name": "The 2974 Collection #1452",
    "imageUrl": "https://arweave.net/urSBBTZEviQPLkbMTEMsYhqnB1Bxrlrp8bYTQZANDGw?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1453,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 40,
    "LOC_X": -155,
    "LOC_Y": 370,
    "GAME_DATE": 20160224,
    "Season": "2015-2016",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/24/0021500848/135/4a8af0c4-5dd2-8b10-e79f-f9fe99b6c3c0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476321149245259497",
    "name": "The 2974 Collection #1453",
    "imageUrl": "https://arweave.net/jrbSCoUvGVDS7eTlFDCzaJ6NBytxEpyeLdrrPDl7Xm8?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1454,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 166,
    "LOC_Y": 200,
    "GAME_DATE": 20160224,
    "Season": "2015-2016",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/24/0021500848/285/8d456aad-48ec-3b2a-41ae-e9ee479019dc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348036622390975141",
    "name": "The 2974 Collection #1454",
    "imageUrl": "https://arweave.net/VzMr_MsAVNsSI3LibmYgX2bncthHJSwKqNRPfYUQNrw?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1455,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 186,
    "LOC_Y": 159,
    "GAME_DATE": 20160224,
    "Season": "2015-2016",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/24/0021500848/407/64cbbed6-8383-e27c-a867-1adaf7f99400_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439644116569150001",
    "name": "The 2974 Collection #1455",
    "imageUrl": "https://arweave.net/VhicjNz3tlj-DtUV0eQB_9BEyKI2-Z2OGt8gPNAIzSA?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1456,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 9,
    "LOC_Y": 267,
    "GAME_DATE": 20160224,
    "Season": "2015-2016",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/24/0021500848/538/61615cdf-7a0d-6e67-dede-fbfec39ac574_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436189518844946337",
    "name": "The 2974 Collection #1456",
    "imageUrl": "https://arweave.net/jzw3arSY-8YVxz8TY6eIqgd6JEwg6Im-rvR0dHcGuVs?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1457,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 12,
    "LOC_Y": 262,
    "GAME_DATE": 20160224,
    "Season": "2015-2016",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/24/0021500848/547/652d1cbb-d249-68ee-f3ca-ff1b8b37dea3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/401130126468622052",
    "name": "The 2974 Collection #1457",
    "imageUrl": "https://arweave.net/lRJgEXtpBRBuPXryCnqF62tbnXl901JN2OrfsFzwRLY?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2016,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1458,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -204,
    "LOC_Y": 154,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/71/eed703a5-98af-1b5d-d64e-e54684aa053f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/574115270136696973",
    "name": "The 2974 Collection #1458",
    "imageUrl": "https://arweave.net/DRH8Tr-kaOruPMihw2TTevciScqCEacX-YDeG_2HGYE?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1459,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -20,
    "LOC_Y": 254,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/78/535c3032-4014-10e1-4f2a-ab17186209cc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429490837133976840",
    "name": "The 2974 Collection #1459",
    "imageUrl": "https://arweave.net/sWx6s-Hkd1IdUhAgx6FbElUkAIlnWmVxbYx0sa13f6k?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1460,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 53,
    "LOC_Y": 237,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/232/838bb49d-330d-fbbf-0f73-1c776ce4aced_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341571071243121781",
    "name": "The 2974 Collection #1460",
    "imageUrl": "https://arweave.net/JzOSPBioPy51MhP-Eu5FL0bluq-ekOYRnYn5sFy8dHk?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1461,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 150,
    "LOC_Y": 208,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/314/bc936c4c-33e8-e2a8-5791-ce0308372462_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423513073910921578",
    "name": "The 2974 Collection #1461",
    "imageUrl": "https://arweave.net/6fw8Q7kJYNo3mkNDRdPSGTMkG9v-OrWx3wjgOQ5nehQ?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1462,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 209,
    "LOC_Y": 121,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/335/9a310efc-2638-bfd0-bd35-51beec423c86_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/455538859393562089",
    "name": "The 2974 Collection #1462",
    "imageUrl": "https://arweave.net/FX3fxA_GzgagPm-R8G7r5yHM8F-m06pzjHFXp5kRM4g?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1463,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -89,
    "LOC_Y": 239,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/375/5fa352b2-6a60-aef9-dde6-5a6ee73939a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550523771773176178",
    "name": "The 2974 Collection #1463",
    "imageUrl": "https://arweave.net/SJ99W9s-YS85zJAJAwYvJKCb9QVyF3eSc3QRMOaj0PQ?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1464,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -155,
    "LOC_Y": 195,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/392/43383635-20b2-14ce-cbaa-caa79037af3e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/313360244856320045",
    "name": "The 2974 Collection #1464",
    "imageUrl": "https://arweave.net/1rvB4czA8VNy0Q4fq2qaAkBeQfiU8CNlY8igUSgof14?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1465,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 155,
    "LOC_Y": 210,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/399/2b1f3ca6-6fc3-e421-b821-135e8db8b6f2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510593721198306054",
    "name": "The 2974 Collection #1465",
    "imageUrl": "https://arweave.net/zbC6rcDLKnLRypjAKPB837gg9PR2Z4baVttIU22rc3M?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1466,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 44,
    "LOC_X": -186,
    "LOC_Y": 400,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/421/924f6245-9e7b-13ad-6d36-8649aae78974_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348681799448263025",
    "name": "The 2974 Collection #1466",
    "imageUrl": "https://arweave.net/KBB1RfMcBlFiehGn7LWxBC9sR8higIDFZd_ClLn--xY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1467,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 73,
    "LOC_Y": 264,
    "GAME_DATE": 20160225,
    "Season": "2015-2016",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/25/0021500855/524/95775848-a130-168a-6e1a-0e7645d1e0a4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379133610061471145",
    "name": "The 2974 Collection #1467",
    "imageUrl": "https://arweave.net/eF6zkZZkbILlq3sxqRVoyP9O--Y3nCbI3AaEdgbofNk?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (51 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1468,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -91,
    "LOC_Y": 221,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/13/6054c3c7-7588-8c54-5326-6f1e1f9bb86c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/563934495864814288",
    "name": "The 2974 Collection #1468",
    "imageUrl": "https://arweave.net/viYC66_SqhRQC3faOnZlX8wj6x-Lz52y57K84OZx_eM?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1469,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 33,
    "LOC_Y": 242,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/172/ebd95308-8b7c-9d23-753a-a600eefc172d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371539477438737492",
    "name": "The 2974 Collection #1469",
    "imageUrl": "https://arweave.net/cmfCeqynKDpDc0sHIWyYecWSK4vZmnBy0IeWW45SjOY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1470,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 3,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/178/4169f407-0e95-f7dc-dede-a6be18d7b3df_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347617002903863601",
    "name": "The 2974 Collection #1470",
    "imageUrl": "https://arweave.net/WW4u-kfN_QMcV9sD8y6srxs2vJlNuCDLIoVnk6ggBfM?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1471,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -173,
    "LOC_Y": 214,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/181/b227cac2-de54-03cb-20bb-2dd34d3c0a49_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/462966616877070310",
    "name": "The 2974 Collection #1471",
    "imageUrl": "https://arweave.net/FpKx521_4gJpI36knYvtnSIQEGf89Z9-6Z7YYe9IX3o?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1472,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 143,
    "LOC_Y": 234,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/323/5368722f-7f48-a358-4b22-a2de0af076a3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338238262287462330",
    "name": "The 2974 Collection #1472",
    "imageUrl": "https://arweave.net/nfVHlBsq4zJ-SRC4-tgTaQD4WxuaobsEmGOYkxH-6ic?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1473,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 184,
    "LOC_Y": 164,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/340/f357e628-6eab-6271-8aa0-bcbb4e175df2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489172224250760522",
    "name": "The 2974 Collection #1473",
    "imageUrl": "https://arweave.net/RDyHJs83S_gq80-EbjaA906cysz5RIoRhxiyTQYRFF4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1474,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -66,
    "LOC_Y": 229,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/365/85407f8f-7485-9c6b-34fe-3bed3e0674f1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484306730587106448",
    "name": "The 2974 Collection #1474",
    "imageUrl": "https://arweave.net/xiJ8l7WIqB8PpRlVDv-jB0Slht4dglwjdXAi3k7TPJA?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1475,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 78,
    "LOC_Y": 249,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/487/4b2ccbaf-bedd-7a90-7d54-435449189090_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/304516277613935370",
    "name": "The 2974 Collection #1475",
    "imageUrl": "https://arweave.net/KxIBrxmXzJgCPH1EM_aQ3ogKY1ovCBEt2nf3xmxNzb4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1476,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 60,
    "LOC_Y": 257,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/505/cc0e40c9-5893-032e-804f-c51caa740901_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568613548560112351",
    "name": "The 2974 Collection #1476",
    "imageUrl": "https://arweave.net/rmPA_Sd0GgAGgjyhfM4xM9bdZN22gIsEU6-csV7QKeI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1477,
    "PERIOD": 5,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -9,
    "LOC_Y": 254,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/554/3321d787-b56b-7f49-efaa-c1997f3ddcfb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324739506684215622",
    "name": "The 2974 Collection #1477",
    "imageUrl": "https://arweave.net/NxA9mOXMbvoybXaxJewGDVlqBLGWORmy4y_lllC1pPA?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1478,
    "PERIOD": 5,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 117,
    "LOC_Y": 223,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/568/3ec5673e-e8b8-bdb9-7305-3077f2fbb85c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363588817890236052",
    "name": "The 2974 Collection #1478",
    "imageUrl": "https://arweave.net/x9gxq9ZXYAQH_9Q4hVilSutHnAqc0ktnjs54OnHZ-cs?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1479,
    "PERIOD": 5,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 37,
    "LOC_X": -180,
    "LOC_Y": 326,
    "GAME_DATE": 20160227,
    "Season": "2015-2016",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/02/27/0021500874/605/b210f25a-bb78-fd03-7bb0-9f36d6cc8f77_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336757581063417060",
    "name": "The 2974 Collection #1479",
    "imageUrl": "https://arweave.net/cwyqF-U_3Chyy5gd8qP8OIxX3iX74g3RQ8Ap6hQJ88M?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 12,
    "Special Moment": "Twelve 3-Pointer Game (46 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1480,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -209,
    "LOC_Y": 151,
    "GAME_DATE": 20160303,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/03/0021500911/72/5987e84d-e644-7d36-4729-f9c6c2c8ad4d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525313281837365083",
    "name": "The 2974 Collection #1480",
    "imageUrl": "https://arweave.net/rWLpbpMgmPuL7k8FEzyuTNKHbJbOigj2S0_3izIlkpI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1481,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -207,
    "LOC_Y": 164,
    "GAME_DATE": 20160303,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/03/0021500911/74/d6c27f8d-cf58-6fd8-7323-38dafdb598af_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330035071314759681",
    "name": "The 2974 Collection #1481",
    "imageUrl": "https://arweave.net/Sq4nIVPposf48shUnu5MWkyQgRRjyzQNwztlPW_RCrY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1482,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": -178,
    "LOC_Y": 272,
    "GAME_DATE": 20160303,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/03/0021500911/246/7f96466b-05ee-a6f2-e5e3-3317450a4f4e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341802349335000415",
    "name": "The 2974 Collection #1482",
    "imageUrl": "https://arweave.net/g8YxmSkgtuCq60OkCW-u1hYPn9WoKUdEO0lIoMPNFhU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1483,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 45,
    "LOC_Y": 257,
    "GAME_DATE": 20160303,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/03/0021500911/490/05633ac2-68b8-7ebd-935c-383b7511d845_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/345438005773588248",
    "name": "The 2974 Collection #1483",
    "imageUrl": "https://arweave.net/WrxFVB-GMeRcdv2Ri_nZWUs8_ff02ilxppCoLWTjj00?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1484,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 187,
    "LOC_Y": 193,
    "GAME_DATE": 20160303,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/03/0021500911/499/49253a5a-4084-4f63-1a10-8a52dbebb4fe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444686868702695485",
    "name": "The 2974 Collection #1484",
    "imageUrl": "https://arweave.net/SJN_y4UKxD6C-_665b6rj0XO8P3vQ06t5ZgBUKuZCGU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1485,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -158,
    "LOC_Y": 208,
    "GAME_DATE": 20160306,
    "Season": "2015-2016",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/06/0021500931/11/ac8071bd-7606-7b15-c5dc-93dceac381ef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546889250726964990",
    "name": "The 2974 Collection #1485",
    "imageUrl": "https://arweave.net/trBceEKwmUqe3Lo3xV_-2uhzFPakAE4xNk0Pqr1UfYc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1486,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -207,
    "LOC_Y": 178,
    "GAME_DATE": 20160307,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/07/0021500943/24/301aed96-8da6-039a-32a2-bf732d6c8d8d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338484757234669740",
    "name": "The 2974 Collection #1486",
    "imageUrl": "https://arweave.net/ujAhWrw2XLUjUZHvH8An6fjguVs7mNNMVRH2wCaHa8Y?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 3,
    "Day": 7,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1487,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 148,
    "LOC_Y": 208,
    "GAME_DATE": 20160307,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/07/0021500943/32/99aae90d-f5d3-bfcc-6b10-da32091a0826_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402649940091806773",
    "name": "The 2974 Collection #1487",
    "imageUrl": "https://arweave.net/x2jsSDdy4aRUs5hQoZgvBspK4U7s5llt1do-7-w32uE?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 3,
    "Day": 7,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1488,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -17,
    "LOC_Y": 262,
    "GAME_DATE": 20160307,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/07/0021500943/80/82a04c74-aa2d-0bf7-6f27-c7e3a2b46fc3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/342525753902104930",
    "name": "The 2974 Collection #1488",
    "imageUrl": "https://arweave.net/QIVFeT7o71MsVbtfx0w6tJ6BrVbDItNt_uOqLpuGq1E?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 3,
    "Day": 7,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1489,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -147,
    "LOC_Y": 203,
    "GAME_DATE": 20160307,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/07/0021500943/261/c042c36d-c74f-79bf-2a30-215e925cce23_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438692155732255421",
    "name": "The 2974 Collection #1489",
    "imageUrl": "https://arweave.net/ITDqrDW1CjR16gBArRkm2tn_R4P6X0dJ7pQik2EkMjw?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 3,
    "Day": 7,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1490,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -97,
    "LOC_Y": 228,
    "GAME_DATE": 20160307,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/07/0021500943/305/2d9b93a8-662b-03a0-2eb8-1605a3bb93a1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421538572721866316",
    "name": "The 2974 Collection #1490",
    "imageUrl": "https://arweave.net/Ym9G_6BuLikoxsczg33d5me20hT9haGYizyGGebeZEY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 3,
    "Day": 7,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1491,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -129,
    "LOC_Y": 244,
    "GAME_DATE": 20160307,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/07/0021500943/404/a32a82a5-70fd-4787-6ad5-260cf1d918ff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552751282443744569",
    "name": "The 2974 Collection #1491",
    "imageUrl": "https://arweave.net/9Sb8mGoEuliwaBALsbl7dg0MIdb9A3inQ4xh6Nd0lIU?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 3,
    "Day": 7,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1492,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -153,
    "LOC_Y": 237,
    "GAME_DATE": 20160307,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/07/0021500943/514/ef09eddb-9487-f974-8e72-05a86da33109_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/569238524777194535",
    "name": "The 2974 Collection #1492",
    "imageUrl": "https://arweave.net/qsF7wIv03eo55OuylOLmTykjPAkZLksSE1PniAGQlts?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2016,
    "Month": 3,
    "Day": 7,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1493,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 173,
    "LOC_Y": 183,
    "GAME_DATE": 20160309,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/09/0021500958/197/b45fc8c9-a056-ad54-d7fb-aa1e77b43326_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320693329741590074",
    "name": "The 2974 Collection #1493",
    "imageUrl": "https://arweave.net/0hCrvpgHiZGR95UJShUYLfnjxuh9_SaSU3vkQ7tOCEE?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1494,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 199,
    "LOC_Y": 164,
    "GAME_DATE": 20160309,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/09/0021500958/212/abba054b-e476-3aaf-8159-fd9529652e52_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421727577755766313",
    "name": "The 2974 Collection #1494",
    "imageUrl": "https://arweave.net/t_WxsEopFzIEGxs3P9-Y-hXU1UTnPwmjXOT1mzrN42o?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1495,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Bank shot",
    "SHOT_ZONE_BASIC": "Backcourt",
    "SHOT_DISTANCE": 54,
    "LOC_X": 151,
    "LOC_Y": 527,
    "GAME_DATE": 20160309,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/09/0021500958/220/3dc319e2-1d98-6b6a-d0fa-d13847266e56_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/432623979869157576",
    "name": "The 2974 Collection #1495",
    "imageUrl": "https://arweave.net/GCXEVxuUvIUntRSJ34O3h_Dwcxi6jrel-GqkK41NED0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 3,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1496,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -214,
    "LOC_Y": 159,
    "GAME_DATE": 20160311,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/11/0021500971/63/d36263b7-c94f-4c42-7b88-844ea1555350_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392862026665122075",
    "name": "The 2974 Collection #1496",
    "imageUrl": "https://arweave.net/-XJ3IOZXpqAgFFtpeMVReZQfiuExdI0TpwJQVH0Own8?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1497,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": 2,
    "GAME_DATE": 20160311,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/11/0021500971/70/fe1a85ae-ff27-83c6-a224-6f456d28bd76_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382452628321876571",
    "name": "The 2974 Collection #1497",
    "imageUrl": "https://arweave.net/ffgFS41-NKlqourfDkGPBMcfXkObggdR3gxjary5pKk?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1498,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -204,
    "LOC_Y": 160,
    "GAME_DATE": 20160311,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/11/0021500971/73/3b6ccf72-7df2-0378-bad4-a2a7693b51c1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293097450848575693",
    "name": "The 2974 Collection #1498",
    "imageUrl": "https://arweave.net/LiswV8fIlxV4RlYH_MXFgUZQeufMrtg5BqImCWdCtlo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1499,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -68,
    "LOC_Y": 249,
    "GAME_DATE": 20160311,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/11/0021500971/85/4f6d9a36-4cdf-d773-7fb5-f7059e08ed03_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551961799540507762",
    "name": "The 2974 Collection #1499",
    "imageUrl": "https://arweave.net/_Cyszv9hYouzTOBXwsqpzu_0pGxyze-x5TgxiNgmt8U?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1500,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 158,
    "LOC_Y": 200,
    "GAME_DATE": 20160311,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/11/0021500971/275/94089f3e-1b8b-8902-f6f5-47b8759c76fc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/315266815032238529",
    "name": "The 2974 Collection #1500",
    "imageUrl": "https://arweave.net/zCViGfyYt8OE1DuS7unLU5X4KViHZXQyEnyykMuNNfo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1501,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 31,
    "GAME_DATE": 20160311,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/11/0021500971/348/ce56c8f4-9a7a-08bb-b42a-8bac3ec0596c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/437313312482128212",
    "name": "The 2974 Collection #1501",
    "imageUrl": "https://arweave.net/I_AtZKRfJNG-kOlYey3dok21XRdY0TqwJ3xsdRZfO4c?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1502,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 213,
    "LOC_Y": 139,
    "GAME_DATE": 20160311,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/11/0021500971/404/84c6b443-a81a-c803-3090-cea56a852d66_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391886203668033182",
    "name": "The 2974 Collection #1502",
    "imageUrl": "https://arweave.net/H5mtWSpRYKFyI-5rdmuKAZhj-fuZp0-fsQcRJ_JQnB0?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1503,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -112,
    "LOC_Y": 223,
    "GAME_DATE": 20160312,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/12/0021500981/34/08cdf067-137b-1c65-d682-e8c52e57a362_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317488551643602548",
    "name": "The 2974 Collection #1503",
    "imageUrl": "https://arweave.net/zfW5KInQLBlwjkSnZPHAH09Ek0etffqCw2S2Cex8B7k?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 3,
    "Day": 12,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1504,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -7,
    "LOC_Y": 249,
    "GAME_DATE": 20160312,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/12/0021500981/64/3ed49cd5-c25b-5faa-d750-79984131973d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305602583172266445",
    "name": "The 2974 Collection #1504",
    "imageUrl": "https://arweave.net/hasmGpzN8Hd6ggg_VSRyefcqUJEXy4pQRapx5hkakYo?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 3,
    "Day": 12,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1505,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -65,
    "LOC_Y": 259,
    "GAME_DATE": 20160312,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/12/0021500981/111/ef647f04-87f9-b9db-35f5-0771da8106b0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482337277118992812",
    "name": "The 2974 Collection #1505",
    "imageUrl": "https://arweave.net/G1j3CvEmpqL-cf0j5IMMm7cGnagyG3fFhzZlpvwD-gw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 3,
    "Day": 12,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1506,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -155,
    "LOC_Y": 228,
    "GAME_DATE": 20160312,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/12/0021500981/299/5aaa23ac-0073-4415-fc9e-d99f17321a65_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474247306139862074",
    "name": "The 2974 Collection #1506",
    "imageUrl": "https://arweave.net/iMuQvNAM1D1dpftC0dsltMeLgLZ14OJiguCWf2mHKv4?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 3,
    "Day": 12,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1507,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -205,
    "LOC_Y": 169,
    "GAME_DATE": 20160312,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/12/0021500981/423/b33f758a-5668-b21a-ff26-4a71be16a4ea_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446310027361714474",
    "name": "The 2974 Collection #1507",
    "imageUrl": "https://arweave.net/8Zqun_QP020aPji3aDn7f_0HSgdyo2d_Jed64yHf_Yc?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 3,
    "Day": 12,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1508,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 87,
    "LOC_Y": 242,
    "GAME_DATE": 20160312,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/12/0021500981/486/a6422246-05a4-5a59-86e9-60eed13fcbe5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391404957450114767",
    "name": "The 2974 Collection #1508",
    "imageUrl": "https://arweave.net/C69l8wcI93m074ojDL8EN1D5U-lwvbeyu6PVQxPG94E?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 3,
    "Day": 12,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1509,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -42,
    "LOC_Y": 249,
    "GAME_DATE": 20160312,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/12/0021500981/505/910d7ef0-452d-0a18-d59c-42fab54a2e9d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397804211515798272",
    "name": "The 2974 Collection #1509",
    "imageUrl": "https://arweave.net/06jYVjWsQAQ5Z20VfmrjZDx2MTruSlU2jfR-yU1ga8w?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 3,
    "Day": 12,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1510,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 28,
    "GAME_DATE": 20160314,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/14/0021500996/79/876e9d31-2b9d-84b3-e369-c22d85c46052_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/292966251560193229",
    "name": "The 2974 Collection #1510",
    "imageUrl": "https://arweave.net/3Rmh9hVSWQJezC2b9KH7B8VrlcH3_zMdWZpKYxq1SyQ?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "Birthday Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1511,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 150,
    "LOC_Y": 203,
    "GAME_DATE": 20160314,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/14/0021500996/388/556ce019-04a3-64b9-4c0d-4dbe17641f58_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356374802826169852",
    "name": "The 2974 Collection #1511",
    "imageUrl": "https://arweave.net/VC2h087oPfjk7vi8mM_B9A99KomIwr-xzwcx3A2gUbM?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "Birthday Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1512,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 235,
    "LOC_Y": 7,
    "GAME_DATE": 20160314,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/14/0021500996/390/60ba5f24-1887-0517-7cb1-36394222f170_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412633415216417677",
    "name": "The 2974 Collection #1512",
    "imageUrl": "https://arweave.net/kPLaxx3wOieDZeRkPp-bMtT-9zbJO27j0wBnqW5YdQU?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "Birthday Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1513,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Bank shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": -89,
    "LOC_Y": 316,
    "GAME_DATE": 20160314,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/14/0021500996/407/259750e8-a26b-4e38-f90c-ea5e0cfba223_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428567878862762070",
    "name": "The 2974 Collection #1513",
    "imageUrl": "https://arweave.net/FBQX-rCTCAt-eDj3bhINUFjrIYIus4ZkBgMFhnswVz4?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 4,
    "Special Moment": "Birthday Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1514,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -11,
    "LOC_Y": 257,
    "GAME_DATE": 20160316,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/16/0021501011/35/651b02f0-1f1c-9e25-aa42-8bb1dbca29d9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364041159577776962",
    "name": "The 2974 Collection #1514",
    "imageUrl": "https://arweave.net/S1fbtUCUORVHmHzggthswB6pfT_FkR7O71DhWX1cP_8?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1515,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -158,
    "LOC_Y": 218,
    "GAME_DATE": 20160316,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/16/0021501011/98/3b11e7f3-d874-463f-4bd8-b2624c301117_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444585113548111541",
    "name": "The 2974 Collection #1515",
    "imageUrl": "https://arweave.net/zY6On0rqccMx9dBAIhyctKgeIDu6PV1iU4p2QXThDdM?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1516,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -45,
    "LOC_Y": 264,
    "GAME_DATE": 20160316,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/16/0021501011/100/a62a9bae-f44b-097f-4230-3f2ab8f305b7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/435860091572807647",
    "name": "The 2974 Collection #1516",
    "imageUrl": "https://arweave.net/ZE5A4jpSFR4KianKfP50k9WHOrITW19298Lf1FBRkCg?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1517,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -186,
    "LOC_Y": 237,
    "GAME_DATE": 20160316,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/16/0021501011/102/a287b29f-e580-b4cd-668b-37971817f025_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568380264589915601",
    "name": "The 2974 Collection #1517",
    "imageUrl": "https://arweave.net/C1UBe_9_8_-MfwlYQ16T8MizTDpzYBxvk7GApPmR-Fs?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1518,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 79,
    "LOC_Y": 244,
    "GAME_DATE": 20160316,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/16/0021501011/189/4e6012a3-598e-5afc-fe93-a6b42a2a1548_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/393848042831845384",
    "name": "The 2974 Collection #1518",
    "imageUrl": "https://arweave.net/1fJv2UkYFrsVrtVd_MzkZvWdVIqO_grL0n4ttngEY5M?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1519,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 202,
    "LOC_Y": 151,
    "GAME_DATE": 20160316,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/16/0021501011/266/b2dd50fa-6b9c-c3b3-4ec6-0f610cc3bd64_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504470115571595900",
    "name": "The 2974 Collection #1519",
    "imageUrl": "https://arweave.net/--rQ8VZKoVnoo2b3UxZMOke_Bja6UK8BMhGxF4FT3KM?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1520,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 207,
    "LOC_Y": 154,
    "GAME_DATE": 20160316,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/16/0021501011/323/5c6dd0ef-c0e7-d51d-107a-1d55219243c6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/298150159255236086",
    "name": "The 2974 Collection #1520",
    "imageUrl": "https://arweave.net/0zW3HJon2aNeW6KIsi0NDXntQpp-unybtpvB3Wu34R8?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1521,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 7,
    "GAME_DATE": 20160316,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/16/0021501011/328/092f4c39-582a-7cea-6ac2-4a5db47b6e1b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/574085202129179853",
    "name": "The 2974 Collection #1521",
    "imageUrl": "https://arweave.net/xG4dqeYISH1Iwju65fhy2ZhZGoFnuMfWzbtjfaGs7dE?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1522,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -223,
    "LOC_Y": 100,
    "GAME_DATE": 20160318,
    "Season": "2015-2016",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/18/0021501026/8/6b5fb453-3e50-8ead-e479-156a261d77c7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479695255333761804",
    "name": "The 2974 Collection #1522",
    "imageUrl": "https://arweave.net/lzx3kn585Z-Zrq6sr3NrK3-gCcacuOicmfMjSmSQvlM?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1523,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -132,
    "LOC_Y": 214,
    "GAME_DATE": 20160318,
    "Season": "2015-2016",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/18/0021501026/19/86e6d5ee-3d92-0707-d6db-939ebe5cb945_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/409629591902604405",
    "name": "The 2974 Collection #1523",
    "imageUrl": "https://arweave.net/PVU6OR70qWKbKknxoQM8Lv2vucP9v9WFH0P_ZTQZ_Ks?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1524,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -217,
    "LOC_Y": 110,
    "GAME_DATE": 20160318,
    "Season": "2015-2016",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/18/0021501026/118/6ca1f001-534d-807b-090e-349cb45ec6ca_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499787729445376559",
    "name": "The 2974 Collection #1524",
    "imageUrl": "https://arweave.net/R5-2Xm8vDQMhcNQt-BHCo5xqLWWgNJo365fy0t3PPhA?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1525,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 163,
    "LOC_Y": 264,
    "GAME_DATE": 20160318,
    "Season": "2015-2016",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/18/0021501026/122/b452ea88-42de-f891-c327-ecb715112ee1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567632588680562774",
    "name": "The 2974 Collection #1525",
    "imageUrl": "https://arweave.net/wFsgW9lm9hbj0KFDfECxR6JOB2Zs9ubDtTrYl0g3OKY?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1526,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Turnaround Bank shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 235,
    "LOC_Y": 7,
    "GAME_DATE": 20160318,
    "Season": "2015-2016",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/18/0021501026/273/5a0679bc-01f4-d406-b1ad-6495ff58d78b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446772473886213849",
    "name": "The 2974 Collection #1526",
    "imageUrl": "https://arweave.net/mDFHHSrkBex3-kwhHfNhkfbV2SPVZn_tXLqhJElbmA8?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1527,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": 8,
    "GAME_DATE": 20160318,
    "Season": "2015-2016",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/18/0021501026/543/e0dc0185-0ed2-35c2-bb72-7c073b97993d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522628753027836980",
    "name": "The 2974 Collection #1527",
    "imageUrl": "https://arweave.net/SKbwAEflYcRWJkXmf1ktTH0-zOlZJt_1Q2XUG9DunSk?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1528,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 182,
    "LOC_Y": 210,
    "GAME_DATE": 20160319,
    "Season": "2015-2016",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/19/0021501036/294/49607c21-b3ab-ffa0-ad16-9513642b831a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336524150956318008",
    "name": "The 2974 Collection #1528",
    "imageUrl": "https://arweave.net/49nkpClCcQsOANOsOW9bw9jndU4Mhr7-WABB1s-rAZc?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 3,
    "Day": 19,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1529,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 86,
    "LOC_Y": 232,
    "GAME_DATE": 20160321,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/21/0021501050/54/182d175e-a5cf-2027-3308-79e857528862_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421683847469943802",
    "name": "The 2974 Collection #1529",
    "imageUrl": "https://arweave.net/l9zXEDMLjMmrImOTabbuIrA6aL6e-pqyuLQq1nIbNQ0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1530,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -107,
    "LOC_Y": 237,
    "GAME_DATE": 20160321,
    "Season": "2015-2016",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/21/0021501050/322/c5e59f50-70aa-c273-e0c7-d0d7901accbb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561181457262659008",
    "name": "The 2974 Collection #1530",
    "imageUrl": "https://arweave.net/AWu-FX-J7ItrKNp9SWDqxSgzRxGMLbYu4JYTMnVZBjc?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1531,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 13,
    "GAME_DATE": 20160323,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/23/0021501066/71/2b0b088a-8b84-5f4e-df40-eedf4724f060_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508559040561267067",
    "name": "The 2974 Collection #1531",
    "imageUrl": "https://arweave.net/Ivl5ABl569PoHyeKhOv9o7bSEwJhw3Xo1ZRRD5Y1mmE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1532,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -210,
    "LOC_Y": 136,
    "GAME_DATE": 20160323,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/23/0021501066/217/dd335b53-b7c9-a0cf-405b-434b621b48c6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336417397640622862",
    "name": "The 2974 Collection #1532",
    "imageUrl": "https://arweave.net/gngEDjJILUEMtD1d5qljz7B8jvf4C915TbF9MbE4pzg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1533,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -168,
    "LOC_Y": 200,
    "GAME_DATE": 20160323,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/23/0021501066/284/53fa7f66-cfa6-57cc-a606-3c6173c5e050_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546475183488990843",
    "name": "The 2974 Collection #1533",
    "imageUrl": "https://arweave.net/lCluQqSMYpPCXbqmShUbwTaQHJSZdjO54GIjrHpGH3U?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1534,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 120,
    "LOC_Y": 244,
    "GAME_DATE": 20160323,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/23/0021501066/503/740d3881-6fb4-3684-9620-25389123a9c7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/555413790373370897",
    "name": "The 2974 Collection #1534",
    "imageUrl": "https://arweave.net/n8pNf9x43LgMyW9cXHscQNQNvRpuZEDTzVGzc0n5gw8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1535,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 7,
    "GAME_DATE": 20160325,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/25/0021501080/12/cd9b01e2-f0dc-c092-7d3b-5ca45ddddee6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468965418498976155",
    "name": "The 2974 Collection #1535",
    "imageUrl": "https://arweave.net/WuEMKPNlbbTV8MyqRXRtRP50HAjEfPOUMeKZv4LhFbI?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1536,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -145,
    "LOC_Y": 247,
    "GAME_DATE": 20160325,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/25/0021501080/66/4c371528-2383-95ec-06a2-b47d8e5956b7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421178061470308114",
    "name": "The 2974 Collection #1536",
    "imageUrl": "https://arweave.net/qhkNOdU0poMMWs9PyBvWlhvswHeqIfI8ajwDJHAQXQo?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1537,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -205,
    "LOC_Y": 159,
    "GAME_DATE": 20160325,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/25/0021501080/104/5f45e9b2-f23a-5944-bdd4-c65614d35570_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420955188570567461",
    "name": "The 2974 Collection #1537",
    "imageUrl": "https://arweave.net/bIesisPCTqLHVyQCh2HrMLsKIW-KodEUOFf-9RBmRDY?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1538,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": -220,
    "LOC_Y": 247,
    "GAME_DATE": 20160325,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/25/0021501080/258/2b9a1d93-1c13-fc0d-1da6-fc0415b66495_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/471277312123151494",
    "name": "The 2974 Collection #1538",
    "imageUrl": "https://arweave.net/ewqtpt-qf7PYN_YCL3iROIHtPwB1LxeslBbVapW7Chk?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1539,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 235,
    "LOC_Y": -6,
    "GAME_DATE": 20160325,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/25/0021501080/360/192ef19c-05c7-83e0-ada4-e0397d56c65c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/332438723456954977",
    "name": "The 2974 Collection #1539",
    "imageUrl": "https://arweave.net/_UUfdmqbtO1DKYv5Y5cw0N0UdkbGS7gq1JApcC1B60U?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 3,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1540,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -166,
    "LOC_Y": 198,
    "GAME_DATE": 20160327,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/27/0021501094/205/e6859ff5-f572-87a5-1d98-2338631a9b47_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/486958025903371369",
    "name": "The 2974 Collection #1540",
    "imageUrl": "https://arweave.net/Qi1uoeVTQrpo7SQBl0xV2DXvxljxbaYOVeVMebqTyO8?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2016,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1541,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -173,
    "LOC_Y": 193,
    "GAME_DATE": 20160327,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/27/0021501094/342/33414ab9-a87e-a15d-1f57-43fde90da6f6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/466088269907292612",
    "name": "The 2974 Collection #1541",
    "imageUrl": "https://arweave.net/U_QwVjcVBrrXFtMy1zbCVzD_NCQSRNmfHPXLGLpu5PM?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2016,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1542,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 42,
    "LOC_Y": 247,
    "GAME_DATE": 20160329,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/29/0021501112/2/a9d0aa96-2e47-2046-2098-14320ec41dfd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/486150974649952037",
    "name": "The 2974 Collection #1542",
    "imageUrl": "https://arweave.net/CjS2T3DWBc5ukritxOZzkiv5kepctTYbNpMUbPWk2Gc?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1543,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 7,
    "GAME_DATE": 20160329,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/29/0021501112/93/e8ab5360-222a-34e7-6cf9-bfad966b81f7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295346840015945255",
    "name": "The 2974 Collection #1543",
    "imageUrl": "https://arweave.net/iMthrVPlugzlaf9_WlppYak2uaqWUTi9juXsrR9ekyI?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1544,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 56,
    "GAME_DATE": 20160329,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/29/0021501112/253/3fe62110-9223-61f0-1831-fae1d4be8725_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368837877722416204",
    "name": "The 2974 Collection #1544",
    "imageUrl": "https://arweave.net/vs8ek8gV2REqrmHlrAwKEAbcxbS4dSZMEPAvDtnUbRU?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1545,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 24,
    "LOC_Y": 272,
    "GAME_DATE": 20160329,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/29/0021501112/266/5a83228a-bd8f-7e96-7eb9-6794c9e3ac6f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474172659688620575",
    "name": "The 2974 Collection #1545",
    "imageUrl": "https://arweave.net/l5aBHF9i2MFbIBy3KiSW1bxtZLnz9h_ReLKaCmANAt0?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1546,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 155,
    "LOC_Y": 228,
    "GAME_DATE": 20160329,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/29/0021501112/315/99b88fc0-d33f-9f3a-c82b-9105d4a075a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543944642974543420",
    "name": "The 2974 Collection #1546",
    "imageUrl": "https://arweave.net/_wPooC830Lr0s4ARFPc3ig_C19VWoWLoCqx8huzfz-4?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1547,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -1,
    "LOC_Y": 278,
    "GAME_DATE": 20160329,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/29/0021501112/458/fd1d03a1-eb43-5876-e238-375d373f4960_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481087849669662972",
    "name": "The 2974 Collection #1547",
    "imageUrl": "https://arweave.net/kBzKydAtX073A5mfIPMDaM1yPEYuDI6x6afUvQD36JE?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2016,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1548,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -138,
    "LOC_Y": 205,
    "GAME_DATE": 20160330,
    "Season": "2015-2016",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/30/0021501119/67/78bec495-ba41-f753-0eb2-164c5a297a66_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407622213813911604",
    "name": "The 2974 Collection #1548",
    "imageUrl": "https://arweave.net/jeA3jrP33PgMSPfWuw9HbC-aWuoalOwPDijhuUQxBBs?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1549,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 195,
    "LOC_Y": 193,
    "GAME_DATE": 20160330,
    "Season": "2015-2016",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/30/0021501119/209/398b56f0-06b3-1a8c-bafc-39df8a37b162_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566641713890940830",
    "name": "The 2974 Collection #1549",
    "imageUrl": "https://arweave.net/r_f2PWQU_k_6hQ_7_vcOm5ArBIsTAqA9jVnzc9s0goU?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1550,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -153,
    "LOC_Y": 195,
    "GAME_DATE": 20160330,
    "Season": "2015-2016",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/30/0021501119/275/7a15d155-79b0-2e5b-d7ad-2981825a6e6d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/425131097840409235",
    "name": "The 2974 Collection #1550",
    "imageUrl": "https://arweave.net/t1_gOH1mxRjVtGgkhIn2IiNDheqF0RSeEhSC77s-Srg?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1551,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 230,
    "LOC_Y": 124,
    "GAME_DATE": 20160330,
    "Season": "2015-2016",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/30/0021501119/304/488204ef-4585-ef70-e0bf-37198bdc116d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476775327210360988",
    "name": "The 2974 Collection #1551",
    "imageUrl": "https://arweave.net/yopZQ2oCB058d7nUm4_9d5UOvgUp5e0h36a8x2ujFvc?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1552,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 109,
    "LOC_Y": 239,
    "GAME_DATE": 20160330,
    "Season": "2015-2016",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/03/30/0021501119/320/1585f47e-1112-4a36-ae00-5c8a03989b4c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334883402806609625",
    "name": "The 2974 Collection #1552",
    "imageUrl": "https://arweave.net/p4tdb8D7oDEvQF1GXLLPVcgpzn4CWwAdH7HA4VSXqeo?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 3,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1553,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 223,
    "LOC_Y": 120,
    "GAME_DATE": 20160401,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/01/0021501136/122/7d45aeea-7115-5fa6-6124-019d4602b9c2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567150984903800410",
    "name": "The 2974 Collection #1553",
    "imageUrl": "https://arweave.net/5wePjOxuffLbANSkDvjb4vBN9HMg64F8YXUH-cHBuUg?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1554,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 51,
    "LOC_Y": 272,
    "GAME_DATE": 20160401,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/01/0021501136/223/376ed4ce-156d-6580-ee72-0b7686e737e2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/570316040686900738",
    "name": "The 2974 Collection #1554",
    "imageUrl": "https://arweave.net/XpY6ANyrisFWv4hCoBdfbTv5EW4_6xTsSqtQVwEnx60?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1555,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -189,
    "LOC_Y": 188,
    "GAME_DATE": 20160401,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/01/0021501136/256/107a2d6a-1453-00e9-6f4a-c9a2a0e0fe3c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489342372102466429",
    "name": "The 2974 Collection #1555",
    "imageUrl": "https://arweave.net/ieMCcMGDitL4Kb8oIcKlMv-BXrf_5QKXuVb4rnWv8xs?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1556,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -227,
    "LOC_Y": 0,
    "GAME_DATE": 20160401,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/01/0021501136/259/54d22cb6-50cc-8436-cf42-38301c291b91_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/333097125672074110",
    "name": "The 2974 Collection #1556",
    "imageUrl": "https://arweave.net/YTh35o4Gca5ksEQ3s-dcGQyZPzyBAIHqatOc-ZHxemk?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1557,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 252,
    "GAME_DATE": 20160401,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/01/0021501136/324/06755a28-e967-0ff8-b3b6-8294f535100a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344799301153842919",
    "name": "The 2974 Collection #1557",
    "imageUrl": "https://arweave.net/p41IyKdpP2QD4Cc360s6l7B0iTS7lXELRgdrz_Vlizs?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1558,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 163,
    "LOC_Y": 213,
    "GAME_DATE": 20160401,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/01/0021501136/345/b97bb736-877a-cabc-bbc9-7276573e3f9a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515650560903003043",
    "name": "The 2974 Collection #1558",
    "imageUrl": "https://arweave.net/3zdrcCwpQfzATXn0_gC7i_dUadE8I-6xhGCu68o2wvg?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1559,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 34,
    "LOC_X": -55,
    "LOC_Y": 337,
    "GAME_DATE": 20160401,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/01/0021501136/360/00e557b3-f58b-d181-e92c-b6d7c229accf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300405480682630847",
    "name": "The 2974 Collection #1559",
    "imageUrl": "https://arweave.net/Ojee3ye979HUiuHcf7cC4-QVJqeC7YhhkNBApaP30oo?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1560,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": 62,
    "GAME_DATE": 20160401,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/01/0021501136/369/5d215495-139f-d2da-2c48-629c0a4c086f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317857631085475817",
    "name": "The 2974 Collection #1560",
    "imageUrl": "https://arweave.net/wLs5bR7z6CX53u33eJw6ogV2RH5Vu3QiCO02AYUgwDc?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1561,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 228,
    "LOC_Y": 41,
    "GAME_DATE": 20160403,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/03/0021501152/25/9ff7ced3-5849-7982-3b3b-e022ba06a511_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/303402592903933778",
    "name": "The 2974 Collection #1561",
    "imageUrl": "https://arweave.net/m8MqCHrxSd1NLKj_mSiXqZekfZlxi53kur81akJeKWo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1562,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 9,
    "LOC_Y": 247,
    "GAME_DATE": 20160403,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/03/0021501152/127/861ec8a7-0396-22b6-66f0-8f0c820da434_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/318161281679799884",
    "name": "The 2974 Collection #1562",
    "imageUrl": "https://arweave.net/G1mwPCoJv_hcKW_wbXhbm6M0ju8mqUkClNz61xNJGg4?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1563,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": -173,
    "LOC_Y": 282,
    "GAME_DATE": 20160403,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/03/0021501152/198/f7a2be9e-c169-b6b9-998e-73e78eb27e18_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438679658995637126",
    "name": "The 2974 Collection #1563",
    "imageUrl": "https://arweave.net/GZv7WAJp4dkttbUB8o_TxXqyBpgycVXcUT2VmGmyq-M?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1564,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -215,
    "LOC_Y": 139,
    "GAME_DATE": 20160403,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/03/0021501152/221/e47bdaf1-2fbd-5cd5-a65c-6ac57dd11f36_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330699393491082201",
    "name": "The 2974 Collection #1564",
    "imageUrl": "https://arweave.net/djxOgC29mtaOvtCTrZwaZyogqhe8ByY8_baJYSmJRhk?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1565,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -166,
    "LOC_Y": 208,
    "GAME_DATE": 20160403,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/03/0021501152/315/07a8c474-9111-cb1f-8fbe-f3806774768f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368875449353154518",
    "name": "The 2974 Collection #1565",
    "imageUrl": "https://arweave.net/vPPcyfV45lOgJjvlXCklbHXCPZL7NDAyYUEr2HP9Y-0?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1566,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -205,
    "LOC_Y": 156,
    "GAME_DATE": 20160403,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/03/0021501152/319/6f60569e-be90-32e1-d56a-d1409f85551d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536602639316169589",
    "name": "The 2974 Collection #1566",
    "imageUrl": "https://arweave.net/oxqvQvW_oj196_0xxfnzg1H9yyAxZk2PLRPVAXM4X-g?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1567,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 0,
    "LOC_Y": 262,
    "GAME_DATE": 20160403,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/03/0021501152/328/3f85dca3-d810-a912-5c5a-c5e1824e3890_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/469378781702505744",
    "name": "The 2974 Collection #1567",
    "imageUrl": "https://arweave.net/CWUV_Lpysw4Ovs2j9vGMJjkWBoSCUoWvgeEZkyRRkEs?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1568,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 192,
    "LOC_Y": 228,
    "GAME_DATE": 20160403,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/03/0021501152/330/ffe86617-fc61-697c-95b2-e064d16744f8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533890809110793168",
    "name": "The 2974 Collection #1568",
    "imageUrl": "https://arweave.net/DI6kNrRvvWahFMNff184RS6iCrTDFQ6iysF5KwAcbTs?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1569,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 140,
    "LOC_Y": 239,
    "GAME_DATE": 20160403,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/03/0021501152/485/523a5933-4b7b-d51d-cee2-a1bb2f369c78_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/431341462338725652",
    "name": "The 2974 Collection #1569",
    "imageUrl": "https://arweave.net/EFA1ydYWCTORrzuUtmpL_CtXdL7WubDN0MS-DUOVmdU?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 4,
    "Day": 3,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1570,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -11,
    "LOC_Y": 249,
    "GAME_DATE": 20160405,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/05/0021501163/271/7ff20a43-241d-f02c-92c2-897f4a18d622_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374642303274239924",
    "name": "The 2974 Collection #1570",
    "imageUrl": "https://arweave.net/zX-lk587ToQWsy3g09bxXb4EsvHkFkteE7iAu6_ytfY?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1571,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 200,
    "LOC_Y": 144,
    "GAME_DATE": 20160405,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/05/0021501163/338/cb00dc52-bcc1-6a0d-0e22-b930a10283cd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/514009273576195722",
    "name": "The 2974 Collection #1571",
    "imageUrl": "https://arweave.net/FBmRNl81F5zI0jN0FZfaPkBe9Ovlf4JrkeuHUNQDD34?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1572,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 186,
    "LOC_Y": 214,
    "GAME_DATE": 20160405,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/05/0021501163/344/33ed4b08-4834-1e17-41d3-44bb50d08e6f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422114782203607450",
    "name": "The 2974 Collection #1572",
    "imageUrl": "https://arweave.net/cMfboWFd33iVe_o1zS9Qb_L_GegAEndg4bxVTB_V1vY?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1573,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -1,
    "LOC_Y": 273,
    "GAME_DATE": 20160405,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/05/0021501163/346/73d3e9ab-9389-83a1-bd8c-2d548b2299ee_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443722910898857834",
    "name": "The 2974 Collection #1573",
    "imageUrl": "https://arweave.net/31Uk6hKqjLHgDoLe4312qZiObCY462lPcEdBo8OgbV4?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1574,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -158,
    "LOC_Y": 203,
    "GAME_DATE": 20160407,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/07/0021501177/187/796ead8d-a0db-0139-2c79-358def2a968c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418080860593771401",
    "name": "The 2974 Collection #1574",
    "imageUrl": "https://arweave.net/cLkvWC0J3NW86E0BmZdfsfQ5izUrrKCFO_0iATadYiY?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1575,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -4,
    "LOC_Y": 269,
    "GAME_DATE": 20160407,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/07/0021501177/277/f79ae21c-1742-a8ab-0193-3ea9d8ea0fd6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356066140276664379",
    "name": "The 2974 Collection #1575",
    "imageUrl": "https://arweave.net/erse3uxYcxca5tWVAEOvn8ihV2e2L40i40eYIKG156k?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1576,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 186,
    "LOC_Y": 174,
    "GAME_DATE": 20160407,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/07/0021501177/440/909f37e0-f89c-bb67-47a3-79519709ce79_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/410267779329615141",
    "name": "The 2974 Collection #1576",
    "imageUrl": "https://arweave.net/Xu7vTmsZcgXHh12i-HqpkRvBiKV_b0AOWk-3KpogFyg?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1577,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 9,
    "LOC_Y": 242,
    "GAME_DATE": 20160409,
    "Season": "2015-2016",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/09/0021501190/279/f877c112-d1c5-eb42-44ff-afc0ba3caec7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508832400726540625",
    "name": "The 2974 Collection #1577",
    "imageUrl": "https://arweave.net/9TsN9xqRuFU4iMRCalmwob3WOI_KmVGC442boOvI3eg?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1578,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 218,
    "LOC_Y": 120,
    "GAME_DATE": 20160409,
    "Season": "2015-2016",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/09/0021501190/361/e6fc3d76-39be-166c-4d53-930e0d5e85cf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/365147442561277946",
    "name": "The 2974 Collection #1578",
    "imageUrl": "https://arweave.net/S9tDhQySmgOJZ5LSet5_2exKkAb8rkHh-gi58vCpraQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1579,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 14,
    "LOC_Y": 257,
    "GAME_DATE": 20160409,
    "Season": "2015-2016",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/09/0021501190/457/1895dcc1-850c-2065-7155-726f02cd61e2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519384030456768984",
    "name": "The 2974 Collection #1579",
    "imageUrl": "https://arweave.net/0qxjobMxbGp9y_E0t0hf_0UmAr_v0nNIT7ZtRCpX5As?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1580,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 171,
    "LOC_Y": 174,
    "GAME_DATE": 20160410,
    "Season": "2015-2016",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/10/0021501201/66/5f9b0c89-6e7e-8afc-efa7-6f31c964a2ed_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363817329258157702",
    "name": "The 2974 Collection #1580",
    "imageUrl": "https://arweave.net/LI2a-eD70IoYk3mKc1vaV0hlKYeg8rVNB_4FZBTCKX4?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1581,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 9,
    "LOC_Y": 252,
    "GAME_DATE": 20160410,
    "Season": "2015-2016",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/10/0021501201/301/2d694eb1-03e0-9457-bafb-9611e27eecde_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300560853039332467",
    "name": "The 2974 Collection #1581",
    "imageUrl": "https://arweave.net/OCXg1cC4ol46xcUnk1PFqpdKkiK94kICN9u40Blo9o8?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1582,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 163,
    "LOC_Y": 180,
    "GAME_DATE": 20160410,
    "Season": "2015-2016",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/10/0021501201/304/8127ef54-9dd4-2105-434f-d566c362bbc5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513200245888865493",
    "name": "The 2974 Collection #1582",
    "imageUrl": "https://arweave.net/5KbWjqJnfkg-2701l5CA0P9s-q68Uh2N_PtxoMKajFM?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1583,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 220,
    "LOC_Y": 131,
    "GAME_DATE": 20160410,
    "Season": "2015-2016",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/10/0021501201/348/3780ff84-0a0f-537b-6335-48e7fbe83170_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501604987798227088",
    "name": "The 2974 Collection #1583",
    "imageUrl": "https://arweave.net/Ii3GTeq-H9NFrmODHOCN1T28SLQQ0VhZYdWE3OChFT8?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1584,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 123,
    "LOC_Y": 242,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/30/5b55256d-5352-3af7-1b6a-0f3e3ac15b37_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/343433753358270262",
    "name": "The 2974 Collection #1584",
    "imageUrl": "https://arweave.net/d7uu8F-w4jn32Mj8U1B35Abn3CcH44MsxhoXEGH9AIw?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1585,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 82,
    "LOC_Y": 242,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/40/3251b62f-22a2-6497-9958-5d9c4c8a67c1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392884419419290186",
    "name": "The 2974 Collection #1585",
    "imageUrl": "https://arweave.net/cylr9AjvRmdkf8qKd8q9kwwp_ZX7oquLF5YAeH25g8U?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1586,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 0,
    "LOC_Y": 313,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/77/2418aa82-b970-89ee-8fa6-e488fda50af6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397106688644459038",
    "name": "The 2974 Collection #1586",
    "imageUrl": "https://arweave.net/VeKkZw7GtGgZ1skhQBJwTa8gyoIf7a167nY7IIV4mTM?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1587,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -89,
    "LOC_Y": 252,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/80/cfd74842-4615-0cdc-b524-c9bef8a2f887_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402685689655371738",
    "name": "The 2974 Collection #1587",
    "imageUrl": "https://arweave.net/F8VwbhnxO0hsDCXocFrtvaIU_PhUz7wawn4BcMg5PFY?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1588,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -142,
    "LOC_Y": 237,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/83/e6605de4-f1ef-9144-76fa-c16da07da782_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422930343292739851",
    "name": "The 2974 Collection #1588",
    "imageUrl": "https://arweave.net/lkQNl-YNeQmhdqvkTE8gcsqpyJ4cO08cX5qrPN00BXo?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1589,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 171,
    "LOC_Y": 183,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/108/7e683f1c-19dc-dc6a-f21c-fccb0b5a662f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544168817327489202",
    "name": "The 2974 Collection #1589",
    "imageUrl": "https://arweave.net/k2ggtevnCQim19Ye8D73MgG9mVO3DmzkCZ4HhPsPsRg?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1590,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 84,
    "LOC_Y": 252,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/228/34571e57-85f4-4c50-1329-6beaa6621e28_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366360503264997684",
    "name": "The 2974 Collection #1590",
    "imageUrl": "https://arweave.net/ZeAOnrf2VBZH8bMYAhbaCpBBzhH0zx1oO4p7RexwNeo?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1591,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 51,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/268/bd7f788f-a7b7-c1eb-5d21-4cc96d0b32fc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493326005756750198",
    "name": "The 2974 Collection #1591",
    "imageUrl": "https://arweave.net/1Jm0EHgtm8qW2c1C-YgGgnHKuK7PKaI8PsHNJyAoshU?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1592,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 1,
    "LOC_Y": 308,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/281/375171c2-26b0-e9b1-ae9c-45a95ef40150_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366220554854553143",
    "name": "The 2974 Collection #1592",
    "imageUrl": "https://arweave.net/wuv7oYgzV_Nk5NkcUXVTavUXX68F7rYZJYe70mIf5BI?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1593,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 235,
    "LOC_Y": 67,
    "GAME_DATE": 20160413,
    "Season": "2015-2016",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/04/13/0021501227/375/807cc3d3-5d00-aa4d-78fe-4fb9fcff4e8b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392858140876745322",
    "name": "The 2974 Collection #1593",
    "imageUrl": "https://arweave.net/jyF8ajnD4Ik9kmVcTDftljvRWvJFZAg-yDIakG7SWuE?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 4,
    "Day": 13,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game (Team 73rd Win)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1594,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 189,
    "LOC_Y": 174,
    "GAME_DATE": 20161025,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/25/0021600003/28/5256ac82-d25a-c39b-0e38-c4ce611420f5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290492630616172012",
    "name": "The 2974 Collection #1594",
    "imageUrl": "https://arweave.net/n2D3dIBuBXSE51POgtC32DDimQDMTI0ASMuxn9XwW2s?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 10,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1595,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -9,
    "LOC_Y": 267,
    "GAME_DATE": 20161025,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/25/0021600003/184/97d6efb6-8c11-8a78-8cd3-3df4800cacc3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322712707255267015",
    "name": "The 2974 Collection #1595",
    "imageUrl": "https://arweave.net/p7Xkl5l9tlRoj9eLYzvpcPxa8W8QdLxQ2lrEHIb16zc?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 10,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1596,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 114,
    "LOC_Y": 247,
    "GAME_DATE": 20161025,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/25/0021600003/223/2e8a2308-d87a-d8b5-4d07-c07f50686084_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/466958041307843316",
    "name": "The 2974 Collection #1596",
    "imageUrl": "https://arweave.net/Le-B-oB9RAse0oCqVPq3eXq2L9CziE4vJ1NX7wlQFGI?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2016,
    "Month": 10,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1597,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -107,
    "LOC_Y": 228,
    "GAME_DATE": 20161028,
    "Season": "2016-2017",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/28/0021600025/10/558bedf0-3222-da74-4ea0-8e8d28048920_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/557212613460386524",
    "name": "The 2974 Collection #1597",
    "imageUrl": "https://arweave.net/rVs3va2LEEDcsAuLwjTXpeTvFhxQR7mEUJ_3z63-NLs?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1598,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 105,
    "LOC_Y": 242,
    "GAME_DATE": 20161028,
    "Season": "2016-2017",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/28/0021600025/218/6b3831bb-b7b1-2cb5-f0ab-f4e2a0ebfd3d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519954832916936851",
    "name": "The 2974 Collection #1598",
    "imageUrl": "https://arweave.net/kg6zJeNxJmeetkR0hwLMkj1RTFcdAB-58ODbd-r57s8?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1599,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -1,
    "GAME_DATE": 20161028,
    "Season": "2016-2017",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/28/0021600025/379/1209413d-9c4a-edfb-b73b-0adef89311f2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/316892633706005797",
    "name": "The 2974 Collection #1599",
    "imageUrl": "https://arweave.net/HVHiEYUWqeirWEnFWejcjyVDVHnltR35f3h957TTUcg?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1600,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -138,
    "LOC_Y": 262,
    "GAME_DATE": 20161028,
    "Season": "2016-2017",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/28/0021600025/434/ee2117d6-9743-87a7-14f8-7116c7cd77a7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485200773278569294",
    "name": "The 2974 Collection #1600",
    "imageUrl": "https://arweave.net/tE8QDJMyCJ3j6QAmmwST1WEPeAmxhd6wjj7OIKB3HGs?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1601,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 1,
    "LOC_Y": 252,
    "GAME_DATE": 20161030,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/30/0021600036/19/7a8a0ed9-98b8-0a9a-14b1-84193ffb2a5b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548484289847374776",
    "name": "The 2974 Collection #1601",
    "imageUrl": "https://arweave.net/fvAHOBS6Pv-vKCHyeSvp9W8Ja04773nt71bERS7WhfA?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1602,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -147,
    "LOC_Y": 214,
    "GAME_DATE": 20161030,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/30/0021600036/35/a2a1a8ad-51e6-8b61-acda-d2407de7dbe6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561136601095030961",
    "name": "The 2974 Collection #1602",
    "imageUrl": "https://arweave.net/gZpX49hK0Cc8HN8TN6685eC2ZmrC9d9FZ9vIhrnDuDA?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1603,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 235,
    "LOC_Y": 120,
    "GAME_DATE": 20161030,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/30/0021600036/199/a4a54453-a44c-bb6f-95d4-0938e91c30bd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360247942652542327",
    "name": "The 2974 Collection #1603",
    "imageUrl": "https://arweave.net/xR-XPR4hN7T2k8zFmRKWwNTOEnx5zKa_DxmzBguTq9E?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1604,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 236,
    "LOC_Y": 11,
    "GAME_DATE": 20161030,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/30/0021600036/224/5fa9420c-de0d-3ea1-78e7-6fa8ae21d326_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511608028128649372",
    "name": "The 2974 Collection #1604",
    "imageUrl": "https://arweave.net/xKyIookabMbRaVzMOU5LSFiH7H45ZTnNRLtsNC_diqw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1605,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -91,
    "LOC_Y": 252,
    "GAME_DATE": 20161030,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/10/30/0021600036/350/2ca479a5-0525-ff91-9468-28d52f716a39_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293549270534362109",
    "name": "The 2974 Collection #1605",
    "imageUrl": "https://arweave.net/y7RKmhG69NEpPtt4owVI9QmnA1Ob3SUA8xi_xn5OK7E?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1606,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -210,
    "LOC_Y": 203,
    "GAME_DATE": 20161101,
    "Season": "2016-2017",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/01/0021600054/303/247fcb73-1471-a631-315b-ebca3e8e5872_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/516732751341432809",
    "name": "The 2974 Collection #1606",
    "imageUrl": "https://arweave.net/6xzWA5NSrOVVhHHddOmVxPo3-NPJII2x2BBjkIWqq30?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 11,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1607,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 81,
    "LOC_Y": 232,
    "GAME_DATE": 20161101,
    "Season": "2016-2017",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/01/0021600054/309/7566a318-95be-0425-c163-04a9847c3ab7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/304865321099740581",
    "name": "The 2974 Collection #1607",
    "imageUrl": "https://arweave.net/5CBImjaP9-ZogSLQ9YGG4GVlI3yxgiKqgZenevfkECg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 11,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1608,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -2,
    "LOC_Y": 288,
    "GAME_DATE": 20161101,
    "Season": "2016-2017",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/01/0021600054/323/89525f83-5e65-f024-63e1-5adf2cd00731_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513298227542235647",
    "name": "The 2974 Collection #1608",
    "imageUrl": "https://arweave.net/CD-Jt8kFalFHb_pNYaWeKjJX7JbBntkRIInkO14fVRw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 11,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1609,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": 11,
    "GAME_DATE": 20161101,
    "Season": "2016-2017",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/01/0021600054/376/05531ef5-fa11-d81f-4ca2-1e1a3091f4f9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301830397530299214",
    "name": "The 2974 Collection #1609",
    "imageUrl": "https://arweave.net/R_jOA_DyPazF68DVtH3nOzIRcrhJceMXsmE0c93Trgo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 11,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1610,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 104,
    "LOC_Y": 229,
    "GAME_DATE": 20161101,
    "Season": "2016-2017",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/01/0021600054/418/11c72a04-3611-2fd4-6c28-2accbd041230_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323593945940832580",
    "name": "The 2974 Collection #1610",
    "imageUrl": "https://arweave.net/sFqcz64iD8lHpxS9cU26bOGpUT1JIlqjn-UdALoEyoo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 11,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1611,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 218,
    "LOC_Y": 144,
    "GAME_DATE": 20161103,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/03/0021600069/362/5ca83035-5a34-8fb2-393a-dbb4ff3d4b44_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/542324612741702694",
    "name": "The 2974 Collection #1611",
    "imageUrl": "https://arweave.net/-k3zFkenV3lLdCrLSG4ik5BQU1-VS__luRSJSf3Aij8?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 11,
    "Day": 3,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1612,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 26,
    "GAME_DATE": 20161103,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/03/0021600069/379/610e9efe-f540-1e58-2cf1-7080e07e7bb6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429805373363692312",
    "name": "The 2974 Collection #1612",
    "imageUrl": "https://arweave.net/cyigkS2-2EUHnZI9NxRwmmy-1XIoYXoEAkwY7w1Yl-A?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2016,
    "Month": 11,
    "Day": 3,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1613,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -196,
    "LOC_Y": 228,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/47/7b8ae87e-4e67-5913-0b00-524e55d468f3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/505238813376303372",
    "name": "The 2974 Collection #1613",
    "imageUrl": "https://arweave.net/tl99w4m-EHZyFj5aw74iWgzxF8kpfRD-muMA1qlHV3o?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1614,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -184,
    "LOC_Y": 203,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/82/0aa64670-4017-7785-7322-dd134daadf60_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566384045081823010",
    "name": "The 2974 Collection #1614",
    "imageUrl": "https://arweave.net/cWg4O-Lra6kov-ST0Hi1JW1hnb8o3yPZsDHFAbV5_ts?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1615,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 31,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/91/6338f399-f466-fc11-0d2b-5b91a60ad5c4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328425229185620665",
    "name": "The 2974 Collection #1615",
    "imageUrl": "https://arweave.net/5FwtrJPaMaUkw8aAtGMYJcCGzD44M5TB4jXToUpsCu8?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1616,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -201,
    "LOC_Y": 165,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/196/5c05f0b6-9ae0-61eb-b252-f75b4de45a3e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326970769087215207",
    "name": "The 2974 Collection #1616",
    "imageUrl": "https://arweave.net/yXQxvXI3vD37nBdYrSt7YIfVS0HrsL0gqHYXyypmpyA?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1617,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -207,
    "LOC_Y": 183,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/202/e7ddbf62-2f5a-2a44-519f-6464f4adf01f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/316961147705155304",
    "name": "The 2974 Collection #1617",
    "imageUrl": "https://arweave.net/-owIqLilr6VYEeq20CnOau6zCv7R0JFzK5vd6sYRV1o?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1618,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -16,
    "LOC_Y": 259,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/209/576faf3d-4eff-7eb9-93de-405460904d51_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556102290919916406",
    "name": "The 2974 Collection #1618",
    "imageUrl": "https://arweave.net/-8gGwEQjZx7C7jk7_Nw2kE2l_z7I23VPi3Z4yVrfZJs?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1619,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 19,
    "LOC_Y": 262,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/265/30259cac-b205-918a-cb27-6a101393f945_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/442895737183748995",
    "name": "The 2974 Collection #1619",
    "imageUrl": "https://arweave.net/CZ-LOQhAHgerjtj0yQRxagnPW0pzyClHAtP2rBaZMoc?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1620,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -120,
    "LOC_Y": 228,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/339/c1be7b8e-c2e1-0a2c-fe7e-e1e3f8bfd53b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/303728957987228304",
    "name": "The 2974 Collection #1620",
    "imageUrl": "https://arweave.net/ByPgCGej2xHa-m7xoToID4Ialr5JtYJYgG3V8LRcmZk?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1621,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -91,
    "LOC_Y": 252,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/365/7cfe78f8-8582-ba80-26e9-4923df421c64_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309866814894196860",
    "name": "The 2974 Collection #1621",
    "imageUrl": "https://arweave.net/_PgEPphxy13qgD95XdllpxqHbRfzezIUhH9YEq2HE08?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1622,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -196,
    "LOC_Y": 154,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/388/a6d1f6d6-49d7-96f5-6449-9ada01e3215f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458921975389189705",
    "name": "The 2974 Collection #1622",
    "imageUrl": "https://arweave.net/konsCZQH3z7tVyjHTDipgAIX4QKSpSUk45xL5CIrnVg?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1623,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -194,
    "LOC_Y": 159,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/466/06ff2e47-1fed-42fc-9206-b473ae542e00_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/416624922713823065",
    "name": "The 2974 Collection #1623",
    "imageUrl": "https://arweave.net/td-nOOppWfOL0KlSYGHi_lHzui94pRZSF6soT4q_xJ4?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1624,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -89,
    "LOC_Y": 237,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/468/677b6e4e-a1fd-5e1a-77b1-846eeb246a9d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508001777612278796",
    "name": "The 2974 Collection #1624",
    "imageUrl": "https://arweave.net/9GPTOhAea3SlNvtvt1vPILwHM0P3eYiFzvM76hFWNf4?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1625,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 71,
    "LOC_Y": 252,
    "GAME_DATE": 20161107,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/07/0021600099/471/10f14915-8711-63f2-4bd2-6e9518c273d6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450465808771163775",
    "name": "The 2974 Collection #1625",
    "imageUrl": "https://arweave.net/yFXSnVTPn23ej1XLAVyOS5eg9uz8h224D2NjFFfmV-E?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 13,
    "Special Moment": "Thirteen 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1626,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -137,
    "LOC_Y": 277,
    "GAME_DATE": 20161109,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/09/0021600116/138/7d5f6ef2-c2fc-888b-652e-2593181239eb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382835097794744759",
    "name": "The 2974 Collection #1626",
    "imageUrl": "https://arweave.net/zvzkjpqLO5LY3fqyabD_DKmX6RB2rZ6woWldxtw_R2Q?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1627,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 182,
    "LOC_Y": 178,
    "GAME_DATE": 20161109,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/09/0021600116/177/a646e6d4-4080-49b5-5f88-950ac3a1a7a7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/506140693238612681",
    "name": "The 2974 Collection #1627",
    "imageUrl": "https://arweave.net/K0EkoeaW6dLw6gyRAWeMtPxEu9DZSlDQc_Jbzbl6PlA?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1628,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -14,
    "LOC_Y": 267,
    "GAME_DATE": 20161109,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/09/0021600116/312/54e23de8-092c-b4e6-86d8-2d3d41a11564_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/535843758334087173",
    "name": "The 2974 Collection #1628",
    "imageUrl": "https://arweave.net/k_2i7o23rT_UQ7cqZPJKcq-YilPTRC-jhE3QNpzL6mM?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1629,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": 127,
    "LOC_Y": 301,
    "GAME_DATE": 20161109,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/09/0021600116/396/8ebf52ef-b580-d596-3b42-ba5e2f74b96a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/396951120073859997",
    "name": "The 2974 Collection #1629",
    "imageUrl": "https://arweave.net/qORYxV1o5MOWAQGcwkRzF8LSPkp4FmCY6_B5MWSfHcc?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 11,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1630,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -147,
    "LOC_Y": 208,
    "GAME_DATE": 20161110,
    "Season": "2016-2017",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/10/0021600119/46/590b83a5-e1f6-329d-42c1-f6aae42fbd0e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/448051819573716304",
    "name": "The 2974 Collection #1630",
    "imageUrl": "https://arweave.net/4gLYvvuCtQcNIPSmb7qLtUmblU7jQwgM_ywAcq-Qud0?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1631,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -148,
    "LOC_Y": 205,
    "GAME_DATE": 20161110,
    "Season": "2016-2017",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/10/0021600119/108/61acb4d8-63a3-db02-c8a5-8a5041a15c51_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531714575701756282",
    "name": "The 2974 Collection #1631",
    "imageUrl": "https://arweave.net/IAkW305W50GBYpL_nIV5PlRmyMH2anYY8HoNm4DiJXo?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1632,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -156,
    "LOC_Y": 198,
    "GAME_DATE": 20161110,
    "Season": "2016-2017",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/10/0021600119/136/f0a3bb87-e7d1-10e1-9164-afa612357e55_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484692600712014714",
    "name": "The 2974 Collection #1632",
    "imageUrl": "https://arweave.net/hnSFZy1nwaLQX74pkLK_WCbk1pfQloM6u1NfNye0daQ?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1633,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 68,
    "LOC_Y": 242,
    "GAME_DATE": 20161110,
    "Season": "2016-2017",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/10/0021600119/335/2ee01fc4-d54a-d27d-cd0f-ec1d88e4d5a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290091255897958580",
    "name": "The 2974 Collection #1633",
    "imageUrl": "https://arweave.net/W8_j7JDrR_-djbtfu0RQJALGwYsEFE2kIxqrE1O5n-E?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1634,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -201,
    "LOC_Y": 149,
    "GAME_DATE": 20161110,
    "Season": "2016-2017",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/10/0021600119/344/04a926b1-9823-5b64-8ec8-aed6206de154_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/452863777299244001",
    "name": "The 2974 Collection #1634",
    "imageUrl": "https://arweave.net/V56aFk0Wm2N4PZFF3cvaXN-K2jfxHMctVcVkPm6-qIg?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1635,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -176,
    "LOC_Y": 232,
    "GAME_DATE": 20161110,
    "Season": "2016-2017",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/10/0021600119/370/07bdb7e3-fb40-6668-032d-8ed51a497879_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/303117560741745924",
    "name": "The 2974 Collection #1635",
    "imageUrl": "https://arweave.net/4k-Ma9C6aA-6KBoRbmuM17WPfPkm6lVJHpWsYrQbi5s?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1636,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -205,
    "LOC_Y": 195,
    "GAME_DATE": 20161110,
    "Season": "2016-2017",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/10/0021600119/378/a93a5830-0254-25cb-50fc-74d380ee49a9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510224886201963512",
    "name": "The 2974 Collection #1636",
    "imageUrl": "https://arweave.net/ApA0l9y3-ybSsC0q8HT4k_DGdKsUAKi5bSx1MEXLBFs?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2016,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1637,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 18,
    "GAME_DATE": 20161113,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/13/0021600143/31/51977d58-2bb6-c85e-bd34-fdab11ea346f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349002027282011319",
    "name": "The 2974 Collection #1637",
    "imageUrl": "https://arweave.net/otoYm7Kgd7ZtjMN0mlEQCb-oF1v646jibGnKbVGWbmA?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 11,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1638,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 46,
    "LOC_Y": 252,
    "GAME_DATE": 20161113,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/13/0021600143/197/e308d676-ce1e-73a5-8d67-078f4737918d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/409797945421060486",
    "name": "The 2974 Collection #1638",
    "imageUrl": "https://arweave.net/Nl2JVkK7JkiQSJ-JGxTaVkURrVhujD9sjn8en4l_U9A?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 11,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1639,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -94,
    "LOC_Y": 249,
    "GAME_DATE": 20161113,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/13/0021600143/242/f4de86c8-9ca7-7c4d-4753-062dbae90dd1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/554218316594614888",
    "name": "The 2974 Collection #1639",
    "imageUrl": "https://arweave.net/BbN-o9xAtIZRjkD1OFEpVc_16gsoCYLSS3O3UVxHBn8?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 11,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1640,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 28,
    "LOC_Y": 247,
    "GAME_DATE": 20161113,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/13/0021600143/365/6719ca9f-c380-eaf5-b6a9-cf1330d7fa89_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/494517940074300973",
    "name": "The 2974 Collection #1640",
    "imageUrl": "https://arweave.net/GtXhzHomNlPYQ3-IwDuiuI5-TmCwKKvQLV4caG6yf3A?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 11,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1641,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 15,
    "LOC_Y": 272,
    "GAME_DATE": 20161113,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/13/0021600143/385/2f8a1a4a-5e21-35a2-1b11-50eca5245174_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518638599614492902",
    "name": "The 2974 Collection #1641",
    "imageUrl": "https://arweave.net/2kdZ19EZsPvx6q-PBqeoZF5zSnvRV2w6f3BaRbiU6hI?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 11,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1642,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 192,
    "LOC_Y": 156,
    "GAME_DATE": 20161116,
    "Season": "2016-2017",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/16/0021600165/222/06bb283d-19aa-490d-915f-651333039ce9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418391515541228929",
    "name": "The 2974 Collection #1642",
    "imageUrl": "https://arweave.net/aklYyXuLZfNVnuwDEkdwKhMTeCr9TJJHqkKxOceIB0o?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2016,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1643,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 168,
    "LOC_Y": 205,
    "GAME_DATE": 20161116,
    "Season": "2016-2017",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/16/0021600165/435/3db3e7bf-d562-47a9-a44b-6b2766f5de83_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367006996342732812",
    "name": "The 2974 Collection #1643",
    "imageUrl": "https://arweave.net/EXp_6GVIZrNVRtd1VziJB60X7L-fjEwfM4lcCbhp-y8?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2016,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1644,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 143,
    "LOC_Y": 208,
    "GAME_DATE": 20161116,
    "Season": "2016-2017",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/16/0021600165/442/ddeceb0a-a8c7-9472-9c29-c5b442ee276f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/452246459795613804",
    "name": "The 2974 Collection #1644",
    "imageUrl": "https://arweave.net/p4P7GwZILrrGzI7wCiAwIWFzyFm1mIdC3LlatnFlc4E?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2016,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1645,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 10,
    "LOC_Y": 257,
    "GAME_DATE": 20161118,
    "Season": "2016-2017",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/18/0021600179/284/a09a4c87-ea5f-3e33-5a2d-0fb3044e8053_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512956110845401658",
    "name": "The 2974 Collection #1645",
    "imageUrl": "https://arweave.net/1AFSzUdPYesChqjtKDWxyikTityXHYXR6INf8ykNp5E?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1646,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 57,
    "GAME_DATE": 20161118,
    "Season": "2016-2017",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/18/0021600179/484/dc0747f1-60f0-79e1-a2a9-34e69e84135a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/377136343793758231",
    "name": "The 2974 Collection #1646",
    "imageUrl": "https://arweave.net/P2sY5vEBZd3yohLQDghFFMyV5M8RLXMlI2rPCH8T5fU?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2016,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1647,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 41,
    "GAME_DATE": 20161119,
    "Season": "2016-2017",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/19/0021600191/270/1ffcb6c7-54bf-62d2-2fa1-0d8e375a7378_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478779132836248614",
    "name": "The 2974 Collection #1647",
    "imageUrl": "https://arweave.net/WH1uRT8t8Pc7D-ZzZybNJEgM0k7PMuWCZN2DlaklMmM?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2016,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1648,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 179,
    "LOC_Y": 178,
    "GAME_DATE": 20161121,
    "Season": "2016-2017",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/21/0021600202/219/cf38a130-8227-5718-d517-102c1a5c5cfe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/409308252396561856",
    "name": "The 2974 Collection #1648",
    "imageUrl": "https://arweave.net/2nLrRmZirGBrp92yc7Jw0r6xL1iXom6VY0LuCsWRAK4?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 11,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1649,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 215,
    "LOC_Y": 139,
    "GAME_DATE": 20161121,
    "Season": "2016-2017",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/21/0021600202/269/f9f108e8-c4a2-c852-fffa-b0097b11ae0f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558250183174516227",
    "name": "The 2974 Collection #1649",
    "imageUrl": "https://arweave.net/ViO1NM2yuOzsxZvzn_fuVq3okQ9CkPRrISeabP391pA?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 11,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1650,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -215,
    "LOC_Y": 146,
    "GAME_DATE": 20161123,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/23/0021600223/18/a61f012c-ea0c-add5-cbb7-55c9681df574_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/398631182456604096",
    "name": "The 2974 Collection #1650",
    "imageUrl": "https://arweave.net/uDIvGBIQGtHgRZROehZXhd3-8F1_3gYgUJd_pOQOHDE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1651,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 94,
    "LOC_Y": 252,
    "GAME_DATE": 20161123,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/23/0021600223/21/70c018f7-3945-0690-8eb5-a2d4eddd4cac_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374835081322168826",
    "name": "The 2974 Collection #1651",
    "imageUrl": "https://arweave.net/GP4hi1b7Vn1xNNdLRIZcoum16WCQCYie3hFgsN58iRo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1652,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -169,
    "LOC_Y": 203,
    "GAME_DATE": 20161123,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/23/0021600223/90/acf714ed-2823-54a6-72f3-c5eb2336ef7e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369715605988493521",
    "name": "The 2974 Collection #1652",
    "imageUrl": "https://arweave.net/WJrPY4efm9bf49MUvIJ0-IILJ9RpZESlkokdEJOolfE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1653,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -187,
    "LOC_Y": 188,
    "GAME_DATE": 20161123,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/23/0021600223/117/e19db42c-78bc-9fb9-dc8f-b78d70bbe43b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397958153685643382",
    "name": "The 2974 Collection #1653",
    "imageUrl": "https://arweave.net/iwHwP_TtsJMTRehsCFmAba80Ew0-3sO8Cmq1-6fEr0I?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1654,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -38,
    "LOC_Y": 262,
    "GAME_DATE": 20161123,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/23/0021600223/233/f9726935-ddc5-58b5-87cf-50f701acf629_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352335968373812528",
    "name": "The 2974 Collection #1654",
    "imageUrl": "https://arweave.net/09eUQPmOZYfUOE_Nh_02-_aYXGJB5JzxF4LHPNdfvTM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1655,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -199,
    "LOC_Y": 164,
    "GAME_DATE": 20161123,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/23/0021600223/249/6dfe6ad0-f3bf-3c04-48fb-4fb24439aa13_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336996585508694881",
    "name": "The 2974 Collection #1655",
    "imageUrl": "https://arweave.net/PPSLHqWIrQjKNUpUtG-GfW6rZLm6bQE2PfnPylFWGu8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1656,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 232,
    "LOC_Y": 65,
    "GAME_DATE": 20161123,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/23/0021600223/349/332faf74-2a5c-e478-116b-ed7a60bba9c1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395008332607999465",
    "name": "The 2974 Collection #1656",
    "imageUrl": "https://arweave.net/jSWDSYhUx0jSbej738uOluVWwo-eeJgfxpDJKfie5-E?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1657,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 1,
    "GAME_DATE": 20161125,
    "Season": "2016-2017",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/25/0021600238/65/fd709951-e215-0f26-ea63-d8d2351f8ce6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/514330059905343970",
    "name": "The 2974 Collection #1657",
    "imageUrl": "https://arweave.net/pdUVPvav0o9tMvso_Xg1N6Xb-kJJVR2UP0lGVH3A1ww?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1658,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -131,
    "LOC_Y": 214,
    "GAME_DATE": 20161125,
    "Season": "2016-2017",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/25/0021600238/100/9befc963-b8d2-ec4e-525f-ad7e40448788_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/463559893466169675",
    "name": "The 2974 Collection #1658",
    "imageUrl": "https://arweave.net/pUufaEPWrm6wEPgKcNJj4wkjVh-GeY31El5oQXxz1RE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1659,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 122,
    "LOC_Y": 241,
    "GAME_DATE": 20161125,
    "Season": "2016-2017",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/25/0021600238/391/7f0b04e2-1faf-6289-a95d-d1535efa63b5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368819128626886196",
    "name": "The 2974 Collection #1659",
    "imageUrl": "https://arweave.net/fOLMuUDHiBhc6sEgR4F6NfmVKJ3T3Bd2vgSD1NcrrNw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1660,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 5,
    "LOC_Y": 246,
    "GAME_DATE": 20161125,
    "Season": "2016-2017",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/25/0021600238/462/9ef6d92e-9756-20a4-4262-24600c3a6c90_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/358991493248314158",
    "name": "The 2974 Collection #1660",
    "imageUrl": "https://arweave.net/6iWbXHtbQaHjc8JEMTgk8WT0QildHoVszXP00odZxgk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2016,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1661,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -238,
    "LOC_Y": 70,
    "GAME_DATE": 20161126,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/26/0021600244/14/6a0fc94c-28f1-4c27-75da-46d97b3c0962_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524095181427400265",
    "name": "The 2974 Collection #1661",
    "imageUrl": "https://arweave.net/1GqdDOIwxwbgi7mOWQfBNecl412QEPEkFeFQ0noXZDQ?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1662,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -142,
    "LOC_Y": 249,
    "GAME_DATE": 20161126,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/26/0021600244/258/9498b977-522e-2c02-9200-7be57b46eeb6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/463033582667592540",
    "name": "The 2974 Collection #1662",
    "imageUrl": "https://arweave.net/oOHiy-Zah2IipPDotJWPe23rJ8mSLSUNc4Ou-l7RXvA?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1663,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": 26,
    "GAME_DATE": 20161126,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/26/0021600244/329/cd6b73b4-1dd6-2ac8-cc38-3b235a984523_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429429527759106605",
    "name": "The 2974 Collection #1663",
    "imageUrl": "https://arweave.net/19bOc89b2s7N9Go_IGJP2P8Q3WQWll8ZJUPLBbysXYs?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1664,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -106,
    "LOC_Y": 272,
    "GAME_DATE": 20161126,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/26/0021600244/333/2c8a7227-b708-49d3-6538-7d9c53e32d39_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359718913469758393",
    "name": "The 2974 Collection #1664",
    "imageUrl": "https://arweave.net/9t8EziMSpUsk1_jl9lDX_aRN5BvcSC_gk3c4MWsmmWA?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1665,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -196,
    "LOC_Y": 170,
    "GAME_DATE": 20161128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/28/0021600259/10/08fc03fd-62c3-b681-2b82-2fc40e93832f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397491951804647358",
    "name": "The 2974 Collection #1665",
    "imageUrl": "https://arweave.net/LaUHopwSTjhx8ZBAnoydUAigqFzdd28WE6qHXgQfqFU?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2016,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1666,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -169,
    "LOC_Y": 213,
    "GAME_DATE": 20161128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/28/0021600259/102/4bf33562-2788-3bcf-4041-0345303f2706_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371753917325099821",
    "name": "The 2974 Collection #1666",
    "imageUrl": "https://arweave.net/hpvVpzdWY33TOLweU1SfqQ56mqDYvNhDGtTiR-LVF8I?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2016,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1667,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 104,
    "LOC_Y": 228,
    "GAME_DATE": 20161128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/28/0021600259/331/39d94502-b138-cb82-f884-be4e072eca48_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/427665277447683490",
    "name": "The 2974 Collection #1667",
    "imageUrl": "https://arweave.net/F86H55oWJ98mSK8h0OU7QNX45Wu8JsR4VHcJ4LSkEfk?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2016,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1668,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -163,
    "LOC_Y": 229,
    "GAME_DATE": 20161128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/11/28/0021600259/520/5012746e-e3fb-b108-d2d3-57c11258cbfe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/298035273196023165",
    "name": "The 2974 Collection #1668",
    "imageUrl": "https://arweave.net/_daaB4uVoxwAhxfb22Hgv_nR8Iczcy9L0BbSnF15Szg?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2016,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1669,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -179,
    "LOC_Y": 223,
    "GAME_DATE": 20161201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/01/0021600281/188/6b9722e9-ee2a-e1fc-4db8-0e618a41046c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490929261687510115",
    "name": "The 2974 Collection #1669",
    "imageUrl": "https://arweave.net/a9vk8xKxvTWkknNhR7AjX8u6XG5nmD3DKVGH6x3R4RA?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1670,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -84,
    "LOC_Y": 262,
    "GAME_DATE": 20161201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/01/0021600281/372/4c335f7a-5767-09fc-fc90-35f8eeb2db37_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/530280614263018611",
    "name": "The 2974 Collection #1670",
    "imageUrl": "https://arweave.net/C4xWpVbb1KQ0qe0QI0Z6fIrfmi2-tU3cOR1E2ftSM_0?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1671,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 184,
    "LOC_Y": 164,
    "GAME_DATE": 20161201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/01/0021600281/509/446e25f7-23de-bdd7-fe46-699c3e2ef352_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382705589289553633",
    "name": "The 2974 Collection #1671",
    "imageUrl": "https://arweave.net/Q8FV5aqnuy6fagVNTfJFOfnbx_NHoRm30UfQ15x4t3g?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1672,
    "PERIOD": 5,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 227,
    "LOC_Y": 75,
    "GAME_DATE": 20161201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/01/0021600281/586/26cdb588-c68d-899e-5aa0-46198e20d3df_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388110655542995265",
    "name": "The 2974 Collection #1672",
    "imageUrl": "https://arweave.net/-V1dBNP8p1-OqHnDHlvT9wxQfOw5QErWn5pXdcLe1pU?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2016,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1673,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -168,
    "LOC_Y": 193,
    "GAME_DATE": 20161203,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/03/0021600299/100/ac32d760-6cc3-d8fe-16e3-ec465cc04c9b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481724469261632737",
    "name": "The 2974 Collection #1673",
    "imageUrl": "https://arweave.net/lycE--7ImfbTvL0wpwvczUQbp_tgyKXSJhZQ7YT4oC4?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1674,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -228,
    "LOC_Y": 61,
    "GAME_DATE": 20161203,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/03/0021600299/121/0aafffcd-2eb0-c326-0ff9-c36c7771d132_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513667616330702935",
    "name": "The 2974 Collection #1674",
    "imageUrl": "https://arweave.net/BFpn1iT47a-UOQRQTC8VvvGpHHpS3Gy6oIMa8a5AbGs?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1675,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -204,
    "LOC_Y": 154,
    "GAME_DATE": 20161203,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/03/0021600299/283/bae98bc1-369a-3210-f8e2-0cd31f93c7f2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510959062488333175",
    "name": "The 2974 Collection #1675",
    "imageUrl": "https://arweave.net/lsTv088J60ZkPZW4dFbAPdK3sxxJMmemQZoRx1gchqk?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1676,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -209,
    "LOC_Y": 154,
    "GAME_DATE": 20161203,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/03/0021600299/314/836863b1-8b29-a8d2-b7b3-c123a4bd2f11_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/437993753979546659",
    "name": "The 2974 Collection #1676",
    "imageUrl": "https://arweave.net/Z_mRxwl_wLobXKrIlT9xnFp6IayyOfpklsOBZvRun-8?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1677,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 115,
    "LOC_Y": 237,
    "GAME_DATE": 20161203,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/03/0021600299/355/62c24fe5-ece4-2ef8-7512-ffa9de58df41_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346499529462833616",
    "name": "The 2974 Collection #1677",
    "imageUrl": "https://arweave.net/1DHhoZdrlCzyefwKroFgtIOocWUh0hRRoWmHFEFUlq0?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2016,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1678,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 145,
    "LOC_Y": 218,
    "GAME_DATE": 20161205,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/05/0021600314/46/f0303de2-b87f-fbd2-4297-664b11bbab81_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361408891149957857",
    "name": "The 2974 Collection #1678",
    "imageUrl": "https://arweave.net/7seP1svTepSV0UoFtyBnbisLWC4himz5xwi_x9J6tTg?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1679,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 21,
    "GAME_DATE": 20161205,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/05/0021600314/231/58527b85-57eb-179a-fc16-1324482f558e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/535414857933825453",
    "name": "The 2974 Collection #1679",
    "imageUrl": "https://arweave.net/iHSuhZ-LC29KIQpjsHkvO5aI39g8Ffs0ROwwIj4ZIYk?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2016,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1680,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 115,
    "LOC_Y": 223,
    "GAME_DATE": 20161208,
    "Season": "2016-2017",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/08/0021600335/24/af1c0c9b-40fc-94ed-21e7-bc24d955c907_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412207649184701321",
    "name": "The 2974 Collection #1680",
    "imageUrl": "https://arweave.net/wb1vwZIOjDVb2L-lt8feAdua1qU69sVt62lFxpB5bYo?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1681,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 21,
    "GAME_DATE": 20161208,
    "Season": "2016-2017",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/08/0021600335/29/0a9b6990-ef3d-bf14-f5b2-39272fa0d09a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356364409956918792",
    "name": "The 2974 Collection #1681",
    "imageUrl": "https://arweave.net/n9hTso-bh1fWg7j20xEBdiMS9vl5nHcu6f9luUZXDfY?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1682,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 125,
    "LOC_Y": 213,
    "GAME_DATE": 20161208,
    "Season": "2016-2017",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/08/0021600335/343/c59c6e12-4c3b-19a7-d59f-3305360330b0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290826077724970557",
    "name": "The 2974 Collection #1682",
    "imageUrl": "https://arweave.net/5WSZ0voFZYq00MRMvpVYfhqq6o5IUtSemw-93b4HZ6Y?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1683,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 125,
    "LOC_Y": 223,
    "GAME_DATE": 20161210,
    "Season": "2016-2017",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/10/0021600351/236/1882d2e5-5458-2775-a099-e6ea44f4fef7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/380599772518667339",
    "name": "The 2974 Collection #1683",
    "imageUrl": "https://arweave.net/_Abl1IzpkSrQ73Z_jfQxqRSNdSgmM7OhTQEvrvvcJtI?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1684,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 105,
    "LOC_Y": 244,
    "GAME_DATE": 20161210,
    "Season": "2016-2017",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/10/0021600351/359/ebd397e2-43d8-dd9d-8b68-605f6e177088_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524145662059435587",
    "name": "The 2974 Collection #1684",
    "imageUrl": "https://arweave.net/IFcIXYeIIIfyBk5HwWnoDmgKNNGrLj0MtjxndsGzIF4?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1685,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 137,
    "LOC_Y": 214,
    "GAME_DATE": 20161210,
    "Season": "2016-2017",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/10/0021600351/420/a715af71-eb8f-00cb-6862-26cc1f7be66a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395104653695104230",
    "name": "The 2974 Collection #1685",
    "imageUrl": "https://arweave.net/BH3XCQPsjCjQREAourvXJGWY7o3FXjgnLopI1jzrymc?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2016,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1686,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -127,
    "LOC_Y": 214,
    "GAME_DATE": 20161211,
    "Season": "2016-2017",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/11/0021600358/333/ca78e977-b51f-558b-fe40-a4159823422e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/314926667785102937",
    "name": "The 2974 Collection #1686",
    "imageUrl": "https://arweave.net/nBFQjd-pMr6OLB97YwUMKMhxIY4VWzMgZO30NEsT-xw?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1687,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 0,
    "LOC_Y": 252,
    "GAME_DATE": 20161211,
    "Season": "2016-2017",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/11/0021600358/344/bf795e4a-1891-20aa-4e6a-957e209e0492_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552216874037929827",
    "name": "The 2974 Collection #1687",
    "imageUrl": "https://arweave.net/PM6y81Phf28vAPt5AP6ydhWOX3uficAYv-Q2iNHDiQg?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2016,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1688,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -163,
    "LOC_Y": 203,
    "GAME_DATE": 20161213,
    "Season": "2016-2017",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/13/0021600371/69/df4000ec-71f1-9bb9-f205-bcff49ca10ec_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531497397845859816",
    "name": "The 2974 Collection #1688",
    "imageUrl": "https://arweave.net/kFT58Sgw49rM1MTWaNj-gqdxFwPsENFSknal_Eo0_dU?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1689,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 41,
    "GAME_DATE": 20161213,
    "Season": "2016-2017",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/13/0021600371/72/d0b75ea9-c0c1-b68f-48ee-64042173618e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/413890830527090813",
    "name": "The 2974 Collection #1689",
    "imageUrl": "https://arweave.net/-V_WD-UrDJOhrwROh_U0djuJDkr272oEfHKzxSGfQgg?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1690,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 6,
    "LOC_Y": 267,
    "GAME_DATE": 20161213,
    "Season": "2016-2017",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/13/0021600371/97/d170a819-5fa4-d60a-5220-cd04fc3b99f1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392583148497850186",
    "name": "The 2974 Collection #1690",
    "imageUrl": "https://arweave.net/Rcn1oV_IDIvoZ4YWlRrvndwLa5MuC0ZoGA72lqqAGcw?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1691,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -209,
    "LOC_Y": 165,
    "GAME_DATE": 20161213,
    "Season": "2016-2017",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/13/0021600371/266/e7b27a81-b0e6-0402-990f-2a8dec26ca17_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550989980487247114",
    "name": "The 2974 Collection #1691",
    "imageUrl": "https://arweave.net/VsxVLfJ634Q1IPGNKNXzOYdi1SDqjzucm221hQ5DQXY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1692,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 89,
    "LOC_Y": 249,
    "GAME_DATE": 20161213,
    "Season": "2016-2017",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/13/0021600371/274/b6ceafe6-737a-2340-b74f-e5d8176cb226_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/396045363201662335",
    "name": "The 2974 Collection #1692",
    "imageUrl": "https://arweave.net/L8hGmJoUvUD3ePSSpk_A6PlhD7wSA2cb0Qe51nO89wk?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2016,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1693,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -186,
    "LOC_Y": 169,
    "GAME_DATE": 20161215,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/15/0021600388/180/20026277-68fa-06d9-78de-af05c2d41b71_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456646379895210434",
    "name": "The 2974 Collection #1693",
    "imageUrl": "https://arweave.net/uEKk2Rsd4ymVXId0GDolGX9fsxj7RJaEkDpRm6zUTFw?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 12,
    "Day": 15,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1694,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 16,
    "GAME_DATE": 20161215,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/15/0021600388/215/92b2d72b-8402-e79d-85b2-f6d445112b50_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520078774518521396",
    "name": "The 2974 Collection #1694",
    "imageUrl": "https://arweave.net/UaTkhVcVle0uUl1nsxGdeNOdVW2gFLlJ9uhcUCEgSNs?ext=png",
    "Opposing Team City": "New York",
    "Year": 2016,
    "Month": 12,
    "Day": 15,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1695,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -169,
    "LOC_Y": 229,
    "GAME_DATE": 20161217,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/17/0021600405/30/5799d119-e2b1-2838-d173-f2de57758a12_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/399572084072362486",
    "name": "The 2974 Collection #1695",
    "imageUrl": "https://arweave.net/zqe-KME45oUjdQ5L9hxX62BA1G5RbJWoyToFvy6Uibo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1696,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -219,
    "LOC_Y": 144,
    "GAME_DATE": 20161217,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/17/0021600405/32/e2b7c645-06e7-7af5-bd75-8134961e898e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385497414073267419",
    "name": "The 2974 Collection #1696",
    "imageUrl": "https://arweave.net/9vXsFPVNrpfIV6KmvOCp-AULc0T1CUORS6O0LzXNMiM?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1697,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 223,
    "LOC_Y": 87,
    "GAME_DATE": 20161217,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/17/0021600405/39/606382e3-03b1-389e-38ea-7b8e87f98a32_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/564316090043340135",
    "name": "The 2974 Collection #1697",
    "imageUrl": "https://arweave.net/aXkVgN1dmenaYAbBM2SpV_pCRUzCSynh4VTA4LFmVG4?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1698,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 132,
    "LOC_Y": 282,
    "GAME_DATE": 20161217,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/17/0021600405/308/b41c75c7-787b-a2d4-e1b3-4b77c779e017_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415948736773222577",
    "name": "The 2974 Collection #1698",
    "imageUrl": "https://arweave.net/nutjgL-fNJW6Fh8uy9McxP_9t31H7-HBgtrheDS2cJA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1699,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -142,
    "LOC_Y": 239,
    "GAME_DATE": 20161217,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/17/0021600405/393/0d62defa-03bd-f21c-23da-9cb00c35aa54_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317194046253394008",
    "name": "The 2974 Collection #1699",
    "imageUrl": "https://arweave.net/VvtFQSFe3tB26GJNfP_ZQazGONyJVTRuc1wSC_4SBzA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2016,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1700,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -74,
    "LOC_Y": 244,
    "GAME_DATE": 20161220,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/20/0021600427/79/e202927b-7c8e-239f-2fff-17b276d1fb1c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/471360415545927793",
    "name": "The 2974 Collection #1700",
    "imageUrl": "https://arweave.net/i1jiTLWpjNqucXDRfFThGTN7GVY8-8IQ3JFxAl7MjwA?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 12,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1701,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 128,
    "LOC_Y": 219,
    "GAME_DATE": 20161220,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/20/0021600427/268/07f375a4-0c42-c5a1-3a8d-df89c6fc9f78_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388934009905223461",
    "name": "The 2974 Collection #1701",
    "imageUrl": "https://arweave.net/IIQZ2Ta8GGlhCuiQQB4XD9sMxnmCSq5ptgTC1SiMfe0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 12,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1702,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 32,
    "LOC_Y": 262,
    "GAME_DATE": 20161220,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/20/0021600427/299/aedbedc8-285b-9af1-7ff2-4aec81977384_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302738881345158026",
    "name": "The 2974 Collection #1702",
    "imageUrl": "https://arweave.net/OQR8eDxrKh6v_lPM6HgO9Z6wlM8MTbYfdrcSoCi_ugs?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 12,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1703,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 169,
    "LOC_Y": 183,
    "GAME_DATE": 20161220,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/20/0021600427/377/159801a8-1c02-8015-1daf-a20b77b67d53_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299201840248944127",
    "name": "The 2974 Collection #1703",
    "imageUrl": "https://arweave.net/rGu43YeGLY0cRY_YxkEZG-RLXAKX-hLgx6dg8XZqKsg?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2016,
    "Month": 12,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1704,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 227,
    "LOC_Y": -1,
    "GAME_DATE": 20161222,
    "Season": "2016-2017",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/22/0021600437/119/c0c016f7-3aa5-8ce1-54ca-8f9c71bf728d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/537051311384405932",
    "name": "The 2974 Collection #1704",
    "imageUrl": "https://arweave.net/1c7dsCpseWbpPDFgGy3ledq2RbzbZGA8M2bBANrysk8?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2016,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1705,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 94,
    "LOC_Y": 223,
    "GAME_DATE": 20161222,
    "Season": "2016-2017",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/22/0021600437/298/c31eabe8-9df5-0eac-2ca3-79c979f19984_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/506989319955700023",
    "name": "The 2974 Collection #1705",
    "imageUrl": "https://arweave.net/POUpnwOVAhLnHV5Jsh4b0kW3VV8P65oYci2TdxWXTFg?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2016,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1706,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -179,
    "LOC_Y": 203,
    "GAME_DATE": 20161222,
    "Season": "2016-2017",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/22/0021600437/495/643b5084-29ec-10bf-69e0-d949d1079839_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334237455181507280",
    "name": "The 2974 Collection #1706",
    "imageUrl": "https://arweave.net/Z1mFrRTr1wsp8cBnkmqOCODNYG9cj-blDbM0Wx2VpQQ?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2016,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1707,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 8,
    "GAME_DATE": 20161223,
    "Season": "2016-2017",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/23/0021600446/101/ce2cacd5-9dd0-3240-7104-2eec29512be2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474870402875264593",
    "name": "The 2974 Collection #1707",
    "imageUrl": "https://arweave.net/eOkfMvY0u4fWR7pAfk3NwLM2o_Zt8MkbTry29UGUtfo?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1708,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -227,
    "LOC_Y": 129,
    "GAME_DATE": 20161223,
    "Season": "2016-2017",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/23/0021600446/220/76086e80-ebc5-8ac7-9d5e-604ba039d8e7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/455675887643281110",
    "name": "The 2974 Collection #1708",
    "imageUrl": "https://arweave.net/szljg4N7MeGSWXxYvDq4BmVdsHwbTS2Gl0Uyqp5KImM?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1709,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 236,
    "LOC_Y": 80,
    "GAME_DATE": 20161223,
    "Season": "2016-2017",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/23/0021600446/297/b25b4fb7-af37-abd6-f87c-af139a5636d4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423030707135345264",
    "name": "The 2974 Collection #1709",
    "imageUrl": "https://arweave.net/88e54evZbQ80rhnuEzRgauMC726-5l6amyPnkFD8q0o?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1710,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 225,
    "LOC_Y": 139,
    "GAME_DATE": 20161223,
    "Season": "2016-2017",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/23/0021600446/362/b93b1e83-5122-889e-c2c4-1ee76fcb656e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/332163726416517796",
    "name": "The 2974 Collection #1710",
    "imageUrl": "https://arweave.net/RX-FgoWHO9jKmZp7uOjFPUMpsDnXfs6VG8bXXeIvNg4?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1711,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -132,
    "LOC_Y": 228,
    "GAME_DATE": 20161223,
    "Season": "2016-2017",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/23/0021600446/481/a8fc472f-6de2-9ce8-234d-4638c2f63355_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/455801498714972800",
    "name": "The 2974 Collection #1711",
    "imageUrl": "https://arweave.net/QyD-lGztZHklYRweRWSsE9vtz5C_GuqyQ9skcCtNVlQ?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2016,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1712,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -240,
    "LOC_Y": 2,
    "GAME_DATE": 20161225,
    "Season": "2016-2017",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/25/0021600457/251/2aa279c2-5d4c-ca19-a912-a483afc4b6b1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572977556487878255",
    "name": "The 2974 Collection #1712",
    "imageUrl": "https://arweave.net/-yMI7XrWS6_D6cCdsm4en69iJ9J7pdY_QTqK9fRY_E8?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2016,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "Christmas",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1713,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -228,
    "LOC_Y": 116,
    "GAME_DATE": 20161225,
    "Season": "2016-2017",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/25/0021600457/584/93c341e3-26e9-90c9-b796-518abc881d73_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378455744055530956",
    "name": "The 2974 Collection #1713",
    "imageUrl": "https://arweave.net/SbZlxhNO8UblmA60gCwpCkuCbnETMLDB3wAshZ5l-mg?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2016,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "Christmas",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1714,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -29,
    "LOC_Y": 272,
    "GAME_DATE": 20161228,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/28/0021600485/34/2d2b0f8f-e4ef-b4f6-0f86-9e0002c72b26_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397459192146972530",
    "name": "The 2974 Collection #1714",
    "imageUrl": "https://arweave.net/tu35SWeCpcRTllmopFvJA7AzbsJ2XBacFA5mClLHXC0?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2016,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1715,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -147,
    "LOC_Y": 229,
    "GAME_DATE": 20161228,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/28/0021600485/253/8fe99911-e139-6641-8bd4-1c937c22a571_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/396036132254774727",
    "name": "The 2974 Collection #1715",
    "imageUrl": "https://arweave.net/wAgynV4u-dzDylFLQ6Ymjaxl_m10urKe6FIGWopsQm4?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2016,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1716,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -235,
    "LOC_Y": 56,
    "GAME_DATE": 20161228,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/28/0021600485/293/bf951ed9-2433-cb27-f379-9bdba9ddb5b5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/325579273468958733",
    "name": "The 2974 Collection #1716",
    "imageUrl": "https://arweave.net/fnktOu_ChqrQSiQgWrWYF9RNUf3aOMxeRAtDWAluvX4?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2016,
    "Month": 12,
    "Day": 28,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1717,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 225,
    "LOC_Y": 65,
    "GAME_DATE": 20161230,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/30/0021600501/21/146f1833-f09a-7c7b-6ad3-3ea9d1793525_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/527271719108342355",
    "name": "The 2974 Collection #1717",
    "imageUrl": "https://arweave.net/ysJ6n0P7visuyk_1ahJj4q7r86lElVMuSBlTTltzTcw?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1718,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 151,
    "LOC_Y": 218,
    "GAME_DATE": 20161230,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/30/0021600501/69/bf56fad5-fc9c-89b9-9479-df75fb467927_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458278029209205318",
    "name": "The 2974 Collection #1718",
    "imageUrl": "https://arweave.net/kZdbQkIPwx5PU1Yi9SvlHYjDUdeE1Kgd4PlHl8pfrus?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1719,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 205,
    "LOC_Y": 149,
    "GAME_DATE": 20161230,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2016/12/30/0021600501/242/fea00adf-6c15-04e1-7c7c-7cf941a86156_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/553285419726383323",
    "name": "The 2974 Collection #1719",
    "imageUrl": "https://arweave.net/WcSIjUDP7VEFHCxGneuYYwlliXqq2utTPmxat5Su3D8?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2016,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1720,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -166,
    "LOC_Y": 193,
    "GAME_DATE": 20170102,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/02/0021600520/52/6fd926b7-62d9-4c0a-105a-ee98d2554116_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508826771798873299",
    "name": "The 2974 Collection #1720",
    "imageUrl": "https://arweave.net/cVWdpNYExuXM-nyoWPHa50cKXrOc3kZQB7SPJ4FZc1c?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2017,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1721,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": -61,
    "LOC_Y": 332,
    "GAME_DATE": 20170102,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/02/0021600520/201/875add5a-f3ce-e5c4-5321-c00d6b18f078_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/435345129584611641",
    "name": "The 2974 Collection #1721",
    "imageUrl": "https://arweave.net/r1IIK6_RYDYaRH66G93mcdJee4NjIafGfTN14RYcZSU?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2017,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1722,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 141,
    "LOC_Y": 259,
    "GAME_DATE": 20170102,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/02/0021600520/481/276fcc3f-fc87-740f-e791-4a2ec5e4d412_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/389380651345284027",
    "name": "The 2974 Collection #1722",
    "imageUrl": "https://arweave.net/2OKSPpSoHKWk1Nk_kUwEhlYk-rLMPUkDDZYM8fUknVo?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2017,
    "Month": 1,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1723,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -29,
    "LOC_Y": 252,
    "GAME_DATE": 20170104,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/04/0021600534/4/018bab57-0ad8-1bfc-3dc8-b5a11a2a1621_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464248651548899200",
    "name": "The 2974 Collection #1723",
    "imageUrl": "https://arweave.net/9zPFcyvjlwJ3p3JI4kTIQ-FZbgejD8VqAN5099NOSa4?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2017,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1724,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 102,
    "LOC_Y": 228,
    "GAME_DATE": 20170104,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/04/0021600534/238/4656c1e6-70dd-a09d-d1a4-23de7b24e71b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510622908497942804",
    "name": "The 2974 Collection #1724",
    "imageUrl": "https://arweave.net/ttvuswWm8fL07jblsukUqmewpjq8UU4G9nvXgFvGmoA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2017,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1725,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 148,
    "LOC_Y": 254,
    "GAME_DATE": 20170104,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/04/0021600534/345/18f84faa-66d2-e898-a79c-a687e546a161_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444764817283953953",
    "name": "The 2974 Collection #1725",
    "imageUrl": "https://arweave.net/PBAyAT7Joi0p6ahM9l75pEQo9LSjcRbSZySukrR-Kcw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2017,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1726,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 228,
    "LOC_Y": 46,
    "GAME_DATE": 20170104,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/04/0021600534/418/e70abb9f-4e00-3a41-9c02-c8c92ee6b15a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/340430644846425337",
    "name": "The 2974 Collection #1726",
    "imageUrl": "https://arweave.net/AU_fgQp7WNFI3ry0PXCkHl5FbD9BHtz0pvsh80PLcGM?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2017,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1727,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": 28,
    "GAME_DATE": 20170104,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/04/0021600534/547/4a247076-050e-22ea-beaa-10cb938649ec_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/576389407924494082",
    "name": "The 2974 Collection #1727",
    "imageUrl": "https://arweave.net/Uv3EC6tdFd0HCxEyGb7HOt9ZMbsEb7enRQI_5rls33g?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2017,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1728,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -16,
    "LOC_Y": 262,
    "GAME_DATE": 20170106,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/06/0021600550/117/bc5620dc-f0e7-2a7d-c45f-4caec467d063_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503780103760106606",
    "name": "The 2974 Collection #1728",
    "imageUrl": "https://arweave.net/PTecdfEShm4n7XO1gmHVy-EqAM7wt5bYW5fu8deDYn0?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1729,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 101,
    "LOC_Y": 237,
    "GAME_DATE": 20170106,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/06/0021600550/295/1e4612af-5cf7-5b47-8c3a-e147e8a7abb4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458191520600275524",
    "name": "The 2974 Collection #1729",
    "imageUrl": "https://arweave.net/6oTSI5lwCYOFBR4wWl3f48evVUk6cYdqZE_MLpIdAbk?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1730,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 213,
    "LOC_Y": 151,
    "GAME_DATE": 20170106,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/06/0021600550/300/956f940b-b500-d0ce-3992-db7f808d83ae_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/526047187356889223",
    "name": "The 2974 Collection #1730",
    "imageUrl": "https://arweave.net/JU_EGlT9ENQhn02DpZIvjOxQa14fMwr5BNHbxzP9lhM?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1731,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 207,
    "LOC_Y": 183,
    "GAME_DATE": 20170106,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/06/0021600550/313/b3ed1a4c-b57a-fe04-2b75-541ae3bb405e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/494332138805689691",
    "name": "The 2974 Collection #1731",
    "imageUrl": "https://arweave.net/D3PXCr_tdNX6MFy0-rS6ix5ePTH-GYDSRmkS6wQ5ZzQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1732,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 120,
    "LOC_Y": 232,
    "GAME_DATE": 20170106,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/06/0021600550/329/e0ea81ac-2d84-0729-eef7-d9d459e86014_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429284055299008638",
    "name": "The 2974 Collection #1732",
    "imageUrl": "https://arweave.net/jqB6uOzC1VNj3coYV0Z-0AO0XGpDDf67p19bems6F9U?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1733,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -140,
    "LOC_Y": 219,
    "GAME_DATE": 20170108,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/08/0021600566/27/6c62222d-f186-35a7-d202-3f4b395e100a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508813872971388215",
    "name": "The 2974 Collection #1733",
    "imageUrl": "https://arweave.net/LQRke30p-oWjhrBZaI22qa4PnOukmYDJVnWeO62JN-I?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1734,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -205,
    "LOC_Y": 144,
    "GAME_DATE": 20170108,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/08/0021600566/42/f8ad5aaf-758e-672d-7f99-0feebc3a400a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356627221924939313",
    "name": "The 2974 Collection #1734",
    "imageUrl": "https://arweave.net/wHK842fhVjmifixNJeoi5ZrqmVa7IowDKo_8JecIE2g?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1735,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -34,
    "LOC_Y": 244,
    "GAME_DATE": 20170108,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/08/0021600566/306/31bda732-9c1e-aaa8-aeac-600855422ac8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519840758069895547",
    "name": "The 2974 Collection #1735",
    "imageUrl": "https://arweave.net/ZOyDH-xTqoWIbcOKRWYotZ7mIcgg5IxSK-6zNsm8Yi4?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1736,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 137,
    "LOC_Y": 223,
    "GAME_DATE": 20170108,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/08/0021600566/341/88d5eddc-2acd-360d-de30-0e9fcc980f15_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352569823193755410",
    "name": "The 2974 Collection #1736",
    "imageUrl": "https://arweave.net/A7tJ2lh8nv2sfqBhV_wVt3Uanl-2whE_xYi7OdDTOPM?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1737,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -225,
    "LOC_Y": 11,
    "GAME_DATE": 20170108,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/08/0021600566/513/8603aed9-f387-6d33-c3d0-a5d713ca6490_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497853442599701948",
    "name": "The 2974 Collection #1737",
    "imageUrl": "https://arweave.net/elGm-a5DGa6x0kb4t_Juna7zj8jZfnuln87WTO0m9vw?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1738,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -210,
    "LOC_Y": 164,
    "GAME_DATE": 20170110,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/10/0021600578/39/3d148e9f-fc70-d4b2-ac13-bc2ead243256_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349369138365461904",
    "name": "The 2974 Collection #1738",
    "imageUrl": "https://arweave.net/O8bRxvFz8o4Pyd3JU408_DAevWxrP5rutsgiLdGmd6A?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 1,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1739,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -117,
    "LOC_Y": 287,
    "GAME_DATE": 20170110,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/10/0021600578/87/c7118c55-3811-75cc-da87-d5406fcdf68f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/466419922189709533",
    "name": "The 2974 Collection #1739",
    "imageUrl": "https://arweave.net/Td7FsanxLnpNTqhHn23Jkq6d_9wYyRhnjw-cx0cLdbU?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 1,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1740,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -74,
    "LOC_Y": 237,
    "GAME_DATE": 20170110,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/10/0021600578/201/0563e0db-0cb4-b4f8-c7af-9a5515d935bf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320646937478396777",
    "name": "The 2974 Collection #1740",
    "imageUrl": "https://arweave.net/XSL-7vNMVfhSqlhzarS8BPAOoumg4gXZcbBDXbaTtR8?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 1,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1741,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -176,
    "LOC_Y": 228,
    "GAME_DATE": 20170110,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/10/0021600578/479/8fe7f2a6-4ea6-de29-f17a-3a92954de6f4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/316247935541596540",
    "name": "The 2974 Collection #1741",
    "imageUrl": "https://arweave.net/dAQbfbB9l_R-Hw4HZjVa79koVghKY8CMwfhEoSLcQbA?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 1,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1742,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -78,
    "LOC_Y": 252,
    "GAME_DATE": 20170112,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/12/0021600590/35/3864e6d9-f40c-7c09-92cd-6fb0e6cf5b25_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/351997110117966831",
    "name": "The 2974 Collection #1742",
    "imageUrl": "https://arweave.net/FlsLvLouUQiSIJKpQf1POipdk_XSwhVV_x07V8KAh6c?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2017,
    "Month": 1,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1743,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -210,
    "LOC_Y": 190,
    "GAME_DATE": 20170112,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/12/0021600590/65/2d845181-80da-e74e-43d4-82f6151afeb0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476981706304519189",
    "name": "The 2974 Collection #1743",
    "imageUrl": "https://arweave.net/tZDZSu5bX1g5yh-FBpIPcPC7VNbh-Y1SEYI52j8M0OY?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2017,
    "Month": 1,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1744,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -107,
    "LOC_Y": 232,
    "GAME_DATE": 20170112,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/12/0021600590/375/6e8ad3cc-6cac-775a-372b-976e21ec3c65_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544133205961771050",
    "name": "The 2974 Collection #1744",
    "imageUrl": "https://arweave.net/2m6gbPCeckrjBzK9ZRm_pFbaeHbfUdK-oTD3MW6MYrU?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2017,
    "Month": 1,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1745,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -202,
    "LOC_Y": 193,
    "GAME_DATE": 20170116,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/16/0021600619/83/82ddf9cb-eec6-2082-4df9-191ad50b2ac0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404816764295765117",
    "name": "The 2974 Collection #1745",
    "imageUrl": "https://arweave.net/tf6ETpjpToc5GyE2pLaqlRmGvd4_Q4qDeIi_EcBp6jw?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2017,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1746,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 6,
    "LOC_Y": 262,
    "GAME_DATE": 20170116,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/16/0021600619/120/757b49df-a178-d00b-e3ce-588ad5f280fa_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417514281602900580",
    "name": "The 2974 Collection #1746",
    "imageUrl": "https://arweave.net/kVOJtxNU3Npw1lCmj0RcoTR85wvxT4YKEZfJvEzQ3IQ?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2017,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1747,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 117,
    "LOC_Y": 244,
    "GAME_DATE": 20170116,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/16/0021600619/268/8d69589a-eed0-8fa2-d18f-417241de1b7b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355898630785359688",
    "name": "The 2974 Collection #1747",
    "imageUrl": "https://arweave.net/EDHJEbqBXM24prIF9EyN4SLFuVj6CoLfYKiOfSV5H0k?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2017,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1748,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 168,
    "LOC_Y": 193,
    "GAME_DATE": 20170116,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/16/0021600619/280/4aad2eba-339c-90d8-191d-2853087bf615_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438841068046075760",
    "name": "The 2974 Collection #1748",
    "imageUrl": "https://arweave.net/v4GzFMelWETKVLZy5hdnzx3PsP7x-bhwTYwhbpb3rQk?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2017,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1749,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 107,
    "LOC_Y": 223,
    "GAME_DATE": 20170116,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/16/0021600619/340/129c00f9-becb-435a-29e7-86c1ea5e71d7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/573274949159298913",
    "name": "The 2974 Collection #1749",
    "imageUrl": "https://arweave.net/qWdVnTvvGYmkLu0yOvUKpDMCJgWwxhw1spmk68W-Bwg?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2017,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1750,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -6,
    "LOC_Y": 291,
    "GAME_DATE": 20170118,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/18/0021600634/34/82efebfb-2fe9-a147-2d93-81bff8f8397e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476334528550801112",
    "name": "The 2974 Collection #1750",
    "imageUrl": "https://arweave.net/ji_OAYMlMpKDcc2CymqI9KRKjrISTRetDwz9MqJJanE?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1751,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 15,
    "LOC_Y": 277,
    "GAME_DATE": 20170118,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/18/0021600634/347/12749bd9-04dd-831b-2ad5-f4380ceaa57d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575138227871752311",
    "name": "The 2974 Collection #1751",
    "imageUrl": "https://arweave.net/y26whx72UGgI4595UZvp687BjGj-1tp2Mn0nrtO46I8?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1752,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -161,
    "LOC_Y": 192,
    "GAME_DATE": 20170120,
    "Season": "2016-2017",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/20/0021600646/92/3e3224ce-7eb2-a43a-a92c-d7cd60c6fd4b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/486737178673914414",
    "name": "The 2974 Collection #1752",
    "imageUrl": "https://arweave.net/yVOZ0cc00uPQW3tPgLbnHDCLxtDVlEFQ0qNwv75jUXY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1753,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -81,
    "LOC_Y": 232,
    "GAME_DATE": 20170120,
    "Season": "2016-2017",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/20/0021600646/284/d111d8ae-e54a-8865-435b-dfe1493f9960_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/507712243931932312",
    "name": "The 2974 Collection #1753",
    "imageUrl": "https://arweave.net/_0NEzPiZeFeDSO2kdTGSI3KlHsikVpgwRd0DL8EZRPU?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1754,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 14,
    "LOC_Y": 283,
    "GAME_DATE": 20170120,
    "Season": "2016-2017",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/20/0021600646/340/c7ea5677-d99a-fdc2-0b65-bd7731de0b18_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/337367055343028085",
    "name": "The 2974 Collection #1754",
    "imageUrl": "https://arweave.net/bQ6jVa5fEL_-usnFpP-IPK6BwNCXbPih7wNfqzujRLI?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1755,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 132,
    "LOC_Y": 203,
    "GAME_DATE": 20170120,
    "Season": "2016-2017",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/20/0021600646/346/b3c5af1c-6e83-dcdd-b491-cba91ec336e0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371070597673932835",
    "name": "The 2974 Collection #1755",
    "imageUrl": "https://arweave.net/YdginzJ0M1YjUv1TiCpuY5oRTvdPhctmGJjYOJKVQSQ?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1756,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 36,
    "GAME_DATE": 20170120,
    "Season": "2016-2017",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/20/0021600646/514/a879e213-298f-6ba6-8e01-85a6d57bf3c3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498825076943245241",
    "name": "The 2974 Collection #1756",
    "imageUrl": "https://arweave.net/5oXD9_DEgrjoZAuCX0fBsD8AHUi9Xn5mBKqiT60OJQI?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1757,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -97,
    "LOC_Y": 244,
    "GAME_DATE": 20170122,
    "Season": "2016-2017",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/22/0021600661/77/eabc8a76-66c5-9dd3-70af-81772b6846c5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421230242209246547",
    "name": "The 2974 Collection #1757",
    "imageUrl": "https://arweave.net/Kt0m3lvtkBkHlHWv-SpB1I2NFZ97QtCPeHWIIlLu5q0?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1758,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 10,
    "LOC_Y": 282,
    "GAME_DATE": 20170122,
    "Season": "2016-2017",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/22/0021600661/239/137be933-32b9-76af-6043-83c8486dc9db_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352228543081038329",
    "name": "The 2974 Collection #1758",
    "imageUrl": "https://arweave.net/vujLz6pjDQ_1xIRmbExqZ4BrHzxqpzepJYg_2nF73ho?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1759,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": 11,
    "GAME_DATE": 20170122,
    "Season": "2016-2017",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/22/0021600661/262/d54205b3-bf5e-a4d9-c602-6eee9fc4f791_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444893041050874622",
    "name": "The 2974 Collection #1759",
    "imageUrl": "https://arweave.net/vFfIv7e2VqyOliuVjsZrAOf94xllmfok8qBtvUSn0JY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1760,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 238,
    "LOC_Y": 95,
    "GAME_DATE": 20170122,
    "Season": "2016-2017",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/22/0021600661/296/25f6034b-917b-0edf-7c0c-76b82af45b6a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/528526443129091072",
    "name": "The 2974 Collection #1760",
    "imageUrl": "https://arweave.net/64djOnZgU_P2Ssbo2N1B3VEU68FKcEL6Q6IDvdmP52E?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1761,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 145,
    "LOC_Y": 234,
    "GAME_DATE": 20170122,
    "Season": "2016-2017",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/22/0021600661/325/d0616470-8342-c767-9145-04cf8e93a01a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418884737142981691",
    "name": "The 2974 Collection #1761",
    "imageUrl": "https://arweave.net/7qFkUpCUlkFBZStAVIClVsEiD157LiLxQEM-7VkxKO4?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1762,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -222,
    "LOC_Y": -11,
    "GAME_DATE": 20170122,
    "Season": "2016-2017",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/22/0021600661/394/a774d228-3f98-1ebd-29ae-217385833539_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438029723480754635",
    "name": "The 2974 Collection #1762",
    "imageUrl": "https://arweave.net/yT9wE4XPW9uQtS2AUlYPcKs8EOZvhFst1XMff4WNQEM?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1763,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 177,
    "LOC_Y": 239,
    "GAME_DATE": 20170122,
    "Season": "2016-2017",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/22/0021600661/397/8dfeeade-8b1c-4be1-a248-ce70bf9798ff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511216432075258439",
    "name": "The 2974 Collection #1763",
    "imageUrl": "https://arweave.net/k5D0z9CIiLhCjBfoBdKvKhqjcZ61zqXotos63swFBp4?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 1,
    "Day": 22,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1764,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 9,
    "LOC_Y": 247,
    "GAME_DATE": 20170123,
    "Season": "2016-2017",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/23/0021600668/12/6b82ad46-47ed-62b3-4f4b-4b9774c8c9ce_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/389326772230451132",
    "name": "The 2974 Collection #1764",
    "imageUrl": "https://arweave.net/ftBx8U4jO5c60VW8C45eDG1BlvfdQ4lD3CINn9lu5NY?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1765,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -133,
    "LOC_Y": 203,
    "GAME_DATE": 20170123,
    "Season": "2016-2017",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/23/0021600668/68/49eddeba-24e2-84fd-2130-4650143a8a44_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317792500319658574",
    "name": "The 2974 Collection #1765",
    "imageUrl": "https://arweave.net/kf4wfSEJ0zrV2iDE9AQr7I2BXHh985Zgc8R4FEE8wu4?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1766,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 22,
    "LOC_Y": 252,
    "GAME_DATE": 20170123,
    "Season": "2016-2017",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/23/0021600668/123/f8760179-b1ec-2a33-8a7a-6b3a799f4e46_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317790133641891819",
    "name": "The 2974 Collection #1766",
    "imageUrl": "https://arweave.net/Z_jlXnw0SkPYyG_Lcawt5igPakHQ2tJWRb2HISRsPUw?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1767,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 69,
    "LOC_Y": 232,
    "GAME_DATE": 20170125,
    "Season": "2016-2017",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/25/0021600687/36/3bccdd1f-52ab-21ce-b0fb-59c39e1bf570_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330078858183976011",
    "name": "The 2974 Collection #1767",
    "imageUrl": "https://arweave.net/b6yERR0QXvw4HjwX4K733wabkJvvnjw5Rbq6-SUbDR8?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1768,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 155,
    "LOC_Y": 219,
    "GAME_DATE": 20170125,
    "Season": "2016-2017",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/25/0021600687/68/af15bfab-3c1d-b8a1-0224-a161ec1f09bd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/471284896715196999",
    "name": "The 2974 Collection #1768",
    "imageUrl": "https://arweave.net/KI962ymwArAJFicPLxVNoD29uPWqGK8zcPTf0gD3LzI?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1769,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 145,
    "LOC_Y": 272,
    "GAME_DATE": 20170125,
    "Season": "2016-2017",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/25/0021600687/114/41bfdd10-3875-025d-3908-cbde4bb68ed3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422834889588703981",
    "name": "The 2974 Collection #1769",
    "imageUrl": "https://arweave.net/ZFbPdMjCQwWEvrifN99FkG3pc_lvH8fz_94Ul2zpXU8?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1770,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 69,
    "LOC_Y": 237,
    "GAME_DATE": 20170125,
    "Season": "2016-2017",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/25/0021600687/316/5f3937f4-74d4-579a-9ff9-a4d69d70ea77_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386685687571553574",
    "name": "The 2974 Collection #1770",
    "imageUrl": "https://arweave.net/Og-kpR7amIQGwYJfobSrBbCUwh48crLg9jaxPGWeac0?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1771,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 233,
    "LOC_Y": 31,
    "GAME_DATE": 20170125,
    "Season": "2016-2017",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/25/0021600687/492/ba158428-cd3e-3d2d-846e-4f54f799f9a0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307929791165052675",
    "name": "The 2974 Collection #1771",
    "imageUrl": "https://arweave.net/MnzQECfGD-znwoTr5sWlNletJ4S2nXsTnaqNdQhxfwo?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1772,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 123,
    "LOC_Y": 213,
    "GAME_DATE": 20170125,
    "Season": "2016-2017",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/25/0021600687/525/1522ff85-788c-64c6-15a0-4cb8c6b315cf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/342118968226837770",
    "name": "The 2974 Collection #1772",
    "imageUrl": "https://arweave.net/QR7yPFuu71He5WIjwiFzK9jVPho6jVt8vnrySG66Xng?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1773,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 63,
    "LOC_Y": 287,
    "GAME_DATE": 20170128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/28/0021600707/27/064570da-5ef1-8499-6552-d27e75e343f5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346446721789112074",
    "name": "The 2974 Collection #1773",
    "imageUrl": "https://arweave.net/03_Q7DbKnbNyJF6e20FqOP3Nm8TIykMqodE4uAG3R-k?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1774,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 13,
    "GAME_DATE": 20170128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/28/0021600707/103/b39dccfe-9778-4138-fc11-f61a056660ea_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521841035802688559",
    "name": "The 2974 Collection #1774",
    "imageUrl": "https://arweave.net/32dbM44AiHCaEqTqFhwlG2QUhEeuV6tsqCOQICJMOow?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1775,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -212,
    "LOC_Y": 174,
    "GAME_DATE": 20170128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/28/0021600707/212/4808a37c-c9a5-d828-619b-5df186eac5ae_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/463395991158464215",
    "name": "The 2974 Collection #1775",
    "imageUrl": "https://arweave.net/K3WOJhj8tU_2q7vAwgG1iIH2nHp_7dWaZMYCajbbeKc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1776,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Backcourt",
    "SHOT_DISTANCE": 51,
    "LOC_X": -102,
    "LOC_Y": 503,
    "GAME_DATE": 20170128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/28/0021600707/244/8ffe07b8-d81d-48f8-b83d-b0c630de80da_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357294152293627368",
    "name": "The 2974 Collection #1776",
    "imageUrl": "https://arweave.net/CL0otVlBlBa4G398TrkcrNNko86pWnoyKmcY42B9Jkg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1777,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 32,
    "LOC_Y": 257,
    "GAME_DATE": 20170128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/28/0021600707/312/02b95d2f-ebb3-078d-24f8-8f92f7e39a0e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493089625467454728",
    "name": "The 2974 Collection #1777",
    "imageUrl": "https://arweave.net/WuDlNvfx5h1YZhZ46Ef8mItKjrZ7WbWQQxFMDnkoHic?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1778,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 168,
    "LOC_Y": 252,
    "GAME_DATE": 20170128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/28/0021600707/351/1772ac2f-6c1e-f0e6-eddf-d7410d5e733e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/527366411723237147",
    "name": "The 2974 Collection #1778",
    "imageUrl": "https://arweave.net/uOVqQmBaGZ5anc--1bvidGcYjltEjBUaTzCSuDkEeUc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1779,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -168,
    "LOC_Y": 223,
    "GAME_DATE": 20170128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/28/0021600707/353/abaf9503-1daa-2fbf-b1bc-a6efdf60478d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/437124562656630429",
    "name": "The 2974 Collection #1779",
    "imageUrl": "https://arweave.net/8xFf3mox0wUMbyA7H2lz31h-uTGNjb-umWmmJimVtpE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1780,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 143,
    "LOC_Y": 257,
    "GAME_DATE": 20170128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/28/0021600707/369/e55ee097-4f57-e90f-eeb4-494e96c7b135_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511582865933064722",
    "name": "The 2974 Collection #1780",
    "imageUrl": "https://arweave.net/Ft-EEbyVWroRPepxVxVdLe03k-ufCY7yFmywrudMQ4c?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1781,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 168,
    "LOC_Y": 193,
    "GAME_DATE": 20170128,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/01/28/0021600707/384/4960672e-41e7-0d2e-6b11-6ed9b693d557_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482496319208092553",
    "name": "The 2974 Collection #1781",
    "imageUrl": "https://arweave.net/pPPrscJutRpPis1ZukR_5dnXZOsFS_xkGPWMMkaCbj8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1782,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -196,
    "LOC_Y": 183,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/2/78878df0-b20a-1011-e9c4-1efe22950367_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/530587250973235361",
    "name": "The 2974 Collection #1782",
    "imageUrl": "https://arweave.net/3jJD4vyw4jbEJ88NXpLi5wzuylr-Pfgb7ObogtUZpJ8?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1783,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -204,
    "LOC_Y": 154,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/11/c3dc722c-0fc2-7f5b-0f36-95f168b0216e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546767028399109594",
    "name": "The 2974 Collection #1783",
    "imageUrl": "https://arweave.net/6bdVtiFIxUX4nXI3wvfaRY7QBZXiu7UXS7S6HBl_QlM?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1784,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 25,
    "LOC_Y": 298,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/16/493e7f7d-60f6-5c96-55da-636b1d19c860_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/473788528788274092",
    "name": "The 2974 Collection #1784",
    "imageUrl": "https://arweave.net/u_H_KBjX-pGE1VE3qhcH9_8OMngitAn-fdhwQH0TCVE?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1785,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -210,
    "LOC_Y": 151,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/37/0dc2c43e-39ac-c687-8bec-dd5f7b139fa3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519244942535496121",
    "name": "The 2974 Collection #1785",
    "imageUrl": "https://arweave.net/rC7t-P73e-KtGAcgAaFvK1UhlNQ8NRdOBpX0Qi5dnSM?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1786,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -196,
    "LOC_Y": 169,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/107/2621900a-142c-babc-0df1-d9076f7cd22b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/313163191346550497",
    "name": "The 2974 Collection #1786",
    "imageUrl": "https://arweave.net/Q_RH0TV1aDaskjoxAN6Uy5HXb5QN4dq2z72YXxiY_6k?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1787,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -179,
    "LOC_Y": 234,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/120/bb9bff4e-8dcf-de19-5b35-4e9e2f57e806_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/414972387532296730",
    "name": "The 2974 Collection #1787",
    "imageUrl": "https://arweave.net/rkTQ2CcEAfmoRfkw1b7QzowUhjP2UJRXDA1TiA9kiho?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1788,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 150,
    "LOC_Y": 223,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/214/ca92878f-5892-38ac-a66a-19ec40a05288_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434784955860244358",
    "name": "The 2974 Collection #1788",
    "imageUrl": "https://arweave.net/Bca2Yc0dnKElz9uiqNkaLvYTHWXWpAIjs1vMBOKbw5k?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1789,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -61,
    "LOC_Y": 306,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/246/179ebd64-4d19-1471-7588-5a1b3f75ccb1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465639425585529753",
    "name": "The 2974 Collection #1789",
    "imageUrl": "https://arweave.net/fK3YV8YPBvYK-_ddvu_6QdFN-4j2CttkpHr-8QK_2l0?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1790,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -132,
    "LOC_Y": 232,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/312/a291ca54-c0a1-2e3d-3e75-0bb46c89a58b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/329848488908056141",
    "name": "The 2974 Collection #1790",
    "imageUrl": "https://arweave.net/tW5QvjdGoiVkpC-GWldix9Ln1hRWOQy62zX0XklKlT0?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1791,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -214,
    "LOC_Y": 141,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/371/72cf7929-5632-a17d-0ea9-eab416ebb000_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324016544017777773",
    "name": "The 2974 Collection #1791",
    "imageUrl": "https://arweave.net/JXb7DBQG-OihjzuNRpUwfEUufcNJSHOFz7CQgATEzAY?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1792,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 163,
    "LOC_Y": 237,
    "GAME_DATE": 20170201,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/01/0021600741/387/171fd9ea-9817-c7a0-2173-e3b3c41e1f8a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474680279712516403",
    "name": "The 2974 Collection #1792",
    "imageUrl": "https://arweave.net/sS1ZazS6bE-0MFCFFdHM1Ffgszokj_McMZEhgMN_Cj4?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2017,
    "Month": 2,
    "Day": 1,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1793,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 128,
    "LOC_Y": 214,
    "GAME_DATE": 20170202,
    "Season": "2016-2017",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/02/0021600745/237/08dc0a65-e6e0-5f1e-e33e-1f6630da3c31_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347565725878960657",
    "name": "The 2974 Collection #1793",
    "imageUrl": "https://arweave.net/WlElnbEwAcA-Nvs8emo8Zqa-W-TyD6o0V0W_ZjO1-Y0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1794,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 171,
    "LOC_Y": 210,
    "GAME_DATE": 20170202,
    "Season": "2016-2017",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/02/0021600745/300/4db6c189-1e0c-54e6-217c-6d08d87bfd0b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397594507378713310",
    "name": "The 2974 Collection #1794",
    "imageUrl": "https://arweave.net/-x1v8nFkWaNIBtqLIAb2eMAzwl9r3KnU_A2mpKv7f8s?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1795,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 212,
    "LOC_Y": 164,
    "GAME_DATE": 20170202,
    "Season": "2016-2017",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/02/0021600745/526/ccd18a7d-baa0-33ef-50c5-cccc3283914c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/303269707140831820",
    "name": "The 2974 Collection #1795",
    "imageUrl": "https://arweave.net/LnxTl2QvZh2z6cnZ1176_sSormvhV_356KR9mAh5mwI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1796,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -19,
    "LOC_Y": 257,
    "GAME_DATE": 20170204,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/04/0021600764/29/a33a094a-c13e-f748-b887-d5ac17fcc78f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400407642964899418",
    "name": "The 2974 Collection #1796",
    "imageUrl": "https://arweave.net/4bIk4i6z0ddZvGfCVhzPM9T7D68Nh0N9eizi51oSbYs?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1797,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -171,
    "LOC_Y": 193,
    "GAME_DATE": 20170204,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/04/0021600764/115/1f625be3-0078-f116-c141-531dec3b5be7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395333898965677251",
    "name": "The 2974 Collection #1797",
    "imageUrl": "https://arweave.net/PnRLRc4i6u6gYYgX-NiYWx6qHwFz1qxKGvFwVynHJ6s?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1798,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -212,
    "LOC_Y": 141,
    "GAME_DATE": 20170204,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/04/0021600764/129/7856a2c7-9069-abbc-0edf-20c0d48d2263_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491227307990693055",
    "name": "The 2974 Collection #1798",
    "imageUrl": "https://arweave.net/fMxXUf9G5T2RevX49U1_dFvtnBAfIwZ5VnyJTHdSTNo?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1799,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -101,
    "LOC_Y": 228,
    "GAME_DATE": 20170204,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/04/0021600764/287/451b611e-3493-c77b-c4f3-3017cca0f516_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/416545637494902831",
    "name": "The 2974 Collection #1799",
    "imageUrl": "https://arweave.net/dUJQDkAB2RCZO9ouja2TnQqK8-27TLBzQBRAGkzLBeI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1800,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 120,
    "LOC_Y": 237,
    "GAME_DATE": 20170204,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/04/0021600764/355/07e41977-fa29-6574-e398-ef2523955215_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373395128829999611",
    "name": "The 2974 Collection #1800",
    "imageUrl": "https://arweave.net/erfSso8cDPqYLQYHRXBHucurYxajxa6KGKELrv3av9Y?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1801,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 135,
    "LOC_Y": 267,
    "GAME_DATE": 20170204,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/04/0021600764/383/ad66ef4c-6bb8-bed8-008b-97bb3f2153bc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/410113504995775820",
    "name": "The 2974 Collection #1801",
    "imageUrl": "https://arweave.net/F9N2Qt10K8SbClYGIsXrv_A6wgNMzuJ186Mj8q09jNE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1802,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 222,
    "LOC_Y": 115,
    "GAME_DATE": 20170204,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/04/0021600764/461/e5c2576d-7b1c-5b76-e236-c26fbb30db1e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/332843246271320440",
    "name": "The 2974 Collection #1802",
    "imageUrl": "https://arweave.net/UgQnTDgNj7Jjxu5O9COCikbNtVB4LOPn_uh9PMOopJ8?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1803,
    "PERIOD": 5,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -114,
    "LOC_Y": 254,
    "GAME_DATE": 20170204,
    "Season": "2016-2017",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/04/0021600764/539/fc6c9bf5-f8ff-70a2-ab53-a2a06b891c6a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/316027341989461776",
    "name": "The 2974 Collection #1803",
    "imageUrl": "https://arweave.net/3Um0I7b-FXJ21SSDwJiHLyO9mWbqF16RUVKbF2xfRpU?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1804,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 7,
    "GAME_DATE": 20170208,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/08/0021600792/21/cdb44b53-c781-456b-6382-429adda1c496_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444870695811167571",
    "name": "The 2974 Collection #1804",
    "imageUrl": "https://arweave.net/6kceYT-DaUVlrvv_J2Myrf7zQLbM2Upyi7L4pWAE7P8?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2017,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1805,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": -16,
    "GAME_DATE": 20170210,
    "Season": "2016-2017",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/10/0021600803/105/cee7150d-5c84-cfd9-b4ac-29f7f2dce7e9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518029229385413278",
    "name": "The 2974 Collection #1805",
    "imageUrl": "https://arweave.net/WY2UzF9pz1VDLCmsNmXLkMtxMSe5hffGcbCF3FTQxlo?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1806,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 11,
    "GAME_DATE": 20170210,
    "Season": "2016-2017",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/10/0021600803/258/2df53a74-1789-16b2-e1ee-8b3a3e732049_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546866354432844580",
    "name": "The 2974 Collection #1806",
    "imageUrl": "https://arweave.net/UFHuHPTrDN9ULXi9BvkD_bLJJ5Yse8Y4HT37yiBZbH0?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1807,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -25,
    "LOC_Y": 257,
    "GAME_DATE": 20170211,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/11/0021600813/151/f4b2f78e-2d2d-cc0f-c986-8c88b44a7f5e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/372520658853155252",
    "name": "The 2974 Collection #1807",
    "imageUrl": "https://arweave.net/LKJPdZNoWweOUOZucM6OxtCy9q70UUzeuBS23UVjqt0?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1808,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 148,
    "LOC_Y": 188,
    "GAME_DATE": 20170211,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/11/0021600813/246/b0370623-23f7-2272-8234-3cb698fcfbe8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328698803497497781",
    "name": "The 2974 Collection #1808",
    "imageUrl": "https://arweave.net/O5HPFiXOewqJCrYh-wemYdOQ_QCtFTW0h99sRTfrCz8?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1809,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -225,
    "LOC_Y": 52,
    "GAME_DATE": 20170211,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/11/0021600813/306/8506e0ef-8d84-eb3e-c0cc-056255f01ff7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297009225948686588",
    "name": "The 2974 Collection #1809",
    "imageUrl": "https://arweave.net/r-OkAAku4Noou6mCiiD4VWNztbcCQrK37RmtBYudHpA?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1810,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 119,
    "LOC_Y": 213,
    "GAME_DATE": 20170211,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/11/0021600813/590/15d23162-e484-5202-c9a9-e2882dec3c69_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307626878924776575",
    "name": "The 2974 Collection #1810",
    "imageUrl": "https://arweave.net/-1HS-ciPeIRurdlMc5s2-yKO6q_OmHjyFdcqG9uBlsQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1811,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 132,
    "LOC_Y": 229,
    "GAME_DATE": 20170213,
    "Season": "2016-2017",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/13/0021600827/228/88e4b860-97e4-cf4a-abe0-be89baf488b5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552519930307700417",
    "name": "The 2974 Collection #1811",
    "imageUrl": "https://arweave.net/mdXjSvWdzrGTdnzu-IFHbxgGmk8kj_j2UyUfAdW2WVY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2017,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1812,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -192,
    "LOC_Y": 170,
    "GAME_DATE": 20170215,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/15/0021600847/188/be62e8ff-e878-3ead-c5bc-ae1becc97f05_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/380022322947992469",
    "name": "The 2974 Collection #1812",
    "imageUrl": "https://arweave.net/_0l3F7DhlNE5J1p9LfRtqHdXMIrLje1EW2zAuFfh16Q?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1813,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -122,
    "LOC_Y": 283,
    "GAME_DATE": 20170215,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/15/0021600847/302/ea8073b0-77a4-8d6a-2cf9-32141db370b7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326985249809358017",
    "name": "The 2974 Collection #1813",
    "imageUrl": "https://arweave.net/nsVrvHb8bKLBX-9RWj2RMXPBG319YxqI2Um8PolR794?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1814,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -32,
    "LOC_Y": 269,
    "GAME_DATE": 20170223,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/23/0021600854/120/f4358324-5659-4cd6-4987-06ea3eb7562e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/542890605378665970",
    "name": "The 2974 Collection #1814",
    "imageUrl": "https://arweave.net/oD61s1b96dogoA9Hmi7kwfX53o4i5rMuTPKS5_VbNX4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1815,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -156,
    "LOC_Y": 213,
    "GAME_DATE": 20170223,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/23/0021600854/315/62bbc0e4-0968-3cc6-27d4-1d3767df724c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/537046707658705244",
    "name": "The 2974 Collection #1815",
    "imageUrl": "https://arweave.net/9rdqX71yZQY2aKwgqtpRg4JHo8ykPjjpqNUL4H06f1o?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1816,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 11,
    "GAME_DATE": 20170223,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/23/0021600854/389/67e5d846-b79c-e67d-7b32-2b0ca83d118a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420508513994384004",
    "name": "The 2974 Collection #1816",
    "imageUrl": "https://arweave.net/qbjoshjes0Yqz76_VKxshF5WnLtj_Y8hZbgKeTqWNNs?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1817,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 177,
    "LOC_Y": 174,
    "GAME_DATE": 20170223,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/23/0021600854/391/4ad62793-e511-ec5a-2b27-762349e0f1a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/325789527324824268",
    "name": "The 2974 Collection #1817",
    "imageUrl": "https://arweave.net/3h71C17h0lqfKd8YYlPjwWHkp_DCqU-njGQZ58iY254?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1818,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -199,
    "LOC_Y": 188,
    "GAME_DATE": 20170223,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/23/0021600854/439/3ec81f14-7c59-d4c5-6a21-35aea5fab4fa_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328445566941532578",
    "name": "The 2974 Collection #1818",
    "imageUrl": "https://arweave.net/EnHKyzbB4EY_KAxbGUhwA2uK5x_z7-nRFMhozE40rDk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1819,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 171,
    "LOC_Y": 259,
    "GAME_DATE": 20170223,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/23/0021600854/453/0a693101-dedb-5cf0-33b1-6fa5235e0217_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/437952397576429748",
    "name": "The 2974 Collection #1819",
    "imageUrl": "https://arweave.net/nAcqIKZVMe-z0i1XGWX8efEW4VKvYfYg_O4ToBk1T0A?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1820,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 94,
    "LOC_Y": 232,
    "GAME_DATE": 20170225,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/25/0021600873/26/d68ad1dd-321b-8d21-dd8b-c28c912bf623_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450173081003379712",
    "name": "The 2974 Collection #1820",
    "imageUrl": "https://arweave.net/MVcwRvlqr5enq5AnWk8mT3bubld9UGDQul1oZF4qORQ?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2017,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1821,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -125,
    "LOC_Y": 219,
    "GAME_DATE": 20170225,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/25/0021600873/49/3908258c-03b0-f3e1-6de4-10d0a9bb05d8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/419349897827686632",
    "name": "The 2974 Collection #1821",
    "imageUrl": "https://arweave.net/KgXyoIWZHKn0B3DY3CKuxrG0YW-ZAYKPV806P0ePL80?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2017,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1822,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -102,
    "LOC_Y": 237,
    "GAME_DATE": 20170225,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/25/0021600873/80/ada39911-f5c9-fa27-12f0-649f305f4599_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293538198100132671",
    "name": "The 2974 Collection #1822",
    "imageUrl": "https://arweave.net/yrRBkejiLl_8K_bZJKAST9ZqN5ZE0vx0GNX_d0M-5UY?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2017,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1823,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -160,
    "LOC_Y": 203,
    "GAME_DATE": 20170225,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/25/0021600873/249/a690310a-6af6-297a-81f9-085beef70f81_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443373792642195893",
    "name": "The 2974 Collection #1823",
    "imageUrl": "https://arweave.net/hm91MtJ-6bs0VqRp-GJmV_ofy1SicYsIWWL6smqL82A?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2017,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1824,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -19,
    "LOC_Y": 259,
    "GAME_DATE": 20170225,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/25/0021600873/527/d3feb12a-982e-900c-2c8c-1eef28e9b8b6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355120190381873570",
    "name": "The 2974 Collection #1824",
    "imageUrl": "https://arweave.net/lUavAaMmc7Pgj6gbMe8tRFQhUll5QE9Z3N6Di6Ir0Ws?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2017,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1825,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -215,
    "LOC_Y": 134,
    "GAME_DATE": 20170228,
    "Season": "2016-2017",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/28/0021600889/291/ac9cb31d-3d44-4f2c-2346-4ce6a1ef5f18_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/294385884597148794",
    "name": "The 2974 Collection #1825",
    "imageUrl": "https://arweave.net/-DncdRKrAZ_htdjjLKCstmASXNcrMAYGo7wY_IniiPo?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1826,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -176,
    "LOC_Y": 198,
    "GAME_DATE": 20170228,
    "Season": "2016-2017",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/02/28/0021600889/418/d2120c45-7a86-16dd-df4d-fbe3152fceac_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/396679097141289264",
    "name": "The 2974 Collection #1826",
    "imageUrl": "https://arweave.net/h5oJ49A6V2q2ki-H09nfWF84MYvH0Bj27P6yLvgjklM?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1827,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": -21,
    "GAME_DATE": 20170302,
    "Season": "2016-2017",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/02/0021600906/223/8e7773f8-05d2-7ff8-75cd-97ab87ff90fe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390157186588272691",
    "name": "The 2974 Collection #1827",
    "imageUrl": "https://arweave.net/USipYFSq_uyRqRewUbd5-Uod3LjU-noKjtp_d9C31Cw?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2017,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1828,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 122,
    "LOC_Y": 223,
    "GAME_DATE": 20170302,
    "Season": "2016-2017",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/02/0021600906/324/d9c370cf-1c1b-cb01-5c73-36860a7c7834_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474798500772132186",
    "name": "The 2974 Collection #1828",
    "imageUrl": "https://arweave.net/FRso6E1QpXH3AmJ_7UQGIiiQPa1X6xr-1r87cp5ihj8?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2017,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1829,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -88,
    "LOC_Y": 222,
    "GAME_DATE": 20170305,
    "Season": "2016-2017",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/05/0021600928/230/86fddf9c-fc72-d945-bc4a-bfe5ca6d6b95_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429895547122628288",
    "name": "The 2974 Collection #1829",
    "imageUrl": "https://arweave.net/nhD0WhOR2zSbNjg1K5cO6DtJcEVhtmHDQ4clH_RT8gI?ext=png",
    "Opposing Team City": "New York",
    "Year": 2017,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1830,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 145,
    "LOC_Y": 203,
    "GAME_DATE": 20170305,
    "Season": "2016-2017",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/05/0021600928/289/c2951932-0382-c185-103d-86a8cc4f24c2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347470415589118008",
    "name": "The 2974 Collection #1830",
    "imageUrl": "https://arweave.net/r3MUbK3f60VMGpr16mjQVtVnNF-Ef42O8MKXsmNLDlg?ext=png",
    "Opposing Team City": "New York",
    "Year": 2017,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1831,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 163,
    "LOC_Y": 208,
    "GAME_DATE": 20170305,
    "Season": "2016-2017",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/05/0021600928/308/1af20405-f441-01b7-94a2-abe42bd6be30_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572847442243637744",
    "name": "The 2974 Collection #1831",
    "imageUrl": "https://arweave.net/KLMFnAHxxAPPdVPjcBBN9H8PTKI-iXYArKdkJxstD1c?ext=png",
    "Opposing Team City": "New York",
    "Year": 2017,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1832,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -11,
    "GAME_DATE": 20170305,
    "Season": "2016-2017",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/05/0021600928/407/1bfaaebe-06e6-d6ea-13cb-87b1077ae6c1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/306281294830198854",
    "name": "The 2974 Collection #1832",
    "imageUrl": "https://arweave.net/YQEi0qPkXeFLUbbJ6B8d_e11ML61TA5IAqK14Sxlhug?ext=png",
    "Opposing Team City": "New York",
    "Year": 2017,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1833,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -137,
    "LOC_Y": 213,
    "GAME_DATE": 20170305,
    "Season": "2016-2017",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/05/0021600928/416/86b921bd-0ea4-c31f-f102-4e0cc7901c67_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493689045435064417",
    "name": "The 2974 Collection #1833",
    "imageUrl": "https://arweave.net/860xgNjSeEdI411QS1ZS08gL4_c9YSnuEjqOBlcGS-M?ext=png",
    "Opposing Team City": "New York",
    "Year": 2017,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1834,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 125,
    "LOC_Y": 208,
    "GAME_DATE": 20170306,
    "Season": "2016-2017",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/06/0021600937/141/b6826e9b-335f-42b0-7b4d-ca162389ea6e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484663635717035433",
    "name": "The 2974 Collection #1834",
    "imageUrl": "https://arweave.net/VOPKw3645LuvXLuhG7uV9vVIaNMpBvzZHo0ql8RT3TQ?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2017,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1835,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -219,
    "LOC_Y": 134,
    "GAME_DATE": 20170306,
    "Season": "2016-2017",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331301321233512091",
    "name": "The 2974 Collection #1835",
    "imageUrl": "https://arweave.net/OiPPTFb9Yx61mLUIwBOhN7BSA9ASc_KLyislgu8ZKRk?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2017,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1836,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 105,
    "LOC_Y": 223,
    "GAME_DATE": 20170306,
    "Season": "2016-2017",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/06/0021600937/363/5e470fad-ebaf-6317-092f-2f559d455234_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379489314237070116",
    "name": "The 2974 Collection #1836",
    "imageUrl": "https://arweave.net/Fq3OFcfp3UiPuBDfIsofaN4E0ucRFuuSFPfHFBUwIe8?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2017,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1837,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 217,
    "LOC_Y": 141,
    "GAME_DATE": 20170306,
    "Season": "2016-2017",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/06/0021600937/438/93ca1ea0-ff7b-c4be-8625-c56e538d3468_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518816841558852172",
    "name": "The 2974 Collection #1837",
    "imageUrl": "https://arweave.net/f8a7jiGzUho5yf5tVAWmkRk7aRctb9Ivy6r898jE9Oo?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2017,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1838,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 0,
    "GAME_DATE": 20170306,
    "Season": "2016-2017",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/06/0021600937/527/e5da9f60-b6e5-1d77-170e-e4f96379708c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500570380589633205",
    "name": "The 2974 Collection #1838",
    "imageUrl": "https://arweave.net/cxtgrRH73mfpJ4DTmXRqugc3-2Io8r3B3INFop_nHpQ?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2017,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1839,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 197,
    "LOC_Y": 164,
    "GAME_DATE": 20170306,
    "Season": "2016-2017",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/06/0021600937/536/fc66e74b-e128-4184-50cf-9186ff76490a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297841358035650216",
    "name": "The 2974 Collection #1839",
    "imageUrl": "https://arweave.net/J93IsAl1v-QtBSXsTN3PjwIVuBlwZUPaH7BAw7d-mAQ?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2017,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1840,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -158,
    "LOC_Y": 208,
    "GAME_DATE": 20170308,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/08/0021600959/56/4b3296b2-b70e-f5a1-7ae7-bb719e067ffd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502998443991323996",
    "name": "The 2974 Collection #1840",
    "imageUrl": "https://arweave.net/jXEGkfvGXL97c8lDlhxQdmF7se5ctM4nA5vmGsYCHMk?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2017,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1841,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 42,
    "LOC_Y": 257,
    "GAME_DATE": 20170308,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/08/0021600959/371/c128a236-d495-f1cf-2467-9527e6671b4d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305340452310310126",
    "name": "The 2974 Collection #1841",
    "imageUrl": "https://arweave.net/4aDPw0gCPxXQGbv03_uCbak3zftsLpHueNMgtkR9SMU?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2017,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1842,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 104,
    "LOC_Y": 232,
    "GAME_DATE": 20170310,
    "Season": "2016-2017",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/10/0021600968/273/0c6144a3-7336-275a-65ee-a445f4093d21_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400489537100109899",
    "name": "The 2974 Collection #1842",
    "imageUrl": "https://arweave.net/w_uCkJqLZQAtx29qLLCIwRuPpnVAPVu3Uiv4HQeFNGA?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2017,
    "Month": 3,
    "Day": 10,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1843,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 47,
    "GAME_DATE": 20170314,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/14/0021601003/104/6ba08bc6-86cc-994f-7f3b-2b8d75d4f5fb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/466030309164081254",
    "name": "The 2974 Collection #1843",
    "imageUrl": "https://arweave.net/n8FJ4ES44atKnAuyqNnli2RbctKy469PuFinG_wBMn0?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1844,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 2,
    "LOC_Y": 272,
    "GAME_DATE": 20170314,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/14/0021601003/368/718fd3ad-57ae-a4cb-9b9c-2870b220ffa2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/514283848617739172",
    "name": "The 2974 Collection #1844",
    "imageUrl": "https://arweave.net/v68yA7GDt2nXSDU-mu81neICUubvnHttZau8EubAAj0?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1845,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 73,
    "LOC_Y": 254,
    "GAME_DATE": 20170314,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/14/0021601003/477/6c168e89-b3c9-0af1-6067-7e7b03990f1e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348158427507926535",
    "name": "The 2974 Collection #1845",
    "imageUrl": "https://arweave.net/v1x-le2EWqNIJ-lpU9TrUFEZwuwH96v0NH-IL6SVOPY?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1846,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -158,
    "LOC_Y": 223,
    "GAME_DATE": 20170314,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/14/0021601003/536/c7a34ddd-e43e-4196-86ac-0434374ed94b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312017033997428988",
    "name": "The 2974 Collection #1846",
    "imageUrl": "https://arweave.net/1FNhEMSq_ywoWu5PVHWpjbDuCGv4CvsgDiD2Q5u2K38?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1847,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -227,
    "LOC_Y": 11,
    "GAME_DATE": 20170314,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/14/0021601003/554/3def1683-1fc8-f4b8-a144-8a2822b444b9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429955577959387150",
    "name": "The 2974 Collection #1847",
    "imageUrl": "https://arweave.net/5ZsbJ484bixk5bQJAEjLe-Aug9thoGCY0kFkPOWdIPw?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Birthday Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1848,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 112,
    "LOC_Y": 244,
    "GAME_DATE": 20170316,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/16/0021601019/295/29cd1128-3ecc-1869-18af-9b1d04601625_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/532893664150287164",
    "name": "The 2974 Collection #1848",
    "imageUrl": "https://arweave.net/AT6B2iPQakwghY-jmffArbOHp1oy4uXqHQ-8p5y4CxY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1849,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 35,
    "LOC_Y": 257,
    "GAME_DATE": 20170316,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/16/0021601019/366/abd8e3bf-cb3b-7fe7-00b4-09ab3a35574f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344015670205223781",
    "name": "The 2974 Collection #1849",
    "imageUrl": "https://arweave.net/StjhcfRICOTwGfyvQNE3WdLXuAnVPyUf4bviT5bqkj4?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1850,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -207,
    "LOC_Y": 156,
    "GAME_DATE": 20170318,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/18/0021601035/63/b7a4ac39-925c-6eae-a7a6-74c718910b86_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/325516335699293651",
    "name": "The 2974 Collection #1850",
    "imageUrl": "https://arweave.net/aOrGT0CENRfekuGgjaqoMbh16SYgnU0FkacUKeJBIMc?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2017,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1851,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -223,
    "LOC_Y": 139,
    "GAME_DATE": 20170318,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/18/0021601035/108/18b57ec7-463a-bda0-a734-730ae31f49f1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459270822574358971",
    "name": "The 2974 Collection #1851",
    "imageUrl": "https://arweave.net/f139QL7gJHkvfHP2NKDJEuyWNuK8BX2eYgQ2vmvuSV8?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2017,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1852,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -63,
    "LOC_Y": 257,
    "GAME_DATE": 20170318,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/18/0021601035/211/a4b9751c-4ea7-d5ba-7313-ec2f4df5f5c2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412505412023035615",
    "name": "The 2974 Collection #1852",
    "imageUrl": "https://arweave.net/oUYazjQXna6dYTIcEx0Sl837ONgjBMo6QfUBydLhBHQ?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2017,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1853,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": -143,
    "LOC_Y": 298,
    "GAME_DATE": 20170318,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/18/0021601035/224/11c08454-0785-3de6-545a-8c2f1c51a402_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497394382883260575",
    "name": "The 2974 Collection #1853",
    "imageUrl": "https://arweave.net/NMrreJZLcBcz9_0RfOHRcFnbIEnqwJenuzOWh_yX_zo?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2017,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1854,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -163,
    "LOC_Y": 193,
    "GAME_DATE": 20170318,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/18/0021601035/280/ed8cc4d3-654b-02b8-5726-ee0b25664c23_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309970694011475145",
    "name": "The 2974 Collection #1854",
    "imageUrl": "https://arweave.net/zsqQp0qPjtcXgsJEXlV1J5VPBeF2C1DJJ1154Gh6cDM?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2017,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1855,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 138,
    "LOC_Y": 229,
    "GAME_DATE": 20170318,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/18/0021601035/332/53388ca4-5d1e-802b-29c6-5daa5693cdc8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307959961039459013",
    "name": "The 2974 Collection #1855",
    "imageUrl": "https://arweave.net/qh4XhjmRZyW-da1Z-0-SD4zdW-U1XFP1FiCm6kHVZpI?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2017,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1856,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -178,
    "LOC_Y": 190,
    "GAME_DATE": 20170320,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/20/0021601049/6/6d83a854-cbb0-a181-3f0d-ca2dcced8734_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/457632658032401928",
    "name": "The 2974 Collection #1856",
    "imageUrl": "https://arweave.net/ilwF-svCHKKikd3IhHOMHc1dUWN1PJ0_cfdqg--y8Fs?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1857,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 51,
    "LOC_Y": 234,
    "GAME_DATE": 20170320,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/20/0021601049/34/1df78049-4fa8-3e06-4749-c2c8140da917_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/571854217054054523",
    "name": "The 2974 Collection #1857",
    "imageUrl": "https://arweave.net/_2GtFoB9zoix4IY-ulceXt2lJKo9eVp77oUeH5pMIvY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1858,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 8,
    "GAME_DATE": 20170320,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/20/0021601049/55/259a04de-6a34-df6b-555a-6887bfc5c6b5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385248883473660000",
    "name": "The 2974 Collection #1858",
    "imageUrl": "https://arweave.net/Q-2yVB4KxhO_VK3A1Q5e9f7beZD0DNclZAjPJSN8LEI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1859,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -225,
    "LOC_Y": 8,
    "GAME_DATE": 20170320,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/20/0021601049/261/f8682e45-5ab8-e6d8-6ae1-14e8d163eaef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/332303771906893094",
    "name": "The 2974 Collection #1859",
    "imageUrl": "https://arweave.net/jXsHvXsWPiuYE_CYR9EMOgV8PJ-VSOo-LGZS5iOu0qQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1860,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 110,
    "LOC_Y": 224,
    "GAME_DATE": 20170320,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/20/0021601049/296/09098ff9-8cf1-c7ea-2b6c-11fe292e40cf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334965520920948107",
    "name": "The 2974 Collection #1860",
    "imageUrl": "https://arweave.net/iMQNEppKwIInfC16yvQ1eNAyLn46dau43G-1zZfX3UY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1861,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -9,
    "LOC_Y": 239,
    "GAME_DATE": 20170320,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/20/0021601049/365/6c448138-8d22-9444-f9a2-b1d3825dd2f3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338713639602830220",
    "name": "The 2974 Collection #1861",
    "imageUrl": "https://arweave.net/4v09XmjLNpgYJcRFPPL7QFYGWYR6tlSE0lKMt9apRXs?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1862,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -25,
    "LOC_Y": 249,
    "GAME_DATE": 20170320,
    "Season": "2016-2017",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/20/0021601049/448/f94b561b-ea69-be8e-2707-09ba71fbb9d7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/527007318129282496",
    "name": "The 2974 Collection #1862",
    "imageUrl": "https://arweave.net/VGV1ZPpZJpiH7jZJnV4LVEHtM2bZ5wcqMcDClThYUqw?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 3,
    "Day": 20,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1863,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -227,
    "LOC_Y": 2,
    "GAME_DATE": 20170321,
    "Season": "2016-2017",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/21/0021601055/106/3c671566-46f1-1c51-ce47-72a52d3be513_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518916795732240207",
    "name": "The 2974 Collection #1863",
    "imageUrl": "https://arweave.net/fd0bHmYitWeuxF-LS8BOerMfqoGN98_fmGSuNQSL1co?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2017,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1864,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -124,
    "LOC_Y": 237,
    "GAME_DATE": 20170321,
    "Season": "2016-2017",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/21/0021601055/299/da6b1f6b-6580-14c5-0610-8ae4ac682d62_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/426879174371195266",
    "name": "The 2974 Collection #1864",
    "imageUrl": "https://arweave.net/MtPvNZDmK-qAuv7bHaAM163T3fh5WQMvKqc5uog5ecY?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2017,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1865,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -135,
    "LOC_Y": 213,
    "GAME_DATE": 20170321,
    "Season": "2016-2017",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/21/0021601055/358/681dba8f-d542-9523-f190-4ae0ec7f6a9b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330231621479980923",
    "name": "The 2974 Collection #1865",
    "imageUrl": "https://arweave.net/oslPWTB8Ly0jgPAg0C0D0F_pcghhG66midDr4D3TFrE?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2017,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1866,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -184,
    "LOC_Y": 174,
    "GAME_DATE": 20170324,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/24/0021601081/3/c0e8f03a-1022-b344-2423-bffc261e2b2f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/393797072430905250",
    "name": "The 2974 Collection #1866",
    "imageUrl": "https://arweave.net/1rRVGU-ekcAaRfYt4M3seajx5pS6bSMjNyPYh78Kdyw?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1867,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 55,
    "LOC_Y": 262,
    "GAME_DATE": 20170324,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/24/0021601081/79/bc66abe6-35da-13be-75e5-47651672456a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436308965594064300",
    "name": "The 2974 Collection #1867",
    "imageUrl": "https://arweave.net/n-L_tuhzGDZmHTWWVpgnpMwD0nw5SFtLAfHOFYOuIHc?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1868,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -197,
    "LOC_Y": 180,
    "GAME_DATE": 20170324,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/24/0021601081/438/033c4824-d504-4cb5-9381-2ca0a964aba0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335545308515344264",
    "name": "The 2974 Collection #1868",
    "imageUrl": "https://arweave.net/zdfY-AqMygLs8dCtJ_eFmkRGOtM1YIBJN7FPUekUPtA?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1869,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -192,
    "LOC_Y": 178,
    "GAME_DATE": 20170324,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/24/0021601081/444/287b8526-e060-de98-8d87-94563620d046_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/506260776224725409",
    "name": "The 2974 Collection #1869",
    "imageUrl": "https://arweave.net/xJNt9b_nweQNZyGBIEXr6WEgtqwzdWCnC8e4rWba5YI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1870,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -48,
    "LOC_Y": 277,
    "GAME_DATE": 20170324,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/24/0021601081/447/60c4e674-af39-9068-603c-837c7eef827c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/389905771189762368",
    "name": "The 2974 Collection #1870",
    "imageUrl": "https://arweave.net/WnleRMPPfYDK8gJeb19wlGrCK1dWY69IOPy5LcPpsws?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2017,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1871,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 8,
    "GAME_DATE": 20170326,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/26/0021601094/15/2e1ca506-b648-893a-5fe1-3b4efa78ce75_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319945249781654830",
    "name": "The 2974 Collection #1871",
    "imageUrl": "https://arweave.net/teZIK4ptggyGw4Sd4BST7n4eHotaqDJf4BNMLWnda0M?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 3,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1872,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -209,
    "LOC_Y": 185,
    "GAME_DATE": 20170326,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/26/0021601094/98/a9abd2f2-d7d5-ccc2-8fab-2ba00d41947d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539334094475140849",
    "name": "The 2974 Collection #1872",
    "imageUrl": "https://arweave.net/iyxzOgQUEpilicnGd46G78VUjODiGjXOhr3YtanmdbA?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 3,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1873,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": 16,
    "GAME_DATE": 20170326,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/26/0021601094/196/008dcc0b-7206-8daa-a9e6-fd49c7ab322d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386029213729412225",
    "name": "The 2974 Collection #1873",
    "imageUrl": "https://arweave.net/zwuNbN_FZg2kRFldSRrHyTpGIy_mFUHRoTXQ7GHpGe0?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 3,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1874,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -19,
    "LOC_Y": 247,
    "GAME_DATE": 20170326,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/26/0021601094/429/9c760768-66d9-830a-997f-dba080a76a41_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305459337204616461",
    "name": "The 2974 Collection #1874",
    "imageUrl": "https://arweave.net/5ExiePx7lsaKyOAFNFwL7xeOY4zXfn7noags0ra4Z1E?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 3,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1875,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 151,
    "LOC_Y": 223,
    "GAME_DATE": 20170326,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/26/0021601094/439/287f85b2-e11a-2ef8-a7f4-7d4fd19eb56a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388134918277806780",
    "name": "The 2974 Collection #1875",
    "imageUrl": "https://arweave.net/ElMKio5bAC3-y5xj_MLSFJqlebKMBHEDLJmTKPfb77A?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 3,
    "Day": 26,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1876,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 233,
    "LOC_Y": 100,
    "GAME_DATE": 20170328,
    "Season": "2016-2017",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/28/0021601108/8/d87a09dd-2878-6f74-9716-a1a1a3031192_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/516202753905248469",
    "name": "The 2974 Collection #1876",
    "imageUrl": "https://arweave.net/6wGO2i_UcbiEEKHjECOlOAD8mDY6nF4wLwSXQThZpdw?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1877,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -174,
    "LOC_Y": 178,
    "GAME_DATE": 20170328,
    "Season": "2016-2017",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/28/0021601108/337/3307be72-14e8-35db-6ee2-fea66a33f239_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/351189468273258960",
    "name": "The 2974 Collection #1877",
    "imageUrl": "https://arweave.net/eIt-yKFP8hbEXvDGoVaHYobFHVJepfr-7J7DEPKyH20?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1878,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 9,
    "LOC_Y": 259,
    "GAME_DATE": 20170328,
    "Season": "2016-2017",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/28/0021601108/583/abd19ffb-e518-4603-967f-9280377d101b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308503304775035115",
    "name": "The 2974 Collection #1878",
    "imageUrl": "https://arweave.net/KvQldUJwjLLd0PEpu2Ha3h_5JielXa5dXiqsRTT9bpA?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 3,
    "Day": 28,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1879,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -225,
    "LOC_Y": 115,
    "GAME_DATE": 20170329,
    "Season": "2016-2017",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/29/0021601118/41/1311238d-b6ba-15a6-dc7b-8dd810fbc4ed_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/431598116366136373",
    "name": "The 2974 Collection #1879",
    "imageUrl": "https://arweave.net/0GC7AXuvIH_nki3VZiVQuwkgpzJSRWQvnAKfa45sUe8?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2017,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1880,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 173,
    "LOC_Y": 203,
    "GAME_DATE": 20170329,
    "Season": "2016-2017",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/29/0021601118/290/5a60a9f8-d597-df6f-080c-3a36f5a3d7e6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541210873345612420",
    "name": "The 2974 Collection #1880",
    "imageUrl": "https://arweave.net/KwLFLzcCAkpnQOPdr5jNZuquWwdUMXY-2ROm6WxT-4c?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2017,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1881,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 197,
    "LOC_Y": 165,
    "GAME_DATE": 20170329,
    "Season": "2016-2017",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/29/0021601118/314/eab3e436-bd61-d108-a490-ab031b418fd4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359939370154591459",
    "name": "The 2974 Collection #1881",
    "imageUrl": "https://arweave.net/FjisojSzQmZhGJOWpaJX3_XlHxHYJfjIHD2SaqGVj5w?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2017,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1882,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 194,
    "LOC_Y": 165,
    "GAME_DATE": 20170329,
    "Season": "2016-2017",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/29/0021601118/339/fbd59421-6985-229d-0377-a4ae90bf09da_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548138198509746572",
    "name": "The 2974 Collection #1882",
    "imageUrl": "https://arweave.net/2vEVr5_t6uzB1jc07VMfGB9J1o3KxvipdB7InlxP3D8?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2017,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1883,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 42,
    "LOC_Y": 249,
    "GAME_DATE": 20170331,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/31/0021601136/13/a88b09cb-680e-f5e3-e9af-b6b49dbbab26_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465325639260801650",
    "name": "The 2974 Collection #1883",
    "imageUrl": "https://arweave.net/GBqG5bCsCeLSAkYoHDW7PDbYZNTtmPyaXPcaZu5wV6E?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1884,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 65,
    "GAME_DATE": 20170331,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/31/0021601136/317/357c3201-6884-2b20-46d3-9405de0437e2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552170917972896614",
    "name": "The 2974 Collection #1884",
    "imageUrl": "https://arweave.net/dYbGSuGGODvjRwm7V8TtL134938SprPSfIPh428mCFM?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1885,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 207,
    "LOC_Y": 144,
    "GAME_DATE": 20170331,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/31/0021601136/366/6183dc9d-88d0-e0f9-7290-598432507cb8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450359856272775246",
    "name": "The 2974 Collection #1885",
    "imageUrl": "https://arweave.net/MbKkMUjOrYvZLwORvUrdi9W5FT4myYkPrBkkwsf781o?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1886,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 161,
    "LOC_Y": 232,
    "GAME_DATE": 20170331,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/03/31/0021601136/495/1cf11324-e140-25e7-e5a6-870dafdf5295_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386151155122215082",
    "name": "The 2974 Collection #1886",
    "imageUrl": "https://arweave.net/ZFsVRz1V4Yy8CNtUpaeScSA7xWN5vXHzb38vdfD4lvQ?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1887,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 182,
    "LOC_Y": 183,
    "GAME_DATE": 20170402,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/02/0021601152/7/9316d410-5abe-5af5-7406-1cf6591cd832_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327732316235158305",
    "name": "The 2974 Collection #1887",
    "imageUrl": "https://arweave.net/gBIbF2grBXRN1srJNMS0vUp0spNvANpxiujPUB29Obw?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1888,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -217,
    "LOC_Y": 164,
    "GAME_DATE": 20170402,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/02/0021601152/27/b5620cfa-17e7-335b-a02e-57a97c129fba_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422034096553847539",
    "name": "The 2974 Collection #1888",
    "imageUrl": "https://arweave.net/3hvEuz4e_fU0GqibYHKZ6rY2YoYe1zjI2j_5MqOwTgw?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1889,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 11,
    "GAME_DATE": 20170402,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/02/0021601152/35/a4fb9383-df1e-7859-3a4e-50b27aba3a8b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476603700287957615",
    "name": "The 2974 Collection #1889",
    "imageUrl": "https://arweave.net/6mT_jOJIJ8CbLhVccs0r4_D4sD3WOZIoXQJMnHJS_0U?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1890,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 151,
    "LOC_Y": 219,
    "GAME_DATE": 20170402,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/02/0021601152/70/258edb73-34d7-3b33-ccc7-9284646ced6a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319635152202040203",
    "name": "The 2974 Collection #1890",
    "imageUrl": "https://arweave.net/aLmAodLc17t7RHJwF3Fa57cR8BPDtzhoQd3hQFEdK34?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1891,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 204,
    "LOC_Y": 160,
    "GAME_DATE": 20170402,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/02/0021601152/225/fcd2b1e9-ca49-8a51-8d63-9e9c086878d7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504747129857498524",
    "name": "The 2974 Collection #1891",
    "imageUrl": "https://arweave.net/sPdWypWtnr3xWlGBbARf7GOFWm7BApMaarwOY4Dnqx8?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1892,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 63,
    "LOC_Y": 259,
    "GAME_DATE": 20170402,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/02/0021601152/227/cb17f8d5-b9b4-2d7a-6730-5749bf555000_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382694569367849629",
    "name": "The 2974 Collection #1892",
    "imageUrl": "https://arweave.net/XwOloOC0_aMgHJC2yp8xUF4ejdUhXueMhzJ7x8Si0oc?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1893,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 189,
    "LOC_Y": 190,
    "GAME_DATE": 20170402,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/02/0021601152/276/33651dd4-d24f-ea29-0420-6847518db924_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436266974967901102",
    "name": "The 2974 Collection #1893",
    "imageUrl": "https://arweave.net/MMKBAvxqy8KSRASJ5lk10_svcNFDggS8jpiojaV0GhM?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1894,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 151,
    "LOC_Y": 228,
    "GAME_DATE": 20170402,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/02/0021601152/361/466ca748-966f-c393-1c14-629f5d384b08_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444893849053177568",
    "name": "The 2974 Collection #1894",
    "imageUrl": "https://arweave.net/0i-iPinX0K4hpxjSgxzop7vdpQmWSs3yA5_H77kiZNg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1895,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 151,
    "LOC_Y": 223,
    "GAME_DATE": 20170402,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/02/0021601152/495/8ab41342-9205-93cc-a746-6db35b48e38e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379575077391357434",
    "name": "The 2974 Collection #1895",
    "imageUrl": "https://arweave.net/WR1FRQI08YSCuYCMRrlqZRdxkk8rUzLP5j0HzNyR1vc?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1896,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 1,
    "LOC_Y": 267,
    "GAME_DATE": 20170404,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/04/0021601162/89/89027230-6d4b-243b-0bc5-4d7f7988b5d8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508022611303204933",
    "name": "The 2974 Collection #1896",
    "imageUrl": "https://arweave.net/OWuaavBkmkv7O1DPEJd_xpHFPcgru0BKcv3lAWmI4Xg?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2017,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1897,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -2,
    "LOC_Y": 262,
    "GAME_DATE": 20170404,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/04/0021601162/339/d1a18261-a6e8-93b4-9354-9c7466bda87a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541057582425086948",
    "name": "The 2974 Collection #1897",
    "imageUrl": "https://arweave.net/Op_P-t5KW_6k3uCdyPyiDqZO3DSbBGEoLOe7bkw11AY?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2017,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1898,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -147,
    "LOC_Y": 214,
    "GAME_DATE": 20170404,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/04/0021601162/342/ab1e917f-b535-9a0f-a44d-918725ec467a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392457067081585925",
    "name": "The 2974 Collection #1898",
    "imageUrl": "https://arweave.net/l9j_vr_cXaQef_9qTNujJVkmAdCMicM0OxqlGeptRvk?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2017,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1899,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 245,
    "LOC_Y": -6,
    "GAME_DATE": 20170405,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/05/0021601171/9/d2db1946-fd96-1bc8-8304-6e8e51a05cf1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319033728133647232",
    "name": "The 2974 Collection #1899",
    "imageUrl": "https://arweave.net/ccsFJbOCP0j_W_KM4DqPWW4-qypToDO3bx48kHnG3hE?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2017,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1900,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -237,
    "LOC_Y": 101,
    "GAME_DATE": 20170405,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/05/0021601171/24/ff5bbdd0-fce9-5c8a-a6e1-06e34be3b3ed_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418667287173261692",
    "name": "The 2974 Collection #1900",
    "imageUrl": "https://arweave.net/IHeMUA6INXw4GCAdxnLfNZIVLFjKjpt1UHqzNfwuJQI?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2017,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1901,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 53,
    "LOC_Y": 249,
    "GAME_DATE": 20170405,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/05/0021601171/35/81f62442-b1a1-cf71-2aa6-ff7d16f1228a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433721947471568353",
    "name": "The 2974 Collection #1901",
    "imageUrl": "https://arweave.net/INx9hrd155T4Sy8cmzZvtmOAlm9yeXFvahYg88CVz3w?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2017,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1902,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 2,
    "LOC_Y": 249,
    "GAME_DATE": 20170405,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/05/0021601171/53/3d639f21-8610-7164-3485-228b6cbe8674_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378743302551948675",
    "name": "The 2974 Collection #1902",
    "imageUrl": "https://arweave.net/aM-EXUuyA2WeRSAFXOdFncWK44g2o_kyelLWAsxdgZ4?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2017,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1903,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -65,
    "LOC_Y": 242,
    "GAME_DATE": 20170405,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/05/0021601171/92/27a4116f-f8f8-dd18-e02b-30467633f782_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404929856026243368",
    "name": "The 2974 Collection #1903",
    "imageUrl": "https://arweave.net/-VqPH9bvu8YUi1-oxtpScOgRJJLTZJqEMn5J5ds0ZII?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2017,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1904,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -124,
    "LOC_Y": 228,
    "GAME_DATE": 20170405,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/05/0021601171/244/b714f884-1034-ff8b-85c5-081816ae0bf8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373775816469830108",
    "name": "The 2974 Collection #1904",
    "imageUrl": "https://arweave.net/VGdtJ2976aWPlNT-sPG_NnysdhkiYDoajarLaYmm_2s?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2017,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1905,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 223,
    "LOC_Y": 120,
    "GAME_DATE": 20170405,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/05/0021601171/419/bcb1e45d-cad6-30fd-2033-65c5e1b8a3e9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480050855413483437",
    "name": "The 2974 Collection #1905",
    "imageUrl": "https://arweave.net/85L3mVMJIMzyjeTLpKYSqGz9po-eCr8NygW_Kr300xg?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2017,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1906,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 9,
    "LOC_Y": 259,
    "GAME_DATE": 20170405,
    "Season": "2016-2017",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/05/0021601171/519/b374887d-b208-cfc5-5a52-c41452c86ffe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468163224031404987",
    "name": "The 2974 Collection #1906",
    "imageUrl": "https://arweave.net/CkPUeaxqvfsFIiPY6SmpsLJqZUrcxSxB-bHS6Bd8rMw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2017,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1907,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 10,
    "LOC_Y": 252,
    "GAME_DATE": 20170410,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/10/0021601211/25/674c585d-4e3e-57b0-074c-1e2fd3a23774_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/333789376124547894",
    "name": "The 2974 Collection #1907",
    "imageUrl": "https://arweave.net/urqMfKvrmXen-0W751Mm-K9lJSzS-Fty83KVQmOwO5o?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2017,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1908,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 10,
    "LOC_Y": 264,
    "GAME_DATE": 20170410,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/10/0021601211/64/3bd40f45-46df-7688-7878-92e33e019467_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/457641657295968193",
    "name": "The 2974 Collection #1908",
    "imageUrl": "https://arweave.net/vzLBVvYpyASqTjXJpIcBoe7Vs0LZMt53YTUAj8Z_T6M?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2017,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1909,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 218,
    "LOC_Y": 116,
    "GAME_DATE": 20170410,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/10/0021601211/97/53ad83f8-4840-3376-10cd-8a85861f099d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388735453506475743",
    "name": "The 2974 Collection #1909",
    "imageUrl": "https://arweave.net/ZwduVQzBOA5nKbyrcrP6IfNlojcF44_DJp-JqPC72qk?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2017,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1910,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 207,
    "LOC_Y": 154,
    "GAME_DATE": 20170410,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/10/0021601211/181/e31c4c1d-7f2a-d6e6-7bc5-df54b8d0a574_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309818644106517088",
    "name": "The 2974 Collection #1910",
    "imageUrl": "https://arweave.net/5m528r_PZtxAl_I4L8tG3VPFpk0lD0dXPq9LUJCCV54?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2017,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1911,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -11,
    "LOC_Y": 277,
    "GAME_DATE": 20170410,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/10/0021601211/208/79432767-ef92-2ef7-006b-d0895ac4ffad_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/475251011891844175",
    "name": "The 2974 Collection #1911",
    "imageUrl": "https://arweave.net/y03mB70BV1hmRiFCQElcGGyTxHBe_CkFNlg_k2E2ogc?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2017,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1912,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -183,
    "LOC_Y": 193,
    "GAME_DATE": 20170410,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/10/0021601211/340/24bd6079-b682-45a7-3b16-b9a517210c25_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/340323850236149968",
    "name": "The 2974 Collection #1912",
    "imageUrl": "https://arweave.net/q1BrgSV2zIUhfL9dFHyRSzk1uf9IrJGQplKmDwZCcHw?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2017,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1913,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 78,
    "LOC_Y": 239,
    "GAME_DATE": 20170412,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/12/0021601229/29/d48fee64-d91f-33d0-770f-4cf31b50c348_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450031078138906651",
    "name": "The 2974 Collection #1913",
    "imageUrl": "https://arweave.net/zFnKfgU21oegJR6trPvgH7TT-78bPINIXZb_dd_PZmE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1914,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -212,
    "LOC_Y": 141,
    "GAME_DATE": 20170412,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/12/0021601229/43/a675f69e-fda3-68cc-5b1a-cf2d6ca4b8f0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/310365044690807086",
    "name": "The 2974 Collection #1914",
    "imageUrl": "https://arweave.net/PKcVx_lE3k_SSh9RpwsiRL7PiTTZ5dcJOUwoZXRBYjE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1915,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -202,
    "LOC_Y": 178,
    "GAME_DATE": 20170412,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/12/0021601229/53/2f3e371e-266d-80ff-e2a2-861d1987c4f1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359469473030040248",
    "name": "The 2974 Collection #1915",
    "imageUrl": "https://arweave.net/ijIO4QgYYifKb2hCUm9azepDZEW8967332Ghy9Siro8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1916,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 227,
    "LOC_Y": 82,
    "GAME_DATE": 20170412,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/12/0021601229/334/c28395c8-e6d5-67d4-5e6c-cf20a23673c6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/343796227031000410",
    "name": "The 2974 Collection #1916",
    "imageUrl": "https://arweave.net/0qHsCLM3zesJaHevpfc5gnail8v648SflkabJ-0c6kU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1917,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 184,
    "LOC_Y": 185,
    "GAME_DATE": 20170412,
    "Season": "2016-2017",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/04/12/0021601229/343/43aec1d3-9f82-0bdf-8af9-4eaeaef057e1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/516490553346067764",
    "name": "The 2974 Collection #1917",
    "imageUrl": "https://arweave.net/czmfPP3WdY54sql7g_hbTOGOk-LogbdErCbXWAp9Mm4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1918,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 95,
    "LOC_Y": 242,
    "GAME_DATE": 20171017,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/17/0021700002/56/f9743275-77f4-8432-0a8d-295de6597e0d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/449312845866752607",
    "name": "The 2974 Collection #1918",
    "imageUrl": "https://arweave.net/o2d_16kGqEh_sFSyp_s1I0irX50PTxRQIS1p1w8uljY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 10,
    "Day": 17,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1919,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 30,
    "LOC_Y": 252,
    "GAME_DATE": 20171017,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/17/0021700002/373/4f2b3144-414a-b8f1-aed6-e748356ace4f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428795564065873699",
    "name": "The 2974 Collection #1919",
    "imageUrl": "https://arweave.net/y8f35ojpiiDUswVnNizDxs6O_6FB7weJTWBjBkPmE34?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 10,
    "Day": 17,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1920,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -75,
    "LOC_Y": 241,
    "GAME_DATE": 20171017,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/17/0021700002/610/9c535c76-65b7-129b-3a86-fb1929433e61_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378609361521896378",
    "name": "The 2974 Collection #1920",
    "imageUrl": "https://arweave.net/-Xm6ys55n-vXXWcUFZPzI8cifLdywNobwKVprScSQic?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2017,
    "Month": 10,
    "Day": 17,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1921,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -133,
    "LOC_Y": 275,
    "GAME_DATE": 20171020,
    "Season": "2017-2018",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307615965198229987",
    "name": "The 2974 Collection #1921",
    "imageUrl": "https://arweave.net/eJz1MOFYioeZwAPMm3H0aXWR9aK7T-Safx5TLL3sOlA?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 10,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1922,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -103,
    "LOC_Y": 236,
    "GAME_DATE": 20171020,
    "Season": "2017-2018",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490654181347321822",
    "name": "The 2974 Collection #1922",
    "imageUrl": "https://arweave.net/HmnW2h0NYRWYlnpADVwSQzS3By-TWQF58L9k7JyG5MQ?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 10,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1923,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 192,
    "LOC_Y": 184,
    "GAME_DATE": 20171020,
    "Season": "2017-2018",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395492555250332760",
    "name": "The 2974 Collection #1923",
    "imageUrl": "https://arweave.net/ZB3aW6C6dCCQ74X70OFMiJMzk-pE1BNPX2_yrIcS1kU?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 10,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1924,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 239,
    "LOC_Y": 17,
    "GAME_DATE": 20171020,
    "Season": "2017-2018",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302647322170579130",
    "name": "The 2974 Collection #1924",
    "imageUrl": "https://arweave.net/CqkOAMTmsL_CA7qi7mglcy5lqiZlGGyoHhBCKEUvoR8?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 10,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1925,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -39,
    "LOC_Y": 260,
    "GAME_DATE": 20171021,
    "Season": "2017-2018",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/21/0021700033/67/56a2bbdd-6d1c-1b80-a1e5-c2b1eaeebb18_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344109713241420043",
    "name": "The 2974 Collection #1925",
    "imageUrl": "https://arweave.net/W_oVbWcCHaZ9vWmFO25plvXWWr8Q0LYpPLGdSleuee8?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1926,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -100,
    "LOC_Y": 232,
    "GAME_DATE": 20171021,
    "Season": "2017-2018",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/21/0021700033/283/050c49cd-87ee-6e7f-d71b-b7ed05a1f533_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/555639052483424625",
    "name": "The 2974 Collection #1926",
    "imageUrl": "https://arweave.net/XRkWlXCSSnYjKEe4iSnt_XFbpGAK-DrVVHM03xSgkTM?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1927,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 89,
    "LOC_Y": 237,
    "GAME_DATE": 20171021,
    "Season": "2017-2018",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/315051925447296423",
    "name": "The 2974 Collection #1927",
    "imageUrl": "https://arweave.net/ayvCMS1TPFTPr7csCNfSFn2vwe3VeehWZm7w_Dr9iQU?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1928,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 22,
    "LOC_Y": 250,
    "GAME_DATE": 20171021,
    "Season": "2017-2018",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/21/0021700033/371/a487a78e-ecd6-7955-8f19-7793aebbf0f5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/528784267377288065",
    "name": "The 2974 Collection #1928",
    "imageUrl": "https://arweave.net/WCiF80OMYy1rUjhEmYU4G_711oIWZKG-HTxRPt4WS7A?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1929,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -14,
    "LOC_Y": 257,
    "GAME_DATE": 20171021,
    "Season": "2017-2018",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/21/0021700033/481/b6348604-7d90-224e-8d9d-260f582ce92e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/288750740286074369",
    "name": "The 2974 Collection #1929",
    "imageUrl": "https://arweave.net/oW3hli3CwMuj-WucLXK2ashR7Dvaowg--GqgMTjDp-8?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1930,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 60,
    "LOC_Y": 246,
    "GAME_DATE": 20171021,
    "Season": "2017-2018",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/21/0021700033/672/31be529a-9f9f-967e-4743-1bafc0c34176_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/318119763753243389",
    "name": "The 2974 Collection #1930",
    "imageUrl": "https://arweave.net/MyxGHy_ZTeUD21BmujDjR--RrXnqAVnQOA-v_ff6uvw?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1931,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": -5,
    "GAME_DATE": 20171023,
    "Season": "2017-2018",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/23/0021700045/267/8f30ed4e-65cb-5e7d-7ec3-34068d2e487f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/398258072310952575",
    "name": "The 2974 Collection #1931",
    "imageUrl": "https://arweave.net/uIcOdLDt1QkGTRFnYtO42oKX3OppmVz4ZtQoutkge-A?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2017,
    "Month": 10,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1932,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 179,
    "LOC_Y": 173,
    "GAME_DATE": 20171023,
    "Season": "2017-2018",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/23/0021700045/383/6d59caca-da4c-d2e7-a1f0-16f604fd76ff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309855505532288613",
    "name": "The 2974 Collection #1932",
    "imageUrl": "https://arweave.net/QKRMS56eXmIcUVhDd11ZuYfVeZjm6KK95yonC1Tgsaw?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2017,
    "Month": 10,
    "Day": 23,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1933,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -226,
    "LOC_Y": 111,
    "GAME_DATE": 20171025,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/25/0021700063/335/f210b42c-150e-d29c-8415-c3714077c88a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346369369971390113",
    "name": "The 2974 Collection #1933",
    "imageUrl": "https://arweave.net/9HF1R8Nk_4YYtUEUanwnaADP0mbURZz635nFYQbY_Ko?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2017,
    "Month": 10,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1934,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -222,
    "LOC_Y": -13,
    "GAME_DATE": 20171025,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/25/0021700063/455/99968bfd-b5cc-bc7b-fbb9-ba79ec8fa565_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/447440817187416441",
    "name": "The 2974 Collection #1934",
    "imageUrl": "https://arweave.net/lAnixduiU3FmVdDMDMYoJ3Zgzute3cBNxrDCVr2RUgQ?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2017,
    "Month": 10,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1935,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 164,
    "LOC_Y": 234,
    "GAME_DATE": 20171025,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/25/0021700063/458/8c991ea7-2aa8-8ef4-a777-1fb0a754eb5c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322483985955527158",
    "name": "The 2974 Collection #1935",
    "imageUrl": "https://arweave.net/yRP5Xxf11Kf7EwbNs9p70EphtGXzEGSoRjQLjtw78DU?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2017,
    "Month": 10,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1936,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -90,
    "LOC_Y": 243,
    "GAME_DATE": 20171025,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/25/0021700063/613/7128205b-effd-ea69-76cd-b367c652c8c8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480587154961614694",
    "name": "The 2974 Collection #1936",
    "imageUrl": "https://arweave.net/VqyGrk1stXrFvDKb-78euwKhMgpPjlTTWAlN7m7nBII?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2017,
    "Month": 10,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1937,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 120,
    "LOC_Y": 237,
    "GAME_DATE": 20171027,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/27/0021700075/150/61452237-46eb-8295-322e-6cd9cf12abbc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369433037022097265",
    "name": "The 2974 Collection #1937",
    "imageUrl": "https://arweave.net/ehBxSGJCk_EIb6mbXRzJtj-7WDAn3aaoMWcN8Ka59Wo?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1938,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 111,
    "LOC_Y": 255,
    "GAME_DATE": 20171027,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/27/0021700075/523/e5f962d8-c07c-445b-c60b-78febf4aa7f3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433430834720692227",
    "name": "The 2974 Collection #1938",
    "imageUrl": "https://arweave.net/dPl7Tbcwue3-uIB2PP7XCkqdXRmQ6MMvrknot6FEuDI?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1939,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -130,
    "LOC_Y": 219,
    "GAME_DATE": 20171027,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/27/0021700075/526/48d458b4-d5bc-063b-5944-c3e0bf9d30d6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/472434625656343653",
    "name": "The 2974 Collection #1939",
    "imageUrl": "https://arweave.net/90GMcRhZfoJgkI94n7KEyJlgvlcQYLLk5tsTiSRutAY?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2017,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1940,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 189,
    "LOC_Y": 168,
    "GAME_DATE": 20171029,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/29/0021700091/28/90165137-7b95-8464-03b3-2648109c6094_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/435828299304356625",
    "name": "The 2974 Collection #1940",
    "imageUrl": "https://arweave.net/3tMhJ9oxUCafRYq-W0qSLzGMqscA4G03MrleeI-y2RA?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2017,
    "Month": 10,
    "Day": 29,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1941,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -100,
    "LOC_Y": 226,
    "GAME_DATE": 20171029,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/29/0021700091/90/6ccbeacf-b990-5578-3d76-47a92792a7fd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326442129277189405",
    "name": "The 2974 Collection #1941",
    "imageUrl": "https://arweave.net/m3baL2SKLKXfOWBCSdZGQKb-byfxFSZr5UDuhMLKJeE?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2017,
    "Month": 10,
    "Day": 29,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1942,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 88,
    "LOC_Y": 241,
    "GAME_DATE": 20171029,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/29/0021700091/371/b130a5c1-1e5b-f045-9eae-8f1296091b28_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412485214036406729",
    "name": "The 2974 Collection #1942",
    "imageUrl": "https://arweave.net/5loUzQOaoVOhY1My_fc4ycenk3RpoWtnxGULfDu_vGI?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2017,
    "Month": 10,
    "Day": 29,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1943,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": -25,
    "GAME_DATE": 20171030,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/30/0021700100/54/d6fd0cb1-6145-ce56-9349-4cf91df09082_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489544346075758189",
    "name": "The 2974 Collection #1943",
    "imageUrl": "https://arweave.net/NzHj68A0kcLUIAkb5eN-Mr5zV2OLhEOSZ0BpDQIiobc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1944,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 134,
    "LOC_Y": 207,
    "GAME_DATE": 20171030,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/30/0021700100/76/ba4acd79-3f83-6566-cb2a-2170e8c347b4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363044724949116872",
    "name": "The 2974 Collection #1944",
    "imageUrl": "https://arweave.net/GgHQs2c-rInvMfh5HNaTV0T3isLTxqJwdNAl9SyT6oU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1945,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 76,
    "LOC_Y": 244,
    "GAME_DATE": 20171030,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/30/0021700100/324/d446aaea-e18e-be6e-13a2-ed49d838997b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346993780427021620",
    "name": "The 2974 Collection #1945",
    "imageUrl": "https://arweave.net/XwgYj1QeXL1DIPKbmOUu4A9d6gffgqyk30HUAOq-FbU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1946,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": 8,
    "GAME_DATE": 20171030,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/30/0021700100/412/8f437790-c4f1-d33f-af28-ee997e88d1dc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328894013165598231",
    "name": "The 2974 Collection #1946",
    "imageUrl": "https://arweave.net/l8OtISNIeQ-MmPwpXzAhaVUYTtYd-w8cNEvWgh0BmK8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1947,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 154,
    "LOC_Y": 201,
    "GAME_DATE": 20171030,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/30/0021700100/444/ba25d4d9-bd4f-9127-1afb-a5cbb049ba8f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/486249114088484629",
    "name": "The 2974 Collection #1947",
    "imageUrl": "https://arweave.net/vCO7lfkM7-v0OLUUr9ZtUTS8sDYhNKN3PM4u57zQEck?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1948,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -165,
    "LOC_Y": 206,
    "GAME_DATE": 20171030,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/30/0021700100/483/3c9e9dee-a0a7-5a76-e505-4fd0beafb25b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465210971125714883",
    "name": "The 2974 Collection #1948",
    "imageUrl": "https://arweave.net/lVD6jWzsoXiYb0nGn4wZvrgJjx6XF4q37d0aqhPTy_4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1949,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 12,
    "LOC_Y": 257,
    "GAME_DATE": 20171030,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/10/30/0021700100/511/6447028d-96b7-2b01-0d40-ec17b0bede82_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491206955427884973",
    "name": "The 2974 Collection #1949",
    "imageUrl": "https://arweave.net/GVYx6NFYJ26XLaNT_2kGAEY8ovz-yZWfhco_e5w6f_c?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1950,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 87,
    "LOC_Y": 239,
    "GAME_DATE": 20171102,
    "Season": "2017-2018",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/02/0021700117/157/d5298477-b930-da85-71bc-bb18b2f63b34_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/564148977495199897",
    "name": "The 2974 Collection #1950",
    "imageUrl": "https://arweave.net/XJl2_vNiHLxzNiJt4Ip9oC8uiiUD__Qj4xKpbgwYwxs?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2017,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1951,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 229,
    "LOC_Y": 75,
    "GAME_DATE": 20171102,
    "Season": "2017-2018",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/02/0021700117/160/e01a0dbc-2061-47f3-901b-d28d81058376_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436794429679501295",
    "name": "The 2974 Collection #1951",
    "imageUrl": "https://arweave.net/96Hg4GpxSS1YwQwe3uilYQH7gAUAEm4qcA9WJsY4fJE?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2017,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1952,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 98,
    "LOC_Y": 231,
    "GAME_DATE": 20171102,
    "Season": "2017-2018",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/02/0021700117/259/51a005ce-1bf3-7b8d-dae9-3388fbc31a96_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541238436638285390",
    "name": "The 2974 Collection #1952",
    "imageUrl": "https://arweave.net/g4Z9OfjpDgr0pd1ueqRFyay2cv2gm6VYVDetvh6BuCA?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2017,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1953,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 163,
    "LOC_Y": 189,
    "GAME_DATE": 20171104,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/04/0021700135/279/92b22b80-f51b-153c-4e38-b660881cb4a9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359263928614257697",
    "name": "The 2974 Collection #1953",
    "imageUrl": "https://arweave.net/Rh0Rcru2FipUze3ESYlBo4-_yjgFa6i2QdLO_SNCef4?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2017,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1954,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 26,
    "GAME_DATE": 20171104,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/04/0021700135/298/ccc26f8d-020c-4286-68b4-9802fe69dd50_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391342066812125484",
    "name": "The 2974 Collection #1954",
    "imageUrl": "https://arweave.net/EinYzFtZvT5-WAnuI2tTiLzEr7d0rHVQJn_EcQrUctk?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2017,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1955,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -237,
    "LOC_Y": 42,
    "GAME_DATE": 20171104,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/04/0021700135/397/9adcff19-1857-ca13-1399-f943968e4d14_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/554065091871405063",
    "name": "The 2974 Collection #1955",
    "imageUrl": "https://arweave.net/4EOL5he0zu3LiBuanYlM0C5SNeNxhZ8pXneQn5F62Ew?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2017,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1956,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 80,
    "LOC_Y": 233,
    "GAME_DATE": 20171104,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/04/0021700135/409/dc597044-4075-803b-61fc-dc7c4bf1cb09_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/473189657687044591",
    "name": "The 2974 Collection #1956",
    "imageUrl": "https://arweave.net/gZGn_IDUXBnxZYd8rXhncHaOK7trvEROJEausi-Na74?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2017,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1957,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -131,
    "LOC_Y": 226,
    "GAME_DATE": 20171104,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/04/0021700135/479/7bee7858-9c4a-62d3-db1d-d2f8ec3d9639_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308765166664212069",
    "name": "The 2974 Collection #1957",
    "imageUrl": "https://arweave.net/3DuwQ_6WlDnVxA_A2aIoyQjsKglCCZ64Uy9BneWs6r0?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2017,
    "Month": 11,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1958,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -128,
    "LOC_Y": 222,
    "GAME_DATE": 20171106,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/06/0021700148/414/87436aa9-8010-7452-a02d-9b2f94394656_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458378868373516225",
    "name": "The 2974 Collection #1958",
    "imageUrl": "https://arweave.net/hRkB7QCZMUx_NX3ldZzcGAbKTwURHjN-h1Yu3WN8xiE?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1959,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -116,
    "LOC_Y": 229,
    "GAME_DATE": 20171106,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/06/0021700148/633/145f1524-fa02-e968-17cf-06dad5a29866_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/298778311268052958",
    "name": "The 2974 Collection #1959",
    "imageUrl": "https://arweave.net/JX3FiF2Nrb4nijxzN1qrd9geijrdzj6BEjyHuoIRXcs?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 11,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1960,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 129,
    "LOC_Y": 220,
    "GAME_DATE": 20171108,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/08/0021700163/155/c3bc05bb-fe89-55d5-46e8-13c852d9900e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/425098422124878148",
    "name": "The 2974 Collection #1960",
    "imageUrl": "https://arweave.net/Ag5PdOtvGRKMzNdCThIBSbo4FqQp2oqGK2PCvlL5hQ8?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2017,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1961,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -163,
    "LOC_Y": 215,
    "GAME_DATE": 20171108,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/08/0021700163/286/f289b970-6e54-082a-18c1-f66643201c18_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415566382102174191",
    "name": "The 2974 Collection #1961",
    "imageUrl": "https://arweave.net/-JHWDkg7W-j_s2XowMG1uPFMGqTLteMFJp1T0_dl6oE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2017,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1962,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -205,
    "LOC_Y": 145,
    "GAME_DATE": 20171111,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/11/0021700184/112/3071c0a5-76d4-4a65-42bb-f3c61c5d2544_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/427219158460767949",
    "name": "The 2974 Collection #1962",
    "imageUrl": "https://arweave.net/2HyzLOKGrfm3qtduNeYbp16UYAFuIoyp87mZvUQ_M-M?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 11,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1963,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 58,
    "LOC_Y": 260,
    "GAME_DATE": 20171111,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/11/0021700184/278/d94cf9c5-4cca-5c47-fb55-5eec963ca105_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353063829429174666",
    "name": "The 2974 Collection #1963",
    "imageUrl": "https://arweave.net/xlrT-ulLJJRd_hNp4wpvK1UhTdxrQ6-jH4Bjm4H63PM?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 11,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1964,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -197,
    "LOC_Y": 199,
    "GAME_DATE": 20171111,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/11/0021700184/496/e1fbe5cd-c996-3246-5dc0-da70863a4463_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/448533121890799982",
    "name": "The 2974 Collection #1964",
    "imageUrl": "https://arweave.net/6IqnHhROd4WLtKzS1JAmSaciV7BscQJt5ESESDwBduo?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 11,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1965,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -78,
    "LOC_Y": 257,
    "GAME_DATE": 20171116,
    "Season": "2017-2018",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/16/0021700215/45/fe64a895-5491-c06b-2a9d-d704c3419156_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/305884420837741633",
    "name": "The 2974 Collection #1965",
    "imageUrl": "https://arweave.net/fpZkCcgAF0UzMdrEDNjq9QUawIF47fZULayov9EW8is?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2017,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1966,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -121,
    "LOC_Y": 217,
    "GAME_DATE": 20171116,
    "Season": "2017-2018",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/16/0021700215/604/3f8e62ba-50d2-29b6-59e2-f48755051c45_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390471515901515526",
    "name": "The 2974 Collection #1966",
    "imageUrl": "https://arweave.net/FwaLmGqek9kpaB8nFgNORuf5O09dlYTF3x62lV56h3s?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2017,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1967,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -140,
    "LOC_Y": 229,
    "GAME_DATE": 20171118,
    "Season": "2017-2018",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/18/0021700231/370/053df7d3-3fc9-68ec-8519-bb276eecce33_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/358286007236175427",
    "name": "The 2974 Collection #1967",
    "imageUrl": "https://arweave.net/opngAFyGwhBNmYKbN7hxbBgLJCiQaF1Xhm2NvTJWLnc?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1968,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 94,
    "LOC_Y": 232,
    "GAME_DATE": 20171118,
    "Season": "2017-2018",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/18/0021700231/440/db1f03d8-bb0b-e542-053c-2dcbaa0e2065_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381426380870803402",
    "name": "The 2974 Collection #1968",
    "imageUrl": "https://arweave.net/QpPr8PIdQRfem_jVG1BisgqdlUIMb7_eBNRbYuyOoFc?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1969,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 141,
    "LOC_Y": 241,
    "GAME_DATE": 20171118,
    "Season": "2017-2018",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/18/0021700231/472/7f27bdd0-c5ee-8b35-2340-95bd64026bda_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307645937938970239",
    "name": "The 2974 Collection #1969",
    "imageUrl": "https://arweave.net/KTROOu2ZI19xojritjpIESJfYA4YJhrpvHWag2zqAcs?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1970,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 106,
    "LOC_Y": 266,
    "GAME_DATE": 20171118,
    "Season": "2017-2018",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/18/0021700231/491/4216b290-c03c-fc9d-9c1a-eca1ddd5fb55_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/424711395288082214",
    "name": "The 2974 Collection #1970",
    "imageUrl": "https://arweave.net/oY1OE2SS-gCyKT4aqJWQJKDWPXOnYAYZrN33vbGLx4U?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2017,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1971,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 40,
    "LOC_Y": 256,
    "GAME_DATE": 20171119,
    "Season": "2017-2018",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/19/0021700236/142/708cbb8c-928b-4c8c-44f0-d3484d8cd757_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307641330644753302",
    "name": "The 2974 Collection #1971",
    "imageUrl": "https://arweave.net/1aXSBU6Qbp0h6zz65yVWwC8BDdHnLaKCOZy8ZWm8uHM?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2017,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1972,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 51,
    "LOC_Y": 240,
    "GAME_DATE": 20171119,
    "Season": "2017-2018",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/19/0021700236/153/8a4d8305-181a-2f5a-8184-c0084062c04c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/529970830845286539",
    "name": "The 2974 Collection #1972",
    "imageUrl": "https://arweave.net/nWAI_ubqk5SPp6vjtIBWEiWgwkbOMhlvQ1DpeHlFWpE?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2017,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1973,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -47,
    "LOC_Y": 242,
    "GAME_DATE": 20171119,
    "Season": "2017-2018",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/19/0021700236/347/ee3c5fb6-f0da-17ee-cbaa-07798e308582_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533918425137663855",
    "name": "The 2974 Collection #1973",
    "imageUrl": "https://arweave.net/GPe_kTS9govhupvEWygF1BBdBSJUk5PScnd2HaB0PVc?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2017,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1974,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -203,
    "LOC_Y": 149,
    "GAME_DATE": 20171119,
    "Season": "2017-2018",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/19/0021700236/504/d20138a4-ea70-3cd2-0d18-1946b5d6fae4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/294117211061853856",
    "name": "The 2974 Collection #1974",
    "imageUrl": "https://arweave.net/USU5cTwlj0FU4eEl-V51eTtFWVRb3CB9V8f7jH4Miys?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2017,
    "Month": 11,
    "Day": 19,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1975,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 166,
    "LOC_Y": 179,
    "GAME_DATE": 20171122,
    "Season": "2017-2018",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/22/0021700263/129/3ef7f8a5-85df-aa03-309b-c1fbe79daef3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/337441178435726458",
    "name": "The 2974 Collection #1975",
    "imageUrl": "https://arweave.net/0KInppi_JRzIVj1pdzI7JIsv_YZ2ubIpBi-GcNQDXtI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 11,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1976,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -225,
    "LOC_Y": 81,
    "GAME_DATE": 20171122,
    "Season": "2017-2018",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/22/0021700263/322/0311fa61-f9a3-2802-f5a1-316bed89336d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515180491923100432",
    "name": "The 2974 Collection #1976",
    "imageUrl": "https://arweave.net/EtfAFgMIGMU-4AVDQFUJFx7YafEbkdtO-OR6_smwYk4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 11,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1977,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 83,
    "LOC_Y": 250,
    "GAME_DATE": 20171122,
    "Season": "2017-2018",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/22/0021700263/521/d5b96e81-9a78-d4b2-5d66-fee02068e0a2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320939034044026245",
    "name": "The 2974 Collection #1977",
    "imageUrl": "https://arweave.net/0KOxSAjHPn8CujqfXuJeOzZLnlBUnhZYXMkhPHc485M?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2017,
    "Month": 11,
    "Day": 22,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1978,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 146,
    "LOC_Y": 201,
    "GAME_DATE": 20171124,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/24/0021700276/65/30b807a4-e173-0501-dd82-3e9bf514400c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403563868679229243",
    "name": "The 2974 Collection #1978",
    "imageUrl": "https://arweave.net/Fq-HNAiV32gUInFcSnks2nxUL8FsiOxyOWT5ai6fZH0?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2017,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1979,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -224,
    "LOC_Y": 8,
    "GAME_DATE": 20171124,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/24/0021700276/230/87977d58-910a-59c6-7f75-8a38c86310b3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/545207998850761140",
    "name": "The 2974 Collection #1979",
    "imageUrl": "https://arweave.net/4OgA17K8SqsXpSeOvIuXzX404_teuSuW8anC6RgabOE?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2017,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1980,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -29,
    "LOC_Y": 280,
    "GAME_DATE": 20171124,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/24/0021700276/234/84fbeb65-308c-361c-756e-985eb09a6293_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458929873680028774",
    "name": "The 2974 Collection #1980",
    "imageUrl": "https://arweave.net/8Y0j3-_Kn0io8hugZIs31jXDCgSJMABcAWCwaFtI6go?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2017,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1981,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 171,
    "LOC_Y": 193,
    "GAME_DATE": 20171124,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/24/0021700276/314/ca3d2d62-258f-0c98-f4f2-1abbed2cc951_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309795710430809420",
    "name": "The 2974 Collection #1981",
    "imageUrl": "https://arweave.net/ar7coHEJ7eJ7JejUji2_FoP8VxfSLs0qHyyMOp6s6gI?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2017,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1982,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 40,
    "LOC_Y": 283,
    "GAME_DATE": 20171125,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/25/0021700284/478/05c01133-93c7-5b45-1de8-a743e6c40119_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497868024190255277",
    "name": "The 2974 Collection #1982",
    "imageUrl": "https://arweave.net/UNK6dbpK4kKoZXKFlC16iwOPPrfDUuS_EnzH11yOvjE?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1983,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -226,
    "LOC_Y": 84,
    "GAME_DATE": 20171125,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/25/0021700284/516/810b1e10-3a8d-b8eb-1e56-0b26530c4bb1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382445554517225559",
    "name": "The 2974 Collection #1983",
    "imageUrl": "https://arweave.net/DlHBG9lfQ8OLz3-Z4C01-kbbKsnZtqun8v9cVeOG35c?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1984,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 99,
    "LOC_Y": 242,
    "GAME_DATE": 20171125,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/25/0021700284/701/fc2019f7-8c0c-3075-4db2-7bef3b16bc0a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/405721744078933142",
    "name": "The 2974 Collection #1984",
    "imageUrl": "https://arweave.net/OSIHMC-qqEzBmJgxme1mo92n1kqZNGqQ6PySL4JIVKs?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 11,
    "Day": 25,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1985,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -210,
    "LOC_Y": 150,
    "GAME_DATE": 20171129,
    "Season": "2017-2018",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/29/0021700312/338/1b62a021-cbae-630f-c91a-2a0ac18f2a7c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/292352129052464622",
    "name": "The 2974 Collection #1985",
    "imageUrl": "https://arweave.net/Ht30PPWdCG_eIt6d1UcmmU6XHzSWFpk3PeRaHEG4kNg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1986,
    "PERIOD": 5,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 136,
    "LOC_Y": 222,
    "GAME_DATE": 20171129,
    "Season": "2017-2018",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/29/0021700312/664/341f81b2-50f7-2d0f-2a1c-62da43fcacd7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/337215621356879156",
    "name": "The 2974 Collection #1986",
    "imageUrl": "https://arweave.net/7KK0VOSpEb9Qqe66GbN4BrSmFhlPsFz_sQvYMheRc7c?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1987,
    "PERIOD": 5,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 122,
    "LOC_Y": 236,
    "GAME_DATE": 20171129,
    "Season": "2017-2018",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/11/29/0021700312/668/0d66cc59-6e18-e302-d322-64eba6c88e99_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324235294010616760",
    "name": "The 2974 Collection #1987",
    "imageUrl": "https://arweave.net/DyGToe9T42UP37HEA_EPMEyrjRPEh-zHabnZN5H7FG4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2017,
    "Month": 11,
    "Day": 29,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1988,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 19,
    "LOC_Y": 257,
    "GAME_DATE": 20171201,
    "Season": "2017-2018",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/01/0021700318/32/1e2a3e3d-bf12-f29c-dc4a-9ea3ea5410a8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/427878040504433090",
    "name": "The 2974 Collection #1988",
    "imageUrl": "https://arweave.net/fGkw9enb8jLUafDI4svTWEtFiRGLJbWAkhRspSbwt8U?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1989,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 116,
    "LOC_Y": 221,
    "GAME_DATE": 20171201,
    "Season": "2017-2018",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/01/0021700318/89/bd038f7e-a210-aded-300e-32bdf9746cf0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344029122463335494",
    "name": "The 2974 Collection #1989",
    "imageUrl": "https://arweave.net/T3L2YarWfhBgv7qQ-1IV0fzC0L_cEZBsS0YLgZpcg8c?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1990,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -81,
    "LOC_Y": 279,
    "GAME_DATE": 20171201,
    "Season": "2017-2018",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/01/0021700318/153/6df9a2fc-409d-671b-e5d7-b35a425bc071_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434559514098718467",
    "name": "The 2974 Collection #1990",
    "imageUrl": "https://arweave.net/G9v-LHo2fhHStpWDfhAI2Y47PsvsaCg51gAoGMqkUMY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2017,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1991,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -174,
    "LOC_Y": 197,
    "GAME_DATE": 20171203,
    "Season": "2017-2018",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/03/0021700335/60/45c7e0d1-c70c-c1fe-d3ea-249db583cf78_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478703595466122913",
    "name": "The 2974 Collection #1991",
    "imageUrl": "https://arweave.net/unXBk8J8pABjaM1U0xx0w5QEDA_j9SqJkba21JP-93w?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1992,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 8,
    "GAME_DATE": 20171203,
    "Season": "2017-2018",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/03/0021700335/137/78652a39-82e7-60b5-0fe0-15c1a197f679_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/549769537322483447",
    "name": "The 2974 Collection #1992",
    "imageUrl": "https://arweave.net/3z9jdFt-1paj3mAvspihgUHGqfhoDjY3QYL2Epm4A0Q?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1993,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -127,
    "LOC_Y": 252,
    "GAME_DATE": 20171203,
    "Season": "2017-2018",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/03/0021700335/146/010bc8f0-8775-262a-9f45-b41d4b1c0dd2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561382863744477008",
    "name": "The 2974 Collection #1993",
    "imageUrl": "https://arweave.net/3ylbEV5CEojdevKkF5zsIqCUs4uJfIOaruwc0s2_qic?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1994,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -203,
    "LOC_Y": 148,
    "GAME_DATE": 20171203,
    "Season": "2017-2018",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/03/0021700335/322/45557f42-b938-b3d6-42f1-dffb0925e0e8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381931278975165754",
    "name": "The 2974 Collection #1994",
    "imageUrl": "https://arweave.net/y_8dwWoAya0UtiSU_O8qxQo8zFF8fDzvd87v2KdCxE4?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1995,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -201,
    "LOC_Y": 153,
    "GAME_DATE": 20171203,
    "Season": "2017-2018",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/03/0021700335/334/3d619c8a-5401-96ca-e33a-016b5f4168c3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478953528619337795",
    "name": "The 2974 Collection #1995",
    "imageUrl": "https://arweave.net/t7rVwp0KQ3vMn74mO2dYTAIHD2yMNtv68vEHzNo3HA8?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2017,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 1996,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 221,
    "LOC_Y": 136,
    "GAME_DATE": 20171204,
    "Season": "2017-2018",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/04/0021700346/23/701a585a-4e88-59cd-2e4f-1e8474623858_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/574238052579223200",
    "name": "The 2974 Collection #1996",
    "imageUrl": "https://arweave.net/BkvfOFk_dciLUHWUQwiznYrTFO6FeSUbkpofgXCsVFk?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 1997,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -94,
    "LOC_Y": 256,
    "GAME_DATE": 20171204,
    "Season": "2017-2018",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/04/0021700346/431/507f489c-53d8-8f28-d288-8e0b84458add_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309353810542797574",
    "name": "The 2974 Collection #1997",
    "imageUrl": "https://arweave.net/5yh38Pqnzc8exadRQUd3iL8Yx23zOtRYsDwhJCbFg7A?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 1998,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -137,
    "LOC_Y": 225,
    "GAME_DATE": 20171204,
    "Season": "2017-2018",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/04/0021700346/445/0bbba94e-13a3-e43e-9734-1a3b7c4acd75_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533041034833931724",
    "name": "The 2974 Collection #1998",
    "imageUrl": "https://arweave.net/bY97pfWJ4Gx84oxr3c07TVzUFdyeKpVK2W8BtNaobAE?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 1999,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -236,
    "LOC_Y": -22,
    "GAME_DATE": 20171204,
    "Season": "2017-2018",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/04/0021700346/506/5cdcbaee-6484-0f2b-674e-4e35a444217a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551747655715055948",
    "name": "The 2974 Collection #1999",
    "imageUrl": "https://arweave.net/g-DrNZSsw5l4IikxVeiENQmUQTH027L48V6d58Sh7_I?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2000,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -182,
    "LOC_Y": 197,
    "GAME_DATE": 20171204,
    "Season": "2017-2018",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/04/0021700346/526/34cb3d87-f521-bd84-3b1c-54c63c4c5725_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443215096597454943",
    "name": "The 2974 Collection #2000",
    "imageUrl": "https://arweave.net/wfaCeu-t0s7rvrFUDfLb2yFIGKYvShDvVYlTQ_2JQ7M?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2017,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2001,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 18,
    "LOC_Y": 263,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/26/f864cde3-bacb-3984-709f-d3b1e4a885c5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357024226606052982",
    "name": "The 2974 Collection #2001",
    "imageUrl": "https://arweave.net/akOJ55yp6w5hrptFWJ61GvGjhPkJBUUsbpfxnnEpc84?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2002,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 128,
    "LOC_Y": 241,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/229/f9c3126d-d357-6e2f-f094-ef906afdf50f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481760991656685548",
    "name": "The 2974 Collection #2002",
    "imageUrl": "https://arweave.net/tEDNUBIl2GXAUhIJKS2fDidPvtNi5CW-yyzlkUEpCok?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2003,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 76,
    "LOC_Y": 258,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/255/e9462b00-49ff-5e2b-a3fa-1a4a4f781d38_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301772478150593784",
    "name": "The 2974 Collection #2003",
    "imageUrl": "https://arweave.net/pNWay-oFjB7kKkJTOT3KX4EIF0gnEHObTVrdoicrQFk?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2004,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 46,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/283/3e56ae5f-8eb0-46b3-d4ba-46edbf61ce5d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302559561002564926",
    "name": "The 2974 Collection #2004",
    "imageUrl": "https://arweave.net/Z5E6UJptEhAVOngF3geq6TtGzaT_FwENgUEN1hSM1sg?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2005,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -185,
    "LOC_Y": 188,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/286/d8c80a16-2fcc-a2a4-fb2d-602596589b6f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/517417922976124024",
    "name": "The 2974 Collection #2005",
    "imageUrl": "https://arweave.net/OxufQxdvw2aBNNgZyfNS-sYI-L3k4gacDCy5G9jDND4?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2006,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 84,
    "LOC_Y": 255,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/330/2912a68b-44e3-6393-986c-61fbed6e099b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/432442154027906365",
    "name": "The 2974 Collection #2006",
    "imageUrl": "https://arweave.net/2DroBrSTdIgq7gIjSIUS7FpQW1f6-eBn-Ei4m6ww-KE?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2007,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 191,
    "LOC_Y": 189,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/346/66b25c74-b720-cfb4-81ef-d248d88a72a4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352327336484786434",
    "name": "The 2974 Collection #2007",
    "imageUrl": "https://arweave.net/FdYyJJlJfMTmu1rYqHIXpyZM81rV2JUJF10oMlY4-do?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2008,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 62,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/387/3de8d83d-afe7-45a9-f506-41195adb06d7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468916286703007844",
    "name": "The 2974 Collection #2008",
    "imageUrl": "https://arweave.net/w1ctCKk41bcbE9WwBZ6I7ykxvDWrorF4h7sn9Sk-2uM?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2009,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -13,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/408/9611620b-8fa3-af4f-3e75-6a79cd3e7f47_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550439079467688010",
    "name": "The 2974 Collection #2009",
    "imageUrl": "https://arweave.net/hfyCW6DnpSyjd4i_NgIM4o8COeM4Ppgg6PAtT5SFgM0?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2010,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 78,
    "LOC_Y": 243,
    "GAME_DATE": 20171230,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2017/12/30/0021700535/603/3bd758d6-a156-34e5-c814-b92d294cd1e3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/471782825467976561",
    "name": "The 2974 Collection #2010",
    "imageUrl": "https://arweave.net/j_YugSAYRtZd23CCpaTT_4j-Bp5gafuyHeTKz7ZPMkM?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2017,
    "Month": 12,
    "Day": 30,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2011,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 90,
    "LOC_Y": 285,
    "GAME_DATE": 20180103,
    "Season": "2017-2018",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/03/0021700562/44/3670c4f9-7d57-520b-2caf-230868d01e4b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/345537536823762839",
    "name": "The 2974 Collection #2011",
    "imageUrl": "https://arweave.net/S2Pwb7cTyTQsx8NemgGYXXyCzaBeKivDJXomtWLiB-Q?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2012,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -6,
    "LOC_Y": 257,
    "GAME_DATE": 20180103,
    "Season": "2017-2018",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/03/0021700562/133/f075d01b-ee5f-7ca8-d933-0dd263ba951b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322264831135114303",
    "name": "The 2974 Collection #2012",
    "imageUrl": "https://arweave.net/jHt7uQyttdP940WOCXUwqxcWUmStEAiPDhlKdwveXr4?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2013,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -185,
    "LOC_Y": 155,
    "GAME_DATE": 20180103,
    "Season": "2017-2018",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/03/0021700562/166/0ba87f78-1ec8-400a-c09b-90f0df06ae2d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357423686052771596",
    "name": "The 2974 Collection #2013",
    "imageUrl": "https://arweave.net/z_FkZP8LEMBlkfRJ3_GvqJdPnVmqN93sWG0tDYjfqzE?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2014,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -79,
    "LOC_Y": 229,
    "GAME_DATE": 20180103,
    "Season": "2017-2018",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/03/0021700562/334/cd745c9c-9c25-8b27-76d1-7f50d29832b0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/492952858400208976",
    "name": "The 2974 Collection #2014",
    "imageUrl": "https://arweave.net/cq6gF0uzFpFjnCPqIyUmplAye9hi9JR3NWzJw2Ide5k?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2015,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -96,
    "LOC_Y": 256,
    "GAME_DATE": 20180103,
    "Season": "2017-2018",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/03/0021700562/436/ddb12845-560a-a718-f4b1-b28892251b8f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/457703119457061742",
    "name": "The 2974 Collection #2015",
    "imageUrl": "https://arweave.net/C0CCOcR9bpEvQD3IaZD3qxKF9f-5WsHT8krQhmcpTwg?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2016,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 3,
    "LOC_Y": 274,
    "GAME_DATE": 20180103,
    "Season": "2017-2018",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/03/0021700562/672/59b2cc81-1e05-077c-4bc5-5474e3932f4c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456383305640555311",
    "name": "The 2974 Collection #2016",
    "imageUrl": "https://arweave.net/IDp0BFl_im6t63vFc-yGBJ7ifMDKS8oX2Ayk8zYzHFg?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2017,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -205,
    "LOC_Y": 134,
    "GAME_DATE": 20180104,
    "Season": "2017-2018",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/04/0021700566/39/297e8386-2514-ea09-5943-b74a26b8b749_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/399353367449807295",
    "name": "The 2974 Collection #2017",
    "imageUrl": "https://arweave.net/iKPsoCyMs-t3pfAKNV98YpDxIR2vOQEq0-URFdo3yzw?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2018,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2018,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -41,
    "LOC_Y": 243,
    "GAME_DATE": 20180104,
    "Season": "2017-2018",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/04/0021700566/266/92903779-3b09-d9a5-a82b-4cd2e3232a22_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412004422594060034",
    "name": "The 2974 Collection #2018",
    "imageUrl": "https://arweave.net/RiBEDMzS33BJy-H2t6Zw8-R3somgQ38Q-6ll1l9-RFU?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2018,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2019,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 157,
    "LOC_Y": 197,
    "GAME_DATE": 20180104,
    "Season": "2017-2018",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/04/0021700566/472/04867b25-c72d-ed58-1825-68480e1e0e77_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326129800504823766",
    "name": "The 2974 Collection #2019",
    "imageUrl": "https://arweave.net/xDq8u776ex4ViHtlHGzsZLLd3sVlbdEvEY3h7GZ_wV4?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2018,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2020,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 124,
    "LOC_Y": 236,
    "GAME_DATE": 20180104,
    "Season": "2017-2018",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/04/0021700566/608/7ed1ab18-689a-4be1-26fa-5346eab2fdc2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299232823778307862",
    "name": "The 2974 Collection #2020",
    "imageUrl": "https://arweave.net/xbd-RgoiOlbf5mNLcy3erv-wJ4IQK2g-bP3QAgrlExk?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2018,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2021,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -149,
    "LOC_Y": 228,
    "GAME_DATE": 20180106,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/06/0021700578/60/31ce7cca-bb24-8fc4-e100-35ca0cbe629f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/538195572644040805",
    "name": "The 2974 Collection #2021",
    "imageUrl": "https://arweave.net/paNTzGagdRQBB11edY41OSyaiRRE-fbqXE1aJppnUco?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2022,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 53,
    "LOC_Y": 248,
    "GAME_DATE": 20180106,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/06/0021700578/78/f529c9f1-493a-c3e1-f186-b92acebbef26_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491238708546720220",
    "name": "The 2974 Collection #2022",
    "imageUrl": "https://arweave.net/wS1GehlSQA3-bKgZpKXMguTNFXxR9-xORD2Hk4CFfz0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2023,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 8,
    "LOC_Y": 269,
    "GAME_DATE": 20180106,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/06/0021700578/96/547016ec-eda7-fb8f-ffcd-194794c6c1d5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480125541921229106",
    "name": "The 2974 Collection #2023",
    "imageUrl": "https://arweave.net/dH1Lful0tmlnceej4klTSlaEm9K6wh9_DgIplfb9Igc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2024,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -235,
    "LOC_Y": 56,
    "GAME_DATE": 20180106,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/06/0021700578/106/bfecf493-9951-fb0c-97d4-12913cc5a0ba_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371425422025441929",
    "name": "The 2974 Collection #2024",
    "imageUrl": "https://arweave.net/1WSdpECfvwTW-2D1fHTFBU50NheRSGhOsy8-tB4m7DE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2025,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -57,
    "LOC_Y": 254,
    "GAME_DATE": 20180106,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/06/0021700578/351/a955be63-5312-4eab-49bf-93538eb1d900_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490159141408787134",
    "name": "The 2974 Collection #2025",
    "imageUrl": "https://arweave.net/OPGgdaQHF8OdikKaoIDDK08VFFtL3wBWJE8VFt4iDIs?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2026,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -146,
    "LOC_Y": 216,
    "GAME_DATE": 20180106,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/06/0021700578/432/7c20eceb-ed9e-ec90-bce3-82b3acb0a9a3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/569591862800810320",
    "name": "The 2974 Collection #2026",
    "imageUrl": "https://arweave.net/9jZwMpbKSVVpSkZ5wx12y_5b_v0I9Z9T6uxNAyzJ5ZQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2027,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 22,
    "LOC_Y": 272,
    "GAME_DATE": 20180106,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/06/0021700578/493/fef04920-eabd-08b1-d2e1-a23a12dc508b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374347016680543799",
    "name": "The 2974 Collection #2027",
    "imageUrl": "https://arweave.net/lW26KrJFxyYYbYwLapVS6y4ON50K3iNbpYYT8nRGz-g?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2028,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -147,
    "LOC_Y": 226,
    "GAME_DATE": 20180106,
    "Season": "2017-2018",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/06/0021700578/512/69b67334-78fc-d391-06bd-9be08f1f94cb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295585916900918464",
    "name": "The 2974 Collection #2028",
    "imageUrl": "https://arweave.net/06_5uDl--XzmjjdxnHUFIGB6otV18Cedsd3XFRhETYg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2029,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 154,
    "LOC_Y": 212,
    "GAME_DATE": 20180108,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/08/0021700597/52/8d0f35b1-3e2d-7bed-4203-517f2b9dc972_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417404281598780679",
    "name": "The 2974 Collection #2029",
    "imageUrl": "https://arweave.net/wsqlWWSISmGEoFTyZg-aCjRgeGyflug2qaJ2Nz-rz4U?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2030,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 226,
    "LOC_Y": 97,
    "GAME_DATE": 20180108,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/08/0021700597/283/81d6c6f0-76df-c2a3-7806-7f39878abea0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360739063556702493",
    "name": "The 2974 Collection #2030",
    "imageUrl": "https://arweave.net/UvK7BOWtBtYLNTHYlCyO-RJ6wkFVZlr73oHILyhrY38?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2031,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 117,
    "LOC_Y": 222,
    "GAME_DATE": 20180108,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/08/0021700597/342/f74271aa-c4e0-4b1a-b560-7008a532419c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290620040616020557",
    "name": "The 2974 Collection #2031",
    "imageUrl": "https://arweave.net/4ANkKRTZdTpnPKzx-6QRjE_FOVC4X6tCrUhZKb6XMcA?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2032,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 128,
    "LOC_Y": 239,
    "GAME_DATE": 20180108,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/08/0021700597/434/a7c89a51-e22a-d82b-c06b-d5f7546ffafc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301800463957257524",
    "name": "The 2974 Collection #2032",
    "imageUrl": "https://arweave.net/3hmlzs-aDfejkf_6sy_EkFPdBxKkEi7Ut2GtOnSVzpc?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2033,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -144,
    "LOC_Y": 221,
    "GAME_DATE": 20180108,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/08/0021700597/445/8985a71f-7840-5d6b-61fe-c8195750902b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465244015849310668",
    "name": "The 2974 Collection #2033",
    "imageUrl": "https://arweave.net/81s1dnBSIU-Oa-fMdbTTsAwP1TuMuI7PRXtZP71XTlM?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2034,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -164,
    "LOC_Y": 189,
    "GAME_DATE": 20180113,
    "Season": "2017-2018",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/13/0021700631/370/3689f7e9-961d-b7f1-6b76-f917e77ba264_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575611820644962955",
    "name": "The 2974 Collection #2034",
    "imageUrl": "https://arweave.net/UuIr2pY_fWjSvzyzSkQpHa8xff2_ZDoC_PayhhYyht4?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2018,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2035,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 6,
    "LOC_Y": 248,
    "GAME_DATE": 20180113,
    "Season": "2017-2018",
    "HTM": "TOR",
    "VTM": "GSW",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/13/0021700631/579/806bad40-5566-dac4-7d81-d6947949f508_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359049047738465663",
    "name": "The 2974 Collection #2035",
    "imageUrl": "https://arweave.net/9N9u9ZDsISv5g_VoN_ClO4nwjPTPKyrij5WZBQXk7YQ?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2018,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2036,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 23,
    "LOC_Y": 258,
    "GAME_DATE": 20180115,
    "Season": "2017-2018",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/15/0021700646/248/743f801f-87ae-6e0b-c631-2632b4c0c2ef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/318827783740091084",
    "name": "The 2974 Collection #2036",
    "imageUrl": "https://arweave.net/dtIkANixBAaPp6YLtH9l_hbYgbQ6EJMynTcTWVtIzlo?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2037,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -130,
    "LOC_Y": 236,
    "GAME_DATE": 20180115,
    "Season": "2017-2018",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498621345782487033",
    "name": "The 2974 Collection #2037",
    "imageUrl": "https://arweave.net/kysOW1DG3yTTpFnuHybpqhoivDtMx3Y1PhLjeiJCtFE?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2038,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -224,
    "LOC_Y": 138,
    "GAME_DATE": 20180115,
    "Season": "2017-2018",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/15/0021700646/400/fc04cdb9-92f7-daee-f319-710c31884165_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531904337526711220",
    "name": "The 2974 Collection #2038",
    "imageUrl": "https://arweave.net/Xabh_dMfAaqA6FbDnW8Hrq6UGHksmZ0uY-xWmWPHcsk?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2039,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": 75,
    "LOC_Y": 325,
    "GAME_DATE": 20180115,
    "Season": "2017-2018",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/15/0021700646/438/a7231c87-0f0c-1d69-ece6-76ab2dd55007_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/431501156184792187",
    "name": "The 2974 Collection #2039",
    "imageUrl": "https://arweave.net/IAAvLL-Ypwph7Z-Jfoi9-oBto67KwLgP04GEZukg6SU?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2040,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 140,
    "LOC_Y": 210,
    "GAME_DATE": 20180117,
    "Season": "2017-2018",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/17/0021700657/18/77f1b45f-b10c-54b8-63e7-9ebe6c8be5de_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565222867840555879",
    "name": "The 2974 Collection #2040",
    "imageUrl": "https://arweave.net/zQTDly0PJusJlSrtReuwhn38u5Qp_UD_ZAMvfUUDfJQ?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2018,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2041,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 87,
    "LOC_Y": 244,
    "GAME_DATE": 20180117,
    "Season": "2017-2018",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/17/0021700657/106/84d8bda6-f496-b4f2-6c80-c99a35862a90_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489375440398444513",
    "name": "The 2974 Collection #2041",
    "imageUrl": "https://arweave.net/SmNOWDACmairycvqPDIaF-mRQG93aCOSYJsrXjWFO0U?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2018,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2042,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 47,
    "LOC_Y": 252,
    "GAME_DATE": 20180117,
    "Season": "2017-2018",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/17/0021700657/289/6de8274b-0842-f95f-3a52-5aeed9e45bbd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480250334649611065",
    "name": "The 2974 Collection #2042",
    "imageUrl": "https://arweave.net/KhKxXhdcATm6pmJnyZjm5J8lPM6WxOgImUBHdP1OtQ8?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2018,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2043,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 18,
    "LOC_Y": 261,
    "GAME_DATE": 20180117,
    "Season": "2017-2018",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/17/0021700657/367/508d4358-fae9-cce3-bb90-9d3f7a020751_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289438969379105134",
    "name": "The 2974 Collection #2043",
    "imageUrl": "https://arweave.net/pkxdLeDOecCEPNU56Amo5-SDQxBwealgi7vuRy5jPL0?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2018,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2044,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -75,
    "LOC_Y": 232,
    "GAME_DATE": 20180117,
    "Season": "2017-2018",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/17/0021700657/397/4c69d473-3eb3-80eb-6db5-c09401465a80_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378825594511204772",
    "name": "The 2974 Collection #2044",
    "imageUrl": "https://arweave.net/5fuZj1z3sxrSZM5uJ2ZXKP-hLELQpwo9jWnVvEi4aTk?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2018,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2045,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 185,
    "LOC_Y": 168,
    "GAME_DATE": 20180117,
    "Season": "2017-2018",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/17/0021700657/409/f1f1695f-eb0e-93c9-21f6-ce1a007530f9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417686989574739612",
    "name": "The 2974 Collection #2045",
    "imageUrl": "https://arweave.net/tlBtFsizMnu0f0guvehbcrToH3q30rC2hPQIETTMXd4?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2018,
    "Month": 1,
    "Day": 17,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2046,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 65,
    "LOC_Y": 253,
    "GAME_DATE": 20180120,
    "Season": "2017-2018",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/20/0021700679/63/5d51177e-698f-1756-3cb1-859c09dbcd4e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/423027752934937233",
    "name": "The 2974 Collection #2046",
    "imageUrl": "https://arweave.net/SSTiBZX1sEBo9qrMtcR7aplXriarXj4zcyCM3R3YyBw?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2018,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2047,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -79,
    "LOC_Y": 237,
    "GAME_DATE": 20180120,
    "Season": "2017-2018",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/20/0021700679/328/e9f37b6c-ed54-c7e6-7cf5-a00fdf6ced3c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568859435311604242",
    "name": "The 2974 Collection #2047",
    "imageUrl": "https://arweave.net/0forWvtWW7dGbfFT-8fzPcpUjuNB1Y3Yn79j7kYWbIw?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2018,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2048,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 214,
    "LOC_Y": 137,
    "GAME_DATE": 20180120,
    "Season": "2017-2018",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/20/0021700679/403/09b32f25-e383-8982-8ea0-ca251ebd6321_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/377874529833217804",
    "name": "The 2974 Collection #2048",
    "imageUrl": "https://arweave.net/hTxvtI_1uNkCMUKDPP-M6eLr30RiHjkM1YQwQeoGtug?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2018,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2049,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 105,
    "LOC_Y": 241,
    "GAME_DATE": 20180120,
    "Season": "2017-2018",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/20/0021700679/449/990f9701-80b3-db33-ba50-4f2b382c4ddf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/306189039887615478",
    "name": "The 2974 Collection #2049",
    "imageUrl": "https://arweave.net/Y8wNEITgZ4McPt0k6AfjiAPKjdo4VYwJLmxd_WDHW2Q?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2018,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2050,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -179,
    "LOC_Y": 185,
    "GAME_DATE": 20180120,
    "Season": "2017-2018",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/20/0021700679/502/739988e3-c260-9635-02d7-7345e5902c0a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361938646920476475",
    "name": "The 2974 Collection #2050",
    "imageUrl": "https://arweave.net/cwkO9GzSJYL7kGN3ZaFsKCCgZGZ-zBgMjMPJ5HxTwWg?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2018,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2051,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -19,
    "LOC_Y": 263,
    "GAME_DATE": 20180123,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/23/0021700699/26/5f4079c8-75c5-50a8-f2e2-0bcf1d91280e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/537713779598606269",
    "name": "The 2974 Collection #2051",
    "imageUrl": "https://arweave.net/ma9AQQu584RWnesOy9X0k_0M5eAruB0L9TG0izLcnCw?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 8,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2052,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -170,
    "LOC_Y": 188,
    "GAME_DATE": 20180123,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/23/0021700699/285/dc9f8765-d2a4-cb1b-4f54-2832b151365d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407409922081009014",
    "name": "The 2974 Collection #2052",
    "imageUrl": "https://arweave.net/Pt1Arnoz5PpIoFc2CeI9NcO3n_YU0VzmPkz8p7lwHxg?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 8,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2053,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 152,
    "LOC_Y": 215,
    "GAME_DATE": 20180123,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/23/0021700699/349/96f2f38c-d9cf-e338-57db-2df94b28f4eb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465774547719377407",
    "name": "The 2974 Collection #2053",
    "imageUrl": "https://arweave.net/6z0u0QTcCS-pDSg5gBlKCyqK-WAC4hREmwtvMQ9slvk?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 8,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2054,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -136,
    "LOC_Y": 216,
    "GAME_DATE": 20180123,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/23/0021700699/378/099ce275-d75a-77df-ab09-7082bbc34fd3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/571344648061145303",
    "name": "The 2974 Collection #2054",
    "imageUrl": "https://arweave.net/c7sojg3aiIvo3AIasmimjyBSXdqBvqG_tgKhddofGMU?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 8,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2055,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -211,
    "LOC_Y": 122,
    "GAME_DATE": 20180123,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/23/0021700699/395/053ce1da-5f3f-7c04-56e8-87d446e9a05d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/569883996764508954",
    "name": "The 2974 Collection #2055",
    "imageUrl": "https://arweave.net/_agcHKnhCRf5XnVjwo0Kyr79oabWqRgE-ABGYae_c6g?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 8,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2056,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 175,
    "LOC_Y": 188,
    "GAME_DATE": 20180123,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/23/0021700699/418/23e74ca8-d86a-01b3-d45e-b88b6754619d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297481219388686735",
    "name": "The 2974 Collection #2056",
    "imageUrl": "https://arweave.net/3hnWdNhHbVGzycHqLTlzwjMT6Pwb37JoHSpKxirlMvA?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 8,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2057,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 2,
    "LOC_Y": 264,
    "GAME_DATE": 20180123,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/23/0021700699/561/40859a90-e726-cdcb-84e6-794185dba206_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324236766774273983",
    "name": "The 2974 Collection #2057",
    "imageUrl": "https://arweave.net/HJrmSa7PKWgUFzUJDJkycM8TeRgYeJw3v6F-TKWs8Jo?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 8,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2058,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 61,
    "LOC_Y": 256,
    "GAME_DATE": 20180123,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/23/0021700699/583/f9e113d5-6b72-8a1b-36b0-cddd0044e498_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/571679342220810970",
    "name": "The 2974 Collection #2058",
    "imageUrl": "https://arweave.net/izS-cnvjAtIbH3MkqYdnldDd0dgNBxz3sUazobcX4N8?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 8,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2059,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 131,
    "LOC_Y": 238,
    "GAME_DATE": 20180125,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/25/0021700713/145/152388c8-a300-8131-b526-1b624fa785c7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/542439393670618136",
    "name": "The 2974 Collection #2059",
    "imageUrl": "https://arweave.net/Q1v1B1tIAnC7sz3YYymOWYOrX_p2Z-C47cjwdbxy3lk?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2060,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -169,
    "LOC_Y": 216,
    "GAME_DATE": 20180125,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/25/0021700713/262/3c568229-789c-91cc-4a28-4bcbea223541_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361662775871407321",
    "name": "The 2974 Collection #2060",
    "imageUrl": "https://arweave.net/L2a5XczvEV6Qn5p_4FyNsHI2LcvqFFmLgObe1-LEHI0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2061,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -226,
    "LOC_Y": 71,
    "GAME_DATE": 20180125,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/25/0021700713/275/1cde769a-8cf4-4f24-af0c-9c4e4ff57c66_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540422530425694372",
    "name": "The 2974 Collection #2061",
    "imageUrl": "https://arweave.net/QMltd_NdH8-cpdXKENoszketMS4mGG-KKtD2CUI5V6c?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2062,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -6,
    "LOC_Y": 278,
    "GAME_DATE": 20180125,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/25/0021700713/441/ca7d8d01-db80-6270-bce7-bc0e53bfd0d4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/401188772307240509",
    "name": "The 2974 Collection #2062",
    "imageUrl": "https://arweave.net/dDvkp9Anu8HF8zv9xXqlEgcfYJe3ENKu7J-1fRCgwl0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2063,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 165,
    "LOC_Y": 218,
    "GAME_DATE": 20180125,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/25/0021700713/631/ccdfd4e7-7143-da0a-4c11-d48ecef9c899_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519071285384336522",
    "name": "The 2974 Collection #2063",
    "imageUrl": "https://arweave.net/YmU0ANQOIfpsvgSpHzsMx-a28Ug-FARhtbqHCJGS-a0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2064,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 235,
    "LOC_Y": 27,
    "GAME_DATE": 20180127,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/27/0021700728/21/188b9300-5022-8276-fd02-3f544c6542fd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520838054721322930",
    "name": "The 2974 Collection #2064",
    "imageUrl": "https://arweave.net/CuNsLXplT6zyPPHlIS5uiYWLAm62WmkC2-T-efoZm44?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2018,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2065,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 190,
    "LOC_Y": 169,
    "GAME_DATE": 20180127,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/27/0021700728/91/682b021e-e9f8-53cf-b323-4065736971bf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/430779587639787889",
    "name": "The 2974 Collection #2065",
    "imageUrl": "https://arweave.net/iNfLXExuSdpi7LSZB-R43W5i2MGOaAKeEXa9JlHJ9Is?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2018,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2066,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -196,
    "LOC_Y": 164,
    "GAME_DATE": 20180127,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/27/0021700728/273/e23e2d04-835d-b54d-d7a4-b2fa46123f1f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/375309287008465139",
    "name": "The 2974 Collection #2066",
    "imageUrl": "https://arweave.net/YFYxETo_eN_orzz2fjBVpATOQQqV98_c1NjRt8Fwyvc?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2018,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2067,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 145,
    "LOC_Y": 218,
    "GAME_DATE": 20180127,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/27/0021700728/312/2324237c-68a9-912a-c863-c1decd871dd9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464364368081976347",
    "name": "The 2974 Collection #2067",
    "imageUrl": "https://arweave.net/l6UJTFFx_BLeIKE5HNm5cHzavG-ZRwlH4W53vcpEBII?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2018,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2068,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -45,
    "LOC_Y": 253,
    "GAME_DATE": 20180127,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/27/0021700728/403/912a479e-1a9b-c551-070e-c5769ff7ed91_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485902768581546346",
    "name": "The 2974 Collection #2068",
    "imageUrl": "https://arweave.net/VfTTbGgwH6jAtbrHjoZyOQ2ggH8FE9yzv4K7taigiA0?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2018,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2069,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 131,
    "LOC_Y": 227,
    "GAME_DATE": 20180127,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/27/0021700728/421/ddfde243-64bf-b218-ddd6-1901d49f1400_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/342242922133434211",
    "name": "The 2974 Collection #2069",
    "imageUrl": "https://arweave.net/eGyiDNudS8OeuwwUKeSmhpSZWkLx5e-S1V1eGnBzuA0?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2018,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2070,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -50,
    "LOC_Y": 263,
    "GAME_DATE": 20180127,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/27/0021700728/435/20ad7c1c-d89a-f411-e42e-8633f4c579ef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479183678706605662",
    "name": "The 2974 Collection #2070",
    "imageUrl": "https://arweave.net/afIP3lYDURrqlThZtzypsSRlJEA_9Dd5BpMQOofdEl8?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2018,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2071,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -38,
    "LOC_Y": 273,
    "GAME_DATE": 20180127,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/27/0021700728/608/64625275-9f74-e228-1813-dd65c29eb9a9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519337817261180436",
    "name": "The 2974 Collection #2071",
    "imageUrl": "https://arweave.net/pFWDMciWE5pksQeC6yokrQugLWrOWrb6QQwLKiJNR4M?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2018,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2072,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -70,
    "LOC_Y": 248,
    "GAME_DATE": 20180130,
    "Season": "2017-2018",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/01/30/0021700751/268/6ddc9bc3-a8e3-36b2-655f-afa6d33d14b9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322813722089906303",
    "name": "The 2974 Collection #2072",
    "imageUrl": "https://arweave.net/F3bkTMR_p0Z6Hi2XlOe9hgUK-2xETSs6NaKexwsCgP0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2073,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -55,
    "LOC_Y": 270,
    "GAME_DATE": 20180202,
    "Season": "2017-2018",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/02/0021700774/86/8fa8ba53-ec13-c3d2-9075-b3d592e9e789_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441588464825609597",
    "name": "The 2974 Collection #2073",
    "imageUrl": "https://arweave.net/WVy5thuUaddTDvDquvBEOOSLGmw2656J6Y2RPHohICI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2018,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2074,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 231,
    "LOC_Y": 50,
    "GAME_DATE": 20180202,
    "Season": "2017-2018",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/02/0021700774/350/2bb49b27-4f4c-7cd9-fb7a-421ea02d2941_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422220871509438298",
    "name": "The 2974 Collection #2074",
    "imageUrl": "https://arweave.net/5ptSWl_1Tlw1DWxdAb2hiNkUI1-MMNbcd9cf5oPx9AU?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2018,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2075,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -195,
    "LOC_Y": 174,
    "GAME_DATE": 20180202,
    "Season": "2017-2018",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/02/0021700774/393/e2742c0a-a74c-784e-a2d4-7801c67c03d8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384588795484755194",
    "name": "The 2974 Collection #2075",
    "imageUrl": "https://arweave.net/PzIZe08c-TQ8Jg8TXkjdhOQSIC7XChS-gt1IBTjK_Oc?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2018,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2076,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 177,
    "LOC_Y": 188,
    "GAME_DATE": 20180203,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/03/0021700782/34/33029e48-aa29-7b8f-734b-d140a5392be3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522361052844439109",
    "name": "The 2974 Collection #2076",
    "imageUrl": "https://arweave.net/rg0-eAFdyxhcPANqsLWVKdp79APqT_GoUj1N2yEhWMs?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2077,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 214,
    "LOC_Y": 120,
    "GAME_DATE": 20180203,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/03/0021700782/52/8d1b6dde-5931-b564-9dd9-5d0e8b41bb64_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543881532569495530",
    "name": "The 2974 Collection #2077",
    "imageUrl": "https://arweave.net/m9dFxlvLmT6mUjhMt8UBf8rBUsTmSMBvZUf8_tIiw4s?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2078,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -95,
    "LOC_Y": 232,
    "GAME_DATE": 20180203,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/03/0021700782/390/01388484-e1f1-e0aa-41f7-cef7c3ca3357_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322307148913401685",
    "name": "The 2974 Collection #2078",
    "imageUrl": "https://arweave.net/WhrlNYkXMuqPRne1Ztrvquhhyo6aaZ4aLcdf6a-a1uo?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2079,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -186,
    "LOC_Y": 174,
    "GAME_DATE": 20180203,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/03/0021700782/435/8250d40f-4045-2fb1-15b6-07917ca2ec80_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290413089662075736",
    "name": "The 2974 Collection #2079",
    "imageUrl": "https://arweave.net/rD4NKw7MkDW1tIMwYoOcD2UE_8OGEkh-RCqGdKteq84?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2080,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -134,
    "LOC_Y": 281,
    "GAME_DATE": 20180203,
    "Season": "2017-2018",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/03/0021700782/688/ff55260c-44c0-52b5-8b36-f22238c8a5c2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433279334318272946",
    "name": "The 2974 Collection #2080",
    "imageUrl": "https://arweave.net/BXbseKO03toV9WBSJpiWYokvvs7rGWDzeSAJxNG5-EY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 2,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2081,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 105,
    "LOC_Y": 253,
    "GAME_DATE": 20180206,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/06/0021700803/146/18ec827a-94fa-c1df-7c61-02e6095fdc36_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521201043190069845",
    "name": "The 2974 Collection #2081",
    "imageUrl": "https://arweave.net/NDOYGFfBMy0YD8sKZN7UpLsu1BvsbmFCk7_b1FI4wK0?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2082,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 145,
    "LOC_Y": 214,
    "GAME_DATE": 20180206,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/06/0021700803/438/53dbf405-15dc-4369-d0d5-8e27ccff31bf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/427432113659342105",
    "name": "The 2974 Collection #2082",
    "imageUrl": "https://arweave.net/oynF-_ZagjqhftHUZmr5eOhq7mGpcXGIt9UlMWrA5WU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2083,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 130,
    "LOC_Y": 227,
    "GAME_DATE": 20180208,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/08/0021700815/122/83438ac8-0f34-ea5e-59d0-ed592c58aa01_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518155096145471371",
    "name": "The 2974 Collection #2083",
    "imageUrl": "https://arweave.net/-NIjU5G-SjlSr9qig074-XNISStAry32yFjVxP1FcyM?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2084,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 160,
    "LOC_Y": 211,
    "GAME_DATE": 20180208,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/08/0021700815/126/2cd61b5f-2f67-2ec8-34e7-6111c3ac92d5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436888577664293760",
    "name": "The 2974 Collection #2084",
    "imageUrl": "https://arweave.net/bhBHZ7B7Xs056CqrVus5lqj9mG4fgEgMl9m77EFlPdM?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2085,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": 41,
    "GAME_DATE": 20180208,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/08/0021700815/326/d749f92a-785e-d698-590f-4726d9f0be3a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/542787489607867060",
    "name": "The 2974 Collection #2085",
    "imageUrl": "https://arweave.net/Ap6OXJ2qU2uufD7BM_WBZqghymKmf62Ui6EOYAExg0s?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2086,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 128,
    "LOC_Y": 257,
    "GAME_DATE": 20180208,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/08/0021700815/431/880253d0-f537-17a9-3fcc-098ec8ab8d51_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575524740986300266",
    "name": "The 2974 Collection #2086",
    "imageUrl": "https://arweave.net/UmwJnh2CCGBtlpPeE7nAnTIXGFotNQGsPkl22LwWTj4?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2087,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 127,
    "LOC_Y": 226,
    "GAME_DATE": 20180210,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/10/0021700831/64/ec0f5cc3-9b7e-71a2-862f-4d665e769a34_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/408498842872860307",
    "name": "The 2974 Collection #2087",
    "imageUrl": "https://arweave.net/oZ-XrBWRD6KOypzNf2ByVHVtA_da7uq3jTRruXgSjh8?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2018,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2088,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 223,
    "LOC_Y": 66,
    "GAME_DATE": 20180210,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/10/0021700831/105/9a696cf3-5a50-c21e-b3b3-86b21e6c8910_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/342544076383805536",
    "name": "The 2974 Collection #2088",
    "imageUrl": "https://arweave.net/ZZ41wFJB4Na-GhKhVjGNwFEMLlJdrds6EWrpGgrF1Ng?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2018,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2089,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 104,
    "LOC_Y": 247,
    "GAME_DATE": 20180210,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/10/0021700831/303/8e23d969-2d0c-4543-8820-fb035d5ec1cf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552140329656315678",
    "name": "The 2974 Collection #2089",
    "imageUrl": "https://arweave.net/Kj3EP2v-Bq2Hippw5MBNWG8Oa4xbifES1E-DEonkI6Q?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2018,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2090,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 192,
    "LOC_Y": 180,
    "GAME_DATE": 20180212,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/12/0021700846/128/2c03ac8b-d718-b38d-a689-f5c04b06101a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/430433846115327653",
    "name": "The 2974 Collection #2090",
    "imageUrl": "https://arweave.net/LUvkEWdYeGN9pUqsmsHNq83N37Ueg4l2_rt_BORE70Q?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2091,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 132,
    "LOC_Y": 226,
    "GAME_DATE": 20180212,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/12/0021700846/319/598b0106-e241-dbc5-4974-bb6863fd2efc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/375380958439655189",
    "name": "The 2974 Collection #2091",
    "imageUrl": "https://arweave.net/HQ9pxkTEZqu1vzrevNpgizUHFkld0rJHR6tqkg4_tGc?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2092,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -89,
    "LOC_Y": 263,
    "GAME_DATE": 20180212,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/12/0021700846/375/250758a9-6eee-aba2-b87f-6bc0ee0b66a7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575600504451279677",
    "name": "The 2974 Collection #2092",
    "imageUrl": "https://arweave.net/J1kM4ILB1wxMD68rgc1zSxhJajCXGMN4LJPYUhr59Kw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2093,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -199,
    "LOC_Y": 142,
    "GAME_DATE": 20180214,
    "Season": "2017-2018",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/14/0021700864/301/6ddd34c6-9575-1bb8-0045-86be0929e463_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374599827935549040",
    "name": "The 2974 Collection #2093",
    "imageUrl": "https://arweave.net/R3BSBgDf85twjA6nuOG2BZK2WDBVvsUmvyC1chzmZYg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 2,
    "Day": 14,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2094,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 198,
    "LOC_Y": 139,
    "GAME_DATE": 20180214,
    "Season": "2017-2018",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/14/0021700864/323/f95d3a0f-e72b-2292-e800-cbe95829a098_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484762208003887821",
    "name": "The 2974 Collection #2094",
    "imageUrl": "https://arweave.net/hg7qNCWVrS2Kaz_T6Em8nOriUrTEGITAOUc3IsPFOBo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 2,
    "Day": 14,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2095,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -60,
    "LOC_Y": 243,
    "GAME_DATE": 20180214,
    "Season": "2017-2018",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/14/0021700864/533/fd0de155-9b6a-7555-9a52-8bacaffe99ff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/437428051560679335",
    "name": "The 2974 Collection #2095",
    "imageUrl": "https://arweave.net/xrONDNHCNgxB43bOHDmKGxiiLOKBDzxMN_oKD7NDVp0?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 2,
    "Day": 14,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2096,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 37,
    "LOC_X": -79,
    "LOC_Y": 362,
    "GAME_DATE": 20180222,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/22/0021700872/152/29c1c9c7-9d15-4692-ffbc-71079e9575dd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/426342947485835787",
    "name": "The 2974 Collection #2096",
    "imageUrl": "https://arweave.net/OrBBykl80Wav3iWBClyF7jgryvujIzZhAGkBZYlaIxM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2097,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -20,
    "LOC_Y": 251,
    "GAME_DATE": 20180222,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/22/0021700872/290/08c6e6fd-73c9-bd16-c92e-6c2c61a45521_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541578777437826859",
    "name": "The 2974 Collection #2097",
    "imageUrl": "https://arweave.net/Mlt2P4bRnbmNWL3zDNjSFKR9yxl3edpwCvrw7Kid1xM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2098,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 73,
    "LOC_Y": 253,
    "GAME_DATE": 20180222,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/22/0021700872/334/595ecb18-1750-1e67-37f9-02e2d76223b5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378404188839870208",
    "name": "The 2974 Collection #2098",
    "imageUrl": "https://arweave.net/MWkE5ftxXcNW9SJyMBwFekQdcQyvAB8hhqsR0sBc3-Y?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2099,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 180,
    "LOC_Y": 185,
    "GAME_DATE": 20180222,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/22/0021700872/377/863aa276-50c8-ed15-c067-4a27d38fbc6d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461911601315256704",
    "name": "The 2974 Collection #2099",
    "imageUrl": "https://arweave.net/LIZTES-r9T-p8Dn8a1Sj1SSy2eQ8kpmHHE2daSFemJk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2100,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -13,
    "LOC_Y": 266,
    "GAME_DATE": 20180222,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/22/0021700872/433/8a9a7765-b6cf-4ae0-822f-9574e4416ceb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562841882099455649",
    "name": "The 2974 Collection #2100",
    "imageUrl": "https://arweave.net/-v1IVxboEduWIfPquExsYcPW7VtQBo8xHfJ_BdSfkc0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2101,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -16,
    "LOC_Y": 269,
    "GAME_DATE": 20180222,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/22/0021700872/607/9f3083b4-fb84-94c9-c5ee-093a22d196bf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421368810490740672",
    "name": "The 2974 Collection #2101",
    "imageUrl": "https://arweave.net/A7d5QZPjvu5-_LWK3tgM8oLYwxnPQw4rHpx8C1Da6oE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2102,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 125,
    "LOC_Y": 262,
    "GAME_DATE": 20180222,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/22/0021700872/655/0ce646f4-74d7-5182-f33f-29edeb86445f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392400707644079396",
    "name": "The 2974 Collection #2102",
    "imageUrl": "https://arweave.net/YPtpN0cn3bFnuE_ZTOzTcRN_VV_WVPe48KavDUp_-VE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2103,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 62,
    "LOC_Y": 251,
    "GAME_DATE": 20180222,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/22/0021700872/666/025afdc8-85e0-6d24-aff0-b6e64a339d7a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/564452334349217616",
    "name": "The 2974 Collection #2103",
    "imageUrl": "https://arweave.net/kbwY0ib5j3J7HkyX_uKBUbtXyEcvgM8E4bM-chQTlWk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 2,
    "Day": 22,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2104,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 176,
    "LOC_Y": 186,
    "GAME_DATE": 20180224,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/24/0021700887/53/8ab3f50f-2350-8ae4-c199-156c3c798477_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485591765939154884",
    "name": "The 2974 Collection #2104",
    "imageUrl": "https://arweave.net/De7BcHIuPuIqyQdRBv_bZ-6KYKNqxV6UHxFxppl0hwA?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2105,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -89,
    "LOC_Y": 275,
    "GAME_DATE": 20180224,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/24/0021700887/125/d0e8f400-707d-94ce-33dc-f7a98f149767_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/398409287136094435",
    "name": "The 2974 Collection #2105",
    "imageUrl": "https://arweave.net/mgYYjaQsiNXfQXHgueMzuU8W973TS1h6UyVUe7ATu2U?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2106,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -166,
    "LOC_Y": 191,
    "GAME_DATE": 20180224,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/24/0021700887/312/1b245af6-6ad4-16d2-3310-452ebb5fbe0c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524096100982181247",
    "name": "The 2974 Collection #2106",
    "imageUrl": "https://arweave.net/E-ebzdAADWxdeIFUKexBe9FXSc7vyYcXDJkEnUEWEYA?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2107,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 20,
    "GAME_DATE": 20180224,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/24/0021700887/408/d19b0cf5-31a9-afcb-4b50-4ab242c0e439_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293203580354844252",
    "name": "The 2974 Collection #2107",
    "imageUrl": "https://arweave.net/qevubd98U4MWVST3rjCSIqFfw1ERm7gW8eNgRvkfgLA?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2108,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -144,
    "LOC_Y": 218,
    "GAME_DATE": 20180224,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/24/0021700887/424/fce34c88-6f89-1670-c55c-291e650fc711_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512128679553959517",
    "name": "The 2974 Collection #2108",
    "imageUrl": "https://arweave.net/p6K3SxmEEg_CnJ3yS86g0DZ5rWBU-5CY0KLqiR26Yds?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2109,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -76,
    "LOC_Y": 247,
    "GAME_DATE": 20180226,
    "Season": "2017-2018",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/26/0021700900/89/d1d899b9-bc9f-13ee-331c-68d2c834ea9d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/416899391792344613",
    "name": "The 2974 Collection #2109",
    "imageUrl": "https://arweave.net/XDMAA01BCQsB4SR-fiXVIOY8UqRH6p5MFBzO81zVwUw?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2110,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -133,
    "LOC_Y": 222,
    "GAME_DATE": 20180226,
    "Season": "2017-2018",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/26/0021700900/303/ef3ea096-db33-61f0-1a52-99e61cc2e30d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/563472852706770293",
    "name": "The 2974 Collection #2110",
    "imageUrl": "https://arweave.net/m7SWLaIT50Mx-lb-XEg8brOzE1Uwc3XAlP0YVA7GWQ0?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2111,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 130,
    "LOC_Y": 214,
    "GAME_DATE": 20180226,
    "Season": "2017-2018",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/26/0021700900/401/bfaa11e8-70cc-8f41-5c8c-9379766536a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464647606733393478",
    "name": "The 2974 Collection #2111",
    "imageUrl": "https://arweave.net/HESELtYlTTvYuAtBdjcdDypHqI3NJ4o7OfIPOkyJvGE?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2112,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 114,
    "LOC_Y": 231,
    "GAME_DATE": 20180226,
    "Season": "2017-2018",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/26/0021700900/434/7aebaa04-5480-648c-52af-bc3319778aca_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/292592861646791767",
    "name": "The 2974 Collection #2112",
    "imageUrl": "https://arweave.net/XrSycx-5KnZS9a9oY3I8LRcjPjRVvzY_c75ho7_8tCQ?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2113,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 241,
    "LOC_Y": 53,
    "GAME_DATE": 20180228,
    "Season": "2017-2018",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/28/0021700917/59/1deb172b-9bb5-3dd7-a32b-4241eb6493f9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/288232735035825198",
    "name": "The 2974 Collection #2113",
    "imageUrl": "https://arweave.net/AUgXjNJReqi2ychYXjgvtK87MRIZDak6_vPAg88l5sA?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2114,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -124,
    "LOC_Y": 243,
    "GAME_DATE": 20180228,
    "Season": "2017-2018",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/28/0021700917/114/4e22f6c3-eae0-c31f-f92e-727ae8e2dc1a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468349912068781153",
    "name": "The 2974 Collection #2114",
    "imageUrl": "https://arweave.net/H5F5hBB_IADgUzj1SXOeXxdk6yWFdmQRm1C4kjYEe3Q?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2115,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -144,
    "LOC_Y": 204,
    "GAME_DATE": 20180228,
    "Season": "2017-2018",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/28/0021700917/143/13f3da83-ebe3-1536-3ebf-4d2f9972cba9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484499081036433890",
    "name": "The 2974 Collection #2115",
    "imageUrl": "https://arweave.net/zoC9PVY7osCpt-j-brXj9JpXLjXvwjNhKAfPXaYHZFs?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2116,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 0,
    "GAME_DATE": 20180228,
    "Season": "2017-2018",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/02/28/0021700917/455/bdc07d5a-9a5b-3b9d-2e5a-1c6d03d276bd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309292294649035050",
    "name": "The 2974 Collection #2116",
    "imageUrl": "https://arweave.net/DcGTpirA54vMBNO3ZSzr1bIC8XPYpGY7jzI5QkVTNoU?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2117,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -221,
    "LOC_Y": 113,
    "GAME_DATE": 20180302,
    "Season": "2017-2018",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/02/0021700928/74/1739ee30-0e83-780c-c56f-51d07279720a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/419980803344393119",
    "name": "The 2974 Collection #2117",
    "imageUrl": "https://arweave.net/sKW5fwpWPZ8zKQxbEbFj542r1SldsyCF1cJ5c8kOI0Y?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2118,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -175,
    "LOC_Y": 189,
    "GAME_DATE": 20180302,
    "Season": "2017-2018",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/02/0021700928/241/82fdcf74-697f-ee9f-3938-ea88c224b947_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498086115250496216",
    "name": "The 2974 Collection #2118",
    "imageUrl": "https://arweave.net/4rG3_sNCRocDsyFClTpt6cBbfcriXc_ovEsj-WFpbx0?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2119,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 206,
    "LOC_Y": 133,
    "GAME_DATE": 20180302,
    "Season": "2017-2018",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/02/0021700928/259/72d48f5e-05ec-b529-64b2-44770e290777_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512205031166860388",
    "name": "The 2974 Collection #2119",
    "imageUrl": "https://arweave.net/xxlmcrp9w8oTYf58jV5f0uMcA2TosgVwrv4x8dOqSXw?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2120,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 126,
    "LOC_Y": 215,
    "GAME_DATE": 20180302,
    "Season": "2017-2018",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/02/0021700928/352/b4069c7e-ab6b-84a8-3181-4df41818b18b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323331337154748975",
    "name": "The 2974 Collection #2120",
    "imageUrl": "https://arweave.net/0ADghOyJmOmEpPhgVvixtukcLbAE8qocnoh3Fl--lpA?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2121,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -25,
    "LOC_Y": 284,
    "GAME_DATE": 20180306,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/06/0021700963/134/48107e30-f86e-09e4-5967-a9dc9cbbee48_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390976199311313284",
    "name": "The 2974 Collection #2121",
    "imageUrl": "https://arweave.net/6Ky02ACQe45HWzHXvrIFLfDOFp2fjxoINTq9pXVUNu8?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2122,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 2,
    "LOC_Y": 278,
    "GAME_DATE": 20180306,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/06/0021700963/140/d34dd306-ab19-aeb8-2666-bced774ef784_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309849491300628488",
    "name": "The 2974 Collection #2122",
    "imageUrl": "https://arweave.net/IdTQbSP2iSvg2tgvuEnM-HEUwORMjR4neJiqw00s6Z4?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2123,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 38,
    "LOC_Y": 248,
    "GAME_DATE": 20180306,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/06/0021700963/229/f9a46aaa-3265-f4bf-c4e7-819bed22502e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385163738888569655",
    "name": "The 2974 Collection #2123",
    "imageUrl": "https://arweave.net/3OrH3vw2gqcHx753XFLPbHnjWp0IJqqO5Pz4WmbY32Y?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2124,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -236,
    "LOC_Y": 33,
    "GAME_DATE": 20180306,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/06/0021700963/386/ebb9ea79-c379-2cfd-8080-d183d3928688_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/573159675192795635",
    "name": "The 2974 Collection #2124",
    "imageUrl": "https://arweave.net/nexcw6CKdnJZmUqMDT-3dl9vu6qqDItPBJPgVlc_sFA?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2125,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 150,
    "LOC_Y": 210,
    "GAME_DATE": 20180306,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/06/0021700963/431/54b18fa5-b55b-73b3-19c3-9ea3b3198a16_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513918698581889861",
    "name": "The 2974 Collection #2125",
    "imageUrl": "https://arweave.net/mzBRGnHIvkAlXc3OYnJMn74UC3MbSA3uv9RvCmA1KPE?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2126,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -147,
    "LOC_Y": 235,
    "GAME_DATE": 20180306,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/06/0021700963/434/db698ff9-878a-930a-b25f-7c4f6b201ea2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/542378571766561255",
    "name": "The 2974 Collection #2126",
    "imageUrl": "https://arweave.net/Cn2_77-eglrkSHgikL4hV4iVFOov5O8WbEKx-Bf8jI4?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 3,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2127,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 184,
    "LOC_Y": 190,
    "GAME_DATE": 20180323,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/23/0021701087/356/ca1ec2f9-6088-1461-d75f-dc03243a31a7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373715845263874387",
    "name": "The 2974 Collection #2127",
    "imageUrl": "https://arweave.net/LbubH2PjrDRhPuMdriI1JCUYtSrfvde2WbZeWTknUGE?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2128,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 59,
    "LOC_Y": 257,
    "GAME_DATE": 20180323,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/23/0021701087/417/4600749b-aa74-297c-b806-1da27ff6b956_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/519348077592779053",
    "name": "The 2974 Collection #2128",
    "imageUrl": "https://arweave.net/Swp51qf0Z86kSeBhV6Y2Zh7x672PEmN4RxcOrlBwkcE?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2129,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 217,
    "LOC_Y": 132,
    "GAME_DATE": 20180323,
    "Season": "2017-2018",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/03/23/0021701087/453/b59682f2-9e90-ad31-5762-66707b219c49_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386288992671007335",
    "name": "The 2974 Collection #2129",
    "imageUrl": "https://arweave.net/k-AE4ZL0BhG-zrmpV_UxJ-Ikq8KdLZ4IV0i7W0BDMrc?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 3,
    "Day": 23,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2130,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 226,
    "LOC_Y": 90,
    "GAME_DATE": 20181016,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/16/0021800002/10/d7e8b7fa-8e17-0f94-360a-23adde684d82_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299468821128325333",
    "name": "The 2974 Collection #2130",
    "imageUrl": "https://arweave.net/KEN4rDPoOiedjdKI73IGd7-5iTgmS2Z4M39YMBJeQTQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 10,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2131,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 8,
    "GAME_DATE": 20181016,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/16/0021800002/145/1ad1fccb-6a4e-f1a0-b0cd-045f4b8d9217_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/557575574170474794",
    "name": "The 2974 Collection #2131",
    "imageUrl": "https://arweave.net/WhJtDmtwGhaQSsxiwCgN_tyj-PaDDpISosR-laG7PLE?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 10,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2132,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -204,
    "LOC_Y": 195,
    "GAME_DATE": 20181016,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/16/0021800002/293/0f178bbc-6c85-72c7-9d22-2c169075aca0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/303255607871574097",
    "name": "The 2974 Collection #2132",
    "imageUrl": "https://arweave.net/ywxAExbTbSJQIYheaMzFNOFN2Eklwnc3H6zxum-EXXg?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 10,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2133,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 25,
    "LOC_Y": 281,
    "GAME_DATE": 20181016,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/16/0021800002/418/fe82c00b-93af-3413-beb0-22f0feab7c8c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397360903881280325",
    "name": "The 2974 Collection #2133",
    "imageUrl": "https://arweave.net/kJBrwwWtrrn5DSFmco8eCB77SwY1IELLtDwp6OWtFqM?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 10,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2134,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 5,
    "LOC_Y": 282,
    "GAME_DATE": 20181016,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/16/0021800002/470/60406359-5428-6c23-3dd6-c619f4651b5e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366792420692472644",
    "name": "The 2974 Collection #2134",
    "imageUrl": "https://arweave.net/T-o3dwIz2Q8dUJFW33ELgkCvWbIBahsMvOy8nUtEhuc?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2018,
    "Month": 10,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2135,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 171,
    "LOC_Y": 179,
    "GAME_DATE": 20181019,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/19/0021800024/314/21ad1294-9ca2-c3f3-07a3-94e7b7b30f43_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548580884284854117",
    "name": "The 2974 Collection #2135",
    "imageUrl": "https://arweave.net/d9G5k1DnGweJ0aAgmBWwlCMojEa8Eiajr0DhNJwVnzI?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 10,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2136,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -137,
    "LOC_Y": 214,
    "GAME_DATE": 20181019,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/19/0021800024/390/ab3dfaf7-4801-9ccc-65a7-3bc4aad9caac_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/542585622795158111",
    "name": "The 2974 Collection #2136",
    "imageUrl": "https://arweave.net/6I9jvW51-GaK4JrjCfFmNLI_E15TdIrHOnymEJH3mG0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 10,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2137,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -226,
    "LOC_Y": 105,
    "GAME_DATE": 20181019,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/19/0021800024/494/3067b188-390a-3042-a5d0-26b11332d449_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539882951259931925",
    "name": "The 2974 Collection #2137",
    "imageUrl": "https://arweave.net/jnsT2e8U8U7OSK4i00ttup_WqAkd3NmV5ym2Tfl2gqY?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 10,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2138,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 156,
    "LOC_Y": 193,
    "GAME_DATE": 20181019,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/19/0021800024/589/f0928d62-4e59-60a8-7f0a-d49cb379f82f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417248042913799456",
    "name": "The 2974 Collection #2138",
    "imageUrl": "https://arweave.net/HsG18r-s0BeOaHvU224JpjZxX9DIC3eWWvE-7EvrlaA?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 10,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2139,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 101,
    "LOC_Y": 231,
    "GAME_DATE": 20181019,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/19/0021800024/654/6cd11795-37f9-9c12-9a17-358215751612_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523380619504925482",
    "name": "The 2974 Collection #2139",
    "imageUrl": "https://arweave.net/e_0N4IhrhhFytudW8LBSFaLiOgjRLl__XDfS-bl-9_I?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 10,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2140,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 11,
    "LOC_Y": 261,
    "GAME_DATE": 20181021,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/21/0021800038/128/10294bb5-1f3a-fee9-c490-83a18f37ea69_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499689008541037172",
    "name": "The 2974 Collection #2140",
    "imageUrl": "https://arweave.net/2IIMEr-Kdqa4alfyKdkChjY-nJ9wchByZLPWxY_tthY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2141,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -7,
    "GAME_DATE": 20181021,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/21/0021800038/295/c24aa95f-f2ac-f097-21f2-aaf450c238f0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330407977754292876",
    "name": "The 2974 Collection #2141",
    "imageUrl": "https://arweave.net/7J0N8xrmo15HiyoVIm86bJKnNqArZWvXWRujne_O51w?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2142,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 222,
    "LOC_Y": 10,
    "GAME_DATE": 20181021,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/21/0021800038/542/38bd2063-beef-1c34-6197-b99536c92c04_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515675503626702941",
    "name": "The 2974 Collection #2142",
    "imageUrl": "https://arweave.net/e5PE0nItqbFqEZvjUx94v32huq2FGuoazciwrE8wrQ0?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2143,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -132,
    "LOC_Y": 217,
    "GAME_DATE": 20181021,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/21/0021800038/603/861e6124-4862-a582-b30e-a53750bcfb40_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/431243205239361891",
    "name": "The 2974 Collection #2143",
    "imageUrl": "https://arweave.net/elwJR2_35WkTztbuTxouiS1MLVCHZb-4TLpf3Fup0Sg?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2144,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 169,
    "LOC_Y": 175,
    "GAME_DATE": 20181021,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/21/0021800038/610/2a2a59a2-cb5b-4caf-19df-f969029b717d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308280216700084812",
    "name": "The 2974 Collection #2144",
    "imageUrl": "https://arweave.net/PTcrWwN7CKPOp08txPCj_I6uaKR-Mg-bAhin5iwlCrc?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2145,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 81,
    "LOC_Y": 237,
    "GAME_DATE": 20181021,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/21/0021800038/620/e869514d-eb99-c892-dd84-b48bdb8fcd03_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/574864125916830036",
    "name": "The 2974 Collection #2145",
    "imageUrl": "https://arweave.net/ZFe_Smel-NF8cKbu2qcITFRcKoHPavweqTAxsuUirO8?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2018,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2146,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 174,
    "LOC_Y": 188,
    "GAME_DATE": 20181022,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/22/0021800047/270/8aa49f78-9e5a-cd90-fee7-5ebcacbb53dd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/372822051585235184",
    "name": "The 2974 Collection #2146",
    "imageUrl": "https://arweave.net/lZAu7oCKnsXzAiVKde6hxN9nQNBbdH39QirojVQW-mQ?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 10,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2147,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 139,
    "LOC_Y": 223,
    "GAME_DATE": 20181022,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/22/0021800047/305/f539cf09-60e9-bdd9-44ff-ca3671608332_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478965355536863051",
    "name": "The 2974 Collection #2147",
    "imageUrl": "https://arweave.net/5Z--4CWPOpOUbHb0ZDQvZosHhwXyEVgX_KCvnqo7E9E?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 10,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2148,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -227,
    "LOC_Y": 3,
    "GAME_DATE": 20181022,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/22/0021800047/423/e7e61b33-ca3b-bcae-a428-11babe599cef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422052887462247959",
    "name": "The 2974 Collection #2148",
    "imageUrl": "https://arweave.net/yCP_hH5UmeeEuyNr7qWgV88ZoLZpuFsDpF6RyRVBcqo?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 10,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2149,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -75,
    "LOC_Y": 243,
    "GAME_DATE": 20181022,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/22/0021800047/501/b3fb42f0-1f6c-f747-5d6d-5d9f855e782c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540793265552053230",
    "name": "The 2974 Collection #2149",
    "imageUrl": "https://arweave.net/Oi383BY-5VkN1mJCEQFRCsCVaRQOSagvnL1RdaWgARw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 10,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2150,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 96,
    "LOC_Y": 245,
    "GAME_DATE": 20181022,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/22/0021800047/506/a44a65d7-6e79-12fc-d2fb-c2396e772717_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443881887159431159",
    "name": "The 2974 Collection #2150",
    "imageUrl": "https://arweave.net/C2rauGuzWFzHYg1HAWacmKYJxxVe3re640R1EZAd0nU?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 10,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2151,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 87,
    "LOC_Y": 267,
    "GAME_DATE": 20181022,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/22/0021800047/518/91f91ad7-e484-1373-3d39-ea21e356730b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/426518379985688809",
    "name": "The 2974 Collection #2151",
    "imageUrl": "https://arweave.net/zsrhYTB2EJ5IrMbsqoLfYvEuAhT9hRYhZSHsF5cOB38?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 10,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2152,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 154,
    "LOC_Y": 197,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/44/16f546f5-5842-c788-8a72-1c28a1adbd32_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346897008116807364",
    "name": "The 2974 Collection #2152",
    "imageUrl": "https://arweave.net/w0_e7uLuKfiGxHSHBeMTR3-rVOVIyYpoSYicQnPFaA8?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2153,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -170,
    "LOC_Y": 227,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/121/133925c0-a018-f73e-4abd-21367375560a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541954131988503913",
    "name": "The 2974 Collection #2153",
    "imageUrl": "https://arweave.net/ucxSqYxMpendj-OrXuWWLEDheKJ62EvXhEgYGVnXPzQ?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2154,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -154,
    "LOC_Y": 272,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/135/b18247c2-ac37-167b-e5fb-950735ade594_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499763421854648180",
    "name": "The 2974 Collection #2154",
    "imageUrl": "https://arweave.net/O7llq53Tlhsyxt6PqzG4JhGPSXUpIXXhbMNjz9K7rtg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2155,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": -7,
    "LOC_Y": 331,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/142/8154b87d-9fd8-fac4-59ce-c61a629a169f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290095013842633648",
    "name": "The 2974 Collection #2155",
    "imageUrl": "https://arweave.net/5p8TjFcPaRlXJlu5-ov8adZgMKwlT_aWBOFE8_s_170?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2156,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 82,
    "LOC_Y": 278,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/150/a363cee0-c35a-9b41-62e5-6354464f8229_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/469945575417474763",
    "name": "The 2974 Collection #2156",
    "imageUrl": "https://arweave.net/qMLnYvi2WRTew7pDs5hihUyWsZG1tCO3_vM0qUuJZwc?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2157,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -223,
    "LOC_Y": 123,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/315/f9727e07-b607-27a1-0a82-8f1e26e77e0d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/453254139430511308",
    "name": "The 2974 Collection #2157",
    "imageUrl": "https://arweave.net/WrkKiGbkBV1bzgmhk6iN5-H39rtPuQ0-mGvM_UH8fbI?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2158,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -10,
    "LOC_Y": 271,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/386/5a0d59d0-dae4-d98c-1be1-fbfeb7880a56_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403522060841135493",
    "name": "The 2974 Collection #2158",
    "imageUrl": "https://arweave.net/gTSVajuHPImTm_-b1r31EtemJxdYCaZCMmlTzBJvUis?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2159,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 29,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/455/cc19adb5-9cae-d29a-5c61-3825b2c6f31a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464411034024210564",
    "name": "The 2974 Collection #2159",
    "imageUrl": "https://arweave.net/8HsNAn8uSEuhgGDRdjDj88iVm1E_xAvx-1BLjOTZgaI?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2160,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -225,
    "LOC_Y": -12,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/464/fdd17876-8f39-5dea-95ab-ef1acb93a44c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575910300238653086",
    "name": "The 2974 Collection #2160",
    "imageUrl": "https://arweave.net/UnfzP3kFuqJVWkZlaM0iWbEwOVEFA79Knppug-bz5tk?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2161,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -206,
    "LOC_Y": 232,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/471/5b7aa826-3d8b-e39c-f8df-ed0b00bd12c3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540786309687989984",
    "name": "The 2974 Collection #2161",
    "imageUrl": "https://arweave.net/_qje8K1ZpzikrqoqPKo-3aPkbg5BleYGDL5hM7KIuwc?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2162,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 0,
    "LOC_Y": 313,
    "GAME_DATE": 20181024,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/24/0021800062/497/4a6cae78-cf54-46d5-a7f6-b5c338bf82c6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/453063822861946093",
    "name": "The 2974 Collection #2162",
    "imageUrl": "https://arweave.net/eay6qhRBvSH7eDu91tqAn0C_u-crxJL6n32KBGaOOE8?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2018,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (51 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2163,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -60,
    "LOC_Y": 243,
    "GAME_DATE": 20181026,
    "Season": "2018-2019",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/26/0021800068/79/1974f605-028c-3546-99cc-b76ad4aac967_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501823217266386203",
    "name": "The 2974 Collection #2163",
    "imageUrl": "https://arweave.net/-ecYlT9GtUVxvoJ8Sytpom3EYypF2OuYkiyUROVIAhc?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2164,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -221,
    "LOC_Y": -13,
    "GAME_DATE": 20181026,
    "Season": "2018-2019",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/26/0021800068/86/f4fd1842-535d-ac6d-d240-28fdb3763224_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438339757176898027",
    "name": "The 2974 Collection #2164",
    "imageUrl": "https://arweave.net/0JiBO17ngPxA_spqakC88513GcYNXvDzJ0QDBkjIWOM?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2165,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -171,
    "LOC_Y": 167,
    "GAME_DATE": 20181026,
    "Season": "2018-2019",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/26/0021800068/103/97ab3cfd-5590-aa74-b74f-87f6f339a5ae_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/427963924628779600",
    "name": "The 2974 Collection #2165",
    "imageUrl": "https://arweave.net/MQmRgaSbKSC7-70e9g-vVxQuYZGIrjSsKpImavc5kCY?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2166,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -84,
    "LOC_Y": 265,
    "GAME_DATE": 20181026,
    "Season": "2018-2019",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/26/0021800068/336/d7d530b0-4a03-0b77-dee5-86a0911bc7c2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390097491850661374",
    "name": "The 2974 Collection #2166",
    "imageUrl": "https://arweave.net/ipVs2OJjnHh1qLzR3XdyMwhPLvpyXZYWI3OQGmKcWS4?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2167,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 222,
    "LOC_Y": 83,
    "GAME_DATE": 20181026,
    "Season": "2018-2019",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/26/0021800068/369/1f02a761-9dad-3182-9556-fdeea6c84a98_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363609198941798708",
    "name": "The 2974 Collection #2167",
    "imageUrl": "https://arweave.net/4qfHMU3efL0lAyMiA3XV_NnSgRVx4rT_p-_QhmRDyY4?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2168,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 156,
    "LOC_Y": 201,
    "GAME_DATE": 20181026,
    "Season": "2018-2019",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/26/0021800068/589/33adafd0-3306-a0ef-e537-49d0f0631ed9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/451388690548917274",
    "name": "The 2974 Collection #2168",
    "imageUrl": "https://arweave.net/YYQSOc64tzuHLgDFqu0jBojZpfHes7tDpn1gBRem0gQ?ext=png",
    "Opposing Team City": "New York",
    "Year": 2018,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2169,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -91,
    "LOC_Y": 227,
    "GAME_DATE": 20181028,
    "Season": "2018-2019",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/28/0021800083/27/bf7fc7a2-0b8a-f498-84b3-98322cb18118_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338450933003636971",
    "name": "The 2974 Collection #2169",
    "imageUrl": "https://arweave.net/FmzBUVkykirY9KwIlYUTRly-gFERJ0vKS4oaFC73ILQ?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2170,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": 14,
    "GAME_DATE": 20181028,
    "Season": "2018-2019",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/28/0021800083/41/cc032dc4-a7fe-4dc8-42c1-8d14de2535d9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489620684095798162",
    "name": "The 2974 Collection #2170",
    "imageUrl": "https://arweave.net/OBacSC8rqx2vfpIxU_zs4wKAOD66briZLqOjn0ZmEv8?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2171,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -182,
    "LOC_Y": 167,
    "GAME_DATE": 20181028,
    "Season": "2018-2019",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/28/0021800083/84/7ee0724e-1fad-fe7b-3d2c-e077ffa9ce6f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572080637442048500",
    "name": "The 2974 Collection #2171",
    "imageUrl": "https://arweave.net/OqcYZFeYaKAsbULd3jMGRbhzQ4OAITBNtcQhMId1n-I?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2172,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -10,
    "GAME_DATE": 20181028,
    "Season": "2018-2019",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/28/0021800083/277/cc65960a-7786-9f48-4c45-54a28848aa2c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352544818181407580",
    "name": "The 2974 Collection #2172",
    "imageUrl": "https://arweave.net/7oPUcPpceCGkY9uPxep5eUNwodGxp7GeNhtyKtB2gEw?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2173,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 19,
    "LOC_Y": 264,
    "GAME_DATE": 20181028,
    "Season": "2018-2019",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/28/0021800083/298/bae18940-7bd7-2a22-8407-fcf97547e58f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/432872436373495991",
    "name": "The 2974 Collection #2173",
    "imageUrl": "https://arweave.net/Whi3oS8Pydujx213hn8H_ggbP9E-VNIZG8RTVYFXHsI?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2174,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -165,
    "LOC_Y": 241,
    "GAME_DATE": 20181028,
    "Season": "2018-2019",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/28/0021800083/381/732c62f2-bc27-058f-3f95-9a350284c729_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/563734405558974933",
    "name": "The 2974 Collection #2174",
    "imageUrl": "https://arweave.net/dP1ncgAqVOn5SvMWigEbZIxdekr5kVdjYcmc6UNIUj0?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2175,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -30,
    "LOC_Y": 247,
    "GAME_DATE": 20181028,
    "Season": "2018-2019",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/28/0021800083/608/b87ea4ba-4ba8-afb0-303e-ed2e62877a7c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/517636045982223678",
    "name": "The 2974 Collection #2175",
    "imageUrl": "https://arweave.net/4DnFB7c2p_Mi0wx6fbn-bplaBrAi53_dBXQIVncs4jc?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2018,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2176,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -122,
    "LOC_Y": 267,
    "GAME_DATE": 20181029,
    "Season": "2018-2019",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301972569350288327",
    "name": "The 2974 Collection #2176",
    "imageUrl": "https://arweave.net/TwiKKqBLoISdHfg7yCAfiDmOPOLIUfQ3JrLInDxyKlw?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2018,
    "Month": 10,
    "Day": 29,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2177,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 146,
    "LOC_Y": 206,
    "GAME_DATE": 20181029,
    "Season": "2018-2019",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/29/0021800091/352/aeb64ed3-74d6-7c42-1d52-0ab3f129d2b3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/516281196731151496",
    "name": "The 2974 Collection #2177",
    "imageUrl": "https://arweave.net/BtLobfsich5L8mpO3rMyvC4FZxaP-n3dYcIClyJI4mM?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2018,
    "Month": 10,
    "Day": 29,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2178,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 8,
    "LOC_Y": 299,
    "GAME_DATE": 20181031,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/31/0021800108/67/596314d9-55f2-91ba-323a-f6daa080dea2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567695096447097193",
    "name": "The 2974 Collection #2178",
    "imageUrl": "https://arweave.net/xZBeo-NdysKDbkNb2lzGXNTbASXHh1DJAxrJqUdVavc?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2018,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2179,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 2,
    "LOC_Y": 269,
    "GAME_DATE": 20181031,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/31/0021800108/307/90686779-dd70-6513-3151-b29874e53364_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444346557420373272",
    "name": "The 2974 Collection #2179",
    "imageUrl": "https://arweave.net/DTpYvImp574m1NDaGTulBGGMMv0TCgn9R3DIlxzqh-E?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2018,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2180,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -150,
    "LOC_Y": 206,
    "GAME_DATE": 20181031,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/31/0021800108/409/5e3aadb5-9345-1f7e-28d2-2e6612bcea8d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354143699450284515",
    "name": "The 2974 Collection #2180",
    "imageUrl": "https://arweave.net/kNYXngiWyHskzmYCGf1OoorM9OgnlkJVeiODqF71wPw?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2018,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2181,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": -16,
    "GAME_DATE": 20181031,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/31/0021800108/435/657295ef-27f5-a0da-64e9-a73e7c8d2574_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/492393836226315171",
    "name": "The 2974 Collection #2181",
    "imageUrl": "https://arweave.net/_0KBlpJBbc9YsI13zupIyhSWiXTTWaBbbcVuej-EIO4?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2018,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2182,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 62,
    "LOC_Y": 276,
    "GAME_DATE": 20181031,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/31/0021800108/490/e3859439-2a8c-0c5d-e6c5-c1f8e8f7182a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/532110413555279796",
    "name": "The 2974 Collection #2182",
    "imageUrl": "https://arweave.net/aHznNbMm8YHgMjVlwisbmpr9ps6eezlxBX9BSm_vxt0?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2018,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2183,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 116,
    "LOC_Y": 279,
    "GAME_DATE": 20181031,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/31/0021800108/528/135bc48c-7edd-0f0c-4823-fdd95a5401a1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456643962602491063",
    "name": "The 2974 Collection #2183",
    "imageUrl": "https://arweave.net/xW9HlAOiuLiDXGIKzOnpiWuH2HCI0g9xjfpPaIBHGRg?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2018,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2184,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 142,
    "LOC_Y": 218,
    "GAME_DATE": 20181031,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/10/31/0021800108/621/db0df45a-fd90-2048-1e6a-2dd1acd3e2c1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395821493842880701",
    "name": "The 2974 Collection #2184",
    "imageUrl": "https://arweave.net/JA0htm98C3vhWKfjiQTOCCV04bWLOb-Hs9Vv6FGAiyo?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2018,
    "Month": 10,
    "Day": 31,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2185,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -18,
    "LOC_Y": 262,
    "GAME_DATE": 20181102,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/11/02/0021800124/41/18243034-3aa0-216e-4546-5803f41da7b2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/557926878229079518",
    "name": "The 2974 Collection #2185",
    "imageUrl": "https://arweave.net/rpeXZzTCVyveygo-wMiOGFkYiS4g-iiFXPEMk0GPGbQ?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2186,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -183,
    "LOC_Y": 220,
    "GAME_DATE": 20181102,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/11/02/0021800124/279/a0869168-496e-e76e-2870-82ce1a5178b6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/383561891659437479",
    "name": "The 2974 Collection #2186",
    "imageUrl": "https://arweave.net/219scIUgBWgs-4vrN2NSydgROmnEnlMknnA0SpG2Ojg?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2187,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 185,
    "LOC_Y": 168,
    "GAME_DATE": 20181102,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/11/02/0021800124/467/7a473e4d-8b89-ade9-82ac-af496414b626_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485313881909924713",
    "name": "The 2974 Collection #2187",
    "imageUrl": "https://arweave.net/yvKxgURi4Sw0e9d2oYcXtQ9ABZzaYeETedYjcvyUGXE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2188,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -220,
    "LOC_Y": 122,
    "GAME_DATE": 20181102,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/11/02/0021800124/634/801295c5-eef5-1c73-d383-139a79d9c5f3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400999223042839749",
    "name": "The 2974 Collection #2188",
    "imageUrl": "https://arweave.net/w558Ca7f9eXn_cCocXmo-ssjZV5IxgJoNvwpNie22Ok?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 11,
    "Day": 2,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2189,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -147,
    "LOC_Y": 277,
    "GAME_DATE": 20181105,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/11/05/0021800147/125/d81d0d17-41bb-ec0c-5450-984f11ecb0c6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352125483069042339",
    "name": "The 2974 Collection #2189",
    "imageUrl": "https://arweave.net/T6I9uoJrTMCMAku3UWKn-WrZze39d5Y-HwXvWKDGO4k?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2018,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2190,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -218,
    "LOC_Y": 138,
    "GAME_DATE": 20181105,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/11/05/0021800147/294/8e1f857f-0903-a268-4c26-c8f126c0e099_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/564124630857829039",
    "name": "The 2974 Collection #2190",
    "imageUrl": "https://arweave.net/uDF-_D8DdVRcutKZtyNp-ZPiRnGRWch-vXWT5yTzpo0?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2018,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2191,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -205,
    "LOC_Y": 179,
    "GAME_DATE": 20181105,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/11/05/0021800147/468/b60f4cef-51cb-4725-f966-68b4ef97cc47_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/526215451333315608",
    "name": "The 2974 Collection #2191",
    "imageUrl": "https://arweave.net/3d6DGZqM_NVba4cVg1EGmrIPtFaKteAS1mSLVzwSWzo?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2018,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2192,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -133,
    "LOC_Y": 244,
    "GAME_DATE": 20181201,
    "Season": "2018-2019",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/01/0021800331/389/9215e712-e3ad-af21-bc5f-bef248408279_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/299200372218588288",
    "name": "The 2974 Collection #2192",
    "imageUrl": "https://arweave.net/oMYrcN-ejUDH7wVI7DBLoY02id4RIneqS3G_83-hRi4?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2018,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2193,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -218,
    "LOC_Y": 170,
    "GAME_DATE": 20181201,
    "Season": "2018-2019",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/01/0021800331/401/2112415c-663a-d0b9-5f06-7523a07d57b1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412653155307350812",
    "name": "The 2974 Collection #2193",
    "imageUrl": "https://arweave.net/qinxw-bu8lb1ri-FkFcLUU8NGUhv_159i_wXaseTHf0?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2018,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2194,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -78,
    "LOC_Y": 273,
    "GAME_DATE": 20181201,
    "Season": "2018-2019",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/01/0021800331/553/fcf2a8fd-8cf7-3d90-61ef-e9e9ceffd179_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/337527882208591984",
    "name": "The 2974 Collection #2194",
    "imageUrl": "https://arweave.net/2rbD3c13PB8zRJssP0_GlHP5vxyHajy45ZhugDlxo5E?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2018,
    "Month": 12,
    "Day": 1,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2195,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -131,
    "LOC_Y": 220,
    "GAME_DATE": 20181203,
    "Season": "2018-2019",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/03/0021800344/39/47d5b540-e2ac-2d28-2938-fe8b1e3c1e3f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302436256475586915",
    "name": "The 2974 Collection #2195",
    "imageUrl": "https://arweave.net/CLNQU4HGXYYQML9QqySRorWtNcme82e8j6lKa0rSZI0?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2196,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -222,
    "LOC_Y": -7,
    "GAME_DATE": 20181203,
    "Season": "2018-2019",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/03/0021800344/55/e7efc7f5-cfbb-e868-b442-c5f6ca4875b7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/343452966951728986",
    "name": "The 2974 Collection #2196",
    "imageUrl": "https://arweave.net/smxqB5ZFZhOAjIgMqtWskwemfk5tdCJKx2nmyYFKJvk?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2197,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 207,
    "LOC_Y": 150,
    "GAME_DATE": 20181203,
    "Season": "2018-2019",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/03/0021800344/67/1ee18de3-c63c-f9e7-10e6-9a03b0f3f83d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/557895362863594524",
    "name": "The 2974 Collection #2197",
    "imageUrl": "https://arweave.net/KrL2_1cSIlcCb1QUY5ayjQmNqn2Bwseo--8bCskvjZM?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2198,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -33,
    "LOC_Y": 247,
    "GAME_DATE": 20181203,
    "Season": "2018-2019",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/03/0021800344/101/a54afacf-04ba-73df-2ec2-d17475a6c8d2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369284659384132488",
    "name": "The 2974 Collection #2198",
    "imageUrl": "https://arweave.net/IrQgTlunqXjedZSKjDFWYBx7oZ9tVKngufkEKEPE1Q0?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2199,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -187,
    "LOC_Y": 170,
    "GAME_DATE": 20181203,
    "Season": "2018-2019",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/03/0021800344/404/18b196da-4bea-11b8-82f6-403286747e1c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417243439227468344",
    "name": "The 2974 Collection #2199",
    "imageUrl": "https://arweave.net/-9yDk3c1igdtb3ifMQkklCNjz7-IkTGtkItLIa6611w?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2200,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 8,
    "LOC_Y": 257,
    "GAME_DATE": 20181203,
    "Season": "2018-2019",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/03/0021800344/639/631c5821-472e-2043-5dda-ef9dc844220f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/419490090082998054",
    "name": "The 2974 Collection #2200",
    "imageUrl": "https://arweave.net/YiaRnG4ybjCeuYyBvFgbWrui_M1-0o_ZhPjQpNGohS4?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2018,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2201,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -136,
    "LOC_Y": 213,
    "GAME_DATE": 20181205,
    "Season": "2018-2019",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/05/0021800355/27/ce59152e-42f7-084f-4419-e9353dba389b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476309408092126383",
    "name": "The 2974 Collection #2201",
    "imageUrl": "https://arweave.net/U2oeqlIZVOz00iIfPLRzMhEUdhOQOloX1D2UgBDMwRg?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2202,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -15,
    "LOC_Y": 262,
    "GAME_DATE": 20181205,
    "Season": "2018-2019",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/05/0021800355/102/7be0744e-346c-a573-0132-a7c4c4daeba6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465294217529256313",
    "name": "The 2974 Collection #2202",
    "imageUrl": "https://arweave.net/jyEsZHc30bNUdMDXXc-rmT4bAFasM5km2yGjETwqlo8?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2203,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 231,
    "LOC_Y": -4,
    "GAME_DATE": 20181205,
    "Season": "2018-2019",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/05/0021800355/116/1c03cef2-9718-b3a4-3d37-1fad98bf90db_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371130699201919807",
    "name": "The 2974 Collection #2203",
    "imageUrl": "https://arweave.net/5U29QCgSXvjqHIMvbRqkX7-LJDKGP5QyIirVwjNnoWE?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2204,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": 190,
    "LOC_Y": 269,
    "GAME_DATE": 20181205,
    "Season": "2018-2019",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/05/0021800355/120/ec8b46cc-27c6-d142-cf64-7c460610158e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536954661032831569",
    "name": "The 2974 Collection #2204",
    "imageUrl": "https://arweave.net/Xv1CsO6KGBCdpVKLNe-gogJj4NM0jxrp04KAv8IMc78?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2205,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -172,
    "LOC_Y": 208,
    "GAME_DATE": 20181205,
    "Season": "2018-2019",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/05/0021800355/285/de8d27c2-9015-7906-ae31-49b085a97f28_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/555760374001317681",
    "name": "The 2974 Collection #2205",
    "imageUrl": "https://arweave.net/ukny4uj2fpHPEkyoUMOp7_5Mu1SnrVA_Y7CaBri9df4?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2206,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -192,
    "LOC_Y": 193,
    "GAME_DATE": 20181205,
    "Season": "2018-2019",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/05/0021800355/311/b4683da0-8ad0-f5d3-40af-1e91705bb606_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512364656631830962",
    "name": "The 2974 Collection #2206",
    "imageUrl": "https://arweave.net/5pO_zcM3xn_Q1rBpZt0iR8YuDO-BjbDqEI521bcKgRg?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2207,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -161,
    "LOC_Y": 220,
    "GAME_DATE": 20181205,
    "Season": "2018-2019",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/05/0021800355/348/3814e92c-35b7-02a1-770d-e753548ec3b3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536846545517330563",
    "name": "The 2974 Collection #2207",
    "imageUrl": "https://arweave.net/YzcohfgRY5xAU7aiPYy0Z8fSKo7G81zlsgM6wuVESv0?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2208,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 37,
    "LOC_Y": 247,
    "GAME_DATE": 20181205,
    "Season": "2018-2019",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/05/0021800355/535/0e548961-6b06-5fa6-c9f5-96f53a25eca1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320793880317794369",
    "name": "The 2974 Collection #2208",
    "imageUrl": "https://arweave.net/TjxOyNkzNqlfsKVKRnp1IZ1FC7atLuIZTyLKSnuANVo?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2209,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 107,
    "LOC_Y": 227,
    "GAME_DATE": 20181205,
    "Season": "2018-2019",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/05/0021800355/542/90879f25-b160-7db3-0011-bf6bcb8029fe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/375771070704490013",
    "name": "The 2974 Collection #2209",
    "imageUrl": "https://arweave.net/5f9M4xK7hAS5IkboIU23wpS-cyCywDIgd2jNq00X3zE?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2018,
    "Month": 12,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2210,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -191,
    "LOC_Y": 226,
    "GAME_DATE": 20181207,
    "Season": "2018-2019",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/07/0021800377/42/1be8c474-fb9e-a5c1-1f3b-c0b358c8ec90_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/393566290257246234",
    "name": "The 2974 Collection #2210",
    "imageUrl": "https://arweave.net/fRjkRfMYANhkJBBqRJf3iQoIZ_3HWxqIllNNve8bQcQ?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2018,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2211,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -51,
    "LOC_Y": 259,
    "GAME_DATE": 20181207,
    "Season": "2018-2019",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/07/0021800377/52/06d0d9e4-754b-3d69-fc9b-0f60ec9e382e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524156433949881008",
    "name": "The 2974 Collection #2211",
    "imageUrl": "https://arweave.net/JspZj45nAFHilnR-Agj1pm3WmQTt9ZIysAaFGjWpUPQ?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2018,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2212,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 77,
    "LOC_Y": 274,
    "GAME_DATE": 20181207,
    "Season": "2018-2019",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/07/0021800377/497/f9edfed1-efc8-6372-c83f-47abcd5e3dc0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511577604630920473",
    "name": "The 2974 Collection #2212",
    "imageUrl": "https://arweave.net/jtDBnwMdTjD0Dt4F-wfUjsvIyTzuzLgKN7CWe3gzIU8?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2018,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2213,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 234,
    "LOC_Y": 110,
    "GAME_DATE": 20181207,
    "Season": "2018-2019",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/07/0021800377/529/4224eaf0-1b82-0d6b-5993-a385f44e6e8d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522980904574848987",
    "name": "The 2974 Collection #2213",
    "imageUrl": "https://arweave.net/1ZdH1YVeosndHG00Eits634u213CHtxFYdzkKOYnzGc?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2018,
    "Month": 12,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2214,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -176,
    "LOC_Y": 196,
    "GAME_DATE": 20181210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/10/0021800400/10/110c68d7-202a-a1a5-1f36-23c706eb1973_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352604540032776532",
    "name": "The 2974 Collection #2214",
    "imageUrl": "https://arweave.net/QYnHqZo5-pEtDNyjC_qF6Km6iwMFuaSHHUEOkq6ho8w?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2215,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -225,
    "LOC_Y": 37,
    "GAME_DATE": 20181210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/10/0021800400/161/d6780b47-803d-13db-d1ea-8c720b570cb7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/432374685603806244",
    "name": "The 2974 Collection #2215",
    "imageUrl": "https://arweave.net/0FRW3T3DEjklzVLqKg8l0pl_lIe9c6TZUUoFdF2_G1w?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2216,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": 13,
    "GAME_DATE": 20181210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/10/0021800400/295/2881a29b-a1ae-0638-59fd-fcc9b28b6274_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444573185935481342",
    "name": "The 2974 Collection #2216",
    "imageUrl": "https://arweave.net/gsnN3behm2xgPux3u-kuYXmAIVyG4lgaJjGRPezi9_M?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2217,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 230,
    "LOC_Y": 69,
    "GAME_DATE": 20181210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/10/0021800400/401/0bc98adb-c27a-ba65-6999-8aa0f01b0d40_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323429913126640763",
    "name": "The 2974 Collection #2217",
    "imageUrl": "https://arweave.net/HUUyr6NN9hsbrcyuRO0p60IO1CNmGVqA3Hoo-ZDsTn4?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2218,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -158,
    "LOC_Y": 206,
    "GAME_DATE": 20181210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/10/0021800400/509/7d376f58-6dc0-8ced-5327-77bc73d032f0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362073586401857633",
    "name": "The 2974 Collection #2218",
    "imageUrl": "https://arweave.net/2dR-mT8VHdNhYgZfk201sG5HsbxfAie0bQD1QAr37wE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2219,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 3,
    "LOC_Y": 299,
    "GAME_DATE": 20181210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/10/0021800400/613/1a7eed93-17b4-2668-cff3-302cae1d9f8f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/472835772174072795",
    "name": "The 2974 Collection #2219",
    "imageUrl": "https://arweave.net/mUVtBN9a-TdIE9VekFCh56mLhxBuIlCsEiFXUXs96iE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2220,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 116,
    "LOC_Y": 252,
    "GAME_DATE": 20181210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/10/0021800400/620/62dca754-4d1e-75de-5bbc-cf1a39111617_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347549927815274882",
    "name": "The 2974 Collection #2220",
    "imageUrl": "https://arweave.net/tYJVnPgKyAgTfh9jguomCj6w_Yy3ipN08QX8TobDbs0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2018,
    "Month": 12,
    "Day": 10,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2221,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 36,
    "GAME_DATE": 20181212,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/12/0021800415/12/02b28bbd-7602-85b3-f7c2-37282a7d0f48_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/532833831381795831",
    "name": "The 2974 Collection #2221",
    "imageUrl": "https://arweave.net/h1Al_goha3rhjSh_zR8MQrSY3Wl3GGkMlJM1BVBdErY?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2018,
    "Month": 12,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2222,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 151,
    "LOC_Y": 211,
    "GAME_DATE": 20181212,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/12/0021800415/222/cf698d06-9f23-7ab8-cb3d-ccfa2d8a47b3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355880385769957444",
    "name": "The 2974 Collection #2222",
    "imageUrl": "https://arweave.net/0B-x29eAirpzvGo6AzlkXDnoRKh0GjqiVDta5ycQuo0?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2018,
    "Month": 12,
    "Day": 12,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2223,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 236,
    "LOC_Y": 18,
    "GAME_DATE": 20181214,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/14/0021800428/52/d7bed63b-24b1-b86b-8f67-2ab13a017909_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302310017794840475",
    "name": "The 2974 Collection #2223",
    "imageUrl": "https://arweave.net/SDLOIaPO6lToqI41TkA7bfh9eW2SBegGsLACAx4juIs?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2018,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2224,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 216,
    "LOC_Y": 118,
    "GAME_DATE": 20181214,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/14/0021800428/219/92ab11f6-6eaa-1d05-6758-7605ce4905e9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335922118584501416",
    "name": "The 2974 Collection #2224",
    "imageUrl": "https://arweave.net/fG6vdNgEhC5J1jF_SAwR5PgzQH8VmoRTnPCYcEWaeRc?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2018,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2225,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -229,
    "LOC_Y": 37,
    "GAME_DATE": 20181214,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/14/0021800428/341/ddec53a0-a31a-3baa-7e80-9b935ada359b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402140663677625070",
    "name": "The 2974 Collection #2225",
    "imageUrl": "https://arweave.net/086Med-YL2uLDT7KaOjkxW2D1vlgxrSJtLO-LdkXAXE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2018,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2226,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -162,
    "LOC_Y": 184,
    "GAME_DATE": 20181214,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/14/0021800428/393/79e39d61-27bc-d42c-b136-0362619247ac_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446423880430546107",
    "name": "The 2974 Collection #2226",
    "imageUrl": "https://arweave.net/Wpdkd4SU3TJRLaMM4xPDjoD4w-Q2qNGWWdMb3zPuI2U?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2018,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2227,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 224,
    "LOC_Y": 19,
    "GAME_DATE": 20181214,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/14/0021800428/453/6d142ef5-3f30-341a-1581-9be178feba9c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500288053524122377",
    "name": "The 2974 Collection #2227",
    "imageUrl": "https://arweave.net/eFQCtBKy9dHQZGMB383PGu2oPslzlkKxPN92_HZ4maI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2018,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2228,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -155,
    "LOC_Y": 264,
    "GAME_DATE": 20181217,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/17/0021800449/219/20357502-a999-132e-9741-89d903e99c56_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/527501239699391440",
    "name": "The 2974 Collection #2228",
    "imageUrl": "https://arweave.net/v3vyyvnBbrKXLkTlnpos9Jcpq3t9-Cfym8J9447egEU?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2018,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2229,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -194,
    "LOC_Y": 167,
    "GAME_DATE": 20181217,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/17/0021800449/368/24c689e7-e0d3-eaef-7955-1aa81ef4bd76_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353001053579598190",
    "name": "The 2974 Collection #2229",
    "imageUrl": "https://arweave.net/V8JAK8sUZGuWxmi-3AtI5aMQPR5P3SNUVtPjalUW4HA?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2018,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2230,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 141,
    "LOC_Y": 248,
    "GAME_DATE": 20181217,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/17/0021800449/497/0a94aa5a-5bc3-71d8-9982-cd8d2514abb7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307184857297313189",
    "name": "The 2974 Collection #2230",
    "imageUrl": "https://arweave.net/g62H5NaOGDvIINwo0FKBMJ7WTuEWYwBqVb-CwgJt_Jc?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2018,
    "Month": 12,
    "Day": 17,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2231,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -228,
    "LOC_Y": 57,
    "GAME_DATE": 20181219,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/19/0021800464/65/2cf6a610-dccd-2c79-29b5-75f96007b45e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/308935253574157699",
    "name": "The 2974 Collection #2231",
    "imageUrl": "https://arweave.net/stZcwwcFg00OaCTBU7oNWHNGNTjjelG--UgB5GWd1nQ?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2232,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 234,
    "LOC_Y": 98,
    "GAME_DATE": 20181219,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/19/0021800464/217/901f0ab8-4eac-7a55-016a-eb5051308c21_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498096026104555648",
    "name": "The 2974 Collection #2232",
    "imageUrl": "https://arweave.net/pd1hWvtuKawkeNMbMLHYivuomkXf2u46z5xnRSQrfeE?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2233,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -162,
    "LOC_Y": 185,
    "GAME_DATE": 20181219,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/19/0021800464/222/856eb2a2-aeb2-2304-1c99-aad76ca689ab_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/394353181646269573",
    "name": "The 2974 Collection #2233",
    "imageUrl": "https://arweave.net/a8wd-b4MKfQ47dXz0vXGdA93hpq20W5vTJ4OkGQI_Jo?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2234,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -150,
    "LOC_Y": 204,
    "GAME_DATE": 20181219,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/19/0021800464/245/0c6e5ad9-d919-1afb-9eab-0586bb55e370_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321064245163493861",
    "name": "The 2974 Collection #2234",
    "imageUrl": "https://arweave.net/vUbatV9oGphdFZOiuklZax0Ir4zxJ2w8EUU4I8CdcIs?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2235,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 5,
    "GAME_DATE": 20181219,
    "Season": "2018-2019",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/19/0021800464/417/504db775-37ca-3805-7248-ae845842715c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/549280707425583229",
    "name": "The 2974 Collection #2235",
    "imageUrl": "https://arweave.net/BheRFbyreS3Axfv3cSencER6AyqbT4p9IeCfkYyf9BM?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2018,
    "Month": 12,
    "Day": 19,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2236,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -213,
    "LOC_Y": 170,
    "GAME_DATE": 20181222,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/22/0021800484/48/8e99ad3c-ffaf-c8e6-e80a-e81a9cb3c13c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546557454328240238",
    "name": "The 2974 Collection #2236",
    "imageUrl": "https://arweave.net/loLiz_X34oFRCg43mcBcxIlErOCJv7cnQSGpK2Oqh_E?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2237,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -136,
    "LOC_Y": 254,
    "GAME_DATE": 20181222,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/22/0021800484/179/2feecfe8-f15e-8f7c-3132-ea85733bdbc1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525489458538827899",
    "name": "The 2974 Collection #2237",
    "imageUrl": "https://arweave.net/7AOg_4TZkLBb51trDgPm6xl0nWrwBNgvFVlzRRFh3a4?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2238,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -157,
    "LOC_Y": 225,
    "GAME_DATE": 20181222,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/22/0021800484/250/8a2ec182-43b1-5b79-31c1-afe3f76376f2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465191172092188597",
    "name": "The 2974 Collection #2238",
    "imageUrl": "https://arweave.net/OIXQP1qsKC77TnMCwxbARkNQUzX93oo_BtLEco_-uuA?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2239,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 233,
    "LOC_Y": 67,
    "GAME_DATE": 20181222,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/22/0021800484/289/0dc861a8-e9c5-b18c-7c73-02731dc375e9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293976099524555732",
    "name": "The 2974 Collection #2239",
    "imageUrl": "https://arweave.net/9YV3GdgahIREvcXS1fD4n9PS7kxbFkg5Cq3E69sMD3s?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2240,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 168,
    "LOC_Y": 247,
    "GAME_DATE": 20181222,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/22/0021800484/540/b1a1e62b-b36d-2d92-a947-82b6f5123678_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434316988407172422",
    "name": "The 2974 Collection #2240",
    "imageUrl": "https://arweave.net/tylU1NQ10k18_hlJxz3NjDAXe7_HwxvgQdNbiEh7-CI?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2241,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 158,
    "LOC_Y": 211,
    "GAME_DATE": 20181222,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/22/0021800484/546/88ce73ec-ada2-f57c-0b3b-9499b85d7208_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/530875731441783055",
    "name": "The 2974 Collection #2241",
    "imageUrl": "https://arweave.net/kMbBQSBvnII7Yyef0nBs9ISet4lbdBMFv5SC6e9NmPg?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2018,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2242,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 13,
    "GAME_DATE": 20181223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/23/0021800494/202/f79ed0ea-efdc-6360-7792-b65fae927391_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543566837510489792",
    "name": "The 2974 Collection #2242",
    "imageUrl": "https://arweave.net/n7k3TbeVtSUwvkIQLCn3XPnc_LfnRqBoD8VKAfwB9hQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2243,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -128,
    "LOC_Y": 258,
    "GAME_DATE": 20181223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/23/0021800494/260/0e53bd56-9868-0327-4bfa-563810c48ed7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499486528503410183",
    "name": "The 2974 Collection #2243",
    "imageUrl": "https://arweave.net/eZ4xKy5Jaz3wk5bUWOtdYqJ_62-PSfpBXiqlKCfiquY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2244,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 81,
    "LOC_Y": 267,
    "GAME_DATE": 20181223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/23/0021800494/339/44b0257b-ef61-e680-3d4c-ca7dd30bc540_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/559985470895038297",
    "name": "The 2974 Collection #2244",
    "imageUrl": "https://arweave.net/bUlpQNFDc14GBU9fP8Zmmm3w4UWy_kFdlU3SHth-_OA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2245,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -108,
    "LOC_Y": 231,
    "GAME_DATE": 20181223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/23/0021800494/439/c02b37e2-c779-23bb-0c14-cbd75e38bf16_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357067684341607372",
    "name": "The 2974 Collection #2245",
    "imageUrl": "https://arweave.net/ScKbwe8sP_sKr00bK-2eY8I_S8nnR6s_w2TK9Fg94XE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2246,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 14,
    "GAME_DATE": 20181223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/23/0021800494/602/5ff64b7c-eb08-239c-8a3f-debdec16d418_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321444340176272239",
    "name": "The 2974 Collection #2246",
    "imageUrl": "https://arweave.net/viedcZR0TYY4LfpiYkqn4vhvOISpXP5Su3JTq4hciZA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2247,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -130,
    "LOC_Y": 226,
    "GAME_DATE": 20181223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/23/0021800494/669/f893b31c-b982-a819-6d3b-870c9497d7cd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479175010098813339",
    "name": "The 2974 Collection #2247",
    "imageUrl": "https://arweave.net/D4_yPQQx6_osmyyUDNPhzDwCwsd7syCnuc3b3npRgfA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 12,
    "Day": 23,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2248,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 24,
    "LOC_Y": 263,
    "GAME_DATE": 20181225,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/25/0021800500/431/8c871416-ef51-ac06-53e6-e031ad59b5b8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417528146166040972",
    "name": "The 2974 Collection #2248",
    "imageUrl": "https://arweave.net/5aswS8Fuj8ZzopamMpUAKvHQQ3ennaEqFcDbNtsZjV0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "Christmas",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2249,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": 19,
    "GAME_DATE": 20181225,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/25/0021800500/434/ea4c0626-683f-cfe7-865a-682e690a9808_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575092811079329068",
    "name": "The 2974 Collection #2249",
    "imageUrl": "https://arweave.net/ueeBRNWNwgL7pLInvr4cqUAUQwT_pVbS5gH6Si0okss?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2018,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "Christmas",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2250,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -143,
    "LOC_Y": 215,
    "GAME_DATE": 20181227,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/27/0021800516/214/295eebad-e3f1-0173-8d68-695aa5377ce4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367410720755487523",
    "name": "The 2974 Collection #2250",
    "imageUrl": "https://arweave.net/0EDLZkY6V1tf5cHjVBF2qMYEja3hKI48c-pNUig4Zz0?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2251,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -60,
    "LOC_Y": 253,
    "GAME_DATE": 20181227,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/27/0021800516/229/7661dc0b-d942-ffca-84cf-2569e66bdd0d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404817610613127014",
    "name": "The 2974 Collection #2251",
    "imageUrl": "https://arweave.net/TcJzi_DZ_OKSjyUo1jnvaHq0t3Hix2jqFLT4t2NEbaA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2252,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": -136,
    "LOC_Y": 293,
    "GAME_DATE": 20181227,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/27/0021800516/396/fb00ced2-bf1d-c875-c009-4de9ce804eff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495643002252392915",
    "name": "The 2974 Collection #2252",
    "imageUrl": "https://arweave.net/8tfa0EcyAhAShcb1EBIItJLyZ0n9g3XL6k4ljN-Cw5s?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2253,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -145,
    "LOC_Y": 283,
    "GAME_DATE": 20181227,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/27/0021800516/542/265385e1-efd8-100b-0f81-7f9c1839855f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338794870215507678",
    "name": "The 2974 Collection #2253",
    "imageUrl": "https://arweave.net/ieCh-TqVIn0SUDjFWCXkDzqWnX90098H9NepAMRnmCg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2254,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 207,
    "LOC_Y": 147,
    "GAME_DATE": 20181227,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/27/0021800516/650/45f11f65-0ef5-ef19-5622-519790e2dc29_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550372937276808828",
    "name": "The 2974 Collection #2254",
    "imageUrl": "https://arweave.net/i5wunqvG73-_T1kdr5gf6lxmQ4Qny5JjEG41hko2oZ0?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2255,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 201,
    "LOC_Y": 170,
    "GAME_DATE": 20181227,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/27/0021800516/677/4a5ae0f2-75d6-84f1-42f9-f3feae3b2bb2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/398510929581595524",
    "name": "The 2974 Collection #2255",
    "imageUrl": "https://arweave.net/gnDjrrXvWAN355T6VGI464SaLgg_gEEpwA5f_MXrH5M?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2256,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -180,
    "LOC_Y": 187,
    "GAME_DATE": 20181229,
    "Season": "2018-2019",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/29/0021800534/167/6cf57d54-f982-f369-1e72-5bf9b765f0c2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550225172262795644",
    "name": "The 2974 Collection #2256",
    "imageUrl": "https://arweave.net/gh15Y_z3_VsbxvNH9coBW4HnIi8QwTK1_V6SuAUN0Eg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2257,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -188,
    "LOC_Y": 169,
    "GAME_DATE": 20181229,
    "Season": "2018-2019",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/29/0021800534/334/a42e657e-132b-8728-b696-2207fdbeaabe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420756519889329534",
    "name": "The 2974 Collection #2257",
    "imageUrl": "https://arweave.net/JhPJfRqHtln-RrWx7w2Ynx8ekwxxnU_tCzYO-yiEEQs?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2018,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2258,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -188,
    "LOC_Y": 166,
    "GAME_DATE": 20181231,
    "Season": "2018-2019",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/31/0021800548/181/b799daca-c95f-e4e7-e2df-78efbde94309_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/292141012885554695",
    "name": "The 2974 Collection #2258",
    "imageUrl": "https://arweave.net/hZunPmDLuDAlKnz2HSSy55sVRTukIMGpIzrRrLdT0ro?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2259,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 24,
    "LOC_Y": 259,
    "GAME_DATE": 20181231,
    "Season": "2018-2019",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/31/0021800548/355/01811d85-c40e-ed58-70b9-ac9342e0cffd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395088513966056335",
    "name": "The 2974 Collection #2259",
    "imageUrl": "https://arweave.net/O0JDjOc5Nr8m5fE8h3qukYt3gl4B_dZqR6FZFxau8JE?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2260,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 82,
    "LOC_Y": 238,
    "GAME_DATE": 20181231,
    "Season": "2018-2019",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/31/0021800548/551/d0ca72eb-d424-c81b-d99a-a649d12b17cd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/416355274857438989",
    "name": "The 2974 Collection #2260",
    "imageUrl": "https://arweave.net/xeiXXw5LATCEnl4-QLt5jd2IQUU8SS7SKdkWp1v-v2k?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2261,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": 31,
    "GAME_DATE": 20181231,
    "Season": "2018-2019",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/31/0021800548/567/8530aa58-c856-a6de-3bb3-02446497840b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499097589614176035",
    "name": "The 2974 Collection #2261",
    "imageUrl": "https://arweave.net/I2ljIQliiZaMm_PJdP2Y2psPOZrgzqTha96h8WgQ0L0?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2262,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": 29,
    "GAME_DATE": 20181231,
    "Season": "2018-2019",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2018/12/31/0021800548/595/8736c688-36cd-689b-d2c9-d363283b53b2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552795101110126682",
    "name": "The 2974 Collection #2262",
    "imageUrl": "https://arweave.net/mzNu_RMPNUgTOfkltdYvur-lfw89sHt1cQvh0u-1P-g?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2018,
    "Month": 12,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2263,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -219,
    "LOC_Y": 143,
    "GAME_DATE": 20190103,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/03/0021800565/202/209696ec-22db-b0f0-763d-831bf271ceb6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402290627767349530",
    "name": "The 2974 Collection #2263",
    "imageUrl": "https://arweave.net/ljE3U2gmuuTIH3wzd9mtrtTVe1lRTeI2nKAI65CQGI4?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2264,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -120,
    "LOC_Y": 290,
    "GAME_DATE": 20190103,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "None",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531692509327786396",
    "name": "The 2974 Collection #2264",
    "imageUrl": "https://arweave.net/TSSekppN10Di-zmOuh3Li81k28YOZhvvuR0LJwRDdEc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2265,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 27,
    "GAME_DATE": 20190103,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/03/0021800565/384/7f21276a-54be-c9a0-2c64-5322d3756411_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/452622942119838548",
    "name": "The 2974 Collection #2265",
    "imageUrl": "https://arweave.net/SPFFLgCSCyJBNiFHcneVpL8c3FQaX-Yy9gAtR1kxcvE?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2266,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -190,
    "LOC_Y": 204,
    "GAME_DATE": 20190103,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/03/0021800565/424/6a325392-1ba8-d9d3-b445-aad355109542_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/306098462453412670",
    "name": "The 2974 Collection #2266",
    "imageUrl": "https://arweave.net/o4vWEU_8N5I5Q4U28cs6Zqu_jIbdPeIeTYR7undT2UY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2267,
    "PERIOD": 5,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": -7,
    "GAME_DATE": 20190103,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/03/0021800565/675/78a6f993-28e3-cb9e-7ef3-ab6b88bfcbb2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543817319469438304",
    "name": "The 2974 Collection #2267",
    "imageUrl": "https://arweave.net/V7rk9eXCuv9LCacXNrnvSxRtkAeEbkmAaA9DR8xTljg?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2268,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -177,
    "LOC_Y": 178,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/34/445a10c1-21c0-d482-185e-a669d79c3f71_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/470286490110251466",
    "name": "The 2974 Collection #2268",
    "imageUrl": "https://arweave.net/vdpXKDuj2fFA-fp4Qb-rtoY4m9AMM6lkhNFpz8vhyLw?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2269,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 188,
    "LOC_Y": 169,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/87/b64aed90-16fd-d379-85d8-2f8c89d197ed_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552892222110314559",
    "name": "The 2974 Collection #2269",
    "imageUrl": "https://arweave.net/RCwb3cGKhEgP3jDkMPAlKyFhuIc22MuLakuXQi5srYY?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2270,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -6,
    "LOC_Y": 274,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/95/8a667acf-e3f6-7394-1257-7a0b58966de3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374798643305035052",
    "name": "The 2974 Collection #2270",
    "imageUrl": "https://arweave.net/opZ8dYEaALQedMfwsrWFou5TBnoc7ELAD8EIgeLnG4I?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2271,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -161,
    "LOC_Y": 202,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/235/b4cb19af-b26c-87a6-6ba7-1a85478a45bc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359815080340679210",
    "name": "The 2974 Collection #2271",
    "imageUrl": "https://arweave.net/Bx0P9IDODCA4o_IXeWm9Ze4zYAgARvCSkXCwTVkAmSY?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2272,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -116,
    "LOC_Y": 224,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/333/2db17953-89d6-9ecf-914f-a98fa4139421_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495123472743890472",
    "name": "The 2974 Collection #2272",
    "imageUrl": "https://arweave.net/ssDm_DV-Ol-bETiPfY3EcX8zkLQTXWwDLaIHm27jSYQ?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2273,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 181,
    "LOC_Y": 173,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/353/5dccd7a1-3386-04d0-f9e0-c4c9b8d5466b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/538545273655294609",
    "name": "The 2974 Collection #2273",
    "imageUrl": "https://arweave.net/AUcDHAiNuQ_5peFdaFPa7SKp4lJKxtG0zr_hGuHGxaY?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2274,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 30,
    "LOC_Y": 243,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/485/b523a7f5-68fd-3129-1a98-61aa3984404f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567420201688359136",
    "name": "The 2974 Collection #2274",
    "imageUrl": "https://arweave.net/anxUl-YuX2GiKZNxoJCVB1habCCOjrXBN02nFQMidoI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2275,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -57,
    "LOC_Y": 264,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/542/79293ff4-a661-3b85-00b7-5e4976b8dd70_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367756693843493083",
    "name": "The 2974 Collection #2275",
    "imageUrl": "https://arweave.net/dOhAX88ii-aDjP2K8FYDMhfr9CCdRRBQctYLgDSWuts?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2276,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 84,
    "LOC_Y": 247,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/575/027050dc-d5da-eac4-3101-30754ffd8a84_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411862856603213563",
    "name": "The 2974 Collection #2276",
    "imageUrl": "https://arweave.net/R2HPMCFaPBwq-UOw0KA2fnwtAZGeAulmW3UVYkl3LHU?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2277,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 149,
    "LOC_Y": 231,
    "GAME_DATE": 20190105,
    "Season": "2018-2019",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/05/0021800583/604/cc79812d-31cb-ccd2-0a10-c61d57af9616_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500644667056053293",
    "name": "The 2974 Collection #2277",
    "imageUrl": "https://arweave.net/BFX2s_ajSrkqtKEQ2hRtcFZ88wn3Ej5hCNpmRmvXL6I?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 1,
    "Day": 5,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2278,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Turnaround Fadeaway shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 57,
    "GAME_DATE": 20190108,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/08/0021800605/45/4ccc443a-e8c3-7d4c-1d79-73828b0b97e4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392733964074987673",
    "name": "The 2974 Collection #2278",
    "imageUrl": "https://arweave.net/Z-yF9XTa8jUT3VYs53DsotB7oc1-k_4GJ9RN04XVX5Y?ext=png",
    "Opposing Team City": "New York",
    "Year": 2019,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2279,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -9,
    "LOC_Y": 275,
    "GAME_DATE": 20190108,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/08/0021800605/190/4c1d29fd-1b91-82b5-a019-3856c9a23e7c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/445435721604078889",
    "name": "The 2974 Collection #2279",
    "imageUrl": "https://arweave.net/AAPrHPim2Ahd0YYTOV7oMuf1PcJZaQeEqj4LEuwQQRk?ext=png",
    "Opposing Team City": "New York",
    "Year": 2019,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2280,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Turnaround Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 166,
    "LOC_Y": 217,
    "GAME_DATE": 20190108,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/08/0021800605/301/7a45cca7-49f6-d118-c9b8-a726436838c6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/288727706825220083",
    "name": "The 2974 Collection #2280",
    "imageUrl": "https://arweave.net/STHt4p6diiERtAghCjVprG6OnhmTEyCRGUsDiO3CWA0?ext=png",
    "Opposing Team City": "New York",
    "Year": 2019,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2281,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -188,
    "LOC_Y": 198,
    "GAME_DATE": 20190111,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/11/0021800629/261/046b33bd-09da-8a82-298e-7de38f89b656_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381374160898099001",
    "name": "The 2974 Collection #2281",
    "imageUrl": "https://arweave.net/fsnQqCi_4M--Sq7BrYARsaSyKEIWnfrpm7UXUlDCbZk?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2019,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2282,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 168,
    "LOC_Y": 221,
    "GAME_DATE": 20190111,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/11/0021800629/351/cf5c0dd0-ca66-cd4b-b5cd-ee6fde448bfb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/564626540180238629",
    "name": "The 2974 Collection #2282",
    "imageUrl": "https://arweave.net/5xwmRiU9_Z6NT5NJM7-wS-zUkj8Hc815Qf8TXVToQ7k?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2019,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2283,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 212,
    "LOC_Y": 153,
    "GAME_DATE": 20190111,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/11/0021800629/356/bdac7ef1-1fdc-7588-3bc9-a261369426e3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368977247468691834",
    "name": "The 2974 Collection #2283",
    "imageUrl": "https://arweave.net/deqoqpm9v9J_RCXcS261O0uERNxNHFiGaVp1rlrcc84?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2019,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2284,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 124,
    "LOC_Y": 254,
    "GAME_DATE": 20190111,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/11/0021800629/370/4780bd91-2fdc-05b1-209b-2dba7c81d4c7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321356227743877857",
    "name": "The 2974 Collection #2284",
    "imageUrl": "https://arweave.net/vC6aj7mRkVuCXUFJe24qhWAsg5f-UighrLB86aeSm88?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2019,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2285,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 228,
    "LOC_Y": 52,
    "GAME_DATE": 20190111,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/11/0021800629/478/397e454d-d6ec-c0a2-0c84-6e817d06a804_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/464001132366041296",
    "name": "The 2974 Collection #2285",
    "imageUrl": "https://arweave.net/3RPSZ9kOwGQ3q4oHrL3MAZYAMCdOLQtXxufcJ45DPQY?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2019,
    "Month": 1,
    "Day": 11,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2286,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 95,
    "LOC_Y": 239,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/41/fbcf94ab-cc2f-709f-71eb-b5e4bfed983c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324997745476009461",
    "name": "The 2974 Collection #2286",
    "imageUrl": "https://arweave.net/reBJhbXE12SpAF6LOJx-vmFgbFkiBz6E9gqHuYAfmIg?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2287,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 221,
    "LOC_Y": 30,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/55/d38c7bc8-4a68-7d4d-9a87-bd6c253cbdc5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289632889501059962",
    "name": "The 2974 Collection #2287",
    "imageUrl": "https://arweave.net/aaCKqQH3IL2_3jk9nB3eWsjSFKxQw_vudUdYiOC20Iw?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2288,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -59,
    "LOC_Y": 246,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/104/f1b86914-8d82-e1f6-f298-3934915e95a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456030954795093605",
    "name": "The 2974 Collection #2288",
    "imageUrl": "https://arweave.net/jU10a2bB1iOZt5kIin589bdiJIKrWbHUrjyLnH25RYA?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2289,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 71,
    "LOC_Y": 243,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/129/806449c0-a71e-2381-f22b-5bad4e05752b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/292927784353871424",
    "name": "The 2974 Collection #2289",
    "imageUrl": "https://arweave.net/8s73chYcHGudxNxTrKixPv5hzFKfqV-_9hVsukefjYw?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2290,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 20,
    "LOC_Y": 252,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/301/334b6d7f-83f3-f6e8-4b56-4e81dae14f65_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/350585098424281368",
    "name": "The 2974 Collection #2290",
    "imageUrl": "https://arweave.net/_hiNbgzStL4igApIsmpadPznGIB3i_t6MtQwW2BBuGg?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2291,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -191,
    "LOC_Y": 207,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/349/0634ed5f-fe25-981b-c691-099c202a400b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446532347338330454",
    "name": "The 2974 Collection #2291",
    "imageUrl": "https://arweave.net/KLO_o6cDiKOE9xQ1yv6BpSlc-ABufY0zKIZt4t1zznA?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2292,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -188,
    "LOC_Y": 167,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/378/11bd6733-813c-639a-9b80-d42c027502f5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391073976416177167",
    "name": "The 2974 Collection #2292",
    "imageUrl": "https://arweave.net/6o8KpARt_0bNOm0wOWQ4U--DeCiu9KGedQs46tSaCzs?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2293,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 184,
    "LOC_Y": 167,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/446/cf8455f4-61c5-9e71-aacc-11a0a2f8621c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/573904483439238998",
    "name": "The 2974 Collection #2293",
    "imageUrl": "https://arweave.net/CXXGylVATDfmFtVAmwuV12TsrHoEXA8IEjbQ98Qd524?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2294,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 216,
    "LOC_Y": 126,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/568/89f75f8b-cb94-5a81-4ccb-920a005f1a9d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406218795783382987",
    "name": "The 2974 Collection #2294",
    "imageUrl": "https://arweave.net/MqDEEKT7z2T8Ay3jejiY-RhSiNKBuHYC8i7AzsfX3KA?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2295,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -223,
    "LOC_Y": 123,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/609/2068f6cd-2f51-0e39-5258-0e4f141e41ff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548386501019051031",
    "name": "The 2974 Collection #2295",
    "imageUrl": "https://arweave.net/u6r-e9RzRMz6CQyR0Ry5-3aiIDRXRjGCCfWH5hW1H5A?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2296,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 38,
    "LOC_Y": 272,
    "GAME_DATE": 20190113,
    "Season": "2018-2019",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/13/0021800642/654/88e4b480-76b2-6225-e4c5-1766f701c0b0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349218402084535426",
    "name": "The 2974 Collection #2296",
    "imageUrl": "https://arweave.net/6A4hqDV-CmXfqljlc1ZAG3hJWALEvwDqtgx1jwKKBYk?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2019,
    "Month": 1,
    "Day": 13,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2297,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -215,
    "LOC_Y": 114,
    "GAME_DATE": 20190115,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/15/0021800655/25/b5425c23-7fbd-b782-73dd-dc4091819455_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309109440446539053",
    "name": "The 2974 Collection #2297",
    "imageUrl": "https://arweave.net/zamBBBFrP0oHe0uqEoBCBL-Mgh90QnC1joJYtNyH3Mo?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2298,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": -11,
    "GAME_DATE": 20190115,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/15/0021800655/59/6112481a-a2e6-d242-416d-3516065c7278_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/408343511442263277",
    "name": "The 2974 Collection #2298",
    "imageUrl": "https://arweave.net/rlfE2HTXy8vTz5COb-oUWblVodk1Ebz6p1nDMDy4Jfw?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2299,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -78,
    "LOC_Y": 261,
    "GAME_DATE": 20190115,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/15/0021800655/95/a1308553-8057-08d7-8501-14e6298c6c0a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504366506239358969",
    "name": "The 2974 Collection #2299",
    "imageUrl": "https://arweave.net/pbXI2ne2SgokL2pPkJcinWoPKDTr3FyEyF7jae6_J40?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2300,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -199,
    "LOC_Y": 135,
    "GAME_DATE": 20190115,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/15/0021800655/131/42609e2b-b9cc-1086-7afc-7720aef4d8a3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331429299388486664",
    "name": "The 2974 Collection #2300",
    "imageUrl": "https://arweave.net/49rj-DdiylVuT1AwjY7MeGm2SQp-nejLvv2lqGeb7O4?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2301,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 227,
    "LOC_Y": 32,
    "GAME_DATE": 20190115,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/15/0021800655/360/db283d51-b10f-3d74-806e-b1fcdf873f35_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404209991357510503",
    "name": "The 2974 Collection #2301",
    "imageUrl": "https://arweave.net/HbJN4p-MJ9QJZcKE_Pz77QLeccz8ePy1ZwLrVDEJ9og?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2302,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 199,
    "LOC_Y": 139,
    "GAME_DATE": 20190115,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/15/0021800655/438/3dfee360-bd3a-fa74-8c5e-12a8bdda3416_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/376101651058068074",
    "name": "The 2974 Collection #2302",
    "imageUrl": "https://arweave.net/yENqrufFa651GG0P0hbd4rv_4c1GMeEJJkieoPYOS7c?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2303,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -172,
    "LOC_Y": 254,
    "GAME_DATE": 20190115,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/15/0021800655/449/7fbf589e-7a07-8d9f-931e-f090b35155d0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361536044478356192",
    "name": "The 2974 Collection #2303",
    "imageUrl": "https://arweave.net/afum_TyB1TYLeA1OEzpnFtGFGF6wVgLWkNc6aHdeEU0?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2304,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 112,
    "LOC_Y": 275,
    "GAME_DATE": 20190115,
    "Season": "2018-2019",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/15/0021800655/458/f815fe04-1ce2-2f23-082b-13cd7a9fd21c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/477338672779824435",
    "name": "The 2974 Collection #2304",
    "imageUrl": "https://arweave.net/A1JJpOmzlSeFZDeWwi0P10N07ZPRs6x3dmIkTAGOFGA?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 1,
    "Day": 15,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2305,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 74,
    "LOC_Y": 272,
    "GAME_DATE": 20190116,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/16/0021800663/67/96e8c84c-54ee-c01a-e593-ff860e2a6c11_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415814953501372021",
    "name": "The 2974 Collection #2305",
    "imageUrl": "https://arweave.net/JTLRDRxewN7cBVglKUrdPHFeqtuPAsNJvw2ZDkg0v6I?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2306,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 147,
    "LOC_Y": 253,
    "GAME_DATE": 20190116,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/16/0021800663/258/81d40c7f-3de8-f14e-2c55-201dd679842d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508600037826800527",
    "name": "The 2974 Collection #2306",
    "imageUrl": "https://arweave.net/1Whjn3Hv8J_eOCU4X2WgE2mK2RFcnhMJIjxJb0kDcTg?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2307,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 100,
    "LOC_Y": 245,
    "GAME_DATE": 20190116,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/16/0021800663/431/5c922eee-93c2-5cfb-e4bd-c485a46d1968_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439889963592539290",
    "name": "The 2974 Collection #2307",
    "imageUrl": "https://arweave.net/hKunPUDq2eyRUc49G2XC2KpEpghcGV1ssrtVvnbXlP4?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2308,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -150,
    "LOC_Y": 209,
    "GAME_DATE": 20190116,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/16/0021800663/491/f6a875fa-8c6c-80c8-210f-9e243d255d2e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450904997496879458",
    "name": "The 2974 Collection #2308",
    "imageUrl": "https://arweave.net/KypjHyjvafYLtWnJNU66AtTPafgOlT7-FcjG2VxMxK4?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2309,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 106,
    "LOC_Y": 226,
    "GAME_DATE": 20190116,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/16/0021800663/506/f8d7b2d6-6163-d156-f199-176cd9bc4d4f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309713604935675484",
    "name": "The 2974 Collection #2309",
    "imageUrl": "https://arweave.net/zSGoSyTSNk1u1RiP4n-ufta5Tq_unSGguN_filSwCZc?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2310,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -150,
    "LOC_Y": 211,
    "GAME_DATE": 20190116,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/16/0021800663/510/6053bea8-f372-1d22-0c55-019acdcb85ff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/555219336979374387",
    "name": "The 2974 Collection #2310",
    "imageUrl": "https://arweave.net/Ovf0ZEfznpcQ_JIWj_oHS5XpuoO59iGA7amIPQzR_eY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2311,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 110,
    "LOC_Y": 253,
    "GAME_DATE": 20190116,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/16/0021800663/522/abcaed2a-2856-6c7a-536a-4e1f9140b443_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/571091522049996033",
    "name": "The 2974 Collection #2311",
    "imageUrl": "https://arweave.net/s1bd1KPz0D3WdxLY-2JXSxFdOF6f2p-YFvvSPG_eZZc?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2312,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 17,
    "LOC_Y": 277,
    "GAME_DATE": 20190116,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/16/0021800663/524/d6836f04-702b-184d-246c-ce04063ca847_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552880035324429458",
    "name": "The 2974 Collection #2312",
    "imageUrl": "https://arweave.net/wj_Z00vpre6aMM8IuQbpmekGl0PQGWHtMKzJo9Ng6XI?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2313,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 67,
    "LOC_Y": 303,
    "GAME_DATE": 20190116,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/16/0021800663/536/e700a7cf-ebaa-a981-9195-f6318a55645d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547033731195871103",
    "name": "The 2974 Collection #2313",
    "imageUrl": "https://arweave.net/xQVInK16x2eYBkDBJ_ii00mnS6Lbw-1CV8J9pv5OMdU?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 1,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2314,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -128,
    "LOC_Y": 216,
    "GAME_DATE": 20190118,
    "Season": "2018-2019",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/18/0021800676/48/484aba4c-25d5-d572-f679-376dd973f26d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/315429892853456833",
    "name": "The 2974 Collection #2314",
    "imageUrl": "https://arweave.net/dSDgEpGIDj66lxRYdTnXuHf3m5A10_wWSrUfWjgiDGE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2315,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -235,
    "LOC_Y": 22,
    "GAME_DATE": 20190118,
    "Season": "2018-2019",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/18/0021800676/85/3b428e00-5e90-a88c-d7d7-d35e18f6c181_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400356618254444070",
    "name": "The 2974 Collection #2315",
    "imageUrl": "https://arweave.net/h85zR0zF2WJJPuhUaef1Msnj3Aj0DCZZFUQrRBodSO8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2316,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -202,
    "LOC_Y": 221,
    "GAME_DATE": 20190118,
    "Season": "2018-2019",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/18/0021800676/310/ccafda9b-e7be-0921-ce92-50b693666d73_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575508057484060345",
    "name": "The 2974 Collection #2316",
    "imageUrl": "https://arweave.net/L7G_29-S2jpopD90JC0Z_1_MN9fyT6J7iv744ZIRXh8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2317,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -163,
    "LOC_Y": 239,
    "GAME_DATE": 20190121,
    "Season": "2018-2019",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/21/0021800701/111/befcc2b0-e1cf-e531-6fdd-051e5b3d3f0a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289361629421161581",
    "name": "The 2974 Collection #2317",
    "imageUrl": "https://arweave.net/CCAiWaqB0kPmPNopzFYF4tCo7oMVS4Df9aIYcvVcMsc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2318,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 0,
    "GAME_DATE": 20190121,
    "Season": "2018-2019",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/21/0021800701/426/efcc7664-ff6d-3d22-758e-e2b36b7257c8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/349342431085160780",
    "name": "The 2974 Collection #2318",
    "imageUrl": "https://arweave.net/EnU-e0anXWBUxPIh48Aj031wLg9OuXgzHwAeeWnQIJM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2319,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -167,
    "LOC_Y": 210,
    "GAME_DATE": 20190124,
    "Season": "2018-2019",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/24/0021800716/298/babbc78b-7a54-826f-f560-d9c0adb15651_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341809546327061895",
    "name": "The 2974 Collection #2319",
    "imageUrl": "https://arweave.net/LqNYFC4iJsL-XRmI_M1bkKOJWmaBiwjF0Uy_fij2a1U?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2019,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2320,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -229,
    "LOC_Y": -2,
    "GAME_DATE": 20190124,
    "Season": "2018-2019",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/24/0021800716/353/face92aa-76c2-a63f-54bd-d75d6d0b285f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378041674508918427",
    "name": "The 2974 Collection #2320",
    "imageUrl": "https://arweave.net/uX9VNBzvqZZlzTn0IpnXSRY9OxASbXqC1D7TNEC9Xys?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2019,
    "Month": 1,
    "Day": 24,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2321,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 217,
    "LOC_Y": 153,
    "GAME_DATE": 20190126,
    "Season": "2018-2019",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/26/0021800732/190/4a86e275-0b47-94a6-96eb-e28e8f0243f0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459709541070099822",
    "name": "The 2974 Collection #2321",
    "imageUrl": "https://arweave.net/MiUgqmJEmgwhZkMOzdh0_JyUTKGzDBUDpEm1E_Wq3RY?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2322,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 240,
    "LOC_Y": 64,
    "GAME_DATE": 20190126,
    "Season": "2018-2019",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/26/0021800732/194/0ec64359-60d6-6124-20be-6fc5d0c9cf32_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562931373038187549",
    "name": "The 2974 Collection #2322",
    "imageUrl": "https://arweave.net/S-j80LgR3XCH2lH-hX0xzwOsW8G0CslSzIgrrFKmwjU?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2323,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -211,
    "LOC_Y": 135,
    "GAME_DATE": 20190126,
    "Season": "2018-2019",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/26/0021800732/207/5750ae25-0639-51c6-3eb3-444386587f66_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417737654109849247",
    "name": "The 2974 Collection #2323",
    "imageUrl": "https://arweave.net/2ZdNvur-g_SDBAuVIonceOJPXYr-oI6ucdf3qEapyzA?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2324,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 187,
    "LOC_Y": 192,
    "GAME_DATE": 20190126,
    "Season": "2018-2019",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/26/0021800732/211/c499ad87-1049-9c37-a06e-142611177e36_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418618025481910082",
    "name": "The 2974 Collection #2324",
    "imageUrl": "https://arweave.net/YvFpaSIIUok6FGfmDgdwCC8m17qiZ2cbg6rUEwSHDWA?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2325,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -187,
    "LOC_Y": 177,
    "GAME_DATE": 20190126,
    "Season": "2018-2019",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/26/0021800732/246/29a657ca-53a5-e901-3446-d07d80ff2a40_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/449915586563421891",
    "name": "The 2974 Collection #2325",
    "imageUrl": "https://arweave.net/fmh-boMw5UHdwucTGJofXr5x5h1PXAIpd3Pg-kEVY5w?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2326,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 189,
    "LOC_Y": 185,
    "GAME_DATE": 20190126,
    "Season": "2018-2019",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/26/0021800732/383/a15b7fd6-ed96-039f-1a30-2993e03cd063_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/365495777466641177",
    "name": "The 2974 Collection #2326",
    "imageUrl": "https://arweave.net/r8fxSCP2FV9m2alcLPuTFo7hOE7UdEoaiFD0miF1cuc?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 1,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2327,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 226,
    "LOC_Y": 132,
    "GAME_DATE": 20190128,
    "Season": "2018-2019",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/28/0021800745/88/6535cfa4-89a0-ef72-8b6f-e9b8f4c94cc9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374566173745455719",
    "name": "The 2974 Collection #2327",
    "imageUrl": "https://arweave.net/fPV_OvRSNiavD0M73BsxK_miaM8cvKPiswTYwb733ZA?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2328,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -227,
    "LOC_Y": -25,
    "GAME_DATE": 20190128,
    "Season": "2018-2019",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/28/0021800745/94/a53dd516-1484-d38a-488e-20f9ecbd7318_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/442653636243992607",
    "name": "The 2974 Collection #2328",
    "imageUrl": "https://arweave.net/FpRtOEYhoTd1jfHv6THldWbnOgdM8dqTur7fzT8QSS8?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2329,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -177,
    "LOC_Y": 209,
    "GAME_DATE": 20190128,
    "Season": "2018-2019",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/28/0021800745/263/53964588-2d62-3d6f-8ecd-4e07f0c93416_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/398042045965097040",
    "name": "The 2974 Collection #2329",
    "imageUrl": "https://arweave.net/l2jBzuzbHe2xRx-yxUIMYynNACB531U03LaEQk6czr0?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2330,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": -23,
    "GAME_DATE": 20190128,
    "Season": "2018-2019",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/28/0021800745/297/242cb09d-e928-0542-8e4b-f9bdb6f34fce_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341211197732100072",
    "name": "The 2974 Collection #2330",
    "imageUrl": "https://arweave.net/_8XQ24cdm-osSUqqLF25EUDb56r0NjqGMx-0yseAGjU?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2331,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -125,
    "LOC_Y": 234,
    "GAME_DATE": 20190128,
    "Season": "2018-2019",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/28/0021800745/334/fdb6ae50-001a-a724-4829-c0721c25cb5c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352529023490016135",
    "name": "The 2974 Collection #2331",
    "imageUrl": "https://arweave.net/SyKwdQvRhcuZhUpbGzM2F2B7VMLY53R79JDXt04F0XQ?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2332,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -177,
    "LOC_Y": 216,
    "GAME_DATE": 20190128,
    "Season": "2018-2019",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/28/0021800745/437/90a7b825-eabc-82a5-5820-cae34860e961_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385044772216084112",
    "name": "The 2974 Collection #2332",
    "imageUrl": "https://arweave.net/s4cdcP6SQcp0SqBCtoh0LEad3FixXkYiIqnRmVU818c?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2333,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 176,
    "LOC_Y": 207,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/72/bcd9314a-8c41-b6cd-1cf0-663771c0c309_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/361163791409353485",
    "name": "The 2974 Collection #2333",
    "imageUrl": "https://arweave.net/rjMGU3NTRN7LAUR2P-V6qdGgZGSgoOuk2D-pIeV4XXk?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2334,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 190,
    "LOC_Y": 206,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/84/ad417787-a150-aa62-bf3b-bc443808935b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433928671661752616",
    "name": "The 2974 Collection #2334",
    "imageUrl": "https://arweave.net/H4LH_BHrVO261324qqXVGD-cnS4lBn1YDwK8WwXjJ18?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2335,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 193,
    "LOC_Y": 174,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/230/af0a51d0-3a06-47f0-019b-30be710671e5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565527339500634166",
    "name": "The 2974 Collection #2335",
    "imageUrl": "https://arweave.net/aGILcWs-Ng6Dy9xSZwjr5f1_IgUlICFVq6knMkcS18M?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2336,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -168,
    "LOC_Y": 267,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/274/ba14c8eb-8e40-35d7-a547-8ec538f3b69c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363128638945385100",
    "name": "The 2974 Collection #2336",
    "imageUrl": "https://arweave.net/qM7Ex_Y7sEalZWcHM8kdc412NB0B-GoASHDyO6-n1Lg?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2337,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -224,
    "LOC_Y": 107,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/293/c6e7c283-179d-7e22-d65c-59c6bb70e9b1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474511446396468081",
    "name": "The 2974 Collection #2337",
    "imageUrl": "https://arweave.net/PgPqowWpOZDzYZJTKdaODkPapjjeR63TphoKplQO9Uc?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2338,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 222,
    "LOC_Y": 113,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/311/ff6350fe-7b77-f9f5-dbad-8568792346ce_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379889524934880059",
    "name": "The 2974 Collection #2338",
    "imageUrl": "https://arweave.net/0nAKkiaPJY6DdBFiLzRQg2floUAXHgbIdolFuG2yRxY?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2339,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 144,
    "LOC_Y": 227,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/355/7a4c641f-b39b-2a00-cd5d-89ce204457f0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523309037903401577",
    "name": "The 2974 Collection #2339",
    "imageUrl": "https://arweave.net/G01ffqh4VwUEB9v6UGjut__sL0FcERmJNCBWgTKKQP0?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2340,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -69,
    "LOC_Y": 261,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/442/2656c698-710a-79f8-5de3-6c7b1775ecaf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/408892997212365163",
    "name": "The 2974 Collection #2340",
    "imageUrl": "https://arweave.net/byFV3pYQwi2Kw95GrI7jC8nR_TpD6J3IVIfpgFP1TLA?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2341,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -225,
    "LOC_Y": 0,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/659/e7ddea11-cefa-1271-8430-20711c537726_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500860826785219263",
    "name": "The 2974 Collection #2341",
    "imageUrl": "https://arweave.net/Vtyk0knSUCTZGk66lslCElyQ2TogErCSjprjh87LxY8?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2342,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -107,
    "LOC_Y": 239,
    "GAME_DATE": 20190131,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/01/31/0021800768/682/396c14d4-b59f-efd6-beaf-9fa6dd5ec523_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/513622627596029685",
    "name": "The 2974 Collection #2342",
    "imageUrl": "https://arweave.net/QEizQvcBVA1pUGBcuvIem4YEmyTEogmOoCL19poW1og?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 1,
    "Day": 31,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2343,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 175,
    "LOC_Y": 218,
    "GAME_DATE": 20190202,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/02/0021800782/604/b0c88cdd-558b-53e3-7d31-f30ff8fb9c7c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565831607837132869",
    "name": "The 2974 Collection #2343",
    "imageUrl": "https://arweave.net/GL5JefrhS9HedLzTOXwIMD6_ATv5cSG8MniuE2rwKwA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2344,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -196,
    "LOC_Y": 180,
    "GAME_DATE": 20190202,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/02/0021800782/612/956b3ca2-1416-0124-08ce-316e8ec736fa_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512653958055079552",
    "name": "The 2974 Collection #2344",
    "imageUrl": "https://arweave.net/0wkgmKNpdY1SO5mxuNB_SjM0ekF0UhevYtAGz6Zg0mw?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2345,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -226,
    "LOC_Y": 4,
    "GAME_DATE": 20190206,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/06/0021800810/320/b97e4794-fac2-5da9-8e42-2989e4f54987_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/371049389807668541",
    "name": "The 2974 Collection #2345",
    "imageUrl": "https://arweave.net/Evve-e5gCZnsxt-ltpKu4r5-VU2jqLwyz_g7Tb3n-y8?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2019,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2346,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 227,
    "LOC_Y": 33,
    "GAME_DATE": 20190206,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/06/0021800810/399/a6e2daf4-4588-d057-0ddb-6cbf8a5b0611_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498089852963649802",
    "name": "The 2974 Collection #2346",
    "imageUrl": "https://arweave.net/In4X7n8HKyCg8YfR_9BJsxN0z0pzSZUGBM2tEV8PyZs?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2019,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2347,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 194,
    "LOC_Y": 202,
    "GAME_DATE": 20190206,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/06/0021800810/504/a6f1b105-6c0a-63f4-0678-773010b3728c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/370927646970244787",
    "name": "The 2974 Collection #2347",
    "imageUrl": "https://arweave.net/BULiwna8inm5WxyqdwW_VwlPxidaJhjLMXPTTKF3nLI?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2019,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2348,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -211,
    "LOC_Y": 146,
    "GAME_DATE": 20190208,
    "Season": "2018-2019",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/08/0021800822/363/d2803938-3809-8b3e-484e-a467e6c7e3a6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296606357478902766",
    "name": "The 2974 Collection #2348",
    "imageUrl": "https://arweave.net/r5PTOIFawcvWBdk4Pq5l23Yd95-gOGWkOwRbawe5Yw0?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2019,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2349,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 131,
    "LOC_Y": 221,
    "GAME_DATE": 20190208,
    "Season": "2018-2019",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/08/0021800822/657/8151d669-69ea-5cc2-062f-93504c822ca8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566428881653139947",
    "name": "The 2974 Collection #2349",
    "imageUrl": "https://arweave.net/PYRDpG6SCEsWmZC7AmX_o30Bas2hykoCd2p2_T6CnV4?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2019,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2350,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 217,
    "LOC_Y": 107,
    "GAME_DATE": 20190208,
    "Season": "2018-2019",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/08/0021800822/682/685d566c-4832-c421-cc37-835f8624e37b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/553522920224895184",
    "name": "The 2974 Collection #2350",
    "imageUrl": "https://arweave.net/Dve1tHebFzGKzActc5FLNDjEoQz2NaaAmW4unNPFftk?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2019,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2351,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -172,
    "LOC_Y": 243,
    "GAME_DATE": 20190210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/10/0021800838/97/f93af932-7edc-7348-4e98-444d7a9ab398_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341837132328153741",
    "name": "The 2974 Collection #2351",
    "imageUrl": "https://arweave.net/7_h3UQXD0B8-JHwWUCgwWl2TfsHCQPSOfO7rtMLBNy4?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2019,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2352,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -12,
    "LOC_Y": 274,
    "GAME_DATE": 20190210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/10/0021800838/282/0e11611d-f52f-9a53-e852-5169730bc102_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541354068007837784",
    "name": "The 2974 Collection #2352",
    "imageUrl": "https://arweave.net/eI9S3QI4rOFRBr5ZIcuzcNvPQNXl0nGnQFumyCELu6c?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2019,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2353,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -3,
    "LOC_Y": 314,
    "GAME_DATE": 20190210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/10/0021800838/300/5cfe628e-21b0-0f89-0b37-2145fe0f74a9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/445113536313154385",
    "name": "The 2974 Collection #2353",
    "imageUrl": "https://arweave.net/95jCG2Phr6QfX6dkAJfBt4NItztq1RuSlWV4yFRz-gw?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2019,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2354,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -167,
    "LOC_Y": 208,
    "GAME_DATE": 20190210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/10/0021800838/358/3a29657e-7f07-8251-e336-aaa0664a0647_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366767370901313991",
    "name": "The 2974 Collection #2354",
    "imageUrl": "https://arweave.net/LOIBUByXXm9gmOVnUxolZKwzHuxge8CG6uQSZCTVM0w?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2019,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2355,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 12,
    "LOC_Y": 283,
    "GAME_DATE": 20190210,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/10/0021800838/479/f33d0a74-698e-cb51-81a5-0712c816c368_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546807359490371984",
    "name": "The 2974 Collection #2355",
    "imageUrl": "https://arweave.net/mB7TGJiYWUxLVL-ipk8UhY34TYs-1e-GpZnh5JfmPFQ?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2019,
    "Month": 2,
    "Day": 10,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2356,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -223,
    "LOC_Y": 103,
    "GAME_DATE": 20190212,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/12/0021800852/284/87bb61ba-ab52-cdba-7368-be036c172ff5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481823075299295277",
    "name": "The 2974 Collection #2356",
    "imageUrl": "https://arweave.net/4Fvg-QWbJ5KTUVf-rq4_p6bUcZ3VsW24IB22MQOcY50?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2019,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2357,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -162,
    "LOC_Y": 195,
    "GAME_DATE": 20190212,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/12/0021800852/289/66ea50bd-0681-706e-9a90-76c3606eebf3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508826395844716041",
    "name": "The 2974 Collection #2357",
    "imageUrl": "https://arweave.net/sagf6jXY-ZVT7iXQXCDWhn8pbkVzxgaxRoJQAsTWY40?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2019,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2358,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 46,
    "LOC_Y": 268,
    "GAME_DATE": 20190212,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/12/0021800852/366/3069f492-7379-3778-be8f-12c24df6be1d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295882772646558545",
    "name": "The 2974 Collection #2358",
    "imageUrl": "https://arweave.net/TOBqpvtI3HaTzFPjGS6BCl8mbmuqUUqKWU13-lLCHaI?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2019,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2359,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 206,
    "LOC_Y": 148,
    "GAME_DATE": 20190212,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/12/0021800852/598/afc22609-3cea-9bf0-723b-33a8b27404b5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/416976764804730582",
    "name": "The 2974 Collection #2359",
    "imageUrl": "https://arweave.net/LyjvtieHJEzgvBIZbuSGFA6skTUBgKdpR_zm9dt-wxs?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2019,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2360,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 141,
    "LOC_Y": 230,
    "GAME_DATE": 20190212,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/12/0021800852/602/61579bd1-529f-af20-6522-d658cf2b9c19_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474522654603800553",
    "name": "The 2974 Collection #2360",
    "imageUrl": "https://arweave.net/4r6LBxEg5QroDq97sYtfgrXAOn9HzUQffuUhSuP9Hs4?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2019,
    "Month": 2,
    "Day": 12,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2361,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -108,
    "LOC_Y": 237,
    "GAME_DATE": 20190213,
    "Season": "2018-2019",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/13/0021800862/51/6a76641f-9e34-183f-8e4c-1590eb95adb8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547710716345776670",
    "name": "The 2974 Collection #2361",
    "imageUrl": "https://arweave.net/hNS200LSNdop084jfquSrDRezLQvrjDnnLB_zuwoPoM?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2019,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2362,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -200,
    "LOC_Y": 137,
    "GAME_DATE": 20190213,
    "Season": "2018-2019",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/13/0021800862/316/0ec8146a-162b-9799-5521-58a1e1c4fee6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434599147093109417",
    "name": "The 2974 Collection #2362",
    "imageUrl": "https://arweave.net/CRXGGE9IjLcN0RaFo1KBT6I6aTjNy7ljTSFZMF7oLBY?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2019,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2363,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -221,
    "LOC_Y": 90,
    "GAME_DATE": 20190213,
    "Season": "2018-2019",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/13/0021800862/445/36dbfe6b-4221-630b-026c-7bc368f1ca3c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/452388289185787370",
    "name": "The 2974 Collection #2363",
    "imageUrl": "https://arweave.net/oFCTFiXYWedSXT3Q5cv3sdJRmFjzbZc6n8m5PHLnxPo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2019,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2364,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 78,
    "LOC_Y": 252,
    "GAME_DATE": 20190213,
    "Season": "2018-2019",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/13/0021800862/460/10d4d194-c150-d576-5bf6-91c69c828c7a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/509422238273136146",
    "name": "The 2974 Collection #2364",
    "imageUrl": "https://arweave.net/n1FW7RZFussSdnBQ2sN86FI4UWcF0A_oCQC3GuBbRns?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2019,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2365,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -133,
    "LOC_Y": 230,
    "GAME_DATE": 20190213,
    "Season": "2018-2019",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/13/0021800862/464/db861705-1a32-0027-b210-e9d72e8ceecd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/477075830528896156",
    "name": "The 2974 Collection #2365",
    "imageUrl": "https://arweave.net/2MUmmNbiFbbacuNfe4EbhuAw-rqxQ5YADIfUKeEYQYw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2019,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2366,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -192,
    "LOC_Y": 197,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/17/4b1e0107-394d-1ec4-da30-fb7291aaf781_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511204648660691663",
    "name": "The 2974 Collection #2366",
    "imageUrl": "https://arweave.net/RjKuNMiNR271wfHCj7b6hGxYcJ3BvJzOZU4042a4yqs?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2367,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 37,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/63/df5e894c-ba23-b350-60bf-dc324f28053b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352105596742851113",
    "name": "The 2974 Collection #2367",
    "imageUrl": "https://arweave.net/DAEa6r055fwMG_bYsvHbjOfWHLF1Y0BU7PBFJlc7RfE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2368,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 194,
    "LOC_Y": 209,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/131/5771e48f-06e8-bb56-46b0-9627c72ea0a2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411487225870613711",
    "name": "The 2974 Collection #2368",
    "imageUrl": "https://arweave.net/UntLh0wgBLNaEAeS3KaJLrwNen0psGNkoepYlFaTclE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2369,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 204,
    "LOC_Y": 178,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/311/9ccea3cc-d6b0-2d0c-cd4c-520f7fcc853e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296740539566782982",
    "name": "The 2974 Collection #2369",
    "imageUrl": "https://arweave.net/YM_x0X2wkAKhraT17emWiVqLHyt8Nf4iobKcIXVb-lU?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2370,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -207,
    "LOC_Y": 195,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/331/8c6cf7a4-f649-e1a8-55bd-ad17448e0182_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499749126288616411",
    "name": "The 2974 Collection #2370",
    "imageUrl": "https://arweave.net/QnHGUspMI5EaA9ZBWPXhFYJROpse9dbJx3U24awX10c?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2371,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 182,
    "LOC_Y": 195,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/432/81691456-d165-0c6b-f134-03b7972d8155_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404899543394894636",
    "name": "The 2974 Collection #2371",
    "imageUrl": "https://arweave.net/AFk1hf27iu9YC5va_nehd95M8wmf0GlzhVtaMyJRy5k?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2372,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 141,
    "LOC_Y": 227,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/520/9a945987-e927-a61a-de58-48117d3db504_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551056170189762695",
    "name": "The 2974 Collection #2372",
    "imageUrl": "https://arweave.net/INWBIrod2WJ4E3nuJluwQJEjq5lobBqcCjh7SVev3HE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2373,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -178,
    "LOC_Y": 193,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/645/3860c60d-8441-98b6-6de4-45cc0f64b792_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330312378291110925",
    "name": "The 2974 Collection #2373",
    "imageUrl": "https://arweave.net/Uwnv1Y22qvfAR79LLzFKwD-K1fu-Ln5YGE-zzjexs-8?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2374,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -40,
    "LOC_Y": 253,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/716/00aefec1-589f-bd9a-d363-6cf7f21049ff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/314459053045084854",
    "name": "The 2974 Collection #2374",
    "imageUrl": "https://arweave.net/31w30GvKAq7PFBS0qtcOvRzW5VMShD5w3a9c5Og61nk?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2375,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 147,
    "LOC_Y": 216,
    "GAME_DATE": 20190221,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/21/0021800871/725/f3e64da9-890e-4deb-4475-62e08f5025b9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/477063934567707413",
    "name": "The 2974 Collection #2375",
    "imageUrl": "https://arweave.net/Oy5xIITu5yTm4PL6Nse4zkybQAIboCkm6_HQD0lkIAE?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2019,
    "Month": 2,
    "Day": 21,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2376,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 179,
    "LOC_Y": 197,
    "GAME_DATE": 20190223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/23/0021800892/60/eb0d64de-3ac0-08bf-dce8-276b1b3d5b70_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/551428189174284594",
    "name": "The 2974 Collection #2376",
    "imageUrl": "https://arweave.net/qg1cdZfKMy3N4UXGe6ljtCZ8byMIwM4kzWsK_m_cOiA?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2377,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 220,
    "LOC_Y": 130,
    "GAME_DATE": 20190223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/23/0021800892/297/4ef2ba52-ebe9-6f7b-73b0-fe4177046d1d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568007694092719486",
    "name": "The 2974 Collection #2377",
    "imageUrl": "https://arweave.net/JYp4QsUIXj7uOKTseS3PL5iAIw3ZK_olzcfYJbjrNuU?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2378,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 107,
    "LOC_Y": 233,
    "GAME_DATE": 20190223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/23/0021800892/358/cdf433b9-7adc-1662-9899-842e546a6c26_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331879545878746871",
    "name": "The 2974 Collection #2378",
    "imageUrl": "https://arweave.net/dCZEROqIroh4Y8Gtd66XGhKogwlD1CgK4jiTYNne70k?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2379,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -6,
    "GAME_DATE": 20190223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/23/0021800892/454/23a63259-fcba-5f76-7d93-0cc52e01314a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403501187166475128",
    "name": "The 2974 Collection #2379",
    "imageUrl": "https://arweave.net/6pQwul17EjwTnwumHTcnm7hNOP8dmuCGU-HTk4XIw3M?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2380,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -233,
    "LOC_Y": -22,
    "GAME_DATE": 20190223,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/23/0021800892/668/a68cee44-a162-bfd4-b14c-ef034934d3e5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/350135245717956718",
    "name": "The 2974 Collection #2380",
    "imageUrl": "https://arweave.net/pjrz9Je4-TjGg-VeHzIz1sr8Tyik05ur-5nCf0UM4Mo?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2381,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 55,
    "LOC_Y": 273,
    "GAME_DATE": 20190225,
    "Season": "2018-2019",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/25/0021800897/261/2c88e2d8-eddf-6aca-4876-2618f580f185_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/451901295773107617",
    "name": "The 2974 Collection #2381",
    "imageUrl": "https://arweave.net/nGUNVncwmro4FCap7kLiAPouQc3-oj3bHJwgbSctwHA?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2019,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2382,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 43,
    "LOC_Y": 269,
    "GAME_DATE": 20190225,
    "Season": "2018-2019",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/25/0021800897/332/3ff9bcc3-6993-8caf-c3b3-a731cde2e82d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/549299603971774659",
    "name": "The 2974 Collection #2382",
    "imageUrl": "https://arweave.net/U5Ba5CryRXpOo8ZOnl0_KOenXvrlVdS2zjBnqdmL0Ls?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2019,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2383,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 119,
    "LOC_Y": 235,
    "GAME_DATE": 20190225,
    "Season": "2018-2019",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/25/0021800897/419/0f746271-5d19-4f05-1d37-80164fb29ad8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/344573110360777278",
    "name": "The 2974 Collection #2383",
    "imageUrl": "https://arweave.net/68owd_hfcm1REcQAXUp-uDJpFTr0SbxMndMqSX5bdOU?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2019,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2384,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -177,
    "LOC_Y": 212,
    "GAME_DATE": 20190225,
    "Season": "2018-2019",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/25/0021800897/677/1f065238-79de-a6ae-7298-8c9e8b0b10a4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366720487576022912",
    "name": "The 2974 Collection #2384",
    "imageUrl": "https://arweave.net/00w5kV9oXutT5MuiZdKptpknyvy2YLFWA-pAjZeChBU?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2019,
    "Month": 2,
    "Day": 25,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2385,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 108,
    "LOC_Y": 230,
    "GAME_DATE": 20190227,
    "Season": "2018-2019",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/27/0021800915/89/4ba5d4cd-1b02-6291-4ef9-d3a357c7eaab_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474643387435432272",
    "name": "The 2974 Collection #2385",
    "imageUrl": "https://arweave.net/gJhkxgjFZ8nGeJp4h3yhTy54MnwhMI7Mcgm_MMvlnjA?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2019,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2386,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 153,
    "LOC_Y": 197,
    "GAME_DATE": 20190227,
    "Season": "2018-2019",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/27/0021800915/366/d7050e93-1ea1-6473-195c-554533e293bb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355796434141979386",
    "name": "The 2974 Collection #2386",
    "imageUrl": "https://arweave.net/80S1tcMW1ibtCQFdqQ7nG6hH7hav5QMgDojIUVfQCLU?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2019,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2387,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 145,
    "LOC_Y": 210,
    "GAME_DATE": 20190227,
    "Season": "2018-2019",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/27/0021800915/466/5f793e5a-6541-fc5b-988d-0cf41713a250_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/457526385045481402",
    "name": "The 2974 Collection #2387",
    "imageUrl": "https://arweave.net/uUHi4D_gv6huCbIEccwK1vxC8Sb2oEY3aeauonSQtdk?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2019,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2388,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -141,
    "LOC_Y": 206,
    "GAME_DATE": 20190227,
    "Season": "2018-2019",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/27/0021800915/584/6879873a-05c8-19a2-fa53-510aff91e1d0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322850955559502884",
    "name": "The 2974 Collection #2388",
    "imageUrl": "https://arweave.net/Vsp9j-HjyGSrXev-Ap1r7uPhpsFPJgZaIpE74iTtW48?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2019,
    "Month": 2,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2389,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 86,
    "LOC_Y": 239,
    "GAME_DATE": 20190228,
    "Season": "2018-2019",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/28/0021800923/84/c4d16635-589c-ce01-b730-9d8bef2ba339_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/524103904732962950",
    "name": "The 2974 Collection #2389",
    "imageUrl": "https://arweave.net/W4mFm4j7H4b4ReWi4VcZ_PQrV2Jy9l0nFUd953tr1XY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2019,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2390,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -19,
    "LOC_Y": 259,
    "GAME_DATE": 20190228,
    "Season": "2018-2019",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/28/0021800923/101/e38e3c2f-84f5-12fe-c955-dc408dde9902_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533180259696549440",
    "name": "The 2974 Collection #2390",
    "imageUrl": "https://arweave.net/vZD4Tu-j6QEBWZtzGWNHJNR0QQsd7wWj031l2yk24GY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2019,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2391,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 187,
    "LOC_Y": 187,
    "GAME_DATE": 20190228,
    "Season": "2018-2019",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/28/0021800923/434/66693594-180b-678a-6f18-fcd8ee0fe70b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441092773556570236",
    "name": "The 2974 Collection #2391",
    "imageUrl": "https://arweave.net/v-Ki5P-nM0CYdvXL0Z9YlkzV5pT2jaTs-x8tSBXWq34?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2019,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2392,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 197,
    "LOC_Y": 157,
    "GAME_DATE": 20190228,
    "Season": "2018-2019",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/28/0021800923/465/6f6addf5-e973-6be9-33d9-eb8e701baa73_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403136932196254879",
    "name": "The 2974 Collection #2392",
    "imageUrl": "https://arweave.net/yAFgvHoHwTHeFU0gb48rMq8DncQOozSzgyWzUV_lZZw?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2019,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2393,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 149,
    "LOC_Y": 215,
    "GAME_DATE": 20190228,
    "Season": "2018-2019",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/02/28/0021800923/584/ebf15a45-8928-0df4-d38a-0466a4e2f82c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443742803188822249",
    "name": "The 2974 Collection #2393",
    "imageUrl": "https://arweave.net/u0C7cqYNxtLHQu4Er8HbxfDuLgT9UoKcLHdYGpD3ITY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2019,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2394,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 206,
    "LOC_Y": 165,
    "GAME_DATE": 20190302,
    "Season": "2018-2019",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/02/0021800938/24/ead397df-f72d-f3ce-05bf-ba30e60349cc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362584211181286009",
    "name": "The 2974 Collection #2394",
    "imageUrl": "https://arweave.net/WZxXqvetrZPatOXUSjvFbXoIHrDfUB4PQ5un_lMFiMM?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2395,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -230,
    "LOC_Y": 17,
    "GAME_DATE": 20190302,
    "Season": "2018-2019",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/02/0021800938/53/ebeef2fe-7e89-d0a0-b4bf-3e27c9323fbe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548155329266072609",
    "name": "The 2974 Collection #2395",
    "imageUrl": "https://arweave.net/TCOaXD7wdJLJmBo2YqNVfK-xSNvndDQMAICLxdZ4-X8?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2396,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 79,
    "LOC_Y": 257,
    "GAME_DATE": 20190302,
    "Season": "2018-2019",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/02/0021800938/78/90e4ae92-11b7-f07b-2fa6-e4dfa4975ed4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/432795733736619952",
    "name": "The 2974 Collection #2396",
    "imageUrl": "https://arweave.net/sFcCZWcq3sl5stQQxrYRhKFscR5lz12oEpGGSeAsi9Y?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2397,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 212,
    "LOC_Y": 135,
    "GAME_DATE": 20190302,
    "Season": "2018-2019",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/02/0021800938/374/b9d3e82c-e82b-329f-9576-a511ede81393_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301224625246791779",
    "name": "The 2974 Collection #2397",
    "imageUrl": "https://arweave.net/460QKwvgI5Ug85ncEueKo_4Sd3h2QcaARki_A-TO6HE?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2398,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 46,
    "LOC_Y": 297,
    "GAME_DATE": 20190302,
    "Season": "2018-2019",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/02/0021800938/639/abb70060-b208-0171-65d1-0f4c3370378c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497351428939309503",
    "name": "The 2974 Collection #2398",
    "imageUrl": "https://arweave.net/-H-LlmnUQZ4xoChzX4GU1ZaawiHxHWx1GBg7lYYzeYc?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2019,
    "Month": 3,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2399,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -179,
    "LOC_Y": 193,
    "GAME_DATE": 20190305,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/05/0021800964/53/dae70cd2-5744-db4c-bf14-b2b9239d6ca7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/333940542068781396",
    "name": "The 2974 Collection #2399",
    "imageUrl": "https://arweave.net/zcpYNKOdNZxTOHwqdcI_UECAZQOHUGFgZ8NN6VblNCo?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2400,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 12,
    "LOC_Y": 274,
    "GAME_DATE": 20190305,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/05/0021800964/183/cba01f09-41a5-96c6-5ee6-85fb383e7425_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/414128922999970916",
    "name": "The 2974 Collection #2400",
    "imageUrl": "https://arweave.net/1SgI9FeOE1AOSOcC82_xY-CA-9xovpTNKp7BWAvi9F4?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2401,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -196,
    "LOC_Y": 172,
    "GAME_DATE": 20190305,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/05/0021800964/197/8a290c25-08c8-1e5c-7810-bc3b2debd626_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500321663120556187",
    "name": "The 2974 Collection #2401",
    "imageUrl": "https://arweave.net/gLVh_X9K31oJCADbJb7L-0XAYice4iD7gSkgSHYFEJ8?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2402,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -207,
    "LOC_Y": 141,
    "GAME_DATE": 20190305,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/05/0021800964/258/eb5d30fa-c708-81b3-d2b9-dff367d613cc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/451249310779631894",
    "name": "The 2974 Collection #2402",
    "imageUrl": "https://arweave.net/FT3UgVuwXi---t6CO_WALi9IAokThYp5NcKqxQsW444?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2019,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2403,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -22,
    "LOC_Y": 289,
    "GAME_DATE": 20190308,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/08/0021800984/122/377a4250-33a2-e9b5-f1f7-9e867c0144c7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/570526227464269855",
    "name": "The 2974 Collection #2403",
    "imageUrl": "https://arweave.net/j5qO-c5UnBI2H723FQRrNzfRW4zHdFSAJVLqEjyBsJA?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2404,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 2,
    "LOC_Y": 278,
    "GAME_DATE": 20190308,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/08/0021800984/364/406c41ab-663b-1e8a-f9af-012df3952fc4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/571711962129937866",
    "name": "The 2974 Collection #2404",
    "imageUrl": "https://arweave.net/P44MunqHrnlcKshSSIc8a4rx7UHeT-gZXJ4q4BgkuMA?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2405,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -46,
    "LOC_Y": 295,
    "GAME_DATE": 20190308,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/08/0021800984/492/6f3e41ea-d03f-edd1-49e4-885df8e505a3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568829903922615453",
    "name": "The 2974 Collection #2405",
    "imageUrl": "https://arweave.net/UQZpzw3pKu3uBJ2vXr7FGxs2bf3rYHEnuOKZ8-16czY?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2406,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 226,
    "LOC_Y": 140,
    "GAME_DATE": 20190308,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/08/0021800984/657/fe9cc23a-2931-3c96-ce30-dd9bd1334161_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296167015762644252",
    "name": "The 2974 Collection #2406",
    "imageUrl": "https://arweave.net/DQomhOVed7XOcDRQ4ol083b13TFYNBgGh9FBYDCjqK8?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 3,
    "Day": 8,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2407,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -101,
    "LOC_Y": 264,
    "GAME_DATE": 20190310,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/10/0021801000/268/caeab3fe-f223-474d-2a27-5fa587168459_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362282479304718714",
    "name": "The 2974 Collection #2407",
    "imageUrl": "https://arweave.net/k6YYeXJX6z74ww0_hN9bmMb2mV1pBOf4zT5VU23PvfY?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2019,
    "Month": 3,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2408,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -190,
    "LOC_Y": 193,
    "GAME_DATE": 20190310,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/10/0021801000/462/be4cafec-ad3e-0eb2-e61b-58671f94223d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572306782866779012",
    "name": "The 2974 Collection #2408",
    "imageUrl": "https://arweave.net/BSTXidiB2ZIE7KRl1x-fAhUhM1XpUEscFFgcQL9y5xM?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2019,
    "Month": 3,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2409,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 139,
    "LOC_Y": 243,
    "GAME_DATE": 20190310,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/10/0021801000/595/453827b3-767d-7291-b76f-f464c79ad65b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320546809582434400",
    "name": "The 2974 Collection #2409",
    "imageUrl": "https://arweave.net/5iesjqfdZww1UrOwOnMc-baRfnhgsLAPZMPqeHI2Kc0?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2019,
    "Month": 3,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2410,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 228,
    "LOC_Y": 114,
    "GAME_DATE": 20190310,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/10/0021801000/615/ca6ae3e2-30b0-9f15-b789-c9bdcdac60e7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317099339328119735",
    "name": "The 2974 Collection #2410",
    "imageUrl": "https://arweave.net/SVc1FBiii4X1Mk6B18I5x4r0wmm6XP7vZlVu6p11zD4?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2019,
    "Month": 3,
    "Day": 10,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2411,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 145,
    "LOC_Y": 222,
    "GAME_DATE": 20190313,
    "Season": "2018-2019",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/13/0021801018/50/1c5f12c7-4f2a-eb15-7766-68188dc430bc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395510869516284389",
    "name": "The 2974 Collection #2411",
    "imageUrl": "https://arweave.net/6uxSd4yh0vWf3AjVp30trhbbrpGzyoosuXOak5t30qE?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2412,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 133,
    "LOC_Y": 271,
    "GAME_DATE": 20190313,
    "Season": "2018-2019",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/13/0021801018/93/4c2dca2a-9c03-7776-05f8-2c424490ce58_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/383100737226403804",
    "name": "The 2974 Collection #2412",
    "imageUrl": "https://arweave.net/nZtkPAqJdXGnt01v1sEgaN5hgQdDJz4mblUU3FHDJTI?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2413,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -186,
    "LOC_Y": 204,
    "GAME_DATE": 20190313,
    "Season": "2018-2019",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/13/0021801018/363/75ab9834-dc22-95c7-bee4-a9daf0d19440_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561353617555035295",
    "name": "The 2974 Collection #2413",
    "imageUrl": "https://arweave.net/uBXLpEmI0nUBmOLALrSHHUzy_bVROEakTP_4jRicr5Q?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2019,
    "Month": 3,
    "Day": 13,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2414,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 57,
    "GAME_DATE": 20190316,
    "Season": "2018-2019",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/16/0021801038/7/d3219271-d03d-40bb-6404-8f16dab884d2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353946054268034685",
    "name": "The 2974 Collection #2414",
    "imageUrl": "https://arweave.net/et9GAMtXFL1jjgCb6aS5EusTlBprbRIOaYcNjIKkgPw?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2019,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2415,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -168,
    "LOC_Y": 195,
    "GAME_DATE": 20190316,
    "Season": "2018-2019",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/16/0021801038/139/b448e1cd-28cb-9254-2dec-375448369127_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363514309379518292",
    "name": "The 2974 Collection #2415",
    "imageUrl": "https://arweave.net/PJ4UEpdQ5eU0ACOF0w_fJ6r6XFFCO9ICkYKgyEn73zk?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2019,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2416,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -112,
    "LOC_Y": 226,
    "GAME_DATE": 20190316,
    "Season": "2018-2019",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/16/0021801038/337/721a4c61-bbd8-8dbb-bd72-727404707e4f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312269489719462951",
    "name": "The 2974 Collection #2416",
    "imageUrl": "https://arweave.net/fTMbQj71sgTAuWSdPl9pLmXA6MHNoyO9cKwcb8tPzyw?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2019,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2417,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 239,
    "LOC_Y": 1,
    "GAME_DATE": 20190316,
    "Season": "2018-2019",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/16/0021801038/419/8a7d28de-0488-97ee-4ccc-7a1bbe3eace8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391687712624331316",
    "name": "The 2974 Collection #2417",
    "imageUrl": "https://arweave.net/BL3RNYVtVU80WUAezyRDJugbwfpCwcZOyC-mP-hnkuw?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2019,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2418,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 40,
    "GAME_DATE": 20190316,
    "Season": "2018-2019",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/16/0021801038/502/22bb1a44-5bf1-0841-8c25-e89b32188a56_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379516819174862203",
    "name": "The 2974 Collection #2418",
    "imageUrl": "https://arweave.net/lJT40vpU27VOq2rMNWsrUqrZOQZZb1FVeXcw0FZKRoU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2019,
    "Month": 3,
    "Day": 16,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2419,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Backcourt",
    "SHOT_DISTANCE": 60,
    "LOC_X": 29,
    "LOC_Y": 603,
    "GAME_DATE": 20190318,
    "Season": "2018-2019",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/18/0021801055/152/2b9c233a-7676-488b-df8d-971dc8caa10c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335772821676898601",
    "name": "The 2974 Collection #2419",
    "imageUrl": "https://arweave.net/L4CJsYDW9H2W7SWUWHQ2wesClOHP1nKyvqykeRtx8_8?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2019,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2420,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 99,
    "LOC_Y": 227,
    "GAME_DATE": 20190318,
    "Season": "2018-2019",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/18/0021801055/280/7e361c4c-29fb-7313-d84d-ffefe9642de7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499461746626313920",
    "name": "The 2974 Collection #2420",
    "imageUrl": "https://arweave.net/Wf-RRqN060PLxDj6Gv47lAbF9KvSnLmaGlOfdzliOlI?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2019,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2421,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -115,
    "LOC_Y": 246,
    "GAME_DATE": 20190318,
    "Season": "2018-2019",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/18/0021801055/426/0a57d665-d28e-1be4-4c98-dec9ee1003e7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364893325957148172",
    "name": "The 2974 Collection #2421",
    "imageUrl": "https://arweave.net/-q7Cm2ew4Nm4r9n9qeB2shBrktvMAilGRhf9IweAdvM?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2019,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2422,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -230,
    "LOC_Y": 85,
    "GAME_DATE": 20190318,
    "Season": "2018-2019",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/18/0021801055/445/f2659095-64c1-22fb-4cd4-e44fb4b51308_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/409646801836202914",
    "name": "The 2974 Collection #2422",
    "imageUrl": "https://arweave.net/JHPa5iqzutMGZflvG9DQ0u6BT2gcmxl6_HyVTID78lE?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2019,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2423,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -76,
    "LOC_Y": 258,
    "GAME_DATE": 20190318,
    "Season": "2018-2019",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/18/0021801055/448/d591a830-35a5-2bd3-9e1b-5dfd11d78ec5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/542804138844202019",
    "name": "The 2974 Collection #2423",
    "imageUrl": "https://arweave.net/rgePriRlloSVpy6laI-AQGE0zacY9nY7KJ3jTybDFHg?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2019,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2424,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -242,
    "LOC_Y": 83,
    "GAME_DATE": 20190318,
    "Season": "2018-2019",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/18/0021801055/616/6213e06a-5766-0891-c6ee-d3395e095164_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/534177467559375080",
    "name": "The 2974 Collection #2424",
    "imageUrl": "https://arweave.net/X8fx4kKgeGECzaVJdYy5XDy2qSpuAUjrvwK2jq-9P-Y?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2019,
    "Month": 3,
    "Day": 18,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2425,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -114,
    "LOC_Y": 217,
    "GAME_DATE": 20190319,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/19/0021801062/124/80e6917b-8627-17bd-9228-00fc21595825_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406339016042906380",
    "name": "The 2974 Collection #2425",
    "imageUrl": "https://arweave.net/gbsrsKZ2ay-7cFOlWVDoMhBVxsJKVy0_Yjlv8JkmarU?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 19,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2426,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 39,
    "GAME_DATE": 20190319,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/19/0021801062/134/f215647d-a3b8-2538-a155-7e241c011e80_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/468376338335679107",
    "name": "The 2974 Collection #2426",
    "imageUrl": "https://arweave.net/zM1tZivIs4tb2gPNtRavlmyPjynRR21EtwZxyYCCMLw?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 19,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2427,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -160,
    "LOC_Y": 197,
    "GAME_DATE": 20190319,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/19/0021801062/312/69afbf55-a87b-2ae4-56a2-36e99582bcb5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/333188115811232234",
    "name": "The 2974 Collection #2427",
    "imageUrl": "https://arweave.net/onifkz8PGs8Y0PZgC0yQ50R_JMKZyKsZv0DrjGNaq38?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 19,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2428,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 30,
    "LOC_Y": 247,
    "GAME_DATE": 20190319,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/19/0021801062/389/a48eb912-089a-357a-e8c6-53ebbfa8e96a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558841848785258467",
    "name": "The 2974 Collection #2428",
    "imageUrl": "https://arweave.net/MF1WC5NcUaCS1BuOECx8EgXxBZCQOMEljfVtWI8M7fs?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 19,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2429,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -171,
    "LOC_Y": 182,
    "GAME_DATE": 20190319,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/19/0021801062/485/454bf26b-318f-41f1-2b2b-cf856797b562_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/532724354548160419",
    "name": "The 2974 Collection #2429",
    "imageUrl": "https://arweave.net/WyOVAfxzQJn_UROR0e652JrgDqsFKVhWz17hjCTyUYE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 19,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2430,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 125,
    "LOC_Y": 221,
    "GAME_DATE": 20190319,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/19/0021801062/488/720593fc-3bdd-71fb-1f89-db47a67a04ef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478650971603906565",
    "name": "The 2974 Collection #2430",
    "imageUrl": "https://arweave.net/xI2XIXcxMxKlim1InUI6onTvYcZZZeIAWze5anypX7U?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 19,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2431,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 235,
    "LOC_Y": 56,
    "GAME_DATE": 20190319,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/19/0021801062/509/dfa34ed2-b0df-974c-7d08-9b51b318f297_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518350755616245808",
    "name": "The 2974 Collection #2431",
    "imageUrl": "https://arweave.net/EDI3Edh_pcgYzj9SIciBmf6yWqEy6jbvDdScXn9j0Tc?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 19,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2432,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 207,
    "LOC_Y": 145,
    "GAME_DATE": 20190319,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/19/0021801062/637/0b8f3304-5261-257b-aac2-29129fbb0552_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420517913688470233",
    "name": "The 2974 Collection #2432",
    "imageUrl": "https://arweave.net/1swi1xcIJesnvabNqcH_gZ9yGnuBbJYDu6N25AfIZFc?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 19,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2433,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 196,
    "LOC_Y": 199,
    "GAME_DATE": 20190321,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/21/0021801079/132/8c866d41-feab-7bb2-4a99-ca6fc755d3dd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327065168864833149",
    "name": "The 2974 Collection #2433",
    "imageUrl": "https://arweave.net/9ocrxX3f6V44Y2fn3DAZ6QR50s-GXG6fRHRGMchW6_I?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2434,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 185,
    "LOC_Y": 235,
    "GAME_DATE": 20190321,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/21/0021801079/337/fff88739-b7be-8f80-7fd4-6ff390d76942_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446120531334689847",
    "name": "The 2974 Collection #2434",
    "imageUrl": "https://arweave.net/O9ZTFPrd3eBWfRybBNLvnnNmnmK_6XGFXjda4qMKKUs?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2435,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -228,
    "LOC_Y": 115,
    "GAME_DATE": 20190321,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/21/0021801079/345/f77ef95f-28cb-f20f-3cf3-976e2b87a20b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531378847447709574",
    "name": "The 2974 Collection #2435",
    "imageUrl": "https://arweave.net/zOv4GJPnE3QgbNwsuF8DzL02AwYAgWHj_BaF-oOK58U?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2436,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 19,
    "GAME_DATE": 20190321,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/21/0021801079/467/59ac9414-c987-1d7c-2a83-44ba19b417c0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336428107568762874",
    "name": "The 2974 Collection #2436",
    "imageUrl": "https://arweave.net/OxCOXcCb5r0bzCSgDpZyfnOTiyOehmOn7uPF4Cav0vQ?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2437,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -185,
    "LOC_Y": 179,
    "GAME_DATE": 20190321,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/21/0021801079/473/694b9322-a876-436c-f357-3720c08f46e0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362799978907522081",
    "name": "The 2974 Collection #2437",
    "imageUrl": "https://arweave.net/bLLUwTXOpZoExTNJtEGLPGm8fWwx2Vwl1Ax-PWUJTBI?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2019,
    "Month": 3,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2438,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": 29,
    "GAME_DATE": 20190324,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/24/0021801101/19/85aa4349-df2b-3e60-589f-a6195851b1e3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434245444444498456",
    "name": "The 2974 Collection #2438",
    "imageUrl": "https://arweave.net/LpQ__Z8v3hjVN6DXKnGRWh5rLhF4CcQ2GkL8W51uhek?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2019,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2439,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 141,
    "LOC_Y": 211,
    "GAME_DATE": 20190324,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/24/0021801101/34/99689d1e-de93-ec66-389f-1e086cd5c9c4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/390355246441536733",
    "name": "The 2974 Collection #2439",
    "imageUrl": "https://arweave.net/5cOJF-1k9IjYdE_nCXMK4KI3J0bC19LdFJUL64Hy5KQ?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2019,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2440,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -39,
    "LOC_Y": 279,
    "GAME_DATE": 20190324,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/24/0021801101/108/33d76ee5-846b-200e-55d0-6fbd766bcb8b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356795684023334425",
    "name": "The 2974 Collection #2440",
    "imageUrl": "https://arweave.net/gu2_R1G7ISQYS827N_uqW5JL-HWHb4sNzVTf5uPzEyk?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2019,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2441,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -188,
    "LOC_Y": 200,
    "GAME_DATE": 20190324,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/24/0021801101/393/e5ceec3d-22a5-7ebd-5292-43be2c17a794_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/510121624362858643",
    "name": "The 2974 Collection #2441",
    "imageUrl": "https://arweave.net/Ov16wv-A6zkIgmOdRDVZGTFsgcZdwU89_vSkgqwxM3I?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2019,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2442,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -184,
    "LOC_Y": 216,
    "GAME_DATE": 20190324,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/24/0021801101/512/ec0fdc49-3e49-20fa-e7f6-e5fdd212eb48_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/358962863814215403",
    "name": "The 2974 Collection #2442",
    "imageUrl": "https://arweave.net/88Zty6Ag7yAa8tz7k05DuDs7hHURwsqcqAAU-gwRXWU?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2019,
    "Month": 3,
    "Day": 24,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2443,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -175,
    "LOC_Y": 202,
    "GAME_DATE": 20190327,
    "Season": "2018-2019",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/27/0021801118/13/e4a45758-26c6-d654-c0fc-01a57985f3f8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309823278119412682",
    "name": "The 2974 Collection #2443",
    "imageUrl": "https://arweave.net/gyEP4qejtzxsKiVmXWoI_OhUsgXaLs5w3G_meBZJE2s?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2019,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2444,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 218,
    "LOC_Y": 125,
    "GAME_DATE": 20190327,
    "Season": "2018-2019",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/27/0021801118/16/a4a0225c-ee61-68bc-8154-ca0356c6c3cf_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433761106811874057",
    "name": "The 2974 Collection #2444",
    "imageUrl": "https://arweave.net/lHhSv-UF60cFHmTNFHMOADALmKKq93tYWw0-LxNrwJQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2019,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2445,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -112,
    "LOC_Y": 233,
    "GAME_DATE": 20190327,
    "Season": "2018-2019",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/27/0021801118/114/90529ece-9f87-2003-43b5-fb5925b1a7e9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450328657360375431",
    "name": "The 2974 Collection #2445",
    "imageUrl": "https://arweave.net/gLa5OysHi63TniGB8B4tfAXGxFfb_Jt4zJXE8eQlTZ4?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2019,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2446,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -226,
    "LOC_Y": 81,
    "GAME_DATE": 20190327,
    "Season": "2018-2019",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/27/0021801118/310/be37c230-da37-597f-42ec-928067156db7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/352164578390189119",
    "name": "The 2974 Collection #2446",
    "imageUrl": "https://arweave.net/HP6JL8JPjW3g4yZFy9dcma8JlgYqBLwikYPspFu25ZQ?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2019,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2447,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -6,
    "LOC_Y": 263,
    "GAME_DATE": 20190327,
    "Season": "2018-2019",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/27/0021801118/393/fc8eb63d-9f11-3827-7ba7-59317ffacc4d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289625212790334729",
    "name": "The 2974 Collection #2447",
    "imageUrl": "https://arweave.net/7R1Fgu-5YFh70UodPBOBWAAjRl4Se9GQ3JItMdwVkeA?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2019,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2448,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": -16,
    "GAME_DATE": 20190327,
    "Season": "2018-2019",
    "HTM": "MEM",
    "VTM": "GSW",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/27/0021801118/397/cf01086a-4344-1b91-cc5f-fd1d5395355d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497034205751765066",
    "name": "The 2974 Collection #2448",
    "imageUrl": "https://arweave.net/MKqW21TAGEh5tCpHQsu4fECk0HL02jaLi0MscF_-lb8?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2019,
    "Month": 3,
    "Day": 27,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2449,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 220,
    "LOC_Y": 2,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/53/511acfc7-bee8-d37b-6dcb-ac377ca9234b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/463635746711030272",
    "name": "The 2974 Collection #2449",
    "imageUrl": "https://arweave.net/tEoZ7RPZKmb61SIw3RIrESTE2BQftE08im7ISHUdcig?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2450,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": 4,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/73/75f517b9-502c-bc2b-4da6-58cd92d749f8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498286718748026513",
    "name": "The 2974 Collection #2450",
    "imageUrl": "https://arweave.net/wmaK4inX-E73495TMkwmkMlgfpgmHwuWviUyfjJlNGc?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2451,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -192,
    "LOC_Y": 215,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/135/cb44aec5-e026-cf56-765e-1acd471bc2d4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404883781511034074",
    "name": "The 2974 Collection #2451",
    "imageUrl": "https://arweave.net/sw_AqnPfYMunbQlkXSmOmM4STAM8YB8r8MCqLdOdmtM?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2452,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 221,
    "LOC_Y": 26,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/137/bec14cfa-c779-9cff-87b0-35d7367b1878_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/356423328908394903",
    "name": "The 2974 Collection #2452",
    "imageUrl": "https://arweave.net/2J4mzU1WdIe4Qmj421YqB34G73_eq4-BxwWfYe43m_M?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2453,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -110,
    "LOC_Y": 244,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/284/02857ef6-9dad-bda0-5814-c461da93f948_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324916909622217526",
    "name": "The 2974 Collection #2453",
    "imageUrl": "https://arweave.net/eHZ7HBafHmWK8ZOxhfOpApnXCk-LGNQvJ_NoFjenWE4?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2454,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": 6,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/313/1beab4bf-84d4-4118-06df-1708b8084def_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/549623992471243223",
    "name": "The 2974 Collection #2454",
    "imageUrl": "https://arweave.net/TdmeJCw0bbSz2ujGusLMZk9UUS30mPhDKC1UaY1iZw0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2455,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 96,
    "LOC_Y": 240,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/637/e645d401-fb27-359e-8e1b-2166773fbc3c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474011089438127328",
    "name": "The 2974 Collection #2455",
    "imageUrl": "https://arweave.net/Vnat_8A4h8P85EfTa13Q_pZ5UPHGQppLH4WrmThTh2c?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2456,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -3,
    "LOC_Y": 245,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/652/60046163-6662-b990-e2ce-bdba75543e5a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368175291328356851",
    "name": "The 2974 Collection #2456",
    "imageUrl": "https://arweave.net/w6vSinaXJKrgAqCzZV4SQBpswOAQ9w6--LPkYL7PVBw?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2457,
    "PERIOD": 5,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 7,
    "LOC_Y": 260,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/720/aaa50ff5-fa29-e30f-107c-51eaffa7ab5c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518801800438624678",
    "name": "The 2974 Collection #2457",
    "imageUrl": "https://arweave.net/XsuFpIPNwG3EFv2bgz0Fji8j_1LnuMS3r3kt_eYT3vo?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2458,
    "PERIOD": 5,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 11,
    "LOC_Y": 248,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/732/6f977640-ac44-508a-e9fd-4421bc119eaa_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359242649589804576",
    "name": "The 2974 Collection #2458",
    "imageUrl": "https://arweave.net/G75O8Ezjf11A1mQiPwiTAh6m8NcDFW97xozoQ-Tt_gc?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2459,
    "PERIOD": 5,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -237,
    "LOC_Y": 24,
    "GAME_DATE": 20190329,
    "Season": "2018-2019",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/29/0021801132/752/7eb06dbf-0a31-59ab-b04f-1afe2b335a9e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368828417690491405",
    "name": "The 2974 Collection #2459",
    "imageUrl": "https://arweave.net/dm4SSj1RTwNpCKUuSjtKcW8eFZ9vjVZSEHbgJgVr0jE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2019,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2460,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 129,
    "LOC_Y": 235,
    "GAME_DATE": 20190331,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/31/0021801150/90/430bfe0c-7fdb-bcfa-b0ad-9acf6976b4ac_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459697903445650570",
    "name": "The 2974 Collection #2460",
    "imageUrl": "https://arweave.net/6g0Q6i4Cgs5Qw43RgJeRY9wDp9197gjRM1rUgq3efxk?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2019,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2461,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 227,
    "LOC_Y": 49,
    "GAME_DATE": 20190331,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/31/0021801150/139/33307790-c7e0-ab93-c7b0-08a650bd9c97_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400266643710104685",
    "name": "The 2974 Collection #2461",
    "imageUrl": "https://arweave.net/_EVzaM5x8Pyuw604dB5JY9-qSS3PpSSpdMNaw30Petc?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2019,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2462,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -171,
    "LOC_Y": 208,
    "GAME_DATE": 20190331,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/31/0021801150/390/f5db59b9-061d-7016-f13d-4dba053ae14b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525346470607043332",
    "name": "The 2974 Collection #2462",
    "imageUrl": "https://arweave.net/gFvWlgcQTualwUMJ1IE9i1XhzkIjXOHDef_0onjEJSM?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2019,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2463,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 159,
    "LOC_Y": 234,
    "GAME_DATE": 20190331,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/31/0021801150/411/906cc87d-e504-f87c-b090-1574b2937400_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/483768771126336323",
    "name": "The 2974 Collection #2463",
    "imageUrl": "https://arweave.net/Sn021ERO8H0-1Inza3yZAQAJabZ59XBP7uIy69nGIE4?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2019,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2464,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -225,
    "LOC_Y": 13,
    "GAME_DATE": 20190331,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/03/31/0021801150/417/8657cf5b-5a60-5a83-908b-625f907ebe0c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/350656612502067725",
    "name": "The 2974 Collection #2464",
    "imageUrl": "https://arweave.net/Mq-Y8nXN-gHOj_ImLWMZoBc6aQFdlKgngJHt0fP1mJ0?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2019,
    "Month": 3,
    "Day": 31,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2465,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 144,
    "LOC_Y": 228,
    "GAME_DATE": 20190402,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/02/0021801164/7/54cfbd1b-0c19-7045-c299-99ccf4f010f1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/472815437818801120",
    "name": "The 2974 Collection #2465",
    "imageUrl": "https://arweave.net/4071LSutJitm1ORNvnw3diCga0zaYzNMNPxwJCL54Yg?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2466,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 199,
    "LOC_Y": 168,
    "GAME_DATE": 20190402,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/02/0021801164/140/19996631-4a99-4eac-0877-7dfaede2d32b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373111062407115078",
    "name": "The 2974 Collection #2466",
    "imageUrl": "https://arweave.net/_omKdztMweUaVuETuIynlU8nndAJaC94RmaY65SkT3U?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2467,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -207,
    "LOC_Y": 161,
    "GAME_DATE": 20190402,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/02/0021801164/404/1b7c9970-6c79-fe7d-2f69-012939ee843c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421572244001236841",
    "name": "The 2974 Collection #2467",
    "imageUrl": "https://arweave.net/dShwV-LLOdS-BPKJ-dFcNOlNgMoor-uYOueVKHyluCE?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2468,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 24,
    "LOC_Y": 271,
    "GAME_DATE": 20190402,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/02/0021801164/448/c08247bb-c82e-06d9-358e-3c8b6ac06d1b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/529502457059881107",
    "name": "The 2974 Collection #2468",
    "imageUrl": "https://arweave.net/XVSV7ANo9qTRto3a_5fJylKlN3rhuv35oVrZpm_oUFM?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2469,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -111,
    "LOC_Y": 253,
    "GAME_DATE": 20190402,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/02/0021801164/571/6e37421c-e320-8359-6127-51ecf47d0cb4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479867266774371117",
    "name": "The 2974 Collection #2469",
    "imageUrl": "https://arweave.net/YINHfSvruLupMK7TjVqwUBr3HyutozvCevEnt4BAysg?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2019,
    "Month": 4,
    "Day": 2,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2470,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 136,
    "LOC_Y": 225,
    "GAME_DATE": 20190404,
    "Season": "2018-2019",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/04/0021801179/328/c3a6fea0-9556-0fde-0999-1147239ed54e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290924114564055656",
    "name": "The 2974 Collection #2470",
    "imageUrl": "https://arweave.net/j5K-4CNGJJwQMK-n2u0P1ybhecYIOk69o0Dt4LbV84M?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2471,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -167,
    "LOC_Y": 230,
    "GAME_DATE": 20190405,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/05/0021801191/58/86dd1bbe-311f-7456-fe0b-bd035db86c06_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381869439734387251",
    "name": "The 2974 Collection #2471",
    "imageUrl": "https://arweave.net/0dg4E4z6lyhTMSilBbGirC0vML4pNJVuA0orce61baY?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2019,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2472,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 224,
    "LOC_Y": 129,
    "GAME_DATE": 20190405,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/05/0021801191/86/c6a15630-21c5-eaf4-4f2f-4754ad2660a9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373652804098022764",
    "name": "The 2974 Collection #2472",
    "imageUrl": "https://arweave.net/2d1laio6I2PfIQTsx5Yapke4g2O_bkMT0wqbFXWbvkI?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2019,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2473,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -209,
    "LOC_Y": 148,
    "GAME_DATE": 20190405,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/05/0021801191/132/b43cf275-63fd-9d6b-328e-3752bddaa160_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/382598048389369725",
    "name": "The 2974 Collection #2473",
    "imageUrl": "https://arweave.net/5bLZWgkd6a6Iqy0xaZuuXNi5ZA589P4FwTQVl2KPsQg?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2019,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2474,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 221,
    "LOC_Y": 120,
    "GAME_DATE": 20190405,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/05/0021801191/142/6009aadd-8b8a-bc1e-dff1-905cd55a5141_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523708397720753016",
    "name": "The 2974 Collection #2474",
    "imageUrl": "https://arweave.net/LAaVQmYHflgJk79kyCzHBB_bQ_rL9YvQ78n5rtFR6tk?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2019,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2475,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 17,
    "LOC_Y": 285,
    "GAME_DATE": 20190405,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/05/0021801191/304/82858f2e-7a37-e4cf-8e79-8476f19a3033_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495575745385378847",
    "name": "The 2974 Collection #2475",
    "imageUrl": "https://arweave.net/DxpGpIkrxFzXfu11BZCCg4Slw3zVubCzmCblTywWegs?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2019,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2476,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 117,
    "LOC_Y": 227,
    "GAME_DATE": 20190405,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/05/0021801191/344/831280c8-20da-01d0-3c97-a821760b08df_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547011092899283241",
    "name": "The 2974 Collection #2476",
    "imageUrl": "https://arweave.net/TgmXpf2Wg2dgi7pdul2fnDEhLoIKKVsrPDLEU5sDO_c?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2019,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2477,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 194,
    "LOC_Y": 199,
    "GAME_DATE": 20190405,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/05/0021801191/416/4aee34f9-faa9-bc7d-ff7f-393c79751aca_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/294951950854065051",
    "name": "The 2974 Collection #2477",
    "imageUrl": "https://arweave.net/12tvNGFZVslmf0QYPMtZDtDEVTxMoLDw4j3jknOLml4?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2019,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2478,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 22,
    "GAME_DATE": 20190405,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/05/0021801191/427/efe108f8-a247-56f8-6c62-463df19db9f1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504400382628764700",
    "name": "The 2974 Collection #2478",
    "imageUrl": "https://arweave.net/TJTkZ0uI-diurxwQJoK9mmZieVpdxY2Ljk5SjVSe_oM?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2019,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2479,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -175,
    "LOC_Y": 221,
    "GAME_DATE": 20190405,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/05/0021801191/585/9ac36732-11fd-db8b-8e8d-e3904834245d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439528164814214364",
    "name": "The 2974 Collection #2479",
    "imageUrl": "https://arweave.net/E7Bcvp3B0cRRJO_Obyf4w31nkdzRyTgvrN0Pb2iWMi0?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2019,
    "Month": 4,
    "Day": 5,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2480,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -148,
    "LOC_Y": 216,
    "GAME_DATE": 20190407,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/07/0021801205/84/8a66eacf-8018-a00b-ccfd-c70bbaead359_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568648492316057152",
    "name": "The 2974 Collection #2480",
    "imageUrl": "https://arweave.net/aZG9CM1cLkZcrFl09UsqBCllwWwKATzCG-2S7ACXTqE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2481,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 204,
    "LOC_Y": 172,
    "GAME_DATE": 20190407,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/07/0021801205/302/4a7f1334-8396-70d0-716b-68ee15af7f4c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/455780824352274074",
    "name": "The 2974 Collection #2481",
    "imageUrl": "https://arweave.net/21mZZipK9QdRn-1xAsAbbiX7IElkDvqI4it3DvqNY7M?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2482,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -201,
    "LOC_Y": 224,
    "GAME_DATE": 20190407,
    "Season": "2018-2019",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/07/0021801205/533/0bc89012-aaca-07cb-13d5-c56fbd6ca349_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/479618206736153035",
    "name": "The 2974 Collection #2482",
    "imageUrl": "https://arweave.net/cxW-c1LPcRlkXZvB5-bBO0WmI-eMQIIhCnqBXNEwKjE?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 4,
    "Day": 7,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2483,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 73,
    "LOC_Y": 255,
    "GAME_DATE": 20190409,
    "Season": "2018-2019",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/04/09/0021801215/48/18917d9a-98e2-fcae-e7cd-4f95d4852d00_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388206329876662286",
    "name": "The 2974 Collection #2483",
    "imageUrl": "https://arweave.net/lMFtCFC3pxkS1b8B_91YTgQMyceJz-8PuUPomNJdwv0?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2484,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -112,
    "LOC_Y": 256,
    "GAME_DATE": 20191024,
    "Season": "2019-2020",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/10/24/0021900016/130/32e83455-19f8-42e6-8d4d-9c1c6bc64f8b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531247810747605477",
    "name": "The 2974 Collection #2484",
    "imageUrl": "https://arweave.net/vUNfZboR07gsmf7SL7LQ_vQ5vBFo7-DVnlkYkUrnaDY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2485,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": -21,
    "GAME_DATE": 20191024,
    "Season": "2019-2020",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/10/24/0021900016/314/b136ff64-d9a0-f2ae-b34b-a2cda4fd5f45_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289816644238096933",
    "name": "The 2974 Collection #2485",
    "imageUrl": "https://arweave.net/vFy1Ai2hYvsdk31cuyg6c4nJrcCR9Le0zzK3kPRyUB4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2019,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2486,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -5,
    "LOC_Y": 270,
    "GAME_DATE": 20191027,
    "Season": "2019-2020",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/10/27/0021900036/18/b89048f1-3a62-22dd-c169-631573b9b4bb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/459824788630055134",
    "name": "The 2974 Collection #2486",
    "imageUrl": "https://arweave.net/UGKuRQEU2gMaSAPxM54LzigPN41OPPHUoJYQgSoSKFU?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2019,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2487,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 10,
    "LOC_Y": 301,
    "GAME_DATE": 20191027,
    "Season": "2019-2020",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/10/27/0021900036/48/450e3b8c-5626-e817-9641-ee011ac0ed31_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366729808409040993",
    "name": "The 2974 Collection #2487",
    "imageUrl": "https://arweave.net/rVkd94oV3kjz62zBJKaRO_g4dFAyKh5T4Pcjypek96Y?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2019,
    "Month": 10,
    "Day": 27,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2488,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 176,
    "LOC_Y": 195,
    "GAME_DATE": 20191028,
    "Season": "2019-2020",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/10/28/0021900047/210/db099096-dce2-4cd7-ec3b-b122a51cf251_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503435407381794218",
    "name": "The 2974 Collection #2488",
    "imageUrl": "https://arweave.net/kkle3HEIfgaxACj80dS28eVR00ef89Vykn-nSwZXtzc?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2489,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 239,
    "LOC_Y": 10,
    "GAME_DATE": 20191028,
    "Season": "2019-2020",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/10/28/0021900047/246/399084c2-18fc-cb01-e2d4-d019754bccad_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520759813096438084",
    "name": "The 2974 Collection #2489",
    "imageUrl": "https://arweave.net/S_JUSd3m3rUl8mEykyJQCgjKIOefJ4I-wEkpuAoeY7c?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2490,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -75,
    "LOC_Y": 281,
    "GAME_DATE": 20191028,
    "Season": "2019-2020",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/10/28/0021900047/379/5f8f7da8-23f1-d171-3b96-4f90c48326cd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357465029311146353",
    "name": "The 2974 Collection #2490",
    "imageUrl": "https://arweave.net/yTB7o59XFGVWFPL4SGt7gFk7oSh9bBYFm8s-N5gzykc?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2491,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 138,
    "LOC_Y": 256,
    "GAME_DATE": 20191028,
    "Season": "2019-2020",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/10/28/0021900047/634/d1566d91-4ddf-8dca-aa46-2199b2c02961_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512834691154356044",
    "name": "The 2974 Collection #2491",
    "imageUrl": "https://arweave.net/eugakOJYKqCuj2xQkGS4yw914P_UGnBezotfHfWsbeE?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2019,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2492,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -196,
    "LOC_Y": 163,
    "GAME_DATE": 20191030,
    "Season": "2019-2020",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2019/10/30/0021900065/20/65cc37e3-abd6-9807-1123-c9fb5dec73bd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489736572352986925",
    "name": "The 2974 Collection #2492",
    "imageUrl": "https://arweave.net/wbiqns4WP-wp4A1btSfkeaL4B4e1veBpvEYrtwAbgVo?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2019,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2493,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -133,
    "LOC_Y": 255,
    "GAME_DATE": 20200305,
    "Season": "2019-2020",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/03/05/0021900929/228/79c0bff9-1fd9-35d2-8918-7f283b538d95_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/448374119959244581",
    "name": "The 2974 Collection #2493",
    "imageUrl": "https://arweave.net/wT0HbyBbWe6KMlEqP28D32OI00UKxDSgDWm5Zae1tmA?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2020,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2494,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 173,
    "LOC_Y": 269,
    "GAME_DATE": 20200305,
    "Season": "2019-2020",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/03/05/0021900929/289/05319ff2-2520-7b22-15af-d86c3d321295_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497349568629784732",
    "name": "The 2974 Collection #2494",
    "imageUrl": "https://arweave.net/RAPauRzZYrbU347qcB6cKCuMmB4nF98gjVYKwyRRhv8?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2020,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2495,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 112,
    "LOC_Y": 288,
    "GAME_DATE": 20200305,
    "Season": "2019-2020",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/03/05/0021900929/398/c92f228b-4cd7-6f37-1145-1d66cdbcc60a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484189489328120772",
    "name": "The 2974 Collection #2495",
    "imageUrl": "https://arweave.net/8f1msH01wS-deqVUqi_cVeZedcY6kRFCnvokTOrsQUI?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2020,
    "Month": 3,
    "Day": 5,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2496,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 74,
    "LOC_Y": 243,
    "GAME_DATE": 20201222,
    "Season": "2020-2021",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/22/0022000001/165/ae3b548f-71d4-9725-2c89-8cf67bcfa7a3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/414678838628945521",
    "name": "The 2974 Collection #2496",
    "imageUrl": "https://arweave.net/Y8cy5PGH0rw7tTG1Yr8SbgZhgKbAPOPQGPTgUDnjnXE?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2020,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2497,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 136,
    "LOC_Y": 216,
    "GAME_DATE": 20201222,
    "Season": "2020-2021",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/22/0022000001/275/dfb45a3d-2b34-03fd-ce19-bea187bfc33c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/409948971807770835",
    "name": "The 2974 Collection #2497",
    "imageUrl": "https://arweave.net/3lFITCyLk2hRPx1io9RFn-sWvSvpSnAuT-VyGtyclJ0?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2020,
    "Month": 12,
    "Day": 22,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2498,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -234,
    "LOC_Y": 57,
    "GAME_DATE": 20201225,
    "Season": "2020-2021",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/25/0022000006/293/a25d723f-edf1-a16a-5c1e-f9b0acb72e59_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334611530357613563",
    "name": "The 2974 Collection #2498",
    "imageUrl": "https://arweave.net/0_2qT-ajVP1W3cp35sbKdCGQHVgOqK8knOj9T_ixNIk?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2020,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "Christmas",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2499,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -22,
    "LOC_Y": 286,
    "GAME_DATE": 20201225,
    "Season": "2020-2021",
    "HTM": "MIL",
    "VTM": "GSW",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/25/0022000006/389/663cd348-d5d6-3db7-d836-5b5157346634_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324489655470510182",
    "name": "The 2974 Collection #2499",
    "imageUrl": "https://arweave.net/dHNifNMrbHytGuVKrclwSybxlOBVPwdMsG12SaUEegw?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2020,
    "Month": 12,
    "Day": 25,
    "3-Pointers made in the game": 2,
    "Special Moment": "Christmas",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2500,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -164,
    "LOC_Y": 199,
    "GAME_DATE": 20201227,
    "Season": "2020-2021",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/27/0022000038/166/d3c051b0-1a7d-c071-4087-fa2a2d8eca06_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/554049564793940566",
    "name": "The 2974 Collection #2500",
    "imageUrl": "https://arweave.net/8JPO2tf4eLd7dJGqfYeG7X0Fd7ueYklPn35U761FtJw?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2020,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2501,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 228,
    "LOC_Y": 3,
    "GAME_DATE": 20201227,
    "Season": "2020-2021",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/27/0022000038/454/27ecea14-38ed-9480-6c14-d2008e4c3d1c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575228149347933061",
    "name": "The 2974 Collection #2501",
    "imageUrl": "https://arweave.net/F4fCURke-yZxH73pHd2VOicR_mZD6BffkvlTTIRhziE?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2020,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2502,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -147,
    "LOC_Y": 281,
    "GAME_DATE": 20201227,
    "Season": "2020-2021",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/27/0022000038/545/3c6f931f-3511-ea81-11bd-e79910c1c15e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327902952410700056",
    "name": "The 2974 Collection #2502",
    "imageUrl": "https://arweave.net/f2Z0U2JcBO3QLjK7dwtYjV0GyNFZyaO7dN7LZMQ7a_E?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2020,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2503,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -216,
    "LOC_Y": 108,
    "GAME_DATE": 20201227,
    "Season": "2020-2021",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/27/0022000038/641/1262077d-1bca-9643-b61d-8ce936bbf8ba_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/451188678149714801",
    "name": "The 2974 Collection #2503",
    "imageUrl": "https://arweave.net/Mr-1GS9V39iOqryRjsfOGjpNluDrXP84BpOAUxOs688?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2020,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2504,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -171,
    "LOC_Y": 168,
    "GAME_DATE": 20201227,
    "Season": "2020-2021",
    "HTM": "CHI",
    "VTM": "GSW",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/27/0022000038/707/f484d05b-27e2-f961-9608-43cfe0f26415_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561298764334731609",
    "name": "The 2974 Collection #2504",
    "imageUrl": "https://arweave.net/RDZAixLoAtsGgAMOFyhiuGL2sk-jR8svIHJ5h31kR54?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2020,
    "Month": 12,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2505,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -92,
    "LOC_Y": 276,
    "GAME_DATE": 20201229,
    "Season": "2020-2021",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/29/0022000047/166/31a708f8-19fa-5402-3b46-99e82190f483_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/376678806009122155",
    "name": "The 2974 Collection #2505",
    "imageUrl": "https://arweave.net/xj0_IWy2LosAm2HIx8oDRKWH4qGcyXaWSswvtuAWM9U?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2020,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2506,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 117,
    "LOC_Y": 230,
    "GAME_DATE": 20201229,
    "Season": "2020-2021",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/29/0022000047/413/f85a6962-f4b4-406c-ec72-8af0f40b5867_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525393921465342629",
    "name": "The 2974 Collection #2506",
    "imageUrl": "https://arweave.net/_udpgfjLsJ_oEw7SJRmOJxa6k9_mqCUz_A0cuvW6exE?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2020,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2507,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -137,
    "LOC_Y": 283,
    "GAME_DATE": 20201229,
    "Season": "2020-2021",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/29/0022000047/442/172fe5fc-92eb-48fe-103a-f432d65d9911_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309142563897621010",
    "name": "The 2974 Collection #2507",
    "imageUrl": "https://arweave.net/_uLBaaAgOlMxKgfX04umwXVott0l9yPh7F17Kw3ugnU?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2020,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2508,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 172,
    "LOC_Y": 185,
    "GAME_DATE": 20201229,
    "Season": "2020-2021",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/29/0022000047/538/f98536be-1cc8-46aa-73db-d77e43a5e00f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/315909531265730540",
    "name": "The 2974 Collection #2508",
    "imageUrl": "https://arweave.net/cyRI_QSDcnBkiH0c-MYhaVxyIhD1-Qp0_-d6j2VX-8o?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2020,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2509,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 183,
    "LOC_Y": 185,
    "GAME_DATE": 20201229,
    "Season": "2020-2021",
    "HTM": "DET",
    "VTM": "GSW",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2020/12/29/0022000047/667/2ff4aadb-5222-c635-8824-41484a1fced9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300811555614274033",
    "name": "The 2974 Collection #2509",
    "imageUrl": "https://arweave.net/Rk3EKdVqGTxn1TL10AZ0ruGZ-5ln3D5ieKbkAO3Wezw?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2020,
    "Month": 12,
    "Day": 29,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2510,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 26,
    "LOC_Y": 275,
    "GAME_DATE": 20210101,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/01/0022000078/39/259e5d84-305d-efe9-f040-3e54c6da7923_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433387098124307051",
    "name": "The 2974 Collection #2510",
    "imageUrl": "https://arweave.net/d_UgbzlP6ye5JlTahlo8wVmlzaSO9iCtIv9Ff7QqgJQ?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "New Year's",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2511,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -185,
    "LOC_Y": 199,
    "GAME_DATE": 20210101,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/01/0022000078/412/a1a80d75-df52-ccd4-6d07-fd480f593011_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/503275624324184588",
    "name": "The 2974 Collection #2511",
    "imageUrl": "https://arweave.net/cqGXJ050Niqw_VIrGtcXejR1hFe4UBUF5cwcsCCs5Vg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "New Year's",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2512,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": 22,
    "GAME_DATE": 20210101,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/01/0022000078/479/c9ee7b6c-9129-2b9c-e569-d38c1ab3c08a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/534104923420790375",
    "name": "The 2974 Collection #2512",
    "imageUrl": "https://arweave.net/2kq4cTWEgL8790mGPI-7i102r2iDYmmdH2Fgw59qldc?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "New Year's",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2513,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -211,
    "LOC_Y": 137,
    "GAME_DATE": 20210101,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/01/0022000078/505/9a91599a-360b-5060-2235-e81a51d73ef8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501131555467810263",
    "name": "The 2974 Collection #2513",
    "imageUrl": "https://arweave.net/Y1um870xgTaMFb8Q8jwQnFZ6iAI0jkPZYN3XoG-FsWk?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 1,
    "3-Pointers made in the game": 4,
    "Special Moment": "New Year's",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2514,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -155,
    "LOC_Y": 211,
    "GAME_DATE": 20210103,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/03/0022000092/72/a69c20f4-c05e-7a8f-d153-f53f00d1fc21_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297119956935833243",
    "name": "The 2974 Collection #2514",
    "imageUrl": "https://arweave.net/8UucIulm87VyjVCAUym7SuIymWI1d7eM9WFmvZfR2mw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (62 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2515,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 143,
    "LOC_Y": 221,
    "GAME_DATE": 20210103,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/03/0022000092/157/4f7b789e-009b-a41b-15ac-5f173e755373_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335415787192285678",
    "name": "The 2974 Collection #2515",
    "imageUrl": "https://arweave.net/LoCRS1OwunT28B2okfjqtS_yNenUaPTyAGrtLklOPls?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (62 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2516,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 52,
    "LOC_Y": 263,
    "GAME_DATE": 20210103,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/03/0022000092/310/2bd7d62a-1e73-e947-3ba4-04f0f27931e4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/398036067916300674",
    "name": "The 2974 Collection #2516",
    "imageUrl": "https://arweave.net/DUxAeG7FxBncnxLZ6Nh2Lkr0YCASnk8la626xTnnUaw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (62 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2517,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 114,
    "LOC_Y": 260,
    "GAME_DATE": 20210103,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/03/0022000092/462/6b394b90-2497-ab76-503f-4fb506f7c8bb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354265539326206408",
    "name": "The 2974 Collection #2517",
    "imageUrl": "https://arweave.net/d0ds-jNg6wByoVrz5lPAO6pvf_8CRlyIa8HwfhyussA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (62 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2518,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 119,
    "LOC_Y": 258,
    "GAME_DATE": 20210103,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/03/0022000092/524/2c9e3019-5786-c125-99c4-6619e4a853c3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484357043693870826",
    "name": "The 2974 Collection #2518",
    "imageUrl": "https://arweave.net/aBZ1Y25YEvOdxhGomRipA5rdVqSafhGebdg-KRC-ncY?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (62 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2519,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -182,
    "LOC_Y": 176,
    "GAME_DATE": 20210103,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/03/0022000092/618/06e8ec62-8a39-238c-b029-802803816a75_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500250582770730430",
    "name": "The 2974 Collection #2519",
    "imageUrl": "https://arweave.net/sn0_NsqeX0ZdvMmpeneg4uWksEVQScJqMH2O1IHLAsA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (62 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2520,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -128,
    "LOC_Y": 235,
    "GAME_DATE": 20210103,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/03/0022000092/722/f701e398-0b5d-17a7-a07c-3f00e638fec6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388069391955662016",
    "name": "The 2974 Collection #2520",
    "imageUrl": "https://arweave.net/3pb_pm6KBwjxhAZA7NsTR11y30UrrZlDNm1WgcZbPj4?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (62 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2521,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -211,
    "LOC_Y": 164,
    "GAME_DATE": 20210103,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/03/0022000092/726/ef351c7f-9b4f-d9a9-e277-9d8bdeb4577b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436580876515018773",
    "name": "The 2974 Collection #2521",
    "imageUrl": "https://arweave.net/CJpuhZqzuSRkrKAgn36cjfQAOfW8Ty0hwRuYx0r5h4E?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 1,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game (62 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2522,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 190,
    "LOC_Y": 174,
    "GAME_DATE": 20210104,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/04/0022000101/94/36a6fd13-db39-d05a-4460-6346049009eb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548568138269740920",
    "name": "The 2974 Collection #2522",
    "imageUrl": "https://arweave.net/ZkAfEWePW_3o7xWuRhxayJDRCWbF8frPfiZ_czVZ1iU?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2523,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -161,
    "LOC_Y": 197,
    "GAME_DATE": 20210104,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/04/0022000101/126/2c304ebd-0ab9-aef7-d854-40f27f60c61d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499647952392097960",
    "name": "The 2974 Collection #2523",
    "imageUrl": "https://arweave.net/LC4iQd_7nrjGWi9jTCTLQIplmFUD0T71tmJnAcVutd8?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2524,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": 127,
    "LOC_Y": 295,
    "GAME_DATE": 20210104,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/04/0022000101/311/2ed2b39a-4dc9-d2a2-a3c0-18c67f9dff52_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/477965774054458416",
    "name": "The 2974 Collection #2524",
    "imageUrl": "https://arweave.net/7bsXArnquUPFRqkTOVxkgt154xhQXs4cnyY6vGsnbSo?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2525,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -45,
    "LOC_Y": 283,
    "GAME_DATE": 20210104,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/04/0022000101/350/3753c264-903d-cdef-b154-873bd7f15875_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/443499739874750605",
    "name": "The 2974 Collection #2525",
    "imageUrl": "https://arweave.net/kaN4jinMm1TgdTPu8N4Q3Z8-pjRsu1CLxJrDcmxiQto?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2526,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 128,
    "LOC_Y": 281,
    "GAME_DATE": 20210104,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/04/0022000101/531/6ee983b1-6e30-0310-6731-36cee9798407_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/380741728167753762",
    "name": "The 2974 Collection #2526",
    "imageUrl": "https://arweave.net/Fx99PlrADNvfKJ7iCUUBU5fltWkGVF_FypJXYLjBzkc?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 1,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2527,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 18,
    "LOC_Y": 277,
    "GAME_DATE": 20210106,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/06/0022000116/330/1dc4fa5e-6749-8027-285f-e20ee5b26454_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/560688562168697360",
    "name": "The 2974 Collection #2527",
    "imageUrl": "https://arweave.net/cIN8qq5yKJf5n6iMw5OadOjuCRMYIOBNyy07z95qEkQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 6,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2528,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -133,
    "LOC_Y": 253,
    "GAME_DATE": 20210108,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/08/0022000130/13/d9a0ad99-ef74-de50-9354-e82913ae2ed2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/289994457913798785",
    "name": "The 2974 Collection #2528",
    "imageUrl": "https://arweave.net/iqyju6pRVfbd1Dhj7v0FQ4ZC-24tnLinuS0SBWGKuyQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2529,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -130,
    "LOC_Y": 242,
    "GAME_DATE": 20210108,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/08/0022000130/85/aa5d0b9e-7eef-2ee0-8ba2-5b16a5b5816d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552100174896547683",
    "name": "The 2974 Collection #2529",
    "imageUrl": "https://arweave.net/uSiwuiWE58uniKPg55BNZG0MoPvKY3l2sFJ78ZN-0eQ?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2530,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 144,
    "LOC_Y": 218,
    "GAME_DATE": 20210108,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/08/0022000130/144/9df0c877-8ffb-83fc-3270-f0b0866f8708_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/477953125836796040",
    "name": "The 2974 Collection #2530",
    "imageUrl": "https://arweave.net/I-ex-khkVNSX8XnGUiO_GFNjOPnQYjNdYwkzl0YZBgs?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2531,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -138,
    "LOC_Y": 236,
    "GAME_DATE": 20210108,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/08/0022000130/239/31604607-c329-f126-8e66-ac81a8dd09bb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436852561785409742",
    "name": "The 2974 Collection #2531",
    "imageUrl": "https://arweave.net/w0jrI6kE_wyA21cm97t3l0agd1_Urn79wbFGiKwrNqI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2532,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -95,
    "LOC_Y": 251,
    "GAME_DATE": 20210108,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/08/0022000130/394/4cee9e7b-c5c7-497a-97ba-7c716ee5bd51_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561677461650923316",
    "name": "The 2974 Collection #2532",
    "imageUrl": "https://arweave.net/WsKxBY0LbM50jAzDKgU7PSGKF_v-0LOYmZCYp8h0MUM?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2533,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 130,
    "LOC_Y": 232,
    "GAME_DATE": 20210108,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/08/0022000130/446/0d2e1ab0-ce60-b0da-1fd2-34486d5441a6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346542225404517380",
    "name": "The 2974 Collection #2533",
    "imageUrl": "https://arweave.net/OTmeofbopJmfnKBzW62gl190JNwnu--llTJyUirrjUI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2534,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 143,
    "LOC_Y": 246,
    "GAME_DATE": 20210108,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/08/0022000130/484/4ae3e910-b85d-e309-1d10-3c9e131219e4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/477151894710374680",
    "name": "The 2974 Collection #2534",
    "imageUrl": "https://arweave.net/iB26FVjD2_ucORIcWwNAnOhw7hu1_w9M8N90d_WwiRU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2535,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 160,
    "LOC_Y": 239,
    "GAME_DATE": 20210108,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/08/0022000130/498/72fd165a-c8b1-b763-b17b-b6c0fa791b52_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/383024264367112380",
    "name": "The 2974 Collection #2535",
    "imageUrl": "https://arweave.net/IXpcD0_TjqWniXXfYp34iwiiaLjfNKHeRrjuiJ59_ag?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2536,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 145,
    "LOC_Y": 199,
    "GAME_DATE": 20210108,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/08/0022000130/615/9447137a-619a-12c8-1b91-542312bc43ec_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326209298627749291",
    "name": "The 2974 Collection #2536",
    "imageUrl": "https://arweave.net/pyE7-L8DeqcCInhO73KL-9TGG2f_xJS4uOfNt54HZVY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2537,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 163,
    "LOC_Y": 190,
    "GAME_DATE": 20210110,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/10/0022000148/651/b14a60fb-5e9e-e48c-4fda-fc29dda74a97_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456213557483097068",
    "name": "The 2974 Collection #2537",
    "imageUrl": "https://arweave.net/2wUtRgMUujTL3zqSomfjK5g44r1nHfMxYrNiBJjPoPs?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2021,
    "Month": 1,
    "Day": 10,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2538,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -199,
    "LOC_Y": 159,
    "GAME_DATE": 20210112,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/12/0022000163/386/5f9e2fca-6379-1e48-9d96-55d24a42a8a6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508187474242844971",
    "name": "The 2974 Collection #2538",
    "imageUrl": "https://arweave.net/km9_h_MUIwKsXAGzMViB7OYH3bhqdPTikTB9v8zIM7A?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2021,
    "Month": 1,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2539,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -206,
    "LOC_Y": 132,
    "GAME_DATE": 20210112,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/12/0022000163/461/7fd9afc5-7e30-b2e8-c50a-ee4ec336fbbe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/570563867784065201",
    "name": "The 2974 Collection #2539",
    "imageUrl": "https://arweave.net/aidfr2aXCvING4W7ynoA7cktZ-TVP60mtd71lGP9u5U?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2021,
    "Month": 1,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2540,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -112,
    "LOC_Y": 230,
    "GAME_DATE": 20210112,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "IND",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/12/0022000163/489/ab80f72e-d7b7-a2d0-4aa4-cafa3dce0e39_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/569957521676195618",
    "name": "The 2974 Collection #2540",
    "imageUrl": "https://arweave.net/NYE4EXkGq7PNU6fPoS07B-kAhqYN8j7U9Mi4aQVMK6s?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2021,
    "Month": 1,
    "Day": 12,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2541,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 172,
    "LOC_Y": 190,
    "GAME_DATE": 20210114,
    "Season": "2020-2021",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/14/0022000177/7/5e3a3bd3-dc57-a76d-9c55-2d6f9d694bf9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/403127789322189827",
    "name": "The 2974 Collection #2541",
    "imageUrl": "https://arweave.net/0Yfkr555HjWoieo2VD3qzrVDdgSnv0M0KlUVbkXeUso?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2542,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 226,
    "LOC_Y": 111,
    "GAME_DATE": 20210114,
    "Season": "2020-2021",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/14/0022000177/99/8c3a2e15-37cd-acc0-2a91-4cab9bcff860_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418641270549403741",
    "name": "The 2974 Collection #2542",
    "imageUrl": "https://arweave.net/i_8DGVICls_kDIYMcrOH8DH5Oqyl2MkReQVw43Omcts?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2543,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 87,
    "LOC_Y": 243,
    "GAME_DATE": 20210114,
    "Season": "2020-2021",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/14/0022000177/274/74c1b6c4-d32e-065a-3205-f40deab4d125_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/529455075601480971",
    "name": "The 2974 Collection #2543",
    "imageUrl": "https://arweave.net/VEYlm_FBA5mG0XscuYkCqypUtP8lTMQz48GFV-OlDnE?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2544,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -125,
    "LOC_Y": 233,
    "GAME_DATE": 20210114,
    "Season": "2020-2021",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/14/0022000177/384/8dabfbf3-2959-d2ab-f800-a743dc927c75_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385293622446414953",
    "name": "The 2974 Collection #2544",
    "imageUrl": "https://arweave.net/d3ksOIxkeVSYCNYf-gCztI-PgPhU-BOdsE5YYj1K4nQ?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2545,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 100,
    "LOC_Y": 260,
    "GAME_DATE": 20210114,
    "Season": "2020-2021",
    "HTM": "DEN",
    "VTM": "GSW",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/14/0022000177/447/146d864c-15fe-153d-fab4-419dc46ac058_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499600431464332107",
    "name": "The 2974 Collection #2545",
    "imageUrl": "https://arweave.net/X_MHPDNM-hUbUd0NhMe1OrwzmR22OhVPROQT0NAQTOw?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 1,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2546,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 130,
    "LOC_Y": 292,
    "GAME_DATE": 20210118,
    "Season": "2020-2021",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/18/0022000212/165/ed370c85-4a67-c042-febf-0212bcbe7f1e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348261663776334868",
    "name": "The 2974 Collection #2546",
    "imageUrl": "https://arweave.net/fiVDfaZjUJpPoFqlbsecsgmZszebPlrlGg6I7u8uwKc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2547,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 95,
    "LOC_Y": 228,
    "GAME_DATE": 20210118,
    "Season": "2020-2021",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/18/0022000212/406/e4fe08a7-7b60-1519-8a5d-4a261b9a9e16_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541963847828308647",
    "name": "The 2974 Collection #2547",
    "imageUrl": "https://arweave.net/V9KxTmdtRcmu3_LuOFb3lRFG_WfmAUDK5ONzBpLZcvc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2548,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -1,
    "LOC_Y": 277,
    "GAME_DATE": 20210118,
    "Season": "2020-2021",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/18/0022000212/656/98aa1d83-a2b0-bc86-5782-da561ebca6fd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498676570355041119",
    "name": "The 2974 Collection #2548",
    "imageUrl": "https://arweave.net/2zn0XWE3yRAgbRd1HrahWKsfE9SaI3ee0CliSTm3LGA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 1,
    "Day": 18,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2549,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -196,
    "LOC_Y": 162,
    "GAME_DATE": 20210120,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/20/0022000223/108/b6f89999-7f92-61a2-ae31-9ffc86d28511_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391957237091721778",
    "name": "The 2974 Collection #2549",
    "imageUrl": "https://arweave.net/fMXII3-XhT0UxEIUs20iVBiHev5JPBj4D4hHaQ06fWI?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2550,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 157,
    "LOC_Y": 225,
    "GAME_DATE": 20210120,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/20/0022000223/136/c449e8e7-719e-3a3f-76c3-b79984d28d00_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301149983319925578",
    "name": "The 2974 Collection #2550",
    "imageUrl": "https://arweave.net/dS4mGu4JraGyBkoM_GGD9sY-NGSpzm9d2F9mWTccU_Y?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2551,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 39,
    "LOC_Y": 274,
    "GAME_DATE": 20210120,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/20/0022000223/299/b3250b5b-61d4-70d5-6244-8ce4c3ec7c4c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336106529389373257",
    "name": "The 2974 Collection #2551",
    "imageUrl": "https://arweave.net/xS4ZP8zayxyBpvWQDKMI7kkg5zJuhuZn9qZqkhREzXw?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2552,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -188,
    "LOC_Y": 183,
    "GAME_DATE": 20210120,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/20/0022000223/325/69c89ada-d0b3-58ca-408c-25000517b19a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386306054774660006",
    "name": "The 2974 Collection #2552",
    "imageUrl": "https://arweave.net/vguzm3DAHkvLDA7JzZPv06f6euKczZR4oDvkcyq_WHs?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 1,
    "Day": 20,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2553,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 216,
    "LOC_Y": 146,
    "GAME_DATE": 20210121,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/21/0022000228/144/7a99bf63-3de3-68cf-887c-feb19257bc6e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572376541724195659",
    "name": "The 2974 Collection #2553",
    "imageUrl": "https://arweave.net/ZQCjxaT85KT1kxM1dUAUiZfVxk5G5Z2JGNnV2jmdVdo?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2554,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 222,
    "LOC_Y": 138,
    "GAME_DATE": 20210121,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/21/0022000228/161/469ffcf3-6abd-feab-0a81-0578724385e7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327280120427246605",
    "name": "The 2974 Collection #2554",
    "imageUrl": "https://arweave.net/FlMIkbTrc668CmT4ggVu3d4-viey5AeIzRbdpFQ-IEc?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2555,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 53,
    "LOC_Y": 273,
    "GAME_DATE": 20210121,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/21/0022000228/316/a2dd4d6c-670c-0c96-4127-f8d6f92be525_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/409489305572838754",
    "name": "The 2974 Collection #2555",
    "imageUrl": "https://arweave.net/SpGA1xwrklztWCRpjpaXczI4j7xlif8lnil-KBsvzdo?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2556,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 165,
    "LOC_Y": 198,
    "GAME_DATE": 20210121,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/21/0022000228/665/886a34d4-7d16-f459-2b47-6429687f303d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/343020132209128851",
    "name": "The 2974 Collection #2556",
    "imageUrl": "https://arweave.net/rcvhMCkRATxSqhM15StSedDeDwSfC9AVzSKTtvnAuH4?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2557,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": 105,
    "LOC_Y": 310,
    "GAME_DATE": 20210121,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "NYK",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/21/0022000228/679/25284023-cb81-8480-aa47-a14dba62e03b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363542172113209874",
    "name": "The 2974 Collection #2557",
    "imageUrl": "https://arweave.net/O3Bw4A8E6aANRxf65ITWgfdTAKOrStnXl9L8UnV0QjM?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 1,
    "Day": 21,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2558,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -111,
    "LOC_Y": 237,
    "GAME_DATE": 20210123,
    "Season": "2020-2021",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/23/0022000242/59/2b0ef601-1458-8197-1829-8587a3895187_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/430743292357442849",
    "name": "The 2974 Collection #2558",
    "imageUrl": "https://arweave.net/TsOTnqzigCLmuAgReI9dwbJQBXfuBHc7yJhxeoXmmBo?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2559,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 231,
    "LOC_Y": 183,
    "GAME_DATE": 20210123,
    "Season": "2020-2021",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/23/0022000242/63/c395842b-dcdf-8967-116c-cc0169bb0469_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/383123803546052498",
    "name": "The 2974 Collection #2559",
    "imageUrl": "https://arweave.net/47qGvYrr4fd7xvfXraj1gmkN3JrPl35KVvzF_g40dsM?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2560,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 116,
    "LOC_Y": 269,
    "GAME_DATE": 20210123,
    "Season": "2020-2021",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/23/0022000242/304/45fcfd1d-2db4-a7bf-07dd-de8c347657e6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547442844558088062",
    "name": "The 2974 Collection #2560",
    "imageUrl": "https://arweave.net/ssscnd3MeN3dhQ92943gPZcHw8Dfy8UHQSBXAT1a7gA?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2561,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 26,
    "GAME_DATE": 20210123,
    "Season": "2020-2021",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/23/0022000242/356/bbb1d56a-b9df-de28-61fa-21b2260261ba_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/496116797187583528",
    "name": "The 2974 Collection #2561",
    "imageUrl": "https://arweave.net/YnTCMUgvoNeA8J2QKxmvEDrqHoQuOuKoDRaJyeoG9vo?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2562,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 91,
    "LOC_Y": 241,
    "GAME_DATE": 20210123,
    "Season": "2020-2021",
    "HTM": "UTA",
    "VTM": "GSW",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/23/0022000242/429/c0d34704-f7ba-38df-b42f-5344cab205d2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450810912954248321",
    "name": "The 2974 Collection #2562",
    "imageUrl": "https://arweave.net/6ggCbVHUo-IsGrBD4Rp8e---s9dC5Y4hrSJdjQAGRHk?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 1,
    "Day": 23,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2563,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -172,
    "LOC_Y": 259,
    "GAME_DATE": 20210125,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/25/0022000266/40/b2810325-6186-82c8-11f4-b59c98e85f2d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474727997607413914",
    "name": "The 2974 Collection #2563",
    "imageUrl": "https://arweave.net/_POj2mjkMnSQNC18Anx7yEjsDqM4OphNffjFMSEMWr4?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2564,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 199,
    "LOC_Y": 170,
    "GAME_DATE": 20210125,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/25/0022000266/62/69e9463f-6585-14b2-f246-73ce639964ae_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/517007860068102412",
    "name": "The 2974 Collection #2564",
    "imageUrl": "https://arweave.net/n_4KTmKHTb9HXQmxLa2fuJFiWt9dDgkD1Af7BiWziM4?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2565,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 158,
    "LOC_Y": 211,
    "GAME_DATE": 20210125,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/25/0022000266/282/c795b3b2-a7bf-15a1-1527-6a9a5af60b74_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428368800021744775",
    "name": "The 2974 Collection #2565",
    "imageUrl": "https://arweave.net/a2vrnoydLfmdio1SgzCnqNwIlLquRRWleh-c7rqHrnk?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2566,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -179,
    "LOC_Y": 185,
    "GAME_DATE": 20210125,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/25/0022000266/419/331e952a-de28-bed9-1279-5a103b79b277_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499846826931364674",
    "name": "The 2974 Collection #2566",
    "imageUrl": "https://arweave.net/QRWZiVr4JWH_uXCuHZt6d-8w-o7_A8rbUfJFe3M2dIo?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2567,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -43,
    "LOC_Y": 281,
    "GAME_DATE": 20210125,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/25/0022000266/619/6d95eafc-dba4-3526-b343-c5e9b865bcdb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500528225684586048",
    "name": "The 2974 Collection #2567",
    "imageUrl": "https://arweave.net/ucJ1FH6F2M5gV3g-T29FyXh6yOwBQfnqAJN7AcnAfcc?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2568,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -113,
    "LOC_Y": 264,
    "GAME_DATE": 20210125,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/25/0022000266/635/3e785ec7-aad4-76c2-4f65-d17ecbeccfec_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300266138883471376",
    "name": "The 2974 Collection #2568",
    "imageUrl": "https://arweave.net/C4A1IpZHVNcbxBwndzf0PnHJessa7XK2asjUqSBeorw?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2569,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -38,
    "LOC_Y": 261,
    "GAME_DATE": 20210125,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/25/0022000266/671/15de742d-0c50-0400-4996-082c79d5d054_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521582997870371955",
    "name": "The 2974 Collection #2569",
    "imageUrl": "https://arweave.net/mVNgLhRZI7NCtuCjeowXJDKkQ8zGJfPTvKmNNN9UUaE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2570,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -190,
    "LOC_Y": 180,
    "GAME_DATE": 20210127,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/27/0022000283/378/44b21eac-8879-9c84-45aa-8bac7eabe645_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/393655863107197408",
    "name": "The 2974 Collection #2570",
    "imageUrl": "https://arweave.net/H2wPPbD-DrwsLLtCMfGULmxIlhiITy_lYlNJ2zDuLpo?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2571,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -169,
    "LOC_Y": 176,
    "GAME_DATE": 20210127,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/27/0022000283/465/585688cf-5c78-265a-073f-1f8328eaa923_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/314220877601793800",
    "name": "The 2974 Collection #2571",
    "imageUrl": "https://arweave.net/ETyjlj5ao0C2s-jTvKfdASt9xPNnCew00IEdRcPpIIk?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2572,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -222,
    "LOC_Y": -12,
    "GAME_DATE": 20210127,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/27/0022000283/507/6c8d323e-22f4-d626-ab0f-878b85d80cde_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/376120014911199691",
    "name": "The 2974 Collection #2572",
    "imageUrl": "https://arweave.net/XBrVnTBJhhXHRXocpMh-Ta3kF97s-VKLOT4T8z_bCPE?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2573,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 43,
    "LOC_Y": 269,
    "GAME_DATE": 20210127,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/27/0022000283/525/e6e4110b-054a-ed4e-895a-0d799493b73a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406783639749465603",
    "name": "The 2974 Collection #2573",
    "imageUrl": "https://arweave.net/rXVJeGE2Z3Ayu4fD5-7dczUCxjWp8JDJvvwkknEQwcM?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 1,
    "Day": 27,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2574,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 58,
    "LOC_Y": 252,
    "GAME_DATE": 20210128,
    "Season": "2020-2021",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/28/0022000286/23/7fe72423-fd05-91a7-21a3-64373c64e84a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/372467871552211258",
    "name": "The 2974 Collection #2574",
    "imageUrl": "https://arweave.net/Ht8d4G31UnRoNoGX8AyHRZYTtlcZ56wONhh4-hBrjIo?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2575,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -216,
    "LOC_Y": 127,
    "GAME_DATE": 20210128,
    "Season": "2020-2021",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/28/0022000286/54/af377e85-5edc-97d6-d6ec-b9e51b9a3443_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536227049722423719",
    "name": "The 2974 Collection #2575",
    "imageUrl": "https://arweave.net/mkC7TW_gsE1loUyc0_keHzXzxSakR6uL1_lHf24wewY?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2576,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -13,
    "LOC_Y": 260,
    "GAME_DATE": 20210128,
    "Season": "2020-2021",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/28/0022000286/155/ed3c92c0-2fa6-1de5-2c9f-ce2a20a8a156_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/535710502417311405",
    "name": "The 2974 Collection #2576",
    "imageUrl": "https://arweave.net/GJ1-_Yave7XjooKGY_-rBJqb9T7raBmJrAPbGIJ7ntM?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2577,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -141,
    "LOC_Y": 206,
    "GAME_DATE": 20210128,
    "Season": "2020-2021",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/28/0022000286/336/64db50ff-80c8-6578-b3c8-2ae544dcb94c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428806500672520672",
    "name": "The 2974 Collection #2577",
    "imageUrl": "https://arweave.net/HTmPOlv6LKdGLMoAwbgsTP9cn1uGe-OqVYfZKB0Z1H8?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2578,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -137,
    "LOC_Y": 238,
    "GAME_DATE": 20210128,
    "Season": "2020-2021",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/28/0022000286/350/304c631f-67a3-ba29-d412-a6d8a92fe1a2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/538109278819803233",
    "name": "The 2974 Collection #2578",
    "imageUrl": "https://arweave.net/_BPnTpT-yd4b_YY0CAEqsAa6CHBtafbTWEzLt3O1xEw?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 1,
    "Day": 28,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2579,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -54,
    "LOC_Y": 258,
    "GAME_DATE": 20210130,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/30/0022000305/15/d6d97b5c-a122-b4ce-7254-1f7e29371b85_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440459186395317544",
    "name": "The 2974 Collection #2579",
    "imageUrl": "https://arweave.net/CdnWrpKThQhTgEnt8KbSaTkl9MKmtx1_aeRO_iJ5izU?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2021,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2580,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 233,
    "LOC_Y": 62,
    "GAME_DATE": 20210130,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/30/0022000305/289/9a55899d-436d-bd95-6143-8dd0134c0c90_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565367519924289819",
    "name": "The 2974 Collection #2580",
    "imageUrl": "https://arweave.net/K1kAOjYH-lDZIA_FHhGlmY6Qxbq6oSFa-5yy__iB1HE?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2021,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2581,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 78,
    "LOC_Y": 279,
    "GAME_DATE": 20210130,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/30/0022000305/296/0fbda2ba-ea5f-4ef5-f92d-7788392eeacc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/426487785381102921",
    "name": "The 2974 Collection #2581",
    "imageUrl": "https://arweave.net/qcbc1CHMby_JRMJIRXjpzsLm9F61wuuqJkMbchBPSvI?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2021,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2582,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -135,
    "LOC_Y": 271,
    "GAME_DATE": 20210130,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/30/0022000305/356/20262298-c45f-3e4f-be2b-5924a30a877c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/410935447016037350",
    "name": "The 2974 Collection #2582",
    "imageUrl": "https://arweave.net/m3dA67stVanrJ2y-gEaDPqGHkeV6tcV_ZRVEYNxB78o?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2021,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2583,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 152,
    "LOC_Y": 263,
    "GAME_DATE": 20210130,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/30/0022000305/379/9b53098d-c1a0-a04d-a6f7-320adaa7eead_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/492255433230258652",
    "name": "The 2974 Collection #2583",
    "imageUrl": "https://arweave.net/1jNpfHsACWNp-UOA7IE1-8DB3lJeoT816aP_x4gYkKE?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2021,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2584,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -79,
    "LOC_Y": 252,
    "GAME_DATE": 20210130,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DET",
    "Opposing Team": "DET",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/01/30/0022000305/459/3188b855-db0e-843a-b6db-f3809bb077d0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/342296812636783957",
    "name": "The 2974 Collection #2584",
    "imageUrl": "https://arweave.net/ckhQwAyVjlpkolxcEFewx1zQExz80Oz9B0auaWr3uv8?ext=png",
    "Opposing Team City": "Detroit",
    "Year": 2021,
    "Month": 1,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2585,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 5,
    "LOC_Y": 263,
    "GAME_DATE": 20210202,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/02/0022000326/7/edbe97b6-6faa-a7e2-6e8b-dbb870abe827_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/405383407170767734",
    "name": "The 2974 Collection #2585",
    "imageUrl": "https://arweave.net/u6eNtPnN53bKe06A_9x6sBL_nTTCV2lLflzw6VfItM4?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2586,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 246,
    "LOC_Y": 30,
    "GAME_DATE": 20210202,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/02/0022000326/32/efb0bd79-b921-7046-8355-383f35668a89_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/332652239544122296",
    "name": "The 2974 Collection #2586",
    "imageUrl": "https://arweave.net/QWTcNcvc0MHzI4bu7Exw3bFv05TvEZKG_535-5CPGqQ?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2587,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 182,
    "LOC_Y": 240,
    "GAME_DATE": 20210202,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/02/0022000326/44/9210c90c-d4df-bd3b-0f43-0272ceac9ed5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474195386500438036",
    "name": "The 2974 Collection #2587",
    "imageUrl": "https://arweave.net/jbYE7vMurZWBdHnAjDnXSIuXjThoFhcfOIliCXdXO0I?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2588,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 74,
    "LOC_Y": 263,
    "GAME_DATE": 20210202,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/02/0022000326/101/505c2a1a-cb04-9770-81ee-a81797f3528b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/537788962990017693",
    "name": "The 2974 Collection #2588",
    "imageUrl": "https://arweave.net/trbcp0uRo5Lwsjr_NQwoizubIZ9PvS82ML8nphsYEzg?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2589,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 181,
    "LOC_Y": 199,
    "GAME_DATE": 20210202,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/02/0022000326/247/7ade73bd-c00a-7d24-5ebe-d723def09523_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/316973805639859237",
    "name": "The 2974 Collection #2589",
    "imageUrl": "https://arweave.net/EhuxUsN002UMbzzr98acWQpxsneM4i3R1xCRoDxG7So?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2590,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 180,
    "LOC_Y": 173,
    "GAME_DATE": 20210202,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/02/0022000326/461/147c97a7-44f5-72f3-a47e-ac9d76a0ae10_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441828539943259752",
    "name": "The 2974 Collection #2590",
    "imageUrl": "https://arweave.net/eDb0tvMkszPq_E_daSJg1v4hAvNHsgcyRHhfSIhoZg4?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2591,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 169,
    "LOC_Y": 252,
    "GAME_DATE": 20210202,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "BOS",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/02/0022000326/469/c7b0ddd7-c1f4-0c4f-5773-4f80175599e4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525018754812941220",
    "name": "The 2974 Collection #2591",
    "imageUrl": "https://arweave.net/gugbcBE1BtADpEO1blEF8qSHzprnEHAY5OKp3g4ftcs?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 2,
    "Day": 2,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2592,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 198,
    "LOC_Y": 157,
    "GAME_DATE": 20210204,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/04/0022000339/27/c7fa6c2f-ce56-b5a8-6e97-5e7dce3d66f5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/368497063112703376",
    "name": "The 2974 Collection #2592",
    "imageUrl": "https://arweave.net/k1I8c7u1-6x8j3ohyeSML1JnDG-QIUiKutUmzTArV_I?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2593,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 150,
    "LOC_Y": 202,
    "GAME_DATE": 20210204,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/04/0022000339/112/a7c5f6b9-f944-8e84-d23b-bb03f3c70315_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498188062700894159",
    "name": "The 2974 Collection #2593",
    "imageUrl": "https://arweave.net/nbTF5YCEzxEEJ9GSsjpckDSF--EHpslksZZGqVzmfEI?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2594,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -138,
    "LOC_Y": 235,
    "GAME_DATE": 20210204,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/04/0022000339/150/a73b585e-8bef-7dd2-0a74-d5c7abf03f5d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522910702783513269",
    "name": "The 2974 Collection #2594",
    "imageUrl": "https://arweave.net/fL_wSxTgcXc-R-ENZsLSVRyipq9ieQOwOauE3mahHN0?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2595,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -223,
    "LOC_Y": 110,
    "GAME_DATE": 20210204,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/04/0022000339/350/affc81b6-fcc6-3bea-2241-ad87441ecd98_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/405269623818961553",
    "name": "The 2974 Collection #2595",
    "imageUrl": "https://arweave.net/DyYH2ri2XNGrZAsB871VupDbhJhYmU6e6qyFryRjyS0?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 4,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2596,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 127,
    "LOC_Y": 221,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/76/f8a545b5-5c38-f434-1913-8021597c2d52_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/445747955133235610",
    "name": "The 2974 Collection #2596",
    "imageUrl": "https://arweave.net/ol50hx2y_ScBAZ8bZizLzZ-HtOVjRIh8_HWWu-vmpB8?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2597,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 109,
    "LOC_Y": 227,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/156/3ed8d778-2b83-cd6b-c8b6-9e99159b0201_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338760946304728421",
    "name": "The 2974 Collection #2597",
    "imageUrl": "https://arweave.net/RUgAOO4OiYx1q4AYsZ6vBnJbrIo2xmAHX3v3IA4n7Wg?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2598,
    "PERIOD": 2,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 206,
    "LOC_Y": 136,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/280/cf42b344-6976-2894-f119-61123c4b6478_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359742824955389079",
    "name": "The 2974 Collection #2598",
    "imageUrl": "https://arweave.net/6uZZNm4_ggt6QzPVGYeEoUHLbBCRb8H59Mr-2jKQAxM?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2599,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -212,
    "LOC_Y": 130,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/296/7f9625b8-0f3f-6878-ac2a-f994d7941a92_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490616235248104828",
    "name": "The 2974 Collection #2599",
    "imageUrl": "https://arweave.net/ucY-IiWFoz2wcAt60wtHd4UyEFhMoo5hRbNhiyXCivw?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2600,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 154,
    "LOC_Y": 211,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/320/f33724de-ef76-a601-8e77-8e7a3be855de_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493792206836917365",
    "name": "The 2974 Collection #2600",
    "imageUrl": "https://arweave.net/fHNEszCsZtGiNBVcfljELYqyq7OvR7olGG5QMaopg90?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2601,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -183,
    "LOC_Y": 174,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/340/bd753928-2d04-b167-e336-dbc8e93bacc0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411778045503025367",
    "name": "The 2974 Collection #2601",
    "imageUrl": "https://arweave.net/KVu6OIly7-WPdewynIj8RMczgKF-80VWX8VS_UCb00E?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2602,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -171,
    "LOC_Y": 196,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/343/be9872a5-ff26-4a50-42cc-eba69dc1f55e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/339821556913733211",
    "name": "The 2974 Collection #2602",
    "imageUrl": "https://arweave.net/UrMVXmywrYmtqxn6_4oqrDUGLeeiF-L2OrC9AQYui2I?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2603,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -183,
    "LOC_Y": 190,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/366/6d571983-83b7-8236-9082-ca1637cb28ff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/336218346618988980",
    "name": "The 2974 Collection #2603",
    "imageUrl": "https://arweave.net/PbQqos0PpUDogWOvkpO3HiVKFkX-f7S06aQLHLjmiEU?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2604,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 36,
    "LOC_X": -4,
    "LOC_Y": 368,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/402/72d7d602-25a0-14c2-80da-e807212aa19f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/458193687552707413",
    "name": "The 2974 Collection #2604",
    "imageUrl": "https://arweave.net/b7Es8MJ_08FpH5jvk9ZgqXLCnBV4tR6fXf9Fpqp1WoE?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2605,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -190,
    "LOC_Y": 177,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/446/11ec32a3-fd2b-731e-5ea3-412a5c017610_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440113813213412004",
    "name": "The 2974 Collection #2605",
    "imageUrl": "https://arweave.net/O01V9f7mb8kaqm0P-Lg9Nfkc8sve2kLZ9VZZPfJgtJs?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2606,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 88,
    "LOC_Y": 245,
    "GAME_DATE": 20210206,
    "Season": "2020-2021",
    "HTM": "DAL",
    "VTM": "GSW",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/06/0022000360/658/e7836aec-5f68-6e00-6a9b-995935fea4ae_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/313310287715298242",
    "name": "The 2974 Collection #2606",
    "imageUrl": "https://arweave.net/coSW0chhS68qI_rZFcShwEMFQIPR4M6o2TwoSJ3xLNM?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 2,
    "Day": 6,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game (57 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2607,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -204,
    "LOC_Y": 235,
    "GAME_DATE": 20210208,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/08/0022000371/64/700e10a9-e51e-b018-dd39-63a9ce7ec407_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474123477308286164",
    "name": "The 2974 Collection #2607",
    "imageUrl": "https://arweave.net/wF6ZfZs5md9vyHATlw9ud4710lmJpkHt2jzCjG2AGug?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2608,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 0,
    "LOC_Y": 241,
    "GAME_DATE": 20210208,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/08/0022000371/132/69082b99-c3bf-a2b0-36b9-6aaeb4376a65_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/306185435157198518",
    "name": "The 2974 Collection #2608",
    "imageUrl": "https://arweave.net/chWYaepnXwTCF4tNZqmssJQXTLfRQBx_FSo10T0nno8?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2609,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -143,
    "LOC_Y": 284,
    "GAME_DATE": 20210208,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/08/0022000371/155/97eb3e45-14db-1b83-ecf6-5a929470e7e6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/292077245522342162",
    "name": "The 2974 Collection #2609",
    "imageUrl": "https://arweave.net/UbTYQ7fBylPUDUvrMIB_v5pA7J3tNAJFoqyomKlDiuk?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2610,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -224,
    "LOC_Y": 123,
    "GAME_DATE": 20210208,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/08/0022000371/344/2cf37535-84f7-c29f-1e4f-a078555ca716_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321975175984822136",
    "name": "The 2974 Collection #2610",
    "imageUrl": "https://arweave.net/VD67duRDzwJbMfNb3sPqiF_KcYkWNvabZg4hImZxRro?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2611,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 146,
    "LOC_Y": 205,
    "GAME_DATE": 20210208,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/08/0022000371/566/15b1ef4e-0823-a7e6-e07a-36c1f7795a59_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362296072563003989",
    "name": "The 2974 Collection #2611",
    "imageUrl": "https://arweave.net/stPoO49ehOknKpV0SKpduPKyFw9czpCJXdYLD_g0mo4?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2612,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -198,
    "LOC_Y": 164,
    "GAME_DATE": 20210208,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/08/0022000371/639/80073f64-9192-8d81-d050-86ddcc2e1030_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323848982996668817",
    "name": "The 2974 Collection #2612",
    "imageUrl": "https://arweave.net/cIS2Uc-4uQadunE0rnw942YtG1hObngA_NARop9eW84?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2613,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -227,
    "LOC_Y": 132,
    "GAME_DATE": 20210209,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/09/0022000378/43/49c5416f-2b6f-ff50-d4ec-6e3f6ec741d7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/426932945966148096",
    "name": "The 2974 Collection #2613",
    "imageUrl": "https://arweave.net/fw8PgPmqVrkzM-wABLGmTIFtyrQg8citpPOaeJ88kts?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2614,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 36,
    "LOC_Y": 260,
    "GAME_DATE": 20210209,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/09/0022000378/371/4427d3a3-9714-7259-fd85-003e6952f0c7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/553532490889556802",
    "name": "The 2974 Collection #2614",
    "imageUrl": "https://arweave.net/nWBCXqYTb0g608vWBG19-m22Wjw7W8VcOjFjyLFSP0Y?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2615,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -152,
    "LOC_Y": 202,
    "GAME_DATE": 20210209,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/09/0022000378/406/1f0378ec-c513-e81c-56a6-01547309f1f4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/391525501924044174",
    "name": "The 2974 Collection #2615",
    "imageUrl": "https://arweave.net/jjL6nJxvMCn24zxA1_8hGqVYcjv2yYuqMZ9lAx1SzBI?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2616,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -176,
    "LOC_Y": 195,
    "GAME_DATE": 20210209,
    "Season": "2020-2021",
    "HTM": "SAS",
    "VTM": "GSW",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/09/0022000378/421/b326f5a3-9f06-543c-0531-9674da23d7c1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366849490273874214",
    "name": "The 2974 Collection #2616",
    "imageUrl": "https://arweave.net/trJrpI3nEAW1JsLX_yspFF0b-10BoIPZFOyAd0cpHL8?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 2,
    "Day": 9,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2617,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 16,
    "LOC_Y": 271,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/30/ee3ef436-68e6-d643-cad3-8e6f3d50e1b6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/315402755765871380",
    "name": "The 2974 Collection #2617",
    "imageUrl": "https://arweave.net/LJS0__6Lcf9GIwUTVvcXHG9hDeuT3s99goQTaAz0S70?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2618,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": 12,
    "LOC_Y": 331,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/92/872472b4-173a-2bf1-99d2-b6d1b3755c5e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504769035428898618",
    "name": "The 2974 Collection #2618",
    "imageUrl": "https://arweave.net/Ry9q6hL6MEhANSH35huyBTpU8UdGng8M1l8bEEHvACI?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2619,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 165,
    "LOC_Y": 187,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/144/bb3182ae-892f-6655-3dd9-e0d4cffde544_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327754389465032342",
    "name": "The 2974 Collection #2619",
    "imageUrl": "https://arweave.net/kimFYwNZnZLRjfw2oBcexTPBaF9UjDqUPVZn5E1w9wg?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2620,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 145,
    "LOC_Y": 236,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/147/849a8b29-4362-527f-c1de-5bc87d9259e7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/457568059028151251",
    "name": "The 2974 Collection #2620",
    "imageUrl": "https://arweave.net/omf2t4Yo8HKlLAzbm9k5prPPGNCw3yrd2GzvrN4nq8M?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2621,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 179,
    "LOC_Y": 198,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/258/83a255a3-9cf3-c769-2235-639b8a1e50cd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/367275436921221770",
    "name": "The 2974 Collection #2621",
    "imageUrl": "https://arweave.net/WYKF90eyiUP4WjK8K3fV4rKfm6m--mLH-uDmMC0kK_0?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2622,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 181,
    "LOC_Y": 214,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/304/96d73ce2-9c7e-b6e5-2ca6-758fe6eacaad_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/351217899538679517",
    "name": "The 2974 Collection #2622",
    "imageUrl": "https://arweave.net/I6rtPUSLSLX9JqMSYTSyUcLkzRyzTxuSCoaGMzSHOKo?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2623,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": -8,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/357/fd337730-2b29-b1e0-5ee4-4545859b026b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302577633049616502",
    "name": "The 2974 Collection #2623",
    "imageUrl": "https://arweave.net/NJeBTNugMqnYeiSl5sTlFmq3IPD6ZG7CbPObHf_DDSg?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2624,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -193,
    "LOC_Y": 175,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/462/ea495919-c9aa-0ac6-0118-510b58d4bc95_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/329686401385079023",
    "name": "The 2974 Collection #2624",
    "imageUrl": "https://arweave.net/aVeSEniodw0TZ2WS7aUb1E9mDQ99BnaIMOSg7r3YxHQ?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2625,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 199,
    "LOC_Y": 169,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/551/caf52392-0902-8d7f-281e-06150e5e6bf9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/370769543475545071",
    "name": "The 2974 Collection #2625",
    "imageUrl": "https://arweave.net/cwRe5htyT2Xw0Pt5dfmPvYeOqwgqV1-ogCuY5-UjwSk?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2626,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -176,
    "LOC_Y": 218,
    "GAME_DATE": 20210211,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/11/0022000393/587/9a787f9c-a1a2-4d59-a110-826a190ab547_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407464311293999816",
    "name": "The 2974 Collection #2626",
    "imageUrl": "https://arweave.net/Cp7Vh4N5rH0eirvuZ42s9kFA6sHffCmQ4Upminom-8c?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 11,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2627,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -41,
    "LOC_Y": 268,
    "GAME_DATE": 20210213,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/13/0022000409/46/a034a32b-19b7-d3e4-69ac-a970d5c00c7f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548367123436713575",
    "name": "The 2974 Collection #2627",
    "imageUrl": "https://arweave.net/51faJW0kynJhWnfGofmbVIjcSQ6ipHnUOtnAPODuKs0?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2628,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 214,
    "LOC_Y": 227,
    "GAME_DATE": 20210213,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "BKN",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/13/0022000409/583/17808448-05b1-4ec3-6d97-724b82df514b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/505401643868219753",
    "name": "The 2974 Collection #2628",
    "imageUrl": "https://arweave.net/SZfY0QIRpuFNTG0FrrHqee0cZcUgxpw3XUFKUrwum_I?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 2,
    "Day": 13,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2629,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 160,
    "LOC_Y": 201,
    "GAME_DATE": 20210215,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/15/0022000424/36/f0d61f55-9a61-d5e2-52d1-8bea547fb227_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/316383609125366273",
    "name": "The 2974 Collection #2629",
    "imageUrl": "https://arweave.net/1Ofmz2MU_JYD4U6b7lh7R6flm-R9PGUke1SBFvSTNOc?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2630,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -21,
    "LOC_Y": 282,
    "GAME_DATE": 20210215,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/15/0022000424/132/d54978cd-1fb1-b343-b71a-3775a06b4fe6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312772657437086814",
    "name": "The 2974 Collection #2630",
    "imageUrl": "https://arweave.net/kcscdLosX_trkQelcxYPEq49iTszEMmOi3s55F0PJd4?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2631,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 179,
    "LOC_Y": 182,
    "GAME_DATE": 20210215,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/15/0022000424/135/25a3ef6f-17a7-2452-0e36-ece59df7d55b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522335946680681772",
    "name": "The 2974 Collection #2631",
    "imageUrl": "https://arweave.net/ghyHNiw5xhJzOvjYHxXbKjozpUSSw-8hSKXd3eOAays?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2632,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -100,
    "LOC_Y": 237,
    "GAME_DATE": 20210215,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/15/0022000424/316/41344570-0995-15cd-259c-7dcbb186d59b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360815250337207320",
    "name": "The 2974 Collection #2632",
    "imageUrl": "https://arweave.net/tVHRj-RL2WebYuoXjpnfIGH6FDgtjIRCx_Urf8lrq5U?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2633,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 197,
    "LOC_Y": 171,
    "GAME_DATE": 20210215,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/15/0022000424/327/4ed8ae09-bb83-a969-2fa8-ad570d318a64_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384647131978800372",
    "name": "The 2974 Collection #2633",
    "imageUrl": "https://arweave.net/W-Xhve-9vj9kMKHbmtLo9VhaP2BALwCq7lVJtL1Ff5c?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2634,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -39,
    "LOC_Y": 264,
    "GAME_DATE": 20210215,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/15/0022000424/365/82257890-1b2e-1bcd-1a9e-2ba5406496fc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/393054633089005857",
    "name": "The 2974 Collection #2634",
    "imageUrl": "https://arweave.net/bPfkuvWEx9vKmpOj0CaYmQW0DX5GsVhaRfvaW5w4wZE?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2635,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 206,
    "LOC_Y": 174,
    "GAME_DATE": 20210215,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CLE",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/15/0022000424/423/eed03e67-4209-3f03-1494-4c1ddaca46c0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/534581696964009316",
    "name": "The 2974 Collection #2635",
    "imageUrl": "https://arweave.net/tXgaCKRPxSHAh86aXDc-E5l0JrMQRaY0ms7oPpR_KH0?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 2,
    "Day": 15,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2636,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 183,
    "LOC_Y": 234,
    "GAME_DATE": 20210217,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/17/0022000443/24/b921c4a1-91be-2928-8f59-20b5de3c41e8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550667368431851648",
    "name": "The 2974 Collection #2636",
    "imageUrl": "https://arweave.net/qEINWcq64kHmO4wO5_WbQHEvjjEWHltY7296cWxr9Ek?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 2,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2637,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -211,
    "LOC_Y": 162,
    "GAME_DATE": 20210217,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/17/0022000443/358/675fd9da-419c-16bb-6145-a9839888cf4c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/575888430903084700",
    "name": "The 2974 Collection #2637",
    "imageUrl": "https://arweave.net/5Vv0tF4MswhCwMpIYlLPAj-6lVm76oD9hoSQ2iDX6RE?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 2,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2638,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 169,
    "LOC_Y": 220,
    "GAME_DATE": 20210217,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/17/0022000443/605/658976e3-88ea-f0a2-a624-c2abd2eca6fd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/449192634361115546",
    "name": "The 2974 Collection #2638",
    "imageUrl": "https://arweave.net/IHrkj24eeEQwKUaF6yzIUgTN-s9jLllP76og6D17sDE?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 2,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2639,
    "PERIOD": 5,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 131,
    "LOC_Y": 255,
    "GAME_DATE": 20210217,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/17/0022000443/671/17a9aa7e-183b-01bf-4a5c-9c2ff478547d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/572071966490228616",
    "name": "The 2974 Collection #2639",
    "imageUrl": "https://arweave.net/I9TVTYGILOwW0vZePRnG659BxX0qZc3xGhFTmaYaWCY?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 2,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2640,
    "PERIOD": 5,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 160,
    "LOC_Y": 231,
    "GAME_DATE": 20210217,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIA",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/17/0022000443/684/06509c1c-530b-6e45-382e-dbd96502262f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323856689784880507",
    "name": "The 2974 Collection #2640",
    "imageUrl": "https://arweave.net/sKwruUujwXuOgQBDtVirgC7CUAFB6_NUelEIRlyYlSA?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 2,
    "Day": 17,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2641,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 78,
    "LOC_Y": 275,
    "GAME_DATE": 20210219,
    "Season": "2020-2021",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/19/0022000449/151/3c74bbe9-03ea-659e-0f84-8bca2253bbfb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/463278966637650369",
    "name": "The 2974 Collection #2641",
    "imageUrl": "https://arweave.net/_22epCm9NZHrwgLHu64LGXyU27nU-tm3FdmrccljDEE?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2642,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 176,
    "LOC_Y": 206,
    "GAME_DATE": 20210219,
    "Season": "2020-2021",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/19/0022000449/298/b0cd9a0c-4554-ae95-e5e1-c95643108249_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478789684715572626",
    "name": "The 2974 Collection #2642",
    "imageUrl": "https://arweave.net/Gyyii0njX56IS1U4S5oMmNaqlnp_sfiHT2MJtyHWckM?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2643,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 182,
    "LOC_Y": 180,
    "GAME_DATE": 20210219,
    "Season": "2020-2021",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/19/0022000449/388/1fc73e5d-2935-5ff5-aff2-20065e502ac8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/419268897402020969",
    "name": "The 2974 Collection #2643",
    "imageUrl": "https://arweave.net/Xu_zuT_QM6r_UavtyP3Cau71hNUBXBq0dBuPtJbBieY?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2644,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 165,
    "LOC_Y": 178,
    "GAME_DATE": 20210219,
    "Season": "2020-2021",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/19/0022000449/468/abc4575a-9f43-df04-6c0f-c315533170b0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404375527228394356",
    "name": "The 2974 Collection #2644",
    "imageUrl": "https://arweave.net/BUWGwy--xNo3HIph6uX61seCi17XKyxWKnV5-QCiLYA?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2645,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 90,
    "LOC_Y": 261,
    "GAME_DATE": 20210219,
    "Season": "2020-2021",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/19/0022000449/666/f42cd88d-f8e4-dad6-2a10-2c581e255832_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/425861789425820729",
    "name": "The 2974 Collection #2645",
    "imageUrl": "https://arweave.net/RZPg3e2pVIhE0TKIWRGX8bUPqdkCAt5LKJHHkT1lnMU?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2646,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 114,
    "LOC_Y": 239,
    "GAME_DATE": 20210219,
    "Season": "2020-2021",
    "HTM": "ORL",
    "VTM": "GSW",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/19/0022000449/671/4d42585d-339e-a139-ed5a-497d8cbba2f0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489697754540953675",
    "name": "The 2974 Collection #2646",
    "imageUrl": "https://arweave.net/W-Mvk6QUdaSuS13OdU5LyFAaX3aqMBlb3CdoiC4eVdw?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 2,
    "Day": 19,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2647,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -221,
    "LOC_Y": 95,
    "GAME_DATE": 20210223,
    "Season": "2020-2021",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/23/0022000483/7/d723be49-ff02-d505-2b05-c92696011852_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412209260380445580",
    "name": "The 2974 Collection #2647",
    "imageUrl": "https://arweave.net/LjkdxlMSSBwjQDqjlu2zi1Sx1PhZN3ZxMu7OfeJJAgc?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2648,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 166,
    "LOC_Y": 237,
    "GAME_DATE": 20210223,
    "Season": "2020-2021",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/23/0022000483/152/bcfdb3a7-7953-c8dc-e8ee-e69affd09fc6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546150214044808893",
    "name": "The 2974 Collection #2648",
    "imageUrl": "https://arweave.net/mfxkkkb_zzC7k5cUEoqRXfyu9C0gkvBIN8yUyTQ5J-Y?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2649,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -192,
    "LOC_Y": 150,
    "GAME_DATE": 20210223,
    "Season": "2020-2021",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/23/0022000483/282/10760ff5-3f8d-e203-4645-32b37f00017a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502352088465559021",
    "name": "The 2974 Collection #2649",
    "imageUrl": "https://arweave.net/-Ze8oRo0OSwRrSavufLSCrB_PKVtWCH5kqGaIh-PnWI?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2650,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 201,
    "LOC_Y": 160,
    "GAME_DATE": 20210223,
    "Season": "2020-2021",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/23/0022000483/338/f14daa4d-b3ca-ec90-39d5-fa30962375f7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415920820127639353",
    "name": "The 2974 Collection #2650",
    "imageUrl": "https://arweave.net/l79Wfq_VRSKdHD6QnKWEA14aTUWFwlQaT32Gtt2Gp7E?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2651,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 12,
    "GAME_DATE": 20210223,
    "Season": "2020-2021",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/23/0022000483/455/e1e55d42-0786-d9c5-cbdd-0c6752277ef9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/467593889770896172",
    "name": "The 2974 Collection #2651",
    "imageUrl": "https://arweave.net/DvJzWUKNUefez0kSGCWF-0G8aEpHcYilQ5Z8hltVKxU?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2652,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 166,
    "LOC_Y": 214,
    "GAME_DATE": 20210223,
    "Season": "2020-2021",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/23/0022000483/460/b008186f-8b33-3220-0023-b5bc3f961bd3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/393484139037168922",
    "name": "The 2974 Collection #2652",
    "imageUrl": "https://arweave.net/vnB13qA8hUp6_LAng_9CbmYYIS1FBqdazvDC_UTwl0Y?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2653,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 97,
    "LOC_Y": 239,
    "GAME_DATE": 20210223,
    "Season": "2020-2021",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/23/0022000483/601/7d7c468f-cfed-180d-5721-905035e5086a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421484604472542707",
    "name": "The 2974 Collection #2653",
    "imageUrl": "https://arweave.net/zj6MbM8Koitwwy0zPyC66dUx6rs2H6KgDcoMph3Z6d0?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 2,
    "Day": 23,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2654,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 223,
    "LOC_Y": 69,
    "GAME_DATE": 20210224,
    "Season": "2020-2021",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/24/0022000489/83/afde3b86-6ea5-7d3d-f52b-803dbec17ca0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/531801570301285740",
    "name": "The 2974 Collection #2654",
    "imageUrl": "https://arweave.net/aW4mxexr2KDfCiXsxTbPWX7IJ-GvQ15EN4VSVa_hRrI?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2021,
    "Month": 2,
    "Day": 24,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2655,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 189,
    "LOC_Y": 194,
    "GAME_DATE": 20210226,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/26/0022000511/299/dda08efc-00fb-1277-5b5c-09ab7916226e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436515764358178973",
    "name": "The 2974 Collection #2655",
    "imageUrl": "https://arweave.net/onaSgko7PiEVfivLQYpXC9VUUpqbZ61w9qlfhdl91I4?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2021,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2656,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 183,
    "LOC_Y": 181,
    "GAME_DATE": 20210226,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/26/0022000511/347/179795b8-3c2d-a7dc-b63a-e506ec019c70_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362841030256858316",
    "name": "The 2974 Collection #2656",
    "imageUrl": "https://arweave.net/90br8bS66OTpUEv8hOiEnVC0Gk9Qtw4pO_Sz_b2VCjE?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2021,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2657,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -182,
    "LOC_Y": 199,
    "GAME_DATE": 20210226,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/26/0022000511/480/83be4126-4967-486d-8e78-7eb9ff11b29f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/353599610776985661",
    "name": "The 2974 Collection #2657",
    "imageUrl": "https://arweave.net/RlV3EJjS-2mqLBMBmTG_caNVQyAKueDof_oHyhAfbTY?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2021,
    "Month": 2,
    "Day": 26,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2658,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -122,
    "LOC_Y": 239,
    "GAME_DATE": 20210228,
    "Season": "2020-2021",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/28/0022000527/81/6f68aaee-d5a9-14a7-3b1a-da0d7d833f17_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322928042380199957",
    "name": "The 2974 Collection #2658",
    "imageUrl": "https://arweave.net/LNxvPJeLGNLK-KgqlXVMZb_-L9dYxpoKYQYwK3G2KX4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2659,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 148,
    "LOC_Y": 204,
    "GAME_DATE": 20210228,
    "Season": "2020-2021",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/02/28/0022000527/355/2ad1e5ec-d663-b3a7-3b52-204861da77fc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539163050969077223",
    "name": "The 2974 Collection #2659",
    "imageUrl": "https://arweave.net/hcyI543hvUg7PlBGuXkmb3kFA8B_93rfJ5Viz6xaMEc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 2,
    "Day": 28,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2660,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 182,
    "LOC_Y": 176,
    "GAME_DATE": 20210303,
    "Season": "2020-2021",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/03/0022000550/24/8447a25a-6bb5-5b15-be32-4cb5c4221860_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500178483286639065",
    "name": "The 2974 Collection #2660",
    "imageUrl": "https://arweave.net/nNcFfn_-Y46GK661APgyr9XgDeqA9p2e9mF8M9uP9uk?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2661,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -193,
    "LOC_Y": 151,
    "GAME_DATE": 20210303,
    "Season": "2020-2021",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/03/0022000550/28/22bd8863-68a0-ecf4-a002-5b81f0f03595_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/445634850181863577",
    "name": "The 2974 Collection #2661",
    "imageUrl": "https://arweave.net/CwMvewCE7lfedF03_WtGKoNKm7GXQU8e8mEMJEtlPQY?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2662,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -168,
    "LOC_Y": 192,
    "GAME_DATE": 20210303,
    "Season": "2020-2021",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/03/0022000550/43/7b1de321-fbaf-ff2c-8067-041fa962905f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465599661152142146",
    "name": "The 2974 Collection #2662",
    "imageUrl": "https://arweave.net/ATSBzdZjsdKVzJnrLliPHtPMxaJ_sq45YgweBoMpBrw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2663,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -128,
    "LOC_Y": 258,
    "GAME_DATE": 20210303,
    "Season": "2020-2021",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/03/0022000550/552/751ace69-e6e0-a4f5-89bd-700e78fa10c0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404782687794509112",
    "name": "The 2974 Collection #2663",
    "imageUrl": "https://arweave.net/2ULXZYNr_gZH043a2ckuYE9y5Z5y6sqA3KhFmhe4EIg?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2664,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 218,
    "LOC_Y": 106,
    "GAME_DATE": 20210303,
    "Season": "2020-2021",
    "HTM": "POR",
    "VTM": "GSW",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/03/0022000550/570/5c49ed2b-49a5-b3b1-749c-cc3c76e5802a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/527841264502590801",
    "name": "The 2974 Collection #2664",
    "imageUrl": "https://arweave.net/7VIGrp3phORn1AoHAVgF__kDZDJLkqGyFCvJek2IVcw?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 3,
    "Day": 3,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2665,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 106,
    "LOC_Y": 249,
    "GAME_DATE": 20210311,
    "Season": "2020-2021",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/11/0022000576/357/a8ab6bf0-4578-f8b1-bd46-069e84b1e1a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330562139785448319",
    "name": "The 2974 Collection #2665",
    "imageUrl": "https://arweave.net/YKdQlbT-1CCxR5eaTUh2Ceg4txdmqxE1H14hbv55Nfk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 3,
    "Day": 11,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2666,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": 8,
    "GAME_DATE": 20210314,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/14/0022000594/41/31f894a5-7d5b-c33c-dd5f-89dd26c8d83d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412018720810302840",
    "name": "The 2974 Collection #2666",
    "imageUrl": "https://arweave.net/LZb5ofKh0yn6McDpoLRyO-EA-6EBYr-sV8SlyHNAcpg?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2667,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 136,
    "LOC_Y": 234,
    "GAME_DATE": 20210314,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/14/0022000594/60/8ab8501c-e089-fcdd-69c8-b9dbf677800f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/549796238422441778",
    "name": "The 2974 Collection #2667",
    "imageUrl": "https://arweave.net/bAp5HXB52z7DuWNoca-8vCypbKVA312UcU89n0BVx7k?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2668,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 121,
    "LOC_Y": 240,
    "GAME_DATE": 20210314,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/14/0022000594/87/5b39f74b-2448-9fe5-13f7-7644cf031e0e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/380296719919401502",
    "name": "The 2974 Collection #2668",
    "imageUrl": "https://arweave.net/Z_M3muG9D35Cp0LRD0NYNM-3ZFYHLuaAXKn46COJYtw?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2669,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -68,
    "LOC_Y": 284,
    "GAME_DATE": 20210314,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/14/0022000594/348/f5995089-6d1f-4393-210a-525fce9153e0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567849110672725687",
    "name": "The 2974 Collection #2669",
    "imageUrl": "https://arweave.net/f5OyI3rKCysCfwbmStDkhtIS8lDQYLkGw2rBAqX2fI0?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2670,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 154,
    "LOC_Y": 233,
    "GAME_DATE": 20210314,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/14/0022000594/429/a27c66a9-e5a3-0938-4373-8a331a7abfa7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436347995666682939",
    "name": "The 2974 Collection #2670",
    "imageUrl": "https://arweave.net/pXlcKy5DYwoIiRvtcI-FH303ksqkUN2ASv3KlMjWmjQ?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2671,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -32,
    "LOC_Y": 269,
    "GAME_DATE": 20210314,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/14/0022000594/611/032dca2c-5b56-1fde-4f85-6e64be0d03f8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/537220526262971463",
    "name": "The 2974 Collection #2671",
    "imageUrl": "https://arweave.net/4HgOfpB6fD_nENrdJdXprJv3xLZMwjY2lzu4x_fYNgY?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 3,
    "Day": 14,
    "3-Pointers made in the game": 6,
    "Special Moment": "Birthday Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2672,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 75,
    "LOC_Y": 268,
    "GAME_DATE": 20210315,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/15/0022000608/20/5e40e371-6835-c97c-622a-7a8f78273d76_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/394578174354772673",
    "name": "The 2974 Collection #2672",
    "imageUrl": "https://arweave.net/GARvY08HU4lWAm1UGusc2iAxEbymDwRH_92KxE4Z7RY?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 3,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2673,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 3,
    "LOC_Y": 294,
    "GAME_DATE": 20210315,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/15/0022000608/123/15bf8f54-5279-a4df-6a4a-468871de9272_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338102792526332857",
    "name": "The 2974 Collection #2673",
    "imageUrl": "https://arweave.net/JwpqdjDX9YsUWAmJ9BtDdn-HWyYj6scgjPk6dUSF1Ms?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 3,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2674,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 108,
    "LOC_Y": 249,
    "GAME_DATE": 20210315,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/15/0022000608/263/89fb9f49-afcc-bd70-878f-8741a800c02a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495941367507684310",
    "name": "The 2974 Collection #2674",
    "imageUrl": "https://arweave.net/VAsJaGZp016kY2EA5ykzkUnw1YNY4huPefG0zEMKqDU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 3,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2675,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 22,
    "LOC_Y": 258,
    "GAME_DATE": 20210315,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "LAL",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/15/0022000608/341/88489745-5fba-2a58-7583-fac04a8a82b4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295196441792481566",
    "name": "The 2974 Collection #2675",
    "imageUrl": "https://arweave.net/rA-h6pFmaihjWOC9VQrxuEtg3l5JzgaJXoVib21Df14?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 3,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2676,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -231,
    "LOC_Y": 11,
    "GAME_DATE": 20210317,
    "Season": "2020-2021",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/17/0022000622/69/0563c060-e952-0bbc-d0a1-2f1f2a5689f9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379564910905604745",
    "name": "The 2974 Collection #2676",
    "imageUrl": "https://arweave.net/ZF8qafFfI-J8A6b9f60E4dzsMB-XvyNwR0iLNxvFd6Y?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 3,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2677,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 133,
    "LOC_Y": 230,
    "GAME_DATE": 20210317,
    "Season": "2020-2021",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/17/0022000622/442/edfce244-dd0f-03ad-2c5f-7358c9429166_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568856428652135521",
    "name": "The 2974 Collection #2677",
    "imageUrl": "https://arweave.net/f5A8dyrNXMpts68JnozN0lo21zJtfhDPGddTShkogYc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 3,
    "Day": 17,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2678,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 158,
    "LOC_Y": 251,
    "GAME_DATE": 20210329,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/29/0022000716/23/36be9880-7152-1be2-98bc-7fc582984caa_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/358654349369545264",
    "name": "The 2974 Collection #2678",
    "imageUrl": "https://arweave.net/iJrWw28kSV37wc6QP-QXiSxcQOV6sGotL21opxwPrjE?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2679,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 145,
    "LOC_Y": 252,
    "GAME_DATE": 20210329,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/29/0022000716/63/724cc4d8-5bde-fdb4-124d-b40dabe2b1e5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/555429697553881163",
    "name": "The 2974 Collection #2679",
    "imageUrl": "https://arweave.net/DJqBt9bQEM3xL6-7hXKUh4UQmY8GUEOJGaEL4Ao0R0w?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2680,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -70,
    "LOC_Y": 241,
    "GAME_DATE": 20210329,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/29/0022000716/94/af24896e-5c37-3fdc-6be4-ff2f6026d2b4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/396869460656197702",
    "name": "The 2974 Collection #2680",
    "imageUrl": "https://arweave.net/vcRyYS4q_fzEYH8XNo54_gqA8OKD0WZ4R8d0IBNnahM?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2681,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -221,
    "LOC_Y": -11,
    "GAME_DATE": 20210329,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/29/0022000716/271/e7f22ced-8d91-3a40-e296-9bca553e3f43_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/447178780196636724",
    "name": "The 2974 Collection #2681",
    "imageUrl": "https://arweave.net/iyqxub2WqYP-gg24YTl4BCOTUyXvUu71MS55FUF2vkY?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2682,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 3,
    "LOC_Y": 296,
    "GAME_DATE": 20210329,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/29/0022000716/399/acd8b7eb-0bbe-9aca-357c-19ab79a6dd2e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/360214410865821546",
    "name": "The 2974 Collection #2682",
    "imageUrl": "https://arweave.net/xX-tX2pYKbd5m2oOl8S8dftWDXJYAFkvphe25u5Awn0?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2683,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 112,
    "LOC_Y": 243,
    "GAME_DATE": 20210329,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/03/29/0022000716/445/aeefcde7-c37a-3ce7-a824-87f44966a934_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/472392506147576378",
    "name": "The 2974 Collection #2683",
    "imageUrl": "https://arweave.net/7_1dt7VB-ndUeCDibw7FxTpKhlv8yD1ci9cSKj3pcoU?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 3,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2684,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 156,
    "LOC_Y": 202,
    "GAME_DATE": 20210401,
    "Season": "2020-2021",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/01/0022000733/326/43cd9b29-0304-1636-87cf-15a642744565_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412834400695120516",
    "name": "The 2974 Collection #2684",
    "imageUrl": "https://arweave.net/JSiIUyVhqSmV5eb2F7hoQSS0hA1dHV4qE3LRN_Zmw-Y?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2685,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -4,
    "LOC_Y": 295,
    "GAME_DATE": 20210401,
    "Season": "2020-2021",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/01/0022000733/449/77267ab6-1f93-7a6d-6fe6-38f8d11fb77c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/424074816005451278",
    "name": "The 2974 Collection #2685",
    "imageUrl": "https://arweave.net/rCN0jKvMNeMCQXp-Ut0bB4KnJ_n2IglGfMGEZGZhjpM?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2686,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 157,
    "LOC_Y": 199,
    "GAME_DATE": 20210401,
    "Season": "2020-2021",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/01/0022000733/619/5642fe92-3f3e-0b15-c8bd-df0cdc3c123a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395900328934073733",
    "name": "The 2974 Collection #2686",
    "imageUrl": "https://arweave.net/Otfg3sw90OS4WUGFBTsCPW-uQCTdEfzpuVRZj6BVwHc?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2687,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -138,
    "LOC_Y": 263,
    "GAME_DATE": 20210401,
    "Season": "2020-2021",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/01/0022000733/685/ce13fec9-95d1-ad9a-e12c-c1f807913118_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/370993945562059025",
    "name": "The 2974 Collection #2687",
    "imageUrl": "https://arweave.net/UXCCtg-KEYupCbk_EWEuC4sRpJySqEsMJ-n25AgU9FA?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2688,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -8,
    "LOC_Y": 283,
    "GAME_DATE": 20210401,
    "Season": "2020-2021",
    "HTM": "MIA",
    "VTM": "GSW",
    "Opposing Team": "MIA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/01/0022000733/692/9daf3b74-2d14-7d18-48d7-e97bb73f3cbb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/472366071615179473",
    "name": "The 2974 Collection #2688",
    "imageUrl": "https://arweave.net/8UzzcrEQH4n2snZn_KiqDo0UI86AdOA3dPzPhHnNYXA?ext=png",
    "Opposing Team City": "Miami",
    "Year": 2021,
    "Month": 4,
    "Day": 1,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2689,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -158,
    "LOC_Y": 211,
    "GAME_DATE": 20210404,
    "Season": "2020-2021",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/04/0022000759/164/cbf52ae9-365a-f5c6-cc06-9aa2ac04ddec_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/400150097457460453",
    "name": "The 2974 Collection #2689",
    "imageUrl": "https://arweave.net/iUSXeYGKamesIVLclTE_zhPT318333ltumWjgiht9J0?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2690,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 90,
    "LOC_Y": 238,
    "GAME_DATE": 20210404,
    "Season": "2020-2021",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/04/0022000759/528/a0afa5f6-7b56-847f-3932-bd9e6ca7ade4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/304934799335771261",
    "name": "The 2974 Collection #2690",
    "imageUrl": "https://arweave.net/6YuBn8EJgFJWdFMeesttbsjVBAtxn7OlCN8zbEeHK1M?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2691,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -41,
    "LOC_Y": 265,
    "GAME_DATE": 20210404,
    "Season": "2020-2021",
    "HTM": "ATL",
    "VTM": "GSW",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/04/0022000759/647/4b792f22-945e-3311-bdeb-1819a0c16212_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436953249686205990",
    "name": "The 2974 Collection #2691",
    "imageUrl": "https://arweave.net/p7q2u4HGPk-qnQHEI0mNKrUshwz7GwV1Bq69m8ma0K8?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 4,
    "Day": 4,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2692,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 127,
    "LOC_Y": 235,
    "GAME_DATE": 20210406,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/06/0022000774/20/c9eb4e9d-849d-e0cb-8f27-38e40a1b64a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540634162177917006",
    "name": "The 2974 Collection #2692",
    "imageUrl": "https://arweave.net/YAov73m-cbEW3O5qIAC1Mi5zUJsnVWtC21zV-pmBYeo?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2021,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2693,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 58,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 196,
    "LOC_Y": 167,
    "GAME_DATE": 20210406,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/06/0022000774/392/bd67b2b7-5da9-7b0c-175a-ec054bc7d78d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309378897461865839",
    "name": "The 2974 Collection #2693",
    "imageUrl": "https://arweave.net/nW89WciGbOJWRIrDp74SIxrVDHD1yTtDIKYMVaTF2pI?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2021,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2694,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -25,
    "LOC_Y": 286,
    "GAME_DATE": 20210406,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/06/0022000774/433/37e0beb8-ead2-2216-b4ae-5a006b2de282_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/294288811453260313",
    "name": "The 2974 Collection #2694",
    "imageUrl": "https://arweave.net/-enenqriWKXk9wFA8jzBH4WVYdW5AMQKVFCTlzLBAwY?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2021,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2695,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -117,
    "LOC_Y": 251,
    "GAME_DATE": 20210406,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/06/0022000774/472/ed744850-eb5c-2a14-c90c-71374ff6447f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327544825758252743",
    "name": "The 2974 Collection #2695",
    "imageUrl": "https://arweave.net/-Iezz86JjeW2utR0O7FassAl0nXDIdVzyFYRFBHv0ds?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2021,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2696,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -7,
    "LOC_Y": 289,
    "GAME_DATE": 20210406,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MIL",
    "Opposing Team": "MIL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/06/0022000774/594/7c8afc17-87af-56a7-8ee5-b8bd9040d5e4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295826217783752552",
    "name": "The 2974 Collection #2696",
    "imageUrl": "https://arweave.net/FyNYGVxVaEXB-_8apxJLaAgCdBE68__a-JVU6bjW92I?ext=png",
    "Opposing Team City": "Milwaukee",
    "Year": 2021,
    "Month": 4,
    "Day": 6,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2697,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -122,
    "LOC_Y": 253,
    "GAME_DATE": 20210409,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/09/0022000798/98/4c3a0a8b-8323-aa94-fac7-384c8fb19251_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/483197393017875733",
    "name": "The 2974 Collection #2697",
    "imageUrl": "https://arweave.net/mgPu0cnvpfZ6F8w7ThPiKSDdfxzq-Z_akXiBgN_AtNg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2021,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2698,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -164,
    "LOC_Y": 227,
    "GAME_DATE": 20210409,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/09/0022000798/125/ad18e926-3e1b-bb1d-a49d-d09632b784de_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/455223185844630238",
    "name": "The 2974 Collection #2698",
    "imageUrl": "https://arweave.net/anHs2a_L2seruxPnEVT3n9UAc2QvBi5OK2VBmwVUBTg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2021,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2699,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -115,
    "LOC_Y": 248,
    "GAME_DATE": 20210409,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/09/0022000798/321/bc893646-3211-960b-9cac-be061e06c0cc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355480683639340636",
    "name": "The 2974 Collection #2699",
    "imageUrl": "https://arweave.net/z8hwIBHDrFuuYf5AwOSNtxlS5ontdTppsaIUS79Lkzk?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2021,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2700,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 164,
    "LOC_Y": 201,
    "GAME_DATE": 20210409,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/09/0022000798/361/84253e2b-23a4-921a-d4cc-030e3d212965_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501386422530616956",
    "name": "The 2974 Collection #2700",
    "imageUrl": "https://arweave.net/Foq5wjZofBOUrMpWdaEtI2ahAABLK9_QQBzX0EMIBbE?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2021,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2701,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -195,
    "LOC_Y": 152,
    "GAME_DATE": 20210409,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "WAS",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/09/0022000798/382/243ce3e1-9749-4967-f337-ae2c91bb8786_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497681109244824813",
    "name": "The 2974 Collection #2701",
    "imageUrl": "https://arweave.net/a4C738HfXadoHdB3o7j7ayCKTZc__kK94Kx-NkInTZg?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2021,
    "Month": 4,
    "Day": 9,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2702,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -141,
    "LOC_Y": 275,
    "GAME_DATE": 20210410,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/10/0022000802/122/77c25cbb-16f0-4724-9e45-11559afa8eb4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544056173640457459",
    "name": "The 2974 Collection #2702",
    "imageUrl": "https://arweave.net/9P_kRgLawayo8YidnGKgiFOF41VTvyW-HkLIfuSLTbY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2703,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -90,
    "LOC_Y": 268,
    "GAME_DATE": 20210410,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/10/0022000802/320/81d53a87-942a-50f4-eeca-0974e299bec9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476735718579503462",
    "name": "The 2974 Collection #2703",
    "imageUrl": "https://arweave.net/i2sx8wr4v9wgLRfIInwERcUbg-P26gDjSsSL0BxLr2I?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2704,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -133,
    "LOC_Y": 235,
    "GAME_DATE": 20210410,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/10/0022000802/382/7ab19ec9-9d4d-825f-1062-f62271274e45_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/521518900264917931",
    "name": "The 2974 Collection #2704",
    "imageUrl": "https://arweave.net/4EOlsXmOEXn6h6J2lrbhZ534Hr2jnEtTxiDto-B0BHU?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2705,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -4,
    "LOC_Y": 279,
    "GAME_DATE": 20210410,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/10/0022000802/418/31edd710-726e-7ce6-84ac-1de4c04f3d46_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/498530452626993666",
    "name": "The 2974 Collection #2705",
    "imageUrl": "https://arweave.net/s_bLmeIKlb1xYaU1vBzKpdUPfWiR1lF-0aU9R0V-mWc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2706,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 110,
    "LOC_Y": 267,
    "GAME_DATE": 20210410,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/10/0022000802/440/ef426978-8239-7e87-5860-a49b5d56ec50_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/411771012821104588",
    "name": "The 2974 Collection #2706",
    "imageUrl": "https://arweave.net/VQj_8TAtAld3a0IOdw0K8iAmxiik6-RfqZ1S4-uodmQ?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2707,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 161,
    "LOC_Y": 247,
    "GAME_DATE": 20210410,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/10/0022000802/458/5b12b568-6bb0-10dd-d8a9-aa37e4711b97_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/445141186463581023",
    "name": "The 2974 Collection #2707",
    "imageUrl": "https://arweave.net/trg6gHwE0GiopNCuA6HgKi8cqSBBmqylF4O1Wzi2ebc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2708,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -169,
    "LOC_Y": 213,
    "GAME_DATE": 20210410,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/10/0022000802/484/fb9ab938-e746-f5e6-5084-13e219f899cd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/364758845441831819",
    "name": "The 2974 Collection #2708",
    "imageUrl": "https://arweave.net/BL_oGwVXgroEBVBwWiIF3RxSg3YAjgea9snA9uKiPAo?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2709,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -35,
    "LOC_Y": 261,
    "GAME_DATE": 20210410,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/10/0022000802/643/d3bcf728-114a-fbc5-75db-0636602663be_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/452222195549945055",
    "name": "The 2974 Collection #2709",
    "imageUrl": "https://arweave.net/d4kk2IOIPZF49M-D-hd9AmqYuCjXD08MLkk6X-Ru_VY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 4,
    "Day": 10,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2710,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 232,
    "LOC_Y": 57,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/13/23b51991-84fc-143d-7422-d01f24d64483_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/433405694540009276",
    "name": "The 2974 Collection #2710",
    "imageUrl": "https://arweave.net/d--p66ZR1KCCBskTI2VisS6yTD1lw3lq2QcVXcl6LvI?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2711,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 120,
    "LOC_Y": 244,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/19/4b1d0d59-7008-2cc4-3929-613e9a75f642_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/547210157957895945",
    "name": "The 2974 Collection #2711",
    "imageUrl": "https://arweave.net/w3rtdptW32NCd9JETWwxiS7HyhfRat-rQbBcv7Zy66E?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2712,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -125,
    "LOC_Y": 236,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/56/68897c40-fb02-194c-fd52-9eedc1a3cbe9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/335146735439428238",
    "name": "The 2974 Collection #2712",
    "imageUrl": "https://arweave.net/vgFq8RpqkZsPlbHzbA921zUjXB1TyGdt3SfoeKNZ8Ps?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2713,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -106,
    "LOC_Y": 293,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/79/fd8bb461-112b-764e-065d-de3e3a699eeb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522447642114276332",
    "name": "The 2974 Collection #2713",
    "imageUrl": "https://arweave.net/QX8QnAI6k8ke6VNgw_Yq-G4xwHORev1E9hHoC6q35xs?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2714,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -94,
    "LOC_Y": 301,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/113/8c54b05f-e2ea-8c25-a739-d8b0b8b94ac1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/365939902317037613",
    "name": "The 2974 Collection #2714",
    "imageUrl": "https://arweave.net/mOZl2XKCLCKkCAJAPdyMozxV-ARRtshA4SPO7wri2fw?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2715,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -142,
    "LOC_Y": 239,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/250/7712789a-5f50-6798-6228-6f3593e88639_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438428679467921747",
    "name": "The 2974 Collection #2715",
    "imageUrl": "https://arweave.net/GdVAmUeSI9I7DbEAsmvSYJ0gPaS-zx1OG8SKH1akroI?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2716,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -168,
    "LOC_Y": 192,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/359/2eb782fb-9ef8-0a10-9e17-655c8677cbdd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461636389715968854",
    "name": "The 2974 Collection #2716",
    "imageUrl": "https://arweave.net/VnwHxfTXaTgkpblcPY-AIWr6Hb8sJFRlQMRTF11GyGs?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2717,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 127,
    "LOC_Y": 278,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/385/57facb34-98de-ae5c-b6d7-d2a2127bb8f8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/407235527505161347",
    "name": "The 2974 Collection #2717",
    "imageUrl": "https://arweave.net/6EKWg6wNdrauQFud8PpDgf8GaOoAZoTig2UcBV4tRMs?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2718,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 179,
    "LOC_Y": 221,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/426/322ed888-e487-eac8-224e-353f05ec41ea_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/534084474961201249",
    "name": "The 2974 Collection #2718",
    "imageUrl": "https://arweave.net/dTVBru4HkRsiEa0wacarW2XFerqK7zCFaWmv3UdYN8Q?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2719,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 163,
    "LOC_Y": 213,
    "GAME_DATE": 20210412,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/12/0022000821/453/98c934b5-a1d3-fe68-d9a9-0a1c0cfdd978_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/389058516157031121",
    "name": "The 2974 Collection #2719",
    "imageUrl": "https://arweave.net/TdeSyfDjBBtdBLvdrFFc9-jNma_reEPTQKnbiaI4pWo?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 12,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2720,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -180,
    "LOC_Y": 172,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/16/b8695a1d-aa27-e801-6997-7885f95880ff_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/496086363408444665",
    "name": "The 2974 Collection #2720",
    "imageUrl": "https://arweave.net/riUymJTl1qNJrxku9ekUmGoxN4eHeosIY5VnmCLZKVI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2721,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 226,
    "LOC_Y": 48,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/55/5b1f194a-fac8-f5b5-b29c-b47c1c8266b9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501044354495312628",
    "name": "The 2974 Collection #2721",
    "imageUrl": "https://arweave.net/MP_EZ6PhZmU8huKQjxQ0DG3P1LpU8kGmxTR4ETYv-80?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2722,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -130,
    "LOC_Y": 241,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/124/11cc7333-95fe-3cee-3d02-5dc97163532b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525214707074006725",
    "name": "The 2974 Collection #2722",
    "imageUrl": "https://arweave.net/YXJtH7E17sYhTFJ67ODJsWZzvhTxyDieIEM9g-RnC0Q?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2723,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 231,
    "LOC_Y": 27,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/295/b7820e67-d592-5ad4-e298-ef95c1d4f206_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341751535038717634",
    "name": "The 2974 Collection #2723",
    "imageUrl": "https://arweave.net/HGAU5TFfqZ_68iT_okm9XiM5oWRFySdna3uJgLDngKk?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2724,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": 34,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/319/f5c44afb-512b-89ad-df1a-5d8e9e6b04ec_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481207810980312900",
    "name": "The 2974 Collection #2724",
    "imageUrl": "https://arweave.net/lywPiT2PQTgEeJdHLLMJRvB8PjbK9FYpqkEK1Nq0KVY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2725,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 137,
    "LOC_Y": 205,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/383/2c6087f1-06b4-5b57-9c01-f5fc60af3243_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/562081744504235974",
    "name": "The 2974 Collection #2725",
    "imageUrl": "https://arweave.net/k1rsNF8i6enp_Oa2rP0uLgEgtbAVDicQKVVcqPLDElo?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2726,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 134,
    "LOC_Y": 248,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/419/e3f02ae1-f930-2e18-6b22-de296fce0f93_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556389854553641147",
    "name": "The 2974 Collection #2726",
    "imageUrl": "https://arweave.net/sg3JcXwCF3IzwrzcwOfy7xLeNw54WK4Zy6xw_1PjEW4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2727,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 141,
    "LOC_Y": 262,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/423/a35cf3b3-5ec6-7937-7b6a-3c44af7b6bfe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/375295076434891603",
    "name": "The 2974 Collection #2727",
    "imageUrl": "https://arweave.net/fwTND5mF6eb9V2IkS55w49mFU3PPr7ncZUuR1jDZEd0?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2728,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -144,
    "LOC_Y": 204,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/444/b28f21a6-ba4e-3e1e-9049-50039f42e2af_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/546021150141074915",
    "name": "The 2974 Collection #2728",
    "imageUrl": "https://arweave.net/K1HrVsoq7-yVbl3jvcwf7i5Xylu5d1YSUQZd4jUYEgE?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2729,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -162,
    "LOC_Y": 194,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/481/6a5eaa07-8233-2281-8632-2290dc3eaf58_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/563414624851629902",
    "name": "The 2974 Collection #2729",
    "imageUrl": "https://arweave.net/7LF7kRncPQGoYsjE1IaT7rI-hGh50U3H41i-LxxAu9M?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2730,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 38,
    "LOC_Y": 247,
    "GAME_DATE": 20210414,
    "Season": "2020-2021",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/14/0022000836/484/937a3fd8-43aa-0286-cfae-3e31c1a74c6d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/321676959427972576",
    "name": "The 2974 Collection #2730",
    "imageUrl": "https://arweave.net/OklL9V3V418XClAY371ndyYXS5XRiDJA4HLfyMn8DTc?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 4,
    "Day": 14,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2731,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 34,
    "LOC_X": 149,
    "LOC_Y": 307,
    "GAME_DATE": 20210415,
    "Season": "2020-2021",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/15/0022000841/473/26e69d60-322f-7315-8603-2695c924e266_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/482743366216302377",
    "name": "The 2974 Collection #2731",
    "imageUrl": "https://arweave.net/IB_EPYSCmdzyWP9OQzfo0YZ2RZudjBcv8Q89BpOJKGQ?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2732,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -172,
    "LOC_Y": 217,
    "GAME_DATE": 20210415,
    "Season": "2020-2021",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/15/0022000841/477/eedca846-9a2d-811f-7142-af958e89db4e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/431002522166106089",
    "name": "The 2974 Collection #2732",
    "imageUrl": "https://arweave.net/PuUL1Jh3qtgJM8SuMxkfDNGi80WWYZLWkN7aSb_X6lg?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2733,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 166,
    "LOC_Y": 206,
    "GAME_DATE": 20210415,
    "Season": "2020-2021",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/15/0022000841/604/7530cde6-e50c-3068-389e-50fc1f3e0675_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/326002723580193588",
    "name": "The 2974 Collection #2733",
    "imageUrl": "https://arweave.net/__yWCudytGYjjgcxjFL-bQRp2HX0PUcVrdo_z2Xgcdo?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2734,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -158,
    "LOC_Y": 259,
    "GAME_DATE": 20210415,
    "Season": "2020-2021",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/15/0022000841/608/e674b08f-4923-1ac2-f981-3c4f5a11710b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386968461666991006",
    "name": "The 2974 Collection #2734",
    "imageUrl": "https://arweave.net/ciz-9k7INS_-Y-BuRmFRYlfAtudSQcbhfyqpediW7y8?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 4,
    "Day": 15,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2735,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -133,
    "LOC_Y": 209,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/21/cf775823-b99a-04a0-b68f-1820b80c78c6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/492236768083994313",
    "name": "The 2974 Collection #2735",
    "imageUrl": "https://arweave.net/301QOjQHy_nxP8ex8HNliB45406PaUFjVDozo4ywnNk?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2736,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 82,
    "LOC_Y": 267,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/93/7cc1b746-2cf6-ec8a-ed92-72e4427c1838_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434960535912007050",
    "name": "The 2974 Collection #2736",
    "imageUrl": "https://arweave.net/zOQHmu5ichb6XpmpeKDAliQlTI7v-Y75jhpsGZPH9Tc?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2737,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 60,
    "LOC_Y": 247,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/292/3a4876d6-a973-dbca-74eb-0f432b592d6a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334671778814632592",
    "name": "The 2974 Collection #2737",
    "imageUrl": "https://arweave.net/pGj-RSLZegSyu_EqsD_r5qAy1L1UFQXYtrUjZ4-Qcx0?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2738,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -174,
    "LOC_Y": 196,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/358/b6b5cdad-f038-a1b6-9e09-b01d7036230c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/351138440588399938",
    "name": "The 2974 Collection #2738",
    "imageUrl": "https://arweave.net/raUwitwZjht-aXEULQJGQgH2dv9myv1IC-pcxKjzsjk?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2739,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -19,
    "LOC_Y": 319,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/387/6d519768-fb39-0a06-b422-a22014ad4ede_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/381087410570429536",
    "name": "The 2974 Collection #2739",
    "imageUrl": "https://arweave.net/c-GNxq7CXuCgnzk28MHGL_mLeB0tPE-SRfYPa2TqG5Y?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2740,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -163,
    "LOC_Y": 260,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/390/a2703d0c-4a89-8a62-8601-5a556fd7124f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/501608650953887188",
    "name": "The 2974 Collection #2740",
    "imageUrl": "https://arweave.net/Gs1SHyIJXmF1iCNnxJSzFQQj6cn8irl8vi5oIGMvoUY?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2741,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -185,
    "LOC_Y": 242,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/437/3b8920ee-9dd6-50db-312c-93e3e01bca6a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/571502685301096644",
    "name": "The 2974 Collection #2741",
    "imageUrl": "https://arweave.net/DfZijX2enHWJMM8XeRtZEey16wWPSAh-ZlpeCmqrt8U?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2742,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -50,
    "LOC_Y": 275,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/463/fd5b1ebe-9844-943a-4607-6db7b4552a94_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/348393470600910347",
    "name": "The 2974 Collection #2742",
    "imageUrl": "https://arweave.net/cifdoYcQWR1AhARRt9bUEpzPJvKQd2vXpqZ68-a7_mo?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2743,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -97,
    "LOC_Y": 218,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/573/bb10c4d5-5ff4-54a0-9832-7dcb62934cf8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320501246101246043",
    "name": "The 2974 Collection #2743",
    "imageUrl": "https://arweave.net/o5YVyj0NMcopLZRELGZDHFofrljuHeDDBNzQw9mZNP0?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2744,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 135,
    "LOC_Y": 223,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/577/10750d77-14ac-393f-e7cf-90e5e1d136d8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346986461688015516",
    "name": "The 2974 Collection #2744",
    "imageUrl": "https://arweave.net/4LMF_FySGh1jRfGu08pGA5efhSv_bj_y6_RkA70cBbE?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2745,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -234,
    "LOC_Y": 112,
    "GAME_DATE": 20210417,
    "Season": "2020-2021",
    "HTM": "BOS",
    "VTM": "GSW",
    "Opposing Team": "BOS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/17/0022000858/638/65390402-51e6-8787-8eee-cea53dbf3f1f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/314685694065491791",
    "name": "The 2974 Collection #2745",
    "imageUrl": "https://arweave.net/42jbSxvBwqKY8ikuLazvueq27yBGZ7JiWTbNqIJ0acw?ext=png",
    "Opposing Team City": "Boston",
    "Year": 2021,
    "Month": 4,
    "Day": 17,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2746,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 107,
    "LOC_Y": 251,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/72/a38e7ff5-ab95-effd-052c-8e54fae9764a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395616623359681633",
    "name": "The 2974 Collection #2746",
    "imageUrl": "https://arweave.net/C_921jvfl95UcG5VA1LbRvtmX0crrncZD7uwSzVq0BE?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2747,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -128,
    "LOC_Y": 249,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/75/3ec7532d-b68d-58a3-0902-cd5c5a275bd8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/556861101876504469",
    "name": "The 2974 Collection #2747",
    "imageUrl": "https://arweave.net/Q6kdUEek5LJzMQKfX8E991VzHNu1WgEZf_s87v1xLHo?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2748,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 24,
    "LOC_Y": 281,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/146/3becbcde-912e-6b3d-d33f-1aae817985de_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395429269037475310",
    "name": "The 2974 Collection #2748",
    "imageUrl": "https://arweave.net/XThLeN_pGApx9g4OYAcbdHFllqOO3oMO5NAf6x_mi0s?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2749,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 154,
    "LOC_Y": 206,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/258/9188d0a5-d12b-b429-1938-5050bf41af02_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438600959904570505",
    "name": "The 2974 Collection #2749",
    "imageUrl": "https://arweave.net/sqJ9R9mpbOPb-s3qhP4Dd328sX5McpjWi7RDpCklxi4?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2750,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 28,
    "LOC_Y": 289,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/416/21e2627c-3b94-b357-694a-d186c6168a8c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/412444002391032390",
    "name": "The 2974 Collection #2750",
    "imageUrl": "https://arweave.net/9ipWSWgrDucD24Pvh4ggg3azNnSkRyWdmQ7qNKzomrM?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2751,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 40,
    "LOC_Y": 282,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/570/2416e86d-af09-2e69-17eb-b3694dd4e230_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312238878740769457",
    "name": "The 2974 Collection #2751",
    "imageUrl": "https://arweave.net/vyMmI5YgTtYRYCmvR5EKwVx2Kmg0EuA0Z2TLlARD3k8?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2752,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 65,
    "LOC_Y": 258,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/586/91d3f9b0-d283-0c9a-b245-ad08505f5411_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497240822689876290",
    "name": "The 2974 Collection #2752",
    "imageUrl": "https://arweave.net/brY_i4pOj44aLPOwrpZEMKGmkbDUbbcDhrbusEupI6Y?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2753,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 73,
    "LOC_Y": 279,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/603/c24c9b32-128e-d4b4-a336-dbda51306be7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/323816575566612477",
    "name": "The 2974 Collection #2753",
    "imageUrl": "https://arweave.net/cgqY1wbLv7dMQWg7_mNcJsSbeKjcwHoblSUBvXgx43U?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2754,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 137,
    "LOC_Y": 236,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/614/f20371ec-3147-dc3f-ada7-825bf01dfe5a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388514683478859580",
    "name": "The 2974 Collection #2754",
    "imageUrl": "https://arweave.net/YvyrhP3q7BTCS0POjlAUulYBsQA1uqBPQ4a_i_OkKMI?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2755,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 8,
    "LOC_Y": 290,
    "GAME_DATE": 20210419,
    "Season": "2020-2021",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/19/0022000870/630/9d97cd97-bbe4-4f76-3abd-fc28ac4b2d1b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439533945545450112",
    "name": "The 2974 Collection #2755",
    "imageUrl": "https://arweave.net/Eve0D6N6HXge91J8hsIKYyICOiKUq2idLVxr8Y6cxP0?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 4,
    "Day": 19,
    "3-Pointers made in the game": 10,
    "Special Moment": "Ten 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2756,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 54,
    "LOC_Y": 265,
    "GAME_DATE": 20210421,
    "Season": "2020-2021",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/21/0022000885/437/c812e76e-c575-5ad6-4f58-5baf89d4a362_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293263913041989787",
    "name": "The 2974 Collection #2756",
    "imageUrl": "https://arweave.net/6kimtQUTPoWM-UEjjrIAlsQwfXQd0dGWoGFBNPIh5no?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2021,
    "Month": 4,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2757,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 225,
    "LOC_Y": 128,
    "GAME_DATE": 20210421,
    "Season": "2020-2021",
    "HTM": "WAS",
    "VTM": "GSW",
    "Opposing Team": "WAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/21/0022000885/477/76919129-5409-2dab-d0fe-810ff5747d88_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/441013684821449144",
    "name": "The 2974 Collection #2757",
    "imageUrl": "https://arweave.net/Nvkby8kEWIW-t8faeNNRhSiNwGOu7QVOgfGDUF3c7IE?ext=png",
    "Opposing Team City": "Washington",
    "Year": 2021,
    "Month": 4,
    "Day": 21,
    "3-Pointers made in the game": 2,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2758,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 182,
    "LOC_Y": 252,
    "GAME_DATE": 20210423,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/23/0022000903/337/7612a010-4247-aa2b-e03a-bcc5c94ef78a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/497366257690669764",
    "name": "The 2974 Collection #2758",
    "imageUrl": "https://arweave.net/BfAWwPOorWdcw0LlCQ57w_QaT-Dx7TEHKF2Zn-b3qis?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2759,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -234,
    "LOC_Y": 10,
    "GAME_DATE": 20210423,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/23/0022000903/389/5091e4fb-f5ac-b411-79f1-106d2ad80ad4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/421391123183891386",
    "name": "The 2974 Collection #2759",
    "imageUrl": "https://arweave.net/Pqzt2L4vxAn94OIppOh6G45-XO6fCbydIfD7iSsN_J0?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2760,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -183,
    "LOC_Y": 198,
    "GAME_DATE": 20210423,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/23/0022000903/568/618c700b-805f-47f2-9de2-0326a3073dcc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395625633252025501",
    "name": "The 2974 Collection #2760",
    "imageUrl": "https://arweave.net/WSw-fFpUU85aCfa3ELHGfGCuO1MMVzstHMwR2exiCLM?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2761,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -135,
    "LOC_Y": 210,
    "GAME_DATE": 20210423,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DEN",
    "Opposing Team": "DEN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/23/0022000903/593/9e273cf3-f1b4-ec3a-24bb-7fdf3d1ac223_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/565259529980929710",
    "name": "The 2974 Collection #2761",
    "imageUrl": "https://arweave.net/TKjaGxKD8Yb4YpCFSh93ZPxgC3-7Jr-w6oZ7oPRGUnE?ext=png",
    "Opposing Team City": "Denver",
    "Year": 2021,
    "Month": 4,
    "Day": 23,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2762,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -183,
    "LOC_Y": 209,
    "GAME_DATE": 20210425,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/25/0022000915/30/490fbaba-cb27-f7e8-a504-d4113868c15d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436187802627065137",
    "name": "The 2974 Collection #2762",
    "imageUrl": "https://arweave.net/5yMT471sh5mVCahHjeYvvaeiDLQW0SB4YszSKAf44-4?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 4,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2763,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": 107,
    "LOC_Y": 320,
    "GAME_DATE": 20210425,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/25/0022000915/33/56dfcc0c-62fa-204f-991e-1cb8e736a554_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/555288979011610870",
    "name": "The 2974 Collection #2763",
    "imageUrl": "https://arweave.net/MAi_hFPsRyF0lV7a4n9Ysd2hp1dmrtpyhjAg0fIJoxc?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 4,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2764,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": 13,
    "LOC_Y": 328,
    "GAME_DATE": 20210425,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/25/0022000915/86/71dd2485-2a27-f152-70a2-48272fe8f148_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309663444996026845",
    "name": "The 2974 Collection #2764",
    "imageUrl": "https://arweave.net/HxhqcacUc4tlTg_ZTZ4Rf9ZfOrD1erXqQ5shz3ioZ9I?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 4,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2765,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 2,
    "LOC_Y": 298,
    "GAME_DATE": 20210425,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/25/0022000915/269/d30780b4-4e6d-1125-abd2-67c868991595_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322122028580564677",
    "name": "The 2974 Collection #2765",
    "imageUrl": "https://arweave.net/ZlQsivC1ZEQS7TamL2q--oJs3M7d3ygaiUyL9KNZAlI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 4,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2766,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 36,
    "LOC_X": 161,
    "LOC_Y": 322,
    "GAME_DATE": 20210425,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/25/0022000915/300/e9739f81-34cc-5975-3c81-fe1a9006ce44_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568829449794640768",
    "name": "The 2974 Collection #2766",
    "imageUrl": "https://arweave.net/cADVptutPa5svMvPNii8tQBRdJoV1BvJXufB98fnuuM?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 4,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2767,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 115,
    "LOC_Y": 253,
    "GAME_DATE": 20210425,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/25/0022000915/398/76cecd64-d754-4b93-3072-c21f5dbe4590_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/420224994546043730",
    "name": "The 2974 Collection #2767",
    "imageUrl": "https://arweave.net/s-lBF21UTkk3cA98_GXb-8CxJp-9O8F7TH1UJM-Ew3Q?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 4,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2768,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": 160,
    "LOC_Y": 279,
    "GAME_DATE": 20210425,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "SAC",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/25/0022000915/443/be6d4342-11d3-f5bb-e7ac-7665f7650733_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/310008166854140579",
    "name": "The 2974 Collection #2768",
    "imageUrl": "https://arweave.net/At5J4p0NzGtRowQd4sNWg1LGirP1f3YaatxbwkzeaH8?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 4,
    "Day": 25,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2769,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -12,
    "LOC_Y": 275,
    "GAME_DATE": 20210427,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/27/0022000932/25/349116ae-0e25-f3ee-06cd-72c7879629cc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/445105558422888222",
    "name": "The 2974 Collection #2769",
    "imageUrl": "https://arweave.net/76Bp60uX4JDKELeGzrPiGH7jjZKXyyj6MC_gtAfRFyY?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 4,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2770,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -193,
    "LOC_Y": 249,
    "GAME_DATE": 20210427,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/27/0022000932/38/00cf6d70-a41e-882d-ee1a-1c32dc8761be_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317872870863942776",
    "name": "The 2974 Collection #2770",
    "imageUrl": "https://arweave.net/HI1duADcoeooorRk63CBU-fiXGaxXbdlNsNO49FwxFk?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 4,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2771,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 120,
    "LOC_Y": 241,
    "GAME_DATE": 20210427,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/27/0022000932/333/f6bcaf04-bed8-1abf-b2c6-0847e3cf9585_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/355647620795349521",
    "name": "The 2974 Collection #2771",
    "imageUrl": "https://arweave.net/3L9GANwJ7nowQCFp4HRZ2MAp1g8ObyTdp7eAHom6_gc?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 4,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2772,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 19,
    "LOC_Y": 281,
    "GAME_DATE": 20210427,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/27/0022000932/345/6ed8fb6d-51b6-e01b-5f57-0f174ae42d58_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/379163806237698035",
    "name": "The 2974 Collection #2772",
    "imageUrl": "https://arweave.net/YTbrIzZ17k8zoq1qeeFiFsqsWUgJq4FVYWdXJfpAazg?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 4,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2773,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -112,
    "LOC_Y": 242,
    "GAME_DATE": 20210427,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "DAL",
    "Opposing Team": "DAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/27/0022000932/417/77aced42-f03c-e7c7-2169-4ab5469b23b3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384422620011487048",
    "name": "The 2974 Collection #2773",
    "imageUrl": "https://arweave.net/TUxea1jV4dnUc3W3Ub1sFd-32Xs0QPM27FCF6oUN1vQ?ext=png",
    "Opposing Team City": "Dallas",
    "Year": 2021,
    "Month": 4,
    "Day": 27,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2774,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 206,
    "LOC_Y": 143,
    "GAME_DATE": 20210429,
    "Season": "2020-2021",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/29/0022000946/66/a4c5baf6-f5f2-5a44-e372-986940630dbe_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/293535455288790666",
    "name": "The 2974 Collection #2774",
    "imageUrl": "https://arweave.net/LmeNZ7jZ-7qpkLzkpBXBgpIc15n_4z3nEzUyH2SmHd0?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 4,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2775,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 59,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 6,
    "LOC_Y": 256,
    "GAME_DATE": 20210429,
    "Season": "2020-2021",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/29/0022000946/314/bd79a4fd-db19-6e92-4f77-53d813db9d49_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536693228798849786",
    "name": "The 2974 Collection #2775",
    "imageUrl": "https://arweave.net/rpkXtfZ3lOmE1E4vX297-zqv_Zg7R-aL-tJ2DIH8iEw?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 4,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2776,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Mid-Range",
    "SHOT_DISTANCE": 23,
    "LOC_X": -217,
    "LOC_Y": 95,
    "GAME_DATE": 20210429,
    "Season": "2020-2021",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/29/0022000946/463/77096f85-b781-bb06-aa1f-01ecd6c47811_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373666122187762246",
    "name": "The 2974 Collection #2776",
    "imageUrl": "https://arweave.net/EiLmVdMBGfSMZytm_DoY1Z3V0iTF0XxMZ2S2xxFTl2Q?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 4,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2777,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 7,
    "LOC_Y": 258,
    "GAME_DATE": 20210429,
    "Season": "2020-2021",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/29/0022000946/478/22b4c333-a15a-0ea9-315f-f9a83cf3f81f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/312058148003839083",
    "name": "The 2974 Collection #2777",
    "imageUrl": "https://arweave.net/6GA5OpgNCR07jquSFh-ElgPv41k_p30aPiKQ12YB9s4?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 4,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2778,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 11,
    "LOC_Y": 287,
    "GAME_DATE": 20210429,
    "Season": "2020-2021",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/29/0022000946/501/a435d5dc-9653-6ffb-4b17-2a1d27b86c70_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/401715418022252086",
    "name": "The 2974 Collection #2778",
    "imageUrl": "https://arweave.net/O_vtLI2RnlMxdESCsT2uz1gpKQ1AJKCkS41n_8Z3b7U?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 4,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2779,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 110,
    "LOC_Y": 242,
    "GAME_DATE": 20210429,
    "Season": "2020-2021",
    "HTM": "MIN",
    "VTM": "GSW",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/04/29/0022000946/581/c2e66324-9679-e11b-ce78-5a4de80b92e0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338716981092779102",
    "name": "The 2974 Collection #2779",
    "imageUrl": "https://arweave.net/NoW0qg4PkwMpB6xPNJkGNABQ-C2F4IsHTF6YTK0HlWg?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 4,
    "Day": 29,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2780,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -123,
    "LOC_Y": 236,
    "GAME_DATE": 20210501,
    "Season": "2020-2021",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/01/0022000958/24/bf95d8b6-5e5a-431e-13e6-b4130bd941a6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/346758518466784843",
    "name": "The 2974 Collection #2780",
    "imageUrl": "https://arweave.net/DZm9Msk896vNLV0Qiz4Njpp9Vlf9BPBUB2MwEMzvZFs?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 5,
    "Day": 1,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2781,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 139,
    "LOC_Y": 261,
    "GAME_DATE": 20210501,
    "Season": "2020-2021",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/01/0022000958/61/0e310423-e62c-1990-e97b-c56a33e0b20a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386851676678222263",
    "name": "The 2974 Collection #2781",
    "imageUrl": "https://arweave.net/ZxV_7Oc51bKRLI76xkQHrHf0SRAAuFddxxLFZO8yH98?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 5,
    "Day": 1,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2782,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -226,
    "LOC_Y": 58,
    "GAME_DATE": 20210501,
    "Season": "2020-2021",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/01/0022000958/388/04f4c2ef-7024-f4f1-1e9c-4bbb33335f2a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/476570360669840396",
    "name": "The 2974 Collection #2782",
    "imageUrl": "https://arweave.net/A-fHtOfUqDh8fP_c14Z6QbecfIFuhP2bACfFZnH2M48?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 5,
    "Day": 1,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2783,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 13,
    "GAME_DATE": 20210501,
    "Season": "2020-2021",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/01/0022000958/413/26c5c14f-f7ef-eec5-025e-9578b57ffd54_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290848756016444788",
    "name": "The 2974 Collection #2783",
    "imageUrl": "https://arweave.net/KHIRHWyrhq3at70HP21BiFP0APb6vYbt67ANoH1c8Jc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 5,
    "Day": 1,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2784,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 103,
    "LOC_Y": 239,
    "GAME_DATE": 20210501,
    "Season": "2020-2021",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/01/0022000958/428/919c50e2-0010-c327-c675-ae23ae078115_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402230153865495437",
    "name": "The 2974 Collection #2784",
    "imageUrl": "https://arweave.net/zPVegHcW_lA1xqr1MNRVxFbCV2nShTr5TYHnPLF1els?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 5,
    "Day": 1,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2785,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -93,
    "LOC_Y": 256,
    "GAME_DATE": 20210501,
    "Season": "2020-2021",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/01/0022000958/445/3f408552-00de-117e-72ae-24f768a7111a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/566237463175944399",
    "name": "The 2974 Collection #2785",
    "imageUrl": "https://arweave.net/rtmTFNxIjNWMoyKzBRxC4_JBMOHGx_pQi6z3AiZ1jEc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 5,
    "Day": 1,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2786,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 111,
    "LOC_Y": 258,
    "GAME_DATE": 20210501,
    "Season": "2020-2021",
    "HTM": "HOU",
    "VTM": "GSW",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/01/0022000958/461/94ea9334-bed1-3062-c648-81ddd75f7dfc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525502397434375275",
    "name": "The 2974 Collection #2786",
    "imageUrl": "https://arweave.net/graI_f6u49uwUD3BIP4bwgOW8Vf4mUGm3kl2KPmUvRc?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 5,
    "Day": 1,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2787,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 230,
    "LOC_Y": 98,
    "GAME_DATE": 20210503,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/03/0022000977/54/9d310695-6164-3231-1ad8-607ced86c198_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/434989796949372962",
    "name": "The 2974 Collection #2787",
    "imageUrl": "https://arweave.net/k797v1MRTazBnDHdj59WoZuTALKgDmeHIEBXnuf81x0?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2788,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -67,
    "LOC_Y": 294,
    "GAME_DATE": 20210503,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/03/0022000977/148/f0487e70-2597-30e4-70dd-7af0994d2025_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567740529463878050",
    "name": "The 2974 Collection #2788",
    "imageUrl": "https://arweave.net/X26Hx56aNaE7wVkQO9Gx-UJO-OBPU0-7EcRTmiuToHw?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2789,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 168,
    "LOC_Y": 218,
    "GAME_DATE": 20210503,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/03/0022000977/151/018d888e-fd63-0d30-0460-6a607b2a66d2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/357159669303781149",
    "name": "The 2974 Collection #2789",
    "imageUrl": "https://arweave.net/fdjWzE9s08QJr4AWVoHouAVI3FaXuDYCN5xtJMy9o24?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2790,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -214,
    "LOC_Y": 151,
    "GAME_DATE": 20210503,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/03/0022000977/348/991f6d8d-8771-25ef-87ca-c606d6c851d6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/508014295529512305",
    "name": "The 2974 Collection #2790",
    "imageUrl": "https://arweave.net/YFN-rmaIuGbNKSXalAvXRCVt9DeHrIsXnXHD0RbU7cA?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2791,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -66,
    "LOC_Y": 279,
    "GAME_DATE": 20210503,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/03/0022000977/357/891d16a5-befe-fa1e-aa42-9100ee033ef7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/425177620303349173",
    "name": "The 2974 Collection #2791",
    "imageUrl": "https://arweave.net/VchQ3DKmEjJWePPDt_bbNSWUTivjZj64l-8b-RKE-GY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2792,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 215,
    "LOC_Y": 115,
    "GAME_DATE": 20210503,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/03/0022000977/401/d3768528-f680-ed8d-90b9-2fb7a4f32ecb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/492663110613922053",
    "name": "The 2974 Collection #2792",
    "imageUrl": "https://arweave.net/2aC8v7Q8GTz4OZR82uATR85oloH05TNgzamPjfum778?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2793,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -77,
    "LOC_Y": 274,
    "GAME_DATE": 20210503,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/03/0022000977/452/006915f8-089c-4657-dea9-3a5a68fcf75a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/540027741221833133",
    "name": "The 2974 Collection #2793",
    "imageUrl": "https://arweave.net/hk2AU1NGrYWHqIwTiF7JEjqOb7TR9j5_0u-ATPysTmo?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2794,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 21,
    "LOC_Y": 262,
    "GAME_DATE": 20210503,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/03/0022000977/564/ae0be76e-fef4-1565-a6a2-c8503c28171a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/449324035551525450",
    "name": "The 2974 Collection #2794",
    "imageUrl": "https://arweave.net/S2e3DnvrkuOViipyMGPdTaD9WMf1ima4NMtEjBJwayo?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 3,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2795,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 5,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 31,
    "GAME_DATE": 20210504,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/04/0022000987/66/e7123ac0-a94b-431a-9aac-d81cf0ac6f1f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/517360776524508116",
    "name": "The 2974 Collection #2795",
    "imageUrl": "https://arweave.net/EQjvSI4VXupmx80IsQ4X7pGaqtqG8rf8ZRLSVlpbAMo?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2796,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 123,
    "LOC_Y": 227,
    "GAME_DATE": 20210504,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/04/0022000987/97/e85fde97-4471-86e1-3324-3e51b88e8d92_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/297604565227510946",
    "name": "The 2974 Collection #2796",
    "imageUrl": "https://arweave.net/jORq5jiniRVXT0W848Cnp_zl1uCYA01Qp3UkZU0yyUc?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2797,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -149,
    "LOC_Y": 203,
    "GAME_DATE": 20210504,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/04/0022000987/115/f0ad8ba8-81da-d53a-c1a6-dde15254cefb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/478600681884904092",
    "name": "The 2974 Collection #2797",
    "imageUrl": "https://arweave.net/50tZpZioifWPr9VS04I4mL6GM9G9haKQPcpKrua3W2o?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2798,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 47,
    "LOC_Y": 267,
    "GAME_DATE": 20210504,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/04/0022000987/125/0325392e-cf22-f359-9d0d-2fa6c63532b0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/345216946438617281",
    "name": "The 2974 Collection #2798",
    "imageUrl": "https://arweave.net/WNYIbKfL6F_8N0AfL8gEKDYeBoZ-OqzWJV5gKVLuqQ4?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2799,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 41,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -96,
    "LOC_Y": 237,
    "GAME_DATE": 20210504,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/04/0022000987/321/85e315ce-f325-c8f2-2a1e-e5c1b7d3ce71_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485249938874467170",
    "name": "The 2974 Collection #2799",
    "imageUrl": "https://arweave.net/tKkGJ8DiFLp2e0PH-Vfpu_h7qKK_zj8DILFDjy3k8IY?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2800,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 189,
    "LOC_Y": 160,
    "GAME_DATE": 20210504,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/04/0022000987/341/bae44c47-b57b-c831-55ac-461c8a2de3a3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/347967375856842025",
    "name": "The 2974 Collection #2800",
    "imageUrl": "https://arweave.net/vtXplwPaMCv0Z16c8hyAyvtKSvjkaf9eFlTjkAOyqmU?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2801,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -126,
    "LOC_Y": 233,
    "GAME_DATE": 20210504,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/04/0022000987/362/d1e981e1-2e29-405d-15ce-6e29ec90620f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/451085011778668373",
    "name": "The 2974 Collection #2801",
    "imageUrl": "https://arweave.net/feSeqHBsTwtqFVtDE32IPejH-GGgTeYlkPRYLNc-ZQg?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2802,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 166,
    "LOC_Y": 217,
    "GAME_DATE": 20210504,
    "Season": "2020-2021",
    "HTM": "NOP",
    "VTM": "GSW",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/04/0022000987/419/66b106e7-b88e-7dc0-5364-391eaba5adea_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/495502240497155730",
    "name": "The 2974 Collection #2802",
    "imageUrl": "https://arweave.net/YdQlH7QOA2vbhXYn-77Q7qAkN7mY8wqyMA-F1HJjD68?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 5,
    "Day": 4,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2803,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 160,
    "LOC_Y": 247,
    "GAME_DATE": 20210506,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/06/0022001001/80/f1db60d8-0d38-af06-9347-750c4beddba4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/491765449562786985",
    "name": "The 2974 Collection #2803",
    "imageUrl": "https://arweave.net/MAXtzfgMBm-LSH1JcYGgXfZ8dKGeaJw0BKJGxvTbhsM?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2804,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -170,
    "LOC_Y": 228,
    "GAME_DATE": 20210506,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/06/0022001001/286/991f3f0d-b3eb-f74e-2ce0-f5366edabe8f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/388134204091310651",
    "name": "The 2974 Collection #2804",
    "imageUrl": "https://arweave.net/wuym2GFM7CKgjXW_FbDrzYOhwC6cpZtTGO1n300uwFI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2805,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 180,
    "LOC_Y": 214,
    "GAME_DATE": 20210506,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/06/0022001001/357/ea6bcd90-670e-cd38-6091-795d54562097_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/555604190314943286",
    "name": "The 2974 Collection #2805",
    "imageUrl": "https://arweave.net/PHMBRjmjEcUy5pWf0B_kfh-5my-o9kfvZoc3-1WQrEc?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2806,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -6,
    "LOC_Y": 255,
    "GAME_DATE": 20210506,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/06/0022001001/404/02b692a2-a767-6137-89de-4e154f1a5e68_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543802282826403993",
    "name": "The 2974 Collection #2806",
    "imageUrl": "https://arweave.net/JNEAhiyTfBv3_GYa04_jRJqEJAzh1VjGcW1VgsMZU3Y?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2807,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 161,
    "LOC_Y": 227,
    "GAME_DATE": 20210506,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/06/0022001001/409/7fb6adfa-2d4e-4328-a20b-5ff0c862107e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/492180985762253639",
    "name": "The 2974 Collection #2807",
    "imageUrl": "https://arweave.net/beXOr9qHVHcJ_EaRBXeqmjPTZ0jRcHM6B4F0xRIMgjM?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2808,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -123,
    "LOC_Y": 239,
    "GAME_DATE": 20210506,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/06/0022001001/429/9e3b5823-33ef-3fdb-fd06-1507c4635516_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/428787098690676809",
    "name": "The 2974 Collection #2808",
    "imageUrl": "https://arweave.net/Zuf_f3qqJ9LOe1YGUuiiuK_TEEpXSxUOZVnjkp8rfO4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 6,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2809,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 79,
    "LOC_Y": 270,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/14/7721a285-d677-1f60-110b-cab055cf5747_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/528617842706938313",
    "name": "The 2974 Collection #2809",
    "imageUrl": "https://arweave.net/pAaIe5higC5gV0dkor_fCZGP3vQTxfcKTe7UQLJELW0?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2810,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 50,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 86,
    "LOC_Y": 304,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/18/61185611-4630-3dd4-9596-148baf49552a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331789190978942110",
    "name": "The 2974 Collection #2810",
    "imageUrl": "https://arweave.net/vDF40c_L0ZZKcspjQuH0EDbZMcw1EG9h4VL9jeAiIKI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2811,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -73,
    "LOC_Y": 268,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/48/66ec0d30-1130-f96d-2b75-64777c068119_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/461075909712680006",
    "name": "The 2974 Collection #2811",
    "imageUrl": "https://arweave.net/dsQCbB18maxnmPJoHPsQNRniJz1WlM3hyRZBxKMFZAY?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2812,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -218,
    "LOC_Y": 152,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/70/8d4570b8-f1ee-7509-11c3-2c60b72c7d2e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/525924000821426121",
    "name": "The 2974 Collection #2812",
    "imageUrl": "https://arweave.net/xxn1TBQuzon0yUU2Qxjl2Gx0aX1NA_VTm6NQ2FB8iI4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2813,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 147,
    "LOC_Y": 280,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/157/336c577c-b5e1-8387-b896-1012abdf4759_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/363583334534028701",
    "name": "The 2974 Collection #2813",
    "imageUrl": "https://arweave.net/TustkDfaNq-g-B5UXHcpOgGxH9SFDEtArZ4oggcEWVI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2814,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 172,
    "LOC_Y": 236,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/298/b579a3ad-73e3-d248-941c-555fe3a3bc18_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378899158316676207",
    "name": "The 2974 Collection #2814",
    "imageUrl": "https://arweave.net/lFK0sCdHhPHnh7pi0DtYGMdC3lfJ_YgVlN5fib8mHn4?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2815,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 228,
    "LOC_Y": 38,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/328/d788eac5-cc05-2075-3f58-473042773fb3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/536826180122666173",
    "name": "The 2974 Collection #2815",
    "imageUrl": "https://arweave.net/D7K_YXONVc45fGag5Z-4MxWQqWkdSUXXRkDD5TUL6eI?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2816,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 119,
    "LOC_Y": 285,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/332/17ad404f-14cb-dc74-f869-a21cb12d7ec1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561728251511008748",
    "name": "The 2974 Collection #2816",
    "imageUrl": "https://arweave.net/NYLXI3LeRkUiic6vCFe3cmZUUXPeZF7MBjURfmdj-Go?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2817,
    "PERIOD": 3,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": 3,
    "LOC_Y": 334,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/383/5e99a42b-9acd-82bf-794d-c97d69761851_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/529316293272534235",
    "name": "The 2974 Collection #2817",
    "imageUrl": "https://arweave.net/1Po6R04IRBL_wvxHyqbClPZ68lokG5sbD4dwHchl3-s?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2818,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 16,
    "LOC_Y": 288,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/416/8fa643a5-5885-bdce-2e4f-9e35ed0819a3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/487544416923135616",
    "name": "The 2974 Collection #2818",
    "imageUrl": "https://arweave.net/nI099MglRR1REQohNmf02Z4QvxQHw1faZdbVZzqvaeE?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2819,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -203,
    "LOC_Y": 247,
    "GAME_DATE": 20210508,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/08/0022001017/424/6b4a3c7c-554b-b6fe-737d-d44f7a10043b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/557635784949094499",
    "name": "The 2974 Collection #2819",
    "imageUrl": "https://arweave.net/m0MyumY-6bHlyZsrxbeyDET8RZUqPv0RxkpvBHw0ffA?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 5,
    "Day": 8,
    "3-Pointers made in the game": 11,
    "Special Moment": "Eleven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2820,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 230,
    "LOC_Y": 41,
    "GAME_DATE": 20210510,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/10/0022001030/9/592cf6b5-7e46-88d4-8053-ef542b9b2e8e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/576119952514812572",
    "name": "The 2974 Collection #2820",
    "imageUrl": "https://arweave.net/Hp6X1JpiYPLXQgTVDW52ihlVi6tttYg3N_nK3AuZVkM?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 5,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2821,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -164,
    "LOC_Y": 226,
    "GAME_DATE": 20210510,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/10/0022001030/328/742f5e90-b99c-311e-6bcc-105a4bde1855_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438688791186395013",
    "name": "The 2974 Collection #2821",
    "imageUrl": "https://arweave.net/ovAZ0jsXoIMm-_s8Q30Kd4fVRgioT7H6ouo9tc5LuE4?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 5,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2822,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 71,
    "LOC_Y": 270,
    "GAME_DATE": 20210510,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "UTA",
    "Opposing Team": "UTA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/10/0022001030/644/83c9623b-a558-0736-ec44-8d565e8d46b3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/334418326421822345",
    "name": "The 2974 Collection #2822",
    "imageUrl": "https://arweave.net/fQIzl0qaacNu0TTbZOAqD-CSeK_PeO-VIjnMtRZJr4s?ext=png",
    "Opposing Team City": "Utah",
    "Year": 2021,
    "Month": 5,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2823,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 139,
    "LOC_Y": 260,
    "GAME_DATE": 20210511,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/11/0022001039/328/b0875128-4bd3-6dca-0639-2a8ec5bc2124_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/330514345303536367",
    "name": "The 2974 Collection #2823",
    "imageUrl": "https://arweave.net/pQ8Pcp-2zwx3s9pRwZ6aVh5ZH6_MBOSggBVo8dFuvPQ?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 5,
    "Day": 11,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2824,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -81,
    "LOC_Y": 245,
    "GAME_DATE": 20210516,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/16/0022001070/118/a496dac3-1eec-a618-aac2-a80c7e07610b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436002915784468792",
    "name": "The 2974 Collection #2824",
    "imageUrl": "https://arweave.net/tYSCdPb5qSZykXazzNQ2fz7QWAHdrU6sdgu50T_IAU0?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 5,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2825,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 35,
    "LOC_X": -152,
    "LOC_Y": 325,
    "GAME_DATE": 20210516,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/16/0022001070/338/749f98d0-5c10-8d8f-97a0-39aabf3da95c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/539448853244724701",
    "name": "The 2974 Collection #2825",
    "imageUrl": "https://arweave.net/-iryhH_Mkfzwk9VrsF5OV8-BsJAE-B0G1r8C5MBpaIw?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 5,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2826,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 169,
    "LOC_Y": 216,
    "GAME_DATE": 20210516,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/16/0022001070/365/5049a323-f7d6-ed8a-e8a5-19dc4b51c28f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484084665427703661",
    "name": "The 2974 Collection #2826",
    "imageUrl": "https://arweave.net/w2w8zS652loH5IcJL-kRpzyi6k5nowm-e9ikGXIYtvA?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 5,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2827,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 37,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -110,
    "LOC_Y": 295,
    "GAME_DATE": 20210516,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/16/0022001070/373/a1d5ec4b-9156-874f-0724-b20551de4ca6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/538261640089696896",
    "name": "The 2974 Collection #2827",
    "imageUrl": "https://arweave.net/p5azEarh4WvyCrcrJf7JFsLJC2yYs19Fh_Z-hdoEfpU?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 5,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2828,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 33,
    "LOC_X": 160,
    "LOC_Y": 293,
    "GAME_DATE": 20210516,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/16/0022001070/429/a6416412-d3a7-353d-da3c-53b6673e3968_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/401187031712628526",
    "name": "The 2974 Collection #2828",
    "imageUrl": "https://arweave.net/Txx8MZNSJE3D9OV1HGyg-2jgKSITwm4k4YUogIu6RXk?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 5,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2829,
    "PERIOD": 4,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 125,
    "LOC_Y": 242,
    "GAME_DATE": 20210516,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/16/0022001070/535/80c1da0c-5922-6e42-6462-eb15c01e2d75_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/301570013519020958",
    "name": "The 2974 Collection #2829",
    "imageUrl": "https://arweave.net/gTsHW6Geo2-u0XlpaK1wFYlk4uBIYkfRfSWux2monjw?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 5,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2830,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -177,
    "LOC_Y": 237,
    "GAME_DATE": 20210516,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/16/0022001070/599/24ab38eb-9e43-8a12-2540-a17dc32e775c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/439118445827918528",
    "name": "The 2974 Collection #2830",
    "imageUrl": "https://arweave.net/PXz82nPGWhR5o-0oIav3zG3F949JgIlh8cpnCER-7QY?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 5,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2831,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -164,
    "LOC_Y": 235,
    "GAME_DATE": 20210516,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/16/0022001070/610/ea37cd31-a366-8d9e-5773-5aaf849d7762_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374560370061731554",
    "name": "The 2974 Collection #2831",
    "imageUrl": "https://arweave.net/Agltg1ab4SaDL-1A7sJ9FxmWIVxWad9r7lcjQKrmi_0?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 5,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2832,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 143,
    "LOC_Y": 265,
    "GAME_DATE": 20210516,
    "Season": "2020-2021",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/05/16/0022001070/617/0df2cf02-e79c-61d3-c632-0faf7d34c9b9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518786982583105716",
    "name": "The 2974 Collection #2832",
    "imageUrl": "https://arweave.net/eW0AiMTjEqsrKpR7kC1s4P7VKFNP660NXgMZ53ek1R0?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 5,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2833,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -165,
    "LOC_Y": 189,
    "GAME_DATE": 20211019,
    "Season": "2021-2022",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/19/0022100002/37/1b0eadc2-80db-547b-bcf5-e19dd55156d6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/541904947643434141",
    "name": "The 2974 Collection #2833",
    "imageUrl": "https://arweave.net/5fi8VhQLlZR7P8cdFZ32sQr_rR3Fj192hB8eagL2OL8?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 19,
    "3-Pointers made in the game": 2,
    "Special Moment": "Triple-Double",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2834,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 48,
    "LOC_Y": 260,
    "GAME_DATE": 20211019,
    "Season": "2021-2022",
    "HTM": "LAL",
    "VTM": "GSW",
    "Opposing Team": "LAL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/19/0022100002/642/56d05e3d-4363-4f8f-983c-6eca01a12eae_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/311376095412793085",
    "name": "The 2974 Collection #2834",
    "imageUrl": "https://arweave.net/XlxIecy-jW3HOhFjA5pUHEuNKwm75uxLXZOgN-KMqf4?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 19,
    "3-Pointers made in the game": 2,
    "Special Moment": "Triple-Double",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2835,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 7,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 110,
    "LOC_Y": 237,
    "GAME_DATE": 20211021,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/21/0022100016/14/beb627f7-e39d-3317-07a9-f06a2a982dfb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493037777801160746",
    "name": "The 2974 Collection #2835",
    "imageUrl": "https://arweave.net/6m9M_kuudsJziFpUuIDQu_6H40eKVxFnlkmnJjcNOTo?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2836,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -116,
    "LOC_Y": 234,
    "GAME_DATE": 20211021,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/21/0022100016/78/b7c168c8-277e-841a-ca35-19dca7924471_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/520505944338133735",
    "name": "The 2974 Collection #2836",
    "imageUrl": "https://arweave.net/GwQw8H-JgZc2YFbSxP_pDK20AII9QA3c2FgT9dMmlUc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2837,
    "PERIOD": 1,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 80,
    "LOC_Y": 247,
    "GAME_DATE": 20211021,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/21/0022100016/113/6bf0e2f3-09b5-7931-5781-80885186d5b5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/317267258166431659",
    "name": "The 2974 Collection #2837",
    "imageUrl": "https://arweave.net/I1H25ASX9EdFYzVSQgV_oq9zVh_AJJ_V8WNcxa-h9Cg?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2838,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -98,
    "LOC_Y": 237,
    "GAME_DATE": 20211021,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/21/0022100016/116/babdfdb9-3567-23c2-761d-a44cef1916dd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415598209648397099",
    "name": "The 2974 Collection #2838",
    "imageUrl": "https://arweave.net/MMGrDqxLfURNpuLxwP3QhtYshRwAoIoR_jczMy6PIqc?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2839,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 213,
    "LOC_Y": 134,
    "GAME_DATE": 20211021,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/21/0022100016/150/a3908eaf-fca8-7622-a900-7bb3bd84e7a2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480163266439752370",
    "name": "The 2974 Collection #2839",
    "imageUrl": "https://arweave.net/LN6WlrJPhOMBuINiY1SxpOhlkI_dlorNEAArnzfEgoU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2840,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -125,
    "LOC_Y": 230,
    "GAME_DATE": 20211021,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/21/0022100016/423/f7ae6055-a01c-0f67-d24a-2ca4e1be9e84_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/351240914693124055",
    "name": "The 2974 Collection #2840",
    "imageUrl": "https://arweave.net/JjcjgyGUcFXcxkNdsoE8n97J41g2cbR0u6JrZCBMiSA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2841,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -116,
    "LOC_Y": 286,
    "GAME_DATE": 20211021,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/21/0022100016/662/3a55a960-8c5e-2d7e-7a08-19b05b73b36c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/480996554137336110",
    "name": "The 2974 Collection #2841",
    "imageUrl": "https://arweave.net/ZHM_DByKst2eZOcuLLe9LNJYjZgMgPBNhJJVxD6KO6E?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2842,
    "PERIOD": 4,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 157,
    "LOC_Y": 212,
    "GAME_DATE": 20211021,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "LAC",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/21/0022100016/671/d56c54ea-bb84-e540-993b-84c8c61d1281_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415460076098908762",
    "name": "The 2974 Collection #2842",
    "imageUrl": "https://arweave.net/Cg3Jkjphveek_qzvrsHrJ1A3KZ8eIltIOkgo7_Eq_dA?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 10,
    "Day": 21,
    "3-Pointers made in the game": 8,
    "Special Moment": "Eight 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2843,
    "PERIOD": 1,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -103,
    "LOC_Y": 252,
    "GAME_DATE": 20211024,
    "Season": "2021-2022",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/24/0022100039/93/e4f16b05-379d-61d0-69ac-75aaf30f5826_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456267908866930894",
    "name": "The 2974 Collection #2843",
    "imageUrl": "https://arweave.net/oB1oeu59eybUiIKoEkF2qgnkv7gM-vjFd3vYhleK2Gg?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2844,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 4,
    "LOC_Y": 286,
    "GAME_DATE": 20211024,
    "Season": "2021-2022",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/24/0022100039/130/6eda6194-aa0e-5dcc-abba-ce6982c71550_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/319113025113968892",
    "name": "The 2974 Collection #2844",
    "imageUrl": "https://arweave.net/mTjZ7TRiNhdIxbxhE5huaCEYae2cnUdFkXbdw8szIcQ?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2845,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 126,
    "LOC_Y": 213,
    "GAME_DATE": 20211024,
    "Season": "2021-2022",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/24/0022100039/357/7ea633fc-333e-d51b-fa58-f06a0d604fb4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/362600444453307267",
    "name": "The 2974 Collection #2845",
    "imageUrl": "https://arweave.net/6YJWWTV3mVJyp0LtQM9ivxxvgxA8P4IiwX10WPzi4ZI?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2846,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -200,
    "LOC_Y": 156,
    "GAME_DATE": 20211024,
    "Season": "2021-2022",
    "HTM": "SAC",
    "VTM": "GSW",
    "Opposing Team": "SAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/24/0022100039/473/457db76e-a08d-6bdf-2099-9f099065a596_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512865543776599900",
    "name": "The 2974 Collection #2846",
    "imageUrl": "https://arweave.net/_tEUXnlfIPR0PFGd2niIrGqknInJqS5o1OtahK3zIy8?ext=png",
    "Opposing Team City": "Sacramento",
    "Year": 2021,
    "Month": 10,
    "Day": 24,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2847,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -181,
    "LOC_Y": 212,
    "GAME_DATE": 20211026,
    "Season": "2021-2022",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/26/0022100051/131/ca6267a2-6c1b-515a-f49d-f56ece8a449c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/559088685414554043",
    "name": "The 2974 Collection #2847",
    "imageUrl": "https://arweave.net/vOdlNMS33QF7lGbVqLYMoOwz0NDjN7oKxFXpWZeZQgQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2848,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 183,
    "LOC_Y": 181,
    "GAME_DATE": 20211026,
    "Season": "2021-2022",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/26/0022100051/135/86f72c66-2e63-93c5-1dbd-46be7ef6e922_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/465964282983706647",
    "name": "The 2974 Collection #2848",
    "imageUrl": "https://arweave.net/L1GuQhgpcMd3UQ5EOU631993IiYKqnosaoUfbEvLY8Y?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2849,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -47,
    "LOC_Y": 251,
    "GAME_DATE": 20211026,
    "Season": "2021-2022",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/26/0022100051/295/40f74053-1b5b-ced1-1e4c-9078db373951_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450294409799718588",
    "name": "The 2974 Collection #2849",
    "imageUrl": "https://arweave.net/w62yV1gARXBx4Oc2KTZv2XDVOlJ6rcu2Y9Qs_fBfQ8A?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2850,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 4,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 15,
    "LOC_Y": 256,
    "GAME_DATE": 20211026,
    "Season": "2021-2022",
    "HTM": "OKC",
    "VTM": "GSW",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/26/0022100051/345/88bf5de7-3913-e66d-8abd-47db3b0455c6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/410996351261171724",
    "name": "The 2974 Collection #2850",
    "imageUrl": "https://arweave.net/VcfG-q3t3dHFSgFRjmZ01-dAECuOHdMJQXQrAsqxm70?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 26,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2851,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 162,
    "LOC_Y": 214,
    "GAME_DATE": 20211028,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/28/0022100070/54/0996abc0-9bff-0f8e-ca46-f5c541045d6f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/359290904061599157",
    "name": "The 2974 Collection #2851",
    "imageUrl": "https://arweave.net/yqYTTZM04372hbH5uFevPnBB9i4SaVCqDa3z73Fy3Aw?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2852,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -186,
    "LOC_Y": 177,
    "GAME_DATE": 20211028,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/28/0022100070/126/bb2c9be4-78f0-26cf-54ab-ed82d9abeda1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/291144447893302672",
    "name": "The 2974 Collection #2852",
    "imageUrl": "https://arweave.net/TzPSvFtRyV68xzYmaHlJlGUpc7W6xslXasmXkZwacCc?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2853,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 201,
    "LOC_Y": 198,
    "GAME_DATE": 20211028,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/28/0022100070/289/ca915e56-23f9-356c-3d4c-949c4c79505f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444077168405303781",
    "name": "The 2974 Collection #2853",
    "imageUrl": "https://arweave.net/N7ZNGg_zrOQ-mUndf1tTPwa8pOesL3laH7mg6vpTAOY?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2854,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -173,
    "LOC_Y": 195,
    "GAME_DATE": 20211028,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/28/0022100070/316/30fdcab3-b832-e0b3-40e7-f0e75f062af7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/485876308753445588",
    "name": "The 2974 Collection #2854",
    "imageUrl": "https://arweave.net/vX4xlSt6nfosU81_lpzWf75qT3k9jzpFhPuojpTK3eM?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2855,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 164,
    "LOC_Y": 212,
    "GAME_DATE": 20211028,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/28/0022100070/383/82ed1ac1-cc29-60f6-d209-d533a9eabe5f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404413011441448007",
    "name": "The 2974 Collection #2855",
    "imageUrl": "https://arweave.net/9_luNAJhbG_iXeDPSeo9sPW8TPr-eAtFEcxSCbDwHYg?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2856,
    "PERIOD": 3,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -164,
    "LOC_Y": 247,
    "GAME_DATE": 20211028,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/28/0022100070/396/fbf7974d-3dfd-a338-edce-dd2fbc0940b6_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444895355960712716",
    "name": "The 2974 Collection #2856",
    "imageUrl": "https://arweave.net/MRPB2jVYyFFQdaJfIxqKMsiQvgX5jPicjEdGCshlWD4?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2857,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 32,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -225,
    "LOC_Y": 18,
    "GAME_DATE": 20211028,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MEM",
    "Opposing Team": "MEM",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/28/0022100070/445/8705b88f-6e1b-fbc0-050e-c010d0fa65a9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/569551010338344282",
    "name": "The 2974 Collection #2857",
    "imageUrl": "https://arweave.net/x8u5EBwpEJ1jtVGEo3h_CQ-0u7XdwBkpOv7-Z5UsgjM?ext=png",
    "Opposing Team City": "Memphis",
    "Year": 2021,
    "Month": 10,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2858,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 113,
    "LOC_Y": 214,
    "GAME_DATE": 20211030,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/30/0022100086/69/4ff757a9-90c9-97b4-6d91-d33daf58bfe3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/544472394304707145",
    "name": "The 2974 Collection #2858",
    "imageUrl": "https://arweave.net/Bdl_iG8elW3RFrYM4OH589XqI5pC6z00wBYDAzX0zPw?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2859,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 217,
    "LOC_Y": 132,
    "GAME_DATE": 20211030,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/30/0022100086/325/9879446b-effd-99b9-d541-5b8624d135a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/557482951065872551",
    "name": "The 2974 Collection #2859",
    "imageUrl": "https://arweave.net/zkF0kxgf4po2JKaw6ZUET2M9GKPbYKdIKb1ux2Zz13w?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2860,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 195,
    "LOC_Y": 153,
    "GAME_DATE": 20211030,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/30/0022100086/328/2b364f9c-0d55-9760-1000-318ed0006462_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331051359455133054",
    "name": "The 2974 Collection #2860",
    "imageUrl": "https://arweave.net/GJLQz4N5wPLu07FqHPmgPxnv2k-bZUMsj-XiAX9pziQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2861,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -240,
    "LOC_Y": -11,
    "GAME_DATE": 20211030,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/30/0022100086/338/a7cf930d-a312-24ad-9595-3e99d6ddccac_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489541674059437681",
    "name": "The 2974 Collection #2861",
    "imageUrl": "https://arweave.net/_ckLNiD1au7rn1jQgTXjvcRW-t8oQmWCJwAk5TZfDBQ?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2862,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 157,
    "LOC_Y": 199,
    "GAME_DATE": 20211030,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/30/0022100086/404/c5273599-6746-f344-c3ab-c603a1c6ac90_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429574032740703602",
    "name": "The 2974 Collection #2862",
    "imageUrl": "https://arweave.net/VPnBAqTLbYlkDUm3umIkVZgr788ZouEhsZDQyJUZosg?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2863,
    "PERIOD": 3,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 42,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -213,
    "LOC_Y": 121,
    "GAME_DATE": 20211030,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "OKC",
    "Opposing Team": "OKC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/10/30/0022100086/407/2a4cfc17-b2a5-67ee-dcd4-9e1e4f766fcc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440196337481514527",
    "name": "The 2974 Collection #2863",
    "imageUrl": "https://arweave.net/4dCu59WOkjMqh4ECdQhxyKd2odn-yrd_ivZ7dvHEg8A?ext=png",
    "Opposing Team City": "Oklahoma City",
    "Year": 2021,
    "Month": 10,
    "Day": 30,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2864,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 18,
    "LOC_Y": 283,
    "GAME_DATE": 20211103,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/03/0022100117/319/41fe2e62-13c2-51dc-3916-5f27707ad9f5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/561578186141915431",
    "name": "The 2974 Collection #2864",
    "imageUrl": "https://arweave.net/3VN0Gz53Gv0UhI9vzSggovj5yJBtQ8lhwHrjqxKUfyg?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2021,
    "Month": 11,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2865,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 207,
    "LOC_Y": 232,
    "GAME_DATE": 20211103,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/03/0022100117/515/1b6cf1fc-d874-3e2d-3e7c-b193a2fd07a5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/471477739092397501",
    "name": "The 2974 Collection #2865",
    "imageUrl": "https://arweave.net/aCnbxN99t78QGho_gB6IBvhCkshkZIv4aCNUcP8bF7o?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2021,
    "Month": 11,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2866,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 40,
    "LOC_Y": 293,
    "GAME_DATE": 20211103,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHA",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/03/0022100117/558/af7bbf86-9a69-9eb4-e5a7-8fc7ac950649_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/327006473689875676",
    "name": "The 2974 Collection #2866",
    "imageUrl": "https://arweave.net/TFMmjnEXrtKr_Hac3Kfi4RweYK2jkBksZK914Hf6_8w?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2021,
    "Month": 11,
    "Day": 3,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2867,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 48,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 124,
    "LOC_Y": 264,
    "GAME_DATE": 20211105,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/05/0022100130/37/d9a445b2-212a-d402-ea93-f49d106c436b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/373594096847423334",
    "name": "The 2974 Collection #2867",
    "imageUrl": "https://arweave.net/-nLjPLm_QY5xwW_A6nNKZ4TgFEoMOtzw2mJiI9K_hcE?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2868,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 22,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -154,
    "LOC_Y": 206,
    "GAME_DATE": 20211105,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/05/0022100130/44/89964b86-91ae-665d-7701-09291bf4b915_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/430934296922363865",
    "name": "The 2974 Collection #2868",
    "imageUrl": "https://arweave.net/AKFt6FRwmQZmM1AUP2SxJ7L5cm5kWns4XF3PWUnNXEE?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2869,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -78,
    "LOC_Y": 266,
    "GAME_DATE": 20211105,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/05/0022100130/82/48eb46e6-3b62-9d59-dab3-f81f5e7d3080_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489442589001151945",
    "name": "The 2974 Collection #2869",
    "imageUrl": "https://arweave.net/omjTVqCJOKxzi_sII5nrnseYvKrKkI-FSBI1_M6x2cs?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2870,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 26,
    "LOC_Y": 289,
    "GAME_DATE": 20211105,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/05/0022100130/125/362d6c0b-d845-b634-b88b-7e63764f45e1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/309565722804522948",
    "name": "The 2974 Collection #2870",
    "imageUrl": "https://arweave.net/M086J-IXFgcwdidud72a87MRDuYi3wpEN0QW0vaW6JA?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2871,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 52,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -154,
    "LOC_Y": 233,
    "GAME_DATE": 20211105,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "NOP",
    "Opposing Team": "NOP",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/05/0022100130/348/75e23d7d-42f6-6312-2ba9-acc9b8926a71_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/506672278539385622",
    "name": "The 2974 Collection #2871",
    "imageUrl": "https://arweave.net/xKpSKaVp8QDUc3WQiaOVhqXN6npJdGJ8n0b7uUWO1yA?ext=png",
    "Opposing Team City": "New Orleans",
    "Year": 2021,
    "Month": 11,
    "Day": 5,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2872,
    "PERIOD": 1,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 227,
    "LOC_Y": 73,
    "GAME_DATE": 20211107,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/07/0022100145/32/7a7769d5-3b97-f0d4-1059-e01677e35c1a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/509231357463496530",
    "name": "The 2974 Collection #2872",
    "imageUrl": "https://arweave.net/DgS-0g135X9MGpRsTCRtrXUneDhko6p9TO3yXtIU5fY?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2873,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 26,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 5,
    "LOC_Y": 279,
    "GAME_DATE": 20211107,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/07/0022100145/321/5e546645-69c8-356e-189f-8f3c0a156522_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/454040090577095704",
    "name": "The 2974 Collection #2873",
    "imageUrl": "https://arweave.net/9huVs0HR3NivLAFIg4FKlEypPpI_XvXFpIwjsPI4cJ8?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2874,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -152,
    "LOC_Y": 218,
    "GAME_DATE": 20211107,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/07/0022100145/423/8cd9e9da-ecac-9aa5-f77c-862aafd8a3b2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/310316431344587693",
    "name": "The 2974 Collection #2874",
    "imageUrl": "https://arweave.net/J5ZCmvXEnEFUc7WGNnZQQVIVQ-imo5xXuzy2T-b9hS0?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2875,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -67,
    "LOC_Y": 241,
    "GAME_DATE": 20211107,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "HOU",
    "Opposing Team": "HOU",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/07/0022100145/502/27d85ac7-a53f-0937-7f8e-8b2c6cafd8a2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446115040426807584",
    "name": "The 2974 Collection #2875",
    "imageUrl": "https://arweave.net/QFgTL04wuC3XIoc6imM6rXvjJzxbOABBqRCFI6ZbOjI?ext=png",
    "Opposing Team City": "Houston",
    "Year": 2021,
    "Month": 11,
    "Day": 7,
    "3-Pointers made in the game": 4,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2876,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 114,
    "LOC_Y": 247,
    "GAME_DATE": 20211108,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/08/0022100152/7/b3714651-8875-9890-452c-388a1f1f29a4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/440558590093327469",
    "name": "The 2974 Collection #2876",
    "imageUrl": "https://arweave.net/vgBAZEytrp1Kee6HdHjMs-Yy-rZwNDw1R_vjh5wEUQg?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game (50 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2877,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 5,
    "LOC_Y": 294,
    "GAME_DATE": 20211108,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/08/0022100152/14/70bfb9fd-cc46-c6c6-150b-25fde8193f88_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406731596437312361",
    "name": "The 2974 Collection #2877",
    "imageUrl": "https://arweave.net/vAxtbxF7cQQC4fDw3CCfqJzADT7uiyT_p7IDnEspxkA?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game (50 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2878,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 87,
    "LOC_Y": 277,
    "GAME_DATE": 20211108,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/08/0022100152/162/88bc8b54-df1a-2fc8-83fa-7eeb83de09b9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543995490245265260",
    "name": "The 2974 Collection #2878",
    "imageUrl": "https://arweave.net/oElyxkTCeF5hYqtXU2aaHPL8slNzLJPNs0BJMQLLfxo?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game (50 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2879,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": -16,
    "GAME_DATE": 20211108,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/08/0022100152/306/e1316584-4dde-e8e3-33a0-a52e20b59065_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/295804929368397449",
    "name": "The 2974 Collection #2879",
    "imageUrl": "https://arweave.net/7Rav-kE8fZhhKEVwLNPN1h_uYs3YW3t4gwMg7L0lEZ0?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game (50 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2880,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 3,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -20,
    "LOC_Y": 309,
    "GAME_DATE": 20211108,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/08/0022100152/345/d07c1514-c1de-b35d-2752-e77d7d83101a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/493931660511782194",
    "name": "The 2974 Collection #2880",
    "imageUrl": "https://arweave.net/XIte1bPhp-DYxGdH02z-tRTKLYvaVyTWjfv29LJkza0?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game (50 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2881,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 57,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 158,
    "LOC_Y": 240,
    "GAME_DATE": 20211108,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/08/0022100152/388/b4cad8ad-6903-4cf8-f0da-e49dfa8e53d4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/490179202193771604",
    "name": "The 2974 Collection #2881",
    "imageUrl": "https://arweave.net/A37Me7urKNSIWuL0wtNc3begx60RsGg8w3aIVJSmfkA?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game (50 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2882,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 129,
    "LOC_Y": 261,
    "GAME_DATE": 20211108,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/08/0022100152/486/5dbcbc41-2e8a-0c21-2456-cb9f2a023ab4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/307503130748211598",
    "name": "The 2974 Collection #2882",
    "imageUrl": "https://arweave.net/d9EKa0UBnzwRCtPZFQ4z4cNeuiq038w0HeZgmKn4UVA?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game (50 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2883,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 221,
    "LOC_Y": 130,
    "GAME_DATE": 20211108,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/08/0022100152/523/edaa972e-429b-72fa-a371-9586ecac3611_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/463489638369026251",
    "name": "The 2974 Collection #2883",
    "imageUrl": "https://arweave.net/U4rGqZLCzlQzHbx_eeb1fPhdZpkIBZs5V-eBinjxFl4?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game (50 Points)",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2884,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 51,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -191,
    "LOC_Y": 157,
    "GAME_DATE": 20211108,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ATL",
    "Opposing Team": "ATL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/08/0022100152/592/785d5616-9aca-7cdf-53f3-b23f8b5abafc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/409236266464709575",
    "name": "The 2974 Collection #2884",
    "imageUrl": "https://arweave.net/OPuRcstsOO40erzpUYtLbQ84I965bnIPcakiJwq0gTM?ext=png",
    "Opposing Team City": "Atlanta",
    "Year": 2021,
    "Month": 11,
    "Day": 8,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game (50 Points)",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2885,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -32,
    "LOC_Y": 278,
    "GAME_DATE": 20211110,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/10/0022100169/170/e0d6a055-f3c1-332e-e79a-db0651fc741e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/511944995058897734",
    "name": "The 2974 Collection #2885",
    "imageUrl": "https://arweave.net/RTr8qbIqObkPf4eLydAdI5lTaSVCRz_uJLHq7Me4-4A?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2886,
    "PERIOD": 2,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 11,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -116,
    "LOC_Y": 281,
    "GAME_DATE": 20211110,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/10/0022100169/209/2d755064-283c-e1ff-14ff-4159400a9213_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/331100005514946964",
    "name": "The 2974 Collection #2886",
    "imageUrl": "https://arweave.net/5r568GdLip3wNWkEai3mVdIi82QuqGX0jArC1cIFoxI?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2887,
    "PERIOD": 3,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 197,
    "LOC_Y": 172,
    "GAME_DATE": 20211110,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "MIN",
    "Opposing Team": "MIN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/10/0022100169/509/574d750c-f3e1-f288-8e38-3c5b8a261b73_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/559204721718490526",
    "name": "The 2974 Collection #2887",
    "imageUrl": "https://arweave.net/3R-aw4-6pJmjClFiU9-zLumW0y_0S5PLcIPnwCRgzVI?ext=png",
    "Opposing Team City": "Minnesota",
    "Year": 2021,
    "Month": 11,
    "Day": 10,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2888,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 4,
    "LOC_Y": 267,
    "GAME_DATE": 20211112,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/12/0022100183/14/0b6fb93f-9064-3ab2-aa3e-b2a08147dfc5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/322223549463903915",
    "name": "The 2974 Collection #2888",
    "imageUrl": "https://arweave.net/XLi9FN_KGOnwP35ZhkImlfr7Vl2D-tvrqV8p9wf3CbE?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2889,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 27,
    "LOC_Y": 262,
    "GAME_DATE": 20211112,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/12/0022100183/169/5f4025a6-f7d3-edf0-d2ba-462f2f35d335_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/462978986081437688",
    "name": "The 2974 Collection #2889",
    "imageUrl": "https://arweave.net/aDXskZDi_o066NEM_Wc76aqnT2zjGO8AHjl5Tbiy704?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2890,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 196,
    "LOC_Y": 155,
    "GAME_DATE": 20211112,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/12/0022100183/177/9dd26d03-c797-22bb-ed89-75b76431f4b3_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/543779855015613698",
    "name": "The 2974 Collection #2890",
    "imageUrl": "https://arweave.net/wLXL2HSWkNx8wGcm9eu8VOE55UE5aa8Ar1jtay--Hws?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2891,
    "PERIOD": 3,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 189,
    "LOC_Y": 196,
    "GAME_DATE": 20211112,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/12/0022100183/333/54e41031-459b-4a15-0972-7eae3b20ab8b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/517631549541169829",
    "name": "The 2974 Collection #2891",
    "imageUrl": "https://arweave.net/fKsgE9F3Ytuok_YUO0tRCJaD3pjeLour7y3fXnf9l-I?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2892,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 152,
    "LOC_Y": 220,
    "GAME_DATE": 20211112,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/12/0022100183/361/52d3bbfe-f49c-9988-ead5-7a3a69b4e049_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/410317630775423396",
    "name": "The 2974 Collection #2892",
    "imageUrl": "https://arweave.net/mvPveDemVf68zO1W7L6nBDvVv9xlP882zjtbC8kLK40?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2893,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 173,
    "LOC_Y": 197,
    "GAME_DATE": 20211112,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/12/0022100183/394/64b4fc79-a6fc-d046-69fd-6ef0f24f5d15_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/473988279718381171",
    "name": "The 2974 Collection #2893",
    "imageUrl": "https://arweave.net/hGkMRicmpZAJMcgA8LPNq7jqKVFgdL_Xgx2zoGeZGiY?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2894,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 100,
    "LOC_Y": 246,
    "GAME_DATE": 20211112,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/12/0022100183/464/a88562b7-f09d-f7b5-7dca-e3c6b6cdd579_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/290465588774829107",
    "name": "The 2974 Collection #2894",
    "imageUrl": "https://arweave.net/UaB6tDiZADzDTPwjcc9yPxHrl4uy0l2haJOivz2NaRU?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2895,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -23,
    "LOC_Y": 284,
    "GAME_DATE": 20211112,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/12/0022100183/584/e155ad38-4d36-e33b-a127-99c7ce61bfc5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/429557901036953514",
    "name": "The 2974 Collection #2895",
    "imageUrl": "https://arweave.net/0eXxwLNAk3Frv4xZwVYdpFDZM1XrqHyeiuoC-F_HKEU?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2896,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -235,
    "LOC_Y": 80,
    "GAME_DATE": 20211112,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "CHI",
    "Opposing Team": "CHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/12/0022100183/598/183d3231-1344-0f74-5f54-b5dbcdfa5888_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/288733967893249940",
    "name": "The 2974 Collection #2896",
    "imageUrl": "https://arweave.net/Rll54EhXkOyOhejOH5BIY7edNKMWnuN3JQKbad3l1X4?ext=png",
    "Opposing Team City": "Chicago",
    "Year": 2021,
    "Month": 11,
    "Day": 12,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2897,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -168,
    "LOC_Y": 188,
    "GAME_DATE": 20211114,
    "Season": "2021-2022",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/14/0022100194/307/19f11c8a-7129-617f-01fb-4972e6cc4521_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/402654680423800714",
    "name": "The 2974 Collection #2897",
    "imageUrl": "https://arweave.net/8pW1LfzNdHTzVuIqFh1QxZ2GQk-LiWNenIlDxsBU1-U?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2021,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2898,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -190,
    "LOC_Y": 178,
    "GAME_DATE": 20211114,
    "Season": "2021-2022",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/14/0022100194/515/6b625a9f-1404-0b9a-20ea-20e8746db57e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/568737973006790663",
    "name": "The 2974 Collection #2898",
    "imageUrl": "https://arweave.net/k8kLyZk1nK7SF_tNhpoOnS7qz9j-QeQdBK8rYRIUyqw?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2021,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2899,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Jump Bank Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 36,
    "LOC_X": -184,
    "LOC_Y": 320,
    "GAME_DATE": 20211114,
    "Season": "2021-2022",
    "HTM": "CHA",
    "VTM": "GSW",
    "Opposing Team": "CHA",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/14/0022100194/534/7c96e2fe-1b26-d7a2-0c74-57782a707bac_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/328091900418196244",
    "name": "The 2974 Collection #2899",
    "imageUrl": "https://arweave.net/VTHsjjwm96pk7l7pPOAPN5MHe2ifD1yScrlBnwhuzVw?ext=png",
    "Opposing Team City": "Charlotte",
    "Year": 2021,
    "Month": 11,
    "Day": 14,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2900,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -178,
    "LOC_Y": 193,
    "GAME_DATE": 20211116,
    "Season": "2021-2022",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/16/0022100210/20/286aa0df-86ce-5c16-65a7-d777c0c848d4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558304022556484422",
    "name": "The 2974 Collection #2900",
    "imageUrl": "https://arweave.net/7w3uObWxx62zdm-NU6MUJT0J23nTQ9g6YiCuz3cR6jA?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2901,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 146,
    "LOC_Y": 204,
    "GAME_DATE": 20211116,
    "Season": "2021-2022",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/16/0022100210/58/8370a713-898f-2f9f-d61a-7ceb41dbf38e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523841546606289374",
    "name": "The 2974 Collection #2901",
    "imageUrl": "https://arweave.net/4wCUCoECWeRtJ6utLSp76l6dRTHjkr4mJ760rbWIbgE?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2902,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -11,
    "LOC_Y": 302,
    "GAME_DATE": 20211116,
    "Season": "2021-2022",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/16/0022100210/112/df7f74f4-6b44-4eda-f09d-cba7c0aa1025_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438850919994640418",
    "name": "The 2974 Collection #2902",
    "imageUrl": "https://arweave.net/wcRufTGr9RfSy1vQJb9YHVOtpPRsRTJuAVrC5KHnSL4?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2903,
    "PERIOD": 1,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 34,
    "LOC_X": 164,
    "LOC_Y": 309,
    "GAME_DATE": 20211116,
    "Season": "2021-2022",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/16/0022100210/115/0b54f206-46ba-6bf0-a8a5-d7f0d6227cb8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/324075991790635929",
    "name": "The 2974 Collection #2903",
    "imageUrl": "https://arweave.net/h3dcfe4mwHVBElhhc-qKil-EpIIS6d8t6EjNAO40W5g?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2904,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 46,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": -16,
    "LOC_Y": 313,
    "GAME_DATE": 20211116,
    "Season": "2021-2022",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/16/0022100210/326/ddcbc257-a3d6-3ae4-bb8f-1d15a40d1c53_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/487097386427949456",
    "name": "The 2974 Collection #2904",
    "imageUrl": "https://arweave.net/8Xre4MHw2bL2b99AqKI_l0ygOLgVJ47SyR3EshY2X4k?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2905,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -25,
    "LOC_Y": 269,
    "GAME_DATE": 20211116,
    "Season": "2021-2022",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/16/0022100210/405/0f8843c8-bec3-7c14-ceda-0fef5fa3bc82_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474006758127852631",
    "name": "The 2974 Collection #2905",
    "imageUrl": "https://arweave.net/ZVPfiYfH2ec0fZx6s1QVpCVOIiEFuWiyzz0tiMgP-hk?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2906,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 93,
    "LOC_Y": 282,
    "GAME_DATE": 20211116,
    "Season": "2021-2022",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/16/0022100210/557/58a23be1-671c-78ad-eff0-7916e71d0e40_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/438952901558557887",
    "name": "The 2974 Collection #2906",
    "imageUrl": "https://arweave.net/FFSvvO3C9xMgoZ47AjN21mlgPrqpyRnnsa9pG9IzIf8?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2907,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": 116,
    "LOC_Y": 284,
    "GAME_DATE": 20211116,
    "Season": "2021-2022",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/16/0022100210/568/1ee54587-4ac3-b142-4d60-eb857e874a1c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296110905788582643",
    "name": "The 2974 Collection #2907",
    "imageUrl": "https://arweave.net/ju9bw3jzH3hMRA4B06j8o95HNYi6lON_H9dycdirc5U?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2908,
    "PERIOD": 4,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -188,
    "LOC_Y": 195,
    "GAME_DATE": 20211116,
    "Season": "2021-2022",
    "HTM": "BKN",
    "VTM": "GSW",
    "Opposing Team": "BKN",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/16/0022100210/613/8db3cff4-739b-61f5-94d9-5f5cc919aae9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/483620742893506473",
    "name": "The 2974 Collection #2908",
    "imageUrl": "https://arweave.net/VWfZ_vmjBDbPP3ZJc7sYiuola-1FX6wmbqgQ3yHkvLw?ext=png",
    "Opposing Team City": "Brooklyn",
    "Year": 2021,
    "Month": 11,
    "Day": 16,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2909,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 53,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 224,
    "LOC_Y": 125,
    "GAME_DATE": 20211118,
    "Season": "2021-2022",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/18/0022100224/31/c6abedc5-3673-e070-31f9-d48199606283_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/418043116000303103",
    "name": "The 2974 Collection #2909",
    "imageUrl": "https://arweave.net/mLVjLJjwPXFCKk3SWvcKhUrea78IqT3LwRxW5K_aJtw?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2910,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 29,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -143,
    "LOC_Y": 201,
    "GAME_DATE": 20211118,
    "Season": "2021-2022",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/18/0022100224/147/46924e7f-502a-e0ba-48d9-1715dafea2fb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/484088442300986922",
    "name": "The 2974 Collection #2910",
    "imageUrl": "https://arweave.net/6elN0-hPywnfYsZU02FOoFZ08sUeFxRFovU87Dbajw8?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2911,
    "PERIOD": 2,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -199,
    "LOC_Y": 206,
    "GAME_DATE": 20211118,
    "Season": "2021-2022",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/18/0022100224/169/a8c2d9ba-efc0-e20d-0c63-063e146f1999_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/394260159743428360",
    "name": "The 2974 Collection #2911",
    "imageUrl": "https://arweave.net/q4PQBnodR_vVJCa-P1qsoZzt1Jymtt2ziYuyZ6UCgwQ?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2912,
    "PERIOD": 2,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -189,
    "LOC_Y": 158,
    "GAME_DATE": 20211118,
    "Season": "2021-2022",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/18/0022100224/215/f004abab-228b-2e61-e769-5f91ac12c6a1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/372543657348668946",
    "name": "The 2974 Collection #2912",
    "imageUrl": "https://arweave.net/Vv_FRVs5OJsdMQjrGfBrdB7bgQK_IZVL9F09Gvn4Q2Q?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2913,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 14,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -211,
    "LOC_Y": 197,
    "GAME_DATE": 20211118,
    "Season": "2021-2022",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/18/0022100224/343/16a4df4d-9380-2e3f-560b-7dcdcaa4aac4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/397608346526379942",
    "name": "The 2974 Collection #2913",
    "imageUrl": "https://arweave.net/rIc1u4ipc0RUf-yaOkFvSopN9t6GNS8BhroUdTUDigI?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2914,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 151,
    "LOC_Y": 232,
    "GAME_DATE": 20211118,
    "Season": "2021-2022",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/18/0022100224/476/aea68b8e-20fe-532a-5308-6bff8e99a031_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/456818719289284858",
    "name": "The 2974 Collection #2914",
    "imageUrl": "https://arweave.net/SbSkLk83V3Naix32nOZ_XjO-dz_mym5NOB-90KPoC8Q?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2915,
    "PERIOD": 4,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 15,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 230,
    "LOC_Y": 73,
    "GAME_DATE": 20211118,
    "Season": "2021-2022",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/18/0022100224/485/e6ac1798-8302-47dd-6a26-e9a29ec05038_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/500717704300338004",
    "name": "The 2974 Collection #2915",
    "imageUrl": "https://arweave.net/yuBV7jsQkiF9Qd0Pj_mL_4Tt7EU87oOynA4iLq8og9s?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2916,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -224,
    "LOC_Y": 139,
    "GAME_DATE": 20211118,
    "Season": "2021-2022",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/18/0022100224/491/d3377bbb-7e04-dac0-f302-81fede00fed4_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/553667357495021490",
    "name": "The 2974 Collection #2916",
    "imageUrl": "https://arweave.net/5NUjLyhEjduLlu69KF1ZbGd46bMD05YGU8cjzyCk2Lc?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2917,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -212,
    "LOC_Y": 169,
    "GAME_DATE": 20211118,
    "Season": "2021-2022",
    "HTM": "CLE",
    "VTM": "GSW",
    "Opposing Team": "CLE",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/18/0022100224/582/14c59322-bff9-62db-9d0f-ee4a208a6815_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/515143846670622060",
    "name": "The 2974 Collection #2917",
    "imageUrl": "https://arweave.net/awqeXUOp4JYUFWD-AUTd03wNhwhKdJQYh_eAkLmic1A?ext=png",
    "Opposing Team City": "Cleveland",
    "Year": 2021,
    "Month": 11,
    "Day": 18,
    "3-Pointers made in the game": 9,
    "Special Moment": "Nine 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2918,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -229,
    "LOC_Y": 92,
    "GAME_DATE": 20211121,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "TOR",
    "Opposing Team": "TOR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/21/0022100252/71/0062876a-9144-4175-4338-feda1eb38c48_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/489369349053839457",
    "name": "The 2974 Collection #2918",
    "imageUrl": "https://arweave.net/Ui-eHrTqcCKH_f8rWqBtw_K5Q_e1PuxvfXHFHLOMllY?ext=png",
    "Opposing Team City": "Toronto",
    "Year": 2021,
    "Month": 11,
    "Day": 21,
    "3-Pointers made in the game": 1,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2919,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -115,
    "LOC_Y": 264,
    "GAME_DATE": 20211124,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/24/0022100278/45/2f024f6d-c9bd-750d-0197-3022dcc5e098_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/444542374622249319",
    "name": "The 2974 Collection #2919",
    "imageUrl": "https://arweave.net/g2CoH3J60FppAF2LNuQbgsBJKdXOhA8LeiI11-Pe2GA?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2920,
    "PERIOD": 2,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -188,
    "LOC_Y": 205,
    "GAME_DATE": 20211124,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/24/0022100278/210/42e9c8a0-bde1-baba-e758-3a4a1e4de76c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/302240906300083720",
    "name": "The 2974 Collection #2920",
    "imageUrl": "https://arweave.net/Nyv7KGbc60RZYNePq9UhidBSSkoAjdcZKsHtw5XoB_k?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2921,
    "PERIOD": 2,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 195,
    "LOC_Y": 206,
    "GAME_DATE": 20211124,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/24/0022100278/299/ea53b2b1-8209-fec0-278e-54c77adf8473_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/494972718926406482",
    "name": "The 2974 Collection #2921",
    "imageUrl": "https://arweave.net/01r4G1jHjSmHq8TVsUIToNG_YqwbOorsaSkZNOeqeRs?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2922,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 19,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -38,
    "LOC_Y": 263,
    "GAME_DATE": 20211124,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/24/0022100278/405/1a715e0a-25f4-8293-6bc8-7c2d8d9a1172_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/377305383854623586",
    "name": "The 2974 Collection #2922",
    "imageUrl": "https://arweave.net/WaQ704CqSy7TLqa27TVvX25LHHBqDaVvxbEYMqoz9jw?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2923,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -212,
    "LOC_Y": 168,
    "GAME_DATE": 20211124,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/24/0022100278/532/46601d0c-7724-d26f-d68c-6fbb8d6298bd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/506146280662354675",
    "name": "The 2974 Collection #2923",
    "imageUrl": "https://arweave.net/0FRFa7Y9bT72T51qUJ2oCr4pGb3kAucOUXxZw8v_o70?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2924,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 27,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -180,
    "LOC_Y": 206,
    "GAME_DATE": 20211124,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHI",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/24/0022100278/697/fa9a2633-f564-c969-4b4a-7b315ac8e2cd_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/288478840331956407",
    "name": "The 2974 Collection #2924",
    "imageUrl": "https://arweave.net/ZlTx9r1O-yGvx5Nqt0MJnG5v_b-fiV13imKERkqFQWg?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 11,
    "Day": 24,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2925,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 31,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 137,
    "LOC_Y": 241,
    "GAME_DATE": 20211126,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/26/0022100290/16/32ade2e9-5d86-67ae-8107-223bc7313345_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/341054235391748939",
    "name": "The 2974 Collection #2925",
    "imageUrl": "https://arweave.net/HjJsAjTsHauIqR98-9s8ue6G2dEMVG6gM8CVk__Nh3s?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2926,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 9,
    "ACTION_TYPE": "Running Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -191,
    "LOC_Y": 201,
    "GAME_DATE": 20211126,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/26/0022100290/273/17080176-ba22-95c1-49d6-42ea25b67ad5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/502677660799060803",
    "name": "The 2974 Collection #2926",
    "imageUrl": "https://arweave.net/TVDyM4oB7npRwnirh_EnwVRFPQojcbgmcs_OqqHJDqk?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2927,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 8,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": -93,
    "LOC_Y": 280,
    "GAME_DATE": 20211126,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/26/0022100290/300/0cd16cac-1f43-21c2-0ec1-72069252aad5_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/436954083647124291",
    "name": "The 2974 Collection #2927",
    "imageUrl": "https://arweave.net/pASvRcn8b2rgBDsbIhSuT1m42gSVhjw9BEPJwEAHqzs?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2928,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 148,
    "LOC_Y": 230,
    "GAME_DATE": 20211126,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/26/0022100290/338/a1b33303-d680-5c1a-ce19-ec293e48c65c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/366000790603264709",
    "name": "The 2974 Collection #2928",
    "imageUrl": "https://arweave.net/hYVi7sY-VvFdzUlMRLAQpv--9Ef6VmQn_DgvOIRb7es?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2929,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 10,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -190,
    "LOC_Y": 157,
    "GAME_DATE": 20211126,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/26/0022100290/570/9e224c34-1142-be88-cc51-6f311d871799_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/365089549690839829",
    "name": "The 2974 Collection #2929",
    "imageUrl": "https://arweave.net/_FcCmcediIEi9tGGdEGej45DBSK4xrCR4J6OvuCltoA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2930,
    "PERIOD": 4,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -199,
    "LOC_Y": 176,
    "GAME_DATE": 20211126,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/26/0022100290/575/75394a87-1b72-ac70-6ba8-2c4f381bd760_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/504624277225545987",
    "name": "The 2974 Collection #2930",
    "imageUrl": "https://arweave.net/Hj-EGRaLWPIVnxX8mmjcZnUgi8tSEqpMt78NGf6ixQo?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 11,
    "Day": 26,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2931,
    "PERIOD": 1,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 18,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": 225,
    "LOC_Y": -10,
    "GAME_DATE": 20211128,
    "Season": "2021-2022",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/28/0022100300/11/7ed1b359-4f4b-0b1e-f938-02a6c9b32a96_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/474987886960122480",
    "name": "The 2974 Collection #2931",
    "imageUrl": "https://arweave.net/bxBHTqPlQU6iXcRJdS-eq64jVhRYr808uaC7feQ5vjI?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2932,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 151,
    "LOC_Y": 199,
    "GAME_DATE": 20211128,
    "Season": "2021-2022",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/28/0022100300/146/777fcbcb-f394-2789-5235-86b5e644a6ba_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/567131818530172657",
    "name": "The 2974 Collection #2932",
    "imageUrl": "https://arweave.net/4wtart8nQL5T5B0MJ5JuCsKZEvA2Wq9USM2vkW1LcxU?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2933,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 40,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -137,
    "LOC_Y": 221,
    "GAME_DATE": 20211128,
    "Season": "2021-2022",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/28/0022100300/333/51157019-1d94-f596-e94c-7c98c934bf5e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/392163202529793487",
    "name": "The 2974 Collection #2933",
    "imageUrl": "https://arweave.net/Q9AfCR0KriMFimo8CBI9yu46cbI5YLBzcDVXuaYbm8U?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2934,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 120,
    "LOC_Y": 292,
    "GAME_DATE": 20211128,
    "Season": "2021-2022",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/28/0022100300/388/cf3184cf-5ef3-711f-c4e6-d5c3e48f1dcb_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/406237667850895196",
    "name": "The 2974 Collection #2934",
    "imageUrl": "https://arweave.net/u4Mtbss6maGghZv8wywwT0vX3k_OxjgeUqVJzvrXh_g?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2935,
    "PERIOD": 4,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 36,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 32,
    "LOC_X": 81,
    "LOC_Y": 315,
    "GAME_DATE": 20211128,
    "Season": "2021-2022",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/28/0022100300/606/66b64a74-5d49-a29e-fbd9-0e41615be0ef_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/550480313449809756",
    "name": "The 2974 Collection #2935",
    "imageUrl": "https://arweave.net/XaJIqdDNqtxiFTa-sub3k7C5QScV1KqhFizzmVQAE1E?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2936,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 157,
    "LOC_Y": 220,
    "GAME_DATE": 20211128,
    "Season": "2021-2022",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/28/0022100300/615/c4ac5dfb-8724-bbb8-f20e-b158dfc449dc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/558445876050494498",
    "name": "The 2974 Collection #2936",
    "imageUrl": "https://arweave.net/zuPJ_nKOS6wULCnCYwBN_laaxxg-EINrzGXWVk5zSMk?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2937,
    "PERIOD": 4,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 21,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -233,
    "LOC_Y": 71,
    "GAME_DATE": 20211128,
    "Season": "2021-2022",
    "HTM": "LAC",
    "VTM": "GSW",
    "Opposing Team": "LAC",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/28/0022100300/618/34f47ef4-7a79-62b7-1c57-bb430df20759_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/417606974372540531",
    "name": "The 2974 Collection #2937",
    "imageUrl": "https://arweave.net/gWbKqLyqq6-8VVRj-_okdtupJkgTxVuY-2tqz9WpJV0?ext=png",
    "Opposing Team City": "Los Angeles",
    "Year": 2021,
    "Month": 11,
    "Day": 28,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2938,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 28,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -167,
    "LOC_Y": 204,
    "GAME_DATE": 20211130,
    "Season": "2021-2022",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/30/0022100316/57/8361441e-3141-b5d2-8813-dc92496d4b82_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/570568802731906844",
    "name": "The 2974 Collection #2938",
    "imageUrl": "https://arweave.net/EDxNwWrwhL5A_UqmlQEcaxCj3m8CmCptumWnaQeJoig?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2939,
    "PERIOD": 2,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 25,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 80,
    "LOC_Y": 261,
    "GAME_DATE": 20211130,
    "Season": "2021-2022",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/30/0022100316/226/eddc606f-032e-f64b-f0ab-472fb0b4e9de_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/446051990911390723",
    "name": "The 2974 Collection #2939",
    "imageUrl": "https://arweave.net/dSzHq1Q1nMnmUOHlUo0OYI_2Jw-gl-aQUpvisuw5sbQ?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2940,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 34,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -62,
    "LOC_Y": 257,
    "GAME_DATE": 20211130,
    "Season": "2021-2022",
    "HTM": "PHX",
    "VTM": "GSW",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/11/30/0022100316/490/59533c78-2771-bfde-d72e-94b6137b40b0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/404181542281091521",
    "name": "The 2974 Collection #2940",
    "imageUrl": "https://arweave.net/w3pvHY47lrjaRSs-oToRFUSUPRKN9E1ttK2NK2vGO18?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 11,
    "Day": 30,
    "3-Pointers made in the game": 3,
    "Special Moment": "",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2941,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 49,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 49,
    "LOC_Y": 261,
    "GAME_DATE": 20211203,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/03/0022100340/19/1310a914-5335-fa14-94fd-6a773fff38b9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/554729773448484151",
    "name": "The 2974 Collection #2941",
    "imageUrl": "https://arweave.net/r06Zh_HT7DB1Yq0oUkwVW3g7bRXp2zeGV_DXbZCWrNI?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2942,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -199,
    "LOC_Y": 187,
    "GAME_DATE": 20211203,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/03/0022100340/74/0c74ac5f-bef1-a4aa-3f96-d87071487e62_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/383675149528981173",
    "name": "The 2974 Collection #2942",
    "imageUrl": "https://arweave.net/sPqX1dj7ztW8JhPKoXwIipb9fPnQ26IlczIffNI1jU8?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2943,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 16,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 17,
    "GAME_DATE": 20211203,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/03/0022100340/224/1118c883-2d24-30f7-5eb4-5d508aa18e99_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/507574454846214832",
    "name": "The 2974 Collection #2943",
    "imageUrl": "https://arweave.net/HCzbbsUtxiz7GBS1O8nrrYn6RhAGVK4YbYsRUwN_K3s?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2944,
    "PERIOD": 2,
    "MINUTES_REMAINING": 4,
    "SECONDS_REMAINING": 23,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -207,
    "LOC_Y": 159,
    "GAME_DATE": 20211203,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/03/0022100340/276/a25c24c2-d399-6b45-641d-11f765822b0f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/518275380205737283",
    "name": "The 2974 Collection #2944",
    "imageUrl": "https://arweave.net/y-etkaerX3yl0jk650vcmFvUzfzgPUQbTEB1s9mzuzo?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2945,
    "PERIOD": 3,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 47,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 22,
    "LOC_X": -228,
    "LOC_Y": 16,
    "GAME_DATE": 20211203,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/03/0022100340/367/56c3b5f0-7937-b17d-760c-8f69e773b1a1_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/378120359127356796",
    "name": "The 2974 Collection #2945",
    "imageUrl": "https://arweave.net/I6_5yEmKzisZV1GkOb1p3G0DWPpzM8A4c_wxH4B9luM?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2946,
    "PERIOD": 3,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 38,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": -192,
    "LOC_Y": 216,
    "GAME_DATE": 20211203,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "PHX",
    "Opposing Team": "PHX",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/03/0022100340/384/7eb3aa3e-f22a-be68-7c97-ec069c299157_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/296065517658030501",
    "name": "The 2974 Collection #2946",
    "imageUrl": "https://arweave.net/NtGUjd4H2nVlD6HUSo1AbWR3BOFGWNPKDcX0z6L-vzE?ext=png",
    "Opposing Team City": "Phoenix",
    "Year": 2021,
    "Month": 12,
    "Day": 3,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2947,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 61,
    "LOC_Y": 263,
    "GAME_DATE": 20211204,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/04/0022100346/314/e861bf10-455d-d29b-7869-b72665bf36ea_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/450364640859721898",
    "name": "The 2974 Collection #2947",
    "imageUrl": "https://arweave.net/XrB_0hoRq8GLlCjvtXvTAJwSk8q1umVwO-u1lbdf_NQ?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2948,
    "PERIOD": 3,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 165,
    "LOC_Y": 192,
    "GAME_DATE": 20211204,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/04/0022100346/480/2263faa0-fd6a-3c3b-6d60-a1f407eddb0c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/552579869037961237",
    "name": "The 2974 Collection #2948",
    "imageUrl": "https://arweave.net/wsKqjxVLiMiFALGKQ6d8CIJqUuC-aIQjo7NkGJJgBL0?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2949,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 0,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -222,
    "LOC_Y": 117,
    "GAME_DATE": 20211204,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/04/0022100346/495/92cee9b3-5bd5-bb70-6d8b-1a81f95b129a_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/432164425550433328",
    "name": "The 2974 Collection #2949",
    "imageUrl": "https://arweave.net/9W7Gp0nwftX2mco0QLxPVaEP0K56SB1dNRu8p94r0vA?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2950,
    "PERIOD": 3,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 37,
    "LOC_X": 112,
    "LOC_Y": 360,
    "GAME_DATE": 20211204,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/04/0022100346/505/93a6109d-b77e-edfd-0872-8aa0a9c937a8_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/533820483964251482",
    "name": "The 2974 Collection #2950",
    "imageUrl": "https://arweave.net/gAfbX7W2003qhdRLy0nDvsBcgtFwYA-38AHeKC9gTrs?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2951,
    "PERIOD": 4,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 39,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": -203,
    "LOC_Y": 129,
    "GAME_DATE": 20211204,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "SAS",
    "Opposing Team": "SAS",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/04/0022100346/620/b8712f2b-f82b-b6b6-990a-34e5d4b3d275_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/469871642001145899",
    "name": "The 2974 Collection #2951",
    "imageUrl": "https://arweave.net/bNswVgm20877zpHoMq3XRwJr0FXt8i87iIc8AVbEU3g?ext=png",
    "Opposing Team City": "San Antonio",
    "Year": 2021,
    "Month": 12,
    "Day": 4,
    "3-Pointers made in the game": 5,
    "Special Moment": "Five 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2952,
    "PERIOD": 1,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Running Pull-Up Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 31,
    "LOC_X": 33,
    "LOC_Y": 313,
    "GAME_DATE": 20211206,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/06/0022100361/35/2fca8f93-1760-e797-b7cd-de0ca2e9a798_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/548076687638362422",
    "name": "The 2974 Collection #2952",
    "imageUrl": "https://arweave.net/26mSmYPpNzKCMNIKYWZKjM-3DORE42yHXwHkkwV-6PA?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2953,
    "PERIOD": 1,
    "MINUTES_REMAINING": 6,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 6,
    "LOC_Y": 281,
    "GAME_DATE": 20211206,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/06/0022100361/55/3b820ad5-246b-256c-f379-a3f66c643c5b_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/516019107599606913",
    "name": "The 2974 Collection #2953",
    "imageUrl": "https://arweave.net/xXjcvwt8L5ll_K8G5Jqu_EGCXcCt-LokFbLGzELuQr0?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2954,
    "PERIOD": 1,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 36,
    "LOC_X": -6,
    "LOC_Y": 366,
    "GAME_DATE": 20211206,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/06/0022100361/153/48bd56de-ec17-c4f4-23f9-68efaeaca2ed_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/523038530303710492",
    "name": "The 2974 Collection #2954",
    "imageUrl": "https://arweave.net/6JhvmqqNb64T8195-BxR0Q8jgCud81Z7fIiOejleJi0?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2955,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 44,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 5,
    "LOC_Y": 269,
    "GAME_DATE": 20211206,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/06/0022100361/295/998ed22c-5398-1d6e-c7e4-764c7bdabdc2_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/374573087363497577",
    "name": "The 2974 Collection #2955",
    "imageUrl": "https://arweave.net/U0mRvucF3tLLulckGaij212yLq_snVrJYmLTOIzVw4I?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2956,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -164,
    "LOC_Y": 216,
    "GAME_DATE": 20211206,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/06/0022100361/382/06cb9ae7-de6d-301a-d820-983d4592655f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/415110666497979421",
    "name": "The 2974 Collection #2956",
    "imageUrl": "https://arweave.net/4LuebzErRgZxeH9-1_UtjJruHgXbryGorFPtbflsSgw?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2957,
    "PERIOD": 4,
    "MINUTES_REMAINING": 11,
    "SECONDS_REMAINING": 30,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Left Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": -232,
    "LOC_Y": -3,
    "GAME_DATE": 20211206,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/06/0022100361/518/445b27f3-27ee-9291-ea72-06812f1299c7_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/386323112144320632",
    "name": "The 2974 Collection #2957",
    "imageUrl": "https://arweave.net/1MD7o0bC1V-iXRh9WCs1a8BBTcTZqR33kKODuZStHFw?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2958,
    "PERIOD": 4,
    "MINUTES_REMAINING": 9,
    "SECONDS_REMAINING": 12,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 34,
    "LOC_Y": 285,
    "GAME_DATE": 20211206,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "ORL",
    "Opposing Team": "ORL",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/06/0022100361/544/4c979935-77ea-f3fa-3c75-1379ba4dec68_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/338027810282193182",
    "name": "The 2974 Collection #2958",
    "imageUrl": "https://arweave.net/ADcgdcUu4D8pqSthyn0CRaM-LMylYN5ueUsII5aiogs?ext=png",
    "Opposing Team City": "Orlando",
    "Year": 2021,
    "Month": 12,
    "Day": 6,
    "3-Pointers made in the game": 7,
    "Special Moment": "Seven 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2959,
    "PERIOD": 1,
    "MINUTES_REMAINING": 5,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 223,
    "LOC_Y": 130,
    "GAME_DATE": 20211208,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/08/0022100376/89/d196d27a-f890-894b-3efb-3d6b908c50df_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/385620150543759307",
    "name": "The 2974 Collection #2959",
    "imageUrl": "https://arweave.net/_J9-Fe07oASirWVPCk98jibpk_TrM1adas6EmsmBmLE?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2960,
    "PERIOD": 1,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 1,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -203,
    "LOC_Y": 163,
    "GAME_DATE": 20211208,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/08/0022100376/166/98c2f7ba-493c-b9d7-09fd-273b0a3b605e_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/316784871676983613",
    "name": "The 2974 Collection #2960",
    "imageUrl": "https://arweave.net/MVK82nDQAgBwRrgeb4UMEkl6vPGXDil3khc1dPL8tCc?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2961,
    "PERIOD": 2,
    "MINUTES_REMAINING": 2,
    "SECONDS_REMAINING": 55,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -156,
    "LOC_Y": 209,
    "GAME_DATE": 20211208,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/08/0022100376/285/bf807a7f-9366-1678-b57a-4131d94d6679_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/395362354323677043",
    "name": "The 2974 Collection #2961",
    "imageUrl": "https://arweave.net/rlWeEs7Ymfer2v4-Jj8-nfjZwQ5NYdjOWPk_vN_51Do?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2962,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 23,
    "LOC_X": 234,
    "LOC_Y": 44,
    "GAME_DATE": 20211208,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/08/0022100376/300/d1abbd18-d052-bc24-a4c1-6c7f9665f2ba_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/522843111826464476",
    "name": "The 2974 Collection #2962",
    "imageUrl": "https://arweave.net/WPBcxM8yMnmKqvpv4eVSU6CLNYbpijdtMYNKkP82mSA?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2963,
    "PERIOD": 3,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 43,
    "ACTION_TYPE": "Step Back Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 124,
    "LOC_Y": 250,
    "GAME_DATE": 20211208,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/08/0022100376/364/08b2d30c-49cc-e63b-5bbb-22214cff26b0_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/300868809693038514",
    "name": "The 2974 Collection #2963",
    "imageUrl": "https://arweave.net/r3OFtABGz9q8n9ARyM5vUgrlXO52feHQXtHGXNZ700A?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2964,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 20,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 28,
    "LOC_X": 222,
    "LOC_Y": 176,
    "GAME_DATE": 20211208,
    "Season": "2021-2022",
    "HTM": "GSW",
    "VTM": "POR",
    "Opposing Team": "POR",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/08/0022100376/386/733d121e-1c41-3428-57d9-f211e0831bf9_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/369763689374497202",
    "name": "The 2974 Collection #2964",
    "imageUrl": "https://arweave.net/G2zvAXHiQz6Vth03HQ5AH4x4wSXzbCCkZtAe1JLBBl8?ext=png",
    "Opposing Team City": "Portland",
    "Year": 2021,
    "Month": 12,
    "Day": 8,
    "3-Pointers made in the game": 6,
    "Special Moment": "Six 3-Pointer Game",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2965,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 45,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 137,
    "LOC_Y": 220,
    "GAME_DATE": 20211211,
    "Season": "2021-2022",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/11/0022100396/293/b24de7a4-e7a1-161f-783f-50c4dc3043ca_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/298012741961431120",
    "name": "The 2974 Collection #2965",
    "imageUrl": "https://arweave.net/6m8gsJuk4nCOLFxNLZB98gMcyf0pcJD5S70E-BpCaB0?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "9 to Go",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2966,
    "PERIOD": 2,
    "MINUTES_REMAINING": 0,
    "SECONDS_REMAINING": 17,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": -42,
    "LOC_Y": 252,
    "GAME_DATE": 20211211,
    "Season": "2021-2022",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/11/0022100396/312/7f633160-8f07-69bb-7d44-a209af90f940_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/560787592572496385",
    "name": "The 2974 Collection #2966",
    "imageUrl": "https://arweave.net/aX0P6AAKF-8_mxP7V0WmXDNGtT3Z-M6e6PBmdlS63Ok?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "8 to Go",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2967,
    "PERIOD": 4,
    "MINUTES_REMAINING": 3,
    "SECONDS_REMAINING": 2,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": -66,
    "LOC_Y": 262,
    "GAME_DATE": 20211211,
    "Season": "2021-2022",
    "HTM": "PHI",
    "VTM": "GSW",
    "Opposing Team": "PHI",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/11/0022100396/577/49e780c8-43e4-8c20-e4a3-33df981c176c_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/573102827984022089",
    "name": "The 2974 Collection #2967",
    "imageUrl": "https://arweave.net/6VQQsvAbn5lv1-3WNvs_SBdJ8EkfsvmK0U6vd6FlB6g?ext=png",
    "Opposing Team City": "Philadelphia",
    "Year": 2021,
    "Month": 12,
    "Day": 11,
    "3-Pointers made in the game": 3,
    "Special Moment": "7 to Go",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2968,
    "PERIOD": 2,
    "MINUTES_REMAINING": 8,
    "SECONDS_REMAINING": 35,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": 13,
    "LOC_Y": 264,
    "GAME_DATE": 20211213,
    "Season": "2021-2022",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/13/0022100405/239/2dd72505-29ef-bab8-dc4c-4d83463e841d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/384967276531720255",
    "name": "The 2974 Collection #2968",
    "imageUrl": "https://arweave.net/b74TNEOFg-6jfqL_WW4EUnaWDhFSChPoi7FFF4_ZLgI?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2021,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "6 to Go",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2969,
    "PERIOD": 2,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 13,
    "ACTION_TYPE": "Fadeaway Jump Shot",
    "SHOT_ZONE_BASIC": "Right Corner 3",
    "SHOT_DISTANCE": 24,
    "LOC_X": 232,
    "LOC_Y": 78,
    "GAME_DATE": 20211213,
    "Season": "2021-2022",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/13/0022100405/362/d5ce3d02-d907-4112-49d7-974bd3210c2f_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/422680411099051545",
    "name": "The 2974 Collection #2969",
    "imageUrl": "https://arweave.net/JygE_3kOJavewKwkxSzRvpmrzYlgGw73Ag3tvRcNNLw?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2021,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "5 to Go",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2970,
    "PERIOD": 3,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 6,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 26,
    "LOC_X": -178,
    "LOC_Y": 191,
    "GAME_DATE": 20211213,
    "Season": "2021-2022",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/13/0022100405/441/27ed9b9e-62ef-af92-afd2-f0ee31ce76bc_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/481045033003337287",
    "name": "The 2974 Collection #2970",
    "imageUrl": "https://arweave.net/oa80vzqB_-ZDoTus71Q_nnLgWNMqeJWKiCGW6EaycUc?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2021,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "4 to Go",
    "Illustration": "Faith"
  },
  {
    "3-Pointer Number": 2971,
    "PERIOD": 3,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 54,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 30,
    "LOC_X": -1,
    "LOC_Y": 309,
    "GAME_DATE": 20211213,
    "Season": "2021-2022",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/13/0022100405/508/8157957f-36e0-4e14-c2af-c9589aacc66d_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/499835915747492293",
    "name": "The 2974 Collection #2971",
    "imageUrl": "https://arweave.net/iXnZGpCSJQ2zjycyc0F5IJuaStHKzqmzEN7hWcQVTUM?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2021,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "3 to Go",
    "Illustration": "Fire"
  },
  {
    "3-Pointer Number": 2972,
    "PERIOD": 4,
    "MINUTES_REMAINING": 1,
    "SECONDS_REMAINING": 24,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 25,
    "LOC_X": 179,
    "LOC_Y": 183,
    "GAME_DATE": 20211213,
    "Season": "2021-2022",
    "HTM": "IND",
    "VTM": "GSW",
    "Opposing Team": "IND",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/13/0022100405/671/ccb233f5-3871-187e-1641-371a6d487b69_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/354743187164709291",
    "name": "The 2974 Collection #2972",
    "imageUrl": "https://arweave.net/ZCe-EDxWW_QyDd9lST81TnJ_-SBQoELqJADPCoKKVgw?ext=png",
    "Opposing Team City": "Indiana",
    "Year": 2021,
    "Month": 12,
    "Day": 13,
    "3-Pointers made in the game": 5,
    "Special Moment": "2 to Go",
    "Illustration": "Joy"
  },
  {
    "3-Pointer Number": 2973,
    "PERIOD": 1,
    "MINUTES_REMAINING": 10,
    "SECONDS_REMAINING": 56,
    "ACTION_TYPE": "Pullup Jump shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 29,
    "LOC_X": 33,
    "LOC_Y": 290,
    "GAME_DATE": 20211214,
    "Season": "2021-2022",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/14/0022100414/17/9ad5c965-c0d2-80d6-5442-842056b4d976_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/512774866583975603",
    "name": "The 2974 Collection #2973",
    "imageUrl": "https://arweave.net/3njDeRQ9zJNV5YEdq9BadTtcWYDVHVwmrXH2mb_D4lY?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "1 More to History",
    "Illustration": "Splash"
  },
  {
    "3-Pointer Number": 2974,
    "PERIOD": 1,
    "MINUTES_REMAINING": 7,
    "SECONDS_REMAINING": 33,
    "ACTION_TYPE": "Jump Shot",
    "SHOT_ZONE_BASIC": "Above the Break 3",
    "SHOT_DISTANCE": 27,
    "LOC_X": 116,
    "LOC_Y": 250,
    "GAME_DATE": 20211214,
    "Season": "2021-2022",
    "HTM": "NYK",
    "VTM": "GSW",
    "Opposing Team": "NYK",
    "VIDEO_URL": "https://videos.nba.com/nba/pbp/media/2021/12/14/0022100414/53/14186d76-6909-459f-c5a5-9f8b21f88b40_960x540.mp4",
    "CLIP_URL": "",
    "nftUrl": "https://ftx.us/nfts/token/320812585751035696",
    "name": "The 2974 Collection #2974",
    "imageUrl": "https://arweave.net/sLYsfCnTx5cSepHTqMqj0d1SVnQjJsfx22Ao9JlbM6I?ext=png",
    "Opposing Team City": "New York",
    "Year": 2021,
    "Month": 12,
    "Day": 14,
    "3-Pointers made in the game": 5,
    "Special Moment": "The Record",
    "Illustration": "Joy"
  }
];

export default combinedShotData;